/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages', [
    'ui.router',
    'Kahuna.pages.services',
    'Kahuna.pages.home',
    'Kahuna.pages.jerarquia',
    'Kahuna.pages.template',
    'Kahuna.pages.campo',
    'Kahuna.pages.proceso',
    'Kahuna.pages.grupo',
    'Kahuna.pages.grupos-usuarios',
    'Kahuna.pages.solicitud',
    'Kahuna.pages.reporte',
    'Kahuna.components',
    'Kahuna.pages.usuario',
    'Kahuna.pages.autosolicitud',
    'Kahuna.pages.autoautorizar',
    'Kahuna.pages.auxparametros',
    'Kahuna.pages.accesosurl',
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($urlRouterProvider,$stateProvider) { // baSidebarServiceProvider) {
    $urlRouterProvider.otherwise('/home');
    $stateProvider
    .state('pages', {
      templateUrl: 'app/pages/shell.html',
      abstract: true,
      authenticate: true,
    });
    
  }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function () {
    'use strict';
    angular.module('Kahuna.pages.accesosurl', []);
  })();
  
(function () {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.autosolicitud', []);
  })();
  
(function () {
    'use strict';
    angular.module('Kahuna.pages.auxparametros', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.campo', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.grupo', []);
  })();
  
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupos-usuarios', []);
  })();
  
(function () {
  'use strict';

  angular.module('Kahuna.pages.home', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('pages.home', {
          url: '/home',
          // templateUrl: 'app/pages/home/home.html',
          template : '<home-inicio></home-inicio>',
          title: 'Inicio',
          sidebarMeta: {
            icon: 'ion-android-home',
            order: 0,
          },
          authenticate:true
        });
  }

})();

(function () {
    'use strict';
  
    angular.module('Kahuna.pages.jerarquia', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.proceso', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.reporte', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.solicitud', []);
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

(function () {
    'use strict';
  
    angular.module('Kahuna.pages.template', []);
  })();
  
(function () {
    'use strict';
  
    angular.module('Kahuna.pages.usuario', []);
  })();
  
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

'use strict';

// IMPORTANTE
// Este proyecto debe ser ejecutado con Node v10.22.1 y npm v6.14.6

angular.module('Kahuna', [
  'ngAnimate',
  'ui.bootstrap',
  'ui.sortable',
  'ui.router',
  'ngTouch',
  'ngFileUpload',
  'toastr',
  "xeditable",
  'ui.slimscroll',
  'ngJsTree',
  'angular-progress-button-styles',
  'BlurAdmin.theme',
  'Kahuna.pages',
  'Kahuna.auth',
  'angularTrix',
  'smart-table',
  'wysiwyg.module',
  'ngImageCompress'
]);

angular.module('Kahuna').constant('appConfig', {
  'apiUrl': 'http://localhost:58149/Kahuna.Api/api/',
  'uploadUrl': 'http://localhost:58149/Kahuna.Api/uploads/',
  'powerbiReport': '',
  'tiempoInactividad': '20',
  'release': 'Kahuna Space Build 45.00',
  'alertMensaje': 'Sitio de Validación...',
  'idioma': 'español',
  'diasVenceClave': '720',
  'solicitudEstadoId': '2',
  'emailIcon': 'https://google.com',
  'infoIcon': 'https://youtube.com',
  'aiIcon': 'https://facebook.com'
});

angular.module('Kahuna').config(function(stConfig, appConfig) {
  stConfig.language = appConfig.idioma;
});

angular.module('Kahuna.pages.services', []);
angular.module('Kahuna.components', []);
angular.module('Kahuna.pages.tables', []);
angular.module('Kahuna.auth', []);
angular.module('Kahuna.factories', []);
angular.module("Kahuna").factory('httpInterceptorFactory', httpInterceptorFactory);
angular.module('Kahuna')
  .config(['$httpProvider', function ($httpProvider) {
    //cfpLoadingBarProvider.includeSpinner = true;
    //console.log($httpProvider);
    $httpProvider.interceptors.push('httpInterceptorFactory');
  }])
  .config(function ($sceDelegateProvider) {
    $sceDelegateProvider.resourceUrlWhitelist([
      // Allow same origin resource loads.
      'self',
      // Allow loading from our assets domain. **.
      'https://pbis.kahuna.biz/**',
      'https://rs.kahuna.biz/**',
      'https://app.powerbi.com/**',
      'http://localhost:58149/**',
      // Allow clients domains
      'https://omnilife.appkahuna.org/**',
      'https://omnilife.gerencial.com.ar/**',
    ])
  })

angular.module('Kahuna').controller('inactivity', function ($scope, $state, $location, $document, $timeout, $window, sharedService, dataService, appConfig) {
  var language = appConfig.idioma;
  var modalText;
  var modalButtonText;

  var inactivityTimeout;
  var INACTIVITY_TIME = Number(appConfig.tiempoInactividad) * 60 * 1000;
  var DEBOUNCE_DELAY = 250; // Retraso para no sobrecargar los eventos

  if (language == "español") {
    modalText = "La sesión está a punto de expirar, ¿Desea extenderla?";
    modalButtonText = "Extender sesión"
  }
  else if (language == "ingles") {
    modalText = "Your session is about to expire, do you want to extend it?";
    modalButtonText = "Extend session"
  }
  else if (language == "portugues") {
    modalText = "A sessão está prestes a expirar, deseja estendê-la?";
    modalButtonText = "Estender sessão"
  }
  else if (language == "italiano") {
    modalText = "La sesión está a punto de expirar, ¿Desea extenderla?";
    modalButtonText = "Estender sessão"
  }

  /**
    * Muestra la alerta modal y maneja la lógica de extender sesión o cerrar sesión.
    */
  function showInactivityModal() {
    Swal.fire({
      title: "",
      icon: 'warning',
      text: modalText,
      timerProgressBar: true,
      timer: 15000,
      confirmButtonClass: "btn-success",
      confirmButtonText: modalButtonText,
      allowOutsideClick: false,
      allowEscapeKey: false
    }).then(function(result) {
      if (result.isConfirmed) {
        resetTimer();
      } else if (result.dismiss == Swal.DismissReason.timer) {
        logout();
      }
    });
  };

  /**
   * Cierra la sesión del usuario.
   */
  function logout() {
    var authData = sharedService.getLoggedUser();
    if (authData) {
      sharedService.clearLocalData(authData.Id);
      dataService.logoutUser(authData.Id);
    }
    sharedService.setLoggedUser({});
    $state.go('auth');
  };

  /**
   * Reinicia el temporizador de inactividad.
   */
  function resetTimer() {
    $timeout.cancel(inactivityTimeout);
    // Solo activa el temporizador si no estamos en la página de login
    if (!$location.url().includes('login')) {
      inactivityTimeout = $timeout(showInactivityModal, INACTIVITY_TIME);
    }
  };

  /**
   * Función "debounce" para optimizar el reinicio del temporizador.
   * Evita que se ejecute en cada micro-movimiento.
   * Adicional actualiza en el localstorage para disparar el evento 'storage'
   */
  var debounceTimer;
  function debouncedResetTimer() {
    $timeout.cancel(debounceTimer);
    debounceTimer = $timeout(function() {
      sharedService.setInactivityTime(Date.now());
      resetTimer();
    }, DEBOUNCE_DELAY);
  };

   /**
   * Se ejecuta cuando otra pestaña modifique el localStorage y evalúa que el trigger sea la key de inactividad
   */
  function handleStorageChange(event) {
    var keyName = sharedService.getInactivityTimeKey();
    if (event.key == keyName && event.newValue) {
      resetTimer();
    }
  }

  var userActivityEvents = ['mousemove', 'keydown', 'click', 'scroll'];

  $document.on(userActivityEvents.join(' '), debouncedResetTimer);
  $window.addEventListener('storage', handleStorageChange);

  // Inicia el temporizador por primera vez
  resetTimer();

  $scope.$on('$destroy', function() {
    $document.off(userActivityEvents.join(' '), debouncedResetTimer);
    $window.removeEventListener('storage', handleStorageChange);
    $timeout.cancel(inactivityTimeout);
    $timeout.cancel(debounceTimer);
  });

})

angular.module('Kahuna').run(stateChangeStart);

httpInterceptorFactory.$inject = ['$q', '$injector', '$location', '$rootScope', 'localStorage'];
function httpInterceptorFactory($q, $injector, $location, $rootScope, localStorage) { //, DialogFactory) {

  var service = {
    request: request,
    response: response,
    responseError: responseError
  };

  return service;

  function request(config) {
    config.headers = config.headers || {};

    var authData = localStorage.getObject('dataUser_kahuna');
    //console.log(authData.Clave);
    if (authData && authData.Clave) {
      config.headers.Authorization = 'Bearer' + ' ' + authData.Clave;
    }

    return config;
  }

  function response(response) {
    return response;
  }

  function responseError(rejection) {
    if (rejection.status === 401 || rejection.status === 403) {
      //localStorage.setObject('dataUser', {});
      $location.path('/login');
    }
    else {
      console.error("API call error.");
      console.error(rejection);
    }

    return $q.reject(rejection);
  }
}

/** @ngInject */
function stateChangeStart($rootScope, $state, dataService, sharedService) {
  $rootScope.$on("$stateChangeStart", function (event, toState, toParams, fromState, fromParams, $window, $location) {
    if (toState.authenticate) {
      var authData = sharedService.getLoggedUser();

      if (!authData || !authData.Login) {
        $state.go('auth', { returnUrl: window.location.href });
        event.preventDefault();
      }
    }
  });
}



(function (angular) {
  'use strict';
  angular.module('Kahuna.auth').component('login', {
    templateUrl: 'app/auth/auth.html',
    controller: function ($state, $window, dataService, sharedService, toastr, $stateParams, $uibModal) {
      var ctrl = this;
      var loginButtonText;
      ctrl.model = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.appVersion = sharedService.getSystemVersion();
      ctrl.diasVenceClave = sharedService.getExpiredPasswordDays();
      ctrl.buttonLoginText = '';
      ctrl.logoIcon = sharedService.getAssetsUrl() + 'img/app/KahunaLogoColor.png';
      ctrl.userIcon = sharedService.getAssetsUrl() + 'img/app/user.svg';
      ctrl.passwordIcon = sharedService.getAssetsUrl() + 'img/app/lock.svg';
      ctrl.showPasswordIcon = sharedService.getAssetsUrl() + 'img/app/eye-off.svg';
      ctrl.hidePasswordIcon = sharedService.getAssetsUrl() + 'img/app/eye.svg';

      this.$onInit = function () {

        if (ctrl.language == "español")
          loginButtonText = "Ingresar";
        else if (ctrl.language == "ingles")
          loginButtonText = 'Log in';
        else if (ctrl.language == "portugues")
          loginButtonText = 'Entrar';
        else if (ctrl.language == "italiano")
          loginButtonText = "Ingresar";

        ctrl.buttonLoginText = loginButtonText;

        jQuery('.al-footer-main').css({ color: '#d9d9d9' });
        jQuery('.al-footer-right i').css({ color: '#d9d9d9' });
        jQuery('.al-footer-right a').css({ color: '#d9d9d9' });

        jQuery('.al-footer').css({ position: 'fixed', bottom: '65px' });

        var backgroundImageUrl = 'url(' + sharedService.getAssetsUrl() + 'img/app/login-background.jpg)';
        $('body')
          .css('backgroundImage', backgroundImageUrl)
          .css('background-size', 'cover')
          .css('background-position', 'center center')
      };

      ctrl.togglePassword = function (event) {
        var inputPassword = $("#inputPassword3");

        if (inputPassword.attr("type") === "password") {
          inputPassword.attr("type", "text");
          event.target.attributes.src.value = ctrl.hidePasswordIcon;
        } else {
          inputPassword.attr("type", "password");
          event.target.attributes.src.value = ctrl.showPasswordIcon;
        }
      }

      ctrl.login = function () {
        if (!ctrl.model.Usuario || !ctrl.model.Password) return;

        var loggingInText, passwordExpiredText, activeSessionUserText;

        if (ctrl.language == "español") {
          loggingInText = 'Ingresando...';
          passwordExpiredText = "Su contraseña ha expirado, por favor realice un cambio de contraseña para continuar";
          activeSessionUserText = "";

        } else if (ctrl.language == "ingles") {
          loggingInText = 'Logging in...';
          passwordExpiredText = "Your password has expired. Please change your password to continue";
          activeSessionUserText = "";

        } else if (ctrl.language == "portugues") {
          loggingInText = 'Entrando...';
          passwordExpiredText = "Sua senha expirou, altere-a para continuar.";
          activeSessionUserText = "";

        } else if (ctrl.language == "italiano") {
          loggingInText = 'Ingresando...';
          passwordExpiredText = "Su contraseña ha expirado, por favor realice un cambio de contraseña para continuar";
          activeSessionUserText = "";
        }

        ctrl.isBusy = true;
        ctrl.buttonLoginText = loggingInText;

        // Desde el 06/11/2025 antes de iniciar sesion, se borran todos los datos del localstorage
        sharedService.clearLocalStorage();

        dataService.loginUser(ctrl.model.Usuario, ctrl.model.Password, ctrl.language, ctrl.diasVenceClave)
          .then(function (response) {
            if (response.data.Success) {
              if (response.data.Value.IsPasswordExpired) {
                var confirmation = $uibModal.open({
                  animation: true,
                  component: "cambioClave",
                  resolve: {
                    title: function () {
                      return passwordExpiredText
                    },
                    showUsername: function () {
                      return true;
                    },
                    usuarioId: function () {
                      return response.data.Value.Usuario.Id
                    },
                    username: function () {
                      return response.data.Value.Usuario.Login
                    },
                    userToken: function () {
                      return response.data.Value.Usuario.Clave
                    }
                  }
                });

                confirmation.result.then(function (selectedItem) {
                  ctrl.isBusy = false;
                  dataService.logoutUser(response.data.Value.Usuario.Id)

                }, function () {
                  ctrl.isBusy = false;
                  dataService.logoutUser(response.data.Value.Usuario.Id)
                });

              } else {
                sharedService.setLoggedUser(response.data.Value.Usuario);
                sharedService.setLoggedUserPermisos(response.data.Value.Menues);
                sharedService.clearLocalData(response.data.Value.Usuario.Id);

                jQuery('.al-footer-main').css({ color: '' });
                jQuery('.al-footer-right i').css({ color: '' });
                jQuery('.al-footer-right a').css({ color: '' });

                jQuery('.al-footer').css({ position: 'inherit', bottom: '0' });
                $('body').css('backgroundImage', '');

                if ($stateParams != null && $stateParams.returnUrl != null && $stateParams.returnUrl.length > 0)
                  $window.location.href = $stateParams.returnUrl;
                else
                  $state.go('pages.home');
              }

            } else {
              if (response.data.ErrorSummary.includes("CLOSESESSION")) {

                var confirmation = $uibModal.open({
                  animation: true,
                  component: "cierreSesion",
                  resolve: {
                    time: function () {
                      return response.data.ErrorSummary.replace('CLOSESESSION', '');
                    },
                    username: function () {
                      return ctrl.model.Usuario;
                    },
                    usuarioId: function () {
                      return response.data.Value.usuarioId;
                    },
                    password: function () {
                      return ctrl.model.Password;
                    }
                  }
                });

                confirmation.result.then(function (selectedItem) {
                  ctrl.isBusy = false;
                }, function () {
                  ctrl.isBusy = false;
                });

              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }
            ctrl.isBusy = false;
            ctrl.buttonLoginText = loginButtonText;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            ctrl.buttonLoginText = loginButtonText;
          });
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.auth').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('auth', {
          url: '/login/:returnUrl',
          title: '',
          template : '<login></login>',
          params: {returnUrl:null},
          authenticate: false,
        });
    }
  })();
(function () {
    'use strict';

    // angular.module("Kahuna.factories").factory('httpInterceptorFactory', httpInterceptorFactory);

    //httpInterceptorFactory.$inject = ['$q', '$injector', '$location', '$rootScope', 'localStorage'];

    function httpInterceptorFactory() { //$q, $injector, $location, $rootScope, localStorage) { //, DialogFactory) {

        // var service = {
        //     request: request,
        //     response: response,
        //     responseError: responseError
        // };

        // return service;

        // function request(config) {
        //     config.headers = config.headers || {};
            
        //     var authData = sharedService.getLoggedUser();
        //     console.log(authData.Clave);
        //     if (authData && authData.Clave) 
        //     {
        //         config.headers.Authorization = 'Bearer' + ' ' + authData.Clave;
        //     }

        //     return config;
        // }

        // function response(response) {
        //     return response;
        // }

        // function responseError(rejection) {
        //     if (rejection.status === 401 || rejection.status === 403) {
        //         //localStorage.setObject('dataUser', {});
        //         $location.path('/login');
        //     } else {
        //         console.error("API call error.")
        //     }

        //     return $q.reject(rejection);
        // }
    }
})();

(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('altaJerarquia', {
    templateUrl: 'app/components/altaJerarquia.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.isBusy = false;

      this.$onInit = function () {
        ctrl.model = {
          Nombre: "",
          JerarquiaPadre: ctrl.resolve.JerarquiaPadre,
          Activo: 1
        };
      };

      ctrl.save = function () {
        var errorText, successfulRegistration;

        if (ctrl.language == "español") {
          errorText = "Ingrese el nombre de la jerarquía a dar de alta";
          successfulRegistration = "Registro exitoso.";
        } else if (ctrl.language == "ingles") {
          errorText = "Enter the name of the hierarchy to register";
          successfulRegistration = "Registration successful.";
        } else if (ctrl.language == "portugues") {
          errorText = "Digite o nome da hierarquia a ser registrada";
          successfulRegistration = "Registro bem-sucedido.";
        } else if (ctrl.language == "italiano") {
          errorText = "Ingrese el nombre de la jerarquía a dar de alta";
          successfulRegistration = "Registro exitoso.";
        }

        if (ctrl.model.Nombre == null || ctrl.model.Nombre.length <= 0) {
          toastr.error(errorText);
          return;
        }

        ctrl.isBusy = true;
        ctrl.model.Activo = 1;

        if (ctrl.model.JerarquiaPadre != null && ctrl.model.JerarquiaPadre.Id > 0)
          ctrl.model.JerarquiaPadreId = ctrl.model.JerarquiaPadre.Id;
        else {
          ctrl.model.JerarquiaPadreId = null;
          ctrl.model.JerarquiaPadre = null;
        }

        dataService.saveJerarquia(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info(successfulRegistration);
              ctrl.close({ $value: response.data.Value });
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        ctrl.dismiss({});
      }

      ctrl.checkKey = function (event) {
        if (event.keyCode == 27)
          ctrl.cancel();

        if (event.keyCode == 13)
          ctrl.save();

        return true;
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('baSidebar', {
    templateUrl: 'app/components/baSidebar.template.html',
    controller: function ($state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.grupos = [];

      this.$onInit = function () {
        ctrl.isGroupSearching = true;

        dataService.getGrupoHomeList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.grupos = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isGroupSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isGroupSearching = false;
          });
      };

      ctrl.setGrupoSeleccionado = function (grupoId) {
        $state.go('pages.solicitud-procesos', { grupoId: grupoId });
      };
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('cambioClave', {
    templateUrl: 'app/components/cambioClave.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.isBusy = false;
      ctrl.showPasswordIcon = sharedService.getAssetsUrl() + 'img/app/eye-off.svg';
      ctrl.hidePasswordIcon = sharedService.getAssetsUrl() + 'img/app/eye.svg';

      this.$onInit = function () {
      };

      ctrl.togglePassword = function (inputId, event) {
        var inputPassword = $("#" + inputId);

        if (inputPassword.attr("type") === "password") {
          inputPassword.attr("type", "text");
          event.target.attributes.src.value = ctrl.hidePasswordIcon;
        } else {
          inputPassword.attr("type", "password");
          event.target.attributes.src.value = ctrl.showPasswordIcon;
        }
      }

      ctrl.save = function () {
        var completeInfoText, confirmPasswordText, newPassDiferentText, passwordUpdatedText;
  
        if (ctrl.language == "español") {
          completeInfoText = "Debe completar todos los campos para continuar con la operación";
          confirmPasswordText = "La nueva contraseña y su confirmación son distintas. Por revise revise ambas";
          newPassDiferentText = "La nueva contraseña no puede ser igual a la contraseña anterior";
          passwordUpdatedText = "Contraseña actualizada satisfactoriamente";

        } else if (ctrl.language == "ingles") {
          completeInfoText = "All fields must be completed to continue the operation.";
          confirmPasswordText = "The new password and its confirmation do not match. Please check both";
          newPassDiferentText = "The new password cannot be the same as the previous password";
          passwordUpdatedText = "Password updated successfully";

        } else if (ctrl.language == "portugues") {
          completeInfoText = "Você deve preencher todos os campos para continuar com a operação";
          confirmPasswordText = "A nova senha e sua confirmação são diferentes. Por favor, revise ambas";
          newPassDiferentText = "A nova senha não pode ser igual à senha anterior";
          passwordUpdatedText = "Senha atualizada com sucesso";

        } else if (ctrl.language == "italiano") {
          completeInfoText = "Debe completar todos los campos para continuar con la operación";
          confirmPasswordText = "La nueva contraseña y su confirmación son distintas. Por revise revise ambas";
          newPassDiferentText = "La nueva contraseña no puede ser igual a la contraseña anterior";
          passwordUpdatedText = "Contraseña actualizada satisfactoriamente";

        }

        if (ctrl.model.ClaveActual == null || ctrl.model.ClaveActual.length <= 0 ||
          ctrl.model.ClaveNueva == null || ctrl.model.ClaveNueva.length <= 0 ||
          ctrl.model.ClaveNuevaConfirmacion == null || ctrl.model.ClaveNuevaConfirmacion.length <= 0) {
          toastr.error(completeInfoText);
          return;
        }

        if (ctrl.model.ClaveNueva != ctrl.model.ClaveNuevaConfirmacion) {
          toastr.error(confirmPasswordText);
          return;
        }

        if (ctrl.model.ClaveNueva == ctrl.model.ClaveActual) {
          toastr.error(newPassDiferentText);
          return;
        }

        ctrl.model.UsuarioId = ctrl.resolve.usuarioId;
        ctrl.isBusy = true;

        dataService.saveClaveUsuario(ctrl.model, ctrl.resolve.userToken)
          .then(function (response) {
            if (response.data.Success) {
              // ctrl.model = response.data.Value;
              toastr.info(passwordUpdatedText);
              ctrl.close({});
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        ctrl.dismiss({});
      }

      ctrl.checkKey = function (event) {
        if (event.keyCode == 27)
          ctrl.cancel();

        if (event.keyCode == 13)
          ctrl.save();

        return true;
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('cierreSesion', {
    templateUrl: 'app/components/cierreSesion.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function ($state, $stateParams, $window, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.isBusy = false;
      ctrl.title = '';

      this.$onInit = function () {
        if (ctrl.language == "español") {
          ctrl.title = "Este usuario ya tiene una sesión activa, para poder acceder cierre la sesión o intente ingresar en" + ctrl.resolve.time + " minutos";
        }
        else if (ctrl.language == "ingles") {
          ctrl.title = "This user already has an active session, in order to access, log out or try to log in within " + ctrl.resolve.time + " minutes";
        }
        else if (ctrl.language == "portugues") {
          ctrl.title = "Este usuário já possui uma sessão ativa, para poder acessar, sair ou tentar fazer login em até" + ctrl.resolve.time + " minutos";
        }
        else if (ctrl.language == "italiano") {
          ctrl.title = "Este usuario ya tiene una sesión activa, para poder acceder cierre la sesión o intente ingresar en" + ctrl.resolve.time + " minutos";
        }
      };

      ctrl.logout = function () {
        ctrl.isBusy = true;

        dataService.logoutUser(ctrl.resolve.usuarioId)
          .then(function (response) {
            if (response.data.Success) {
              dataService.loginUser(ctrl.resolve.username, ctrl.resolve.password, ctrl.language)
                .then(function (response) {
                  if (response.data.Success) {

                    sharedService.setLoggedUser(response.data.Value.Usuario);
                    sharedService.setLoggedUserPermisos(response.data.Value.Menues);
                    sharedService.clearLocalData(response.data.Value.Usuario.Id);

                    jQuery('.al-footer-main').css({ color: '' });
                    jQuery('.al-footer-right i').css({ color: '' });
                    jQuery('.al-footer-right a').css({ color: '' });

                    jQuery('.al-footer').css({ position: 'inherit', bottom: '0' });
                    $('body').css('backgroundImage', '');

                    if ($stateParams != null && $stateParams.returnUrl != null && $stateParams.returnUrl.length > 0)
                      $window.location.href = $stateParams.returnUrl;
                    else
                      $state.go('pages.home');

                    ctrl.close({});

                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isBusy = false;
                }, function (error) {
                  toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  ctrl.isBusy = false;
                });
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        ctrl.dismiss({});
      }

    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('confirmation', {
    templateUrl: 'app/components/confirmation.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (sharedService) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      this.$onInit = function () {
      };
      ctrl.confirm = function () {
        ctrl.close({})
      }
      ctrl.cancel = function () {
        ctrl.dismiss({})
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('footerUser', {
    templateUrl: 'app/components/footerUser.template.html',
    controller: function (sharedService, dataService, appConfig, $state, $scope, $location, $uibModal) {
      var ctrl = this;
      var authData = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.appVersion = sharedService.getSystemVersion();
      ctrl.myStyle = {};
      ctrl.applicationProperties = {
        HEADCOLOR: "",
        HEADLINEA1: "",
        HEADLINEA2: ""
      };
      ctrl.alert = null;

      // if ($location.url().match(/solicitud\/edit\/0\/0/g) || $location.url().match(/solicitud\/template\/edit\//g)) {
      //   ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
      // } else {
      //   sharedService.setIframeSolicitudActivo(false);
      //   ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
      // }

      this.$onInit = function () {
        authData = sharedService.getLoggedUser();
        var userWelcome, userDefaultWelcome;

        if (ctrl.language == "español") {
          userWelcome = "¡Hola " + authData.Login + '!';
          userDefaultWelcome = "¡Hola Usuario!";
        } else if (ctrl.language == "ingles") {
          userWelcome = "Hello " + authData.Login + '!';
          userDefaultWelcome = "Hello User!";
        } else if (ctrl.language == "portugues") {
          userWelcome = "Olá " + authData.Login + '!';
          userDefaultWelcome = "Olá Usuário!";
        } else if (ctrl.language == "italiano") {
          userWelcome = "¡Hola " + authData.Login + '!';
          userDefaultWelcome = "¡Hola Usuario!";
        }

        footerUserHome();
        getParametrosInicialesApp();

        if (appConfig.alertMensaje != "")
          ctrl.alert = appConfig.alertMensaje;
        // Este es un mensaje que se va a mostrar a modo de notificación cuando por ejemplo se le va a hacer actualización a un despliegue de un cliente

        if (authData != null && authData.Login != null)
          ctrl.userMessage = userWelcome;
        else
          ctrl.userMessage = userDefaultWelcome;

      };

      function getParametrosInicialesApp() {
        dataService.obtenerParametrosApp()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.applicationProperties = sharedService.arrayToObjProp(response.data.Value, "Ident", "Descripcion");
              sharedService.setLocalData("ApplicationProperties", ctrl.applicationProperties);
              if (ctrl.applicationProperties.hasOwnProperty("HEADCOLOR")) {
                ctrl.myStyle = {
                  'background-color': ctrl.applicationProperties.HEADCOLOR
                };
              }
            }
          });
      };

      function footerUserHome() {
        // Función para cambiar el tamaño del footer dependiendo si se está en la vista home o si se cambia de vista
        var url = $location.url();

        if (url == '/home') {
          $('.footer-container').addClass('is-home');
        } else {
          $('.footer-container').removeClass('is-home');
        }
      }

      ctrl.cambioClave = function () {
        var modalTitle;

        if (ctrl.language == "español")
          modalTitle = "Cambio de Contraseña de Usuario ";
        else if (ctrl.language == "ingles")
          modalTitle = "User Password Change ";
        else if (ctrl.language == "portugues")
          modalTitle = "Alteração de Senha do Usuário ";
        else if (ctrl.language == "italiano")
          modalTitle = "Cambio de Contraseña de Usuario ";


        if (authData != null && authData.Id > 0) {
          var confirmation = $uibModal.open({
            animation: true,
            component: "cambioClave",
            resolve: {
              title: function () {
                return modalTitle + authData.Login
              },
              showUsername: function () {
                return false
              },
              usuarioId: function () {
                return authData.Id
              },
              username: function () {
                return authData.Login
              },
            }
          });

          confirmation.result.then(function (selectedItem) {
            ctrl.isBusy = false;
          }, function () {
            ctrl.isBusy = false;
          });
        } else {
          ctrl.logout();
        }
      }

      ctrl.logout = function () {
        if (authData != null)
          sharedService.clearLocalData(authData.Id);

        dataService.logoutUser(authData.Id);
        sharedService.setLoggedUser({});
        $state.go('auth');
      }

      $scope.$on('$locationChangeSuccess', function () {
        footerUserHome();
      });

      ctrl.medirVelocidadInternet = function () {
        var url = "https://www.highspeedinternet.com/es/herramientas/test-velocidad"
        window.open(url, "_blank", "width=650,height=350,top=150,left=350,status=no,toolbar=no,menubar=no,location=no")
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('modalVisor', {
    templateUrl: 'app/components/modalVisor.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (sharedService) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.urlVisor = "";
      ctrl.pdfDoc = null; // Documento PDF
      ctrl.currentPage = 1; // Página actual
      ctrl.scale = 1; // Escala de visualización
      ctrl.totalPages = 0;
      ctrl.contextListener = function (e) {
        e.preventDefault();
      };

      this.$onInit = function () {
        ctrl.urlVisor = ctrl.resolve.url;

        if (ctrl.resolve.isPdf) {
          // Cargar el PDF
          var loadingTask = pdfjsLib.getDocument(ctrl.urlVisor);

          loadingTask.promise.then(function (pdf) {
            ctrl.pdfDoc = pdf;
            ctrl.totalPages = ctrl.pdfDoc.numPages; // Mostrar el número total de páginas
            renderPage(ctrl.currentPage); // Renderizar la primera página
          }, function (reason) {
            console.error('Error cargando el PDF: ' + reason);
          });

          ctrl.contextListener = document.querySelector('.modal-visor-content').addEventListener('contextmenu', ctrl.contextListener, true);
        }

      };

      // Renderizar una página
      function renderPage(pageNum) {
        ctrl.pdfDoc.getPage(pageNum).then(function (page) {
          var pdfViewer = document.getElementById('displayPdf');
          var pageContainer = document.createElement('div');

          pageContainer.className = 'page-container';

          var viewport = page.getViewport({ scale: ctrl.scale });

          pageContainer.style.width = viewport.width + 'px';
          pageContainer.style.height = viewport.height + 'px';

          // Preparar el contenedor para el canvas
          var canvas = document.createElement('canvas');
          var context = canvas.getContext('2d');
          canvas.height = viewport.height;
          canvas.width = viewport.width;

          // Limpiar el contenedor y añadir el canvas
          pdfViewer.innerHTML = ''; // Limpiar el contenido anterior

          pageContainer.appendChild(canvas);
          pdfViewer.appendChild(pageContainer);

          // Renderizar la página en el canvas
          var renderContext = {
            canvasContext: context,
            viewport: viewport
          };

          var renderTask = page.render(renderContext);

          renderTask.promise.then(function() {
            console.log('Página renderizada');
            return page.getAnnotations();
          }).then(function(annotations) {
            // Recorremos todas las anotaciones
            annotations.forEach(function(annotation) {
              // Verificamos si la anotación es de tipo 'Link'
              if (annotation.subtype !== 'Link' || !annotation.url) {
                return;
              }

              var link = document.createElement('a');
              link.href = annotation.url;
              link.target = '_blank';
              link.className = 'linkAnnotation';

              // Convertimos las coordenadas del PDF a las del viewport
              // El método convertToViewportRectangle se encarga de la escala y rotación
              var rect = page.getViewport({ scale: ctrl.scale }).convertToViewportRectangle(annotation.rect);

              // console.log("rect",rect);
              
              // Aplicamos el estilo para posicionar el enlace sobre el canvas
              link.style.left = rect[0] + 'px';
              link.style.top = rect[3] + 'px';
              link.style.width = (rect[2] - rect[0]) + 'px';
              link.style.height = (rect[1] - rect[3]) + 'px';

              // Añadimos el enlace al contenedor de la página
              pageContainer.appendChild(link);
            });
          });

          // Actualizar el número de página mostrado
          ctrl.currentPage = pageNum;
        });
      }

      // Navegación entre páginas
      ctrl.prevPage = function () {
        if (ctrl.currentPage > 1) {
          ctrl.currentPage--;
          renderPage(ctrl.currentPage);
        }
      };

      ctrl.nextPage = function () {
        if (ctrl.currentPage < ctrl.pdfDoc.numPages) {
          ctrl.currentPage++;
          renderPage(ctrl.currentPage);
        }
      };

      // Función para aumentar el zoom
      ctrl.zoomInPage = function () {
        if (ctrl.scale < 2) {
          ctrl.scale += 0.1; // Incrementar la escala
          renderPage(ctrl.currentPage); // Renderizar la página actual con la nueva escala
        }
      };

      // Función para disminuir el zoom
      ctrl.zoomOutPage = function () {
        if (ctrl.scale > 0.7) { // Limitar el zoom mínimo
          ctrl.scale -= 0.1; // Disminuir la escala
          renderPage(ctrl.currentPage); // Renderizar la página actual con la nueva escala
        }
      };

      function getNameFile(url) {
        var lastIndex = url.lastIndexOf('/');

        if (lastIndex == -1)
          return location.hostname + " file";

        var urlHastaUltimoSlash = url.slice(lastIndex + 1, url.length);

        return urlHastaUltimoSlash;
      }

      // Función para descargar el PDF
      ctrl.downloadPdf = function () {
        var link = document.createElement('a');
        link.href = ctrl.urlVisor; // URL del PDF
        link.download = getNameFile(ctrl.urlVisor); // Nombre del archivo al descargar
        link.target = "_blank";
        link.rel = "noopener";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      ctrl.close = function () {
        document.querySelector('.modal-visor-content').removeEventListener('contextmenu', ctrl.contextListener, true);
        ctrl.dismiss({});
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('pageTop', {
    templateUrl: 'app/components/pageTop.template.html',
    controller: function (sharedService, pageTopService, $scope, $location, appConfig) {
      var ctrl = this;
      ctrl.appLogoIcon = sharedService.getAssetsUrl() + 'img/app/KahunaLogoColor.png';
      ctrl.clientLogoIcon = sharedService.getAssetsUrl() + 'img/app/ClienteLogo.png';
      ctrl.emailIcon = sharedService.getAssetsUrl() + 'img/email-icon.png';
      ctrl.infoIcon = sharedService.getAssetsUrl() + 'img/info-icon.png';
      ctrl.aiIcon = sharedService.getAssetsUrl() + 'img/ai-icon.png';
      ctrl.appVersion = sharedService.getSystemVersion();
      ctrl.selectedIndexMenu = null;

      ctrl.emailIconHref = appConfig.emailIcon;
      ctrl.infoIconHref = appConfig.infoIcon;
      ctrl.aiIconHref = appConfig.aiIcon;
      // if ($location.url().match(/solicitud\/edit\/0\/0/g) || $location.url().match(/solicitud\/template\/edit\//g)) {
      //   ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
      // } else {
      //   sharedService.setIframeSolicitudActivo(false);
      //   ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
      // }

      this.$onInit = function () {

        var authData = sharedService.getLoggedUser();

        if (authData != null && authData.Id > 0) {
          var permisosList = sharedService.getLoggedUserPermisos();

          if (permisosList != null && permisosList.length > 0) {
            var mainMenuList = getMainMenus(permisosList);

            if (mainMenuList != null) {
              for (var i = 0; i < mainMenuList.length; i++) {
                $scope.menuItems.push(
                  {
                    title: mainMenuList[i].Nombre,
                    icon: mainMenuList[i].Icono,
                    stateRef: mainMenuList[i].Ruta,
                    subMenu: getSubMenus(permisosList, mainMenuList[i].Id)
                  });
              }
            }
          }
          else
            $scope.menuItems = {};
        }
      };

      ctrl.toggleMenuMobile = function toggleMenuMobile() {
        $('.menu-panel').toggleClass('is-active');
      }
      
      ctrl.hideMenu = function hideMenu(indexOfMenu) {
        // Recorre todos los li con la clase .menu-option y oculta los que no se hayan seleccionado
        $('.menu-option').each(function (index, element) {
          if (index != indexOfMenu) {
            element.classList.remove('page-top-item-expanded');

            if (element.children.length > 1) element.children[1].removeAttribute('style')
          }
        });
      }

      function getMainMenus(permisosList) {
        return permisosList.filter(function (item) {
          return item.MenuPadreId == null;
        });
      }

      function getSubMenus(permisosList, menuId) {
        var submenus = permisosList.filter(function (item) {
          return item.MenuPadreId == menuId;
        });

        if (submenus != null && submenus.length > 0) {
          var menuList = [];
          for (var i = 0; i < submenus.length; i++) {
            menuList.push({
              title: submenus[i].Nombre,
              icon: submenus[i].Icono,
              stateRef: submenus[i].Ruta,
              subMenu: getSubMenus(permisosList, submenus[i].Id)
            });
          }

          return menuList;
        }

        return null;
      }

      $scope.menuItems = pageTopService.getMenuItems();

      $scope.$on('$locationChangeSuccess', function () {
        pageTopService.setMenuCollapsed(true);
        $('.page-top-item-expanded').removeClass('page-top-item-expanded');
        $('.submenu').removeAttr('style');
        $('.menu-panel').removeClass('is-active');
      });
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('seleccionProceso', {
    templateUrl: 'app/components/seleccionProceso.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.isBusy = false;

      ctrl.gruposList = [];
      ctrl.procesosList = [];

      this.$onInit = function () {
        ctrl.grupoLoading = true;
        ctrl.procesoLoading = false;

        ctrl.gruposList = [];
        ctrl.procesosList = [];

        /* if (ctrl.resolve.aceptaHijos != null && ctrl.resolve.aceptaHijos)
         {
           dataService.getGrupoByProcesoPadreList(ctrl.resolve.procesoPadreId)
             .then(function (response) 
             {
               if (response.data.Success) 
               {
                 ctrl.gruposList = response.data.Value;
               } 
               else 
               {
                 toastr.error(response.data.ErrorSummary);
               }
               ctrl.grupoLoading = false;
             }, function (error) {
               toastr.error(error.data || sharedService.getGenericErrorMessage(error));
               ctrl.grupoLoading = false;
           });
         }
         else
         {
           dataService.getGrupoList()
             .then(function (response) 
             {
               if (response.data.Success) 
               {
                 ctrl.gruposList = response.data.Value;
               } 
               else 
               {
                 toastr.error(response.data.ErrorSummary);
               }
               ctrl.grupoLoading = false;
             }, function (error) {
               toastr.error(error.data || sharedService.getGenericErrorMessage(error));
               ctrl.grupoLoading = false;
           });
         }*/
        ctrl.onSelectGrupo();
      };

      ctrl.onSelectGrupo = function () {
        ctrl.procesosList = [];
        ctrl.model.GrupoSeleccionado = {};
        ctrl.model.GrupoSeleccionado.Id = 0;//Default value.

        /* if (ctrl.model.GrupoSeleccionado == null || ctrl.model.GrupoSeleccionado.Id <= 0)
         {
           // toastr.error('Debe seleccionar un grupo');
           return;
         }*/

        ctrl.procesoLoading = true;

        if (ctrl.resolve.aceptaHijos != null && ctrl.resolve.aceptaHijos) {
          dataService.getProcesoHijoSeleccionableList(0, ctrl.resolve.procesoPadreId)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.procesosList = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.procesoLoading = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.procesoLoading = false;
            });
        }
        else {
          var filtrosProceso = { PageSize: 5000, SkipNumber: 0 };
          filtrosProceso.Grupo = {};
          filtrosProceso.Grupo.Id = ctrl.model.GrupoSeleccionado.Id;
          dataService.searchProceso(filtrosProceso)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.procesosList = response.data.Value.Resultados;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.procesoLoading = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.procesoLoading = false;
            });
        }
      }

      ctrl.save = function () {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Debe seleccionar un proceso antes de continuar con la operación";
        else if (ctrl.language == "ingles")
          errorText = "You must select a process before continuing";
        else if (ctrl.language == "portugues")
          errorText = "Você deve selecionar um processo antes de continuar com a operação";
        else if (ctrl.language == "italiano")
          errorText = "Debe seleccionar un proceso antes de continuar con la operación";
  
        if (ctrl.model.ProcesoSeleccionado != null && ctrl.model.ProcesoSeleccionado.Id > 0) {
          ctrl.close({ $value: ctrl.model });
        }
        else {
          toastr.error(errorText);
        }
      }

      ctrl.cancel = function () {
        ctrl.dismiss({});
      }

      ctrl.checkKey = function (event) {
        if (event.keyCode == 27)
          ctrl.cancel();

        if (event.keyCode == 13)
          ctrl.save();

        return true;
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.components').component('validaProcesoMaestro', {
    templateUrl: 'app/components/validaProcesoMaestro.template.html',
    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },
    controller: function (dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.isBusy = false;

      this.$onInit = function () {
        ctrl.model = {
          value: "",
          procesoId: ctrl.resolve.procesoId,
        };
      };

      ctrl.save = function () {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Digite el código del maestro para consultar";
        else if (ctrl.language == "ingles")
          errorText = "Enter the master code to consult";
        else if (ctrl.language == "portugues")
          errorText = "Digite o código do mestre para consultar";
        else if (ctrl.language == "italiano")
          errorText = "Digite el código del maestro para consultar";


        if (ctrl.model.value == null || ctrl.model.value.length <= 0) {
          toastr.error(errorText);
          return;
        }

        ctrl.isBusy = true;

        dataService.validarProcesoMaestro(ctrl.model.procesoId, ctrl.model.value)
          .then(function (response) {
            if (response.data.Success) {
              // Si el código es válido, guarda el valor en el localStorage para obtenerlo dentro de la solicitud antes de cargar los campos
              sharedService.setMaestroCodigo(ctrl.model.value);
              ctrl.close({ $value: response.data.Value });
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        ctrl.dismiss({});
      }

      ctrl.checkKey = function (event) {
        if (event.keyCode == 27)
          ctrl.cancel();

        if (event.keyCode == 13)
          ctrl.save();

        return true;
      }
    }
  });
})(window.angular);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    // ``
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, pageTopService, themeLayoutSettings, sharedService) { // baSidebarService ) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.appVersion = sharedService.getSystemVersion();
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$pageTopService = pageTopService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';
    angular.module('Kahuna.pages.accesosurl').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.accesosurl', {
          url: '/accesosurl',
          title: 'accesosurl',
          template : '<accesosurl-list></accesosurl-list>',
          authenticate: true,
        })
        .state('pages.accesosurl-edit', {
          url: '/accesosurl/edit/:id',
          title: 'accesosurl',
          template : '<accesosurl-edit></accesosurl-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.accesosurl').component('accesosurlEdit', {
    templateUrl: 'app/pages/accesosurl/edit.template.html',
    controller: function ($state, dataService, sharedService, toastr, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {
        idProceso: null,
        idUsuario: null,
        urlProcesoLink: '',
        usrReport: '',
        pswdReport: ''
      };
      ctrl.isBusy = false;
      ctrl.title = '';
      ctrl.usuarioCargado = {
        id: 0,
        login: '',
        Usuario: null,
        userId: 0,
        verUrl: false,
        imprimirUrl: false
      };
      // ctrl.usuarioCargado = {
      //   Id: 0,
      //   Login: ''
      // };
      ctrl.procesoUsuariosList = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.showDelete = false;
      ctrl.isEditing = false;
      ctrl.MostrarUserAndPassword = false;

      this.$onInit = function () {
        loadView();
      };

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          dataService.getAccesoUrlById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                // searchUsuarioById(ctrl.model.idUsuario);
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();

                if (ctrl.model.idUsuario != null && ctrl.model.idUsuario.length > 0) {
                  for (var i = 0; i < ctrl.model.idUsuario.length; i++) {
                    ctrl.procesoUsuariosList.push({
                      id: ctrl.model.idUsuario[i].id,
                      userId: ctrl.model.idUsuario[i].userId,
                      Usuario: {
                        Id: ctrl.model.idUsuario[i].userId,
                        Login: ctrl.model.idUsuario[i].login
                      },
                      verUrl: ctrl.model.idUsuario[i].verURL,
                      imprimirUrl: ctrl.model.idUsuario[i].imprimirURL
                    });
                  }

                  ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
                }

                if (ctrl.model.usrReport.length > 0 || ctrl.model.pswdReport.length > 0) {
                  ctrl.MostrarUserAndPassword = true;
                }

                ctrl.isEditing = true;
                ctrl.title = 'Editar Acceso Url:';
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        } else {
          ctrl.title = 'Crear Acceso Url: -';
        }
      }

      // function searchUsuarioById(id) {
      //   dataService.getUsuarioById(id)
      //     .then(function (response) {
      //       if (response.data.Success) {
      //         ctrl.usuarioCargado = response.data.Value;
      //       } else {
      //         toastr.error(response.data.ErrorSummary);
      //       }
      //     }, function (error) {
      //       toastr.error(error.data || sharedService.getGenericErrorMessage(error));
      //     })
      // }

      ctrl.searchUsuario = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0
        };

        var usuarioDefault = {
          Id: 0,
          Login: "Todos"
        }

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              var finalResults = [usuarioDefault].concat(response.data.Value.Resultados);
              return finalResults;

            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }


      ctrl.save = function () {

        if (
          ctrl.model.urlProcesoLink == null ||
          ctrl.model.urlProcesoLink.length <= 0 ||
          // ctrl.model.idProceso == null ||
          // ctrl.model.idProceso.Id <= 0 ||
          ctrl.procesoUsuariosList == null ||
          ctrl.procesoUsuariosList.length <= 0
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.MostrarUserAndPassword &&
          (ctrl.model.usrReport == null || ctrl.model.usrReport.length <= 0) &&
          (ctrl.model.pswdReport == null || ctrl.model.pswdReport.length <= 0)
        ) {
          toastr.error('Por favor complete el usuario y contraseña del URL');
          return;
        }

        ctrl.model.idUsuario = [];

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            ctrl.model.idUsuario.push({
              userId: ctrl.procesoUsuariosList[i].Usuario.Id,
              login: ctrl.procesoUsuariosList[i].Usuario.Login,
              verUrl: ctrl.procesoUsuariosList[i].verUrl,
              imprimirUrl: ctrl.procesoUsuariosList[i].imprimirUrl
            });
          }
        }

        ctrl.isBusy = true;

        dataService.saveAccesosUrl(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.accesosurl");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.update = function () {

        // if (!ctrl.form.$valid) {
        //   toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
        //   return;
        // }

        // if (ctrl.usuarioCargado == null || ctrl.usuarioCargado == "") {
        //   ctrl.usuarioCargado = { Id: 0, Login: '' }
        // }

        // ctrl.model.idUsuario = ctrl.usuarioCargado.Id;
        // ctrl.isBusy = true;

        // dataService.updateAccesosUrl(ctrl.model.id, ctrl.model)
        //   .then(function (response) {
        //     if (response.data.Success) {
        //       toastr.info("Registro exitoso.");
        //       $state.reload();
        //     } else {
        //       toastr.error(response.data.ErrorSummary);
        //     }
        //     ctrl.isBusy = false;
        //   }, function (error) {
        //     toastr.error(error.data || sharedService.getGenericErrorMessage(error));
        //     ctrl.isBusy = false;
        //   });

        if (
          ctrl.model.urlProcesoLink == null ||
          ctrl.model.urlProcesoLink.length <= 0 ||
          // ctrl.model.idProceso == null ||
          // ctrl.model.idProceso.Id <= 0 ||
          ctrl.procesoUsuariosList == null ||
          ctrl.procesoUsuariosList.length <= 0
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.MostrarUserAndPassword &&
          (ctrl.model.usrReport == null || ctrl.model.usrReport.length <= 0) &&
          (ctrl.model.pswdReport == null || ctrl.model.pswdReport.length <= 0)
        ) {
          toastr.error('Por favor complete el usuario y contraseña del URL');
          return;
        }

        ctrl.model.idUsuario = [];

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            ctrl.model.idUsuario.push({
              id: ctrl.procesoUsuariosList[i].id,
              userId: ctrl.procesoUsuariosList[i].Usuario.Id,
              login: ctrl.procesoUsuariosList[i].Usuario.Login,
              verUrl: ctrl.procesoUsuariosList[i].verUrl,
              imprimirUrl: ctrl.procesoUsuariosList[i].imprimirUrl
            });

          }
        }

        dataService.updateAccesosUrl(ctrl.model.id, ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.reload();
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.accesosurl");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;

        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?"
            },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteAccesosUrl(ctrl.model.id)
            .then(function (response) {
              if (response.data.Success) {
                toastr.info("Registro exitoso.");
                $state.transitionTo("pages.accesosurl");
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        });
        ctrl.isBusy = false;
      }

      ctrl.searchProceso = function (nombreProceso) {
        var filtroProceso = {
          Nombre: nombreProceso,
          PageSize: 20,
          SkipNumber: 0
        };

        return dataService.searchProceso(filtroProceso)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.clearUsuario = function () {
        ctrl.usuarioCargado = {
          id: 0,
          login: '',
          Usuario: null,
          userId: 0,
          verUrl: false,
          imprimirUrl: false
        };
      }

      ctrl.saveUsuarioModel = function () {
        if (ctrl.usuarioCargado == null || 
          ctrl.usuarioCargado.Usuario == null || 
          typeof ctrl.usuarioCargado.Usuario == "string") {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
          return;
        }

        // console.log(ctrl.usuarioCargado);

        // ctrl.usuarioCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioCargado.userId = ctrl.usuarioCargado.Usuario.Id;

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
          if (ctrl.procesoUsuariosList[i].Usuario.Login == ctrl.usuarioCargado.Usuario.Login)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoUsuariosList[index] = ctrl.usuarioCargado;
        else
          ctrl.procesoUsuariosList.push(ctrl.usuarioCargado);

        ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
        ctrl.clearUsuario();
      }

      ctrl.cargarUsuario = function (usuarioSeleccionado) {
        if (usuarioSeleccionado == null) {
          toastr.error('Por favor seleccione un usuario para poder visualizarlo');
          return;
        }

        ctrl.usuarioCargado.id = usuarioSeleccionado.id;
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado.Usuario;
        ctrl.usuarioCargado.userId = usuarioSeleccionado.userId;
        ctrl.usuarioCargado.verUrl = usuarioSeleccionado.verUrl;
        ctrl.usuarioCargado.imprimirUrl = usuarioSeleccionado.imprimirUrl;
      }

      ctrl.eliminarUsuario = function (index) {
        if (index < 0) {
          toastr.error('Usuario seleccionado inválido');
          return;
        }

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          ctrl.procesoUsuariosList.splice(index, 1);
        }
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.accesosurl').component('accesosurlList', {
    templateUrl: 'app/pages/accesosurl/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.mostrarAgregar = false;

      this.$onInit = function () {
        ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.urlProcesoLink = tableState.search.predicateObject.Url;
          ctrl.filtros.proceso = {
            Nombre: tableState.search.predicateObject.Proceso
          }
          // ctrl.filtros.usuario = {
          //   Login: tableState.search.predicateObject.Usuario
          // };
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }
        dataService.searchAccesosUrl(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); 
              //set the number of pages so the pagination can update
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.accesosurl-edit", { id: 0 });
      }

      ctrl.edit = function (id) {
        $state.go("pages.accesosurl-edit", { id: id });
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.autoautorizar', {
          url: '/autoautorizar',
          title: 'autoautorizar',
          template : '<autoautorizar-list></autoautorizar-list>',
          authenticate: true,
        })
        .state('pages.autoautorizar-edit', {
          url: '/autoautorizar/edit/:id',
          title: 'autoautorizar',
          template : '<autoautorizar-edit></autoautorizar-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.autoautorizar").component("autoautorizarEdit", {
    templateUrl: "app/pages/autoautorizar/edit.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      toastr,
      toastrConfig,
      $stateParams,
      $timeout,
      $uibModal
    ) {
      var ctrl = this;
      var authData = {};
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = "";
      ctrl.configuracionTituloText = "";
      ctrl.camposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0,
      };
      ctrl.resultListProcesos = [];
      ctrl.resultListTemplatesProcesos = [];
      ctrl.listaAutoSolicitud = [];

      this.$onInit = function () {
        authData = sharedService.getLoggedUser();
        loadProcesos();
        getParametrosByIdent(ctrl.ident);
      };

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;
          dataService.getAutoAutorizarById($stateParams.id).then(
            function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                ctrl.model.procesoId = "" + ctrl.model.procesoId + "";
                ctrl.model.CodigoProcedure =
                  "" + ctrl.model.CodigoProcedure + "";
                ctrl.model.campoId = "" + ctrl.model.campoId + "";
                ctrl.model.ProcesoTemplate = {
                  TemplateId: "" + ctrl.model.IdProcesoTemplate + "",
                };
                ctrl.loadTemplatesProcesos();
                ctrl.title = "Editar Auto Autorizar: " + ctrl.model.AutClave;
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
        } else {
          ctrl.title = "Crear autoautorizar: -";
        }
      }

      function loadProcesos() {
        ctrl.isSearching = true;
        sharedService.showLoading();
        ctrl.listarAutoSolicitud();
        dataService.getCampoListLigth().then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
              dataService.searchProceso(ctrl.filtrosProcesos).then(
                function (response) {
                  if (response.data.Success) {
                    ctrl.resultListProcesos = response.data.Value.Resultados;
                    sharedService.closeLoading();
                    loadView();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isSearching = false;
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage(error)
                  );
                  ctrl.isSearching = false;
                }
              );
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      }

      ctrl.loadTemplatesProcesos = function () {
        ctrl.isSearching = true;
        dataService.searchTemplatesByProceso(ctrl.model.procesoId).then(
          function (response) {
            if (response.data.Success) {
              ctrl.resultListTemplatesProcesos = response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.listarAutoSolicitud = function buscar() {
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 500,
          SkipNumber: 0,
        };
        ctrl.filtros.DetalleAcciones = "";
        ctrl.filtros.SubjectCorreo = "";
        ctrl.filtros.AutoId = "";
        dataService.searchAutoSolicitud(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              ctrl.listaAutoSolicitud = response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.setIdSSolicitudEstado = function () {
        ctrl.model.ProcesoTemplateTemp = ctrl.model.ProcesoTemplate;
        if (
          ctrl.model.ProcesoTemplate != null &&
          ctrl.model.ProcesoTemplate != undefined
        ) {
          ctrl.model.IdProcesoTemplate =
            ctrl.model.ProcesoTemplateTemp.TemplateId;
          ctrl.model.IdSolicitudEstado =
            ctrl.model.ProcesoTemplateTemp.SolicitudEstadoId;
        } else {
          ctrl.model.IdSolicitudEstado = "";
        }
      };

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = "Editar Auto Solicitud: " + ctrl.model.autoautorizarId;
          else
            ctrl.title = "Crear Auto Solicitud: " + ctrl.model.autoautorizarId;
        }
      };

      ctrl.save = function () {
        if (!ctrl.form.$valid) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco"
          );
          return;
        }

        ctrl.isBusy = true;
        ctrl.model.autoautorizarDetalle = ctrl.procesoCamposDS;
        dataService.saveAutoAutorizar(ctrl.model).then(
          function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.autoautorizar");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.cancel = function () {
        $state.transitionTo("pages.autoautorizar");
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención";
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?";
            },
          },
        });
        confirmation.result.then(
          function (selectedItem) {
            dataService.deleteAutoAutorizar(ctrl.model.Id).then(
              function (response) {
                if (response.data.Success) {
                  toastr.info("Registro exitoso.");
                  $state.transitionTo("pages.autoautorizar");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
                ctrl.isBusy = false;
              }
            );
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.openAttachment = function (fileName) {
        var usuarioLogueadoId = authData.Id;
        var fullUrl = appConfig.uploadUrl + fileName;
        sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl);
        // window.open(appConfig.uploadUrl + fileName);
      };

      ctrl.uploadAttachment = function (file) {
        if (file == null) return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file).then(
          function (response) {
            $timeout(function () {
              if (response.data.Success) {
                ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }
        );
      };

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      };

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (!ctrl.formDetalle.$valid) {
          toastr.error(
            "Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle de autoautorizar"
          );
          return;
        }
        ctrl.campoCargado.autoautorizarId = this.model.autoautorizarId;
        if (ctrl.procesoCamposList == null) ctrl.procesoCamposList = [];

        /*var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          index = i;
        }*/
        /*if (index >= 0)
          ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else*/
        ctrl.procesoCamposList.push(ctrl.campoCargado);
        //ctrl.procesoCamposList.sort(function (a, b) { return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0); });
        ctrl.procesoCamposDS.push(ctrl.campoCargado);
        ctrl.campoCargado = {};
      };

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error("Por favor seleccione un campo para poder visualizarlo");
          return;
        }

        ctrl.campoCargado = {};
        ctrl.campoCargado.autoautorizarId = campoSeleccionado.autoautorizarId;
        ctrl.campoCargado.OrigenCampo = campoSeleccionado.OrigenCampo;
        ctrl.campoCargado.IdCampoDestino = campoSeleccionado.IdCampoDestino;
        ctrl.campoCargado.IdCampoOrigen = campoSeleccionado.IdCampoOrigen;
        ctrl.campoCargado.OrigenCampoA = campoSeleccionado.OrigenCampoA;
        ctrl.campoCargado.IdCampoOrigenA = campoSeleccionado.IdCampoOrigenA;
        ctrl.campoCargado.OrigenCampoB = campoSeleccionado.OrigenCampoB;
        ctrl.campoCargado.IdCampoOrigenB = campoSeleccionado.IdCampoOrigenB;
        ctrl.campoCargado.OrigenCampoC = campoSeleccionado.OrigenCampoC;
        ctrl.campoCargado.IdCampoOrigenC = campoSeleccionado.IdCampoOrigenC;
        ctrl.campoCargado.ValCampoOrigen = campoSeleccionado.ValCampoOrigen;
        ctrl.campoCargado.UsuarioCreacionid =
          campoSeleccionado.UsuarioCreacionid;
        ctrl.campoCargado.UsuarioModificacionId =
          campoSeleccionado.UsuarioModificacionId;
      };

      ctrl.ident = "AUTOAUTORIZAR";
      ctrl.auxParams = [];
      function getParametrosByIdent(Ident) {
        if (Ident != "") {
          dataService
            .obtenerALLParametrosByIdent(Ident)
            .then(function (response) {
              if (response.data.Success && response.data.Value != null) {
                ctrl.showBtnLink = true;
                ctrl.auxParams = response.data.Value;
              }
            });
        }
      }

      ctrl.returnDescription = function (tipocampo) {
        if (ctrl.auxParams.length > 1) {
          return ctrl.auxParams.filter(function (p) {
            return p.TipoCampo == tipocampo;
          })[0].Descripcion;
        }
        return;
      };

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error("Campo seleccionado inválido");
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      };

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      };
    },
  });
})(window.angular);

(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.autoautorizar').component('autoautorizarList', {
      templateUrl: 'app/pages/autoautorizar/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.DetalleAcciones = tableState.search.predicateObject.DetalleAcciones;
            ctrl.filtros.SubjectCorreo = tableState.search.predicateObject.SubjectCorreo;
            ctrl.filtros.AutoId = tableState.search.predicateObject.AutoId;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            //ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;
            ctrl.filtros.AutClave = tableState.search.predicateObject.AutClave;
            ctrl.filtros.DescripAccion = tableState.search.predicateObject.DescripAccion;
            ctrl.filtros.CodigoProcedure = tableState.search.predicateObject.CodigoProcedure;

            // if (tableState.search.predicateObject.Proceso != null) {
            //   ctrl.filtros.Proceso.Nombre = tableState.search.predicateObject.Proceso;
            // }

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchAutoAutorizar(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          // console.log("");
          var authData =  sharedService.getLoggedUser();
          // console.log(authData);
          // console.log(ctrl);
          $state.go("pages.autoautorizar-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.autoautorizar-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.autosolicitud').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.autosolicitud', {
          url: '/autosolicitud',
          title: 'Autosolicitud',
          template : '<autosolicitud-list></autosolicitud-list>',
          authenticate: true,
        })
        .state('pages.autosolicitud-edit', {
          url: '/autosolicitud/edit/:id',
          title: 'Autosolicitud',
          template : '<autosolicitud-edit></autosolicitud-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.autosolicitud').component('autosolicitudEdit', {
    templateUrl: 'app/pages/autosolicitud/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      var authData = {};
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = '';
      ctrl.configuracionTituloText = "";

      ctrl.procesoCamposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0
      };
      ctrl.resultListProcesos = [];
      ctrl.ident = "AUTO";
      ctrl.auxParams = [];

      this.$onInit = function () {
        authData = sharedService.getLoggedUser();
        loadView();
        getParametrosByIdent(ctrl.ident);
      };

      function getParametrosByIdent(Ident) {
        if (Ident != "") {
          dataService.obtenerALLParametrosByIdent(Ident).then(function (response) {
            if (response.data.Success && response.data.Value != null) {
              ctrl.showBtnLink = true;
              ctrl.auxParams = response.data.Value;
              // console.log(ctrl.auxParams)
            }
          });
        }
      };

      ctrl.returnDescription = function (tipocampo) {
        if (ctrl.auxParams.length > 1) {
          return ctrl.auxParams.filter(
            function (p) {
              return p.TipoCampo == tipocampo
            }
          )[0].Descripcion;
        }
        return;
      }

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;

          dataService.getAutoSolicitudById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                // console.log("LLEGO PROCESOP");
                // console.log(ctrl.model);
                ctrl.title = 'Editar AutoSolicitud: ' + ctrl.model.AutoId;
                ctrl.procesoCamposList = ctrl.model.autoSolicitudDetalle;
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            });
        } else {
          ctrl.title = 'Crear AutoSolicitud: -';
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Auto Solicitud: ' + ctrl.model.AutoSolicitudId;
          else
            ctrl.title = 'Crear Auto Solicitud: ' + ctrl.model.AutoSolicitudId;
        }
      }

      ctrl.save = function () {

        // console.log(ctrl.form);
        if (!ctrl.form.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        ctrl.isBusy = true;
        ctrl.model.autoSolicitudDetalle = ctrl.procesoCamposDS;

        dataService.saveAutoSolicitud(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.autosolicitud");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.autosolicitud");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?"
            },
          }
        });
        confirmation.result.then(function (selectedItem) {
          dataService.deleteAutoSolicitud(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.autosolicitud");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.openAttachment = function (fileName) {
        var usuarioLogueadoId = authData.Id;
        var fullUrl = appConfig.uploadUrl + fileName;
        sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl);
        // window.open(appConfig.uploadUrl + fileName);
      }

      ctrl.uploadAttachment = function (file) {
        if (file == null)
          return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file)
          .then(function (response) {
            $timeout(function () {
              // console.log(response);
              if (response.data.Success) {
                // console.log('uploadFileAttachment: ' + response.data.Value);
                ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          });
      }

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      }

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (!ctrl.formDetalle.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle de AutoSolicitud');
          return;
        }
        ctrl.campoCargado.AutoSolicitudId = this.model.AutoSolicitudId;
        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        if (ctrl.campoCargado.Id != undefined && ctrl.campoCargado.Id != "") {
          ctrl.procesoCamposList = ctrl.procesoCamposList.filter(function (item) {
            return item.Id != ctrl.campoCargado.Id
          });
        }
        ctrl.procesoCamposList.push(ctrl.campoCargado);

        if (ctrl.campoCargado.Id != undefined && ctrl.campoCargado.Id != "") {
          ctrl.procesoCamposDS = ctrl.procesoCamposDS.filter(function (item) {
            return item.Id != ctrl.campoCargado.Id
          });
        }
        ctrl.procesoCamposDS.push(ctrl.campoCargado);
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {

        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        }

        ctrl.campoCargado = {};
        ctrl.campoCargado.AutoSolicitudId = campoSeleccionado.AutoSolicitudId;
        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.OrigenCampo = campoSeleccionado.OrigenCampo;
        ctrl.campoCargado.IdCampoDestino = campoSeleccionado.IdCampoDestino;
        ctrl.campoCargado.IdCampoOrigen = campoSeleccionado.IdCampoOrigen;
        ctrl.campoCargado.OrigenCampoA = campoSeleccionado.OrigenCampoA;
        ctrl.campoCargado.IdCampoOrigenA = campoSeleccionado.IdCampoOrigenA;
        ctrl.campoCargado.OrigenCampoB = campoSeleccionado.OrigenCampoB;
        ctrl.campoCargado.IdCampoOrigenB = campoSeleccionado.IdCampoOrigenB;
        ctrl.campoCargado.OrigenCampoC = campoSeleccionado.OrigenCampoC;
        ctrl.campoCargado.IdCampoOrigenC = campoSeleccionado.IdCampoOrigenC;
        ctrl.campoCargado.ValCampoOrigen = campoSeleccionado.ValCampoOrigen;
        ctrl.campoCargado.UsuarioCreacionid = campoSeleccionado.UsuarioCreacionid;
        ctrl.campoCargado.UsuarioModificacionId = campoSeleccionado.UsuarioModificacionId;

      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }


    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.autosolicitud').component('autosolicitudList', {
      templateUrl: 'app/pages/autosolicitud/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.DetalleAcciones = tableState.search.predicateObject.DetalleAcciones;
            ctrl.filtros.SubjectCorreo = tableState.search.predicateObject.SubjectCorreo;
            ctrl.filtros.AutoId = tableState.search.predicateObject.AutoId;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            //ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchAutoSolicitud(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          // console.log("");
          var authData =  sharedService.getLoggedUser();
          // console.log(authData);
          // console.log(ctrl);
          $state.go("pages.autosolicitud-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.autosolicitud-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.auxparametros').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.auxparametros', {
          url: '/auxparametros',
          title: 'auxparametros',
          template : '<auxparametros-list></auxparametros-list>',
          authenticate: true,
        })
        .state('pages.auxparametros-edit', {
          url: '/auxparametros/edit/:id',
          title: 'auxparametros',
          template : '<auxparametros-edit></auxparametros-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.auxparametros').component('auxparametrosEdit', {
    templateUrl: 'app/pages/auxparametros/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;
      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;
      ctrl.title = '';
      ctrl.configuracionTituloText = "";
      ctrl.camposList = [];

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};

      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0
      };
      ctrl.resultListProcesos = [];
      ctrl.resultListTemplatesProcesos = [];
      ctrl.listaAutoSolicitud = [];

      this.$onInit = function () {
        loadView();
        //loadCampos();
      };

      function loadView() {
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;
          dataService.getAuxParametrosById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                // console.log("LLEGO RESPONSE");
                // console.log(ctrl.model);                                                
                ctrl.model.campoId = ""+ctrl.model.campoId + "";                
                ctrl.title = 'Editar Auto Autorizar: ' + ctrl.model.Ident;
                ctrl.model.campo =  {
                  Id : ctrl.model.Campo.Id,
                  Nombre : ctrl.model.Campo.Nombre,
                };
                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        } else {
          ctrl.title = 'Crear auxparametros: -';
        }
      }
 
      /******************* Campos Filtros  *******************/
      ctrl.searchCampos = function (nombre) {
        var filtroCampos = { Nombre: nombre, PageSize: 20, SkipNumber: 0 };
        return dataService.searchCampo(filtroCampos)
          .then(function (response) {
            if (response.data.Success) {
              // console.log(response.data.Value.Resultados);
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectCampo = function (campoSeleccionado) {
        // console.log("CAmpo SEleccionado");
        // console.log(campoSeleccionado);
        ctrl.model.campoId = campoSeleccionado.Id;
      }


      // function loadCampos() {
      //   ctrl.isSearching = true;        
      //   sharedService.showLoading();
      //   dataService.getCampoListLigth()
      //     .then(function (response) {
      //       if (response.data.Success) {
      //         loadView();
      //         var defaultCampo = {
      //           Id: 0,
      //           Nombre: ""
      //         };            
      //         ctrl.camposList = [];
      //         ctrl.camposList.push(defaultCampo);
      //         ctrl.camposList = ctrl.camposList.concat(response.data.Value);
      //         // console.log(ctrl.camposList); 
      //         sharedService.closeLoading();
      //       } else {
      //         toastr.error(response.data.ErrorSummary);
      //       }
      //     }, function (error) {
      //       toastr.error(error.data || sharedService.getGenericErrorMessage(error));
      //     });          
      // }

      ctrl.save = function () {
        // console.log(ctrl.form);
        if (!ctrl.form.$valid) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }
        ctrl.isBusy = true;
        dataService.saveAuxParametros(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.auxparametros");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.auxparametros");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado del registro seleccionado?"
            },
          }
        });
        confirmation.result.then(function (selectedItem) {
          dataService.deleteAuxParametros(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.auxparametros");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

 
 
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.auxparametros').component('auxparametrosList', {
      templateUrl: 'app/pages/auxparametros/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {
          ctrl.mostrarAgregar = sharedService.isSysAdminLoggedUser();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.Ident = tableState.search.predicateObject.Ident;
            ctrl.filtros.Descripcion = tableState.search.predicateObject.Descripcion;
            ctrl.filtros.ObjetivoParametro = tableState.search.predicateObject.ObjetivoParametro;
            ctrl.filtros.OrdenImp = tableState.search.predicateObject.OrdenImp;
            ctrl.filtros.TipoCampo = tableState.search.predicateObject.TipoCampo;
            ctrl.filtros.CreationDate = tableState.search.predicateObject.CreationDate;
            ctrl.filtros.LastUpdate = tableState.search.predicateObject.LastUpdate;
            // ctrl.filtros.UsuarioCreacionid = tableState.search.predicateObject.UsuarioCreacionid;
            // ctrl.filtros.UsuarioModificacionId = tableState.search.predicateObject.UsuarioModificacionId;
            ctrl.filtros.UrlDocumentos = tableState.search.predicateObject.UrlDocumentos;
            ctrl.filtros.Parametro1 = tableState.search.predicateObject.Parametro1;
            ctrl.filtros.Parametro2 = tableState.search.predicateObject.Parametro2;
            ctrl.filtros.Parametro3 = tableState.search.predicateObject.Parametro3;
            ctrl.filtros.Parametro4 = tableState.search.predicateObject.Parametro4;
            ctrl.filtros.Parametro5 = tableState.search.predicateObject.Parametro5;
            //ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }
          dataService.searchAuxParametros(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;
                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          // console.log("");
          var authData =  sharedService.getLoggedUser();
          // console.log(authData);
          // console.log(ctrl);
          $state.go("pages.auxparametros-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.auxparametros-edit",{id:id});
        }

        // function getUsuarioName(usuarioId) {
        //   var username = '';
        //   if (usuarioId != null) {
        //     dataService.getUsuarioById(usuarioId)
        //     .then(function(response) {
        //       if (response.data.Success) {
        //         username = response.data.Value;

        //         return username.Login;
        //       } else {
        //         toastr.error(response.data.ErrorSummary);
        //       }
        //     })
        //   }
        // }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.campo').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.campo', {
          url: '/campo',
          title: 'Campo',
          template : '<campo-list></campo-list>',
          authenticate: true,
        })
        .state('pages.campo-edit', {
          url: '/campo/edit/:id',
          title: 'Campo',
          template : '<campo-edit></campo-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.campo').component('campoEdit', {
    templateUrl: 'app/pages/campo/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = '';
      ctrl.campoTipoList = [];
      // ctrl.jerarquiaList = [];
      ctrl.periodoList = [];
      ctrl.camposTablaList = [];

      this.$onInit = function () {
        dataService.getCampoTipoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.campoTipoList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        // dataService.getJerarquiaPadreList()
        //   .then(function (response) {
        //     if (response.data.Success) {
        //       ctrl.jerarquiaList = response.data.Value;
        //     }
        //     else {
        //       toastr.error(response.data.ErrorSummary);
        //     }
        //   }, function (error) {
        //     toastr.error(error.data || sharedService.getGenericErrorMessage(error));
        //   });

        dataService.getPeriodoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.periodoList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        if ($stateParams.id != "0") {
          ctrl.title = 'Editar Campo';

          dataService.getCampo($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                if (ctrl.model != null) {
                  ctrl.showDelete = true;
                  // console.log(ctrl.model.CampoTipo);
                  if (ctrl.model.CampoTipo.Codigo == "COND") {
                    ctrl.camposTablaListCondicional = ctrl.model.Columnas;
                  } else if (ctrl.model.CampoTipo.Codigo == "NUMERADOR") {
                    ctrl.camposTablaListNumerador = ctrl.model.Columnas;
                  } else {
                    ctrl.camposTablaList = ctrl.model.Columnas;
                  }
                  // console.log(ctrl.camposTablaList);
                }
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        }
        else {
          ctrl.title = 'Crear Campo';
        }
      };

      ctrl.save = function (form) {


        if (ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.CampoId == null ||
          ctrl.model.CampoId == '' ||
          ctrl.model.CampoTipo == null ||
          ctrl.model.CampoTipo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if ((ctrl.model.CampoTipo.Codigo == 'JERARQ' ||
          ctrl.model.CampoTipo.Codigo == 'LIST' ||
          ctrl.model.CampoTipo.Codigo == 'MULTI_LIST') &&
          (ctrl.model.Jerarquia == null || ctrl.model.Jerarquia.Id <= 0)) {
          toastr.error('Por favor seleccione una jerarquía para continuar con la operación');
          return;
        }

        if (ctrl.model.CampoTipo.Codigo == 'TABLE' || ctrl.model.CampoTipo.Codigo == 'TABLEENR') {
          if (ctrl.model.TotalRegistrosTabla == null || ctrl.model.TotalRegistrosTabla <= 0) {
            toastr.error('Por favor ingrese la cantidad de filas que tendrá la tabla');
            return;
          }

          if (ctrl.camposTablaList == null || ctrl.camposTablaList.length <= 0) {
            toastr.error('Por favor seleccione al menos un campo para formar la tabla');
            return;
          }
        }

        ctrl.isBusy = true;

        ctrl.model.Activo = 1;
        ctrl.model.JerarquiaId = null;
        ctrl.model.CampoTipoId = ctrl.model.CampoTipo.Id;
        ctrl.model.Columnas = null;

        if (ctrl.model.CampoTipo.Codigo == 'TABLE' || ctrl.model.CampoTipo.Codigo == 'TABLEENR')
          ctrl.model.Columnas = ctrl.camposTablaList;

        if (ctrl.model.CampoTipo.Codigo == 'COND') {
          ctrl.model.Columnas = ctrl.camposTablaListCondicional;
        }
        if (ctrl.model.CampoTipo.Codigo == 'NUMERADOR') {
          ctrl.model.Columnas = ctrl.camposTablaListNumerador;
        }

        if ((ctrl.model.CampoTipo.Codigo == 'JERARQ' ||
          ctrl.model.CampoTipo.Codigo == 'LIST' ||
          ctrl.model.CampoTipo.Codigo == 'MULTI_LIST') &&
          ctrl.model.Jerarquia != null)
          ctrl.model.JerarquiaId = ctrl.model.Jerarquia.Id;

        if (ctrl.model.CampoTipo.Codigo != 'JERARQ')
          ctrl.model.PermiteAltaJerarquia = false;

        dataService.saveCampo(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.campo");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.campo");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return "Atención" },
            message: function () { return "Confirma el borrado del campo?" },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteCampo(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.campo");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      /*** COLUMNAS DE CAMPO TIPO TABLA **/
      ctrl.searchColumnaCampo = function (nombreCampo) {
        var filtroCampo = { Nombre: nombreCampo, PageSize: 20, SkipNumber: 0 };

        return dataService.searchCampo(filtroCampo)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectColumnaCampo = function (campoSeleccionado) {
        ctrl.campoCargado.ColumnaCampo = campoSeleccionado;
      }
      ctrl.editColumnaCampo = function () {
        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.model.CampoTipo.Codigo == 'TABLEENR') {
          if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATETIMEREGIONAL' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'MULTI_LIST' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'JERARQ' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'LINK' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'USER' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'LIST' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE') {
            toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
            return;
          }
          // console.log(" ES UNA TABLA ..................");
        } else {
          if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
            ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE') {
            toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
            return;
          }

        }



        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        //ctrl.campoCargado.CampoId = ctrl.model.Id;
        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;

        if (ctrl.camposTablaList == null)
          ctrl.camposTablaList = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaList.length; i++) {
          if (ctrl.camposTablaList[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (index >= 0)
          ctrl.camposTablaList[index] = ctrl.campoCargado;
        else
          ctrl.camposTablaList.push(ctrl.campoCargado);

        ctrl.campoCargado = {};
      }

      ctrl.eliminarColumnaCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.camposTablaList != null && ctrl.camposTablaList.length > 0)
          ctrl.camposTablaList.splice(index, 1);
      }

      ctrl.editColumnaCampoCondicional = function () {

        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0 ||
          !ctrl.campoCargado.hasOwnProperty("condicion")
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'IMG' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE'
        ) {
          toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;
        if (ctrl.camposTablaListCondicional == null)
          ctrl.camposTablaListCondicional = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaListCondicional.length; i++) {
          if (ctrl.camposTablaListCondicional[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (ctrl.camposTablaListCondicional.length < 10) {
          if (index >= 0) {
            ctrl.camposTablaListCondicional[index] = ctrl.campoCargado;
          } else {
            ctrl.camposTablaListCondicional.push(ctrl.campoCargado);
          }
        } else {
          toastr.error('No puede agregar mas de 10 condicionales');
          return;
        }

        ctrl.campoCargado = {};
        // console.log(ctrl.camposTablaListCondicional);
      }

      ctrl.editColumnaCampoNumerador = function () {

        if (ctrl.campoCargado == null ||
          ctrl.campoCargado.ColumnaCampo == null ||
          ctrl.campoCargado.ColumnaCampo.Id <= 0
        ) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'INT' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DECIMAL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'DATE' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'BOOL' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TEXTAREA' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'ATTACH' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'IMG' &&
          ctrl.campoCargado.ColumnaCampo.CampoTipo.Codigo != 'TITLE'
        ) {
          toastr.error('No puede agregar el tipo de campo ' + ctrl.campoCargado.ColumnaCampo.CampoTipo.Nombre + ' entre las columnas');
          return;
        }

        if (ctrl.campoCargado.ColumnaCampo.Id == ctrl.model.Id) {
          toastr.error('No puede agregar el mismo campo que está editando');
          return;
        }

        ctrl.campoCargado.ColumnaCampoId = ctrl.campoCargado.ColumnaCampo.Id;
        if (ctrl.camposTablaListNumerador == null)
          ctrl.camposTablaListNumerador = [];

        var index = -1;
        for (var i = 0; i < ctrl.camposTablaListNumerador.length; i++) {
          if (ctrl.camposTablaListNumerador[i].ColumnaCampo.Id == ctrl.campoCargado.ColumnaCampo.Id) {
            index = i;
            break;
          }
        }

        if (ctrl.camposTablaListNumerador.length < 10) {
          if (index >= 0) {
            ctrl.camposTablaListNumerador[index] = ctrl.campoCargado;
          } else {
            ctrl.camposTablaListNumerador.push(ctrl.campoCargado);
          }
        } else {
          toastr.error('No puede agregar mas de 10 condicionales');
          return;
        }

        ctrl.campoCargado = {};
        // console.log(ctrl.camposTablaListNumerador);
      }


      ctrl.eliminarColumnaCampoNumerador = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }
        if (ctrl.camposTablaListNumerador != null && ctrl.camposTablaListNumerador.length > 0)
          ctrl.camposTablaListNumerador.splice(index, 1);
      }

      ctrl.eliminarColumnaCampoCondicional = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }
        if (ctrl.camposTablaListCondicional != null && ctrl.camposTablaListCondicional.length > 0)
          ctrl.camposTablaListCondicional.splice(index, 1);
      }

      ctrl.searchJerarquia = function (nombreJerarquia) {
        var filtroJerarquia = {
          Nombre: nombreJerarquia,
          PageSize: 20,
          SkipNumber: 0
        };

        return dataService.searchJerarquia(filtroJerarquia)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.searchCampoTipo = function (nombreCampoTipo) {
        // este método realiza un filtrado para mostrar en el input de tipo busqueda, los campo tipo. Se hizo de esta forma porque no hay un endpoint de searchCampoTipo, por lo que el filtrado se hacen desde el front
        return ctrl.campoTipoList.filter(function(campo) {
          if (nombreCampoTipo == "_") 
            return campo;
          else if (campo.Nombre.toUpperCase().includes(nombreCampoTipo.toUpperCase())) 
            return campo;
        })
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.campo').component('campoList', {
    templateUrl: 'app/pages/campo/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.CampoId = tableState.search.predicateObject.CampoId;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.CampoTipo = tableState.search.predicateObject.CampoTipo;
          ctrl.filtros.Jerarquia = tableState.search.predicateObject.Jerarquia;
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchCampo(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.campo-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.campo-edit",{id:id});
      }
    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.grupo').component('grupoEdit', {
      templateUrl: 'app/pages/grupo/edit.template.html',
      controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $timeout, $stateParams, $uibModal) {
        var ctrl = this;
        var authData = {};
        ctrl.model = {};
        ctrl.isBusy = false;
        ctrl.showDelete = false;
        ctrl.title = '';
  
        this.$onInit = function () 
        {
          authData = sharedService.getLoggedUser();

          if ($stateParams.id != "0") 
          {
            ctrl.title = 'Editar Grupo';

            dataService.getGrupoById($stateParams.id)
              .then(function (response) 
              {
                if (response.data.Success) 
                {
                  ctrl.model = response.data.Value;
                  ctrl.showDelete = true;
                } 
                else 
                {
                  toastr.error(response.data.ErrorSummary);
                }
              }, function (error) {
                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              });
          } 
          else 
          {
            ctrl.title = 'Crear Grupo';
          }
        };
  
        ctrl.save = function (form) 
        {
          // if (form.$invalid) 
          // {
          //   ctrl.showError = true;
          //   return;
          // }

          if (ctrl.model.Nombre == null ||
              ctrl.model.Nombre == '')
          {
            toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
            return;
          }

          if (ctrl.model.MostrarEnHome && ctrl.model.HomeOrden <= 0)
          {
            toastr.error('Por favor ingrese el orden para mostrar en la home');
            return;
          }
  
          ctrl.isBusy = true;
  
          ctrl.model.Activo = 1;
            
          dataService.saveGrupo(ctrl.model)
            .then(function (response) 
            {
              if (response.data.Success) 
              {
                toastr.info("Registro exitoso.");
                $state.transitionTo("pages.grupo");
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
            });
        }
  
        ctrl.cancel = function () 
        {
          $state.transitionTo("pages.grupo");
        }
  
        ctrl.delete = function () 
        {
          ctrl.isBusy = true;
          var confirmation = $uibModal.open({
            animation: true,
            component: "confirmation",
            resolve: {
              title: function () { return "Atención" },
              message: function () { return "Confirma el borrado del grupo?" },
            }
          });
  
          confirmation.result.then(function (selectedItem) 
          {
            dataService.deleteGrupo(ctrl.model.Id).then(function (response) 
            {
              if (response.data.Success) 
              {
                toastr.info("Registro exitoso.");
                $state.transitionTo("pages.grupo");
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
            }); 
          }, function () {
            ctrl.isBusy = false;
          });
        }

        ctrl.openAttachment = function (fileName) {
          var usuarioLogueadoId = authData.Id;
          var fullUrl = appConfig.uploadUrl + fileName;
          sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl);
          // window.open(appConfig.uploadUrl + fileName);
        }

        ctrl.uploadAttachment = function (file) 
        {
          if (file == null)
            return;

          ctrl.isBusy = true;
          ctrl.model.isImageLoading = true;

          dataService.uploadImageFileGrupo(file)
            .then(function (response) 
            {
              $timeout(function () 
              {
                //console.log(response);
                if (response.data.Success)
                {
                  //console.log('uploadFileAttachment: ' + response.data.Value);
                  ctrl.model.UrlImagen = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
                }
                else
                {
                  ctrl.model.UrlImagen = null;
                }
              });
              ctrl.isBusy = false;
              ctrl.model.isImageLoading = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
              ctrl.model.isImageLoading = false;
            });
        }

        ctrl.removeAttachment = function () 
        {
          ctrl.model.UrlImagen = null;
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupo').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.grupo', {
          url: '/grupo',
          title: 'Grupo',
          template : '<grupo-list></grupo-list>',
          authenticate: true,
        })
        .state('pages.grupo-edit', {
          url: '/grupo/edit/:id',
          title: 'Grupo',
          template : '<grupo-edit></grupo-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.grupo').component('grupoList', {
    templateUrl: 'app/pages/grupo/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Resumen = tableState.search.predicateObject.Resumen;
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchGrupo(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.grupo-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.grupo-edit",{id:id});
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.grupos-usuarios').component('gruposUsuariosEdit', {
    templateUrl: 'app/pages/grupos-usuarios/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $timeout, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = '';
      ctrl.procesoUsuariosList;

      this.$onInit = function () {
        var gruposUsuariosEditTitle, editingTitle, creatingTitle;

        if (ctrl.language == "español") {
          gruposUsuariosEditTitle = 'Grupos Usuario';
          ctrl.successfulRegistration = "Registro exitoso.";
          editingTitle = "Editar Grupo de Usuarios";
          creatingTitle = "Crear Grupo de Usuarios";

        } else if (ctrl.language == "ingles") {
          gruposUsuariosEditTitle = 'Users Group';
          ctrl.successfulRegistration = "Registration successful.";
          editingTitle = "Edit User Group";
          creatingTitle = "Create User Group";

        } else if (ctrl.language == "portugues") {
          gruposUsuariosEditTitle = 'Grupo de Usuários';
          ctrl.successfulRegistration = "Registro bem-sucedido.";
          editingTitle = "Editar grupo de usuários";
          creatingTitle = "Criar grupo de usuários";

        } else if (ctrl.language == "italiano") {
          gruposUsuariosEditTitle = 'Grupos Usuario';
          ctrl.successfulRegistration = "Registro exitoso.";
          editingTitle = "Editar Grupo de Usuarios";
          creatingTitle = "Crear Grupo de Usuarios";

        }

        $state.current.title = gruposUsuariosEditTitle;

        if ($stateParams.id != "0") {
          ctrl.title = editingTitle;

          dataService.getGruposUsuariosById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                ctrl.procesoUsuariosList = ctrl.model.gruposUsuariosRelacion;
                ctrl.showDelete = true;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        } else {
          ctrl.title = creatingTitle;
        }
      };

      ctrl.save = function (form) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco";
        else if (ctrl.language == "ingles")
          errorText = "Complete the required fields marked with an asterisk";
        else if (ctrl.language == "portugues")
          errorText = "Preencha os campos obrigatórios marcados com um asterisco";
        else if (ctrl.language == "italiano")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco";

        if (ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '') {
          toastr.error(errorText);
          return;
        }
        ctrl.isBusy = true;
        ctrl.model.Activo = 1;
        // console.log(ctrl.procesoUsuariosList);
        ctrl.model.gruposUsuariosRelacion = [];
        //ctrl.model.GruposUsuariosRelacion = ctrl.procesoUsuariosList;
        var grupoUsuariosRelacion = {};

        for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
          grupoUsuariosRelacion = {};
          grupoUsuariosRelacion.usuarioId = ctrl.procesoUsuariosList[i].Usuario.Id;
          grupoUsuariosRelacion.Usuario = ctrl.procesoUsuariosList[i].Usuario;
          grupoUsuariosRelacion.grupoId = ctrl.procesoUsuariosList[i].grupoId;
          ctrl.model.gruposUsuariosRelacion.push(grupoUsuariosRelacion);
        }

        // console.log("OBJ TO SAVE");
        // console.log(ctrl.model);
        dataService.saveGruposUsuarios(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info(ctrl.successfulRegistration);
              $state.transitionTo("pages.grupos-usuarios");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.grupos-usuarios");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;

        var modalTitle, modalMessage;

        if (ctrl.language == "español") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado del grupo de usuario?";
        } else if (ctrl.language == "ingles") {
          modalTitle = "Attention";
          modalMessage = "Do you confirm the deletion of the user group?";
        } else if (ctrl.language == "portugues") {
          modalTitle = "Atenção";
          modalMessage = "Confirmar a exclusão do grupo de usuários?";
        } else if (ctrl.language == "italiano") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado del grupo de usuario?";
        }

        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return modalTitle
            },
            message: function () {
              return modalMessage
            },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteGruposUsuarios(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info(ctrl.successfulRegistration);
              $state.transitionTo("pages.grupos-usuarios");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }



      /******************* Proceso Usuarios *******************/
      ctrl.searchUsuario = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0
        };

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectUsuario = function (usuarioSeleccionado) {
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado;
      }

      ctrl.editUsuario = function () {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario";
        else if (ctrl.language == "ingles")
          errorText = "Please complete the mandatory data marked with an asterisk to load the user";
        else if (ctrl.language == "portugues")
          errorText = "Preencha os dados obrigatórios marcados com um asterisco para carregar o usuário";
        else if (ctrl.language == "italiano")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario";

        if (ctrl.usuarioCargado == null ||
          ctrl.usuarioCargado.Usuario == null ||
          ctrl.usuarioCargado.Usuario.Id == 0) {
          toastr.error(errorText);
          return;
        }

        ctrl.usuarioCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioCargado.UsuarioId = ctrl.usuarioCargado.Usuario.Id;

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
          if (ctrl.procesoUsuariosList[i].Usuario.Login == ctrl.usuarioCargado.Usuario.Login)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoUsuariosList[index] = ctrl.usuarioCargado;
        else
          ctrl.procesoUsuariosList.push(ctrl.usuarioCargado);

        ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
        ctrl.usuarioCargado = {};

        //Actualizo los permisos para el usuario cargado
        //ctrl.loadSeguridadTemplatesTab();            
      }

      ctrl.cargarUsuario = function (usuarioSeleccionado) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor seleccione un usuario para poder visualizarlo";
        else if (ctrl.language == "ingles")
          errorText = "Please select a user to view it";
        else if (ctrl.language == "portugues")
          errorText = "Selecione um usuário para visualizá-lo";
        else if (ctrl.language == "italiano")
          errorText = "Por favor seleccione un usuario para poder visualizarlo";

        if (usuarioSeleccionado == null) {
          toastr.error(errorText);
          return;
        }

        ctrl.usuarioCargado = {};

        ctrl.usuarioCargado.ProcesoId = usuarioSeleccionado.ProcesoId;
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado.Usuario;
        ctrl.usuarioCargado.UsuarioInput = usuarioSeleccionado.Usuario.Login;
        ctrl.usuarioCargado.RolProcesoList = usuarioSeleccionado.RolProcesoList;
      }

      ctrl.eliminarUsuario = function (userId) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Usuario seleccionado inválido";
        else if (ctrl.language == "ingles")
          errorText = "Invalid selected user";
        else if (ctrl.language == "portugues")
          errorText = "Usuário selecionado inválido";
        else if (ctrl.language == "italiano")
          errorText = "Usuario seleccionado inválido";

        if (userId == undefined || userId == null || userId <= 0) {
          toastr.error(errorText);
          return;
        }

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          var procesoUsuariosListFinal = [];
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            if (ctrl.procesoUsuariosList[i].Usuario.Id != userId)
              procesoUsuariosListFinal.push(ctrl.procesoUsuariosList[i]);
          }

          ctrl.procesoUsuariosList = procesoUsuariosListFinal;
        }

        // if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
        //   ctrl.procesoUsuariosList.splice(index, 1);
        //   //Actualizo los permisos de templates para los usuarios que quedaron
        //   //ctrl.loadSeguridadTemplatesTab();
        // }
      }

      ctrl.clearUsuario = function () {
        ctrl.usuarioCargado = {};
      }

      ctrl.concatRolesString = function (values) {
        return values.map(function (elem) {
          if (elem != null)
            return elem.Nombre;
          return "";
        }).join(", ");
      }

    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.grupos-usuarios').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.grupos-usuarios', {
          url: '/grupos-usuarios',
          title: '',
          template : '<grupos-usuarios-list></grupos-usuarios-list>',
          authenticate: true,
        })
        .state('pages.grupos-usuarios-edit', {
          url: '/grupos-usuarios/edit/:id',
          title: '',
          template : '<grupos-usuarios-edit></grupos-usuarios-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.grupo').component('gruposUsuariosList', {
    templateUrl: 'app/pages/grupos-usuarios/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      ctrl.language = sharedService.getLanguage();

      
      this.$onInit = function () {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
        var gruposUsuariosListTitle;

        if (ctrl.language == "español")
          gruposUsuariosListTitle = 'Grupos Usuario';
        else if (ctrl.language == "ingles")
          gruposUsuariosListTitle = 'Users Group';
        else if (ctrl.language == "portugues")
          gruposUsuariosListTitle = 'Grupo de Usuários';
        else if (ctrl.language == "italiano")
          gruposUsuariosListTitle = 'Grupos Usuario';

        $state.current.title = gruposUsuariosListTitle;
      };
      // console.log(ctrl.anularVista);

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10; // Number of entries showed per page.

        ctrl.filtros = {
          PageSize: number,
          SkipNumber: start
        };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Resumen = tableState.search.predicateObject.Resumen;
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchGruposUsuarios(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;
              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.grupos-usuarios-edit", {
          id: 0
        });
      }

      ctrl.edit = function (id) {
        // console.log("EDITO!!!" + id  );
        $state.go("pages.grupos-usuarios-edit", {
          id: id
        });
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.home').component('homeInicio', {
    templateUrl: 'app/pages/home/home.html',
    controller: function (sharedService) { //$scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;   

      ctrl.powerbiReport = sharedService.getPowerbiReport('?rs:embed=true');

      // console.log(sharedService.getPowerbiReport('?rs:embed=true'));

      // ctrl.grupos = [];

      // this.$onInit = function () {
      //   ctrl.isGroupSearching = true;

      //   dataService.getGrupoHomeList()
      //     .then(function (response) {
      //       if (response.data.Success) {
      //         ctrl.grupos = response.data.Value;
      //       }
      //       else {
      //         toastr.error(response.data.ErrorSummary);
      //       }
      //       ctrl.isGroupSearching = false;
      //     }, function (error) {
      //       toastr.error(error.data || sharedService.getGenericErrorMessage(error));
      //       ctrl.isGroupSearching = false;
      //     });
      // };

      // ctrl.setGrupoSeleccionado = function (grupoId) {
      //   $state.go('pages.solicitud-procesos', { grupoId: grupoId });
      // };
    }
  });
})(window.angular);
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.jerarquia").component("jerarquiaEdit", {
    templateUrl: "app/pages/jerarquia/edit.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      toastr,
      toastrConfig,
      $stateParams,
      $uibModal
    ) {
      var ctrl = this;
      var authData = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.model.Permisos = {};
      ctrl.model.TieneJerarquiaPermisosCampos = false;
      ctrl.GruposUsuariosList = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.isOnlyRead = false;
      ctrl.title = "";
      ctrl.resultListProcesos = [];
      ctrl.resultListCamposProceso = [];
      ctrl.arrayTemplateSeleccionados = [];
      ctrl.campoCargado = {};
      ctrl.contadorProcesoSelected = 0;
      ctrl.filtrosProcesos = {
        PageSize: 500,
        SkipNumber: 0,
      };
      ctrl.resultListJerarquiaProcesos = [];
      ctrl.model.listaProcesosTemplates = [];

      ctrl.procesoFounded1 = null;
      ctrl.procesoFounded2 = null;

      ctrl.GruposUsuariosListFiltered = [];
      ctrl.GruposUsuariosListFilteredNoResults = false;

      function initialize() {
        authData = sharedService.getLoggedUser();
        var jerarquiaEditTitle;

        if (ctrl.language == "español") {
          jerarquiaEditTitle = 'Jerarquía';
          ctrl.successfulRegistration = "Registro exitoso.";
        } else if (ctrl.language == "ingles") {
          jerarquiaEditTitle = 'Hierarchy';
          ctrl.successfulRegistration = "Registration successful.";
        } else if (ctrl.language == "portugues") {
          jerarquiaEditTitle = 'Hierarquia';
          ctrl.successfulRegistration = "Registro bem-sucedido.";
        } else if (ctrl.language == "italiano") {
          jerarquiaEditTitle = 'Jerarquía';
          ctrl.successfulRegistration = "Registro exitoso.";
        }

        $state.current.title = jerarquiaEditTitle;

        // ctrl.loadGrupos();
        loadProcesos();
        afterInitialize();
      }

      function afterInitialize() {
        var editingTitle, creatingTitle;

        if (ctrl.language == "español") {
          editingTitle = "Editar Jerarquía";
          creatingTitle = "Crear Jerarquía";
        } else if (ctrl.language == "ingles") {
          editingTitle = "Edit Hierarchy";
          creatingTitle = "Create Hierarchy";
        } else if (ctrl.language == "portugues") {
          editingTitle = "Editar Hierarquia";
          creatingTitle = "Criar Hierarquia";
        } else if (ctrl.language == "italiano") {
          editingTitle = "Editar Jerarquía";
          creatingTitle = "Crear Jerarquía";
        }

        if ($stateParams.id != "0") {
          ctrl.title = editingTitle;
          dataService.getJerarquiaById($stateParams.id).then(
            function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;
                if (ctrl.model != null) {

                  if (ctrl.model.TienePermisos) {
                    if (authData != null && authData.Id > 0) {
                      dataService.getPermisosUsuarioJerarquia(authData.Id)
                        .then(function (responsePermisos) {
                          if (responsePermisos.data.Success) {
                            // Este endpoint valida si un usuario tiene los permisos para editar una Jerarquía, estos permisos se establecen en el parametro "USRUPDATEJERARQUIA" de Kahuna
                            ctrl.isOnlyRead = responsePermisos.data.Value.isOnlyRead;
                          } else {
                            toastr.error(responsePermisos.data.ErrorSummary);
                          }
                        }, function (error) {
                          toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })
                    }
                  }

                  if (ctrl.model.JerarquiaPadre != null) {
                    ctrl.model.JerarquiaPadreInput =
                      ctrl.model.JerarquiaPadre.Nombre;
                  }
                  if (
                    ctrl.model.listaProcesosTemplates != null &&
                    ctrl.model.listaProcesosTemplates.length > 0
                  ) {
                    ctrl.model.procesoId =
                      ctrl.model.listaProcesosTemplates[0].ProcesoId;
                    // // console.log(ctrl.model.procesoId);
                    if (ctrl.model.procesoId != 0) {
                      ctrl.loadJerarquiaProcesos(ctrl.model.procesoId);
                    }
                    //ctrl.model.listaProcesosTemplates
                    //todo: clear
                    angular.forEach(
                      ctrl.model.listaProcesosTemplates,
                      function (procesoTemplate, key) {
                        // console.log(procesoTemplate);
                        // console.log(ctrl.resultListJerarquiaProcesos);
                        ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                          function (item) {
                            return (
                              item.Template.Id != procesoTemplate.Template.Id
                            );
                          }
                        );
                      }
                    );
                  }
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
        } else {
          ctrl.title = creatingTitle;
        }
      }

      this.$onInit = function () {
        initialize();
      };

      ctrl.loadJerarquiaProcesos = function (procesoId) {
        // console.log("ejecuto loadTemplatesProcesos " + ctrl.model.procesoId);
        ctrl.isSearching = true;

        ctrl.model.procesoId = procesoId;

        dataService.searchTemplatesByProceso(ctrl.model.procesoId).then(
          function (response) {
            ctrl.resultListJerarquiaProcesos = response.data.Value.Resultados;
            dataService
              .SearchTemplatesByProcesoJerarquia(
                ctrl.model.Id,
                ctrl.model.procesoId
              )
              .then(function (response) {
                if (response.data.Success) {
                  ctrl.arrayTemplateSeleccionados =
                    response.data.Value.Resultados;
                  if (ctrl.contadorProcesoSelected != 0) {
                    ctrl.arrayTemplateSeleccionados;
                  } else {
                    // console.log("INGESO PORQUE YA EXISTE.....");
                    if (
                      ctrl.arrayTemplateSeleccionados != null &&
                      ctrl.arrayTemplateSeleccionados.length > 0
                    ) {
                      angular.forEach(
                        ctrl.arrayTemplateSeleccionados,
                        function (procesoTemplate, key) {
                          ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                            function (item) {
                              return (
                                item.Template.Id != procesoTemplate.Template.Id
                              );
                            }
                          );
                        }
                      );
                    }
                  }

                  ctrl.arrayTemplateSeleccionados.forEach(function (template) {
                    ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
                      function (item) {
                        return item.Template.Id != template.Template.Id;
                      }
                    );
                  });

                  ctrl.contadorProcesoSelected = 1;
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isSearching = false;
              });
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          }
        );
      };

      ctrl.actionAddOnClick = function (j) {
        //ctrl.model.listaProcesosTemplates
        //ctrl.resultListJerarquiaProcesos
        ctrl.resultListJerarquiaProcesos = ctrl.resultListJerarquiaProcesos.filter(
          function (item) {
            return item.Template.Id != j.Template.Id;
          }
        );

        if (
          ctrl.arrayTemplateSeleccionados === null ||
          ctrl.arrayTemplateSeleccionados === undefined
        ) {
          // console.log("LLEGÓ NULL");
          ctrl.arrayTemplateSeleccionados = [];
        }

        if (ctrl.model.listaProcesosTemplates.indexOf(j) == -1) {
          //verifica si el elemento ya está adentro
          ctrl.model.listaProcesosTemplates.push(j);
        }

        ctrl.arrayTemplateSeleccionados.push(j);
      };

      ctrl.actionRemoveOnClick = function (j) {
        ctrl.arrayTemplateSeleccionados = ctrl.arrayTemplateSeleccionados.filter(
          function (item) {
            return item.Template.Id != j.Template.Id;
          }
        );

        // ctrl.model.listaProcesosTemplates = ctrl.model.listaProcesosTemplates.filter(
        //   function (item){
        //     // console.log("ES DIFERENTE DEL ITEM" ,item.ProcesoId != j.ProcesoId &&  item.JerarquiaId != j.JerarquiaId);
        //     return item.ProcesoId != j.ProcesoId &&  item.JerarquiaId != j.JerarquiaId
        //   }
        // );

        ctrl.model.listaProcesosTemplates.forEach(function (item, i) {
          if (
            item.ProcesoId == j.ProcesoId &&
            item.JerarquiaId == j.JerarquiaId
          ) {
            ctrl.model.listaProcesosTemplates.splice(i, 1);
            // console.log("removed", item, "at position", i);
          }
        });
        ctrl.resultListJerarquiaProcesos.push(j);
      };

      function loadProcesos() {
        ctrl.isSearching = true;
        sharedService.showLoading();
        dataService.getCampoListLigth().then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
              dataService.searchProceso(ctrl.filtrosProcesos).then(
                function (response) {
                  if (response.data.Success) {
                    ctrl.resultListProcesos = response.data.Value.Resultados;
                    // console.log("Listado de procesos.");
                    // console.log(ctrl.resultListProcesos);
                    sharedService.closeLoading();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isSearching = false;
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage(error)
                  );
                  ctrl.isSearching = false;
                }
              );
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      }

      ctrl.loadCamposProceso = function (procesoId) {
        // console.log("cargar campos del proceso: " + procesoId);
        sharedService.showLoading();
        dataService.getCamposLigthByProceso(procesoId).then(
          function (response) {
            if (response.data.Success) {
              // console.log(response);
              ctrl.resultListCamposProceso = response.data.Value;
              // console.log("Listado de procesos.");
              // console.log(ctrl.resultListCamposProceso);
              sharedService.closeLoading();
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          }
        );

        if (ctrl.model.Id != 0) {
          dataService.getJerarquiaProcesoCampos(procesoId, ctrl.model.Id).then(
            function (response) {
              if (response.data.Success) {
                // console.log(response);
                ctrl.procesoCamposList = response.data.Value.Resultados;
                ctrl.procesoCamposDS = ctrl.procesoCamposList;
                // console.log("Listado de campos Proceso Jerarquia.");
                sharedService.closeLoading();
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
              ctrl.isSearching = false;
            }
          );
        }
      };

      // ctrl.loadGrupos = function () {
      //   ctrl.filtros = {
      //     // PageSize: 1000,
      //     PageSize: 5000,
      //     SkipNumber: 0,
      //   };

      //   dataService.searchGruposUsuarios(ctrl.filtros).then(
      //     function (response) {
      //       if (response.data.Success) {
      //         // console.log("TRESPONSE USUARIOS");

      //         var defaultUser = {
      //           Id: 0,
      //           Nombre: "",
      //         };
      //         ctrl.GruposUsuariosList = [];
      //         ctrl.GruposUsuariosList.push(defaultUser);
      //         ctrl.GruposUsuariosList = ctrl.GruposUsuariosList.concat(
      //           response.data.Value.Resultados
      //         );
      //         // console.log(ctrl.GruposUsuariosList);
      //       } else {
      //         toastr.error(response.data.ErrorSummary);
      //       }
      //       ctrl.isSearching = false;
      //     },
      //     function (error) {
      //       toastr.error(error.data || sharedService.getGenericErrorMessage(error));
      //       ctrl.isSearching = false;
      //     }
      //   );
      // };

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco para cargar el campo";
        else if (ctrl.language == "ingles")
          errorText = "Complete the required fields marked with an asterisk to load the field";
        else if (ctrl.language == "portugues")
          errorText = "Preencha os campos obrigatórios marcados com um asterisco para carregar o campo";
        else if (ctrl.language == "italiano")
          errorText = "Por favor complete los datos obligatorios marcados con asterisco para cargar el campo";

        if (
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.Campo.Id == 0
        ) {
          toastr.error(errorText);
          return;
        }

        ctrl.campoCargado.campoId = ctrl.campoCargado.Campo.Id;
        ctrl.campoCargado.procesoId = ctrl.procesoFounded2.Id; // El Id del proceso seleccionado en "Seguridad de Campos" fue agregado el 07/03/2025

        if (ctrl.procesoCamposList == null) ctrl.procesoCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          /*if (ctrl.procesoCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.procesoCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }*/
          if (ctrl.procesoCamposList[i].campoId == ctrl.campoCargado.campoId)
            index = i;
        }

        if (index >= 0) ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else ctrl.procesoCamposList.push(ctrl.campoCargado);

        ctrl.procesoCamposList.sort(function (a, b) {
          return parseInt(a.Orden) > parseInt(b.Orden)
            ? 1
            : parseInt(b.Orden) > parseInt(a.Orden)
              ? -1
              : 0;
        });
        ctrl.procesoCamposDS = ctrl.procesoCamposList;
        ctrl.campoCargado = {};
      };

      ctrl.cargarCampo = function (campoSeleccionado) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor seleccione un campo para poder visualizarlo";
        else if (ctrl.language == "ingles")
          errorText = "Select a field to view it";
        else if (ctrl.language == "portugues")
          errorText = "Selecione um campo para exibi-lo";
        else if (ctrl.language == "italiano")
          errorText = "Por favor seleccione un campo para poder visualizarlo";

        if (campoSeleccionado == null) {
          toastr.error(errorText);
          return;
        }
        ctrl.campoCargado = {};
        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.procesoId = ctrl.model.procesoId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.campoId = campoSeleccionado.Campo.Id;
      };

      ctrl.eliminarCampo = function (index) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Campo seleccionado inválido";
        else if (ctrl.language == "ingles")
          errorText = "Selected field is invalid";
        else if (ctrl.language == "portugues")
          errorText = "Campo selecionado inválido";
        else if (ctrl.language == "italiano")
          errorText = "Por favor seleccione un campo para poder visualizarlo";

        if (index < 0) {
          toastr.error(errorText);
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      };
      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      };

      ctrl.save = function (form) {
        // console.log("GUARDAR JERARQUIA.....");
        // console.log("***********************");
        // console.log(ctrl.procesoCamposList);
        ctrl.model.jerarquiaProcesoCampos = ctrl.procesoCamposList;
        // console.log("***********************");
        // if (form.$invalid)
        // {
        //   ctrl.showError = true;
        //   return;
        // }

        var completeCode, completeName, completeDetails;

        if (ctrl.language == "español") {
          completeCode = "Debe completar el Código de la jerarquía";
          completeName = "Debe completar el nombre de la jerarquía";
          completeDetails = "Debe ingresar por lo menos un detalle para la jerarquía";

        } else if (ctrl.language == "ingles") {
          completeCode = "You must complete the hierarchy name";
          completeName = "Create Hierarchy";
          completeDetails = "You must enter at least one detail for the hierarchy.";

        } else if (ctrl.language == "portugues") {
          completeCode = "Você deve preencher o Código da hierarquia";
          completeName = "Você deve preencher o nome da hierarquia";
          completeDetails = "Você deve inserir pelo menos um detalhe para a hierarquia";

        } else if (ctrl.language == "italiano") {
          completeCode = "Debe completar el Código de la jerarquía";
          completeName = "Debe completar el nombre de la jerarquía";
          completeDetails = "Debe ingresar por lo menos un detalle para la jerarquía";
        }

        if (ctrl.model.TienePermisos && ctrl.model.Permisos != null) {
          // Si un grupo etapa tiene Id 0, significa que se seleccionó el valor por defecto y al backend no debe llegar ese Id 0, por lo que en las siguientes validaciones se limpian todos esos posibles casos

          if (ctrl.model.Permisos.grupo1Etapa2) {
            ctrl.model.Permisos.grupo1Etapa2Id = ctrl.model.Permisos.grupo1Etapa2.Id;
            ctrl.model.Permisos.grupo1Etapa2 = clearZeroId(ctrl.model.Permisos.grupo1Etapa2);
          }

          if (ctrl.model.Permisos.grupo2Etapa2) {
            ctrl.model.Permisos.grupo2Etapa2Id = ctrl.model.Permisos.grupo2Etapa2.Id;
            ctrl.model.Permisos.grupo2Etapa2 = clearZeroId(ctrl.model.Permisos.grupo2Etapa2);
          }

          if (ctrl.model.Permisos.grupo3Etapa2) {
            ctrl.model.Permisos.grupo3Etapa2Id = ctrl.model.Permisos.grupo3Etapa2.Id;
            ctrl.model.Permisos.grupo3Etapa2 = clearZeroId(ctrl.model.Permisos.grupo3Etapa2);
          }

          if (ctrl.model.Permisos.grupo1Etapa3) {
            ctrl.model.Permisos.grupo1Etapa3Id = ctrl.model.Permisos.grupo1Etapa3.Id;
            ctrl.model.Permisos.grupo1Etapa3 = clearZeroId(ctrl.model.Permisos.grupo1Etapa3);
          }

          if (ctrl.model.Permisos.grupo2Etapa3) {
            ctrl.model.Permisos.grupo2Etapa3Id = ctrl.model.Permisos.grupo2Etapa3.Id;
            ctrl.model.Permisos.grupo2Etapa3 = clearZeroId(ctrl.model.Permisos.grupo2Etapa3);
          }

          if (ctrl.model.Permisos.grupo3Etapa3) {
            ctrl.model.Permisos.grupo3Etapa3Id = ctrl.model.Permisos.grupo3Etapa3.Id;
            ctrl.model.Permisos.grupo3Etapa3 = clearZeroId(ctrl.model.Permisos.grupo3Etapa3);
          }

          if (ctrl.model.Permisos.grupo1Etapa4) {
            ctrl.model.Permisos.grupo1Etapa4Id = ctrl.model.Permisos.grupo1Etapa4.Id;
            ctrl.model.Permisos.grupo1Etapa4 = clearZeroId(ctrl.model.Permisos.grupo1Etapa4Id);
          }

          if (ctrl.model.Permisos.grupo2Etapa4) {
            ctrl.model.Permisos.grupo2Etapa4Id = ctrl.model.Permisos.grupo2Etapa4.Id;
            ctrl.model.Permisos.grupo2Etapa4 = clearZeroId(ctrl.model.Permisos.grupo2Etapa4);
          }

          if (ctrl.model.Permisos.grupo3Etapa4) {
            ctrl.model.Permisos.grupo3Etapa4Id = ctrl.model.Permisos.grupo3Etapa4.Id;
            ctrl.model.Permisos.grupo3Etapa4 = clearZeroId(ctrl.model.Permisos.grupo3Etapa4);
          }

          if (ctrl.model.Permisos.grupo1Etapa5) {
            ctrl.model.Permisos.grupo1Etapa5Id = ctrl.model.Permisos.grupo1Etapa5.Id;
            ctrl.model.Permisos.grupo1Etapa5 = clearZeroId(ctrl.model.Permisos.grupo1Etapa5);
          }

          if (ctrl.model.Permisos.grupo2Etapa5) {
            ctrl.model.Permisos.grupo2Etapa5Id = ctrl.model.Permisos.grupo2Etapa5.Id;
            ctrl.model.Permisos.grupo2Etapa5 = clearZeroId(ctrl.model.Permisos.grupo2Etapa5);
          }

          if (ctrl.model.Permisos.grupo3Etapa5) {
            ctrl.model.Permisos.grupo3Etapa5Id = ctrl.model.Permisos.grupo3Etapa5.Id;
            ctrl.model.Permisos.grupo3Etapa5 = clearZeroId(ctrl.model.Permisos.grupo3Etapa5);
          }

          if (ctrl.model.Permisos.grupo1EtapaLectores) {
            ctrl.model.Permisos.grupo1EtapaLectoresId = ctrl.model.Permisos.grupo1EtapaLectores.Id;
            ctrl.model.Permisos.grupo1EtapaLectores = clearZeroId(ctrl.model.Permisos.grupo1EtapaLectores);
          }

          if (ctrl.model.Permisos.grupo2EtapaLectores) {
            ctrl.model.Permisos.grupo2EtapaLectoresId = ctrl.model.Permisos.grupo2EtapaLectores.Id;
            ctrl.model.Permisos.grupo2EtapaLectores = clearZeroId(ctrl.model.Permisos.grupo2EtapaLectores);
          }

          if (ctrl.model.Permisos.grupo3EtapaLectores) {
            ctrl.model.Permisos.grupo3EtapaLectoresId = ctrl.model.Permisos.grupo3EtapaLectores.Id;
            ctrl.model.Permisos.grupo3EtapaLectores = clearZeroId(ctrl.model.Permisos.grupo3EtapaLectores);
          }
        }

        // console.log(ctrl.model.Activo);

        if (ctrl.model.Codigo == null || ctrl.model.Codigo.length <= 0) {
          toastr.error(completeCode);
          return;
        }

        if (ctrl.model.Nombre == null || ctrl.model.Nombre.length <= 0) {
          toastr.error(completeName);
          return;
        }

        if (
          ctrl.model.MostrarDetalle &&
          (ctrl.model.Detalles == null || ctrl.model.Detalles.lenght <= 0)
        ) {
          toastr.error(completeDetails);
          return;
        }

        ctrl.isBusy = true;

        if (
          ctrl.model.JerarquiaPadreInput == null ||
          ctrl.model.JerarquiaPadreInput.length <= 0
        )
          ctrl.model.JerarquiaPadre = null;

        if (!ctrl.model.MostrarDetalle) ctrl.model.Detalles = null;

        //ctrl.model.Activo = 1;
        if (
          ctrl.model.JerarquiaPadre != null &&
          ctrl.model.JerarquiaPadre.Id > 0
        ) {
          ctrl.model.JerarquiaPadreId = ctrl.model.JerarquiaPadre.Id;
        } else {
          ctrl.model.JerarquiaPadreId = null;
          ctrl.model.JerarquiaPadre = null;
        }

        dataService.saveJerarquia(ctrl.model).then(
          function (response) {
            if (response.data.Success) {
              toastr.info(ctrl.successfulRegistration);
              $state.transitionTo("pages.jerarquia");
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.cancel = function () {
        $state.transitionTo("pages.jerarquia");
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var modalTitle, modalMessage;

        if (ctrl.language == "español") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado de la jerarquía?";
        } else if (ctrl.language == "ingles") {
          modalTitle = "Attention";
          modalMessage = "Do you confirm the deletion of the hierarchy?";
        } else if (ctrl.language == "portugues") {
          modalTitle = "Atenção";
          modalMessage = "Confirma a exclusão da hierarquia?";
        } else if (ctrl.language == "italiano") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado de la jerarquía?";
        }

        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return modalTitle;
            },
            message: function () {
              return modalMessage;
            },
          },
        });

        confirmation.result.then(
          function (selectedItem) {
            dataService.deleteJerarquia(ctrl.model.Id).then(
              function (response) {
                if (response.data.Success) {
                  toastr.info(ctrl.successfulRegistration);
                  $state.transitionTo("pages.jerarquia");
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isBusy = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
                ctrl.isBusy = false;
              }
            );
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.searchJerarquiaPadre = function (nombreJerarquia) {
        var filtroJerarquia = {
          Nombre: nombreJerarquia,
          PageSize: 20,
          SkipNumber: 0,
        };

        return dataService.searchJerarquia(filtroJerarquia).then(
          function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      };

      ctrl.onSelectJerarquia = function (jerarquiaSeleccionada) {
        ctrl.model.JerarquiaPadre = jerarquiaSeleccionada;

        if (jerarquiaSeleccionada != null)
          ctrl.model.JerarquiaPadreInput = jerarquiaSeleccionada.Nombre;
        else ctrl.model.JerarquiaPadreInput = null;
      };

      ctrl.editDetalle = function () {
        var errorCompleteFields, errorChangeOrderNumber;

        if (ctrl.language == "español") {
          errorCompleteFields = "Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle";
          errorChangeOrderNumber = "Por favor ingrese un número de orden distinto ya que el ingresado ya existe";

        } else if (ctrl.language == "ingles") {
          errorCompleteFields = "Complete the required fields marked with an asterisk to load the detail";
          errorChangeOrderNumber = "Please enter a different order number as the entered one already exists.";

        } else if (ctrl.language == "portugues") {
          errorCompleteFields = "Por favor, complete os dados obrigatórios marcados com asterisco para preencher o detalhe";
          errorChangeOrderNumber = "Por favor, insira um número de ordem diferente, pois o inserido já existe";

        } else if (ctrl.language == "italiano") {
          errorCompleteFields = "Por favor complete los datos obligatorios marcados con asterisco para cargar el detalle";
          errorChangeOrderNumber = "Por favor ingrese un número de orden distinto ya que el ingresado ya existe";
        }

        if (
          ctrl.detalleCargado.Orden <= 0 ||
          ctrl.detalleCargado.Orden == null ||
          ctrl.detalleCargado.Orden.lenght <= 0 ||
          ctrl.detalleCargado.Titulo == null ||
          ctrl.detalleCargado.Titulo.lenght <= 0 ||
          ctrl.detalleCargado.Valor == null ||
          ctrl.detalleCargado.Valor.lenght <= 0
        ) {
          toastr.error(errorCompleteFields);
          return;
        }

        ctrl.detalleCargado.JerarquiaId = ctrl.model.Id;

        if (ctrl.model.Detalles == null) ctrl.model.Detalles = [];

        var index = -1;
        for (var i = 0; i < ctrl.model.Detalles.length; i++) {
          if (
            ctrl.model.Detalles[i].Titulo != ctrl.detalleCargado.Titulo &&
            ctrl.model.Detalles[i].Orden == ctrl.detalleCargado.Orden
          ) {
            toastr.error(errorChangeOrderNumber);
            return;
          }

          if (ctrl.model.Detalles[i].Titulo == ctrl.detalleCargado.Titulo)
            index = i;
        }

        if (index >= 0) ctrl.model.Detalles[index] = ctrl.detalleCargado;
        else ctrl.model.Detalles.push(ctrl.detalleCargado);

        ctrl.model.Detalles.sort(function (a, b) {
          return parseInt(a.Orden) > parseInt(b.Orden)
            ? 1
            : parseInt(b.Orden) > parseInt(a.Orden)
              ? -1
              : 0;
        });
        ctrl.jerarquiaDetalleDS = ctrl.model.Detalles;
        ctrl.detalleCargado = {};
      };

      ctrl.cargarDetalle = function (detalleSeleccionado) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Por favor seleccione un detalle para poder visualizarlo";
        else if (ctrl.language == "ingles")
          errorText = "Please select a detail to view it";
        else if (ctrl.language == "portugues")
          errorText = "Por favor, selecione um detalhe para visualizá-lo";
        else if (ctrl.language == "italiano")
          errorText = "Por favor seleccione un detalle para poder visualizarlo";

        if (detalleSeleccionado == null) {
          toastr.error(errorText);
          return;
        }

        ctrl.detalleCargado = {};

        ctrl.detalleCargado.Id = detalleSeleccionado.Id;
        ctrl.detalleCargado.JerarquiaId = detalleSeleccionado.JerarquiaId;
        ctrl.detalleCargado.Titulo = detalleSeleccionado.Titulo;
        ctrl.detalleCargado.Valor = detalleSeleccionado.Valor;
        ctrl.detalleCargado.Orden = detalleSeleccionado.Orden;
      };

      ctrl.eliminarDetalle = function (index) {
        var errorText;

        if (ctrl.language == "español")
          errorText = "Detalle seleccionado inválido";
        else if (ctrl.language == "ingles")
          errorText = "Invalid selected Detail";
        else if (ctrl.language == "portugues")
          errorText = "Detalhe selecionado inválido";
        else if (ctrl.language == "italiano")
          errorText = "Detalle seleccionado inválido";

        if (index < 0) {
          toastr.error(errorText);
          return;
        }

        if (ctrl.model.Detalles != null && ctrl.model.Detalles.length > 0)
          ctrl.model.Detalles.splice(index, 1);
      };

      ctrl.clearDetalle = function () {
        ctrl.detalleCargado = {};
      };

      ctrl.searchGroup = function (value) {
        ctrl.filtros = {
          Nombre: value,
          PageSize: 30,
          SkipNumber: 0,
        };

        return dataService.searchGruposUsuarios(ctrl.filtros).then(
          function (response) {
            if (response.data.Success) {
              // console.log("TRESPONSE USUARIOS");

              var defaultUser = {
                Id: 0,
                Nombre: "&nbsp;",
              };
              ctrl.GruposUsuariosListFiltered = [];
              ctrl.GruposUsuariosListFiltered.push(defaultUser);
              ctrl.GruposUsuariosListFiltered = ctrl.GruposUsuariosListFiltered.concat(
                response.data.Value.Resultados
              );

              return ctrl.GruposUsuariosListFiltered;

            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          }
        );

        // var word = value.toUpperCase().trim();
        // if (word == "_") {
        //   ctrl.GruposUsuariosListFiltered = ctrl.GruposUsuariosList;
        // } else {
        //   ctrl.GruposUsuariosListFiltered = ctrl.GruposUsuariosList.filter(function (element) {
        //     return element.Nombre.toUpperCase().includes(word);
        //   })
        // }

        // return ctrl.GruposUsuariosListFiltered;
      }

      ctrl.searchProceso = function (nombreProceso) {
        return ctrl.resultListProcesos.filter(function (proceso) {
          if (nombreProceso == "_")
            return proceso;
          else if (proceso.Nombre.toUpperCase().includes(nombreProceso.toUpperCase()))
            return proceso;
        })
      }

      ctrl.clearInput = function (inputContent) {
        inputContent.Nombre == "&nbsp;" ? inputContent.Nombre = "" : null
      }

      function clearZeroId(itemForValidate) {
        // Sólo se usa para limpiar los grupo etapa que tengan id 0, lo que significa que se seleccionó un valor por defecto
        return itemForValidate.Id == 0 ? null : itemForValidate;
      }
    },
  });
})(window.angular);

(function () {
    'use strict';
    angular.module('Kahuna.pages.jerarquia').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.jerarquia', {
          url: '/jerarquia',
          title: '',
          template : '<jerarquia-list></jerarquia-list>',
          authenticate: true,
        })
        .state('pages.jerarquia-edit', {
          url: '/jerarquia/edit/:id',
          title: '',
          template : '<jerarquia-edit></jerarquia-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.jerarquia').component('jerarquiaList', {
    templateUrl: 'app/pages/jerarquia/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.filtros = {};
      ctrl.resultList = [];

      this.$onInit = function () {
        var jerarquiaListTitle;

        if (ctrl.language == "español")
          jerarquiaListTitle = 'Jerarquía';
        else if (ctrl.language == "ingles")
          jerarquiaListTitle = 'Hierarchy';
        else if (ctrl.language == "portugues")
          jerarquiaListTitle = 'Hierarquia';
        else if (ctrl.language == "italiano")
          jerarquiaListTitle = 'Jerarquía';

        $state.current.title = jerarquiaListTitle;
      };

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.JerarquiaPadre = tableState.search.predicateObject.JerarquiaPadre;
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchJerarquia(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.jerarquia-edit", { id: 0 });
      }

      ctrl.edit = function (id) {
        $state.go("pages.jerarquia-edit", { id: id });
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.proceso').component('procesoEdit', {
    templateUrl: 'app/pages/proceso/edit.template.html',
    controller: function ($scope, $state, appConfig, dataService, sharedService, toastr, toastrConfig, $stateParams, $timeout, $uibModal) {
      var ctrl = this;
      var authData = {};
      ctrl.model = {};
      ctrl.model.procedimientoRefresh = null;
      ctrl.model.tieneProcedimientoRefresh = false;
      // Seteando por defecto estas 2 propiedades en el modelo
      ctrl.isBusy = false;
      ctrl.enableDatosProcesoTab = false;
      ctrl.showDelete = false;

      ctrl.showCampoProcesoTituloSelect = false;
      ctrl.showCampoTemplateTituloSelect = false;
      ctrl.showTemplateTituloSelect = false;

      ctrl.title = '';
      ctrl.configuracionTituloText = "";

      ctrl.estadosFilteredList = [];
      ctrl.rolProcesoFilteredList = [];
      ctrl.usuarioFilteredList = [];
      ctrl.rolProcesoList = [];
      ctrl.rolTemplateList = [];
      ctrl.estadosList = [];
      ctrl.gruposList = [];
      ctrl.camposList = [];
      ctrl.tipoCampoSolicitudList = [];

      ctrl.columnasProcesoList = [];
      ctrl.procesoUsuariosList = [];
      ctrl.templatesCamposList = [];
      ctrl.procesoTemplatesList = [];
      ctrl.procesoTemplateCamposList = [];
      ctrl.procesoTemplateUsuariosList = [];
      ctrl.procesoLinksList = [];
      ctrl.procesoCamposList = [];
      ctrl.procesoHijosSeleccionables = [];
      ctrl.allProcesosList = [];
      ctrl.procesoCamposListJerarquiaGestion = [];

      ctrl.searchProcesoUsuarioLogin = '';
      ctrl.showFooterTable = true;

      ctrl.procesoCamposDS = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoTemplatesDS = [];

      ctrl.campoCargado = {};
      ctrl.usuarioCargado = {};
      ctrl.templateCargado = {};
      ctrl.usuarioTemplateCargado = {};
      ctrl.campoTemplateCargado = {};

      ctrl.filtrosProcesos = { PageSize: 500, SkipNumber: 0 };
      ctrl.resultListProcesos = [];
      ctrl.lsuarioLogueadoIsSysAdmin = false;

      this.$onInit = function () {
        ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSuperAdminLoggedUser();
        authData = sharedService.getLoggedUser();
        ctrl.active = 0; // Por defecto, debe entrar a Datos del Proceso
        // if (ctrl.lsuarioLogueadoIsSysAdmin) {
        //   ctrl.active = 0; // Si el usuario logueado es SuperAdmin, Por defecto, debe entrar a Datos del Proceso
        // }
        loadView();
      };

      ctrl.evaluatenumberDigit = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      }


      function loadProcesos() {
        dataService.searchProceso(ctrl.filtrosProcesos)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultListProcesos = response.data.Value.Resultados;
              // console.log("Listado de procesos.");
              // console.log(ctrl.resultListProcesos);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });
      }

      function loadView() {
        loadProcesos();
        ctrl.enableDatosProcesoTab = sharedService.isSysAdminLoggedUser();
        dataService.getRolTemplateList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.rolTemplateList = response.data.Value;
              // console.log(ctrl.rolTemplateList);
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        dataService.getSolicitudEstadoSeleccionablesList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.estadosList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        dataService.getGrupoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.gruposList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        dataService.getProcesoList()
          .then(function (response) {
            if (response.data.Success) {
              var grupoIndex = -1;
              var procesosList = response.data.Value;
              var finalList = [];

              ctrl.allProcesosList = [];

              if (procesosList == null)
                procesosList = [];

              for (var i = 0; i < procesosList.length; i++) {
                grupoIndex = -1;
                var p = procesosList[i];

                for (var k = 0; k < finalList.length; k++) {
                  if (finalList[k].Grupo.Id == p.Grupo.Id) {
                    grupoIndex = k;
                    break;
                  }
                }

                if (grupoIndex < 0) {
                  grupoIndex = finalList.length;

                  finalList.push({
                    Grupo: p.Grupo,
                    ProcesosHijosList: []
                  });
                }

                finalList[grupoIndex].ProcesosHijosList.push(p);
              }

              ctrl.allProcesosList = finalList;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        dataService.getCampoList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        dataService.getTipoCampoSolicitudList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.tipoCampoSolicitudList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        if ($stateParams.id != "0") {
          ctrl.isTemplateSearching = true;
          ctrl.isTemplateUsuarioSearching = true;
          ctrl.isUsuarioSearching = true;
          ctrl.isCampoSearching = true;

          dataService.getProcesoById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;
                // console.log("LLEGO PROCESOP");
                // console.log(ctrl.model);
                ctrl.title = 'Editar Proceso: ' + ctrl.model.Nombre;

                ctrl.procesoTemplatesList = ctrl.model.Templates;
                // console.log(ctrl.procesoTemplatesList);
                ctrl.procesoCamposList = ctrl.model.Campos;

                ctrl.procesoCamposListJerarquiaGestion = ctrl.procesoCamposListJerarquiaGestion.concat(ctrl.procesoCamposList);
                ctrl.procesoCamposListJerarquiaGestion.unshift({ Campo: { Id: '', Nombre: '' } });

                // console.log(ctrl.procesoCamposList);
                ctrl.procesoHijosSeleccionables = ctrl.model.HijosSeleccionables;
                ctrl.procesoLinksList = ctrl.model.Links;

                ctrl.procesoUsuariosList = [];
                ctrl.procesoTemplateUsuariosList = [];
                ctrl.procesoTemplateCamposList = [];

                ctrl.model.procesoIdObsoletos = "" + ctrl.model.procesoIdObsoletos + "";
                ctrl.model.procesoIdVersiones = "" + ctrl.model.procesoIdVersiones + "";
                ctrl.model.campoIdAutorizacion = "" + ctrl.model.campoIdAutorizacion + "";
                ctrl.model.jerarquiatemplate = "" + ctrl.model.jerarquiatemplate + "";
                ctrl.model.tipoDocumentoId = "" + ctrl.model.tipoDocumentoId + "";
                ctrl.model.documentoPublicableId = "" + ctrl.model.documentoPublicableId + "";
                ctrl.model.numeradorDocumentalId = "" + ctrl.model.numeradorDocumentalId + "";

                /*ctrl.found =  ctrl.resultListProcesos.find(x => x.id === ctrl.model.procesoIdObsoletos);
                ctrl.found2 = ctrl.resultListProcesos.find(x => x.id === ctrl.model.procesoIdVersiones);
                console.log(ctrl.found2);
                console.log(ctrl.found);*/

                //Carga de roles de la seguridad del proceso
                dataService.getRolProcesoList()
                  .then(function (response) {
                    if (response.data.Success) {
                      ctrl.rolProcesoList = response.data.Value;
                      ctrl.loadSeguridadProcesosTab();
                    }
                    else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  });

                //Carga de usuarios del proceso
                if (ctrl.model.Usuarios != null && ctrl.model.Usuarios.length > 0) {
                  var index;

                  for (var i = 0; i < ctrl.model.Usuarios.length; i++) {
                    index = -1;

                    for (var x = 0; x < ctrl.procesoUsuariosList.length; x++) {
                      if (ctrl.procesoUsuariosList[x].Usuario.Id == ctrl.model.Usuarios[i].Usuario.Id) {
                        index = x;
                        break;
                      }
                    }

                    if (index < 0) {
                      ctrl.procesoUsuariosList.push({ Usuario: ctrl.model.Usuarios[i].Usuario, RolProcesoList: [] });
                      index = ctrl.procesoUsuariosList.length - 1;
                    }

                    //Existe el usuario
                    ctrl.procesoUsuariosList[index].RolProcesoList.push(ctrl.model.Usuarios[i].RolProceso);
                  }
                }

                //Carga de usuarios de cada template/gestion del proceso
                if (ctrl.model.Templates != null && ctrl.model.Templates.length > 0) {
                  var index2;

                  for (var i = 0; i < ctrl.model.Templates.length; i++) {
                    if (ctrl.model.Templates[i].Usuarios != null) {
                      for (var j = 0; j < ctrl.model.Templates[i].Usuarios.length; j++) {
                        index2 = -1;

                        for (var x = 0; x < ctrl.procesoTemplateUsuariosList.length; x++) {
                          if (ctrl.procesoTemplateUsuariosList[x].Usuario.Id == ctrl.model.Templates[i].Usuarios[j].Usuario.Id &&
                            ctrl.procesoTemplateUsuariosList[x].ProcesoTemplate.Id == ctrl.model.Templates[i].Usuarios[j].ProcesoTemplateId) {
                            index2 = x;
                            break;
                          }
                        }

                        if (index2 < 0) {
                          ctrl.procesoTemplateUsuariosList.push({
                            ProcesoTemplate: ctrl.model.Templates[i],
                            Usuario: ctrl.model.Templates[i].Usuarios[j].Usuario,
                            RolTemplateList: []
                          });
                          index2 = ctrl.procesoTemplateUsuariosList.length - 1;
                        }

                        //Existe el usuario
                        ctrl.procesoTemplateUsuariosList[index2].RolTemplateList.push(ctrl.model.Templates[i].Usuarios[j].RolTemplate);
                      }
                    }
                  }
                }

                // console.log(ctrl.model.Templates);
                //Carga de campos de cada template/gestion del proceso
                if (ctrl.model.Templates != null && ctrl.model.Templates.length > 0) {
                  var index2;

                  for (var i = 0; i < ctrl.model.Templates.length; i++) {
                    if (ctrl.model.Templates[i].Campos != null) {
                      for (var j = 0; j < ctrl.model.Templates[i].Campos.length; j++) {
                        index2 = -1;
                        for (var x = 0; x < ctrl.procesoTemplateCamposList.length; x++) {
                          if (ctrl.procesoTemplateCamposList[x].Campo.Id == ctrl.model.Templates[i].Campos[j].Campo.Id &&
                            ctrl.procesoTemplateCamposList[x].ProcesoTemplate.Id == ctrl.model.Templates[i].Campos[j].ProcesoTemplateId) {
                            index2 = x;
                            break;
                          }
                        }

                        if (index2 < 0) {
                          ctrl.procesoTemplateCamposList.push({
                            ProcesoTemplate: ctrl.model.Templates[i],
                            Campo: ctrl.model.Templates[i].Campos[j].Campo,
                            orden: ctrl.model.Templates[i].Campos[j].orden
                          });
                          index2 = ctrl.procesoTemplateCamposList.length - 1;
                        }
                      }
                    }
                  }
                }
                // console.log(ctrl.procesoTemplateCamposList);

                //Carga de columnas del proceso
                dataService.getSolicitudNombreCamposList()
                  .then(function (response) {
                    if (response.data.Success) {
                      ctrl.columnasProcesoList = response.data.Value;
                      var found = false;

                      if (ctrl.model.CamposListado != null && ctrl.model.CamposListado.length > 0) {
                        for (var i = 0; i < ctrl.model.CamposListado.length; i++) {
                          found = false;

                          if (ctrl.columnasProcesoList != null) {
                            for (var x = 0; x < ctrl.columnasProcesoList.length; x++) {
                              if (ctrl.columnasProcesoList[x].Id == ctrl.model.CamposListado[i].SolicitudColumnaId) {
                                ctrl.columnasProcesoList[x].SeleccionLista = true;
                                ctrl.columnasProcesoList[x].CampoId = null;
                                ctrl.columnasProcesoList[x].SolicitudColumnaId = ctrl.model.CamposListado[i].SolicitudColumnaId;
                                ctrl.columnasProcesoList[x].OrdenLista = ctrl.model.CamposListado[i].Orden;
                                ctrl.columnasProcesoList[x].IdLista = ctrl.model.CamposListado[i].Id;
                                found = true;
                                break;
                              }
                            }
                          }

                          if (!found && ctrl.procesoCamposList != null) {
                            for (var x = 0; x < ctrl.procesoCamposList.length; x++) {
                              if (ctrl.procesoCamposList[x].CampoId == ctrl.model.CamposListado[i].CampoId) {
                                ctrl.procesoCamposList[x].SeleccionLista = true;
                                ctrl.procesoCamposList[x].CampoId = ctrl.model.CamposListado[i].CampoId;
                                ctrl.procesoCamposList[x].SolicitudColumnaId = null;
                                ctrl.procesoCamposList[x].OrdenLista = ctrl.model.CamposListado[i].Orden;
                                ctrl.procesoCamposList[x].IdLista = ctrl.model.CamposListado[i].Id;
                                found = true;
                                break;
                              }
                            }
                          }
                        }
                      }
                    }
                    else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  });

                ctrl.showDelete = sharedService.isSysAdminLoggedUser();
                ctrl.actualizarTituloConfigText();
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));

              ctrl.isTemplateSearching = false;
              ctrl.isTemplateUsuarioSearching = false;
              ctrl.isUsuarioSearching = false;
              ctrl.isCampoSearching = false;
            });
        }
        else {
          ctrl.title = 'Crear Proceso: -';

          dataService.getProcesoDefault()
            .then(function (response) {
              if (response.data.Success) {
                ctrl.model = response.data.Value;

                dataService.getRolProcesoList()
                  .then(function (response) {
                    if (response.data.Success) {
                      ctrl.rolProcesoList = response.data.Value;
                      ctrl.loadSeguridadProcesosTab();
                    }
                    else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  });
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Proceso: ' + ctrl.model.Nombre;
          else
            ctrl.title = 'Crear Proceso: ' + ctrl.model.Nombre;
        }
      }

      ctrl.buscarCampoProcesoTitulo = function (show) {
        ctrl.templateTituloSeleccionado = null;

        ctrl.showCampoProcesoTituloSelect = show;
        ctrl.showTemplateTituloSelect = false;
        ctrl.showCampoTemplateTituloSelect = false;
      }

      ctrl.onSelectCampoProcesoTitulo = function (campoSeleccionado) {
        if (campoSeleccionado != null && campoSeleccionado.Campo != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "[[" + campoSeleccionado.Campo.Id + "]]", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showCampoProcesoTituloSelect = false;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.buscarCampoTemplateTitulo = function (show) {
        ctrl.templateTituloSeleccionado = null;
        ctrl.campoTituloSeleccionado = null;

        ctrl.showTemplateTituloSelect = show;
        ctrl.showCampoTemplateTituloSelect = false;
        ctrl.showCampoProcesoTituloSelect = false;

        ctrl.templateCamposList = null;
      }

      ctrl.onSelectTemplateTitulo = function (templateSeleccionado) {
        ctrl.templateCamposList = null;

        if (templateSeleccionado != null && templateSeleccionado.Template != null) {
          ctrl.showCampoTemplateTituloSelect = true;

          dataService.getCampoListByTemplate(templateSeleccionado.Template.Id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.templateCamposList = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        }
        else
          ctrl.showCampoTemplateTituloSelect = false;
      }

      ctrl.onSelectCampoTemplateTitulo = function (templateSeleccionado, campoSeleccionado) {
        if (templateSeleccionado != null && templateSeleccionado.Template != null &&
          campoSeleccionado != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "{{" + templateSeleccionado.Template.Id + "|" + campoSeleccionado.Id + "}}", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showTemplateTituloSelect = false;
          ctrl.showCampoTemplateTituloSelect = false;
          ctrl.templateTituloSeleccionado = null;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.actualizarTituloConfigText = function () {
        ctrl.configuracionTituloText = "...";

        if (ctrl.model.ConfiguracionTitulo != null && ctrl.model.ConfiguracionTitulo.length > 0) {
          dataService.getProcesoTituloConfigText(ctrl.model)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.configuracionTituloText = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
                ctrl.configuracionTituloText = "";
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.configuracionTituloText = "";
            });
        }
        else
          ctrl.configuracionTituloText = "";
      }

      ctrl.save = function (form) {

        if (ctrl.model.isDocumental) {
          if (ctrl.model.procesoIdVersiones == "" || ctrl.model.procesoIdVersiones == 0 || ctrl.model.procesoIdVersiones == null) {
            toastr.error('El proceso id de versiones es obligatorio cuando es un proceso documental.');
            return;
          }
          if (ctrl.model.procesoIdObsoletos == "" || ctrl.model.procesoIdObsoletos == 0 || ctrl.model.procesoIdObsoletos == null) {
            toastr.error('El proceso id de obsoletos es obligatorio cuando es un proceso documental.');
            return;
          }
        }

        if (ctrl.model.Codigo == null ||
          ctrl.model.Codigo == '' ||
          ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.CantidadDiasCierre == null ||
          ctrl.model.CantidadDiasCierre <= 0 ||
          ctrl.model.Grupo == null ||
          ctrl.model.Grupo.Id <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.model.tieneProcedimientoRefresh == true && (ctrl.model.procedimientoRefresh == null ||
          ctrl.model.procedimientoRefresh.length <= 0)) {
          toastr.error('Debe completar el nombre del Procedimiento Refresh');
          return;
        }

        if (ctrl.model.MostrarEnHome && ctrl.model.HomeOrden <= 0) {
          toastr.error('Por favor ingrese el orden para mostrar en la home');
          return;
        }

        if (ctrl.model.ConfiguracionTitulo == null ||
          ctrl.model.ConfiguracionTitulo.length <= 0) {
          toastr.error('Por favor inserte la Configuración de Título');
          return;
        }

        if (ctrl.procesoTemplatesList == null ||
          ctrl.procesoTemplatesList.length <= 0) {
          toastr.error('Por favor seleccione al menos una gestión para el proceso');
          return;
        }

        if (ctrl.model.AceptaHijos &&
          (ctrl.procesoHijosSeleccionables == null ||
            ctrl.procesoHijosSeleccionables.length <= 0)) {
          toastr.error('Por favor seleccione al menos un proceso para ser hijo');
          return;
        }

        ctrl.isBusy = true;

        if (!ctrl.model.AceptaHijos)
          ctrl.procesoHijosSeleccionables = [];

        ctrl.model.Campos = ctrl.procesoCamposList;
        ctrl.model.Templates = ctrl.procesoTemplatesList;
        ctrl.model.HijosSeleccionables = ctrl.procesoHijosSeleccionables;
        ctrl.model.Links = ctrl.procesoLinksList;

        ctrl.model.Usuarios = [];
        ctrl.model.GrupoId = ctrl.model.Grupo.Id;
        ctrl.model.Activo = 1;

        for (var i = 0; i < ctrl.model.Templates.length; i++) {
          ctrl.model.Templates[i].Usuarios = [];
          ctrl.model.Templates[i].Campos = [];
        }

        //Usuarios del proceso
        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            if (ctrl.procesoUsuariosList[i].RolProcesoList != null) {
              for (var j = 0; j < ctrl.procesoUsuariosList[i].RolProcesoList.length; j++) {
                ctrl.model.Usuarios.push({
                  ProcesoId: ctrl.model.Id,
                  UsuarioId: ctrl.procesoUsuariosList[i].Usuario.Id,
                  RolProcesoId: ctrl.procesoUsuariosList[i].RolProcesoList[j].Id
                });
              }
            }
          }
        }

        //Si no tiene cargado nada en la lista, cargo el default
        if (ctrl.procesoTemplateUsuariosList == null || ctrl.procesoTemplateUsuariosList.length <= 0)
          ctrl.loadSeguridadTemplatesTab();

        //Usuarios de cada template/gestion del proceso
        if (ctrl.procesoTemplateUsuariosList != null && ctrl.procesoTemplateUsuariosList.length > 0) {
          var index = -1;

          for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
            if (ctrl.procesoTemplateUsuariosList[i].RolTemplateList != null) {
              for (var x = 0; x < ctrl.model.Templates.length; x++) {
                if (ctrl.model.Templates[x].TemplateId == ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id) {
                  index = x;
                  break;
                }
              }

              if (index >= 0) {
                for (var j = 0; j < ctrl.procesoTemplateUsuariosList[i].RolTemplateList.length; j++) {
                  ctrl.model.Templates[index].Usuarios.push({
                    ProcesoTemplateId: ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Id,
                    UsuarioId: ctrl.procesoTemplateUsuariosList[i].Usuario.Id,
                    RolTemplateId: ctrl.procesoTemplateUsuariosList[i].RolTemplateList[j].Id
                  });
                }//for
              }
            }
          }//for
        }

        //Campos de cada template/gestion del proceso
        // console.log(ctrl.procesoTemplateCamposList);
        if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
          var index = -1;
          for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
            for (var x = 0; x < ctrl.model.Templates.length; x++) {
              if (ctrl.model.Templates[x].TemplateId == ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id) {
                var lOrden = 0;
                var lCamposTemplate = ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Campos;
                for (var t = 0; t < lCamposTemplate.length; t++) {
                  lOrden = lCamposTemplate[t].orden;
                  // console.log(lCamposTemplate[t].orden);
                }
                ctrl.model.Templates[x].Campos.push({
                  ProcesoTemplateId: ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Id,
                  CampoId: ctrl.procesoTemplateCamposList[i].Campo.Id,
                  orden: ctrl.procesoTemplateCamposList[i].orden
                });
              }
            }//for
          }//for
        }

        ctrl.model.CamposListado = [];
        if (ctrl.columnasProcesoList != null && ctrl.columnasProcesoList.length > 0) {
          for (var i = 0; i < ctrl.columnasProcesoList.length; i++) {
            if (ctrl.columnasProcesoList[i].SeleccionLista)
              ctrl.model.CamposListado.push(
                {
                  ProcesoId: ctrl.model.Id,
                  SolicitudColumnaId: ctrl.columnasProcesoList[i].Id,
                  CampoId: null,
                  Orden: ctrl.columnasProcesoList[i].OrdenLista,
                  Id: ctrl.columnasProcesoList[i].IdLista
                });
          }
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0) {
          for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
            if (ctrl.procesoCamposList[i].SeleccionLista) {
              ctrl.model.CamposListado.push(
                {
                  ProcesoId: ctrl.model.Id,
                  SolicitudColumnaId: null,
                  CampoId: ctrl.procesoCamposList[i].CampoId,
                  Orden: ctrl.procesoCamposList[i].OrdenLista,
                  Id: ctrl.procesoCamposList[i].IdLista
                });
            }
          }
        }

        dataService.saveProceso(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.proceso");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.updateFilters = function () {
        dataService.updateFilters(ctrl.model.Id)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.proceso");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.proceso");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return "Atención" },
            message: function () { return "Confirma el borrado del proceso?" },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteProceso(ctrl.model.Id).then(function (response) {
            if (response.data.Success) {
              toastr.info("Registro exitoso.");
              $state.transitionTo("pages.proceso");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.loadTemplatesTab = function () {
        var index;
        ctrl.estadosFilteredList = Object.create(ctrl.estadosList);

        if (!ctrl.model.RequiereValidacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'ACEP') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereVerificacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'VALI') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }

        if (!ctrl.model.RequiereAutorizacion) {
          index = -1;
          for (var i = 0; i < ctrl.estadosFilteredList.length; i++) {
            if (ctrl.estadosFilteredList[i].Codigo == 'VERI') {
              index = i;
              break;
            }
          }

          if (index >= 0)
            ctrl.estadosFilteredList.splice(index, 1);
        }

        ctrl.estadosFilteredList.unshift({ NombreEtapa: '' });
      }

      ctrl.loadSeguridadProcesosTab = function () {
        // var index;
        // console.log("entro a load seguridad");
        ctrl.rolProcesoFilteredList = Object.create(ctrl.rolProcesoList);
        // console.log(ctrl.rolProcesoList);
        // console.log(ctrl.model);

        if (!ctrl.model.RequiereValidacion) {
          var indexGestor = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'GESTOR') {
              indexGestor = i;
              break;
            }
          }

          if (indexGestor >= 0)
            ctrl.rolProcesoFilteredList.splice(indexGestor, 1);
        }

        if (!ctrl.model.RequiereVerificacion) {
          var indexVerificacion = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'VERIF') {
              indexVerificacion = i;
              break;
            }
          }

          if (indexVerificacion >= 0)
            ctrl.rolProcesoFilteredList.splice(indexVerificacion, 1);
        }

        if (!ctrl.model.RequiereAutorizacion) {
          var indexAprobacion = -1;
          for (var i = 0; i < ctrl.rolProcesoFilteredList.length; i++) {
            if (ctrl.rolProcesoFilteredList[i].Codigo == 'APROB') {
              indexAprobacion = i;
              break;
            }
          }

          if (indexAprobacion >= 0)
            ctrl.rolProcesoFilteredList.splice(indexAprobacion, 1);
        }

        // console.log(ctrl.rolProcesoFilteredList);
      }

      ctrl.loadSeguridadTemplatesTab = function () {
        ctrl.usuarioTemplateCargado = {};

        var finalList = [];
        var existePtu = false;
        var rolTemplateLector = {};

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        if (ctrl.procesoTemplateUsuariosList == null)
          ctrl.procesoTemplateUsuariosList = [];

        if (ctrl.rolTemplateList != null && ctrl.rolTemplateList.length > 0) {
          for (var i = 0; i < ctrl.rolTemplateList.length; i++) {
            if (ctrl.rolTemplateList[i].Codigo == 'LECTOR') {
              rolTemplateLector = ctrl.rolTemplateList[i];
              break;
            }
          }
        }

        if (ctrl.procesoTemplatesList != null) {
          for (var i = 0; i < ctrl.procesoTemplatesList.length; i++) {
            var pt = ctrl.procesoTemplatesList[i];

            for (var j = 0; j < ctrl.procesoUsuariosList.length; j++) {
              var pu = ctrl.procesoUsuariosList[j];
              existePtu = false;

              for (var k = 0; k < ctrl.procesoTemplateUsuariosList.length; k++) {
                if (ctrl.procesoTemplateUsuariosList[k].ProcesoTemplate.Template.Id == pt.Template.Id &&
                  ctrl.procesoTemplateUsuariosList[k].Usuario.Id == pu.Usuario.Id) {
                  existePtu = true;
                  finalList.push({
                    ProcesoTemplate: pt,
                    Usuario: pu.Usuario,
                    RolTemplateList: ctrl.procesoTemplateUsuariosList[k].RolTemplateList
                  });
                  break;
                }
              }

              //Si no tiene ningun rol asociado al template/gestion, lo sumo como LECTOR como default
              if (!existePtu) {
                finalList.push({
                  ProcesoTemplate: pt,
                  Usuario: pu.Usuario,
                  RolTemplateList: []
                });

                finalList[finalList.length - 1].RolTemplateList.push(rolTemplateLector);
              }
            }
          }
        }

        ctrl.procesoTemplateUsuariosList = finalList;
      }

      ctrl.loadCamposTemplatesTab = function () {
        // console.log("loadCamposTemplatesTab");
        // console.log(ctrl.procesoTemplateCamposList);
        ctrl.campoTemplateCargado = {};

        // var finalList = [];

        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        if (ctrl.procesoTemplateCamposList == null)
          ctrl.procesoTemplateCamposList = [];

        // if (ctrl.procesoTemplatesList != null)
        // {
        //   for (var i=0;i<ctrl.procesoTemplatesList.length;i++)
        //   {
        //     var pt = ctrl.procesoTemplatesList[i];

        //     finalList.push({
        //                       ProcesoTemplate: pt,
        //                       CampoList: []
        //                     });

        //     for (var k=0;k<ctrl.procesoTemplateCamposList.length;k++)
        //     {
        //       if (ctrl.procesoTemplateCamposList[k].ProcesoTemplate.Template.Id == pt.Template.Id)
        //       {
        //         finalList[i].CampoList.push(ctrl.procesoTemplateCamposList[k].Campo);
        //       }
        //     }
        //   }
        // }
        // ctrl.procesoTemplateCamposList = finalList;
      }

      ctrl.loadProcesosHijoTab = function (aceptaHijos) {
        ctrl.procesoHijoCargado = {};

        if (!aceptaHijos) {
          ctrl.procesoHijosSeleccionables = [];
        }
      }

      ctrl.openAttachment = function (fileName) {
        var usuarioLogueadoId = authData.Id;
        sharedService.openVisorDocumental(usuarioLogueadoId, fileName);
        // window.open(fileName);
      }

      ctrl.uploadAttachment = function (file) {
        if (file == null)
          return;

        ctrl.isBusy = true;
        ctrl.model.isImageLoading = true;

        dataService.uploadImageFileProceso(file)
          .then(function (response) {
            $timeout(function () {
              //console.log(response);
              if (response.data.Success) {
                //console.log('uploadFileAttachment: ' + response.data.Value);
                // Este endpoint está respondiendo únicamente con el nombre del archivo, por lo que el front le concatena el resto del url de la api que corresponde
                // ctrl.model.UrlImagen = appConfig.uploadUrl.replace('uploads/', 'Images') + response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };

                // Cambio anterior revertido el 23/04/2024
                // ctrl.model.UrlImagen = response.data.Value; 

                if (response.data.Value != null && response.data.Value.length > 0) {
                  if (response.data.Value.slice(0, 4).toLowerCase() == "http") {
                    ctrl.model.UrlImagen = response.data.Value;
                  } else {
                    ctrl.model.UrlImagen = appConfig.uploadUrl.replace('uploads/', 'Images') + response.data.Value;
                  }
                }
              }
              else {
                ctrl.model.UrlImagen = null;
              }
            });
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            ctrl.model.isImageLoading = false;
          });
      }

      ctrl.removeAttachment = function () {
        ctrl.model.UrlImagen = null;
      }

      /******************* Templates *******************/
      ctrl.searchTemplate = function (nombreTemplate) {
        var filtroTemplate = { Nombre: nombreTemplate, PageSize: 20, SkipNumber: 0 };

        return dataService.searchTemplate(filtroTemplate)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectTemplate = function (templateSeleccionado) {
        ctrl.templateCargado.Template = templateSeleccionado;
      }

      ctrl.editTemplate = function () {
        if (ctrl.templateCargado == null ||
          ctrl.templateCargado.Template == null ||
          ctrl.templateCargado.Template.Id == 0 ||
          ctrl.templateCargado.Ocurrencia == null ||
          ctrl.templateCargado.Ocurrencia <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar la gestión');
          return;
        }

        if (ctrl.templateCargado.Obligatorio == true &&
          ctrl.templateCargado.SolicitudEstado == null) {
          toastr.error('No puede dar de alta una gestión obligatoria sin definir el estado en el cual se deberá validar el mismo');
          return;
        }

        ctrl.templateCargado.ProcesoId = ctrl.model.Id;
        ctrl.templateCargado.TemplateId = ctrl.templateCargado.Template.Id;
        ctrl.templateCargado.SolicitudEstadoId = null;

        if (ctrl.templateCargado.SolicitudEstado != null && ctrl.templateCargado.SolicitudEstado.Id)
          ctrl.templateCargado.SolicitudEstadoId = ctrl.templateCargado.SolicitudEstado.Id;

        if (ctrl.procesoTemplatesList == null)
          ctrl.procesoTemplatesList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoTemplatesList.length; i++) {
          if (ctrl.procesoTemplatesList[i].TemplateId == ctrl.templateCargado.TemplateId)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoTemplatesList[index] = ctrl.templateCargado;
        else
          ctrl.procesoTemplatesList.push(ctrl.templateCargado);

        ctrl.procesoTemplatesDS = ctrl.procesoTemplatesList;
        ctrl.templateCargado = {};
      }

      ctrl.cargarTemplate = function (templateSeleccionado) {
        if (templateSeleccionado == null) {
          toastr.error('Por favor seleccione una gestión para poder visualizarlo');
          return;
        }

        ctrl.templateCargado = {};

        ctrl.templateCargado.Id = templateSeleccionado.Id;
        ctrl.templateCargado.ProcesoId = templateSeleccionado.ProcesoId;
        ctrl.templateCargado.Template = templateSeleccionado.Template;
        ctrl.templateCargado.TemplateInput = templateSeleccionado.Template.Nombre;
        ctrl.templateCargado.SolicitudEstado = templateSeleccionado.SolicitudEstado;
        ctrl.templateCargado.Ocurrencia = templateSeleccionado.Ocurrencia;
        ctrl.templateCargado.Obligatorio = templateSeleccionado.Obligatorio;
      }

      ctrl.eliminarTemplate = function (index) {
        if (index < 0) {
          toastr.error('Gestión seleccionada inválida');
          return;
        }

        if (ctrl.procesoTemplatesList != null && ctrl.procesoTemplatesList.length > 0)
          ctrl.procesoTemplatesList.splice(index, 1);
      }

      ctrl.clearTemplate = function () {
        ctrl.templateCargado = {};
      }

      /******************* Campos *******************/
      ctrl.editCampo = function () {
        if (ctrl.campoCargado.Orden <= 0 ||
          ctrl.campoCargado.Orden == null ||
          ctrl.campoCargado.Orden == '' ||
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.TipoCampoSolicitud == '' ||
          ctrl.campoCargado.TipoCampoSolicitud == null ||
          ctrl.campoCargado.Campo.Id == 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el campo');
          return;
        }

        if (ctrl.campoCargado.Obligatorio == null)
          ctrl.campoCargado.Obligatorio = false;

        ctrl.campoCargado.ProcesoId = ctrl.model.Id;
        ctrl.campoCargado.CampoId = ctrl.campoCargado.Campo.Id;
        ctrl.campoCargado.tipoCampoSolicitudId = ctrl.campoCargado.TipoCampoSolicitud.Id;

        if (ctrl.procesoCamposList == null)
          ctrl.procesoCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          if (ctrl.procesoCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.procesoCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }

          if (ctrl.procesoCamposList[i].CampoId == ctrl.campoCargado.CampoId)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoCamposList[index] = ctrl.campoCargado;
        else
          ctrl.procesoCamposList.push(ctrl.campoCargado);

        ctrl.procesoCamposList.sort(function (a, b) { return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0); });
        ctrl.procesoCamposDS = ctrl.procesoCamposList;
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        }

        ctrl.campoCargado = {};

        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.ProcesoId = campoSeleccionado.ProcesoId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.Orden = campoSeleccionado.Orden;
        ctrl.campoCargado.Obligatorio = campoSeleccionado.Obligatorio;
        ctrl.campoCargado.TipoCampoSolicitud = campoSeleccionado.TipoCampoSolicitud;
      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.procesoCamposList != null && ctrl.procesoCamposList.length > 0)
          ctrl.procesoCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }

      ctrl.searchCampo = function (campoNombre) {
        var filtroCampo = {
          Nombre: campoNombre,
          PageSize: 20,
          SkipNumber: 0
        };

        return dataService.searchCampo(filtroCampo)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
              console.log(response.data.Value);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      /******************* Proceso Usuarios *******************/
      ctrl.searchProcesoUsuarios = function (usuarioLogin) {
        // Filtro hecho a mano para la tabla "Usuarios Cargados" debido a que la misma usa la librería "smart table" y no permite ver el usuario actualizado una vez se cambian los roles

        if (usuarioLogin != null && usuarioLogin.length > 0) {
          ctrl.showFooterTable = false; // ocultando la navegación de la tabla mientras se hace el filtrado

          ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList.filter(function (procesoUsuario) {
            if (procesoUsuario.Usuario.Login.toLowerCase().includes(usuarioLogin.toLowerCase())) {
              return procesoUsuario;
            }
          });
        } else {
          ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
          ctrl.showFooterTable = true; // volviendo a mostrar el paginado de la tabla
        }
      }

      ctrl.searchUsuario = function (nombreUsuario) {
        var filtroUsuario = { Login: nombreUsuario, PageSize: 20, SkipNumber: 0 };

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectUsuario = function (usuarioSeleccionado) {
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado;
      }

      ctrl.editUsuario = function () {
        if (ctrl.usuarioCargado == null ||
          ctrl.usuarioCargado.Usuario == null ||
          ctrl.usuarioCargado.Usuario.Id == 0 ||
          ctrl.usuarioCargado.RolProcesoList == null ||
          ctrl.usuarioCargado.RolProcesoList.length <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
          return;
        }

        ctrl.usuarioCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioCargado.UsuarioId = ctrl.usuarioCargado.Usuario.Id;

        if (ctrl.procesoUsuariosList == null)
          ctrl.procesoUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
          if (ctrl.procesoUsuariosList[i].Usuario.Login == ctrl.usuarioCargado.Usuario.Login)
            index = i;
        }

        if (index >= 0)
          ctrl.procesoUsuariosList[index] = ctrl.usuarioCargado;
        else
          ctrl.procesoUsuariosList.push(ctrl.usuarioCargado);

        ctrl.procesoUsuariosDS = ctrl.procesoUsuariosList;
        ctrl.usuarioCargado = {};

        //Actualizo los permisos para el usuario cargado
        ctrl.loadSeguridadTemplatesTab();

        ctrl.showFooterTable = true; // volviendo a mostrar el paginado de la tabla
      }

      ctrl.cargarUsuario = function (usuarioSeleccionado) {
        if (usuarioSeleccionado == null) {
          toastr.error('Por favor seleccione un usuario para poder visualizarlo');
          return;
        }

        ctrl.usuarioCargado = {};

        ctrl.usuarioCargado.ProcesoId = usuarioSeleccionado.ProcesoId;
        ctrl.usuarioCargado.Usuario = usuarioSeleccionado.Usuario;
        ctrl.usuarioCargado.UsuarioInput = usuarioSeleccionado.Usuario.Login;
        ctrl.usuarioCargado.RolProcesoList = usuarioSeleccionado.RolProcesoList;
      }

      ctrl.eliminarUsuario = function (userId) {
        if (userId == undefined || userId == null || userId <= 0) {
          toastr.error('Usuario seleccionado inválido');
          return;
        }

        if (ctrl.procesoUsuariosList != null && ctrl.procesoUsuariosList.length > 0) {
          var procesoUsuariosListFinal = [];
          for (var i = 0; i < ctrl.procesoUsuariosList.length; i++) {
            if (ctrl.procesoUsuariosList[i].Usuario.Id != userId)
              procesoUsuariosListFinal.push(ctrl.procesoUsuariosList[i]);
          }

          ctrl.procesoUsuariosList = procesoUsuariosListFinal;

          //Actualizo los permisos de templates para los usuarios que quedaron
          ctrl.loadSeguridadTemplatesTab();
        }

        ctrl.showFooterTable = true; // volviendo a mostrar el paginado de la tabla
      }

      ctrl.clearUsuario = function () {
        ctrl.usuarioCargado = {};
      }

      ctrl.concatRolesString = function (values) {
        return values.map(function (elem) {
          if (elem != null)
            return elem.Nombre;
          return "";
        }).join(", ");
      }

      /******************* Templates Usuarios *******************/
      ctrl.loadTemplateUsuarioSeleccionado = function () {
        ctrl.usuarioTemplateCargado.Usuarios = [];
        var uIndex;

        if (ctrl.usuarioTemplateCargado.ProcesoTemplate == null)
          return;

        for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
          uIndex = -1;

          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id == ctrl.usuarioTemplateCargado.ProcesoTemplate.Template.Id) {
            for (var j = 0; j < ctrl.usuarioTemplateCargado.Usuarios.length; j++) {
              if (ctrl.usuarioTemplateCargado.Usuarios[j].Id == ctrl.procesoTemplateUsuariosList[i].Usuario.Id) {
                uIndex = j;
                break;
              }
            }

            if (uIndex < 0) {
              ctrl.usuarioTemplateCargado.Usuarios.push(ctrl.procesoTemplateUsuariosList[i].Usuario);
              uIndex = ctrl.usuarioTemplateCargado.Usuarios.length - 1;
              ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList = [];
            }

            // ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList.push(ctrl.procesoTemplateUsuariosList[i].RolTemplate);
            ctrl.usuarioTemplateCargado.Usuarios[uIndex].RolTemplateList = ctrl.procesoTemplateUsuariosList[i].RolTemplateList;
          }
        }
      }

      ctrl.onRolTemplateSeleccionado = function (procesoTemplate, usuarioTemplate) {
        var i = ctrl.procesoTemplateUsuariosList.length;

        while (i--) {
          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.Template.Id == procesoTemplate.Template.Id &&
            ctrl.procesoTemplateUsuariosList[i].Usuario.Id == usuarioTemplate.Id) {
            ctrl.procesoTemplateUsuariosList.splice(i, 1);
          }
        }

        if (usuarioTemplate.RolTemplateList != null && usuarioTemplate.RolTemplateList.length > 0) {
          ctrl.procesoTemplateUsuariosList.push({
            ProcesoTemplate: procesoTemplate,
            Usuario: usuarioTemplate,
            RolTemplateList: usuarioTemplate.RolTemplateList
          });
        }
      }

      ctrl.searchTemplateUsuario = function (nombreUsuario) {
        var filtroUsuario = { Login: nombreUsuario, PageSize: 20, SkipNumber: 0 };

        return dataService.searchUsuario(filtroUsuario)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectTemplateUsuario = function (usuarioSeleccionado) {
        ctrl.usuarioTemplateCargado.Usuario = usuarioSeleccionado;
      }

      ctrl.editTemplateUsuario = function () {
        if (ctrl.usuarioTemplateCargado == null ||
          ctrl.usuarioTemplateCargado.ProcesoTemplate == null ||
          ctrl.usuarioTemplateCargado.ProcesoTemplate.Id == 0 ||
          ctrl.usuarioTemplateCargado.Usuario == null ||
          ctrl.usuarioTemplateCargado.Usuario.Id == 0 ||
          ctrl.usuarioTemplateCargado.RolTemplateList == null ||
          ctrl.usuarioTemplateCargado.RolTemplateList.length <= 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el usuario');
          return;
        }

        //ctrl.usuarioTemplateCargado.ProcesoId = ctrl.model.Id;
        ctrl.usuarioTemplateCargado.ProcesoTemplateId = ctrl.usuarioTemplateCargado.ProcesoTemplate.Id;
        ctrl.usuarioTemplateCargado.UsuarioId = ctrl.usuarioTemplateCargado.Usuario.Id;

        if (ctrl.procesoTemplateUsuariosList == null)
          ctrl.procesoTemplateUsuariosList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoTemplateUsuariosList.length; i++) {
          if (ctrl.procesoTemplateUsuariosList[i].ProcesoTemplate.TemplateId == ctrl.usuarioTemplateCargado.ProcesoTemplate.TemplateId &&
            ctrl.procesoTemplateUsuariosList[i].Usuario.Id == ctrl.usuarioTemplateCargado.Usuario.Id) {
            index = i;
            break;
          }
        }

        if (index >= 0)
          ctrl.procesoTemplateUsuariosList[index] = ctrl.usuarioTemplateCargado;
        else
          ctrl.procesoTemplateUsuariosList.push(ctrl.usuarioTemplateCargado);

        ctrl.usuarioTemplateCargado = {};
      }

      ctrl.cargarTemplateUsuario = function (usuarioTemplateSeleccionado) {
        if (usuarioTemplateSeleccionado == null) {
          toastr.error('Por favor seleccione un usuario para poder visualizarlo');
          return;
        }

        ctrl.usuarioTemplateCargado = {};

        ctrl.usuarioTemplateCargado.ProcesoId = usuarioTemplateSeleccionado.ProcesoId;
        ctrl.usuarioTemplateCargado.ProcesoTemplate = usuarioTemplateSeleccionado.ProcesoTemplate;
        ctrl.usuarioTemplateCargado.Usuario = usuarioTemplateSeleccionado.Usuario;
        ctrl.usuarioTemplateCargado.UsuarioInput = usuarioTemplateSeleccionado.Usuario.Login;
        ctrl.usuarioTemplateCargado.RolTemplateList = usuarioTemplateSeleccionado.RolTemplateList;
      }

      ctrl.eliminarTemplateUsuario = function (index) {
        if (index < 0) {
          toastr.error('Usuario seleccionado inválido');
          return;
        }

        if (ctrl.procesoTemplateUsuariosList != null && ctrl.procesoTemplateUsuariosList.length > 0)
          ctrl.procesoTemplateUsuariosList.splice(index, 1);
      }

      ctrl.clearTemplateUsuario = function () {
        ctrl.usuarioTemplateCargado = {};
      }

      ctrl.concatTemplateRolesString = function (values) {
        return values.map(function (elem) {
          if (elem != null)
            return elem.Nombre;
          return "";
        }).join(", ");
      }

      /******************* Templates Campos *******************/
      ctrl.loadTemplateCampoSeleccionado = function () {
        if (ctrl.campoTemplateCargado.ProcesoTemplate == null)
          return;

        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          ctrl.procesoCamposList[i].Seleccionado = false;

          if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
            for (var j = 0; j < ctrl.procesoTemplateCamposList.length; j++) {
              if (ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
                ctrl.procesoTemplateCamposList[j].Campo.Id == ctrl.procesoCamposList[i].Campo.Id) {
                ctrl.procesoCamposList[i].Seleccionado = true;
                /*var lCamposTemplate = ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Campos;
                  for (var t = 0; t < lCamposTemplate.length; t++) {
                    if (ctrl.procesoCamposList[i].CampoId == lCamposTemplate[t].CampoId) {
                      ctrl.procesoCamposList[i].orden = lCamposTemplate[t].orden;
                      break;
                    }
                  }*/
                // console.log(ctrl.procesoCamposList[i]);
                break;
              } else {
                ctrl.procesoCamposList[i].orden = "";
              }
            }
          }
        }


        /*Update Orden*/
        if (ctrl.procesoTemplateCamposList != null && ctrl.procesoTemplateCamposList.length > 0) {
          for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
            if (ctrl.procesoCamposList[i].Seleccionado) {
              for (var j = 0; j < ctrl.procesoTemplateCamposList.length; j++) {
                if (ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id) {
                  var lCamposTemplate = ctrl.procesoTemplateCamposList[j].ProcesoTemplate.Campos;
                  for (var t = 0; t < lCamposTemplate.length; t++) {
                    if (ctrl.procesoCamposList[i].CampoId == lCamposTemplate[t].CampoId) {
                      ctrl.procesoCamposList[i].orden = lCamposTemplate[t].orden;
                      break;
                    }
                  }
                }
              }
            }
          }
        }
      }

      ctrl.onTemplateCampoSeleccionado = function (procesoCampo) {
        if (procesoCampo == null)
          return;

        var index = -1;

        for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
          if (ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
            ctrl.procesoTemplateCamposList[i].Campo.Id == procesoCampo.Campo.Id) {
            ctrl.procesoTemplateCamposList[i].orden = procesoCampo.orden;
            index = i;
            break;
          }
        }//for

        //Seleccionado y no esta en el listado
        if (procesoCampo.Seleccionado && index == -1)
          ctrl.procesoTemplateCamposList.push(
            {
              ProcesoTemplate: ctrl.campoTemplateCargado.ProcesoTemplate,
              Campo: procesoCampo.Campo,
              ProcesoTemplateId: ctrl.campoTemplateCargado.ProcesoTemplate.Id,
              CampoId: procesoCampo.Campo.Id,
              orden: procesoCampo.orden
            });

        //Deseleccionado y esta en el listado
        if (!procesoCampo.Seleccionado && index >= 0) {
          procesoCampo.orden = "";
          ctrl.procesoTemplateCamposList.splice(index, 1);
        }
      }

      ctrl.onTemplateCampoSeleccionadoOrden = function (procesoCampo) {
        if (procesoCampo == null)
          return;

        var index = -1;
        // console.log(ctrl.procesoTemplateCamposList);
        for (var i = 0; i < ctrl.procesoTemplateCamposList.length; i++) {
          if (ctrl.procesoTemplateCamposList[i].ProcesoTemplate.Template.Id == ctrl.campoTemplateCargado.ProcesoTemplate.Template.Id &&
            ctrl.procesoTemplateCamposList[i].Campo.Id == procesoCampo.Campo.Id) {
            ctrl.procesoTemplateCamposList[i].orden = procesoCampo.orden;
            index = i;
            break;
          }
        }

        //Seleccionado y no esta en el listado
        if (index != -1) {
          if (procesoCampo.orden != "") {
            ctrl.procesoTemplateCamposList[index].orden = procesoCampo.orden;
            // console.log(ctrl.procesoTemplateCamposList[index]);
          }
        }
      }

      /******************* Procesos Hijo *******************/
      ctrl.loadProcesosByGrupo = function () {
        if (ctrl.procesoHijoCargado != null) {
          ctrl.procesoHijoCargado.ProcesosHijoSeleccionados = [];

          if (ctrl.procesoHijosSeleccionables != null && ctrl.procesoHijosSeleccionables.length > 0) {
            for (var i = 0; i < ctrl.procesoHijosSeleccionables.length; i++) {
              var ph = ctrl.procesoHijosSeleccionables[i];

              for (var j = 0; j < ctrl.procesoHijoCargado.ProcesosHijosList.length; j++) {
                if (ph.ProcesoHijoId == ctrl.procesoHijoCargado.ProcesosHijosList[j].Id) {
                  ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.push(ctrl.procesoHijoCargado.ProcesosHijosList[j]);
                  break;
                }
              }
            }
          }
        }
      }

      ctrl.onProcesoHijoSeleccionado = function () {
        if (ctrl.procesoHijosSeleccionables == null)
          ctrl.procesoHijosSeleccionables = [];

        var i = ctrl.procesoHijosSeleccionables.length;

        while (i--) {
          if (ctrl.procesoHijosSeleccionables[i].ProcesoHijoId == ctrl.model.Id) {
            if (ctrl.model.Grupo.Id == ctrl.procesoHijoCargado.Grupo.Id) {
              ctrl.procesoHijosSeleccionables.splice(i, 1);
            }
          }
          else {
            if (ctrl.procesoHijosSeleccionables[i].ProcesoHijo.Grupo.Id == ctrl.procesoHijoCargado.Grupo.Id) {
              ctrl.procesoHijosSeleccionables.splice(i, 1);
            }
          }
        }

        if (ctrl.procesoHijoCargado.ProcesosHijoSeleccionados != null && ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.length > 0) {
          for (var i = 0; i < ctrl.procesoHijoCargado.ProcesosHijoSeleccionados.length; i++) {
            ctrl.procesoHijosSeleccionables.push({
              ProcesoId: ctrl.model.Id,
              // Proceso: ctrl.model,
              ProcesoHijoId: ctrl.procesoHijoCargado.ProcesosHijoSeleccionados[i].Id,
              ProcesoHijo: ctrl.procesoHijoCargado.ProcesosHijoSeleccionados[i]
            });
          }
        }
      }

      /******************* Procesos Link *******************/
      ctrl.editProcesoLink = function () {
        if (ctrl.procesoLinkCargado.NombreLink == null ||
          ctrl.procesoLinkCargado.NombreLink.length == 0 ||
          ctrl.procesoLinkCargado.UrlLink == null ||
          ctrl.procesoLinkCargado.UrlLink.length == 0) {
          toastr.error('Por favor complete los datos obligatorios marcados con asterisco para cargar el link');
          return;
        }

        ctrl.procesoLinkCargado.ProcesoId = ctrl.model.Id;

        if (ctrl.procesoLinksList == null)
          ctrl.procesoLinksList = [];

        var index = -1;
        for (var i = 0; i < ctrl.procesoLinksList.length; i++) {
          if ((ctrl.procesoLinksList[i].Id == ctrl.procesoLinkCargado.Id) && 
          (ctrl.procesoLinksList[i].temporalId == ctrl.procesoLinkCargado.temporalId)) {
            index = i;
          }
        }

        // temporalId es una prop generada por front para poder editar el link correctamente, no se guarda en backend
        if (!ctrl.procesoLinkCargado.temporalId) {
          ctrl.procesoLinkCargado.temporalId = Date.now().toString(16);
        }

        if (index >= 0)
          ctrl.procesoLinksList[index] = ctrl.procesoLinkCargado;
        else
          ctrl.procesoLinksList.push(ctrl.procesoLinkCargado);

        ctrl.procesoLinkCargado = {};
      }

      ctrl.cargarProcesoLink = function (linkSeleccionado) {
        if (linkSeleccionado == null) {
          toastr.error('Por favor seleccione un link para poder visualizarlo');
          return;
        }

        ctrl.procesoLinkCargado = {};

        ctrl.procesoLinkCargado.Id = linkSeleccionado.Id;
        ctrl.procesoLinkCargado.ProcesoId = linkSeleccionado.ProcesoId;
        ctrl.procesoLinkCargado.NombreLink = linkSeleccionado.NombreLink;
        ctrl.procesoLinkCargado.UrlLink = linkSeleccionado.UrlLink;
        ctrl.procesoLinkCargado.solicitudLevel = linkSeleccionado.solicitudLevel;
        ctrl.procesoLinkCargado.ejecutaProcedure = linkSeleccionado.ejecutaProcedure;
        // temporalId es una prop generada por front para poder editar el link correctamente, no se guarda en backend
        ctrl.procesoLinkCargado.temporalId = linkSeleccionado.temporalId;
      }

      ctrl.eliminarProcesoLink = function (index) {
        if (index < 0) {
          toastr.error('Link seleccionado inválido');
          return;
        }

        if (ctrl.procesoLinksList != null && ctrl.procesoLinksList.length > 0)
          ctrl.procesoLinksList.splice(index, 1);
      }

      ctrl.clearProcesoLink = function () {
        ctrl.procesoLinkCargado = {};
      }

      ctrl.isCampoListChequed = function (item) {
        var contador = 1;
        for (var i = 0; i < ctrl.procesoCamposList.length; i++) {
          if (ctrl.procesoCamposList[i].SeleccionLista) {
            if (contador > 6) {
              item.SeleccionLista = false;
              toastr.error('Por favor seleccione Maximo 6 Campos de Busqueda');
              return;
            }
            contador += 1;
          }
        }
      }

      ctrl.validatePercentage = function(value) {
        if (value > 100) {
          ctrl.campoCargado.PorcentajeOcupacion = 100;
        } else {
          ctrl.campoCargado.PorcentajeOcupacion = parseInt(value);
        }
      }

    }
  });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.proceso').component('procesoList', {
      templateUrl: 'app/pages/proceso/list.template.html',
      controller: function ($scope,$state,dataService,sharedService,toastr) {
        var ctrl = this;
        ctrl.mostrarAgregar = false;
        
        this.$onInit = function () 
        {          
          // ctrl.mostrarAgregar = sharedService.isSuperAdminLoggedUserId();
          ctrl.mostrarAgregar = sharedService.isSuperAdminLoggedActivateAddProcess();
        };

        ctrl.buscar = function buscar(tableState) 
        {
          ctrl.mostrarAgregar = sharedService.isSuperAdminLoggedUserId();
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 10;  // Number of entries showed per page.

          ctrl.filtros = { PageSize: number, SkipNumber: start };

          if (tableState.search.predicateObject != null)
          {
            ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
            ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
            ctrl.filtros.Grupo = tableState.search.predicateObject.Grupo;
            ctrl.filtros.CantidadDiasCierre = tableState.search.predicateObject.CantidadDiasCierre;

            if (tableState.search.predicateObject.RequiereValidacion == 1 ||
                tableState.search.predicateObject.RequiereValidacion == 'true')
              ctrl.filtros.RequiereValidacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereValidacion == 0 ||
                  tableState.search.predicateObject.RequiereValidacion == 'false')
                ctrl.filtros.RequiereValidacion = false;
              else
                ctrl.filtros.RequiereValidacion = null;
            }

            if (tableState.search.predicateObject.RequiereVerificacion == 1 ||
                tableState.search.predicateObject.RequiereVerificacion == 'true') 
              ctrl.filtros.RequiereVerificacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereVerificacion == 0 ||
                  tableState.search.predicateObject.RequiereVerificacion == 'false')
                ctrl.filtros.RequiereVerificacion = false;
              else
                ctrl.filtros.RequiereVerificacion = null;
            }

            if (tableState.search.predicateObject.RequiereAutorizacion == 1 ||
                tableState.search.predicateObject.RequiereAutorizacion == 'true')
              ctrl.filtros.RequiereAutorizacion = true;
            else
            {
              if (tableState.search.predicateObject.RequiereAutorizacion == 0 ||
                  tableState.search.predicateObject.RequiereAutorizacion == 'false')
                ctrl.filtros.RequiereAutorizacion = false;
              else
                ctrl.filtros.RequiereAutorizacion = null;
            }
          }

          if (tableState.sort != null)
          {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.searchProceso(ctrl.filtros)
            .then(function (response)
            {
              if (response.data.Success)
              {
                ctrl.resultList = response.data.Value.Resultados;
                //ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
              } 
              else 
              {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
          });
        };
        
        ctrl.add = function ()
        {
          // console.log("");
          var authData =  sharedService.getLoggedUser();
          // console.log(authData);
          // console.log(ctrl);
          $state.go("pages.proceso-edit",{id:0});
        }

        ctrl.edit = function (id)
        {
          $state.go("pages.proceso-edit",{id:id});
        }
      }
    });
  })(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.proceso').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.proceso', {
          url: '/proceso',
          title: 'Proceso',
          template : '<proceso-list></proceso-list>',
          authenticate: true,
        })
        .state('pages.proceso-edit', {
          url: '/proceso/edit/:id',
          title: 'Proceso',
          template : '<proceso-edit></proceso-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function () {
    'use strict';
    angular.module('Kahuna.pages.reporte').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.reporte-templates-pendientes', {
          url: '/reporte/templatespendientes',
          title: 'Reporte de Gestiones Pendientes',
          template : '<reporte-templates-pendientes-list></reporte-templates-pendientes-list>',
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular
    .module("Kahuna.pages.reporte")
    .component("reporteTemplatesPendientesList", {
      templateUrl: "app/pages/reporte/templatespendienteslist.template.html",
      controller: function (
        $scope,
        $state,
        dataService,
        sharedService,
        toastr
      ) {
        var ctrl = this;
        ctrl.anularVista = true;
        ctrl.isSearching = true;
        ctrl.totalResultados = 0;
        ctrl.tableState = {};
        ctrl.authData = {};
        ctrl.ident = "URL_TEMPLATES_PEND";
        ctrl.urlLink = "";

        this.$onInit = function () {
          ctrl.authData = sharedService.getLoggedUser();

          //Sobre reportes reemplazar link (GESTIONES PENDIENTES)
          //&VarUsuarioId parasar el id del usuario autenticado.
          //http://reportes.kahunasoft.com.ar/ReportServer?%2fKhnDocV2APAAustin&rs:Command=Render&Usuario=VarUsuarioId

          if (ctrl.authData != null && ctrl.authData.Id > 0) {
            ctrl.viewLoading = true;
            dataService.checkMenuFuncion("REPO_TEMPLATES_PENDIENTES").then(
              function (response) {
                if (response.data.Success) {
                  if (response.data.Value == true) {
                    ctrl.anularVista = false;
                    loadView();
                  } else {
                    ctrl.anularVista = true;
                    ctrl.motivoBloqueo =
                      "No tiene permisos para visualizar esta vista.";
                  }
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
                ctrl.viewLoading = false;
              }
            );
          } else {
            $state.go("auth", { returnUrl: window.location.href });
            return;
          }
        };

        function loadView() {
          //ctrl.buscar(ctrl.tableState);
          //Ejecutar llamado al link
          ctrl.getParametrosByIdent(ctrl.ident);
        }

        ctrl.openLinkTemplate = function () {
          if (
            ctrl.authData.Id != null &&
            ctrl.authData.Id != "" &&
            ctrl.urlLink !== ""
          ) {
            ctrl.urlLink = ctrl.urlLink.replace("&VarUsuarioId", ctrl.authData.Id);
            ctrl.urlLink = ctrl.urlLink.replace("&varusuarioid", ctrl.authData.Id );
            var usuarioLogueadoId = ctrl.authData.Id;
            sharedService.openVisorDocumental(usuarioLogueadoId, ctrl.urlLink);
            // window.open(ctrl.urlLink, "_blank");
          }
        };

        ctrl.getParametrosByIdent = function (Ident) {
          if (Ident != "") {
            dataService
              .obtenerParametrosByIdent(Ident)
              .then(function (response) {
                if (response.data.Success && response.data.Value != null) {
                  ctrl.urlLink = response.data.Value.UrlDocumentos;
                  ctrl.showBtnLink = true;
                  ctrl.openLinkTemplate();
                }
              });
          }
        };

        ctrl.buscar = function buscar(tableState) {
          ctrl.isSearching = true;

          var pagination = tableState.pagination;

          var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
          var number = pagination.number || 20; // Number of entries showed per page.

          ctrl.filtros = {
            PageSize: number,
            SkipNumber: start,
            UsuarioId: ctrl.authData.Id,
          };

          if (tableState.sort != null) {
            ctrl.filtros.OrderFieldName = tableState.sort.predicate;
            ctrl.filtros.OrderAscending = !tableState.sort.reverse;
          }

          dataService.reporteTemplatesPendientesCarga(ctrl.filtros).then(
            function (response) {
              if (response.data.Success) {
                ctrl.resultList = response.data.Value.Resultados;
                ctrl.totalResultados = response.data.Value.TotalResultados;

                tableState.pagination.numberOfPages = Math.ceil(
                  response.data.Value.TotalResultados / number
                ); //result.numberOfPages;//set the number of pages so the pagination can update
                ctrl.tableState = tableState;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isSearching = false;
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
              ctrl.isSearching = false;
            }
          );
        };

        ctrl.ver = function (solicitudProcesoTemplate) {
          if (solicitudProcesoTemplate != null) {
            $state.go("pages.solicitud-template", {
              solicitud: solicitudProcesoTemplate.SolicitudId,
              solicitudEstado: solicitudProcesoTemplate.Solicitud.EstadoId,
              procesoTemplate: solicitudProcesoTemplate.ProcesoTemplateId,
              template: solicitudProcesoTemplate.ProcesoTemplate.TemplateId,
              proceso: solicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
              solicitudProcesoTemplate: solicitudProcesoTemplate.Id,
            });
          } else
            toastr.error(
              "Debe seleccionar un registro para ejecutar la operación"
            );
        };
      },
    });
})(window.angular);

(function () {
  'use strict';

  angular.module('Kahuna.pages.services').service('dataService', dataService);

  /** @ngInject */
  function dataService($http, appConfig, Upload, localStorage, $timeout) {

    var service = {
      //Seguridad
      loginUser: loginUser,
      logoutUser: logoutUser,
      checkpassword: checkpassword,

      // AccesosUrl
      getAccesosURL: getAccesosURL,
      searchAccesosUrl: searchAccesosUrl,
      getAccesoUrlById: getAccesoUrlById,
      saveAccesosUrl: saveAccesosUrl,
      updateAccesosUrl: updateAccesosUrl,
      deleteAccesosUrl: deleteAccesosUrl,

      //AuxParametros
      obtenerParametrosApp: obtenerParametrosApp,
      obtenerParametrosByIdent: obtenerParametrosByIdent,
      obtenerALLParametrosByIdent: obtenerALLParametrosByIdent,
      getAuxParametrosById: getAuxParametrosById,
      searchAuxParametros: searchAuxParametros,
      saveAuxParametros: saveAuxParametros,
      deleteAuxParametros: deleteAuxParametros,

      //Jerarquia
      getJerarquiaList: getJerarquiaList,
      getJerarquiaPadreList: getJerarquiaPadreList,
      getJerarquiaByPadreList: getJerarquiaByPadreList,
      getJerarquiaById: getJerarquiaById,
      getJerarquiaAutorizacionesById: getJerarquiaAutorizacionesById,
      isUserAbleToCreateDocumentFromJerarquia: isUserAbleToCreateDocumentFromJerarquia,
      isUserAbleToCreateDocumentFromSolicitud: isUserAbleToCreateDocumentFromSolicitud,
      checkIfUserTieneMarcaObsoleto: checkIfUserTieneMarcaObsoleto,
      listadoUsuariosAutorizanSolicitudEtapa: listadoUsuariosAutorizanSolicitudEtapa,
      historialAutorizaciones: historialAutorizaciones,
      getJerarquiaCompleta: getJerarquiaCompleta,
      getJerarquiaMuestra: getJerarquiaMuestra,
      searchJerarquia: searchJerarquia,
      searchJerarquiaByPadre: searchJerarquiaByPadre,
      validarJerarquiaTienePadre: validarJerarquiaTienePadre,
      saveJerarquia: saveJerarquia,
      deleteJerarquia: deleteJerarquia,
      getJerarquiaProcesoCampos: getJerarquiaProcesoCampos,
      getPermisosUsuarioJerarquia: getPermisosUsuarioJerarquia,

      // Autosolicitud
      getAutoSolicitudById: getAutoSolicitudById,
      searchAutoSolicitud: searchAutoSolicitud,
      saveAutoSolicitud: saveAutoSolicitud,
      deleteAutoSolicitud: deleteAutoSolicitud,

      // Auto Autorizar
      getAutoAutorizarById: getAutoAutorizarById,
      searchAutoAutorizar: searchAutoAutorizar,
      saveAutoAutorizar: saveAutoAutorizar,
      deleteAutoAutorizar: deleteAutoAutorizar,

      //Periodo
      getPeriodoList: getPeriodoList,

      //Campo
      getCampoList: getCampoList,
      getCampoListLigth: getCampoListLigth,
      getCampoListByTemplate: getCampoListByTemplate,
      getCamposLigthByProceso: getCamposLigthByProceso,
      searchCampo: searchCampo,
      getCampo: getCampo,
      saveCampo: saveCampo,
      deleteCampo: deleteCampo,

      //CampoTipo
      getCampoTipoList: getCampoTipoList,
      //TipoCampoSolicitud
      getTipoCampoSolicitudList: getTipoCampoSolicitudList,

      //Campo tipo TABLEENR
      saveCampoValorGrillaFilas: saveCampoValorGrillaFilas,

      //Proceso
      updateFilters: updateFilters,
      getProcesoList: getProcesoList,
      getProcesoByGrupo: getProcesoByGrupo,
      getProcesoDefault: getProcesoDefault,
      searchProceso: searchProceso,
      searchProceso_doc: searchProceso_doc,
      searchProceso_nodoc: searchProceso_nodoc,
      searchProcesoTemplate: searchProcesoTemplate,
      searchProcesoUsuarios: searchProcesoUsuarios,
      searchUsuariosdeUnProceso: searchUsuariosdeUnProceso,
      getProcesoTituloConfigText: getProcesoTituloConfigText,
      getProcesoById: getProcesoById,
      getProcesoInSolicitud: getProcesoInSolicitud,
      getProcesoSolicitudGrid: getProcesoSolicitudGrid,
      getProcesoTemplateById: getProcesoTemplateById,
      getProcesoUsuarioListByProceso: getProcesoUsuarioListByProceso,
      getProcesoHijoSeleccionableList: getProcesoHijoSeleccionableList,
      saveProceso: saveProceso,
      deleteProceso: deleteProceso,
      uploadImageFileProceso: uploadImageFileProceso,
      searchTemplatesByProceso: searchTemplatesByProceso,
      executeProcedure: executeProcedure,
      SearchTemplatesByProcesoJerarquia: SearchTemplatesByProcesoJerarquia,

      //Grupo
      getGrupoList: getGrupoList,
      getGrupoHomeList: getGrupoHomeList,
      getGrupoByProcesoPadreList: getGrupoByProcesoPadreList,
      getGrupoById: getGrupoById,
      searchGrupo: searchGrupo,
      saveGrupo: saveGrupo,
      deleteGrupo: deleteGrupo,
      uploadImageFileGrupo: uploadImageFileGrupo,


      //Grupo
      getGruposUsuariosList: getGruposUsuariosList,
      getGruposUsuariosById: getGruposUsuariosById,
      searchGruposUsuarios: searchGruposUsuarios,
      saveGruposUsuarios: saveGruposUsuarios,
      deleteGruposUsuarios: deleteGruposUsuarios,
      userInGroup: userInGroup,

      //TipoTemplate
      getTipoTemplateList: getTipoTemplateList,
      getTipoTemplateEnvioMailConfiguracion: getTipoTemplateEnvioMailConfiguracion,
      getTipoTemplateHabilitacionUsuarioConfiguracion: getTipoTemplateHabilitacionUsuarioConfiguracion,
      getTipoTemplateRecursivoConfiguracion: getTipoTemplateRecursivoConfiguracion,
      saveTipoTemplateEnvioMailConfiguracion: saveTipoTemplateEnvioMailConfiguracion,
      saveTipoTemplateHabilitacionUsuarioConfiguracion: saveTipoTemplateHabilitacionUsuarioConfiguracion,
      saveTipoTemplateRecursivoConfiguracion: saveTipoTemplateRecursivoConfiguracion,
      deleteTipoTemplateConfiguracion: deleteTipoTemplateConfiguracion,

      //Autorizaciones     
      guardarAutorizacion: guardarAutorizacion,
      guardarAutorizacionTemplate: guardarAutorizacionTemplate,
      rechazarAutorizacion: rechazarAutorizacion,
      listarAutorizaciones: listarAutorizaciones,
      eliminarAutorizacionesEtapa: eliminarAutorizacionesEtapa,

      //Template
      getTemplateList: getTemplateList,
      getTemplateTituloConfigText: getTemplateTituloConfigText,
      searchTemplate: searchTemplate,
      getTemplatePendientesBySolicitudList: getTemplatePendientesBySolicitudList,
      getTemplateAllPendientesBySolicitudList: getTemplateAllPendientesBySolicitudList,
      getTemplateById: getTemplateById,
      getCargadosBySolicitudList: getCargadosBySolicitudList,
      saveTemplate: saveTemplate,
      deleteTemplate: deleteTemplate,

      //Rol
      getRolesList: getRolesList,
      getRolById: getRolById,
      saveRol: saveRol,
      deleteRol: deleteRol,

      //RolProceso
      getRolProcesoList: getRolProcesoList,
      getRolProcesoByProcesoUsuario: getRolProcesoByProcesoUsuario,

      //RolTemplate
      getRolTemplateList: getRolTemplateList,
      getRolTemplateByProcesoTemplateUsuario: getRolTemplateByProcesoTemplateUsuario,

      //Solicitud
      getSolicitudList: getSolicitudList,
      searchSolicitud: searchSolicitud,
      searchSolicitudSimple: searchSolicitudSimple,
      searchSolicitud_doc: searchSolicitud_doc,
      searchSolicitud_docSimple: searchSolicitud_docSimple,
      getSolicitudById: getSolicitudById,
      getSolicitudDefault: getSolicitudDefault,
      getSolicitudProcesoTemplateById: getSolicitudProcesoTemplateById,
      getSolicitudesByPadre: getSolicitudesByPadre,
      getSolicitudNombreCamposList: getSolicitudNombreCamposList,
      saveSolicitud: saveSolicitud,
      saveObsoleto: saveObsoleto,
      deleteSolicitud: deleteSolicitud,
      deleteSolicitudesByProceso: deleteSolicitudesByProceso,
      saveSolicitudVersion: saveSolicitudVersion,
      saveSolicitudCopia: saveSolicitudCopia,
      generarImpresionDocumentalPdf: generarImpresionDocumentalPdf,

      //SolicitudEstado
      getAnteriorEstadoSolicitud: getAnteriorEstadoSolicitud,
      getSiguienteEstadoSolicitud: getSiguienteEstadoSolicitud,
      getSolicitudEstadoSeleccionablesList: getSolicitudEstadoSeleccionablesList,

      //SolicitudEtapa
      saveSolicitudEtapa: saveSolicitudEtapa,
      saveSolicitudEtapaDerivarRes: saveSolicitudEtapaDerivarRes,
      getSolicitudEtapaDefault: getSolicitudEtapaDefault,
      getSolicitudEtapaBySolicitud: getSolicitudEtapaBySolicitud,

      //TRAZABILIDAD    
      getSolicitudTrazabilidad: getSolicitudTrazabilidad,

      //SolicitudCampoValor
      saveSolicitudCampoValor: saveSolicitudCampoValor,
      updateFileSolicitudCampoValor: updateFileSolicitudCampoValor,
      checkSolicitudCampoValor: checkSolicitudCampoValor,
      getSolicitudCampoValorCompleto: getSolicitudCampoValorCompleto,
      getSolicitudCampoValorDefault: getSolicitudCampoValorDefault,
      getSolicitudCampoValorTextosCompleto: getSolicitudCampoValorTextosCompleto,
      getSolicitudCampoValorProcesoTemplate: getSolicitudCampoValorProcesoTemplate,
      SaveSolicitudCampoValorGeneraProcesos: saveSolicitudCampoValorGeneraProcesos,
      SaveSolicitudCampoValorGeneraProcesosTemplates: saveSolicitudCampoValorGeneraProcesosTemplates,
      saveSolicitudCampoValorVersion: saveSolicitudCampoValorVersion,
      getSolicitudCampoValorMaestroDefault: getSolicitudCampoValorMaestroDefault,
      saveSolicitudCampoValorNoValidaOblig: saveSolicitudCampoValorNoValidaOblig,

      //Usuario
      getUsuarioList: getUsuarioList,
      getUsuarioById: getUsuarioById,
      getUsuarioListByProcesoEstado: getUsuarioListByProcesoEstado,
      searchUsuario: searchUsuario,
      saveClaveUsuario: saveClaveUsuario,
      saveUsuario: saveUsuario,
      deleteUsuario: deleteUsuario,

      //MenuFuncion
      checkMenuFuncion: checkMenuFuncion,

      //Reporte
      reporteTemplatesPendientesCarga: reporteTemplatesPendientesCarga,

      generateImagesPdf: generateImagesPdf,
      generateImagesPdfFromList: generateImagesPdfFromList,

      //CampoValor
      saveCampoValor: saveCampoValor,
      deleteCampoValor: deleteCampoValor,
      updateFileCampoValor: updateFileCampoValor,
      getCampoValorCompleto: getCampoValorCompleto,
      getCampoValorTextosCompleto: getCampoValorTextosCompleto,
      notificacionesCampoValor: notificacionesCampoValor,
      saveCampoValorNoValidaOblig: saveCampoValorNoValidaOblig,

      // Valores por defecto de una solicitud
      camposValorDefault: camposValorDefault,

      // Ejecuta un SP desde la vista Solicitud o Template (Gestion)
      executeProcedureRefresh: executeProcedureRefresh,

      validarProcesoMaestro: validarProcesoMaestro,

      // Valida que los documentos de tipo "SKT-TIPOPUBLICACION-OP1" tenga permisos
      generateImpresionDocumentalOtros: generateImpresionDocumentalOtros,
    }

    return service;

    //AuxParametros.
    function obtenerParametrosApp() {
      return $http.get(appConfig.apiUrl + 'AuxParametros/obtenerParametrosApp/');
    }


    //AuxParametros.
    function obtenerParametrosByIdent(Ident) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/AuxParametrosByIdent/' + Ident);
    }

    function obtenerALLParametrosByIdent(Ident) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/AuxParametrosByIdentALL/' + Ident);
    }

    //Autorizaciones.
    function listarAutorizaciones(SolicitudId, EtapaId) {
      return $http.get(appConfig.apiUrl + 'Autorizar/listarAutorizadas/' + SolicitudId + '/' + EtapaId);
    }

    function guardarAutorizacion(value) {
      return $http.post(appConfig.apiUrl + 'Autorizar', value);
    }
    function guardarAutorizacionTemplate(value) {
      return $http.post(appConfig.apiUrl + 'AutorizarTemplate', value);
    }

    function rechazarAutorizacion(value) {
      return $http.post(appConfig.apiUrl + 'RechazarAutorizacion', value);
    }

    function eliminarAutorizacionesEtapa(SolicitudId, EtapaId) {
      return $http.get(appConfig.apiUrl + 'Autorizaciones/eliminar/' + SolicitudId + '/' + EtapaId);
    }


    function convertToHex(str) {
      var hex = '';
      for (var i = 0; i < str.length; i++) {
        hex += '' + str.charCodeAt(i).toString(16);
      }
      return hex;
    }


    function checkpassword(inputtxt) {
      var passw = /^(?=.*[0-9])(?=.+[!"#$%&/()=?¡¨*:_;@^+-])(?=.+[a-zA-Z])[a-zA-Z0-9!"#$%&/()=?¡¨*:_;@^+-]{6,30}$/;
      if (inputtxt.match(passw)) {
        return true;
      }
      else {
        return false;
      }
    }
    //Seguridad
    function loginUser(user, password, language, diasVenceClave) {
      var result = convertToHex(password);
      var userL = {
        Login: user,
        Clave: btoa(result),
        diasVenceClave: Number(diasVenceClave)
      }
      var languageUI = language.slice(0, 3).toUpperCase();
      // console.log(userL);
      // Este endpoint antes de 16/10/2024 no recibìa el idioma , se envia como parametro para no modificar la entidad que maneja el endpoint en el backend
      return $http.post(appConfig.apiUrl + 'Usuario/UsuarioLogin/' + languageUI, userL);
    }

    function logoutUser(user) {
      return $http.get(appConfig.apiUrl + 'Usuario/UsuarioLogout/' + user);
    }

    //Autosolicitud
    function getAutoSolicitudById(value) {
      return $http.get(appConfig.apiUrl + 'AutoSolicitud/' + value);
    }

    function saveAutoSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'AutoSolicitud', value);
    }

    function deleteAutoSolicitud(id) {
      return $http.delete(appConfig.apiUrl + 'AutoSolicitud/' + id);
    }

    //Auto Solicitud
    function searchAutoSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'AutoSolicitud/Search', value);
    }

    //Auto Autorizar
    function getAutoAutorizarById(value) {
      return $http.get(appConfig.apiUrl + 'AutoAutorizar/' + value);
    }
    function saveAutoAutorizar(value) {
      return $http.post(appConfig.apiUrl + 'AutoAutorizar', value);
    }
    function deleteAutoAutorizar(id) {
      return $http.delete(appConfig.apiUrl + 'AutoAutorizar/' + id);
    }
    //Autosolicitud
    function searchAutoAutorizar(value) {
      return $http.post(appConfig.apiUrl + 'AutoAutorizar/Search', value);
    }


    //Aux Parametros
    function getAuxParametrosById(value) {
      return $http.get(appConfig.apiUrl + 'AuxParametros/' + value);
    }
    function saveAuxParametros(value) {
      return $http.post(appConfig.apiUrl + 'AuxParametros', value);
    }
    function deleteAuxParametros(id) {
      return $http.delete(appConfig.apiUrl + 'AuxParametros/' + id);
    }
    //Autosolicitud
    function searchAuxParametros(value) {
      return $http.post(appConfig.apiUrl + 'AuxParametros/Search', value);
    }


    //Periodo
    function getPeriodoList() {
      return $http.get(appConfig.apiUrl + 'Periodo');
    }

    //Jerarquia
    function getJerarquiaList() {
      return $http.get(appConfig.apiUrl + 'Jerarquia');
    }

    function getJerarquiaPadreList() {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Padre');
    }

    function getJerarquiaByPadreList(jerarquiaPadreId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Padre/' + jerarquiaPadreId);
    }

    function getJerarquiaById(id) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/' + id);
    }

    //Validar si el usaurio es parte de la jerarquia.
    function isUserAbleToCreateDocumentFromJerarquia(procesoId, jerarquiaValor) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/puedeCrearDocumento/' + procesoId + '/' + jerarquiaValor);
    }

    //Validar si el usuario es parte de la jerarquia filtrando por Solicitud
    function isUserAbleToCreateDocumentFromSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/puedeCrearDocumento/' + solicitudId);
    }
    //Validar si el usuario tiene marca de objeto en La vista.
    function checkIfUserTieneMarcaObsoleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/tieneMarcaObsoleto/' + solicitudId);
    }

    //Usuarios que pueden autorizar una solicitud en una etapa especifica.
    function listadoUsuariosAutorizanSolicitudEtapa(solicitudId, campoId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/listadoUsuariosAutorizanSolicitudEtapa/' + solicitudId + '/' + campoId);
    }

    //Usuarios que pueden autorizar una solicitud en una etapa especifica.
    function historialAutorizaciones(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Autorizar/listarHistorialAutorizacion/' + solicitudId);
    }

    //Obtiene La jerarquia de Autorizaciones Mediante Solicitud y campoID
    function getJerarquiaAutorizacionesById(solicitudId, campoId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Autorizaciones/' + solicitudId + '/' + campoId);
    }

    function getJerarquiaCompleta(id) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Completa/' + id);
    }

    function getJerarquiaMuestra(jerarquiaPadreId, cantidad) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/Muestra/' + jerarquiaPadreId + '/' + cantidad);
    }

    function searchJerarquia(value) {
      return $http.post(appConfig.apiUrl + 'Jerarquia/Search', value);
    }

    function searchJerarquiaByPadre(nombreJerarquia, padreId) {
      // return $http.get(appConfig.apiUrl + 'Jerarquia/SearchByPadre/' + padreId + '/' + nombreJerarquia);
      // Este endpoint fue cambiado para evitar las palabras reservadas por el sistema  en el backend y que tome lo que se envia como un string
      return $http.get(appConfig.apiUrl + 'Jerarquia/SearchByPadre/' + padreId + '?jerarquiaNombre=' + nombreJerarquia);
    }

    function validarJerarquiaTienePadre(jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/TienePadre/' + jerarquiaId);
    }

    function saveJerarquia(value) {
      return $http.post(appConfig.apiUrl + 'Jerarquia', value);
    }

    function deleteJerarquia(id) {
      return $http.delete(appConfig.apiUrl + 'Jerarquia/' + id);
    }

    function getJerarquiaProcesoCampos(procesoId, jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Jerarquia/getJerarquiaProcesoCampos/' + procesoId + "/" + jerarquiaId);
    }

    function getPermisosUsuarioJerarquia(userId) {
      // Este endpoint valida si un usuario tiene los permisos para editar una Jerarquía, estos permisos se establecen en el parametro "USRUPDATEJERARQUIA" de Kahuna
      return $http.get(appConfig.apiUrl + 'Usuario/EditaJerarquia/' + userId)
    }

    //Campo
    function getCampoList() {
      return $http.get(appConfig.apiUrl + 'Campo');
    }

    function getCampoListLigth() {
      return $http.get(appConfig.apiUrl + 'CamposLigth');
    }

    function getCampo(id) {
      return $http.get(appConfig.apiUrl + 'Campo/' + id);
    }

    function getCampoListByTemplate(templateId) {
      return $http.get(appConfig.apiUrl + 'Campo/Template/' + templateId);
    }

    function getCamposLigthByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Campo/CamposLigthByProceso/' + procesoId);
    }

    function searchCampo(value) {
      return $http.post(appConfig.apiUrl + 'Campo/Search', value);
    }

    function saveCampo(value) {
      return $http.post(appConfig.apiUrl + 'Campo', value);
    }

    function deleteCampo(id) {
      return $http.delete(appConfig.apiUrl + 'Campo/' + id);
    }

    //Tipo Campo Solicitud
    function getTipoCampoSolicitudList() {
      return $http.get(appConfig.apiUrl + 'TipoCampoSolicitud');
    }

    //CampoTipo
    function getCampoTipoList() {
      return $http.get(appConfig.apiUrl + 'CampoTipo');
    }

    //Guardar Valores de Campo TABLEENR 
    function saveCampoValorGrillaFilas(value) {
      return $http.post(appConfig.apiUrl + 'CampoValorGrillaFilas', value);
    }

    //Proceso
    function updateFilters(procesoId) {
      return $http.get(appConfig.apiUrl + 'updateFilters/' + procesoId);
    }

    function getProcesoList() {
      return $http.get(appConfig.apiUrl + 'Proceso');
    }

    function getProcesoByGrupo(grupoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/Grupo/' + grupoId);
    }

    function getProcesoDefault() {
      return $http.get(appConfig.apiUrl + 'Proceso/Default');
    }

    function searchProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/Search', value);
    }
    function searchProceso_doc(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/Search_doc', value);
    }
    function searchProceso_nodoc(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/Search_nodoc', value);
    }

    function searchProcesoTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchTemplates', value);
    }

    function searchProcesoUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchUsuarios', value);
    }

    function searchUsuariosdeUnProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/SearchUsuariosdeUnProceso', value);
    }

    function getProcesoTituloConfigText(value) {
      return $http.post(appConfig.apiUrl + 'Proceso/GetTituloConfigText', value);
    }

    function getProcesoById(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/' + id);
    }

    function getProcesoInSolicitud(id) {
      return $http.get(appConfig.apiUrl + 'ProcesoInSolicitud/' + id);
    }

    function getProcesoSolicitudGrid(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/SolicitudGrid/' + id);
    }

    function getProcesoTemplateById(id) {
      return $http.get(appConfig.apiUrl + 'Proceso/ProcesoTemplate/' + id);
    }

    function getProcesoUsuarioListByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/UsuariosProceso/' + procesoId);
    }

    function getProcesoHijoSeleccionableList(grupoId, procesoPadreId) {
      return $http.get(appConfig.apiUrl + 'Proceso/ProcesosHijoSeleccionables/' + grupoId + '/' + procesoPadreId);
    }

    function saveProceso(value) {
      return $http.post(appConfig.apiUrl + 'Proceso', value);
    }

    function deleteProceso(id) {
      return $http.delete(appConfig.apiUrl + 'Proceso/' + id);
    }

    function uploadImageFileProceso(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'Proceso/UploadProcesoImage',
        data: {
          file: file
        }
      });
    }

    //searchTemplatesByProceso
    function searchTemplatesByProceso(procesoId) {
      return $http.get(appConfig.apiUrl + 'Proceso/SearchTemplatesByProceso/' + procesoId);
    }
    function executeProcedure(solicitudId, nombreProcedure) {
      return $http.post(appConfig.apiUrl + 'Proceso/' + solicitudId + "/" + nombreProcedure);
    }
    function SearchTemplatesByProcesoJerarquia(procesoId, jerarquiaId) {
      return $http.get(appConfig.apiUrl + 'Proceso/SearchTemplatesByProcesoJerarquia/' + procesoId + '/' + jerarquiaId);
    }
    //Grupo
    function getGrupoList() {
      return $http.get(appConfig.apiUrl + 'Grupo');
    }

    function getGrupoHomeList() {
      return $http.get(appConfig.apiUrl + 'Grupo/Home');
    }

    function getGrupoByProcesoPadreList(procesoPadreId) {
      return $http.get(appConfig.apiUrl + 'Grupo/ProcesoPadre/' + procesoPadreId);
    }

    function getGrupoById(id) {
      return $http.get(appConfig.apiUrl + 'Grupo/' + id);
    }

    function searchGrupo(value) {
      return $http.post(appConfig.apiUrl + 'Grupo/Search', value);
    }

    function saveGrupo(value) {
      return $http.post(appConfig.apiUrl + 'Grupo', value);
    }

    function deleteGrupo(id) {
      return $http.delete(appConfig.apiUrl + 'Grupo/' + id);
    }

    function uploadImageFileGrupo(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'Grupo/UploadGrupoImage',
        data: {
          file: file
        }
      });
    }


    //Grupos Usuarios
    function getGruposUsuariosList() {
      return $http.get(appConfig.apiUrl + 'Grupo');
    }

    function getGruposUsuariosById(id) {
      return $http.get(appConfig.apiUrl + 'GruposUsuarios/' + id);
    }

    function searchGruposUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'GruposUsuarios/Search', value);
    }

    function saveGruposUsuarios(value) {
      return $http.post(appConfig.apiUrl + 'GruposUsuarios', value);
    }

    function deleteGruposUsuarios(id) {
      return $http.delete(appConfig.apiUrl + 'GruposUsuarios/' + id);
    }

    function userInGroup(grupoId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'GruposUsuarios/UserInGroup/' + grupoId + '/' + usuarioId);
    }

    //TipoTemplate
    function getTipoTemplateList() {
      return $http.get(appConfig.apiUrl + 'TipoTemplate');
    }

    function getTipoTemplateEnvioMailConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/EnvioMail/' + templateId);
    }

    function getTipoTemplateHabilitacionUsuarioConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/HabilitacionUsuario/' + templateId);
    }

    function getTipoTemplateRecursivoConfiguracion(templateId) {
      return $http.get(appConfig.apiUrl + 'TipoTemplate/Configuracion/Recursivo/' + templateId);
    }

    function saveTipoTemplateEnvioMailConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/EnvioMail', value);
    }

    function saveTipoTemplateHabilitacionUsuarioConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/HabilitacionUsuario', value);
    }

    function saveTipoTemplateRecursivoConfiguracion(value) {
      return $http.post(appConfig.apiUrl + 'TipoTemplate/Configuracion/Recursivo', value);
    }

    function deleteTipoTemplateConfiguracion(templateId) {
      return $http.delete(appConfig.apiUrl + 'TipoTemplate/Configuracion/' + templateId);
    }

    //Template
    function getTemplateList() {
      return $http.get(appConfig.apiUrl + 'Template');
    }

    function getTemplateTituloConfigText(value) {
      return $http.post(appConfig.apiUrl + 'Template/GetTituloConfigText', value);
    }

    function searchTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Template/Search', value);
    }

    function getTemplatePendientesBySolicitudList(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Template/Pendientes/' + solicitudId);
    }

    function getTemplateAllPendientesBySolicitudList(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Template/AllPendientes/' + solicitudId);
    }

    function getTemplateById(id) {
      return $http.get(appConfig.apiUrl + 'Template/' + id);
    }

    function getCargadosBySolicitudList(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Cargadas', value);
    }

    function saveTemplate(value) {
      return $http.post(appConfig.apiUrl + 'Template', value);
    }

    function deleteTemplate(id) {
      return $http.delete(appConfig.apiUrl + 'Template/' + id);
    }

    //Rol
    function getRolesList() {
      return $http.get(appConfig.apiUrl + 'Rol');
    }

    function getRolById(id) {
      return $http.get(appConfig.apiUrl + 'Rol/' + id);
    }

    function saveRol(value) {
      return $http.post(appConfig.apiUrl + 'Rol', value);
    }

    function deleteRol(id) {
      return $http.delete(appConfig.apiUrl + 'Rol/' + id);
    }

    //RolProceso
    function getRolProcesoList() {
      return $http.get(appConfig.apiUrl + 'RolProceso');
    }

    function getRolProcesoByProcesoUsuario(solicitudId, procesoId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'RolProceso/ProcesoUsuario/' + solicitudId + '/' + procesoId + '/' + usuarioId);
    }

    //RolTemplate
    function getRolTemplateList() {
      return $http.get(appConfig.apiUrl + 'RolTemplate');
    }

    function getRolTemplateByProcesoTemplateUsuario(solicitudId, procesoTemplateId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'RolTemplate/ProcesoTemplateUsuario/' + solicitudId + '/' + procesoTemplateId + '/' + usuarioId);
    }

    //Solicitud
    function getSolicitudList() {
      return $http.get(appConfig.apiUrl + 'Solicitud');
    }

    function searchSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search', value);
    }

    function searchSolicitudSimple(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search/Simple', value);
    }

    function searchSolicitud_doc(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search_doc', value);
    }

    function searchSolicitud_docSimple(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/Search_doc/Simple', value);
    }

    function getSolicitudById(id) {
      return $http.get(appConfig.apiUrl + 'Solicitud/' + id);
    }

    function getSolicitudDefault(proceso, solicitudPadreId) {
      return $http.get(appConfig.apiUrl + 'Solicitud/GetNewSolicitud/' + proceso + '/' + solicitudPadreId);
    }

    function getSolicitudesByPadre(solicitudId, verTodos) {
      return $http.get(appConfig.apiUrl + 'Solicitud/Padre/' + solicitudId + '/' + verTodos);
    }

    function getSolicitudNombreCamposList() {
      return $http.get(appConfig.apiUrl + 'Solicitud/NombreCampos');
    }

    function saveSolicitud(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud', value);
    }

    function saveObsoleto(value) {
      return $http.post(appConfig.apiUrl + 'Solicitud/obsoleto', value);
    }

    function saveSolicitudVersion(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCrearVersion', value);
    }

    function saveSolicitudCopia(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCopia', value);
    }


    function deleteSolicitud(id) {
      return $http.delete(appConfig.apiUrl + 'Solicitud/' + id);
    }

    function deleteSolicitudesByProceso(procesoId) {
      return $http.delete(appConfig.apiUrl + 'Solicitud/Proceso/' + procesoId);
    }

    function getSolicitudProcesoTemplateById(solicitudProcesoTemplateId) {
      return $http.get(appConfig.apiUrl + 'Solicitud/SolicitudProcesoTemplate/' + solicitudProcesoTemplateId);
    }
    function generarImpresionDocumentalPdf(solicitudId, procesoId) {
      return $http.get(appConfig.apiUrl + 'Reporte/generateImpresionDocumentalPdf' + '/'+ solicitudId + '/' + procesoId);
    }

    //SolicitudEstado
    function getAnteriorEstadoSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/AnteriorEstado/' + solicitudId);
    }

    function getSiguienteEstadoSolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/SiguienteEstado/' + solicitudId);
    }

    function getSolicitudEstadoSeleccionablesList() {
      return $http.get(appConfig.apiUrl + 'SolicitudEstado/Seleccionables');
    }


    //SolicitudEtapa     
    function saveSolicitudEtapa(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudEtapa', value);
    }

    function saveSolicitudEtapaDerivarRes(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudEtapaDerivar', value);
    }

    function getSolicitudEtapaDefault() {
      return $http.get(appConfig.apiUrl + 'SolicitudEtapa/GetDefault');
    }

    function getSolicitudEtapaBySolicitud(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudEtapa/Solicitud/' + solicitudId);
    }

    function getSolicitudTrazabilidad(procesoId, solicitudId, numero) {
      return $http.get(appConfig.apiUrl + 'Trazabilidad' + '/' + procesoId + '/' + solicitudId + '/' + numero);
    }

    //SolicitudCampoValor
    function getSolicitudCampoValorCompleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresCompletos/' + solicitudId);
    }

    function getSolicitudCampoValorDefault(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/Default', value);
    }

    function getSolicitudCampoValorMaestroDefault(solicitud, maestroCodigo) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/DefaultEsMaestro/' + maestroCodigo, solicitud);
    }

    function saveSolicitudCampoValorNoValidaOblig(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValorNoValidaOblig', value);
    }

    function getSolicitudCampoValorTextosCompleto(solicitudId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresTextosCompletos/' + solicitudId);
    }

    function getSolicitudCampoValorProcesoTemplate(solicitudId, procesoTemplateId) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresProcesoTemplate/' + solicitudId + '/' + procesoTemplateId);
    }

    function checkSolicitudCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/ChequearValores', value);
    }

    function saveSolicitudCampoValorGeneraProcesos(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/generaprocesos', value);
    }

    function saveSolicitudCampoValorGeneraProcesosTemplates(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor/generaprocesostemplates', value);
    }

    function saveSolicitudCampoValor(value) {
      value.generaProcesos = true;
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValor', value);
    }

    function saveSolicitudCampoValorVersion(value) {
      return $http.post(appConfig.apiUrl + 'SolicitudCampoValorVersion', value);
    }


    function updateFileSolicitudCampoValor(file, campoId, solicitudId, ip, dispositivo, qrPage, qrPosX, qrPosY, qrSize) {
      return Upload.upload({
        url: appConfig.apiUrl + 'SolicitudCampoValor/UploadFile',
        data: {
          file: file,
          campoId: campoId,
          solicitudId: solicitudId,
          ip: ip,
          dispositivo: dispositivo,
          qrPage: qrPage,
          qrPosX: qrPosX,
          qrPosY: qrPosY,
          qrSize: qrSize
        }
      });
    }

    //Usuario
    function getUsuarioList() {
      return $http.get(appConfig.apiUrl + 'Usuario');
    }

    function getUsuarioById(id) {
      return $http.get(appConfig.apiUrl + 'Usuario/' + id);
    }

    function getUsuarioListByProcesoEstado(procesoId, solicitudId, solicitudEstadoId) {
      return $http.get(appConfig.apiUrl + 'Usuario/ProcesoEstado/' + procesoId + '/' + solicitudId + '/' + solicitudEstadoId);
    }

    function searchUsuario(value) {
      return $http.post(appConfig.apiUrl + 'Usuario/Search', value);
    }

    function saveClaveUsuario(value, userToken) {
      if (userToken) {
        // Si se envìa un token, es porque se está haciendo un cambio de contraseña desde la vista login
        var config = {
          headers: { Authorization: 'Bearer' + ' ' + userToken }
        }

        return $http.post(appConfig.apiUrl + 'Usuario/Clave', value, config);
      } else {
        return $http.post(appConfig.apiUrl + 'Usuario/Clave', value);
      }
    }

    function saveUsuario(value) {
      return $http.post(appConfig.apiUrl + 'Usuario', value);
    }

    function deleteUsuario(id) {
      return $http.delete(appConfig.apiUrl + 'Usuario/' + id);
    }

    //MenuFuncion
    function checkMenuFuncion(codFuncion) {
      return $http.get(appConfig.apiUrl + 'MenuFuncion/Validar/' + codFuncion);
    }

    //Reporte
    function reporteTemplatesPendientesCarga(value) {
      return $http.post(appConfig.apiUrl + 'Reporte/GetTemplatesPendientesCarga', value);
    }


    function generateImagesPdf(solicitudId) {
      return $http.get(appConfig.apiUrl + 'Reporte/generateImagesPdf/' + solicitudId);
    }

    function generateImagesPdfFromList(solicitudId) {
      // Este endpoint hace exactamente lo mismo que "generateImagesPdf" con la única diferencia de que si no encuentra el PDF en reporting services, lo crea y permite visualizarlo. (Este endpoint sólo se llama en "solicitud/list.component")
      return $http.get(appConfig.apiUrl + 'Reporte/generateImagesPdfVer/' + solicitudId);
    }

    //CampoValor
    function getCampoValorCompleto(solicitudProcesoTemplateId, solicitudId, solicitudEstadoId, procesoTemplateId, templateId) {
      return $http.get(appConfig.apiUrl + 'CampoValor/ValoresCompletos/' + solicitudProcesoTemplateId + '/' + solicitudId + '/' + solicitudEstadoId + '/' + procesoTemplateId + '/' + templateId);
    }

    function getCampoValorTextosCompleto(solicitudProcesoTemplateId, solicitudId, solicitudEstadoId, procesoTemplateId, templateId) {
      return $http.get(appConfig.apiUrl + 'CampoValor/ValoresTextosCompletos/' + solicitudProcesoTemplateId + '/' + solicitudId + '/' + solicitudEstadoId + '/' + procesoTemplateId + '/' + templateId);
    }

    function notificacionesCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'CampoValor/Notificaciones', value);
    }

    function saveCampoValor(value) {
      return $http.post(appConfig.apiUrl + 'CampoValor', value);
    }

    function deleteCampoValor(solicitudProcesoTemplateId) {
      return $http.delete(appConfig.apiUrl + 'CampoValor/' + solicitudProcesoTemplateId);
    }

    function updateFileCampoValor(file) {
      return Upload.upload({
        url: appConfig.apiUrl + 'CampoValor/UploadFile',
        data: {
          file: file
        }
      });
    }

    function camposValorDefault(codigoJerarq) {
      return $http.get(appConfig.apiUrl + 'SolicitudCampoValor/ValoresSolicitudQR/' + codigoJerarq);
    }

    function saveCampoValorNoValidaOblig(value) {
      return $http.post(appConfig.apiUrl + 'CampoValorNoValidaOblig', value);
    }

    // AccesosUrl
    function getAccesosURL(usuarioId, urlBase64) {
      return $http.get(appConfig.apiUrl + 'AccesosURL?usuarioId=' + usuarioId + '&url=' + urlBase64);
    }

    function searchAccesosUrl(value) {
      return $http.post(appConfig.apiUrl + 'AccesosURL/search', value);
    }

    function getAccesoUrlById(id) {
      return $http.get(appConfig.apiUrl + 'AccesosURL/' + id);
    }

    function saveAccesosUrl(value) {
      return $http.post(appConfig.apiUrl + 'AccesosURL', value);
    }

    function updateAccesosUrl(id, value) {
      return $http.put(appConfig.apiUrl + 'AccesosURL/' + id, value);
    }

    function deleteAccesosUrl(idUrl) {
      return $http.delete(appConfig.apiUrl + 'AccesosURL/' + idUrl);
    }

    // Execute SP at Solicitud or Template (Gestion) 
    function executeProcedureRefresh(nombreProcedure, solicitudId, solicitudProcesoTemplateId) {
      return $http.post(appConfig.apiUrl + 'Proceso/' + nombreProcedure + '/' + solicitudId + '/' + solicitudProcesoTemplateId);
    }

    // Valida si el proceso es maestro en el listado de solicitudes
    function validarProcesoMaestro(procesoId, valor) {
      return $http.get(appConfig.apiUrl + 'Solicitud/' + procesoId + '/' + valor);
    }

    // Valida que los documentos de tipo "SKT-TIPOPUBLICACION-OP1" tenga permisos
    function generateImpresionDocumentalOtros(solicitudId, usuarioId) {
      return $http.get(appConfig.apiUrl + 'Reporte/generateImpresionDocumentalOtros/' + solicitudId + '/' + usuarioId);
    }
  }
})();
(function() {
  'use strict';

  angular.module('Kahuna.pages.services').service('localStorage', localStorage);

  /** @ngInject */
  function localStorage($window) {
    var service = {
      set: set,
      get: get,
      setObject: setObject,
      getObject: getObject,
      clear: clear
    }

    return service;

    function set(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = value;
      } else {
        $window.localStorage[key] = value;
      }
    }

    function get(key, defaultValue) {
      return !$window.fakeLocalStorage ? $window.localStorage[key] || defaultValue : $window.fakeLocalStorage[key] || defaultValue;
    }

    function setObject(key, value) {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage[key] = angular.toJson(value);
      } else {
        $window.localStorage[key] = angular.toJson(value);
      }
    }

    function getObject(key) {
      return !$window.fakeLocalStorage ? angular.fromJson($window.localStorage[key] || '{}') : angular.fromJson($window.fakeLocalStorage[key] || '{}');
    }

    function clear() {
      if ($window.fakeLocalStorage) {
        $window.fakeLocalStorage = {};
      } else {
        $window.localStorage.clear();
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('Kahuna.pages.services').service('sharedService', sharedService);

  /** @ngInject */
  function sharedService(appConfig, localStorage, $state, dataService, toastr, $uibModal) {

    var lSuperAdminId = 1;
    var service = {
      getInactivityTimeKey: getInactivityTimeKey,
      setInactivityTime: setInactivityTime,

      getLanguage: getLanguage,
      getExpiredPasswordDays: getExpiredPasswordDays,

      getAssetsUrl: getAssetsUrl,
      getSystemVersion: getSystemVersion,
      getGenericErrorMessage: getGenericErrorMessage,

      //PowerbiReport
      getPowerbiReport: getPowerbiReport,

      getLoggedUser: getLoggedUser,
      getLoggedUserPermisos: getLoggedUserPermisos,
      setLoggedUser: setLoggedUser,
      setLoggedUserPermisos: setLoggedUserPermisos,
      isSysAdminLoggedUser: isSysAdminLoggedUser,
      isSuperAdminLoggedUser: isSuperAdminLoggedUser,
      isSuperAdminLoggedUserId: isSuperAdminLoggedUserId,
      isSuperAdminLoggedActivateAddProcess: isSuperAdminLoggedActivateAddProcess,
      getLocalData: getLocalData,
      setLocalData: setLocalData,
      clearLocalData: clearLocalData,
      clearLocalStorage: clearLocalStorage,

      replaceAll: replaceAll,
      RGB2Hex: RGB2Hex,
      getArrayColors: getArrayColors,

      addThousandSeparator: addThousandSeparator,

      checkEmailFormat: checkEmailFormat,

      formatDate: formatDate,
      convertDate: convertDate,
      formatDateForGetUrl: formatDateForGetUrl,
      uniqById: uniqById,
      arrayToObjProp: arrayToObjProp,
      startWith: startWith,
      contains: contains,

      // setUrlIframe: setUrlIframe,

      showLoading: showLoading,
      closeLoading: closeLoading,

      openVisorDocumental: openVisorDocumental,

      getActiveTabSolicitud: getActiveTabSolicitud,
      setActiveTabSolicitud: setActiveTabSolicitud,

      getMaestroCodigo: getMaestroCodigo,
      setMaestroCodigo: setMaestroCodigo,

      getSolicitudEstadoId: getSolicitudEstadoId

      // getIframeSolicitudActivo: getIframeSolicitudActivo,
      // setIframeSolicitudActivo: setIframeSolicitudActivo,

      // setIsBusyIframe: setIsBusyIframe,
      // getIsBusyIframe: getIsBusyIframe,

      // getFirstSaveSolicitud: getFirstSaveSolicitud,
      // setFirstSaveSolicitud: setFirstSaveSolicitud,

      // Gestiones/Template en una solicitud
      // getModalGestionesOpen: getModalGestionesOpen,
      // setModalGestionesOpen: setModalGestionesOpen,
    }

    return service;

    function getInactivityTimeKey() {
      return 'inactivityTime';
    }

    function setInactivityTime(value) {
      localStorage.setObject('inactivityTime', value);
    }

    function getLanguage() {
      return appConfig.idioma.toLowerCase().trim();
    }

    function getExpiredPasswordDays() {
      return appConfig.diasVenceClave.trim();
    }

    function showLoading() {
      var language = getLanguage();
      var modalText;

      if (language == "español")
        modalText = "Cargando...";
      else if (language == "ingles")
        modalText = "Loading...";
      else if (language == "portugues")
        modalText = "Carregando...";
      else if (language == "italiano")
        modalText = "Cargando...";

      Swal.fire({
        title: '',
        text: modalText,
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: function () {
          swal.showLoading();
        }
      })
        .then(function (result) { });
    }

    function closeLoading() {
      swal.close();
    }

    /*este filtro permite sacar resultados de un array mediante una propiedad,  si la propiedad empieza por.. */
    function startWith(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) {
          if (arr[i][prop].toLowerCase().startsWith(valueProp.toLowerCase())) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }

    function contains(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) {
          if (String(arr[i][prop]).toLowerCase().includes(String(valueProp).toLowerCase())) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }


    /*este filtro permite sacar resultados de un array mediante una propiedad,  si la propiedad es igual a valueProp*/
    function uniqById(arr, prop, valueProp) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        if (!obj[arr[i][prop]]) {
          if (arr[i][prop] == valueProp) {
            obj[arr[i][prop]] = arr[i];
          }
        }
      }
      var newArr = [];
      for (var key in obj) {
        newArr.push(obj[key]);
      }
      return newArr;
    }

    /*Sirve para sacar  de un array una propiedad y su valor PropValue y devolver un OBJ*/
    function arrayToObjProp(arr, prop, propValue) {
      var obj = {};
      for (var i = 0, len = arr.length; i < len; i++) {
        obj[arr[i][prop]] = arr[i][propValue];
      }
      return obj;
    }

    //PowerBI Report
    function getPowerbiReport(params) {
      // var credentials = btoa(appConfig.username + ':' + appConfig.password);
      /* PowerBI Report Server requiere las credenciales con base 64, la función btoa() convierte un texto a base64 */

      if (appConfig.powerbiReport != '') {
        return appConfig.powerbiReport + params;
      }

      return appConfig.powerbiReport;

      // return $.ajax({
      //   method: 'GET',
      //   url: appConfig.powerbiReport + params,
      //   headers: {
      //     'Authorization': `Basic ${credentials}`
      //   }
      // })
      //   .done(function (data) {
      //     console.log(data)
      //     var blob = new Blob([data], {type: 'text/html'});
      //     var newUrl = URL.createObjectURL(blob);
      //     return newUrl;
      //   })
      //   .catch(function (error) {
      //     console.log('ERROR ENVIANDO LA PETICIÓN PARA POWERBI');
      //     console.error(error)
      //   })
    }

    function getAssetsUrl() {
      // return '/Kahuna.Web/assets/'; 
      return '/assets/'; //Local & Production
    }

    function getSystemVersion() {
      return appConfig.release;
    }

    function getGenericErrorMessage(error) {
      $state.go('auth');

      var language = getLanguage();
      var error401Text, genericErrorText;

      if (language == "español") {
        error401Text = "Este usuario ha iniciado sesión en otro dispositivo.";
        genericErrorText = "Tiene problemas de conexión de red, Por favor ingrese nuevamente.";
      }
      else if (language == "ingles") {
        error401Text = "This user has logged in on another device.";
        genericErrorText = "You are experiencing network connectivity issues. Please log in again.";
      }
      else if (language == "portugues") {
        error401Text = "Este usuário está conectado em outro dispositivo.";
        genericErrorText = "Você tem problemas de conexão de rede, faça login novamente.";
      }
      else if (language == "italiano") {
        error401Text = "Este usuario ha iniciado sesión en otro dispositivo.";
        genericErrorText = "Tiene problemas de conexión de red, Por favor ingrese nuevamente.";
      }

      if (error.status == 401) return error401Text;
      else return genericErrorText;
    }

    function getLoggedUser() {
      return localStorage.getObject('dataUser_kahuna');
    }

    function setLoggedUser(user) {
      localStorage.setObject('dataUser_kahuna', user);
    }

    function getLocalData(key) {
      return localStorage.getObject(key);
    }

    function setLocalData(key, data) {
      localStorage.setObject(key, data);
    }

    function clearLocalData(usuarioId) {
      localStorage.setObject("BUSQUEDA_SOLICITUDES_" + usuarioId, null);
    }

    function clearLocalStorage() {
      localStorage.clear();
    }

    function isSysAdminLoggedUser() {
      var authData = getLoggedUser();

      if (authData != null && authData.Id > 0) {
        for (var i = 0; i < authData.Roles.length; i++) {
          if (authData.Roles[i].Rol.EsSysAdmin)
            return true;
        }
      }

      return false;
    }

    function isSuperAdminLoggedUser() {
      var authData = getLoggedUser();
      // console.log(authData.Id);
      if (authData != null && authData.Id > 0) {
        for (var i = 0; i < authData.Roles.length; i++) {
          if (authData.Roles[i].Rol.Id == lSuperAdminId)
            return true;
        }
      }

      return false;
    }

    function isSuperAdminLoggedActivateAddProcess() {
      var authData = getLoggedUser();
      if (authData != null && authData.Id > 0) {
        if (authData.Login.toLowerCase() == 'superadmin')
          return true;
      }

      return false;
    }


    function isSuperAdminLoggedUserId() {
      var authData = getLoggedUser();
      // console.log(authData.Id);
      if (authData.Id == lSuperAdminId) {
        return true;
      }
      return false;
    }

    function replaceAll(text, search, replacement) {
      if (text != null)
        return text.split(search).join(replacement);

      return "";
    };

    function addThousandSeparator(nStr) {
      if (nStr == null)
        nStr = "";

      nStr = replaceAll(nStr, ",", "");
      var x = nStr.split(',');
      var x1 = x[0];
      var x2 = x.length > 1 ? ',' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }

    function RGB2Hex(rgb) {
      var sep = rgb.indexOf(",") > -1 ? "," : " ";
      rgb = rgb.substr(4).split(")")[0].split(sep);
      var r = (+rgb[0]).toString(16),
        g = (+rgb[1]).toString(16),
        b = (+rgb[2]).toString(16);

      if (r.length == 1)
        r = "0" + r;
      if (g.length == 1)
        g = "0" + g;
      if (b.length == 1)
        b = "0" + b;

      return "#" + r + g + b;
    }

    function getArrayColors(cadena) {
      var regexp = /(#([\da-f]{3}){1,2}|(rgb|hsl)a\((\d{1,3}%?,\s?){3}(1|0?\.\d+)\)|(rgb|hsl)\(\d{1,3}%?(,\s?\d{1,3}%?){2}\))/g;
      //var array = [...cadena.matchAll(regexp)];
      var results = [];
      var obj = cadena.matchAll(regexp);
      var array = Array.from(obj, function (x) { return x[0] });
      // console.log(array);
      return array;
    }



    function getLoggedUserPermisos(callback) {
      return localStorage.getObject('dataPermisos_kahuna');
    }

    function setLoggedUserPermisos(permisos) {
      localStorage.setObject('dataPermisos_kahuna', permisos);
    }

    function formatDate(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      var d = new Date(inputDate);
      var r = new Date([pad(d.getMonth() + 1), pad(d.getDate()), d.getFullYear()].join('/'));

      // console.log('formatDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function convertDate(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      inputDate = inputDate.toString().replace(new RegExp('-', 'g'), '/');

      var split = inputDate.split('/');
      var r = new Date([split[1], split[0], split[2]].join('/'));

      // console.log('convertDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function formatDateForGetUrl(inputDate) {
      function pad(s) { return (s < 10) ? '0' + s : s; }

      if (inputDate == null)
        return null;

      var d = new Date(inputDate);
      var r = [pad(d.getDate()), pad(d.getMonth() + 1), d.getFullYear()].join('-');

      // console.log('formatDate -> Original: ' + inputDate + ' || Resultado: ' + r);
      return r;
    }

    function checkEmailFormat(email) {
      var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    }

    // ************************** PRIMER VERSION DEL VISOR DOCUMENTAL **************************
    // function validarPermisosVisorDocumental(itemAValidar) {
    //   if (itemAValidar.ver) {
    //     if (itemAValidar.urlProcesoLink.includes('kahuna.biz')) {
    //       // Si se accede a un servidor de Reporting Services
    //       if (itemAValidar.urlProcesoLink.includes('?')) {
    //         // si la url ya tiene parámetros
    //         return (itemAValidar.imprimir)
    //             ? '&rs:embed=true&rc:toolbar=true'
    //             : '&rs:embed=true&rc:toolbar=false'
    //       } else {
    //         // Si no tiene, se le añaden
    //         return (itemAValidar.imprimir)
    //           ? '?rs:embed=true&rc:toolbar=true'
    //           : '?rs:embed=true&rc:toolbar=false'
    //       }
    //     } else 
    //       return '';
    //   } else 
    //     return '';
    // }

    // function validarTipoDeLink(link, permisos, fileName) {
    //   if (link.includes('vimeo')) {
    //     window.open(link, '', "width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no")
    //   } else if (link.includes('Kahuna.Api/uploads' || 'Kahuna.Api/Images')) {
    //     // Si el link se aloja en el backend
    //     // console.log(link);
    //     window.open(link + fileName, '_blank')
    //   } else {
    //     setUrlIframe(link + fileName + permisos);
    //     window.open('/accesoUrl.html', '', 'width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no');
    //   }
    // }

    // function openVisorDocumental(usuarioLogueadoId, urlBase64, fileName) {
    //   var permisos = '';
    //   var usuarioDefault = 0;

    //   dataService.getAccesosURL(usuarioLogueadoId, urlBase64)
    //     .then(function(response) {
    //       if (response.data.Success) {
    //         // console.log('usuario valido');
    //         // console.log(response.data);
    //         // console.log(permisos);

    //         if (response.data.Value && response.data.Value.ver) {
    //           permisos = validarPermisosVisorDocumental(response.data.Value);
    //           validarTipoDeLink(response.data.Value.urlProcesoLink, permisos, fileName);
    //         }
    //         else 
    //           toastr.info('Usuario no autorizado para visualizar esta información');

    //       } else {
    //         // console.log('usuario default');
    //         dataService.getAccesosURL(usuarioDefault, urlBase64)
    //           .then(function (response) {
    //             if (response.data.Success) {
    //               // console.log(response.data);
    //               // console.log(permisos);

    //               if (response.data.Value && response.data.Value.ver) {
    //                 permisos = validarPermisosVisorDocumental(response.data.Value);
    //                 validarTipoDeLink(response.data.Value.urlProcesoLink, permisos, fileName);
    //               }
    //               else 
    //                 toastr.info('Usuario no autorizado para visualizar esta información');

    //             } else {
    //               toastr.info('Esta información no se encuentra disponible por el momento');
    //               // console.log(response.data);
    //               return;
    //             }
    //           })
    //       }
    //     })
    // }

    // ************************** SEGUNDA VERSION DEL VISOR DOCUMENTAL **************************
    // function validarPermisosReportVisorDocumental(urlProcesoLink, userPermissions) {
    //   if (userPermissions.verURL) {
    //     if (urlProcesoLink.includes('kahuna.biz') || urlProcesoLink.includes('wkhn-madrid')) {
    //       // Si se accede a un servidor de Reporting Services
    //       if (urlProcesoLink.includes('?')) {
    //         // si la url ya tiene parámetros
    //         return (userPermissions.imprimirURL)
    //             ? '&rs:embed=true&rc:toolbar=true'
    //             : '&rs:embed=true&rc:toolbar=false'
    //       } else {
    //         // Si no tiene, se le añaden
    //         return (userPermissions.imprimirURL)
    //           ? '?rs:embed=true&rc:toolbar=true'
    //           : '?rs:embed=true&rc:toolbar=false'
    //       }
    //     } else 
    //       return '';
    //   } else 
    //     return '';
    // }

    // function validarTipoDeLink(link, permisos, fileName) {
    //     if (fileName != null) {
    //       // Si el fileName no es null, significa que el proceso es documental por lo que hay que validar la carpeta y añadir el nombre del archivo antes de abrir visor
    //       if (link.includes('vimeo') || link.includes('youtube.com') || link.includes('youtu.be')) {
    //         window.open(link, '', "width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no")
    //       } else if (link.includes('Kahuna.Api/uploads' || 'Kahuna.Api/Images')) {
    //         // Si el link se aloja en el backend
    //         window.open(link + fileName, '_blank')
    //       } else {
    //         $uibModal.open({
    //           animation: true,
    //           component: "modalVisor",
    //           windowClass: "modal-visor",
    //           openedClass: "overflow-hidden",
    //           resolve: {
    //             url: function () {
    //               return link + fileName + permisos;
    //             }
    //           }
    //         });
    //         // setUrlIframe(link + fileName + permisos);
    //         // window.open('/accesoUrl.html', '', 'width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no');
    //       }
    //     } else {
    //       if (link.includes('vimeo') || link.includes('youtube.com') || link.includes('youtu.be')) {
    //         window.open(link, '', "width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no")
    //       } else if (link.includes('Kahuna.Api/uploads' || 'Kahuna.Api/Images')) {
    //         window.open(link, '_blank')
    //       } else {
    //         $uibModal.open({
    //           animation: true,
    //           component: "modalVisor",
    //           windowClass: "modal-visor",
    //           openedClass: "overflow-hidden",
    //           resolve: {
    //             url: function () {
    //               return link + permisos;
    //             }
    //           }
    //         });
    //         // setUrlIframe(link + permisos);
    //         // window.open('/accesoUrl.html', '', 'width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no');
    //       }
    //     }
    //   }

    // function openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, procesoDelLink) {
    //   var permisos = '';
    //   var userDefault = null;
    //   var userLogged = null;

    //     dataService.getAccesosURL(usuarioLogueadoId, urlBase64)
    //       .then(function(response) {
    //         if (response.data.Success) {

    //           if (response.data.Value != null) {
    //             if (procesoDelLink.isDocumental) {
    //               // console.log('Proceso Documental');

    //               for (var i = 0; i < response.data.Value.idUsuario.length; i++) {
    //                 var currentUser = response.data.Value.idUsuario[i];

    //                 if (currentUser.userId == usuarioLogueadoId) {
    //                   userLogged = currentUser;
    //                   break;
    //                 } else if (currentUser.userId == 0) {
    //                   userDefault = currentUser;
    //                 }
    //               }

    //               if (userLogged != null) {
    //                 permisos = validarPermisosReportVisorDocumental(response.data.Value.urlProcesoLink, userLogged);

    //                 if (userLogged.verURL)
    //                   return validarTipoDeLink(response.data.Value.urlProcesoLink, permisos, fileName);
    //                 else 
    //                   return toastr.info("Usuario no autorizado para visualizar esta información");

    //               } else if (userDefault != null) {
    //                 permisos = validarPermisosReportVisorDocumental(response.data.Value.urlProcesoLink, userDefault);

    //                 if (userDefault.verURL)
    //                   return validarTipoDeLink(response.data.Value.urlProcesoLink, permisos, fileName);
    //                 else 
    //                   return toastr.info("Usuario no autorizado para visualizar esta información");

    //               } else {
    //                 toastr.info("Usuario no autorizado para visualizar esta información");
    //               }

    //             } else {
    //               // console.log('Proceso NO Documental');
    //               var fullUrl = response.data.Value.urlProcesoLink + fileName;
    //               var fullUrlBase64 = btoa(fullUrl);

    //               dataService.getAccesosURL(usuarioLogueadoId, fullUrlBase64)
    //                 .then(function(response) {
    //                   if (response.data.Success) {

    //                     if (response.data.Value != null) {
    //                       for (var i = 0; i < response.data.Value.idUsuario.length; i++) {
    //                         var currentUser = response.data.Value.idUsuario[i];

    //                         if (currentUser.userId == usuarioLogueadoId) {
    //                           userLogged = currentUser;
    //                           break;
    //                         } else if (currentUser.userId == 0) {
    //                           userDefault = currentUser;
    //                         }
    //                       }

    //                       if (userLogged != null) {
    //                         permisos = validarPermisosReportVisorDocumental(fullUrl, userLogged);

    //                         if (userLogged.verURL)
    //                           return validarTipoDeLink(fullUrl, permisos, null);
    //                         else 
    //                           return toastr.info("Usuario no autorizado para visualizar esta información");

    //                       } else if (userDefault != null) {
    //                         permisos = validarPermisosReportVisorDocumental(fullUrl, userDefault);

    //                         if (userDefault.verURL)
    //                           return validarTipoDeLink(fullUrl, permisos, null);
    //                         else 
    //                           return toastr.info("Usuario no autorizado para visualizar esta información");

    //                       } else {
    //                         toastr.info("Usuario no autorizado para visualizar esta información");
    //                       }

    //                     } else {
    //                       toastr.info("Información no disponible");
    //                     }

    //                   } else {
    //                     toastr.info("Información no disponible");
    //                   }
    //                 })
    //             }
    //           } else {
    //             toastr.info("Información no disponible");
    //           }

    //         }
    //       })
    //   }

    function setUrlIframe(url) {
      localStorage.setObject('urlIframe', url);
    }

    // ************************** TERCERA VERSION DEL VISOR DOCUMENTAL **************************
    function validarPermisosReportVisorDocumental(urlProcesoLink, userPermissions) {
      if (userPermissions.verURL) {
        if (urlProcesoLink.includes('kahuna.biz') || urlProcesoLink.includes('wkhn-madrid')) {
          // Si se accede a un servidor de Reporting Services
          if (urlProcesoLink.includes('?')) {
            // si la url ya tiene parámetros
            return (userPermissions.imprimirURL)
              ? '&rs:embed=true&rc:toolbar=true'
              : '&rs:embed=true&rc:toolbar=false'
          } else {
            // Si no tiene, se le añaden
            return (userPermissions.imprimirURL)
              ? '?rs:embed=true&rc:toolbar=true'
              : '?rs:embed=true&rc:toolbar=false'
          }
        } else
          return '';
      } else
        return '';
    }

    function openVisorDocumental(usuarioLogueadoId, url, isPdf) {
      console.log(url);

      var language = getLanguage();
      var userNotAllowedText, infoNotAvailableText;

      if (language == "español") {
        userNotAllowedText = "Usuario no autorizado para visualizar esta información";
        infoNotAvailableText = "Información no disponible";
      }
      else if (language == "ingles") {
        userNotAllowedText = "Unauthorized user to view this information";
        infoNotAvailableText = "Information not available";
      }
      else if (language == "portugues") {
        userNotAllowedText = "Usuário não autorizado para visualizar estas informações";
        infoNotAvailableText = "Informação não disponível";
      }
      else if (language == "italiano") {
        userNotAllowedText = "Usuario no autorizado para visualizar esta información";
        infoNotAvailableText = "Información no disponible";
      }

      var permisos = '';
      var userDefault = null;
      var userLogged = null;
      var urlBase64 = btoa(url);
      var urlForValidate = url.toLowerCase();
      var urlFolder = getUrlUntilLastSlash(url);
      var urlFolderBase64 = btoa(urlFolder);

      dataService.getAccesosURL(usuarioLogueadoId, urlFolderBase64)
        .then(function (response) {
          if (response.data.Success && response.data.Value != null) {

            var dataFromUrlFolder = response.data.Value;

            dataService.obtenerParametrosByIdent("URL_REPORTSERVER")
              .then(function (response) {
                if (response.data.Success) {
                  var includeOnePossibleDomain = false;
                  var possibleDomains = response.data.Value.UrlDocumentos.toLowerCase().split("|");

                  possibleDomains.map(function (domain) {
                    if (urlForValidate.includes(domain))
                      includeOnePossibleDomain = true;
                  });

                  if (/\.(pdf|jpg|jpeg|png|gif)$/i.test(urlForValidate) || includeOnePossibleDomain) {

                    dataService.getAccesosURL(usuarioLogueadoId, urlBase64)
                      .then(function (response) {
                        if (response.data.Success && response.data.Value != null) {

                          for (var i = 0; i < response.data.Value.idUsuario.length; i++) {
                            var currentUser = response.data.Value.idUsuario[i];

                            if (currentUser.userId == usuarioLogueadoId) {
                              userLogged = currentUser;
                              break;
                            } else if (currentUser.userId == 0) {
                              userDefault = currentUser;
                            }
                          }

                          if (userLogged != null) {
                            permisos = validarPermisosReportVisorDocumental(response.data.Value.urlProcesoLink, userLogged);

                            if (userLogged.verURL) {
                              $uibModal.open({
                                animation: true,
                                component: "modalVisor",
                                windowClass: "modal-visor",
                                openedClass: "overflow-hidden",
                                resolve: {
                                  url: function () {
                                    return response.data.Value.urlProcesoLink + permisos;
                                  },
                                  isPdf: isPdf,
                                  canPrint: userLogged.imprimirURL,
                                }
                              });
                            }
                            else {
                              return toastr.info(userNotAllowedText);
                            }

                          } else if (userDefault != null) {
                            permisos = validarPermisosReportVisorDocumental(response.data.Value.urlProcesoLink, userDefault);

                            if (userDefault.verURL) {
                              $uibModal.open({
                                animation: true,
                                component: "modalVisor",
                                windowClass: "modal-visor",
                                openedClass: "overflow-hidden",
                                resolve: {
                                  url: function () {
                                    return response.data.Value.urlProcesoLink + permisos;
                                  },
                                  isPdf: isPdf,
                                  canPrint: userDefault.imprimirURL,
                                }
                              });
                            } else {
                              return toastr.info(userNotAllowedText);
                            }

                          } else {
                            toastr.info(userNotAllowedText);
                          }

                        } else {
                          // var urlFolder = getUrlUntilLastSlash(url);
                          // var urlFolderBase64 = btoa(urlFolder);

                          // dataService.getAccesosURL(usuarioLogueadoId, urlFolderBase64)
                          //   .then(function (response) {
                          //     if (response.data.Success && response.data.Value != null) {

                          for (var i = 0; i < dataFromUrlFolder.idUsuario.length; i++) {
                            var currentUser = dataFromUrlFolder.idUsuario[i];

                            if (currentUser.userId == usuarioLogueadoId) {
                              userLogged = currentUser;
                              break;
                            } else if (currentUser.userId == 0) {
                              userDefault = currentUser;
                            }
                          }

                          if (userLogged != null) {
                            permisos = validarPermisosReportVisorDocumental(url, userLogged);

                            if (userLogged.verURL) {
                              $uibModal.open({
                                animation: true,
                                component: "modalVisor",
                                windowClass: "modal-visor",
                                openedClass: "overflow-hidden",
                                resolve: {
                                  url: function () {
                                    return url + permisos;
                                  },
                                  isPdf: isPdf,
                                  canPrint: userLogged.imprimirURL,
                                }
                              });
                            }
                            else {
                              return toastr.info(userNotAllowedText);
                            }

                          } else if (userDefault != null) {
                            permisos = validarPermisosReportVisorDocumental(url, userDefault);

                            if (userDefault.verURL) {
                              $uibModal.open({
                                animation: true,
                                component: "modalVisor",
                                windowClass: "modal-visor",
                                openedClass: "overflow-hidden",
                                resolve: {
                                  url: function () {
                                    return url + permisos;
                                  },
                                  isPdf: isPdf,
                                  canPrint: userDefault.imprimirURL,
                                }
                              });
                            } else {
                              return toastr.info(userNotAllowedText);
                            }

                          } else {
                            toastr.info(userNotAllowedText);
                          }

                          //     } else {
                          //       toastr.info(infoNotAvailableText);
                          //     }
                          //   }, function (error) {
                          //     toastr.error(error.data || getGenericErrorMessage(error));
                          //   })
                        }
                      }, function (error) {
                        toastr.error(error.data || getGenericErrorMessage(error));
                      })
                  } else {
                    // Si el archivo no es PDF, Imagen o el url pertenece a alguno de los sitios configurados en el parámetro URL_REPORTSERVER, valida los permisos con el endpoint y si los tiene simplemente abre el archivo

                    setUrlIframe(url);
                    window.open('/accesoUrl.html', '', 'width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no');
                    // window.open(url, '_blank');
                  }
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
              }, function (error) {
                toastr.error(error.data || getGenericErrorMessage(error));
                ctrl.isBusy = false;
              });

          } else {
            window.open(url, '_blank');
          }
        }, function (error) {
          toastr.error(error.data || getGenericErrorMessage(error));
        })
    }

    function getUrlUntilLastSlash(url) {
      var lastIndex = url.lastIndexOf('/');

      if (lastIndex == -1)
        return url;

      var urlHastaUltimoSlash = url.slice(0, lastIndex + 1);

      return urlHastaUltimoSlash;
    }

    // function getIframeSolicitudActivo() {
    //   return localStorage.getObject('iframeSolicitudActivo');
    // }

    // function setIframeSolicitudActivo(value) {
    //   localStorage.setObject('iframeSolicitudActivo', value);
    // }

    // function setIsBusyIframe(value) {
    //   localStorage.setObject('isBusyIframe', value);
    // }

    // function getIsBusyIframe() {
    //   return localStorage.getObject('isBusyIframe');
    // }

    // function getFirstSaveSolicitud() {
    //   return localStorage.getObject('firstSaveSolicitud');
    // }

    // function setFirstSaveSolicitud(value) {
    //   localStorage.setObject('firstSaveSolicitud', value);
    // }

    // function getModalGestionesOpen() {
    //   return localStorage.getObject('modalGestionesOpen');
    // }

    // function setModalGestionesOpen(value) {
    //   localStorage.setObject('modalGestionesOpen', value);
    // }

    function getActiveTabSolicitud() {
      return localStorage.getObject('activeTabSolicitud');
    }

    function setActiveTabSolicitud(value) {
      localStorage.setObject('activeTabSolicitud', value);
    }

    function getMaestroCodigo() {
      return localStorage.getObject('maestroCodigo');
    }
    
    function setMaestroCodigo(value) {
      localStorage.setObject('maestroCodigo', value);
    }

    function getSolicitudEstadoId() {
      return parseInt(appConfig.solicitudEstadoId);
    }
  }
})();
// import swal from 'sweetalert';
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.solicitud').component('solicitudEdit', {
        templateUrl: 'app/pages/solicitud/edit.template.html',
        controller: function ($scope, $state, dataService, sharedService, toastr, appConfig, toastrConfig, $stateParams, $uibModal, $timeout, $window, $location, $interval) {
            var ctrl = this;
            var authData = {};
            ctrl.language = sharedService.getLanguage();
            $scope.readonly = false;
            ctrl.showIconProcesosAsociados = false;
            ctrl.procesoCamposListado = null;
            ctrl.camposListOrdered = null;
            ctrl.procesoPadre = {};
            ctrl.camposTableEnr = []

            ctrl.timerImg;
            ctrl.model = {};
            ctrl.isBusy = false;
            ctrl.isBusyBlocked = false;
            ctrl.isNew = false;
            ctrl.CurrentDate = new Date();
            ctrl.showDelete = false;
            ctrl.showModalDataContainer = false;
            ctrl.templateCargadosIsSearching = true;
            ctrl.templatePendientesIsSearching = false;
            ctrl.mostrarAprobacion = false;
            ctrl.mostrarTemplates = false;
            ctrl.mostrarCamposBoton = false;
            ctrl.puedeEditarSolicitud = false;
            ctrl.puedeCargarTemplates = false;
            ctrl.puedeVerBtnQuitarPadre = false;
            ctrl.historialIsSearchingTrazabilidad = false;
            ctrl.showCopiaControlada = false;
            ctrl.solicitudHasProceduresField = false;
            ctrl.generaProcesoRelacionados = false;
            ctrl.usuarioPuedeAutorizar = false;
            ctrl.usuarioYaAutorizo = false;
            ctrl.gruposFilledLectores = false;
            ctrl.procesomcaOcultaAvanzarEtapa = false;
            ctrl.SourceObjetoTemp = [];
            ctrl.hideDatosDelProceso = false;

            ctrl.showProcesosHijosEtapaActual = false;
            ctrl.showForzarCierreEtapa = false;
            ctrl.verTodosProcesosAsociados = false;
            ctrl.lProcesoIsDocumental = false; //Guardar propiedad del proceso.
            ctrl.lProcesoIsDocumentalAutorizacionesV2 = false; //Guardar propiedad del proceso.
            ctrl.lsuarioLogueadoIsEditorDocV2 = false;
            ctrl.IdSolicitudEtapa = 0; //Guardar el Nombre de la Etapa.
            ctrl.lsuarioLogueadoIsAdminProceso = false;
            ctrl.lsuarioLogueadoIsSupervisorProceso = false;
            ctrl.lsuarioLogueadoIsSysAdmin = false;
            ctrl.lsuarioLogueadoIsLectorOnly = false;
            ctrl.lsuarioLogueadoIsNoCreateOnly = false;
            ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
            ctrl.userTieneMarcaObsoleto = false;
            ctrl.lUsuarioLogeado = {};
            ctrl.procesoIdObsoleto = 99;
            ctrl.procesoIdversiones = 999;

            ctrl.variableDePrueba = '';

            ctrl.anularVista = true;
            ctrl.viewLoading = true;
            ctrl.motivoBloqueo = '';
            ctrl.title = 'Carga de Proceso';
            ctrl.buttonSaveCabeceraText = 'Guardar Cabecera';
            ctrl.active = 0;
            ctrl.active2 = 66;
            ctrl.imgFile = appConfig.uploadUrl;
            //ctrl.evaluatenumber = evaluatenumber;        
            ctrl.testTrixModel = "<div><div>";
            ctrl.testTrixModelText = "";

            ctrl.fechaEtapa = '';
            ctrl.fechaEtapaForzarCierre = '';
            ctrl.aceptadoEtapa = false;
            ctrl.usuarioEtapaSiguiente = {};
            ctrl.usuarioEtapaAnterior = {};
            ctrl.justificacionEtapa = '';
            ctrl.solicitudEtapaModel = {};

            ctrl.rolProcesoList = [];
            ctrl.camposList = [];
            ctrl.templatesPendientesList = [];
            ctrl.templatesPendientesAccesoDirectoList = [];
            ctrl.templatesCargadosList = [];
            ctrl.procesoTemplateSeleccionado = {};

            ctrl.listadoDeProcesos = [];
            ctrl.listadoDeProcesos_doc = [];
            ctrl.listadoAutorizadasEtapa = [];

            ctrl.gruposList = [];
            ctrl.procesosList = [];
            ctrl.solicitudPadre = {};
            ctrl.solicitudesPadreList = [];

            ctrl.listadoUsuariosAutorizanSolicitudEtapa = [];
            ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
            ctrl.listaUsuariosDerivarResponsabilidad = [];
            ctrl.listadoHistorialAutorizaciones = [];
            ctrl.siguienteEstadoUsuariosList = [];
            ctrl.siguienteEstadoUsuariosListTmp = [];
            ctrl.anteriorEstadoUsuariosList = [];
            ctrl.anteriorEstadoUsuariosListTmp = [];
            ctrl.siguienteEstadoSolicitud = {};
            ctrl.anteriorEstadoSolicitud = {};

            ctrl.solicitudesHijoList = [];
            ctrl.historialSolicitud = [];
            ctrl.TrazabilidadSolicitud = [];

            ctrl.campoUsuarioList = [];
            ctrl.campoTemplateList = [];
            ctrl.campoJerarquiaList = [];

            ctrl.grupoUsuariosObj = {
                grupo1: 0,
                grupo1Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo2: 0,
                grupo2Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo3: 0,
                grupo3Obj: {
                    gruposUsuariosRelacion: null,
                    GrupoIsAutorizated: false
                },
                grupo1Lectores: 0,
                grupo1LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupo2Lectores: 0,
                grupo2LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupo3Lectores: 0,
                grupo3LectoresObj: {
                    gruposUsuariosRelacion: null
                },
                grupoUsersSiguienteEtapa: null,
                grupoUsersSiguienteEtapaV2: null
            };

            ctrl.jerarquia = {}
            ctrl.jerarquia.Permisos = {
                grupo1Etapa2Id: null,
                grupo2Etapa2Id: null,
                grupo3Etapa2Id: null,
                grupo1Etapa3Id: null,
                grupo2Etapa3Id: null,
                grupo3Etapa3Id: null,
                grupo1Etapa4Id: null,
                grupo2Etapa4Id: null,
                grupo3Etapa4Id: null,
                grupo1Etapa5Id: null,
                grupo2Etapa5Id: null,
                grupo3Etapa5Id: null,
                grupo1EtapaLectoresId: null,
                grupo2EtapaLectoresId: null,
                grupo3EtapaLectoresId: null
            }

            /*
             * STEPER
             */
            ctrl.myDynamicClassStep = "step";
            ctrl.ConstantcheckText = "✔";
            ctrl.ConstantCssDone = "step stepDone";
            ctrl.ConstantCssstepOnIt = "step stepOnIt";

            ctrl.step1Text = 1;
            ctrl.step2Text = 2;
            ctrl.step3Text = 3;
            ctrl.step4Text = 4;
            ctrl.step5Text = 5;

            ctrl.objSteps = [];

            ctrl.fileForQR = {};
            ctrl.fileForQRTouched = false;

            ctrl.autoSaveInterval = null;

            function Step(id, ngclass, text, label) {
                this.id = id;
                this.ngclass = ngclass;
                this.text = text;
                this.label = label;
            };

            function setStep(indice) {
                angular.forEach(ctrl.objSteps, function (value, key) {
                    if (value.id <= indice) {
                        value.ngclass = ctrl.ConstantCssDone;
                        value.Imgtext = ctrl.ConstantcheckText;
                    } else {
                        value.ngclass = ctrl.myDynamicClassStep;
                        value.Imgtext = value.id;
                        return;
                    }
                });
            };

            ctrl.testTrix = function () { }

            this.$onInit = function () {
                // console.log("INIT");
                authData = sharedService.getLoggedUser();
                if (authData != null && authData.Id > 0) {
                    ctrl.lUsuarioLogeado = authData;
                    // if (sharedService.getFirstSaveSolicitud() == true) {
                    //     Swal.fire({
                    //         title: '',
                    //         text: "Se está ejecutando un proceso, por favor espere",
                    //         allowEscapeKey: false,
                    //         allowOutsideClick: false,
                    //         onOpen: function () {
                    //             swal.showLoading();
                    //         }
                    //     })
                    // }

                    var solicitudListTitle;

                    if (ctrl.language == "español") {
                        solicitudListTitle = 'Carga de Proceso';
                        ctrl.acceptText = "Aceptar";
                        ctrl.cancelText = "Cancelar";
                        ctrl.successfulRegistration = "Registro exitoso.";

                    } else if (ctrl.language == "ingles") {
                        solicitudListTitle = 'Process Load';
                        ctrl.acceptText = "Accept";
                        ctrl.cancelText = "Cancel";
                        ctrl.successfulRegistration = "Registration successful.";

                    } else if (ctrl.language == "portugues") {
                        solicitudListTitle = 'Carga do processo';
                        ctrl.acceptText = "Aceitar";
                        ctrl.cancelText = "Cancelar";
                        ctrl.successfulRegistration = "Registro bem-sucedido.";

                    } else if (ctrl.language == "italiano") {
                        solicitudListTitle = 'Carga de Proceso';
                        ctrl.acceptText = "Aceptar";
                        ctrl.cancelText = "Cancelar";
                        ctrl.successfulRegistration = "Registro exitoso.";
                    }

                    $state.current.title = solicitudListTitle;

                    loadView(authData);

                    // esta función le da valor al ctrl.procesoCamposListado
                    getProcesoCamposListado();
                } else
                    $state.go('auth');

                // if ($location.url().match(/solicitud\/edit\/0\/0/g) || $location.url().match(/solicitud\/template\/edit/g)) {
                //     ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
                // } else {
                //     sharedService.setIframeSolicitudActivo(false);
                //     ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
                // }
            };

            ctrl.trixInitialize = function (e, editor) {
            };
            ctrl.trixChange = function (e, editor) {
                var document = editor.getDocument()
                ctrl.testTrixModelText = document.toString();
            };

            function fillStepsEtapas() {
                //model.Proceso.EtapasNombres
                if (ctrl.model != null && ctrl.model.Proceso != null) {
                    var etapas = ctrl.model.Proceso.EtapasNombres;
                    var estadIdActual = ctrl.model.EstadoId;
                    var contador = 1;
                    ctrl.cantidadEtapas = 1;
                    if (etapas != null && etapas != undefined) {
                        for (var i = 0; i < etapas.length; i++) {
                            var etapanombre = etapas[i].NombreEtapa;
                            var step1 = new Step();
                            step1.id = ctrl.cantidadEtapas;
                            step1.ngclass = ctrl.myDynamicClassStep;
                            step1.Imgtext = ctrl.cantidadEtapas;
                            step1.label = etapanombre;
                            ctrl.objSteps.push(step1);
                            ctrl.cantidadEtapas += 1;
                            if (etapanombre == "Cerrado" ||
                                etapanombre == "Closed" ||
                                etapanombre == "Fechados" ||
                                etapanombre == "italiano"
                            ) {
                                break;
                            }
                        }
                        if (estadIdActual != 6) {
                            setStep(estadIdActual);
                        } else {
                            setStep(ctrl.cantidadEtapas);
                        }
                    }

                }
            }

            function listarAutorizadasEtapa() {
                if ($stateParams.id != null && $stateParams.id != undefined &&
                    ctrl.model.EstadoId != null && ctrl.model.EstadoId != undefined) {
                    ctrl.viewLoading = true;
                    dataService.listarAutorizaciones($stateParams.id, ctrl.model.EstadoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.viewLoading = false;
                                ctrl.listadoAutorizadasEtapa = response.data.Value;
                                if (ctrl.lProcesoIsDocumentalAutorizacionesV2 && ctrl.IdSolicitudEtapa == 1) {
                                    if (!ctrl.lsuarioLogueadoIsSysAdmin && ctrl.lsuarioLogueadoIsEditorDocV2)
                                        ctrl.showDelete = false;
                                }
                                verifyGruposListadoAutorizados();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                } else {
                }
            }

            ctrl.actionAddOnClick = function (j, item) {
                if (!item.SourceObjetoTemp) {
                    item.SourceObjetoTemp = item.SourceObjeto;
                }

                if (!item.ValorObjeto) {
                    item.ValorObjeto = [];
                }

                // Filtrando el elemento clickado de la lista de la vista
                item.SourceObjeto = item.SourceObjeto.filter(function (element) {
                    return element.Id != j.Id;
                });

                // Filtrando el elemento clickado de la lista de por defecto
                item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (element) {
                    return element.Id != j.Id;
                });

                var alreadySelected = item.ValorObjeto.findIndex(function (element) {
                    return element.Id == j.Id;
                })

                // Si ya existe el elemento seleccionado, no lo agregará
                alreadySelected == -1 ? item.ValorObjeto.push(j) : '';
            };

            ctrl.actionAddOnClickTableEnr = function (j, item) {
                // Este metodo hace lo mismo que el actionAddOnClick, pero se separó por si la lógica del TableEnr es necesario cambiarla
                if (!item.SourceObjetoTemp) {
                    item.SourceObjetoTemp = item.SourceObjeto;
                }

                // Filtrando el elemento clickado de la lista de la vista
                item.SourceObjeto = item.SourceObjeto.filter(function (element) {
                    return element.Id != j.Id;
                });

                // Filtrando el elemento clickado de la lista de por defecto
                item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (element) {
                    return element.Id != j.Id;
                });

                var alreadySelected = item.ValorObjeto.findIndex(function (element) {
                    return element.Id == j.Id;
                })

                // Si ya existe el elemento seleccionado, no lo agregará
                alreadySelected == -1 ? item.ValorObjeto.push(j) : '';
            };

            ctrl.actionRemoveOnClick = function (j, item) {
                item.ValorObjeto = item.ValorObjeto.filter(function (item) {
                    return item.Id != j.Id;
                });
                item.SourceObjeto.push(j);
                item.SourceObjetoTemp.push(j);
                // item.SourceObjetoTemp = item.SourceObjeto;
                // item.TextoBusqueda = "";
            };

            ctrl.actionRemoveOnClickTableEnr = function (j, item) {
                // Este metodo hace lo mismo que el actionRemoveOnClick, pero se separó por si la lógica del TableEnr es necesario cambiarla
                item.ValorObjeto = item.ValorObjeto.filter(function (item) {
                    return item.Id != j.Id;
                });
                item.SourceObjeto.push(j);
                item.SourceObjetoTemp.push(j);
                // item.SourceObjetoTemp = item.SourceObjeto;
                // item.TextoBusqueda = "";
            };

            ctrl.RechazarAction = function () {
                if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
                    var titleComment;
                    if (ctrl.language == "español")
                        titleComment = "Debe ingresar comentario.";
                    else if (ctrl.language == "ingles")
                        titleComment = "You must enter a comment.";
                    else if (ctrl.language == "portugues")
                        titleComment = "Deve inserir comentário.";
                    else if (ctrl.language == "italiano")
                        titleComment = "Debe ingresar comentario.";

                    Swal.fire({
                        title: titleModal,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: ctrl.acceptText,
                        cancelButtonText: ctrl.cancelText,
                        heightAuto: false,
                    }).then(function (result) { });
                    return;
                }
                var obj = {
                    UsuarioId: authData.Id,
                    SolicitudId: $stateParams.id,
                    EtapaId: ctrl.model.EstadoId,
                    Comentario: ctrl.AutorizarMsg,
                    EtapaNombre: ctrl.model.SolicitudEtapaNombre,
                };
                sharedService.showLoading();
                dataService.rechazarAutorizacion(obj).then(
                    function (response) {
                        if (response.data.Success) {
                            var titleRefuse;
                            if (ctrl.language == "español")
                                titleRefuse = "Autorización Rechazada Correctamente.";
                            else if (ctrl.language == "ingles")
                                titleRefuse = "Authorization Rejected Successfully.";
                            else if (ctrl.language == "portugues")
                                titleRefuse = "Autorização Rejeitada com Sucesso.";
                            else if (ctrl.language == "italiano")
                                titleRefuse = "Autorización Rechazada Correctamente.";

                            Swal.fire({
                                title: titleRefuse,
                                type: "success",
                                showCancelButton: false,
                                confirmButtonColor: "#3085d6",
                                confirmButtonText: ctrl.acceptText,
                                heightAuto: false,
                            }).then(function (result) {
                                //.then((result) => {
                                //listarAutorizadasEtapa();
                                $state.reload();
                            });
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    },
                    function (error) {
                        toastr.error(
                            error.data || sharedService.getGenericErrorMessage(error)
                        );
                    }
                );
            };

            ctrl.AutorizarAction = function () {
                if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
                    var titleComment;
                    if (ctrl.language == "español")
                        titleComment = "Debe ingresar comentario.";
                    else if (ctrl.language == "ingles")
                        titleComment = "You must enter a comment.";
                    else if (ctrl.language == "portugues")
                        titleComment = "Deve inserir comentário.";
                    else if (ctrl.language == "italiano")
                        titleComment = "Debe ingresar comentario.";

                    Swal.fire({
                        title: titleComment,
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#3085d6',
                        confirmButtonText: ctrl.acceptText,
                        heightAuto: false
                    })
                        .then(function (result) {

                        });
                    return;
                }
                var obj = {
                    UsuarioId: authData.Id,
                    SolicitudId: $stateParams.id,
                    EtapaId: ctrl.model.EstadoId,
                    Comentario: ctrl.AutorizarMsg,
                    EtapaNombre: ctrl.model.SolicitudEtapaNombre
                };
                sharedService.showLoading();
                dataService.guardarAutorizacion(obj)
                    .then(function (response) {
                        if (response.data.Success) {
                            var titleAuthorization;
                            if (ctrl.language == "español")
                                titleAuthorization = "Autorización Guardada Correctamente.";
                            else if (ctrl.language == "ingles")
                                titleAuthorization = "Authorization Saved Successfully.";
                            else if (ctrl.language == "portugues")
                                titleAuthorization = "Autorização Salva com Sucesso.";
                            else if (ctrl.language == "italiano")
                                titleAuthorization = "Autorización Guardada Correctamente.";

                            if (response.data.Value.EtapaId == 6) {
                                dataService.generarImpresionDocumentalPdf(ctrl.model.Id, ctrl.model.ProcesoId)
                                .then(function (response) {
                                    if (response.data.Success) {
                                    } else {
                                        toastr.error(response.data.ErrorSummary);
                                        // sharedService.closeLoading();
                                    }
                                    Swal.fire({
                                        title: titleAuthorization,
                                        type: 'success',
                                        showCancelButton: false,
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: ctrl.acceptText,
                                        heightAuto: false
                                    })
                                        .then(function (result) {
                                            //.then((result) => {
                                            $state.reload();
                                            //listarAutorizadasEtapa();
                                        });
                                }, function (error) {
                                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                    sharedService.closeLoading();
                                });
                            } else {
                                Swal.fire({
                                    title: titleAuthorization,
                                    type: 'success',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: ctrl.acceptText,
                                    heightAuto: false
                                })
                                    .then(function (result) {
                                        //.then((result) => {
                                        $state.reload();
                                        //listarAutorizadasEtapa();
                                    });
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            sharedService.closeLoading();
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        sharedService.closeLoading();
                    });
            }

            function getJerarquiaAutorizaciones() {
                if (ctrl.model.Proceso.autorizaciones) {
                    var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;

                    var jerarquiaIdValor = 0;
                    if (campoIdAutorizacion != null && campoIdAutorizacion != undefined && campoIdAutorizacion != 0) {
                        listarAutorizadasEtapa();
                    }
                    angular.forEach(ctrl.camposList, function (value, key) {
                        if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                            jerarquiaIdValor = value.Valor;
                            getJerarquiaById(campoIdAutorizacion, jerarquiaIdValor);
                            listadoUsuariosAutorizanSolicitudEtapa(campoIdAutorizacion);
                            historialAutorizaciones();
                        }
                    });
                } else {
                    return;
                }
            }

            //function para GEstion documental V2
            // Objetivo Verificar si mi usuario es miembro de algun grupo de la Jerarquia y puede crear Solicitud
            ctrl.isUserAbleToCreateDocument = function (campoAutorizacion, jerarquiaIdValor) {
                dataService.isUserAbleToCreateDocumentFromJerarquia(ctrl.model.ProcesoId, jerarquiaIdValor)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == "false" || response.data.Value == false) {
                                var titleModal;
                                if (ctrl.language == "español")
                                    titleModal = "No tienes permisos de Edicion para la Nomenclatura Documental.";
                                else if (ctrl.language == "ingles")
                                    titleModal = "You do not have editing permissions for Document Nomenclature.";
                                else if (ctrl.language == "portugues")
                                    titleModal = "Você não tem permissões de Edição para a Nomenclatura Documental";
                                else if (ctrl.language == "italiano")
                                    titleModal = "No tienes permisos de Edicion para la Nomenclatura Documental.";

                                Swal.fire({
                                    title: titleModal,
                                    type: 'success',
                                    showCancelButton: false,
                                    confirmButtonColor: '#3085d6',
                                    confirmButtonText: ctrl.acceptText,
                                    heightAuto: false
                                })
                                    .then(function (result) {
                                        ctrl.goListado();
                                    });
                            } else {
                                var jerarquiaTemp = null;
                                dataService.getJerarquiaById(jerarquiaIdValor)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            jerarquiaTemp = response.data.Value;
                                            if (jerarquiaTemp != undefined && jerarquiaTemp.TieneJerarquiaPermisosCampos) {
                                                dataService.getJerarquiaProcesoCampos(ctrl.model.ProcesoId, jerarquiaIdValor)
                                                    .then(function (response) {
                                                        if (response.data.Success) {
                                                            ctrl.procesoCamposListJerarquia = response.data.Value.Resultados;
                                                            ctrl.camposList = ctrl.camposList.filter(function (item) {
                                                                return ctrl.procesoCamposListJerarquia.some(function (c) {
                                                                    return item.CampoId == c.campoId
                                                                });
                                                            });
                                                        } else {
                                                            toastr.error(response.data.ErrorSummary);
                                                        }
                                                        ctrl.isSearching = false;
                                                    }, function (error) {
                                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                        ctrl.isSearching = false;
                                                    });
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                        }
                                        ctrl.isSearching = false;
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        ctrl.isSearching = false;
                                    });


                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.isUserAbleToCreateDocumentFromSolicitud = function () {
                ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.campoIdAutorizacion;
                if (ctrl.model.Id != 0 && isAutorizacionesDocumentalV2 && ctrl.IdSolicitudEtapa == 6) {
                    ctrl.viewLoading = true;
                    dataService.isUserAbleToCreateDocumentFromSolicitud(ctrl.model.Id)
                        .then(function (response) {
                            ctrl.viewLoading = false;
                            if (response.data.Success) {
                                if (response.data.Value == "false" || response.data.Value == false) {
                                    ctrl.lDocIsUserAbleToCreateDocumentV2 = false;
                                } else {
                                    ctrl.lDocIsUserAbleToCreateDocumentV2 = true;
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                }
            }

            ctrl.userTieneMarcaObsoleto = function () {
                ctrl.userTieneMarcaObsoleto = false;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.campoIdAutorizacion;
                if (ctrl.model.Id != 0 && isAutorizacionesDocumentalV2 && ctrl.IdSolicitudEtapa == 6) {
                    dataService.checkIfUserTieneMarcaObsoleto(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                if (response.data.Value == "false" || response.data.Value == false) {
                                    ctrl.userTieneMarcaObsoleto = false;
                                } else {
                                    ctrl.userTieneMarcaObsoleto = true;
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                }
            }


            //listado Usuarios Autorizan Solicitud Segun la Etapa Actual
            function listadoUsuariosAutorizanSolicitudEtapa(campoAutorizacion) {
                if (ctrl.model.Proceso.autorizacionesDocumental) {
                    dataService.listadoUsuariosAutorizanSolicitudEtapa(ctrl.model.Id, campoAutorizacion)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.listadoUsuariosAutorizanSolicitudEtapa = response.data.Value;
                                checkIfUserIsAllowedToAutorizeByEtapa(); //V2
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                }
            }

            //Historial de autorizaciones de todas las etapas.
            function historialAutorizaciones() {
                if (ctrl.model.Proceso.autorizacionesDocumental) {
                    dataService.historialAutorizaciones(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.listadoHistorialAutorizaciones = response.data.Value;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                }
            }

            //Mediante el campo de autorizacion o id de la jerarquia obteine la jerarquia completa con permisos.
            // tambien recibe como filtro la solicitud ID
            function getJerarquiaById(campoAutorizacion, jerarquiaIdValor) {
                dataService.getJerarquiaAutorizacionesById(ctrl.model.Id, campoAutorizacion)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.jerarquia = response.data.Value;
                            gruposByEtapa();
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            function gruposByEtapa() {
                switch (ctrl.model.EstadoId) {
                    case 1:
                        ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa2);
                        ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa2);
                        ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa2);
                        ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa2;
                        ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa3;
                        break;
                    case 2:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa2);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa2);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa2);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa3;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa4;
                        }
                        break;
                    case 3:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa3);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa3);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa3);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa4;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa5;
                        }
                        break;
                    case 4:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa4);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa4);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa4);

                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa = ctrl.jerarquia.Permisos.grupo1Etapa5;
                            ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2 = ctrl.jerarquia.Permisos.grupo1Etapa6;
                        }
                        break;
                    case 5:
                        if (ctrl.jerarquia.Permisos != null) {
                            ctrl.grupoUsuariosObj.grupo1Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo1Etapa5);
                            ctrl.grupoUsuariosObj.grupo2Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo2Etapa5);
                            ctrl.grupoUsuariosObj.grupo3Obj = validateNullUndefined(ctrl.jerarquia.Permisos.grupo3Etapa5);
                        }
                        break;
                    case 6:
                        break;
                    default:
                        break;
                }

                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo1Obj);
                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo2Obj);
                checkIfUserIsAllowedToAutorize(ctrl.grupoUsuariosObj.grupo3Obj);
                verifyGruposListadoAutorizados();

                var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                var isAutorizacionesDocumentalV2 = ctrl.model.Proceso.autorizacionesDocumental;
                var isAutorizaciones = ctrl.model.Proceso.autorizaciones;
                if (isAutorizacionesDocumentalV2 && isAutorizaciones &&
                    campoIdAutorizacion != null && campoIdAutorizacion != undefined && campoIdAutorizacion != 0) {
                    fillUsuariosEtapaSiguiente(ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapaV2);
                } else {
                    fillUsuariosEtapaSiguiente(ctrl.grupoUsuariosObj.grupoUsersSiguienteEtapa);
                }
            }

            function fillUsuariosEtapaSiguiente(obj) {
                ctrl.siguienteEstadoUsuariosList = [];
                ctrl.siguienteEstadoUsuariosListTmp = [];
                if (obj != null && obj != undefined) {
                    angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                        ctrl.siguienteEstadoUsuariosList.push(value.Usuario);
                        ctrl.siguienteEstadoUsuariosListTmp.push(value.Usuario);
                    });
                }
            }

            function validateNullUndefined(obj) {
                if (obj != null && obj != undefined)
                    return obj;
                else {
                    return null;
                }
            }

            function verifyGruposListadoAutorizados() {
                if (ctrl.grupoUsuariosObj.grupo1Obj != null ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion != null ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion != undefined ||
                    ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion.length > 0) {
                    ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated = false;
                } else {
                    if (ctrl.grupoUsuariosObj.grupo1Obj == null) {
                        ctrl.grupoUsuariosObj.grupo1Obj = {};
                        ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated = true;
                    }
                }
                if (ctrl.grupoUsuariosObj.grupo2Obj != null) {
                    ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = true;
                    if (ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion != null ||
                        ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion != undefined) {
                        if (ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion.length > 0) {
                            ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = false;
                        }
                    }
                } else {
                    if (ctrl.grupoUsuariosObj.grupo2Obj == null) {
                        ctrl.grupoUsuariosObj.grupo2Obj = {};
                        ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated = true;
                    }
                }
                if (ctrl.grupoUsuariosObj.grupo3Obj != null) {
                    ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = true;
                    if (ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion != null ||
                        ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion != undefined) {
                        if (ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion.length > 0) {
                            ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = false;
                        }
                    }
                } else {
                    if (ctrl.grupoUsuariosObj.grupo3Obj == null) {
                        ctrl.grupoUsuariosObj.grupo3Obj = {};
                        ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated = true;
                    }
                }

                angular.forEach(ctrl.listadoAutorizadasEtapa, function (value, key) {
                    var objAutorizacion = value;
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo1Obj, objAutorizacion);
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo2Obj, objAutorizacion);
                    checkIfUserhasAutorized(ctrl.grupoUsuariosObj.grupo3Obj, objAutorizacion);
                });
            }

            function checkIfUserhasAutorized(obj, objAutorizacion) {
                ctrl.active2 = 77;
                if (obj != null && obj.gruposUsuariosRelacion != null) {
                    angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                        if (value.Usuario.Id == objAutorizacion.UsuarioId) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = false; //No debe poder autorizar ya lo hizo..
                                ctrl.usuarioYaAutorizo = true;
                            }
                            obj.GrupoIsAutorizated = true;
                            value.hasAutorized = true;
                            value.Comentario = objAutorizacion.Comentario;
                            value.FechaAutorizacion = objAutorizacion.CreationDate;
                        }
                    });
                }

                if (ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    if (objAutorizacion.UsuarioId == authData.Id) {
                        ctrl.usuarioPuedeAutorizar = false; //No debe poder autorizar ya lo hizo..
                        ctrl.usuarioYaAutorizo = true;
                    } else {
                        ctrl.active2 = 77;
                    }
                }
            }

            function checkIfUserIsAllowedToAutorize(obj) {
                if (!ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    if (obj != null && obj.gruposUsuariosRelacion != null) {
                        angular.forEach(obj.gruposUsuariosRelacion, function (value, key) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = true;
                            } else {
                            }
                        });
                    }
                }
            }

            function checkIfUserIsAllowedToAutorizeByEtapa(obj) {
                if (ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                    angular.forEach(ctrl.listadoUsuariosAutorizanSolicitudEtapa, function (objPermiso, key) {
                        angular.forEach(objPermiso.gruposUsuariosRelacion, function (value, key) {
                            if (value.Usuario.Id == authData.Id) {
                                ctrl.usuarioPuedeAutorizar = true;
                            } else {
                            }
                        });
                    });
                }
            }

            function loadView(authData) {
                ctrl.puedeVerBtnQuitarPadre = sharedService.isSysAdminLoggedUser();

                if ($stateParams.id != "0") {
                    ctrl.isBusy = true;
                    if (ctrl.language == "español") {
                        ctrl.title = 'Editar Datos de Carga del Proceso';
                        ctrl.buttonSaveCabeceraText = 'Guardar Cabecera';
                    } else if (ctrl.language == "ingles") {
                        ctrl.title = 'Edit Process Load Data';
                        ctrl.buttonSaveCabeceraText = 'Save Header';
                    } else if (ctrl.language == "portugues") {
                        ctrl.title = 'Editar Dados de Carregamento do Processo';
                        ctrl.buttonSaveCabeceraText = 'Salvar Cabeçalho';
                    } else if (ctrl.language == "italiano") {
                        ctrl.title = 'Editar Datos de Carga del Proceso';
                        ctrl.buttonSaveCabeceraText = 'Guardar Cabecera';
                    }

                    dataService.getSolicitudById($stateParams.id)
                        .then(function (response) {
                            if (response.data.Success) {
                                // console.log("Editar datos del proces1!!!" + ctrl.viewLoading);
                                ctrl.model = response.data.Value;

                                if (ctrl.model != null && ctrl.model.Id > 0) {
                                    ctrl.isBusy = false;

                                    // Guardando la propiedad Proceso de la Solicitud para ser usada al guardar los SolicitudCampoValor
                                    ctrl.procesoPadre = ctrl.model.Proceso;

                                    initAutoSaveCounter();

                                    ctrl.procesomcaOcultaAvanzarEtapa = ctrl.model.Proceso.mcaOcultaAvanzarEtapa;
                                    ctrl.lProcesoIsDocumental = ctrl.model.Proceso.isDocumental;
                                    ctrl.hideDatosDelProceso = ctrl.model.EstadoId >= sharedService.getSolicitudEstadoId();
                                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.model.Proceso.autorizacionesDocumental;
                                    ctrl.IdSolicitudEtapa = ctrl.model.Estado.Id;
                                    ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();

                                    if (ctrl.language == "español") {
                                        ctrl.motivoBloqueo = 'Cargando datos...';
                                    } else if (ctrl.language == "ingles") {
                                        ctrl.motivoBloqueo = 'Loading data...';
                                    } else if (ctrl.language == "portugues") {
                                        ctrl.motivoBloqueo = 'Carregando dados...';
                                    } else if (ctrl.language == "italiano") {
                                        ctrl.motivoBloqueo = 'Cargando datos...';
                                    }

                                    ctrl.showDelete = true;
                                    ctrl.fechaEtapa = ctrl.getFecha();
                                    ctrl.fechaEtapaForzarCierre = ctrl.getFecha();
                                    if (ctrl.model.SolicitudPadre != null && ctrl.model.SolicitudPadreId > 0) {
                                        getDataSolicitudesPadre(ctrl.model.SolicitudPadre.ProcesoId);
                                    }

                                    //En la primer etapa no figura si aprueba o no en la vista. Aprueba por default
                                    if (ctrl.model.Estado.Codigo == 'ALTA') {
                                        ctrl.aceptadoEtapa = 1;
                                    }
                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                    ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                                    onInitShowHideItemsModelSolicitud();

                                    ctrl.isBusy = true;
                                    dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.isBusy = false;
                                                ctrl.rolProcesoList = response.data.Value;
                                                ctrl.showProcesosHijosEtapaActual = etapaActualProcesaHijos(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                ctrl.lsuarioLogueadoIsAdminProceso = usuariosLogueadoIsAdminProceso(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                ctrl.lsuarioLogueadoIsSupervisorProceso = userIsSupervisor(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                ctrl.lsuarioLogueadoIsEditorDocV2 = usuariosLogueadoIsEditor(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                if (sharedService.isSysAdminLoggedUser() ||
                                                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                                    ctrl.anularVista = false;
                                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.fechaEtapa = ctrl.getFecha();
                                                    ctrl.isAdministradorProceso = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    getSolicitudCampos();
                                                    // AQUI SE LLAMA AL 'SolicitudCampoValor/ValoresCompletos'
                                                } else {
                                                    ctrl.showProcesosHijosEtapaActual = false;
                                                    ctrl.anularVista = true;

                                                    if (ctrl.language == "español") {
                                                        ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                    } else if (ctrl.language == "ingles") {
                                                        ctrl.motivoBloqueo = 'You do not have permissions to view or perform actions on this process.';
                                                    } else if (ctrl.language == "portugues") {
                                                        ctrl.motivoBloqueo = 'Não tem permissões para visualizar ou realizar ações neste processo';
                                                    } else if (ctrl.language == "italiano") {
                                                        ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                    }
                                                }
                                                ctrl.listaUsuariosDerivar(ctrl);
                                            } else {
                                                ctrl.showProcesosHijosEtapaActual = false;
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.viewLoading = false;
                                            ctrl.isBusy = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.viewLoading = false;
                                            ctrl.isBusy = false;
                                        });

                                    ctrl.buscarSolicitudesHijo(true);
                                    ctrl.showForzarCierreEtapa = showForzarCierreEtapa(ctrl.model);
                                    if (sharedService.isSysAdminLoggedUser() || authData.Id == ctrl.model.UsuarioAprobadorId || ctrl.isAdministradorProceso) {
                                        if (ctrl.showForzarCierreEtapa) {
                                            ctrl.showForzarCierre = true;
                                        } else {
                                            ctrl.showForzarCierre = false;
                                        }
                                    } else {
                                        ctrl.showForzarCierre = false;
                                    }

                                    ctrl.isDatosSiguienteEstadoLoading = true;
                                    ctrl.isBusy = true;
                                    dataService.getSiguienteEstadoSolicitud($stateParams.id)
                                        .then(function (response) {
                                            ctrl.isBusy = false;
                                            if (response.data.Success) {
                                                ctrl.siguienteEstadoSolicitud = response.data.Value;
                                                if (ctrl.siguienteEstadoSolicitud != null && ctrl.siguienteEstadoSolicitud.Id > 0) {
                                                    ctrl.isBusy = true;
                                                    dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, $stateParams.id, ctrl.siguienteEstadoSolicitud.Id)
                                                        .then(function (response) {
                                                            ctrl.isBusy = false;
                                                            if (response.data.Success) {
                                                                ctrl.siguienteEstadoUsuariosList = response.data.Value;
                                                                ctrl.siguienteEstadoUsuariosListTmp = response.data.Value;
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                                            ctrl.isBusy = false;
                                                        });
                                                } else
                                                    ctrl.isDatosSiguienteEstadoLoading = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                ctrl.isDatosSiguienteEstadoLoading = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isDatosSiguienteEstadoLoading = false;
                                            ctrl.isBusy = false;
                                        });

                                    ctrl.isDatosAnteriorEstadoLoading = true;
                                    dataService.getAnteriorEstadoSolicitud($stateParams.id)
                                        .then(function (response) {
                                            ctrl.isBusy = false;
                                            if (response.data.Success) {
                                                ctrl.anteriorEstadoSolicitud = response.data.Value;
                                                if (ctrl.anteriorEstadoSolicitud != null && ctrl.anteriorEstadoSolicitud.Id > 0) {
                                                    dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, $stateParams.id, ctrl.anteriorEstadoSolicitud.Id)
                                                        .then(function (response) {
                                                            if (response.data.Success) {
                                                                ctrl.anteriorEstadoUsuariosList = response.data.Value;
                                                                ctrl.anteriorEstadoUsuariosListTmp = response.data.Value;
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                                        });
                                                } else
                                                    ctrl.isDatosAnteriorEstadoLoading = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                ctrl.isDatosAnteriorEstadoLoading = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isDatosAnteriorEstadoLoading = false;
                                        });

                                    ctrl.historialIsSearching = true;
                                    ctrl.isBusy = true;
                                    dataService.getSolicitudEtapaBySolicitud($stateParams.id)
                                        .then(function (response) {
                                            ctrl.isBusy = false;
                                            if (response.data.Success) {
                                                ctrl.historialSolicitud = response.data.Value;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.historialIsSearching = false;
                                        }, function (error) {
                                            ctrl.isBusy = false;
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.historialIsSearching = false;
                                        });
                                    ctrl.getHistorialTrazabilidadSolicitud();

                                    if (true) {
                                        // Esta validación fue quitada a fin de poder cargar un template luego de haber cerrado cualquier solicitud

                                        // if (ctrl.lProcesoIsDocumental || (ctrl.model.Estado.Codigo != 'APRO' && ctrl.model.Estado.Codigo != 'CERR')) {
                                        ctrl.templatePendientesIsSearching = true;
                                        ctrl.isBusy = true;
                                        dataService.getTemplatePendientesBySolicitudList($stateParams.id)
                                            .then(function (response) {
                                                ctrl.isBusy = false;
                                                if (response.data.Success) {
                                                    ctrl.templatesPendientesList = response.data.Value;
                                                    ctrl.mostrarTemplates = mostrarTemplates(ctrl.templatesPendientesList);
                                                    ctrl.templatesPendientesAccesoDirectoList = [];
                                                    if (ctrl.templatesPendientesList != null && ctrl.templatesPendientesList.length > 0) {
                                                        for (var i = 0; i < ctrl.templatesPendientesList.length; i++) {
                                                            if (ctrl.templatesPendientesList[i].EsAccesoDirecto)
                                                                ctrl.templatesPendientesAccesoDirectoList.push(ctrl.templatesPendientesList[i]);
                                                        }

                                                        // Ordenando los templates pendientes según la prop Nombre
                                                        ctrl.templatesPendientesAccesoDirectoList.sort(function (templateA, templateB) {
                                                            return templateA.Template.Nombre.localeCompare(templateB.Template.Nombre)
                                                        });
                                                    }
                                                } else {
                                                    toastr.error(response.data.ErrorSummary);
                                                }
                                                ctrl.templatePendientesIsSearching = false;
                                            }, function (error) {
                                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                ctrl.templatePendientesIsSearching = false;
                                                ctrl.isBusy = false;
                                            });
                                    }
                                    fillStepsEtapas();
                                    ctrl.isUserAbleToCreateDocumentFromSolicitud();
                                    ctrl.userTieneMarcaObsoleto();
                                    if (ctrl.model.Proceso.mcaOcultaAvanzarEtapa) {
                                        ctrl.active = 1;
                                    }

                                    if (sharedService.getActiveTabSolicitud() == true) {
                                        ctrl.active = 1;
                                        sharedService.setActiveTabSolicitud(false);
                                        // Si se guardó la solicitud desde el engranaje que ejecuta el ctrl.saveCamposAndExecSP o desde el auto guardado, siempre debe mostrar los "Datos del Proceso" al refrescar
                                    }

                                    // if (sharedService.getModalGestionesOpen() == true) {
                                    //     ctrl.active = 0;
                                    //     sharedService.setModalGestionesOpen(false);
                                    //     // Este if sólo se encarga de consultar en el localStorage si se activó el modal de Gestiones, sólo el de Gestiones,  para que cuando se recargue la pantalla, muestre la vista de Gestiones
                                    // }
                                    // console.log("Editar datos del procesO FIN!!!!!!!" + ctrl.viewLoading);
                                } else {
                                    ctrl.anularVista = true;
                                    if (ctrl.language == "español") {
                                        ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                    } else if (ctrl.language == "ingles") {
                                        ctrl.motivoBloqueo = 'Selected process load not found.';
                                    } else if (ctrl.language == "portugues") {
                                        ctrl.motivoBloqueo = 'Não foi encontrado o carregamento do processo selecionado';
                                    } else if (ctrl.language == "italiano") {
                                        ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                    }
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }

                            ctrl.viewLoading = false;
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.viewLoading = false;
                        });
                } else {
                    ctrl.active = 1;

                    if (ctrl.language == "español") {
                        ctrl.title = 'Crear Datos de Carga del Proceso';
                        ctrl.buttonSaveCabeceraText = 'Crear Proceso';
                    } else if (ctrl.language == "ingles") {
                        ctrl.title = 'Create Process Load Data';
                        ctrl.buttonSaveCabeceraText = 'Create Process';
                    } else if (ctrl.language == "portugues") {
                        ctrl.title = 'Criar Dados de Carregamento do Processo';
                        ctrl.buttonSaveCabeceraText = 'Criar Processo';
                    } else if (ctrl.language == "italiano") {
                        ctrl.title = 'Crear Datos de Carga del Proceso';
                        ctrl.buttonSaveCabeceraText = 'Crear Proceso';
                    }

                    ctrl.isBusy = true;

                    var solicitudPadreId = 0;
                    if ($stateParams.solicitudPadreId != null)
                        solicitudPadreId = $stateParams.solicitudPadreId;

                    dataService.getSolicitudDefault($stateParams.proceso, solicitudPadreId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.model = response.data.Value;
                                ctrl.isNew = true;
                                if (ctrl.model != null) {
                                    ctrl.procesoPadre = ctrl.model.Proceso;
                                    ctrl.lProcesoIsDocumental = ctrl.model.Proceso.isDocumental;
                                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.model.Proceso.autorizacionesDocumental;
                                    ctrl.IdSolicitudEtapa = ctrl.model.Estado.Id;
                                    ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();

                                    initAutoSaveCounter();

                                    if (ctrl.language == "español") {
                                        ctrl.motivoBloqueo = 'Cargando datos...';
                                    } else if (ctrl.language == "ingles") {
                                        ctrl.motivoBloqueo = 'Loading data...';
                                    } else if (ctrl.language == "portugues") {
                                        ctrl.motivoBloqueo = 'Carregando dados...';
                                    } else if (ctrl.language == "italiano") {
                                        ctrl.motivoBloqueo = 'Cargando datos...';
                                    }
                                    ctrl.fechaEtapa = ctrl.getFecha();
                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                    ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                                    onInitShowHideItemsModelSolicitud();

                                    if (ctrl.model.SolicitudPadre != null && ctrl.model.SolicitudPadreId > 0) {
                                        getDataSolicitudesPadre(ctrl.model.SolicitudPadre.ProcesoId);
                                    }

                                    dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.rolProcesoList = response.data.Value;
                                                ctrl.lsuarioLogueadoIsAdminProceso = usuariosLogueadoIsAdminProceso(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                if (sharedService.isSysAdminLoggedUser() ||
                                                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                                    ctrl.puedeEditarSolicitud = puedeEditarSolicitud(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.puedeEditarCampos = puedeEditarCampos(ctrl.model, ctrl.model.UsuarioCreacionId, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.puedeCargarTemplates = puedeCargarTemplates(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.mostrarAprobacion = mostrarAprobacion(ctrl.model, authData.Id, ctrl.rolProcesoList);
                                                    ctrl.lsuarioLogueadoIsSupervisorProceso = userIsSupervisor(ctrl.model, ctrl.rolProcesoList, authData.Id);
                                                    ctrl.anularVista = !ctrl.puedeEditarSolicitud;
                                                } else {
                                                    ctrl.anularVista = true;
                                                    if (ctrl.language == "español") {
                                                        ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                    } else if (ctrl.language == "ingles") {
                                                        ctrl.motivoBloqueo = 'You do not have permissions to view or perform actions on this process.';
                                                    } else if (ctrl.language == "portugues") {
                                                        ctrl.motivoBloqueo = 'Não tem permissões para visualizar ou realizar ações neste processo';
                                                    } else if (ctrl.language == "italiano") {
                                                        ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                                                    }
                                                }
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.viewLoading = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.viewLoading = false;
                                        });

                                    ctrl.isCamposLoading = true;
                                    if (ctrl.model.Proceso.esMaestro) {
                                        var maestroCodigo = sharedService.getMaestroCodigo();
                                        dataService.getSolicitudCampoValorMaestroDefault(ctrl.model, maestroCodigo)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.camposList = response.data.Value;
                                                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                    ctrl.mostrarCamposBoton = true;
                                                    for (var i = 0; i < ctrl.camposList.length; i++) {
                                                        loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                                    }
                                                }
                                                ctrl.isBusy = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.isCamposLoading = false;
                                            ctrl.runModal();
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isCamposLoading = false;
                                        });
                                    } else {
                                        dataService.getSolicitudCampoValorDefault(ctrl.model)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.camposList = response.data.Value;
                                                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                    ctrl.mostrarCamposBoton = true;
                                                    for (var i = 0; i < ctrl.camposList.length; i++) {
                                                        loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                                    }
                                                }
                                                ctrl.isBusy = false;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.isCamposLoading = false;
                                            ctrl.runModal();
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isCamposLoading = false;
                                        });
                                    }

                                    ctrl.historialIsSearching = true;
                                    dataService.getSolicitudEtapaBySolicitud($stateParams.id)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                ctrl.historialSolicitud = response.data.Value;
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                            }
                                            ctrl.historialIsSearching = false;
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.historialIsSearching = false;
                                        });
                                    ctrl.getHistorialTrazabilidadSolicitud();
                                    fillStepsEtapas();
                                } else {
                                    ctrl.anularVista = true;
                                    if (ctrl.language == "español") {
                                        ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                    } else if (ctrl.language == "ingles") {
                                        ctrl.motivoBloqueo = 'Selected process load not found.';
                                    } else if (ctrl.language == "portugues") {
                                        ctrl.motivoBloqueo = 'Não foi encontrado o carregamento do processo selecionado.';
                                    } else if (ctrl.language == "italiano") {
                                        ctrl.motivoBloqueo = 'No se encuentra la carga de proceso seleccionado.';
                                    }
                                }
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.viewLoading = false;
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.viewLoading = false;
                        });
                } //Fin Load Datos Proceso View - Crear
                ctrl.isBusy = false;
            }

            ctrl.runModal = function () {
                if (ctrl.model != null && ctrl.model.Id == 0) {
                    if (ctrl.lProcesoIsDocumental && ctrl.lProcesoIsDocumentalAutorizacionesV2) {
                        ctrl.showModalDataContainer = true;
                        var htmlCode = document.getElementById("divContainerData");

                        var titleModal;
                        if (ctrl.language == "español")
                            titleModal = '<strong>Parámetros Iniciales</strong>';
                        else if (ctrl.language == "ingles")
                            titleModal = '<strong>Initial Parameters</strong>';
                        else if (ctrl.language == "portugues")
                            titleModal = '<strong>Parâmetros Iniciais</strong>';
                        else if (ctrl.language == "italiano")
                            titleModal = '<strong>Parametros Iniciales</strong>';

                        Swal.fire({
                            title: titleModal,
                            onOpen: function () {
                                //Swal.disableButtons();
                            },
                            type: 'warning',
                            html: htmlCode,
                            showCloseButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            showCancelButton: true,
                            focusConfirm: false,
                            confirmButtonText: ctrl.acceptText,
                            confirmButtonAriaLabel: ctrl.acceptText,
                            cancelButtonText: ctrl.cancelText,
                            cancelButtonColor: '#ff6a00c9',
                            heightAuto: false,
                            preConfirm: function () { }
                        }).then(function (result) {
                            if (result.dismiss != null && (result.dismiss == "cancel" || result.dismiss == "close")) {
                                ctrl.goListado();
                            }
                            if (result.value) {
                                validarDatosModal();
                            }
                        });
                    }
                }
            }

            function validarDatosModal() {
                var campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                var jerarquiaIdValor = 0;
                angular.forEach(ctrl.camposList, function (value, key) {
                    if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                        jerarquiaIdValor = value.Valor;
                        ctrl.isUserAbleToCreateDocument(campoIdAutorizacion, jerarquiaIdValor);
                    }
                });
                if (jerarquiaIdValor == 0) {
                    ctrl.runModal();
                }
            }

            ctrl.getHistorialTrazabilidadSolicitud = function () {
                ctrl.TrazabilidadSolicitud = [];
                ctrl.historialIsSearchingTrazabilidad = true;
                dataService.getSolicitudTrazabilidad(ctrl.model.ProcesoId, ctrl.model.Id, ctrl.model.Numero)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.TrazabilidadSolicitud = response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.historialIsSearchingTrazabilidad = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.historialIsSearchingTrazabilidad = false;
                    });

            }

            function getSolicitudCampos() {
                ctrl.isCamposLoading = true;
                ctrl.isBusy = true;
                if ($stateParams.id != undefined) {
                    if (ctrl.puedeEditarCampos) {
                        dataService.getSolicitudCampoValorCompleto($stateParams.id)
                            .then(function (response) {
                                if (response.data.Success) {
                                    ctrl.camposList = response.data.Value;
                                    if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                        ctrl.mostrarCamposBoton = true;
                                        for (var i = 0; i < ctrl.camposList.length; i++) {
                                            loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                        }
                                    }

                                    //TODO:HAVERJAN
                                    var campoIdAutorizacion = 0;
                                    campoIdAutorizacion = ctrl.model.Proceso.campoIdAutorizacion;
                                    var jerarquiaIdValor = 0;
                                    if (campoIdAutorizacion != 0) {
                                        angular.forEach(ctrl.camposList, function (value, key) {
                                            if (value.CampoId == campoIdAutorizacion && value.Valor != "") {
                                                jerarquiaIdValor = value.Valor;
                                                var jerarquiaItems = value.ValorObjeto;
                                                var jerarquiaTemp = null;
                                                angular.forEach(jerarquiaItems, function (value, key) {
                                                    if (value.Id == jerarquiaIdValor) {
                                                        jerarquiaTemp = value;
                                                    }
                                                });
                                                if (jerarquiaTemp.TieneJerarquiaPermisosCampos) {
                                                    dataService.getJerarquiaProcesoCampos(ctrl.model.ProcesoId, jerarquiaIdValor)
                                                        .then(function (response) {
                                                            // console.log(response);
                                                            if (response.data.Success) {
                                                                ctrl.procesoCamposListJerarquia = response.data.Value.Resultados;
                                                                ctrl.camposList = ctrl.camposList.filter(function (item) {
                                                                    return ctrl.procesoCamposListJerarquia.some(function (c) {
                                                                        return item.CampoId == c.campoId
                                                                    });
                                                                });
                                                            } else {
                                                                toastr.error(response.data.ErrorSummary);
                                                            }
                                                            ctrl.isSearching = false;
                                                        }, function (error) {
                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                            ctrl.isSearching = false;
                                                        });
                                                }
                                            }
                                        });
                                    }
                                    //GET AUTORIZACIONES!!!
                                    getJerarquiaAutorizaciones();
                                    ctrl.isBusy = false;

                                    // Esta porcion de codigo, se encarga de ejecutar todo  el guardado de los campos en solicitudCampoValor y obtener nuevamente la solicitud por Id, esto es porque fue la UNICA forma que encontramos para que las propiedades de ValorFiltro dentro de la solicitud, se llenaran, ya que por temas de tiempo para implementar, no tuvimos mucho  tiempo para buscar el  origen de  que no se mostraran los valores de los filtros
                                    // if (sharedService.getFirstSaveSolicitud() == true) {
                                    //     // Swal.fire({
                                    //     //     title: '',
                                    //     //     text: "Se está ejecutando un proceso, por favor espere",
                                    //     //     allowEscapeKey: false,
                                    //     //     allowOutsideClick: false,
                                    //     //     onOpen: function () {
                                    //     //         swal.showLoading();
                                    //     //     }
                                    //     // })

                                    //     ctrl.saveCamposSolicitud();

                                    //     dataService.getSolicitudById($stateParams.id)
                                    //         .then(function (response) {
                                    //             if (response.data.Success) {
                                    //                 ctrl.model = response.data.Value;
                                    //             } else {
                                    //                 toastr.error(response.data.ErrorSummary);
                                    //             }
                                    //         }, function (error) {
                                    //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                    //         });

                                    //     ctrl.isBusy = false;
                                    //     sharedService.setFirstSaveSolicitud(false);
                                    // } else {
                                    //     swal.close();
                                    // }

                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                }
                                ctrl.isCamposLoading = false;
                                ctrl.isBusy = false;
                            }, function (error) {
                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                ctrl.isCamposLoading = false;
                                ctrl.isBusy = false;
                            });
                    } else {
                        dataService.getSolicitudCampoValorTextosCompleto($stateParams.id)
                            .then(function (response) {
                                if (response.data.Success) {
                                    ctrl.camposList = response.data.Value;
                                    if (ctrl.camposList != null) {
                                        for (var i = 0; i < ctrl.camposList.length; i++) {
                                            loadProcesoCampoDataReadOnly(i, ctrl.camposList[i].Campo.CampoTipo);
                                        }
                                    }
                                    //GET AUTORIZACIONES!!!
                                    getJerarquiaAutorizaciones();
                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                }
                                ctrl.isCamposLoading = false;
                                ctrl.isBusy = false;
                            }, function (error) {
                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                ctrl.isCamposLoading = false;
                                ctrl.isBusy = false;
                            });
                    }
                }

            }

            function usuariosLogueadoIsAdminProceso(model, loggedUserId, roles) {
                var response = false;
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN') {
                            response = true;
                        }
                    }

                    var rolId = "6";
                    ctrl.lsuarioLogueadoIsLectorOnly = checkifUserhasOneRol(rolId, roles);
                    rolId = "7";
                    ctrl.lsuarioLogueadoIsNoCreateOnly = checkifUserhasOneRol(rolId, roles);

                }
                return response;
            }


            function usuariosLogueadoIsEditor(model, loggedUserId, roles) {
                var response = false;
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'Admin-Editor') {
                            response = true;
                        }
                    }
                }
                return response;
            }

            function checkifUserhasOneRol(rolId, roles) {
                if (roles != null && roles.length > 0) {
                    if (roles.length == 1) {
                        for (var i = 0; i < roles.length; i++) {
                            if (roles[i].Id == rolId) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }

            function etapaActualProcesaHijos(model, loggedUserId, roles) {
                var response = false;
                angular.forEach(model.Proceso.EtapasNombres, function (value, key) {
                    if (value.NombreEtapa == model.SolicitudEtapaNombre) {
                        response = value.procesoHijo;

                        if (response) {
                            if (sharedService.isSysAdminLoggedUser() || loggedUserId == model.UsuarioAprobadorId) {
                                response = true;
                            } else {
                                response = false;
                            }

                            if (roles != null && roles.length > 0) {
                                for (var i = 0; i < roles.length; i++) {
                                    if (roles[i].Codigo == 'ADMIN')
                                        response = true;
                                }
                            }

                        }

                    }
                });
                return response;
            };

            function showForzarCierreEtapa(model) {
                var response = false;
                angular.forEach(model.Proceso.EtapasNombres, function (value, key) {
                    if (value.NombreEtapa == model.SolicitudEtapaNombre) {
                        response = value.forzarCierre;
                    }
                });
                return response;
            };

            // ctrl.closeModal = function () {
            //     if (sharedService.getIsBusyIframe()) return;

            //     $('.modal-solicitud').removeClass('active');
            //     $('.modal-solicitud iframe').remove();
            //     sharedService.setIframeSolicitudActivo(false);
            //     $state.reload();
            // }

            ctrl.agregarSolicitudHijo = function () {
                if (ctrl.model.Proceso.AceptaHijos == null || !ctrl.model.Proceso.AceptaHijos) {
                    var titleModal, errorText;
                    if (ctrl.language == "español") {
                        titleModal = "Selección de Proceso para el Proceso Hijo"
                        errorText = "No puede agregar hijos a un proceso que no acepta hijos"
                    }
                    else if (ctrl.language == "ingles") {
                        titleModal = "Process Selection for the associated Process"
                        errorText = "If a process does not accept associates, it will not be able to relate them"
                    }
                    else if (ctrl.language == "portugues") {
                        titleModal = "Seleção de Processo para o Processo Filho"
                        errorText = "Não é possível adicionar filhos a um processo que não aceita filhos"
                    }
                    else if (ctrl.language == "italiano") {
                        titleModal = "Selección de Proceso para el Proceso Hijo"
                        errorText = "No puede agregar hijos a un proceso que no acepta hijos"
                    }

                    toastr.error(errorText);
                    return;
                }

                ctrl.isBusy = true;

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "seleccionProceso",
                    resolve: {
                        title: function () {
                            return titleModal;
                        },
                        aceptaHijos: function () {
                            return ctrl.model.Proceso.AceptaHijos
                        },
                        procesoPadreId: function () {
                            return ctrl.model.Proceso.Id
                        },
                    }
                });

                confirmation.result.then(function (returnValue) {
                    ctrl.isBusy = false;
                    var absHost = $location.absUrl();

                    //var urlTogo =  "http://localhost:3000/#/solicitud/edit/0/0/16/7282
                    var arrayHost = absHost.split("#");
                    absHost = arrayHost[0];

                    absHost = absHost + "#/solicitud/edit/0/0/" + returnValue.ProcesoSeleccionado.Id + "/" + ctrl.model.Id;

                    // sharedService.setIframeSolicitudActivo(true);
                    // var modalSolicitud = $('.modal-solicitud');

                    // modalSolicitud.append('<iframe src=' + absHost + ' frameborder="0"><iframe/>');

                    // modalSolicitud.addClass('active');

                    // window.open(absHost, '', 'width=1000,height=600,top=50,left=100,status=no,toolbar=no,menubar=no,location=no');

                    window.open(absHost, '_blank');
                    /*$state.go("pages.solicitud-edit", {
                        id: 0,
                        grupo: returnValue.GrupoSeleccionado.Id,
                        proceso: returnValue.ProcesoSeleccionado.Id,
                        solicitudPadreId: ctrl.model.Id
                    });*/
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.buscarSolicitudesHijo = function () {
                ctrl.solicitudesHijoIsSearching = true;
                dataService.getSolicitudesByPadre($stateParams.id, ctrl.verTodosProcesosAsociados)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.solicitudesHijoList = response.data.Value;
                            if (ctrl.solicitudesHijoList) {
                                Object.keys(ctrl.solicitudesHijoList).length > 0
                                    ? ctrl.showIconProcesosAsociados = true
                                    : ctrl.showIconProcesosAsociados = false;
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.solicitudesHijoIsSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.solicitudesHijoIsSearching = false;
                    });
            }

            ctrl.buscarTemplatesCargados = function buscarTemplatesCargados(tableState) {
                ctrl.templateCargadosIsSearching = true;
                var cargadosFilter = {};
                cargadosFilter.SolicitudId = $stateParams.id;

                if (tableState.search.predicateObject != null) {
                    cargadosFilter.Titulo = tableState.search.predicateObject.Resumen;
                    cargadosFilter.SolicitudEtapaNombre = tableState.search.predicateObject.SolicitudEtapaNombre;
                    cargadosFilter.Template = tableState.search.predicateObject.Template;
                    cargadosFilter.LastUpdate = tableState.search.predicateObject.LastUpdate;
                    cargadosFilter.UsuarioModificacion = tableState.search.predicateObject.UsuarioModificacion;
                }

                if (tableState.sort != null) {
                    cargadosFilter.OrderFieldName = tableState.sort.predicate;
                    cargadosFilter.OrderAscending = !tableState.sort.reverse;
                }

                dataService.getCargadosBySolicitudList(cargadosFilter)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.templatesCargadosList = response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.templateCargadosIsSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.templateCargadosIsSearching = false;
                    });
            }

            ctrl.totalProcesosHijo = function () {
                return (ctrl.solicitudesHijoList != null && Object.keys(ctrl.solicitudesHijoList).length > 1);
            }

            ctrl.borrarSolicitudPadre = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    var errorTitle;
                    if (ctrl.language == "español")
                        errorTitle = 'Debe seleccionar un proceso para poder eliminarlo';
                    else if (ctrl.language == "ingles")
                        errorTitle = "You must select a process to delete it";
                    else if (ctrl.language == "portugues")
                        errorTitle = 'Deve selecionar um processo para excluí-lo';
                    else if (ctrl.language == "italiano")
                        errorTitle = 'Debe seleccionar un proceso para poder eliminarlo';

                    toastr.error(errorTitle);
                    return;
                }

                ctrl.model.SolicitudPadre = null;
                ctrl.model.SolicitudPadreId = null;

                ctrl.solicitudesPadreList = [];
            }

            ctrl.verSolicitudPadre = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    var errorTitle;
                    if (ctrl.language == "español")
                        errorTitle = 'Debe seleccionar un proceso para poder visualizarlo';
                    else if (ctrl.language == "ingles")
                        errorTitle = "You must select a process to view it";
                    else if (ctrl.language == "portugues")
                        errorTitle = 'Deve selecionar um processo para visualizá-lo';
                    else if (ctrl.language == "italiano")
                        errorTitle = 'Debe seleccionar un proceso para poder visualizarlo';

                    toastr.error(errorTitle);
                    return;
                }

                $state.go("pages.solicitud-edit", {
                    id: solicitudSeleccionada.Id,
                    grupo: solicitudSeleccionada.Proceso.GrupoId,
                    proceso: solicitudSeleccionada.ProcesoId,
                    solicitudPadreId: 0
                });
            }

            ctrl.verSolicitudHijo = function (solicitudSeleccionada) {
                if (solicitudSeleccionada == null || solicitudSeleccionada.Id <= 0) {
                    var errorTitle;
                    if (ctrl.language == "español")
                        errorTitle = 'Debe seleccionar un proceso para poder visualizarlo';
                    else if (ctrl.language == "ingles")
                        errorTitle = "You must select a process to view it";
                    else if (ctrl.language == "portugues")
                        errorTitle = 'Deve selecionar um processo para visualizá-lo';
                    else if (ctrl.language == "italiano")
                        errorTitle = 'Debe seleccionar un proceso para poder visualizarlo';

                    toastr.error(errorTitle);
                    return;
                }

                $state.go("pages.solicitud-edit", {
                    id: solicitudSeleccionada.Id,
                    grupo: solicitudSeleccionada.Proceso.GrupoId,
                    proceso: solicitudSeleccionada.ProcesoId,
                    solicitudPadreId: 0
                });
            }

            function mostrarAprobacion(solicitud, loggedUserId, roles) {
                if (solicitud == null || solicitud.Id == 0)
                    return false;

                if (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR')
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                if (solicitud.Estado.Codigo == 'ALTA' &&
                    loggedUserId != null && loggedUserId == solicitud.UsuarioCreacionId)
                    return true;

                // if (solicitud.UsuarioAprobadorId == null)
                //   return true;

                if (loggedUserId != null && loggedUserId == solicitud.UsuarioAprobadorId)
                    return true;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN')
                            return true;
                    }
                }

                return false;
            }

            ctrl.mostrarControlesAprobacion = function (solicitudEstadoCodigo) {
                return (solicitudEstadoCodigo == 'GENE' ||
                    solicitudEstadoCodigo == 'ACEP' ||
                    solicitudEstadoCodigo == 'VALI' ||
                    solicitudEstadoCodigo == 'VERI');
            }

            ctrl.mostrarComboSiguienteEstado = function (solicitudEstadoCodigo) {
                return (solicitudEstadoCodigo == 'GENE' ||
                    solicitudEstadoCodigo == 'ACEP' ||
                    solicitudEstadoCodigo == 'VALI' ||
                    solicitudEstadoCodigo == 'VERI');
            }

            ctrl.puedeEditarDescripcion = function (solicitud) {
                return (ctrl.puedeEditarSolicitud &&
                    !(solicitud.Proceso.ConfiguracionTitulo != null && solicitud.Proceso.ConfiguracionTitulo.length > 0));
            }

            ctrl.puedeRetrocederEstado = function (solicitud) {
                return (ctrl.mostrarAprobacion &&
                    !ctrl.anularVista &&
                    ctrl.anteriorEstadoSolicitud != null && ctrl.anteriorEstadoSolicitud.Id > 0 &&
                    solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo != 'ALTA' &&
                    solicitud.Estado.Codigo != 'APRO' &&
                    solicitud.Estado.Codigo != 'CERR');
            }

            ctrl.puedeAvanzarEstado = function (solicitud) {
                return (ctrl.mostrarAprobacion &&
                    !ctrl.anularVista &&
                    ctrl.siguienteEstadoSolicitud != null && ctrl.siguienteEstadoSolicitud.Id > 0 &&
                    solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo != 'APRO' &&
                    solicitud.Estado.Codigo != 'CERR');
            }


            function userIsSupervisor(solicitud, roles, loggedUserId) {
                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        //if (roles[i].Codigo == 'ADMIN') {
                        //esAdmin = true;
                        //break;
                        //}
                        // if (roles[i].Codigo == 'LECTOR')
                        //   esLector = true;
                        if (roles[i].Codigo == 'SUPERV') {
                            return true;
                        }
                        // if (roles[i].Codigo == 'GESTOR' &&
                        //     solicitud.Estado.Codigo == 'ACEP')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'VERIF' &&
                        //     solicitud.Estado.Codigo == 'VALI')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'APROB' &&
                        //     solicitud.Estado.Codigo == 'VERI')
                        //   esUsuarioAutorizador = true;
                    }
                }

                //return true;
                return false;
            }

            function puedeEditarSolicitud(solicitud, roles, loggedUserId) {
                //Si la solicitud es nueva y tiene algun rol dentro del proceso, puede crearla
                if ((solicitud == null || solicitud.Id == 0) && (roles != null && roles.length > 0))
                    return true;

                //No puede hacer nada si la solicitud se aprobo o cerro
                if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                //Si la solicitud esta en la primer etapa y el usuario logueado es el creador de la solicitud, puede editarla
                if (solicitud != null && solicitud.Id > 0 &&
                    solicitud.Estado.Codigo == 'ALTA' &&
                    loggedUserId == solicitud.UsuarioCreacionId)
                    return true;

                var esAdmin = false;
                // var esLector = false;
                // var esUsuarioAutorizador = false;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN') {
                            esAdmin = true;
                            break;
                        }

                        // if (roles[i].Codigo == 'LECTOR')
                        //   esLector = true;

                        // if (roles[i].Codigo == 'SUPERV' &&
                        //     solicitud.Estado.Codigo == 'GENE')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'GESTOR' &&
                        //     solicitud.Estado.Codigo == 'ACEP')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'VERIF' &&
                        //     solicitud.Estado.Codigo == 'VALI')
                        //   esUsuarioAutorizador = true;

                        // if (roles[i].Codigo == 'APROB' &&
                        //     solicitud.Estado.Codigo == 'VERI')
                        //   esUsuarioAutorizador = true;
                    }
                }

                //Si es admin, puede editarlo en cualquier momento
                if (esAdmin)
                    return true;

                // if (esUsuarioAutorizador)
                //   return true;                

                //return true;
                return false;
            }

            function puedeEditarCampos(solicitud, usuarioCreacionId, loggedUserId, roles) {
                //No puede hacer nada si la solicitud se aprobo o cerro
                if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                    return false;

                if (sharedService.isSysAdminLoggedUser())
                    return true;

                if (roles != null && roles.length > 0) {
                    for (var i = 0; i < roles.length; i++) {
                        if (roles[i].Codigo == 'ADMIN')
                            return true;
                    }
                }

                //HAVERJAN..
                return (solicitud != null && solicitud.Estado.Codigo == 'ALTA' && usuarioCreacionId == loggedUserId);
            }

            function puedeCargarTemplates(solicitud, roles, loggedUserId) {
                //Si la solicitud es nueva y tiene algun rol dentro del proceso, puede crearla
                return true;
                // if (solicitud == null || solicitud.Id == 0)
                //     return false;

                // //No puede hacer nada si la solicitud se aprobo o cerro
                // if (solicitud != null && (solicitud.Estado.Codigo == 'APRO' || solicitud.Estado.Codigo == 'CERR'))
                //     return false;

                // if (sharedService.isSysAdminLoggedUser())
                //     return true;

                // return (roles != null && roles.length > 0);
            }

            function mostrarTemplates() {
                return true;
                // return (ctrl.templatesPendientesList != null && ctrl.templatesPendientesList.length > 0);
            }

            ctrl.showConfirmar = function () {
                if (ctrl.model.Estado.Id > 0)
                    return true;
                else
                    return false;
            }

            ctrl.getFecha = function () {
                var fecha = new Date();

                var dd = fecha.getDate();
                var mm = fecha.getMonth() + 1;
                var yyyy = fecha.getFullYear();

                if (dd < 10) {
                    dd = '0' + dd
                }

                if (mm < 10) {
                    mm = '0' + mm
                }

                fecha = dd + '/' + mm + '/' + yyyy;
                return fecha;
            }

            function validateMandatoryFields() {
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        var nombre = ctrl.camposList[i].Campo.Nombre;
                        var lastCharacter = nombre.slice(-1);
                        if (lastCharacter == "*") {
                            var ValorObjeto = ctrl.camposList[i].ValorObjeto;
                            var Valor = ctrl.camposList[i].Valor;
                            if ((Valor == null || Valor == "") && (ValorObjeto == null || ValorObjeto == "")) {
                                return false;
                            }
                        }
                    }
                }
                return true;
            }

            ctrl.createSolicitud = function () {
                ctrl.isBusy = true;
                // sharedService.setIsBusyIframe(true);
                // sharedService.setFirstSaveSolicitud(true);

                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                    ctrl.preSaveCamposSolicitud(); //Fix Error Constraint!
                }

                //funciton de validacion de campos obligatorios.
                // if (!validateMandatoryFields()) {
                //     ctrl.isBusy = false;
                //     toastr.error("Hay Datos Obligatorios no cumplidos.");
                //     return;
                // }

                // Swal.fire({
                //     title: '',
                //     text: "Se está ejecutando un proceso, por favor espere",
                //     allowEscapeKey: false,
                //     allowOutsideClick: false,
                //     onOpen: function () {
                //         swal.showLoading();
                //     }
                // })

                // console.log(ctrl.camposList);

                dataService.checkSolicitudCampoValor(ctrl.camposList)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == true) {
                                dataService.saveSolicitud(ctrl.model)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            // Guardando la propiedad Proceso de la Solicitud para ser usada al guardar los SolicitudCampoValor
                                            ctrl.procesoPadre = ctrl.model.Proceso;
                                            ctrl.model = response.data.Value;
                                            // swal.close();
                                            if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                ctrl.saveCamposSolicitud();
                                            } else {
                                                // sharedService.setIsBusyIframe(false);
                                                toastr.info(ctrl.successfulRegistration);
                                                // if (ctrl.iframeSolicitudActivo) {
                                                //     swal.close();
                                                //     Swal.fire({
                                                //         title: '',
                                                //         text: "Proceso finalizado, puede cerrar la ventana",
                                                //         allowEscapeKey: false,
                                                //         allowOutsideClick: false,
                                                //         showConfirmButton: false,
                                                //         icon: "success"
                                                //     })
                                                //     ctrl.isBusy = false;
                                                //     return;
                                                // }

                                                ctrl.isBusy = false;
                                                $state.go("pages.solicitud-edit", {
                                                    id: ctrl.model.Id,
                                                    grupo: $stateParams.grupo,
                                                    proceso: $stateParams.proceso,
                                                    solicitudPadreId: 0
                                                });
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            // sharedService.setIsBusyIframe(false);
                                            // sharedService.setFirstSaveSolicitud(false);
                                            ctrl.isBusy = false;
                                            swal.close();
                                        }
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        // // sharedService.setIsBusyIframe(false);
                                        ctrl.isBusy = false;
                                        swal.close();
                                    });
                            } else {
                                ctrl.active = 1;
                                // sharedService.setIsBusyIframe(false);
                                // sharedService.setFirstSaveSolicitud(false);
                                ctrl.isBusy = false;
                                swal.close();
                            }
                        } else {
                            ctrl.active = 1;
                            toastr.error(response.data.ErrorSummary);
                            // sharedService.setIsBusyIframe(false);
                            // sharedService.setFirstSaveSolicitud(false);
                            ctrl.isBusy = false;
                            swal.close();
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        // sharedService.setIsBusyIframe(false);
                        // sharedService.setFirstSaveSolicitud(false);
                        ctrl.isBusy = false;
                        swal.close();
                    });
                ctrl.active = 0;
            }

            ctrl.saveObsoleto = function () {
                ctrl.isBusy = true;
                dataService.saveObsoleto(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            toastr.info(ctrl.successfulRegistration);
                            ctrl.getHistorialTrazabilidadSolicitud();
                            $state.reload();
                            /*$state.go("pages.solicitud-edit", {
                                id: ctrl.model.Id,
                                grupo: $stateParams.grupo,
                                proceso: $stateParams.proceso,
                                solicitudPadreId: 0
                            });*/
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveSolicitud = function () {
                ctrl.isBusy = true;

                dataService.saveSolicitud(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            toastr.info(ctrl.successfulRegistration);

                            $state.go("pages.solicitud-edit", {
                                id: ctrl.model.Id,
                                grupo: $stateParams.grupo,
                                proceso: $stateParams.proceso,
                                solicitudPadreId: 0
                            });
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveSolicitudVersion = function () {
                ctrl.isBusy = true;
                ctrl.active = 0;
                dataService.saveSolicitudVersion(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            ctrl.isBusy = false;

                            var respon;
                            if (ctrl.language == "español")
                                respon = "Se ha creado la nueva version de la solicitud con numero: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "ingles")
                                respon = "The new version of the request has been created with number: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "portugues")
                                respon = "Foi criada a nova versão da solicitação com número: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "italiano")
                                respon = "Se ha creado la nueva version de la solicitud con numero: " + ctrl.model.NumeroCompleto;

                            toastr.info(respon);
                            ctrl.goListado();
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            ctrl.isBusy = false;
                            $state.reload();
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                    });
            }

            ctrl.saveCrearCopia = function () {
                ctrl.isBusy = true;
                ctrl.active = 0;
                dataService.saveSolicitudCopia(ctrl.model)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model = response.data.Value;
                            var respon;
                            if (ctrl.language == "español")
                                respon = "Se ha creado la nueva solicitud con numero: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "ingles")
                                respon = "The new request has been created with number: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "portugues")
                                respon = "Foi criada a nova solicitação com número: " + ctrl.model.NumeroCompleto;
                            else if (ctrl.language == "italiano")
                                respon = "Se ha creado la nueva solicitud con numero: " + ctrl.model.NumeroCompleto;

                            toastr.info(respon);
                            ctrl.isBusy = false;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            ctrl.isBusy = false;
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                    });
            }

            ctrl.preSaveCamposSolicitud = function () {
                ctrl.isBusy = true;
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        ctrl.camposList[i].SolicitudId = ctrl.model.Id;
                        ctrl.camposList[i].Solicitud = ctrl.model;
                        switch (ctrl.camposList[i].Campo.CampoTipo.Codigo) {
                            case 'TEXTENR':
                                var tmpValor = ctrl.camposList[i].ValorObjeto;
                                //tmpValor == '' ? ctrl.camposList[i].ValorObjeto:ctrl.camposList[i].Valor;
                                //tmpValor == '' || tmpValor ==  null ? ctrl.camposList[i].ValorObjeto:ctrl.camposList[i].Valor;
                                if (tmpValor != "" && tmpValor != null) {
                                    var colors = sharedService.getArrayColors(tmpValor);
                                    var lColor, lColorRGB;
                                    angular.forEach(colors, function (value, key) {
                                        lColorRGB = colors[key];
                                        if (!lColorRGB.startsWith('#')) {
                                            lColor = sharedService.RGB2Hex(colors[key]);
                                            //ctrl.camposList[i].Valor  = ctrl.camposList[i].Valor.replace(lColorRGB, lColor);
                                            ctrl.camposList[i].ValorObjeto = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            /*if (ctrl.camposList[i].ValorObjeto != null && ctrl.camposList[i].ValorObjeto!= ""){
                                                ctrl.camposList[i].ValorObjeto  = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            }*/
                                        }
                                    });
                                }
                                break;
                            case 'TABLE':
                                // console.log("entro.. TABLE");
                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                break;
                            case 'TABLEENR':
                                // console.log("entro.. TABLEENR----------------------------");
                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                if (Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                } else if (Object.prototype.toString.call(ctrl.camposList[i].TablaFilas[j].Valor[k]) === '[object Date]') {
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                } else if (typeof ctrl.camposList[i].TablaFilas[j].Valor[k] === 'object' && ctrl.camposList[i].TablaFilas[j].Valor[k] !== null && !Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    if (ctrl.camposList[i].TablaFilas[j].Valor[k].Id) {
                                                        // Si dentro del valor, encuentras una prop Id, es un campo tipo LIST y sólo hace falta el Id, ya que se muestra en un <select>
                                                        colValor += ctrl.camposList[i].TablaFilas[j].Valor[k].Id;
                                                        // Guardando sólo el Id como número siempre en el valor de TablaFilas
                                                        ctrl.camposList[i].TablaFilas[j].Valor[k] = Number(ctrl.camposList[i].TablaFilas[j].Valor[k].Id);
                                                    } else {
                                                        // Si no, es un campo tipo MULTI_LIST, por lo que se eliminan las propiedades usadas por el front para que se limpie el registro y se pasa a texto
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].TextoBusqueda;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].jerarquiaPadreId;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].SourceObjetoTemp;

                                                        colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                    }
                                                }
                                                else {
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                }
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }

                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                // console.log("DATA TO SAVE TABLE ENR------");
                                // console.log(ctrl.camposList[i].Valor);
                                break;
                            case 'COND':
                                var tmpValorObjeto = ctrl.camposList[i].ValorObjeto;
                                try {
                                    var filaValor = "";
                                    if (ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "ATTACH" ||
                                        ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "IMG") {
                                        filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                        filaValor += "~";
                                        filaValor += tmpValorObjeto;
                                    } else {
                                        if (ctrl.camposList[i].TablaFilas != null) {
                                            try {
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                                filaValor += "~";
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                                            } catch (exception) {
                                                filaValor += "";
                                            }
                                        }
                                    }
                                } catch (ex) {
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                filaValor = "";
                                break;
                        }
                    }
                }
            }

            ctrl.saveCamposSolicitud = function () {
                ctrl.isBusy = true;
                ctrl.isBusyBlocked = true;
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        ctrl.camposList[i].SolicitudId = ctrl.model.Id;
                        ctrl.camposList[i].Solicitud = ctrl.model;
                        ctrl.camposList[i].Solicitud.Proceso = ctrl.procesoPadre;
                        switch (ctrl.camposList[i].Campo.CampoTipo.Codigo) {
                            case 'TEXTENR':
                                var tmpValor = ctrl.camposList[i].ValorObjeto;
                                if (tmpValor != "" && tmpValor != null) {
                                    var colors = sharedService.getArrayColors(tmpValor);
                                    var lColor, lColorRGB;
                                    angular.forEach(colors, function (value, key) {
                                        lColorRGB = colors[key];
                                        if (!lColorRGB.startsWith('#')) {
                                            lColor = sharedService.RGB2Hex(colors[key]);
                                            ctrl.camposList[i].ValorObjeto = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            if (ctrl.camposList[i].Valor != null && ctrl.camposList[i].Valor != "") {
                                                ctrl.camposList[i].Valor = ctrl.camposList[i].Valor.replace(lColorRGB, lColor);
                                            }
                                        }
                                    });
                                }
                                break;
                            case 'TABLE':
                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                break;
                            case 'TABLEENR':
                                // console.log("Ingreso a TABLE ENR");
                                // console.log(ctrl.camposList[i].TablaFilas);

                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            // console.log("FIR NUL!!!!");
                                            // console.log(ctrl.camposList[i].TablaFilas[j].Valor);

                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                if (Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    // console.log("ES UN ARRAY!!!!");
                                                    // console.log(JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]));
                                                    colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                } else if (Object.prototype.toString.call(ctrl.camposList[i].TablaFilas[j].Valor[k]) === '[object Date]') {
                                                    // console.log(" ES LA FECHYA!!!");
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                } else if (typeof ctrl.camposList[i].TablaFilas[j].Valor[k] === 'object' && ctrl.camposList[i].TablaFilas[j].Valor[k] !== null && !Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    // console.log("ES UN OBJECT");
                                                    // console.log(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                    if (ctrl.camposList[i].TablaFilas[j].Valor[k].Id) {
                                                        // Si dentro del valor, encuentras una prop Id, es un campo tipo LIST y sólo hace falta el Id, ya que se muestra en un <select>
                                                        colValor += ctrl.camposList[i].TablaFilas[j].Valor[k].Id;
                                                        // Guardando sólo el Id como número siempre en el valor de TablaFilas
                                                        ctrl.camposList[i].TablaFilas[j].Valor[k] = Number(ctrl.camposList[i].TablaFilas[j].Valor[k].Id);
                                                    } else {
                                                        // Si no, es un campo tipo MULTI_LIST, por lo que se eliminan las propiedades usadas por el front para que se limpie el registro y se pasa a texto
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].TextoBusqueda;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].jerarquiaPadreId;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].SourceObjetoTemp;

                                                        colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                    }
                                                }
                                                else {
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                }
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }

                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                // console.log(ctrl.camposList);
                                break;
                            case 'COND':
                                var tmpValorObjeto = ctrl.camposList[i].ValorObjeto;
                                try {
                                    var filaValor = "";
                                    if (ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "ATTACH" ||
                                        ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "IMG") {
                                        filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                        filaValor += "~";
                                        filaValor += tmpValorObjeto;
                                    } else {
                                        if (ctrl.camposList[i].TablaFilas != null) {
                                            try {
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                                filaValor += "~";
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                                            } catch (exception) {
                                                filaValor += "";
                                            }
                                        }
                                    }
                                } catch (ex) {
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                filaValor = "";
                                break;
                        }
                    }
                }

                if (ctrl.camposTableEnr.length > 0) {
                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                        campoTableEnr.TablaFilas = ctrl.camposList[campoTableEnr.index].TablaFilas;
                        campoTableEnr.Campo = ctrl.camposList[campoTableEnr.index].Campo;
                        campoTableEnr.SolicitudId = ctrl.model.Id;
                        return campoTableEnr;
                    });
                }

                orderCamposList();

                /*
                 * Guadar la solicitud con sus campos y valores.
                 */
                dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                    .then(function (response) {
                        if (response.data.Success) {
                            // ctrl.camposList = response.data.Value;

                            ctrl.camposList = ctrl.camposList.map(function (campo) {
                                response.data.Value.map(function (campoResult) {
                                    if (campoResult.CampoId == campo.CampoId)
                                        campo.Id = campoResult.Id;
                                    // Actualizando el valor del Id generado por el backend a los campos cargados en memoria, esto se hizo con el fin de no generar codigo extra, porque el backend retorna datos en null como "Campo", "UsuarioModificacion" y "Solicitud" que son necesarios para realizar una segunda peticion POST, por ende, como estos datos estan en memoria, no se puede igualar la respuesta del backend, sino sólo actualizar los Id
                                })

                                if (campo.Campo.CampoId == "QRPAGE")
                                    ctrl.fileForQR.qrPage = campo.ValorObjeto;

                                if (campo.Campo.CampoId == "QRPOSX")
                                    ctrl.fileForQR.qrPosX = campo.ValorObjeto.toString().replace('.', ',');

                                if (campo.Campo.CampoId == "QRPOSY")
                                    ctrl.fileForQR.qrPosY = campo.ValorObjeto.toString().replace('.', ',');

                                if (campo.Campo.CampoId == "QRMEDIDA")
                                    ctrl.fileForQR.qrSize = campo.ValorObjeto.toString().replace('.', ',');

                                // Para aprovechar este ciclo, por performance, capturo los datos que necesitaré enviar al backend para la posición del segundo QR en el documento PDF final, en caso de que venga un valor decimal, reemplazo el punto por una coma, porque el servidor está configurado en Latinoamérica, por ende se utiliza la coma en lugar del punto
                                return campo;
                            })

                            orderCamposList();

                            // console.log(ctrl.fileForQR);

                            if (ctrl.generaProcesoRelacionados) {

                                var modalText;
                                if (ctrl.language == "español")
                                    modalText = "Se está ejecutando un proceso, por favor espere";
                                else if (ctrl.language == "ingles")
                                    modalText = "A process is running, please wait";
                                else if (ctrl.language == "portugues")
                                    modalText = "Um processo está sendo executado, aguarde";
                                else if (ctrl.language == "italiano")
                                    modalText = "Se está ejecutando un proceso, por favor espere";

                                Swal.fire({
                                    title: '',
                                    text: modalText,
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    onOpen: function () {
                                        swal.showLoading();
                                    }
                                })

                                if (ctrl.camposTableEnr.length > 0) {
                                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                                        campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                                        delete campoTableEnr.index
                                        return campoTableEnr;
                                    });
                                    
                                    dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            dataService.SaveSolicitudCampoValorGeneraProcesos(ctrl.camposListOrdered)
                                            .then(function (response) {
                                                if (response.data.Success) {
                                                    var solicitudId = ctrl.model.Id;

                                                    // Aqui se va a hacer el UploadFile
                                                    if (ctrl.fileForQRTouched) {
                                                        ctrl.camposList.map(function (campo) {
                                                            if (campo.CampoId == ctrl.fileForQR.campoId) {
                                                                dataService.updateFileSolicitudCampoValor(
                                                                    ctrl.fileForQR.file,
                                                                    ctrl.fileForQR.campoId,
                                                                    solicitudId,
                                                                    ctrl.fileForQR.ip,
                                                                    ctrl.fileForQR.dispositivo,
                                                                    ctrl.fileForQR.qrPage,
                                                                    ctrl.fileForQR.qrPosX,
                                                                    ctrl.fileForQR.qrPosY,
                                                                    ctrl.fileForQR.qrSize
                                                                )
                                                                    .then(function (response) {
                                                                        if (response.data.Success) {
                                                                            var fileName = response.data.Value;

                                                                            dataService.getSolicitudCampoValorCompleto(solicitudId)
                                                                                .then(function (response) {
                                                                                    if (response.data.Success) {
                                                                                        ctrl.camposList = response.data.Value.map(function (campoActualizado) {
                                                                                            // Dandole al campo el valor del nombre del archivo generado por el backend
                                                                                            if (campoActualizado.CampoId == ctrl.fileForQR.campoId) {
                                                                                                campoActualizado.Valor = fileName;
                                                                                                campoActualizado.ValorObjeto = fileName;
                                                                                            }

                                                                                            // Dandole a los campos actualizados la entidad Solicitud, que es necesaria para el guardado de SolicitudCampoValor. Esta propiedad es identica en todos los campos de una solicitud, por eso se usa la misma para todos
                                                                                            campoActualizado.Solicitud = campo.Solicitud;

                                                                                            return campoActualizado;
                                                                                        })

                                                                                        updateCampoValorFile(solicitudId, fileName);

                                                                                        orderCamposList();

                                                                                        dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                                                                                            .then(function (response) {
                                                                                                if (response.data.Success) {

                                                                                                    // if (ctrl.iframeSolicitudActivo) {
                                                                                                    //     // sharedService.setIsBusyIframe(false);
                                                                                                    //     Swal.fire({
                                                                                                    //         title: '',
                                                                                                    //         text: "Proceso finalizado, puede cerrar la ventana",
                                                                                                    //         allowEscapeKey: false,
                                                                                                    //         allowOutsideClick: false,
                                                                                                    //         showConfirmButton: false,
                                                                                                    //         icon: "success"
                                                                                                    //     })
                                                                                                    //     ctrl.isBusy = false;
                                                                                                    //     return;
                                                                                                    // }

                                                                                                    toastr.info(ctrl.successfulRegistration);
                                                                                                    swal.close();
                                                                                                    ctrl.isBusy = false;
                                                                                                    ctrl.isBusyBlocked = false;
                                                                                                    
                                                                                                    if (ctrl.isNew) {
                                                                                                        $state.go("pages.solicitud-edit", {
                                                                                                            id: ctrl.model.Id,
                                                                                                            grupo: $stateParams.grupo,
                                                                                                            proceso: $stateParams.proceso,
                                                                                                            solicitudPadreId: 0
                                                                                                        });
                                                                                                    } else {
                                                                                                        $state.reload();
                                                                                                    }

                                                                                                } else {
                                                                                                    swal.close();
                                                                                                    toastr.error(response.data.ErrorSummary);
                                                                                                    ctrl.isBusy = false;
                                                                                                    ctrl.isBusyBlocked = false;
                                                                                                    // sharedService.setFirstSaveSolicitud(false);
                                                                                                }
                                                                                            })
                                                                                    } else {
                                                                                        ctrl.active = 1;
                                                                                        // sharedService.setFirstSaveSolicitud(false);
                                                                                        toastr.error(response.data.ErrorSummary);
                                                                                        ctrl.fileForQRTouched = true;
                                                                                        swal.close();
                                                                                        ctrl.isBusy = false;
                                                                                        ctrl.isBusyBlocked = false;
                                                                                    }
                                                                                }, function (error) {
                                                                                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                                    ctrl.isBusy = false;
                                                                                    ctrl.isBusyBlocked = false;
                                                                                    campo.isLoading = false;
                                                                                    swal.close();
                                                                                });
                                                                        } else {
                                                                            ctrl.active = 1;
                                                                            // sharedService.setFirstSaveSolicitud(false);
                                                                            toastr.error(response.data.ErrorSummary);
                                                                            ctrl.fileForQRTouched = true;
                                                                            swal.close();
                                                                            ctrl.isBusy = false;
                                                                            ctrl.isBusyBlocked = false;
                                                                        }
                                                                        campo.isLoading = false;
                                                                    }, function (error) {
                                                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                        ctrl.isBusy = false;
                                                                        campo.isLoading = false;
                                                                        ctrl.isBusyBlocked = false;
                                                                        swal.close();
                                                                    });
                                                            }
                                                        })
                                                    } else {

                                                        // if (ctrl.iframeSolicitudActivo) {
                                                        //     // sharedService.setIsBusyIframe(false);
                                                        //     Swal.fire({
                                                        //         title: '',
                                                        //         text: "Proceso finalizado, puede cerrar la ventana",
                                                        //         allowEscapeKey: false,
                                                        //         allowOutsideClick: false,
                                                        //         showConfirmButton: false,
                                                        //         icon: "success"
                                                        //     })
                                                        //     ctrl.isBusy = false;
                                                        //     return;
                                                        // }
                                                        toastr.info(ctrl.successfulRegistration);
                                                        swal.close();
                                                        ctrl.isBusy = false;
                                                        ctrl.isBusyBlocked = false;
            
                                                        if (ctrl.isNew) {
                                                            $state.go("pages.solicitud-edit", {
                                                                id: ctrl.model.Id,
                                                                grupo: $stateParams.grupo,
                                                                proceso: $stateParams.proceso,
                                                                solicitudPadreId: 0
                                                            });
                                                        } else {
                                                            $state.reload();
                                                        }
                        
                                                    }
                                                } else {
                                                    // sharedService.setFirstSaveSolicitud(false);
                                                    toastr.error(response.data.ErrorSummary);
                                                    ctrl.isBusy = false;
                                                    swal.close();
                                                }
                                            });
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            swal.close();
                                            ctrl.isBusy = false;
                                            ctrl.isBusyBlocked = false;
                                        }
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        ctrl.isBusy = false;
                                        ctrl.isBusyBlocked = false;
                                        swal.close();
                                    });
                                } else {
                                    dataService.SaveSolicitudCampoValorGeneraProcesos(ctrl.camposListOrdered)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            var solicitudId = ctrl.model.Id;

                                            // Aqui se va a hacer el UploadFile
                                            if (ctrl.fileForQRTouched) {
                                                ctrl.camposList.map(function (campo) {
                                                    if (campo.CampoId == ctrl.fileForQR.campoId) {
                                                        dataService.updateFileSolicitudCampoValor(
                                                            ctrl.fileForQR.file,
                                                            ctrl.fileForQR.campoId,
                                                            solicitudId,
                                                            ctrl.fileForQR.ip,
                                                            ctrl.fileForQR.dispositivo,
                                                            ctrl.fileForQR.qrPage,
                                                            ctrl.fileForQR.qrPosX,
                                                            ctrl.fileForQR.qrPosY,
                                                            ctrl.fileForQR.qrSize
                                                        )
                                                            .then(function (response) {
                                                                if (response.data.Success) {
                                                                    var fileName = response.data.Value;

                                                                    dataService.getSolicitudCampoValorCompleto(solicitudId)
                                                                        .then(function (response) {
                                                                            if (response.data.Success) {
                                                                                ctrl.camposList = response.data.Value.map(function (campoActualizado) {
                                                                                    // Dandole al campo el valor del nombre del archivo generado por el backend
                                                                                    if (campoActualizado.CampoId == ctrl.fileForQR.campoId) {
                                                                                        campoActualizado.Valor = fileName;
                                                                                        campoActualizado.ValorObjeto = fileName;
                                                                                    }

                                                                                    // Dandole a los campos actualizados la entidad Solicitud, que es necesaria para el guardado de SolicitudCampoValor. Esta propiedad es identica en todos los campos de una solicitud, por eso se usa la misma para todos
                                                                                    campoActualizado.Solicitud = campo.Solicitud;

                                                                                    return campoActualizado;
                                                                                })

                                                                                updateCampoValorFile(solicitudId, fileName);

                                                                                orderCamposList();

                                                                                dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                                                                                    .then(function (response) {
                                                                                        if (response.data.Success) {

                                                                                            // if (ctrl.iframeSolicitudActivo) {
                                                                                            //     // sharedService.setIsBusyIframe(false);
                                                                                            //     Swal.fire({
                                                                                            //         title: '',
                                                                                            //         text: "Proceso finalizado, puede cerrar la ventana",
                                                                                            //         allowEscapeKey: false,
                                                                                            //         allowOutsideClick: false,
                                                                                            //         showConfirmButton: false,
                                                                                            //         icon: "success"
                                                                                            //     })
                                                                                            //     ctrl.isBusy = false;
                                                                                            //     return;
                                                                                            // }

                                                                                            toastr.info(ctrl.successfulRegistration);
                                                                                            swal.close();
                                                                                            ctrl.isBusy = false;
                                                                                            ctrl.isBusyBlocked = false;
                                                                                            
                                                                                            if (ctrl.isNew) {
                                                                                                $state.go("pages.solicitud-edit", {
                                                                                                    id: ctrl.model.Id,
                                                                                                    grupo: $stateParams.grupo,
                                                                                                    proceso: $stateParams.proceso,
                                                                                                    solicitudPadreId: 0
                                                                                                });
                                                                                            } else {
                                                                                                $state.reload();
                                                                                            }

                                                                                        } else {
                                                                                            swal.close();
                                                                                            toastr.error(response.data.ErrorSummary);
                                                                                            ctrl.isBusy = false;
                                                                                            ctrl.isBusyBlocked = false;
                                                                                            // sharedService.setFirstSaveSolicitud(false);
                                                                                        }
                                                                                    })
                                                                            } else {
                                                                                ctrl.active = 1;
                                                                                // sharedService.setFirstSaveSolicitud(false);
                                                                                toastr.error(response.data.ErrorSummary);
                                                                                ctrl.fileForQRTouched = true;
                                                                                swal.close();
                                                                                ctrl.isBusy = false;
                                                                                ctrl.isBusyBlocked = false;
                                                                            }
                                                                        }, function (error) {
                                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                            ctrl.isBusy = false;
                                                                            ctrl.isBusyBlocked = false;
                                                                            campo.isLoading = false;
                                                                            swal.close();
                                                                        });
                                                                } else {
                                                                    ctrl.active = 1;
                                                                    // sharedService.setFirstSaveSolicitud(false);
                                                                    toastr.error(response.data.ErrorSummary);
                                                                    ctrl.fileForQRTouched = true;
                                                                    swal.close();
                                                                    ctrl.isBusy = false;
                                                                    ctrl.isBusyBlocked = false;
                                                                }
                                                                campo.isLoading = false;
                                                            }, function (error) {
                                                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                ctrl.isBusy = false;
                                                                campo.isLoading = false;
                                                                ctrl.isBusyBlocked = false;
                                                                swal.close();
                                                            });
                                                    }
                                                })
                                            } else {

                                                // if (ctrl.iframeSolicitudActivo) {
                                                //     // sharedService.setIsBusyIframe(false);
                                                //     Swal.fire({
                                                //         title: '',
                                                //         text: "Proceso finalizado, puede cerrar la ventana",
                                                //         allowEscapeKey: false,
                                                //         allowOutsideClick: false,
                                                //         showConfirmButton: false,
                                                //         icon: "success"
                                                //     })
                                                //     ctrl.isBusy = false;
                                                //     return;
                                                // }

                                                toastr.info(ctrl.successfulRegistration);
                                                swal.close();
                                                ctrl.isBusy = false;
                                                ctrl.isBusyBlocked = false;
    
                                                if (ctrl.isNew) {
                                                    $state.go("pages.solicitud-edit", {
                                                        id: ctrl.model.Id,
                                                        grupo: $stateParams.grupo,
                                                        proceso: $stateParams.proceso,
                                                        solicitudPadreId: 0
                                                    });
                                                } else {
                                                    $state.reload();
                                                }
                
                                            }
                                        } else {
                                            // sharedService.setFirstSaveSolicitud(false);
                                            toastr.error(response.data.ErrorSummary);
                                            ctrl.isBusy = false;
                                            swal.close();
                                        }
                                    });
                                }
                            } else {
                                

                                // if (ctrl.iframeSolicitudActivo) {
                                //     toastr.info("Registro exitoso.");
                                //     // sharedService.setIsBusyIframe(false);
                                //     Swal.fire({
                                //         title: '',
                                //         text: "Proceso finalizado, puede cerrar la ventana",
                                //         allowEscapeKey: false,
                                //         allowOutsideClick: false,
                                //         showConfirmButton: false,
                                //         icon: "success"
                                //     })
                                //     ctrl.isBusy = false;
                                //     return;
                                // }

                                if (ctrl.camposTableEnr.length > 0) {
                                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                                        campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                                        delete campoTableEnr.index
                                        return campoTableEnr;
                                    });

                                    dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                toastr.info(ctrl.successfulRegistration);
                                                swal.close();
                                                ctrl.isBusy = false;
                                                ctrl.isBusyBlocked = false;
    
                                                if (ctrl.isNew) {
                                                    $state.go("pages.solicitud-edit", {
                                                        id: ctrl.model.Id,
                                                        grupo: $stateParams.grupo,
                                                        proceso: $stateParams.proceso,
                                                        solicitudPadreId: 0
                                                    });
                                                } else {
                                                    $state.reload();
                                                }
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                swal.close();
                                                ctrl.isBusy = false;
                                                ctrl.isBusyBlocked = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isBusy = false;
                                            ctrl.isBusyBlocked = false;
                                            swal.close();
                                        });
                                } else {
                                    toastr.info(ctrl.successfulRegistration);
                                    swal.close();
                                    ctrl.isBusy = false;
                                    ctrl.isBusyBlocked = false;

                                    if (ctrl.isNew) {
                                        $state.go("pages.solicitud-edit", {
                                            id: ctrl.model.Id,
                                            grupo: $stateParams.grupo,
                                            proceso: $stateParams.proceso,
                                            solicitudPadreId: 0
                                        });
                                    } else {
                                        $state.reload();
                                    }
                                }
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            // sharedService.setFirstSaveSolicitud(false);
                            swal.close();
                            ctrl.isBusy = false;
                            ctrl.isBusyBlocked = false;
                        }
                        // sharedService.setIsBusyIframe(false);
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        // sharedService.setFirstSaveSolicitud(false);
                        ctrl.isBusy = false;
                        ctrl.isBusyBlocked = false;
                        swal.close();
                    });
            }

            ctrl.retrocederEtapa = function (form) {
                var justificationText, aceptadoEtapaText, previousState, previousStateUser, saveBeforeExit;

                if (ctrl.language == "español") {
                    justificationText = 'Ingrese la justificación por favor';
                    aceptadoEtapaText = 'No puede regresar a la etapa anterior si cierra el ciclo';
                    previousState = 'No hay etapa previa a la cual retroceder';
                    previousStateUser = 'Seleccione un usuario para regresar a la etapa anterior';
                    saveBeforeExit = 'Antes de retroceder de etapa, guarde la solicitud por favor';

                } else if (ctrl.language == "ingles") {
                    justificationText = 'Please enter the justification.';
                    aceptadoEtapaText = 'Cannot revert to the previous stage if the cycle is closed';
                    previousState = 'There is no previous stage to revert to';
                    previousStateUser = 'Select a user to revert to the previous stage';
                    saveBeforeExit = 'Before reverting the stage, please save the request.';

                } else if (ctrl.language == "portugues") {
                    justificationText = 'Digite a justificativa';
                    aceptadoEtapaText = 'Não é possível voltar à etapa anterior se o ciclo for fechado';
                    previousState = 'Não há etapa anterior para retroceder';
                    previousStateUser = 'Selecione um usuário para voltar à etapa anterior';
                    saveBeforeExit = 'Antes de voltar, salve o aplicativo.';

                } else if (ctrl.language == "italiano") {
                    justificationText = 'Ingrese la justificación por favor';
                    aceptadoEtapaText = 'No puede regresar a la etapa anterior si cierra el ciclo';
                    previousState = 'No hay etapa previa a la cual retroceder';
                    previousStateUser = 'Seleccione un usuario para regresar a la etapa anterior';
                    saveBeforeExit = 'Antes de retroceder de etapa, guarde la solicitud por favor';
                }

                if (ctrl.model.Proceso.justificacionEsRequerida) {
                    if (ctrl.justificacionEtapa == "") {
                        toastr.error(justificationText);
                        return;
                    }
                }

                if (ctrl.model.Id > 0) {
                    if (ctrl.aceptadoEtapa) {
                        toastr.error(aceptadoEtapaText);
                        return;
                    }

                    if (ctrl.anteriorEstadoSolicitud == null) {
                        toastr.error(previousState);
                        return;
                    }

                    if (ctrl.usuarioEtapaAnterior == null ||
                        !(ctrl.usuarioEtapaAnterior.Id > 0)) {
                        toastr.error(previousStateUser);
                        return;
                    }

                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapa;
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;

                    if (ctrl.usuarioEtapaAnterior != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaAnterior.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });

                    dataService.eliminarAutorizacionesEtapa(ctrl.solicitudEtapaModel.SolicitudId, ctrl.solicitudEtapaModel.SolicitudEstadoId)
                        .then(function (response) {
                            /*if (response.data.Success) {
                                //toastr.info("Registro exitoso.");
                                //$state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;*/
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error(saveBeforeExit);
                }
            }

            ctrl.avanzarEtapa = function (form) {
                var mandatoryFields, authorization, justificationText, aceptadoEtapaText, nextState, saveBeforeExit;

                if (ctrl.language == "español") {
                    mandatoryFields = 'Hay Datos Obligatorios no cumplidos.';
                    authorization = 'La Solicitud no ha sido autorizada';
                    justificationText = 'Ingrese la justificación por favor';
                    aceptadoEtapaText = 'No puede avanzar a la etapa siguiente si no cierra el ciclo';
                    nextState = 'No hay siguiente etapa a la cual avanzar';
                    saveBeforeExit = 'Antes de avanzar de etapa, guarde la solicitud por favor';

                } else if (ctrl.language == "ingles") {
                    mandatoryFields = 'There are Unmet Mandatory Data.';
                    authorization = 'The Request has not been authorized';
                    justificationText = 'Please enter the justification';
                    aceptadoEtapaText = 'Cannot proceed to the next stage if the cycle is not closed';
                    nextState = 'There is no next stage to advance to';
                    saveBeforeExit = 'Before advancing the stage, please save the request';

                } else if (ctrl.language == "portugues") {
                    mandatoryFields = 'Há Dados Obrigatórios não cumpridos';
                    authorization = 'A Solicitação não foi autorizada';
                    justificationText = 'Digite a justificativa';
                    aceptadoEtapaText = 'Não é possível avançar para a próxima etapa se o ciclo não for fechado';
                    nextState = 'Não há próxima etapa para avançar';
                    saveBeforeExit = 'Antes de avançar para a próxima etapa, salve a solicitação, por favor';

                } else if (ctrl.language == "italiano") {
                    mandatoryFields = 'Hay Datos Obligatorios no cumplidos.';
                    authorization = 'La Solicitud no ha sido autorizada';
                    justificationText = 'Ingrese la justificación por favor';
                    aceptadoEtapaText = 'No puede avanzar a la etapa siguiente si no cierra el ciclo';
                    nextState = 'No hay siguiente etapa a la cual avanzar';
                    saveBeforeExit = 'Antes de avanzar de etapa, guarde la solicitud por favor';
                }

                if (!validateMandatoryFields()) {
                    ctrl.isBusy = false;
                    toastr.error(mandatoryFields);
                    return;
                }

                if (ctrl.model.Proceso.autorizaciones && (ctrl.model.EstadoId >= 2 && ctrl.model.EstadoId != 6)) {
                    if (ctrl.grupoUsuariosObj.grupo1Obj != null && ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated == false ||
                        ctrl.grupoUsuariosObj.grupo2Obj != null && ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated == false ||
                        ctrl.grupoUsuariosObj.grupo3Obj != null && ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated == false) {
                        toastr.error(authorization);
                        return;
                    }
                }

                if (ctrl.mostrarControlesAprobacion(ctrl.model.Estado.Codigo) && ctrl.model.Proceso.justificacionEsRequerida) {
                    if (ctrl.justificacionEtapa == "") {
                        toastr.error(justificationText);
                        return;
                    }
                }
                if (ctrl.model.Id > 0) {
                    if (!ctrl.aceptadoEtapa) {
                        toastr.error(aceptadoEtapaText);
                        return;
                    }

                    if (ctrl.siguienteEstadoSolicitud == null) {
                        toastr.error(nextState);
                        return;
                    }

                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapa;
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;
                    ctrl.solicitudEtapaModel.forzarCierre = false;

                    if (ctrl.usuarioEtapaSiguiente != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguiente.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error(saveBeforeExit);
                }
            }

            ctrl.forzarCierre = function (form) {
                if (ctrl.model.Id > 0) {
                    ctrl.isBusy = true;

                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = ctrl.justificacionEtapaForzarCierre;
                    ctrl.solicitudEtapaModel.Aprobado = true;
                    ctrl.solicitudEtapaModel.forzarCierre = true;

                    if (ctrl.usuarioEtapaSiguiente != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguiente.Id;

                    dataService.saveSolicitudEtapa(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });
                } else {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = 'Antes de avanzar de etapa, guarde la solicitud por favor';
                    else if (ctrl.language == "ingles")
                        errorText = 'Before advancing the stage, please save the request';
                    else if (ctrl.language == "portugues")
                        errorText = 'Antes de avançar para a próxima etapa, salve a solicitação, por favor';
                    else if (ctrl.language == "italiano")
                        errorText = 'Antes de avanzar de etapa, guarde la solicitud por favor';

                    toastr.error(errorText);
                }
            }

            ctrl.derivarEtapa = function (form) {
                var comments, saveBeforeExit;

                if (ctrl.language == "español") {
                    comments = "Derivar Etapa a otro usuario";
                    saveBeforeExit = 'Antes de avanzar de etapa, guarde la solicitud por favor';
                }
                else if (ctrl.language == "ingles") {
                    comments = "Assign Stage to another user";
                    saveBeforeExit = 'Before advancing the stage, please save the request';
                }
                else if (ctrl.language == "portugues") {
                    comments = "Encaminhar Etapa para outro usuário";
                    saveBeforeExit = 'Antes de avançar para a próxima etapa, salve a solicitação, por favor';
                }
                else if (ctrl.language == "italiano") {
                    comments = "Derivar Etapa a otro usuario";
                    saveBeforeExit = 'Antes de avanzar de etapa, guarde la solicitud por favor';
                }

                if (ctrl.model.Id > 0) {
                    ctrl.isBusy = true;


                    ctrl.solicitudEtapaModel.SolicitudId = ctrl.model.Id;
                    ctrl.solicitudEtapaModel.SolicitudEstadoId = ctrl.model.EstadoId;
                    ctrl.solicitudEtapaModel.Comentarios = comments;
                    ctrl.solicitudEtapaModel.Aprobado = ctrl.aceptadoEtapa;
                    ctrl.solicitudEtapaModel.forzarCierre = false;

                    if (ctrl.usuarioEtapaSiguienteDerivar != null)
                        ctrl.solicitudEtapaModel.UsuarioAprobadorId = ctrl.usuarioEtapaSiguienteDerivar.Id;

                    dataService.saveSolicitudEtapaDerivarRes(ctrl.solicitudEtapaModel)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });
                } else {
                    toastr.error(saveBeforeExit);
                }
            }

            ctrl.goListado = function () {
                var grupoId = $stateParams.grupo;
                if (ctrl.model != null && ctrl.model.Proceso != null)
                    grupoId = ctrl.model.Proceso.GrupoId;

                $state.go("pages.solicitud", {
                    grupoId: grupoId,
                    procesoId: $stateParams.proceso
                });
            }

            ctrl.goBack = function () {
                $window.history.back();
            }
            ctrl.verDocumento = function (messageDestino) {
                //tipoDocumentoId
                //documentoPublicableId

                var configureFieldOfProcess, configureLinkProcess;

                if (ctrl.language == "español") {
                    configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
                    configureLinkProcess = 'Debe configurar link en el Proceso.';

                } else if (ctrl.language == "ingles") {
                    configureFieldOfProcess = 'You must configure a field for publishable document in the Process.';
                    configureLinkProcess = 'You must configure a link in the Process.';

                } else if (ctrl.language == "portugues") {
                    configureFieldOfProcess = 'Deve configurar o campo para documento publicável no Processo';
                    configureLinkProcess = 'Deve configurar o link no Processo';

                } else if (ctrl.language == "italiano") {
                    configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
                    configureLinkProcess = 'Debe configurar link en el Proceso.';
                }

                var tipoDocumentoId = ctrl.model.Proceso.tipoDocumentoId;
                var documentoPublicableId = ctrl.model.Proceso.documentoPublicableId;
                var linkDocumental = ctrl.model.Proceso.LinkDocumental;

                var campoForDocumentoPublicable, campoForTipoDocumento;

                angular.forEach(ctrl.camposList, function (value, key) {
                    if (value.CampoId == tipoDocumentoId && value.Valor != "") {
                        campoForTipoDocumento = value;
                    }
                    if (value.CampoId == documentoPublicableId && value.Valor != "") {
                        campoForDocumentoPublicable = value;
                    }
                });

                var tipoDocumentoOpcion;
                if (campoForTipoDocumento != null && campoForTipoDocumento.ValorObjeto != null && campoForTipoDocumento.ValorObjeto != undefined) {
                    var codigo = campoForTipoDocumento.ValorObjeto[0].Codigo;
                    if (codigo != null && codigo != undefined && codigo != "") {
                        if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP1") {
                            tipoDocumentoOpcion = 1;
                        }
                        if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP2") {
                            tipoDocumentoOpcion = 2;
                        }
                        if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP3") {
                            tipoDocumentoOpcion = 3;
                        }
                    }
                }
                if (tipoDocumentoOpcion == 1) {
                    if (campoForDocumentoPublicable != null && campoForDocumentoPublicable.Valor != null && campoForDocumentoPublicable.Valor != undefined && campoForDocumentoPublicable.Valor != "") {
                        dataService.generateImpresionDocumentalOtros(ctrl.model.Id, authData.Id)
                        .then(function (response) {
                            if (response.data.Success && response.data.Value) {
                                ctrl.openAttachment(campoForDocumentoPublicable.Valor); //, 'verDocumento');
                            } else {
                                toastr.error(response.data.ErrorSummary);
                                return;
                            }
                        }, function (error) {
                            toastr.error(error.data || getGenericErrorMessage(error));
                            return;
                        });
                    } else {
                        Swal.fire({
                            title: configureFieldOfProcess,
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: ctrl.acceptText,
                            cancelButtonText: ctrl.cancelText,
                            heightAuto: false
                        })
                            .then(function (result) { });
                    }
                } else if (tipoDocumentoOpcion == 2) {
                    if (linkDocumental != null && linkDocumental != undefined && linkDocumental != "") {
                        linkDocumental = linkDocumental.replace("VarProcesoId", ctrl.model.ProcesoId);
                        linkDocumental = linkDocumental.replace("VarUsuarioId", authData.Id);
                        linkDocumental = linkDocumental.replace("varDestinoID", messageDestino);
                        linkDocumental = linkDocumental.replace("VarSolicitudId", ctrl.model.Id);
                        ctrl.generateImagesPdf(linkDocumental, tipoDocumentoOpcion);
                    } else {
                        Swal.fire({
                            title: configureLinkProcess,
                            type: 'warning',
                            showCancelButton: false,
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: ctrl.acceptText,
                            cancelButtonText: ctrl.cancelText,
                            heightAuto: false
                        })
                            .then(function (result) { });
                    }
                } else if (tipoDocumentoOpcion == 3) {
                    ctrl.generateImagesPdf('', tipoDocumentoOpcion);
                }
            }

            ctrl.generateImagesPdf = function (linkDocumental, tipoDocumentoOpcion) {
                var modalText;

                if (ctrl.language == "español")
                    modalText = 'Estamos trabajando para ti, Por favor espera.';
                else if (ctrl.language == "ingles")
                    modalText = 'We are working for you. Please wait.';
                else if (ctrl.language == "portugues")
                    modalText = 'Estamos trabalhando para você, aguarde.';
                else if (ctrl.language == "italiano")
                    modalText = 'Estamos trabajando para ti, Por favor espera.';

                Swal.fire({
                    title: modalText,
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: ctrl.acceptText,
                    cancelButtonText: ctrl.cancelText,
                    showCloseButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    focusConfirm: false,
                    heightAuto: false,
                    onOpen: function () {
                        swal.showLoading();
                    }
                });

                if (tipoDocumentoOpcion == 3) {
                    dataService.generarImpresionDocumentalPdf(ctrl.model.Id, ctrl.model.ProcesoId)
                    .then(function (response) {
                        if (response.data.Success) {
                            swal.close();
                            var usuarioLogueadoId = authData.Id;
                            var decodedUrl = atob(response.data.Value);
                            
                            sharedService.openVisorDocumental(usuarioLogueadoId, decodedUrl, true);
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            swal.close();
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        swal.close();
                        ctrl.isBusy = false;
                    });
                } else {
                    dataService.generateImagesPdf(ctrl.model.Id)
                    .then(function (response) {
                        swal.close();
                        if (response.data.Success) {
                            swal.close();
                            var usuarioLogueadoId = authData.Id;
                            sharedService.openVisorDocumental(usuarioLogueadoId, linkDocumental);

                            // if (linkDocumental.includes('rs.kahuna.biz')) {
                            //     dataService.obtenerParametrosByIdent("URL_REPORTSERVER")
                            //     .then(function (response) {
                            //         if (response.data.Success) {
                            //             swal.close();
                            //             var usuarioLogueadoId = authData.Id;
                            //             var urlBase64 = btoa(response.data.Value.UrlDocumentos);
                            //             var fileName = linkDocumental.replace(response.data.Value.UrlDocumentos, '');

                            //             sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.model.Proceso);
                            //             // window.open(linkDocumental, "_blank");
                            //         } else {
                            //             toastr.error(response.data.ErrorSummary);
                            //         }
                            //     }, function (error) {
                            //         toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            //         ctrl.isBusy = false;
                            //     });
                            // } else if (linkDocumental.includes('pbis.kahuna.biz')) {
                            //     dataService.obtenerParametrosByIdent("URL_REPORTPOWERBI")
                            //     .then(function (response) {
                            //         if (response.data.Success) {
                            //             swal.close();
                            //             var usuarioLogueadoId = authData.Id;
                            //             var urlBase64 = btoa(response.data.Value.UrlDocumentos);
                            //             var fileName = linkDocumental.replace(response.data.Value.UrlDocumentos, '');

                            //             sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.model.Proceso);
                            //         } else {
                            //             toastr.error(response.data.ErrorSummary);
                            //         }
                            //     }, function (error) {
                            //         toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            //         ctrl.isBusy = false;
                            //     });
                            // }

                        } else {
                            swal.close();
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                        swal.close();
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        swal.close();
                        ctrl.isBusy = false;
                    })
                }
            }

            ctrl.crearVersion = function () {
                ctrl.isBusy = true;

                var modalTitle, modalMessage;

                if (ctrl.language == "español") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea crear una nueva Version?";
                }
                else if (ctrl.language == "ingles") {
                    modalTitle = "Attention";
                    modalMessage = "Are you sure you want to create a new Version?";
                }
                else if (ctrl.language == "portugues") {
                    modalTitle = "Atenção";
                    modalMessage = "Tem certeza de que deseja criar uma nova Versão?";
                }
                else if (ctrl.language == "italiano") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea crear una nueva Version?";
                }

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return modalTitle
                        },
                        message: function () {
                            return modalMessage
                        },
                    }
                });
                confirmation.result.then(function () {
                    ctrl.saveSolicitudVersion();
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.enviarObsoleto = function () {
                //ctrl.procesoIdObsoleto
                ctrl.isBusy = true;

                var modalTitle, modalMessage;

                if (ctrl.language == "español") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea enviar el proceso a Obsoleto?";
                }
                else if (ctrl.language == "ingles") {
                    modalTitle = "Attention";
                    modalMessage = "Are you sure you want to send the process to Obsolete?";
                }
                else if (ctrl.language == "portugues") {
                    modalTitle = "Atenção";
                    modalMessage = "Tem certeza de que deseja enviar o processo para Obsoleto?";
                }
                else if (ctrl.language == "italiano") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea enviar el proceso a Obsoleto?";
                }

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return modalTitle
                        },
                        message: function () {
                            return modalMessage
                        },
                    }
                });

                confirmation.result.then(function () {
                    ctrl.model.ProcesoId = ctrl.model.Proceso.procesoIdObsoletos;
                    ctrl.saveObsoleto();
                }, function () {
                    ctrl.isBusy = false;
                });

            }
            ctrl.crearCopia = function () {
                ctrl.isBusy = true;

                var modalTitle, modalMessage;

                if (ctrl.language == "español") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea crear una Copia?";
                }
                else if (ctrl.language == "ingles") {
                    modalTitle = "Attention";
                    modalMessage = "Are you sure you want to create a Copy?";
                }
                else if (ctrl.language == "portugues") {
                    modalTitle = "Atenção";
                    modalMessage = "Tem certeza de que deseja criar uma Cópia?";
                }
                else if (ctrl.language == "italiano") {
                    modalTitle = "Atención";
                    modalMessage = "Esta seguro que desea crear una Copia?";
                }

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return modalTitle
                        },
                        message: function () {
                            return modalMessage
                        },
                    }
                });

                confirmation.result.then(function () {
                    ctrl.saveCrearCopia();
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.cargarAccesoDirectoTemplate = function (itemSeleccionado) {
                if (itemSeleccionado != null && itemSeleccionado.Id != null) {
                    ctrl.procesoTemplateSeleccionado = itemSeleccionado;
                    ctrl.cargarTemplate();
                }
            }

            ctrl.cargarTemplate = function () {
                ctrl.isBusy = true;
                if (ctrl.procesoTemplateSeleccionado != null && ctrl.procesoTemplateSeleccionado.Id != null) {
                    // var absHost = $location.absUrl();
                    // var arrayHost = absHost.split("#");
                    // absHost = arrayHost[0];
                    // absHost = absHost +
                    //     '#/solicitud/template/edit/' +
                    //     $stateParams.id + '/' +
                    //     ctrl.model.EstadoId + '/' +
                    //     ctrl.procesoTemplateSeleccionado.Id + '/' +
                    //     ctrl.procesoTemplateSeleccionado.TemplateId + '/' +
                    //     ctrl.procesoTemplateSeleccionado.ProcesoId + '/0';

                    // sharedService.setIframeSolicitudActivo(true);
                    // sharedService.setModalGestionesOpen(true);

                    // var modalSolicitud = $('.modal-solicitud');
                    // modalSolicitud.append('<iframe src=' + absHost + ' frameborder="0"><iframe/>');

                    // modalSolicitud.addClass('active');

                    ctrl.isBusy = false;

                    // Antes del cambio de 13/09/2023
                    // --------------------------------------------
                    $state.go("pages.solicitud-template", {
                        solicitud: $stateParams.id,
                        solicitudEstado: ctrl.model.EstadoId,
                        procesoTemplate: ctrl.procesoTemplateSeleccionado.Id,
                        template: ctrl.procesoTemplateSeleccionado.TemplateId,
                        proceso: ctrl.procesoTemplateSeleccionado.ProcesoId,
                        solicitudProcesoTemplate: 0
                    });

                } else {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = "Debe seleccionar una gestión para iniciar su carga";
                    else if (ctrl.language == "ingles")
                        errorText = "You must select a management to start its load";
                    else if (ctrl.language == "portugues")
                        errorText = "Deve selecionar uma gestão para iniciar a carga";
                    else if (ctrl.language == "italiano")
                        errorText = "Debe seleccionar una gestión para iniciar su carga";

                    toastr.error(errorText);
                    ctrl.isBusy = false;
                }
            }

            ctrl.openTemplate = function (solicitudProcesoTemplate) {
                if (solicitudProcesoTemplate != null) {
                    // var absHost = $location.absUrl();
                    // var arrayHost = absHost.split("#");
                    // absHost = arrayHost[0];
                    // absHost = absHost +
                    //     '#/solicitud/template/edit/' +
                    //     solicitudProcesoTemplate.SolicitudId + '/' +
                    //     ctrl.model.EstadoId + '/' +
                    //     solicitudProcesoTemplate.ProcesoTemplateId + '/' +
                    //     solicitudProcesoTemplate.ProcesoTemplate.TemplateId + '/' +
                    //     solicitudProcesoTemplate.ProcesoTemplate.ProcesoId + '/' +
                    //     solicitudProcesoTemplate.Id;

                    // sharedService.setIframeSolicitudActivo(true);
                    // sharedService.setModalGestionesOpen(true);

                    // var modalSolicitud = $('.modal-solicitud');
                    // modalSolicitud.append('<iframe src=' + absHost + ' frameborder="0"><iframe/>');

                    // modalSolicitud.addClass('active');

                    ctrl.isBusy = false;
                    // Antes de la modificación 09/11/2023
                    // -------------------------------------------------------
                    $state.go("pages.solicitud-template", {
                        solicitud: solicitudProcesoTemplate.SolicitudId,
                        solicitudEstado: ctrl.model.EstadoId,
                        procesoTemplate: solicitudProcesoTemplate.ProcesoTemplateId,
                        template: solicitudProcesoTemplate.ProcesoTemplate.TemplateId,
                        proceso: solicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
                        solicitudProcesoTemplate: solicitudProcesoTemplate.Id
                    });
                }
            }

            ctrl.openUrlLink = function (urlLink) {
                if (urlLink != undefined && urlLink != "") {
                    var usuarioLogueadoId = authData.Id;
                    var urlLink = urlLink.replace("&solicitud", ctrl.model.Id);
                    urlLink = urlLink.replace("&SolicitudId", ctrl.model.Id);

                    sharedService.openVisorDocumental(usuarioLogueadoId, urlLink);

                    // window.open(urlLink, "_blank");
                }
            }
            ctrl.executeProcedure = function (item) {
                var modaltitle;

                if (ctrl.language == "español")
                    modaltitle = "Procedimiento Ejecutado Correctamente";
                else if (ctrl.language == "ingles")
                    modaltitle = "Procedure Executed Successfully";
                else if (ctrl.language == "portugues")
                    modaltitle = "Procedimento Executado Corretamente";
                else if (ctrl.language == "italiano")
                    modaltitle = "Procedimiento Ejecutado Correctamente";

                dataService.executeProcedure(item.UrlLink, ctrl.model.Id).then(function (response) {
                    Swal.fire({
                        title: modaltitle,
                        type: "success",
                        showCancelButton: false,
                        confirmButtonColor: "#3085d6",
                        confirmButtonText: ctrl.acceptText,
                        heightAuto: false,
                    }).then(function (result) {
                    });
                });
            }

            ctrl.delete = function () {
                ctrl.isBusy = true;
                // sharedService.setIsBusyIframe(true);

                var modalTitle, modalMessage, confirmationText;

                if (ctrl.language == "español") {
                    modalTitle = "Atención";
                    modalMessage = "Confirma el borrado de la carga del proceso actual?";
                    confirmationText = "Se está ejecutando un proceso, por favor espere.";
                }
                else if (ctrl.language == "ingles") {
                    modalTitle = "Attention";
                    modalMessage = "Do you confirm the deletion of the current process load?";
                    confirmationText = "A process is running, please wait.";
                }
                else if (ctrl.language == "portugues") {
                    modalTitle = "Atenção";
                    modalMessage = "Confirma a exclusão do carregamento do processo atual?";
                    confirmationText = "Um processo está sendo executado, aguarde.";
                }
                else if (ctrl.language == "italiano") {
                    modalTitle = "Atención";
                    modalMessage = "Confirma el borrado de la carga del proceso actual?";
                    confirmationText = "Se está ejecutando un proceso, por favor espere";
                }

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return modalTitle
                        },
                        message: function () {
                            return modalMessage
                        },
                    }
                });

                confirmation.result.then(function (selectedItem) {
                    Swal.fire({
                        title: '',
                        text: confirmationText,
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        onOpen: function () {
                            swal.showLoading();
                        }
                    })

                    dataService.deleteSolicitud(ctrl.model.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);

                                // if (ctrl.iframeSolicitudActivo) {
                                //     swal.close();
                                //     // sharedService.setIsBusyIframe(false);
                                //     Swal.fire({
                                //         title: '',
                                //         text: "Proceso finalizado, puede cerrar la ventana",
                                //         allowEscapeKey: false,
                                //         allowOutsideClick: false,
                                //         showConfirmButton: false,
                                //         icon: "success"
                                //     })
                                //     ctrl.isBusy = false;
                                //     return;
                                // }

                                var grupoId = $stateParams.grupo;
                                if (ctrl.model != null && ctrl.model.Proceso != null)
                                    grupoId = ctrl.model.Proceso.GrupoId;

                                $state.go("pages.solicitud", {
                                    grupoId: grupoId,
                                    procesoId: $stateParams.proceso
                                });
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                            // sharedService.setIsBusyIframe(false);
                            swal.close();
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                            // sharedService.setIsBusyIframe(false);
                            swal.close();
                        });
                }, function () {
                    ctrl.isBusy = false;
                    // sharedService.setIsBusyIframe(false);
                });
            }

            // ctrl.imprimirSolicitud = function () {
            //     var usuarioLogueadoId = authData.Id;
            //     sharedService.openVisorDocumental(usuarioLogueadoId, appConfig.apiUrl + 'Solicitud/GenerarImpresion/' + ctrl.model.Id);
            //     // window.open(appConfig.apiUrl + 'Solicitud/GenerarImpresion/' + ctrl.model.Id);
            // }
            ctrl.imprimirCopiaControlada = function () {
                if (ctrl.copiaDestinadaA != undefined && ctrl.copiaDestinadaA != "") {
                    //window.open(appConfig.apiUrl + 'Solicitud/GenerarCopiaControlada/' + ctrl.model.Id + '/' + ctrl.lUsuarioLogeado.Id + '/' + ctrl.copiaDestinadaA);                    
                    ctrl.verDocumento(ctrl.copiaDestinadaA);
                } else {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = "Ingrese el destino de la copia";
                    else if (ctrl.language == "ingles")
                        errorText = "Enter the copy destination";
                    else if (ctrl.language == "portugues")
                        errorText = "Insira o destino da cópia";
                    else if (ctrl.language == "italiano")
                        errorText = "Ingrese el destino de la copia";

                    toastr.error(errorText);
                }
            }

            /******************* CAMPOS DEL PROCESO *******************/
            function loadProcesoCampoData(campoList, index, campoTipo) {
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Cargando...";
                else if (ctrl.language == "ingles")
                    placeholderText = "Loading...";
                else if (ctrl.language == "portugues")
                    placeholderText = "Carregando...";
                else if (ctrl.language == "italiano")
                    placeholderText = "Cargando...";

                if (campoTipo == null)
                    return;
                if (index < 0)
                    return;

                if (ctrl.camposList[index] == null)
                    return;

                switch (campoTipo.Codigo) {
                    case 'PROCEDURE':
                        ctrl.solicitudHasProceduresField = true;
                        // Posible Bug, revisar 08/10/2023
                        ctrl.procesoGeneraProcesosRelacionados = ctrl.model.Proceso.generaProcesosRelacionados;
                        if (ctrl.procesoGeneraProcesosRelacionados) {
                            ctrl.generaProcesoRelacionados = true;//It will set the value.
                        }
                        break;
                    case 'VERSION':
                        ctrl.camposList[index].ValorObjeto = Number(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'INT':
                        ctrl.camposList[index].ValorObjeto = sharedService.addThousandSeparator(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'DECIMAL':
                        ctrl.camposList[index].ValorObjeto = sharedService.addThousandSeparator(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'DATE':
                        ctrl.camposList[index].ValorObjeto = sharedService.formatDate(ctrl.camposList[index].ValorObjeto);
                        break;
                    case 'JERARQ':
                        if (ctrl.camposList[index].ValorObjeto != null && ctrl.camposList[index].ValorObjeto.length > 0) {
                            for (var k = 0; k < ctrl.camposList[index].ValorObjeto.length; k++) {
                                if (ctrl.camposList[index].ValorObjeto[k] != null)
                                    ctrl.camposList[index].ValorObjeto[k].ValorInput = ctrl.camposList[index].ValorObjeto[k].Nombre;
                            }
                        } else {
                            if (ctrl.camposList[index].ValorObjeto == null)
                                ctrl.camposList[index].ValorObjeto = [];

                            ctrl.camposList[index].ValorObjeto.push({
                                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                                LoadingJerarquia: false,
                                NoResults: false,
                                Placeholder: placeholderText
                            });
                            loadJerarquiaPlaceholder(ctrl.camposList[index].Campo.JerarquiaId, index, ctrl.camposList[index].ValorObjeto.length - 1);
                        }
                        break;
                    case 'TABLE':
                        // console.log("ENTRO TABLE");
                        loadTablaCampo(index);
                        break;
                    case 'TABLEENR':
                        // console.log("ENTRO TABLE ENR");
                        // Si encuentra un campo tipo TABLEENR
                        ctrl.camposTableEnr.push({ // guarda que lo encontró
                            index: index, // guarda el index en el ctrl.camposList
                            Id: null,
                            Campo: null,
                            TablaFilas: null,
                            SolicitudId: null,
                            SolicitudProcesoTemplateId: null
                        }); 
                        loadTablaCampo(index);
                        break;
                    case 'COND':
                        loadTablaCampoCondicional(index);
                        break;
                } //switch
            }

            function loadProcesoCampoDataReadOnly(index, campoTipo) {
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Cargando...";
                else if (ctrl.language == "ingles")
                    placeholderText = "Loading...";
                else if (ctrl.language == "portugues")
                    placeholderText = "Carregando...";
                else if (ctrl.language == "italiano")
                    placeholderText = "Cargando...";

                if (campoTipo == null)
                    return;

                if (index < 0)
                    return;

                if (ctrl.camposList[index] == null)
                    return;
                switch (campoTipo.Codigo) {
                    case 'PROCEDURE':
                        ctrl.solicitudHasProceduresField = false;
                        break;
                    case 'VERSION':
                        ctrl.camposList[index].Valor = Number(ctrl.camposList[index].Valor);
                        break;
                    case 'INT':
                        ctrl.camposList[index].Valor = sharedService.addThousandSeparator(ctrl.camposList[index].Valor);
                        break;
                    case 'DECIMAL':
                        ctrl.camposList[index].Valor = sharedService.addThousandSeparator(ctrl.camposList[index].Valor);
                        break;
                    case 'TABLE':
                        // console.log("ENTRO TABLA");
                        loadTablaCampo(index);
                        break;
                    case 'TABLEENR':
                        // console.log("ENTRO TRABL EENRIQUEZIDA 2612");
                        loadTablaCampo(index);
                        break;

                    case 'JERARQ':
                        if (ctrl.camposList[index].ValorObjeto != null && ctrl.camposList[index].ValorObjeto.length > 0) {
                            for (var k = 0; k < ctrl.camposList[index].ValorObjeto.length; k++) {
                                if (ctrl.camposList[index].ValorObjeto[k] != null)
                                    ctrl.camposList[index].ValorObjeto[k].ValorInput = ctrl.camposList[index].ValorObjeto[k].Nombre;
                            }
                        } else {
                            if (ctrl.camposList[index].ValorObjeto == null)
                                ctrl.camposList[index].ValorObjeto = [];

                            ctrl.camposList[index].ValorObjeto.push({
                                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                                LoadingJerarquia: false,
                                NoResults: false,
                                Placeholder: placeholderText
                            });

                            loadJerarquiaPlaceholder(ctrl.camposList[index].Campo.JerarquiaId, index, ctrl.camposList[index].ValorObjeto.length - 1);
                        }
                        break;
                    case 'COND':
                        loadTablaCampoCondicional(index);
                        break;
                } //switch
            }


            function loadTablaCampo(index) {
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Cargando...";
                else if (ctrl.language == "ingles")
                    placeholderText = "Loading...";
                else if (ctrl.language == "portugues")
                    placeholderText = "Carregando...";
                else if (ctrl.language == "italiano")
                    placeholderText = "Cargando...";

                if (ctrl.camposList[index].Valor != null && ctrl.camposList[index].Valor.length > 0) {
                    ctrl.camposList[index].TablaFilas = [];
                    // AQUI 
                    var valorFilas = ctrl.camposList[index].Valor.split('^');
                    if (valorFilas != null && valorFilas.length > 0) {
                        for (var k = 0; k < valorFilas.length; k++) {
                            ctrl.camposList[index].TablaFilas.push({
                                Valor: []
                            });
                            var valorColumnas = valorFilas[k].split('~');
                            if (valorColumnas != null && valorColumnas.length > 0) {
                                ctrl.camposList[index].ValorObjeto = valorColumnas[0];
                                for (var h = 0; h < valorColumnas.length; h++) {
                                    try {
                                        switch (ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.CampoTipo.Codigo) {
                                            case 'INT':
                                                valorColumnas[h] = sharedService.addThousandSeparator(valorColumnas[h]);
                                                break;
                                            case 'DECIMAL':
                                                valorColumnas[h] = sharedService.addThousandSeparator(valorColumnas[h]);
                                                break;
                                            case 'BOOL':
                                                if (valorColumnas[h] == 'true' || valorColumnas[h] == '1')
                                                    valorColumnas[h] = true;
                                                else
                                                    valorColumnas[h] = false;
                                                break;
                                            case 'DATE':
                                                // console.log("DATE");
                                                valorColumnas[h] = sharedService.formatDate(valorColumnas[h]);
                                                // console.log(valorColumnas[h]);
                                                break;
                                            case 'DATETIMEREGIONAL':
                                                // Manejo de un DATETIMEREGIONAL agregado el 04/09/2024

                                                // valorColumnas[h] = sharedService.formatDate(valorColumnas[h]);
                                                if (!valorColumnas[h])
                                                    valorColumnas[h] = ctrl.camposList[index].Campo.Columnas[h].ValorObjeto;

                                                break;
                                            case 'JERARQ':
                                                // Manejo de una jerarquia agregada el 04/09/2024
                                                if (valorColumnas[h] && valorColumnas[h] != null && valorColumnas[h].length > 0) {
                                                    valorColumnas[h] = JSON.parse(valorColumnas[h]);
                                                    for (var l = 0; l < valorColumnas[h].length; l++) {
                                                        if (valorColumnas[h][l] != null)
                                                            valorColumnas[h][l].ValorInput = valorColumnas[h][l].Nombre;
                                                    }
                                                } else {
                                                    if (!valorColumnas[h])
                                                        valorColumnas[h] = [];

                                                    valorColumnas[h].push({
                                                        JerarquiaPadreId: ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId,
                                                        LoadingJerarquia: false,
                                                        NoResults: false,
                                                        Placeholder: placeholderText
                                                    });
                                                    loadJerarquiaPlaceholderTableEnr(ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId, index, k, h, valorColumnas[h].length - 1);
                                                }
                                                break;
                                            case 'MULTI_LIST':
                                                if (valorColumnas[h]) {
                                                    valorColumnas[h] = JSON.parse(valorColumnas[h]);
                                                } else {
                                                    valorColumnas[h] = {
                                                        SourceObjeto: ctrl.camposList[index].Campo.Columnas[h].SourceObjeto,
                                                        ValorObjeto: [],
                                                    }
                                                }
                                                // console.log(valorColumnas[h]);
                                                break;
                                            case 'LIST':
                                                valorColumnas[h] = { "Id": valorColumnas[h] }
                                                break;
                                            case 'USER':
                                                // console.log(valorColumnas[h]);
                                                valorColumnas[h] = JSON.parse(valorColumnas[h]);
                                                break;
                                            default:
                                                break;
                                        }
                                    } catch (ex) {

                                    }
                                    ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[h]);
                                }
                            }
                        }
                    }
                }
            }

            function loadTablaCampoCondicional(index) {
                if (ctrl.camposList[index].Valor != null && ctrl.camposList[index].Valor.length > 0) {
                    ctrl.camposList[index].TablaFilas = [];
                    var valorFilas = ctrl.camposList[index].Valor.split('^');
                    if (valorFilas != null && valorFilas.length > 0) {
                        for (var k = 0; k < valorFilas.length; k++) {
                            ctrl.camposList[index].TablaFilas.push({
                                Valor: []
                            });
                            var valorColumnas = valorFilas[k].split('~');

                            if (valorColumnas != null && valorColumnas.length > 0) {
                                ctrl.camposList[index].ValorObjeto = valorColumnas[0];
                                ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[0]);
                                for (var h = 0; h < valorColumnas.length; h++) {
                                    try {
                                        switch (ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.CampoTipo.Codigo) {
                                            case 'INT':
                                                valorColumnas[1] = sharedService.addThousandSeparator(valorColumnas[1]);
                                                break;
                                            case 'DECIMAL':
                                                valorColumnas[1] = sharedService.addThousandSeparator(valorColumnas[1]);
                                                break;
                                            case 'BOOL':
                                                if (valorColumnas[1] == 'true' || valorColumnas[1] == '1')
                                                    valorColumnas[1] = true;
                                                else
                                                    valorColumnas[1] = false;
                                                break;
                                            case 'DATE':
                                                valorColumnas[1] = sharedService.formatDate(valorColumnas[1]);
                                                break;
                                            case 'ATTACH':
                                                ctrl.camposList[index].ValorObjeto = valorColumnas[1];
                                                break;
                                            case 'IMG':
                                                ctrl.camposList[index].ValorObjeto = valorColumnas[1];
                                                break;
                                            default:
                                                break;
                                        }
                                    } catch (ex) {

                                    }
                                    ctrl.camposList[index].TablaFilas[k].Valor.push(valorColumnas[1]);
                                }
                            }
                        }
                    }
                }
            }

            function loadJerarquiaPlaceholder(jerarquiaPadreId, campoIndex, jerarquiaIndex) {
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Ejemplo: ";
                else if (ctrl.language == "ingles")
                    placeholderText = "Example: ";
                else if (ctrl.language == "portugues")
                    placeholderText = "Exemplo: ";
                else if (ctrl.language == "italiano")
                    placeholderText = "Ejemplo: ";

                dataService.getJerarquiaMuestra(jerarquiaPadreId, 2)
                    .then(function (response) {
                        if (response.data.Success) {
                            var ph = '';

                            if (response.data.Value != null) {
                                if (response.data.Value.length > 0)
                                    ph = placeholderText + response.data.Value[0].Nombre;

                                if (response.data.Value.length > 1)
                                    ph = ph + ', ' + response.data.Value[1].Nombre;
                            }

                            ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].Placeholder = ph;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            function loadJerarquiaPlaceholderTableEnr(jerarquiaPadreId, campoIndex, filaIndex, columnaIndex, jerarquiaIndex) {
                // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Ejemplo: ";
                else if (ctrl.language == "ingles")
                    placeholderText = "Example: ";
                else if (ctrl.language == "portugues")
                    placeholderText = "Exemplo: ";
                else if (ctrl.language == "italiano")
                    placeholderText = "Ejemplo: ";

                dataService.getJerarquiaMuestra(jerarquiaPadreId, 2)
                    .then(function (response) {
                        if (response.data.Success) {
                            var ph = '';

                            if (response.data.Value != null) {
                                if (response.data.Value.length > 0)
                                    ph = placeholderText + response.data.Value[0].Nombre;

                                if (response.data.Value.length > 1)
                                    ph = ph + ', ' + response.data.Value[1].Nombre;
                            }

                            ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].Placeholder = ph;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.searchJerarquia = function (nombreJerarquia, padreId) {
                if (!(/[A-Za-z\s\-_0-9]/g.test(nombreJerarquia))) {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = 'El carácter no es válido, revíselo e intente nuevamente';
                    else if (ctrl.language == "ingles")
                        errorText = 'Invalid character, please check and try again';
                    else if (ctrl.language == "portugues")
                        errorText = 'O caractere não é válido, revise e tente novamente';
                    else if (ctrl.language == "italiano")
                        errorText = 'El carácter no es válido, revíselo e intente nuevamente';

                    toastr.error(errorText);
                    return;
                }
                return dataService.searchJerarquiaByPadre(nombreJerarquia, padreId)
                    .then(function (response) {
                        if (response.data.Success) {
                            return response.data.Value;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.onSelectJerarquia = function (campoIndex, jerarquiaIndex, jerarquiaSeleccionada) {
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Cargando...";
                else if (ctrl.language == "ingles")
                    placeholderText = "Loading...";
                else if (ctrl.language == "portugues")
                    placeholderText = "Carregando...";
                else if (ctrl.language == "italiano")
                    placeholderText = "Cargando...";

                if (jerarquiaSeleccionada == null)
                    return;

                if (campoIndex >= 0) {
                    if (jerarquiaSeleccionada.Detalles != null && jerarquiaSeleccionada.Detalles.length > 0) {
                        jerarquiaSeleccionada.Detalles.sort(function (a, b) {
                            return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
                        });
                    }

                    ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex] = jerarquiaSeleccionada;
                    ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].ValorInput = jerarquiaSeleccionada.Nombre;

                    //Borrado de todas las jerarquias posteriores a la actual
                    ctrl.camposList[campoIndex].ValorObjeto.splice(jerarquiaIndex + 1, (ctrl.camposList[campoIndex].ValorObjeto.length - jerarquiaIndex - 1));
                    ctrl.camposList[campoIndex].Valor = jerarquiaSeleccionada.Id;

                }

                dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == true) {
                                ctrl.camposList[campoIndex].ValorObjeto.push({
                                    ValorInput: null,
                                    JerarquiaPadreId: jerarquiaSeleccionada.Id,
                                    LoadingJerarquia: false,
                                    NoResults: false,
                                    Placeholder: placeholderText
                                });

                                loadJerarquiaPlaceholder(jerarquiaSeleccionada.Id, campoIndex, ctrl.camposList[campoIndex].ValorObjeto.length - 1);
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.onSelectJerarquiaTableEnr = function (campoIndex, filaIndex, columnaIndex, jerarquiaIndex, jerarquiaSeleccionada) {
                // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
                var placeholderText;

                if (ctrl.language == "español")
                    placeholderText = "Cargando...";
                else if (ctrl.language == "ingles")
                    placeholderText = "Loading...";
                else if (ctrl.language == "portugues")
                    placeholderText = "Carregando...";
                else if (ctrl.language == "italiano")
                    placeholderText = "Cargando...";

                if (jerarquiaSeleccionada == null)
                    return;

                if (campoIndex >= 0) {
                    if (jerarquiaSeleccionada.Detalles != null && jerarquiaSeleccionada.Detalles.length > 0) {
                        jerarquiaSeleccionada.Detalles.sort(function (a, b) {
                            return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
                        });
                    }

                    // console.log("Campo : " + campoIndex);
                    // console.log("Fila : " + filaIndex);
                    // console.log("Columna : " + columnaIndex);
                    // console.log("Jerarquia : " + jerarquiaIndex);
                    // console.log(ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex]);
                    // console.log(ctrl.camposList[campoIndex]);

                    ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex] = jerarquiaSeleccionada;
                    ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].ValorInput = jerarquiaSeleccionada.Nombre;

                    //Borrado de todas las jerarquias posteriores a la actual
                    ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].splice(jerarquiaIndex + 1,
                        (ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].length - jerarquiaIndex - 1));

                }

                dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            if (response.data.Value == true) {
                                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].push({
                                    ValorInput: null,
                                    JerarquiaPadreId: jerarquiaSeleccionada.Id,
                                    LoadingJerarquia: false,
                                    NoResults: false,
                                    Placeholder: placeholderText
                                });

                                // Al jerarquiaIndex se le suma uno porque actualmente tiene el valor del primer input, en caso de tener padre, el placeholder sería para el siguiente input
                                loadJerarquiaPlaceholderTableEnr(jerarquiaSeleccionada.Id, campoIndex, filaIndex, columnaIndex, jerarquiaIndex + 1);
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.altaNuevaJerarquiaTableEnr = function (campoIndex, filaIndex, columnaIndex, jerarquiaIndex) {
                // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
                ctrl.isBusy = true;
                var jerarquiaPadre = {};
                var confirmationTitle;

                if (ctrl.language == "español")
                    confirmationTitle = "Alta de Nueva Jerarquía";
                else if (ctrl.language == "ingles")
                    confirmationTitle = "New Hierarchy Registration";
                else if (ctrl.language == "portugues")
                    confirmationTitle = "Cadastro de Nova Hierarquia";
                else if (ctrl.language == "italiano")
                    confirmationTitle = "Alta de Nueva Jerarquía";


                if (jerarquiaIndex > 0)
                    jerarquiaPadre = ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex - 1];
                else
                    jerarquiaPadre = {
                        Id: ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].JerarquiaPadreId,
                        Nombre: ""
                    };

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "altaJerarquia",
                    resolve: {
                        title: function () {
                            return confirmationTitle
                        },
                        JerarquiaPadre: function () {
                            return jerarquiaPadre
                        },
                    }
                });

                confirmation.result.then(function (returnValue) {
                    ctrl.isBusy = false;
                    ctrl.onSelectJerarquiaTableEnr(campoIndex, filaIndex, columnaIndex, jerarquiaIndex, returnValue);
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.searchCampoUsuario = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                return dataService.searchUsuario(filtroUsuario)
                    .then(function (response) {
                        if (response.data.Success) {
                            return response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.altaNuevaJerarquia = function (campoIndex, jerarquiaIndex) {
                ctrl.isBusy = true;
                var jerarquiaPadre = {};
                var confirmationTitle;

                if (ctrl.language == "español")
                    confirmationTitle = "Alta de Nueva Jerarquía";
                else if (ctrl.language == "ingles")
                    confirmationTitle = "New Hierarchy Registration";
                else if (ctrl.language == "portugues")
                    confirmationTitle = "Cadastro de Nova Hierarquia";
                else if (ctrl.language == "italiano")
                    confirmationTitle = "Alta de Nueva Jerarquía";


                if (jerarquiaIndex > 0)
                    jerarquiaPadre = ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex - 1];
                else
                    jerarquiaPadre = {
                        Id: ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].JerarquiaPadreId,
                        Nombre: ""
                    };

                var confirmation = $uibModal.open({
                    animation: true,
                    component: "altaJerarquia",
                    resolve: {
                        title: function () {
                            return confirmationTitle
                        },
                        JerarquiaPadre: function () {
                            return jerarquiaPadre
                        },
                    }
                });

                confirmation.result.then(function (returnValue) {
                    ctrl.isBusy = false;
                    ctrl.onSelectJerarquia(campoIndex, jerarquiaIndex, returnValue);
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.onSelectUsuarioMultiList = function (campoIndex, usuarioSeleccionado) {
                if (usuarioSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null)
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioSeleccionado.Id) {
                            ctrl.usuarioCargado = null;
                            return;
                        }
                    }
                    ctrl.camposList[campoIndex].ValorObjeto.push(usuarioSeleccionado);
                    ctrl.usuarioCargado = null;
                }
            }

            ctrl.onSelectUsuarioMultiListTableEnr = function (indexCampo, indexFila, indexColumna, colValor, defaultSelected) {
                // console.log(indexCampo);
                // console.log("FilA : " + indexFila);
                // console.log("Columna : " + indexColumna);
                // console.log("VALOR!!! : " + colValor);
                // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna]);
                if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == null || ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].length == 0) {
                    ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = [];
                }
                if (defaultSelected == 99) {
                    colValor = {
                        text: {
                            Id: ctrl.model.UsuarioCreacion.Id,
                            Login: ctrl.model.UsuarioCreacion.Login,
                            Nombre: ctrl.model.UsuarioCreacion.Nombre,
                            Apellido: ctrl.model.UsuarioCreacion.Apellido
                        }
                    }
                }
                if (!ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].some(function (user) { return user.Id === colValor.text.Id; })) {
                    ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].push({
                        Id: colValor.text.Id,
                        Login: colValor.text.Login,
                        Nombre: colValor.text.Nombre,
                        Apellido: colValor.text.Apellido
                    });
                }
                colValor.text = '';
                // console.log("OJOJOJOJOJOJOJ");
                // console.log(ctrl.camposList);
            }

            ctrl.deleteCampoUsuarioTableEnr = function (indexCampo, indexFila, indexColumna, colValor, defaultSelected) {
                // console.log(indexCampo);
                // console.log("FilA : " + indexFila);
                // console.log("Columna : " + indexColumna);
                // console.log("VALOR!!! : " + colValor);
                // console.log(ctrl.camposList[indexCampo]);
                if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == null || ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == undefined)
                    return;
                for (var k = 0; k < ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].length; k++) {
                    // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna][k].Id);
                    if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna][k].Id == colValor) {
                        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].splice(k, 1);
                        return;
                    }
                }
            }


            ctrl.deleteCampoUsuario = function (campoIndex, usuarioId) {
                if (ctrl.camposList[campoIndex].ValorObjeto == null)
                    return;

                for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                    if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
                        ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
                        return;
                    }
                }
            }
            ctrl.initListadoProcesos = function () {
                ctrl.isSearching = true;
                ctrl.filtros = {
                    PageSize: 1000,
                    SkipNumber: 0
                };
                // dataService.searchProceso(ctrl.filtros) // Este endpoint se usó hasta el 17/02/2025, se comporta igual al endpoint agregado abajo
                dataService.searchProceso_nodoc(ctrl.filtros)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.listadoDeProcesos = response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isSearching = false;
                    });

            }
            ctrl.initListadoProcesos_doc = function () {
                ctrl.isSearching = true;
                ctrl.filtros = {
                    PageSize: 1000,
                    SkipNumber: 0
                };
                dataService.searchProceso_doc(ctrl.filtros)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.listadoDeProcesos_doc = response.data.Value.Resultados;
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isSearching = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isSearching = false;
                    });

            }
            ctrl.onChangeSelectProcesoSeleccionado = function (procesoSeleccionado) {
            };
            ctrl.onChangeSelectProcesoSeleccionado_doc = function (procesoSeleccionado_doc) {
            };
            ctrl.searchCampoSolicitud = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                if (ctrl.procesoSeleccionado != null && ctrl.procesoSeleccionado.Id != "") {

                    var filtrosSolicitud = {
                        ProcesoId: ctrl.procesoSeleccionado.Id + "",
                        Descripcion: nombreUsuario,
                        PageSize: 100,
                        SkipNumber: 0,
                        VerTodos: true,
                        documentalGetCerrados: true,
                        // VerProcesosPendientesOtrosUsuarios: false,
                        lProcesoIsDocumentalAutorizacionesV2: ctrl.procesoSeleccionado.autorizacionesDocumental,
                        // true, esta prop hasta el 11/02/2025 siempre se enviaba en true, ahora debe tomar el valor que venga en autorizacionesDocumental del proceso 
                        // false, esta prop se enviaba en false hasta la fecha 07/08/2024, debido a que este tipo de campos SIEMPRE debe traer solicitudes ya cerradas
                        VerProcesosPendientesOtrosUsuarios: false,
                        misSolicitudes: true
                        // las propiedades VerProcesosPendientesOtrosUsuarios y misSolicitudes fueron seteadas el dia 12/09/2025 solo cuando no es solicitud documental
                    };

                    // return dataService.searchSolicitud(filtrosSolicitud)
                    return dataService.searchSolicitudSimple(filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {
                                //
                                ctrl.ListarSolicitudesProceso = response.data.Value.Resultados;
                                return response.data.Value.Resultados;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                } else {
                }


            }
            ctrl.searchCampoSolicitud_doc = function (nombreUsuario) {
                var filtroUsuario = {
                    Login: nombreUsuario,
                    PageSize: 20,
                    SkipNumber: 0
                };

                if (ctrl.procesoSeleccionado_doc != null && ctrl.procesoSeleccionado_doc.Id != "") {

                    var filtrosSolicitud = {
                        ProcesoId: ctrl.procesoSeleccionado_doc.Id + "",
                        Descripcion: nombreUsuario,
                        PageSize: 100,
                        SkipNumber: 0,
                        VerTodos: true,
                        documentalGetCerrados: true,
                        // VerProcesosPendientesOtrosUsuarios: false,
                        lProcesoIsDocumentalAutorizacionesV2: ctrl.procesoSeleccionado_doc.autorizacionesDocumental 
                        // true, esta prop hasta el 11/02/2025 siempre se enviaba en true, ahora debe tomar el valor que venga en autorizacionesDocumental del proceso 
                        // false, esta prop se enviaba en false hasta la fecha 07/08/2024, debido a que este tipo de campos SIEMPRE debe traer solicitudes ya cerradas
                    };

                    // return dataService.searchSolicitud_doc(filtrosSolicitud)
                    return dataService.searchSolicitudSimple(filtrosSolicitud)
                        .then(function (response) {
                            if (response.data.Success) {

                                ctrl.ListarSolicitudesProceso_doc = response.data.Value.Resultados;
                                return response.data.Value.Resultados;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                } else {
                }
            }
            //MANTENER IGUAL
            ctrl.onSelectSolicitudMultiList = function (campoIndex, itemSeleccionado) {

                if (itemSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
                            ctrl.solicitudCargada = null;
                            return;
                        }
                    }

                    // Antes del 29/03/2025 se usaba este método para obtener el proceso, pero se cambio para mejorar performace
                    // dataService.getProcesoById(itemSeleccionado.ProcesoId)
                    dataService.getProcesoInSolicitud(itemSeleccionado.ProcesoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                var proceso = response.data.Value;

                                var obj = {
                                    Id: itemSeleccionado.Id,
                                    Numero: itemSeleccionado.Numero,
                                    NumeroCompleto: itemSeleccionado.NumeroCompleto,
                                    ProcesoId: itemSeleccionado.ProcesoId,
                                    Descripcion: itemSeleccionado.Descripcion,
                                    DescripcionResumida: itemSeleccionado.DescripcionResumida,
                                    Proceso: {
                                        Id: itemSeleccionado.ProcesoId,
                                        Nombre: proceso.Nombre,
                                        GrupoId: proceso.GrupoId
                                    },
                                    CreationDate: itemSeleccionado.CreationDate
                                };

                                ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                                ctrl.solicitudCargada = null;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })

                }
            }
            ctrl.onSelectSolicitudMultiList_doc = function (campoIndex, itemSeleccionado) {

                if (itemSeleccionado == null)
                    return;

                if (campoIndex >= 0) {
                    if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
                        ctrl.camposList[campoIndex].ValorObjeto = [];

                    for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                        if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
                            ctrl.solicitudCargada_doc = null;
                            return;
                        }
                    }

                    // Antes del 29/03/2025 se usaba este método para obtener el proceso, pero se cambio para mejorar performace
                    // dataService.getProcesoById(itemSeleccionado.ProcesoId)
                    dataService.getProcesoInSolicitud(itemSeleccionado.ProcesoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                var proceso = response.data.Value;

                                var obj = {
                                    Id: itemSeleccionado.Id,
                                    Numero: itemSeleccionado.Numero,
                                    NumeroCompleto: itemSeleccionado.NumeroCompleto,
                                    ProcesoId: itemSeleccionado.ProcesoId,
                                    Descripcion: itemSeleccionado.Descripcion,
                                    DescripcionResumida: itemSeleccionado.DescripcionResumida,
                                    Proceso: {
                                        Id: itemSeleccionado.ProcesoId,
                                        Nombre: proceso.Nombre,
                                        GrupoId: proceso.GrupoId
                                    },
                                    NumeradorDocumental: itemSeleccionado.NumeradorDocumental,
                                    CreationDate: itemSeleccionado.CreationDate
                                };

                                ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                                ctrl.solicitudCargada_doc = null;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })

                }
            }

            ctrl.deleteCampoSolicitud = function (campoIndex, usuarioId) {
                if (ctrl.camposList[campoIndex].ValorObjeto == null)
                    return;

                for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
                    if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
                        ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
                        return;
                    }
                }
            }


            ctrl.openAttachment = function (fileName) { // isVerDocumento
                var usuarioLogueadoId = authData.Id;

                if (fileName.toLowerCase().slice(0, 4) != "http") {
                    // Si el fileName no comienza por http, quiere decir que es el nombre del archivo y por ende hay que añadir la ruta del upload
                    var fullUrl = appConfig.uploadUrl + fileName;
                    sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl, false);

                } else {
                    // Si no, es una url válida para entrar al visor
                    sharedService.openVisorDocumental(usuarioLogueadoId, fileName, false);
                }

                //     var usuarioLogueadoId = authData.Id;
                //     // var urlBase64 = btoa(appConfig.uploadUrl + fileName);
                //     var urlBase64 = btoa(appConfig.uploadUrl);
                //     console.log(appConfig.uploadUrl + fileName);

                //     if (isVerDocumento == 'verDocumento') {
                //         sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.model.Proceso);
                //         return;
                //     }

                //     window.open(appConfig.uploadUrl + fileName);
            }


            ctrl.loadImgCompleted = function (file) {
                // console.log("completed");
                // console.log(file);
            }

            ctrl.removeAttachment = function (item) {
                // console.log(item);
                item.ValorObjeto = null;
                item.ValorObjetoImgTmp = null;
            }

            ctrl.removeAttachmentTableEnr = function (campoIndex, filaIndex, columnaIndex) {
                // console.log(campoIndex, filaIndex, columnaIndex);
                // Este valor se guada posteriormente como string, por lo que para vaciarlo es mejor darle un void string
                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = "";
            }

            ctrl.uploadAttachment = function (file, item, index) {
                var valorObjetoUrl = $('.valorObjetoUrl').filter('[data-index="' + index + '"]')

                if (item.Campo.CampoId.slice(0, 2) == 'QR') {
                    // Si el campo es de tipo QR
                    ctrl.fileForQRTouched = true;

                    var dispositivo = navigator.userAgent;
                    var ip = null;

                    $.ajax({
                        method: 'GET',
                        url: 'https://api.ipify.org?format=json',
                        success: function (response) {
                            ip = response.ip;

                            ctrl.fileForQR = {
                                file: file,
                                campoId: item.Campo.Id,
                                dispositivo: dispositivo,
                                ip: ip,
                            };
                            // Capturada la ip del usuario y el dispositivo desde el que subio el archivo para almacenarlo en memoria

                            // console.log(ctrl.fileForQR);
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        },
                        error: function (error) {
                            toastr.error(error || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        }
                    })


                    if (ctrl.language == "español") {
                        item.ValorObjeto = 'El archivo "' + file.name + '" será procesado una vez guardada la solicitud';
                        item.Valor = 'El archivo "' + file.name + '" será procesado una vez guardada la solicitud';
                    }
                    else if (ctrl.language == "ingles") {
                        item.ValorObjeto = 'The file "' + file.name + '" will be processed once the request is saved';
                        item.Valor = 'The file "' + file.name + '" will be processed once the request is saved';
                    }
                    else if (ctrl.language == "portugues") {
                        item.ValorObjeto = 'O arquivo "' + file.name + '" será processado assim que o aplicativo for salvo';
                        item.Valor = 'O arquivo "' + file.name + '" será processado assim que o aplicativo for salvo';
                    }
                    else if (ctrl.language == "italiano") {
                        item.ValorObjeto = 'El archivo "' + file.name + '" será procesado una vez guardada la solicitud';
                        item.Valor = 'El archivo "' + file.name + '" será procesado una vez guardada la solicitud';
                    }

                    valorObjetoUrl.html(item.ValorObjeto)
                } else {

                    if (file == null)
                        return;

                    ctrl.isBusy = true;
                    item.isLoading = true;

                    // console.log(item.Campo.CampoId);
                    dataService.updateFileSolicitudCampoValor(file)
                        .then(function (response) {
                            $timeout(function () {
                                if (response.data.Success) {
                                    item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };

                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                    item.ValorObjeto = null;
                                }
                            });
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        });
                }
            }
            // ctrl.uploadAttachment = function (file, item) {
            //     if (file == null)
            //         return;

            //     ctrl.isBusy = true;
            //     item.isLoading = true;

            //     // console.log(item.Campo.CampoId);
            //     dataService.updateFileSolicitudCampoValor(file)
            //         .then(function (response) {
            //             $timeout(function () {
            //                 if (response.data.Success) {
            //                     item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
            //                 } else {
            //                     toastr.error(response.data.ErrorSummary);
            //                     item.ValorObjeto = null;
            //                 }
            //             });
            //             ctrl.isBusy = false;
            //             item.isLoading = false;
            //         }, function (error) {
            //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            //             ctrl.isBusy = false;
            //             item.isLoading = false;
            //         });
            // }

            ctrl.uploadAttachmentTableEnr = function (file, campoIndex, filaIndex, columnaIndex) {
                if (file == null)
                    return;

                ctrl.isBusy = true;

                dataService.updateFileSolicitudCampoValor(file)
                    .then(function (response) {
                        $timeout(function () {
                            if (response.data.Success) {
                                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = response.data.Value;
                            } else {
                                toastr.error(response.data.ErrorSummary);
                                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = "";
                            }
                        });
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                    });
            }

            ctrl.uploadAttachmentPicture = function (file, item) {
                ctrl.isBusy = true;
                item.isLoading = true;
                $timeout(function () {
                    // Swal.fire({
                    //     title: '',
                    //     showCancelButton: false,
                    //     confirmButtonColor: '#3085d6',
                    //     confirmButtonText: 'Aceptar',
                    //     cancelButtonText: 'Cancel',
                    //     showCloseButton: false,
                    //     allowOutsideClick: false,
                    //     allowEscapeKey: false,
                    //     focusConfirm: false,
                    //     heightAuto: false,
                    //     onOpen: function () {
                    //         swal.showLoading();
                    //     }
                    // });

                    if (item.ValorObjetoImgTmp == null || item.ValorObjetoImgTmp == undefined) {
                        ctrl.isBusy = false;
                        item.isLoading = false;
                        return;
                    }

                    // file = item.ValorObjetoImgTmp.compressed.dataURL; // Antes del 05/03/2025 se enviaba la imagen comprimida, lo que daba conflicto con los pngs, por ende se cambio a la imagen completa
                    file = item.ValorObjetoImgTmp.dataURL;

                    // console.log(file);
                    file = file.replace("data:image/png;base64,", "").replace("data:image/jpg;base64,", "").replace("data:image/jpeg;base64,", "");

                    dataService.updateFileSolicitudCampoValor(file)
                        .then(function (response) {
                            $timeout(function () {
                                if (response.data.Success) {
                                    item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
                                } else {
                                    toastr.error(response.data.ErrorSummary);
                                    item.ValorObjeto = null;
                                }
                                // console.log(response.data);
                                swal.close();
                            });
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                            item.isLoading = false;
                        });
                }, 3000);
            }

            ctrl.evaluatenumber = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.evaluatenumberDigit = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 109) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.validateNotOnlyZero = function (campo) {
                // Si en el campo de código "VERSION" se escribe un 0 solo, se valida que debe ser mayor a 0
                if (campo.ValorObjeto == 0) {
                    campo.ValorObjeto = null;

                    var errorText;

                    if (ctrl.language == "español")
                        errorText = 'Este campo debe tener un valor superior a 0';
                    else if (ctrl.language == "ingles")
                        errorText = 'This field must have a value greater than 0';
                    else if (ctrl.language == "portugues")
                        errorText = 'Este campo deve ter um valor superior a 0';
                    else if (ctrl.language == "italiano")
                        errorText = 'Este campo debe tener un valor superior a 0';

                    return toastr.error(errorText)
                }
            }

            ctrl.evaluatenumberDecimal = function (event) {
                var charCode = (event.which) ? event.which : event.keyCode;
                if (charCode == 8 || charCode == 35 || charCode == 36 || charCode == 37 || charCode == 39 || charCode == 45 || charCode == 46 || charCode == 96 || charCode == 190 || charCode == 109 || charCode == 110) {
                    return true;
                } else if (charCode >= 97 && charCode <= 105) {
                    return true;
                } else if (charCode < 48 || charCode > 57) {
                    event.preventDefault();
                    return false;
                } else {
                    return true;
                }
            }

            ctrl.onChangeInputTable = function (indexCampo, indexFila, indexColumna, valor) {
                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor;
            }

            ctrl.onChangeInputEnr = function (indexCampo, indexFila, indexColumna, valor) {
                // console.log("index CAMPO: " + indexCampo);
                // console.log("index FILA: " + indexFila);
                // console.log("index COLUMNA: " + indexColumna);

                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor;
            }

            ctrl.onChangeSelectTableEnrList = function (indexCampo, indexFila, indexColumna, valor) {
                // console.log("index CAMPO: " + indexCampo);
                // console.log("index FILA: " + indexFila);
                // console.log("index COLUMNA: " + indexColumna);
                // console.log(valor);

                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor.Id;
                // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila]);
            }

            ctrl.onChangeInputEnrindextest = function (indexCampo, indexFila, indexColumna, valor, TMP1, TMP2, TMP3) {
                // console.log("index CAMPO: " + indexCampo);
                // console.log("index FILA: " + indexFila);
                // console.log("index COLUMNA: " + indexColumna);
                // console.log("index TMP1: " + TMP1);
                // console.log("index TMP2: " + TMP2);
                // console.log("index TMP3: " + TMP3);
                // console.log(valor);

                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor.Id;
                // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila]);
            }


            ctrl.onChangeInputTableCond = function (indexCampo, indexFila, indexColumna, valor) {
                ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor;
            }

            ctrl.onChangeInputcond = function (item) {
                item.Valor[1] = "";
            }

            ctrl.onNumericInputGotFocus = function (nStr) {
                return sharedService.replaceAll(nStr, ",", "");
            }

            ctrl.onNumericInputLostFocus = function (nStr) {
                return sharedService.addThousandSeparator(nStr);
            }

            ctrl.onChangeInputUsuarioAnterior = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.anteriorEstadoUsuariosList, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.anteriorEstadoUsuariosList = result;
                    } else {
                        ctrl.anteriorEstadoUsuariosList = ctrl.anteriorEstadoUsuariosListTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.anteriorEstadoUsuariosList = ctrl.anteriorEstadoUsuariosListTmp;
                }
            }

            ctrl.onChangeInputCampostList = function (textoBusqueda, item, jerarquiaPadreId) {
                if (!item.SourceObjetoTemp) {
                    item.SourceObjetoTemp = item.SourceObjeto;
                }

                if (!item.jerarquiaPadreId && jerarquiaPadreId) {
                    item.jerarquiaPadreId = jerarquiaPadreId;
                }

                if (!item.ValorObjeto || item.ValorObjeto.length < 1) {
                    item.ValorObjeto = [];
                  }

                if (textoBusqueda.length >= 1) {
                    dataService.searchJerarquiaByPadre(textoBusqueda, item.jerarquiaPadreId)
                        .then(function(response) {
                            if (response.data.Success) {
                                // Si filtra los elementos seleccionados de la respuesta del backend
                                item.SourceObjeto = response.data.Value.filter(function(element) {
                                    var alreadySelected = item.ValorObjeto.findIndex(function (el) {
                                        return element.Id == el.Id;
                                    })

                                    return alreadySelected == -1;
                                });
                            } else {
                                toastr.error(response.data.ErrorSummary)
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })
                    /**
                     * Antes del cambio del 17/09/2024 ↓
                     */
                    // var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
                    // if (result != null && result != undefined && result.length > 0) {
                    //     item.SourceObjeto = result;
                    // } else {
                    //     item.SourceObjeto = [];// item.SourceObjetoTemp;
                    // }
                } else if (textoBusqueda.length == 0) {
                    item.SourceObjeto = item.SourceObjetoTemp;
                }
            }

            ctrl.onChangeInputCampostListTableEnr = function (textoBusqueda, item, jerarquiaPadreId) {
                if (!item.SourceObjetoTemp) {
                    item.SourceObjetoTemp = item.SourceObjeto;
                }

                if (!item.jerarquiaPadreId && jerarquiaPadreId) {
                    item.jerarquiaPadreId = jerarquiaPadreId;
                }

                if (!item.ValorObjeto || item.ValorObjeto.length < 1) {
                    item.ValorObjeto = [];
                  }

                if (textoBusqueda.length >= 1) {
                    dataService.searchJerarquiaByPadre(textoBusqueda, item.jerarquiaPadreId)
                        .then(function(response) {
                            if (response.data.Success) {
                                // Si filtra los elementos seleccionados de la respuesta del backend
                                item.SourceObjeto = response.data.Value.filter(function(element) {
                                    var alreadySelected = item.ValorObjeto.findIndex(function (el) {
                                        return element.Id == el.Id;
                                    })

                                    return alreadySelected == -1;
                                });
                            } else {
                                toastr.error(response.data.ErrorSummary)
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })
                    /**
                     * Antes del cambio del 17/09/2024 ↓
                     */
                    // var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
                    // if (result != null && result != undefined && result.length > 0) {
                    //     item.SourceObjeto = result;
                    // } else {
                    //     item.SourceObjeto = [];// item.SourceObjetoTemp;
                    // }
                } else if (textoBusqueda.length == 0) {
                    item.SourceObjeto = item.SourceObjetoTemp;
                }
            }

            ctrl.onChangeInputUsuarioSiguiente = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.siguienteEstadoUsuariosList, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.siguienteEstadoUsuariosList = result;
                    } else {
                        ctrl.siguienteEstadoUsuariosList = ctrl.siguienteEstadoUsuariosListTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.siguienteEstadoUsuariosList = ctrl.siguienteEstadoUsuariosListTmp;
                }
            }

            ctrl.onChangeInputUsuarioSiguienteDerivar = function (nStr) {
                if (nStr.length > 1) {
                    var result = sharedService.contains(ctrl.listaUsuariosDerivarResponsabilidad, "Login", nStr);
                    if (result != null && result != undefined) {
                        ctrl.listaUsuariosDerivarResponsabilidad = result;
                    } else {
                        ctrl.listaUsuariosDerivarResponsabilidad = ctrl.listaUsuariosDerivarResponsabilidadTmp;
                    }
                } else if (nStr.length == 0) {
                    ctrl.listaUsuariosDerivarResponsabilidad = ctrl.listaUsuariosDerivarResponsabilidadTmp;
                }
            }

            ctrl.listaUsuariosDerivar = function () {
                //Si el proceso permite derivar responsabilidad hacer esto:
                if (
                    (ctrl.model.Id != 0 && ctrl.model.Proceso.PermiteDerivarRes == 1) &&
                    (ctrl.lsuarioLogueadoIsAdminProceso || ctrl.model.UsuarioAprobadorId == ctrl.lUsuarioLogeado.Id) &&
                    (ctrl.model.EstadoId != 6)
                ) {
                    try {
                        dataService.getUsuarioListByProcesoEstado(ctrl.model.ProcesoId, ctrl.model.Id, ctrl.model.EstadoId).then(function (response) {
                            if (response.data.Success) {
                                ctrl.listaUsuariosDerivarResponsabilidad = response.data.Value;
                                ctrl.listaUsuariosDerivarResponsabilidadTmp = ctrl.listaUsuariosDerivarResponsabilidad;
                            } else {
                                ctrl.listaUsuariosDerivarResponsabilidad = [];
                                ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                    } catch (ex) {
                        ctrl.listaUsuariosDerivarResponsabilidad = [];
                        ctrl.listaUsuariosDerivarResponsabilidadTmp = [];
                    }
                }
            }

            /**
             * Permite Mostrar u ocultar items dependiendo de los datos de la solicitud ctrl.model
             */
            function onInitShowHideItemsModelSolicitud() {
                ctrl.showCopiaControlada = ctrl.model.Proceso.isDocumental;
            }

            ctrl.activarCampoValorDefault = function (item) {
                // Este mètodo se ejecuta cuando el campo "Tipo Registro" (Jerarquía) cambia su valor, lo que hace es llamar a un endpoint que devuelve varios campos con la estructura de "SolicitudCampoValor" darle a los campos que tengan el mismo CampoId, un valor por defecto que viene del dicho endpoint, las propiedades que se toman son "ValorObjeto" y "Valor"
                if (item.Campo.CampoId.slice(0, 8) == 'QRJERARQ') {
                    dataService.camposValorDefault(item.ValorObjeto.Codigo)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.camposList = ctrl.camposList.map(function (campo) {
                                    response.data.Value.filter(function (campoDef) {
                                        if (campoDef.CampoId == campo.CampoId) {
                                            campo.Valor = campoDef.Valor;
                                            campo.ValorObjeto = campoDef.ValorObjeto;
                                        }
                                    })
                                    return campo;
                                })
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        })
                }
            }

            function getProcesoCamposListado() {
                // Se llama al endpoint que tiene el CamposListado que se utiliza para armar la estructura del listado de solicitudes, esto para saber el orden en que debe enviarse los SolicitudCampoValor para darle de forma correcta el valor a los ValorFiltro
                dataService.getProcesoSolicitudGrid($state.params.proceso)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.procesoCamposListado = response.data.Value.CamposListado;

                            // console.log(ctrl.procesoCamposListado);
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            function orderCamposList() {
                // Esta funcion ordena los SolicitudCampoValor (camposList) en el orden de la propiedad CamposListado del Proceso (procesoCamposListado), con la finalidad de que cuando se generen los valorFiltro, siempre se guarden en el orden correcto. Para ello crea una copia del array ctrl.camposList, para no modificar la vista de los campos y que guarde la copia ordenada
                ctrl.camposListOrdered = [].concat(ctrl.camposList);

                var orderIndex = {};
                ctrl.procesoCamposListado.forEach(function (item, index) {
                    if (item.CampoId)
                        orderIndex[item.CampoId] = index;
                });

                ctrl.camposListOrdered.sort(function (a, b) {
                    var indexA = orderIndex.hasOwnProperty(a.CampoId) ? orderIndex[a.CampoId] : Infinity;
                    var indexB = orderIndex.hasOwnProperty(b.CampoId) ? orderIndex[b.CampoId] : Infinity;
                    return indexA - indexB;
                });
            }

            function getDataSolicitudesPadre(processId) {
                // Antes del 29/03/2025 se usaba este método para obtener el proceso, pero se cambio para mejorar performace
                // dataService.getProcesoById(processId)
                dataService.getProcesoInSolicitud(processId)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.model.SolicitudPadre.Proceso = response.data.Value;

                            ctrl.model.SolicitudPadre.ValorMostrarBusqueda = [];
                            var contador = 1;

                            ctrl.model.SolicitudPadre.Proceso.CamposListado.map(function (campo, index) {
                                if (campo.CampoId != null) {
                                    if (contador == 1) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro1);
                                        contador++;
                                    } else if (contador == 2) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro2);
                                        contador++;
                                    } else if (contador == 3) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro3);
                                        contador++;
                                    } else if (contador == 4) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro4);
                                        contador++;
                                    } else if (contador == 5) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro5);
                                        contador++;
                                    } else if (contador == 6) {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValorFiltro6);
                                    }
                                } else {
                                    var codigo = ctrl.model.SolicitudPadre.Proceso.CamposListado[index].SolicitudColumna.Codigo;

                                    if (codigo == "Id") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.Id);
                                    } else if (codigo == "Activo") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.Activo);
                                    } else if (codigo == "Descripcion") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.Descripcion);
                                    } else if (codigo == "DescripcionResumida") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.DescripcionResumida);
                                    } else if (codigo == "Estado") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValoresSolicitudColumna.EstadoNombre);
                                    } else if (codigo == "LastUpdate") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.LastUpdate);
                                    } else if (codigo == "FechaCierre") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.FechaCierre);
                                    } else if (codigo == "CreationDate") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.CreationDate);
                                    } else if (codigo == "Proceso") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.Proceso.Nombre);
                                    } else if (codigo == "NumeroCompleto") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.NumeroCompleto);
                                    } else if (codigo == "UsuarioAprobador") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValoresSolicitudColumna.UsuarioAprobacionNombre);
                                    } else if (codigo == "UsuarioCreacion") {
                                        ctrl.model.SolicitudPadre.ValorMostrarBusqueda.push(ctrl.model.SolicitudPadre.ValoresSolicitudColumna.UsuarioCreacionNombre);
                                    }
                                }
                            })

                            ctrl.solicitudesPadreList.push(ctrl.model.SolicitudPadre);
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            function updateCampoValorFile(SolicitudId, FileName) {
                // Esta función se encarga de actualizar el campo tipo attach con el valor del pdf QR actualizado,  ya que se ejecuta un Stored Procedure para generar la gestión (template) en solicitud y luego se genera el archivo. En esta función lo que se hace es actualizar el campo correspondiente al archivo  con el valor del pdf con el QR final
                var cargadosFilter = {
                    SolicitudId: SolicitudId
                };

                dataService.getCargadosBySolicitudList(cargadosFilter)
                    .then(function (response) {
                        if (response.data.Success) {
                            var templatesCargados = response.data.Value;

                            if (templatesCargados.length > 0) {
                                templatesCargados.map(function (template) {
                                    if (template.ProcesoTemplate.TemplateId == 4) {
                                        dataService
                                            .getCampoValorCompleto(
                                                template.Id,
                                                SolicitudId,
                                                ctrl.model.EstadoId,
                                                template.ProcesoTemplate.Id,
                                                template.ProcesoTemplate.TemplateId
                                            )
                                            .then(
                                                function (response) {
                                                    if (response.data.Success) {
                                                        var camposValor = response.data.Value;

                                                        if (camposValor.length > 0) {
                                                            var camposValorResult = camposValor.filter(function (campoValor) {
                                                                // si el Id del CampoTipo es attach (archivo), voy a actualizar su valor
                                                                if (campoValor.Campo.CampoTipo.Id == 10 && campoValor.Campo.CampoTipo.Codigo == "ATTACH") {
                                                                    campoValor.Valor = FileName;
                                                                    campoValor.ValorObjeto = FileName;
                                                                    return campoValor;
                                                                }

                                                            })

                                                            dataService.saveCampoValor(camposValorResult).then(
                                                                function (response) {
                                                                    if (response.data.Success) {
                                                                        // toastr.info("Registro exitoso.");
                                                                    } else {
                                                                        toastr.error(response.data.ErrorSummary);
                                                                    }
                                                                }, function (error) {
                                                                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                });
                                                        }
                                                    } else {
                                                        toastr.error(response.data.ErrorSummary);
                                                    }
                                                }, function (error) {
                                                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                });
                                    }
                                })
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
            }

            ctrl.searchListadoDeProcesos = function (nombreProceso, tipoBusqueda) {
                if (tipoBusqueda && tipoBusqueda != "DOCUMENTAL") {
                    return ctrl.listadoDeProcesos.filter(function (proceso) {
                        if (nombreProceso == "_")
                            return proceso;
                        else if (proceso.Nombre.toUpperCase().includes(nombreProceso.toUpperCase()))
                            return proceso;
                    })
                } else {
                    return ctrl.listadoDeProcesos_doc.filter(function (proceso) {
                        if (nombreProceso == "_")
                            return proceso;
                        else if (proceso.Nombre.toUpperCase().includes(nombreProceso.toUpperCase()))
                            return proceso;
                    })
                }
            }

            function saveCamposSolicitudAndExecuteSP() {
                ctrl.isBusy = true;
                if (ctrl.camposList != null) {
                    for (var i = 0; i < ctrl.camposList.length; i++) {
                        ctrl.camposList[i].SolicitudId = ctrl.model.Id;
                        ctrl.camposList[i].Solicitud = ctrl.model;
                        ctrl.camposList[i].Solicitud.Proceso = ctrl.procesoPadre;
                        switch (ctrl.camposList[i].Campo.CampoTipo.Codigo) {
                            case 'TEXTENR':
                                var tmpValor = ctrl.camposList[i].ValorObjeto;
                                if (tmpValor != "" && tmpValor != null) {
                                    var colors = sharedService.getArrayColors(tmpValor);
                                    var lColor, lColorRGB;
                                    angular.forEach(colors, function (value, key) {
                                        lColorRGB = colors[key];
                                        if (!lColorRGB.startsWith('#')) {
                                            lColor = sharedService.RGB2Hex(colors[key]);
                                            ctrl.camposList[i].ValorObjeto = ctrl.camposList[i].ValorObjeto.replace(lColorRGB, lColor);
                                            if (ctrl.camposList[i].Valor != null && ctrl.camposList[i].Valor != "") {
                                                ctrl.camposList[i].Valor = ctrl.camposList[i].Valor.replace(lColorRGB, lColor);
                                            }
                                        }
                                    });
                                }
                                break;
                            case 'TABLE':
                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                break;
                            case 'TABLEENR':
                                // console.log("Ingreso a TABLE ENR");
                                // console.log(ctrl.camposList[i].TablaFilas);

                                if (ctrl.camposList[i].TablaFilas != null) {
                                    var filaValor = "";
                                    for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                                        if (j > 0)
                                            filaValor += "^";

                                        if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                                            // console.log("FIR NUL!!!!");
                                            // console.log(ctrl.camposList[i].TablaFilas[j].Valor);

                                            var colValor = "";
                                            for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                                                if (k > 0)
                                                    colValor += "~";

                                                if (Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    // console.log("ES UN ARRAY!!!!");
                                                    // console.log(JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]));
                                                    colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                } else if (Object.prototype.toString.call(ctrl.camposList[i].TablaFilas[j].Valor[k]) === '[object Date]') {
                                                    // console.log(" ES LA FECHYA!!!");
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                } else if (typeof ctrl.camposList[i].TablaFilas[j].Valor[k] === 'object' && ctrl.camposList[i].TablaFilas[j].Valor[k] !== null && !Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                                                    // console.log("ES UN OBJECT");
                                                    // console.log(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                    if (ctrl.camposList[i].TablaFilas[j].Valor[k].Id) {
                                                        // Si dentro del valor, encuentras una prop Id, es un campo tipo LIST y sólo hace falta el Id, ya que se muestra en un <select>
                                                        colValor += ctrl.camposList[i].TablaFilas[j].Valor[k].Id;
                                                        // Guardando sólo el Id como número siempre en el valor de TablaFilas
                                                        ctrl.camposList[i].TablaFilas[j].Valor[k] = Number(ctrl.camposList[i].TablaFilas[j].Valor[k].Id);
                                                    } else {
                                                        // Si no, es un campo tipo MULTI_LIST, por lo que se eliminan las propiedades usadas por el front para que se limpie el registro y se pasa a texto
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].TextoBusqueda;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].jerarquiaPadreId;
                                                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].SourceObjetoTemp;

                                                        colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                                                    }
                                                }
                                                else {
                                                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                                                }
                                            }
                                            filaValor += colValor;
                                        }
                                    }
                                }

                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                // console.log(ctrl.camposList);
                                break;
                            case 'COND':
                                var tmpValorObjeto = ctrl.camposList[i].ValorObjeto;
                                try {
                                    var filaValor = "";
                                    if (ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "ATTACH" ||
                                        ctrl.camposList[i].Campo.Columnas[0].ColumnaCampo.CampoTipo.Codigo == "IMG") {
                                        filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                        filaValor += "~";
                                        filaValor += tmpValorObjeto;
                                    } else {
                                        if (ctrl.camposList[i].TablaFilas != null) {
                                            try {
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                                                filaValor += "~";
                                                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
                                            } catch (exception) {
                                                filaValor += "";
                                            }
                                        }
                                    }
                                } catch (ex) {
                                }
                                ctrl.camposList[i].Valor = filaValor;
                                ctrl.camposList[i].ValorObjeto = filaValor;
                                filaValor = "";
                                break;
                        }
                    }
                }

                if (ctrl.camposTableEnr.length > 0) {
                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                        campoTableEnr.TablaFilas = ctrl.camposList[campoTableEnr.index].TablaFilas;
                        campoTableEnr.Campo = ctrl.camposList[campoTableEnr.index].Campo;
                        campoTableEnr.SolicitudId = ctrl.model.Id;
                        return campoTableEnr;
                    });
                }

                orderCamposList();

                /*
                 * Guadar la solicitud con sus campos y valores.
                 */
                dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                    .then(function (response) {
                        if (response.data.Success) {

                            ctrl.camposList = ctrl.camposList.map(function (campo) {
                                response.data.Value.map(function (campoResult) {
                                    if (campoResult.CampoId == campo.CampoId)
                                        campo.Id = campoResult.Id;
                                    // Actualizando el valor del Id generado por el backend a los campos cargados en memoria, esto se hizo con el fin de no generar codigo extra, porque el backend retorna datos en null como "Campo", "UsuarioModificacion" y "Solicitud" que son necesarios para realizar una segunda peticion POST, por ende, como estos datos estan en memoria, no se puede igualar la respuesta del backend, sino sólo actualizar los Id
                                })

                                if (campo.Campo.CampoId == "QRPAGE")
                                    ctrl.fileForQR.qrPage = campo.ValorObjeto;

                                if (campo.Campo.CampoId == "QRPOSX")
                                    ctrl.fileForQR.qrPosX = campo.ValorObjeto.toString().replace('.', ',');

                                if (campo.Campo.CampoId == "QRPOSY")
                                    ctrl.fileForQR.qrPosY = campo.ValorObjeto.toString().replace('.', ',');

                                if (campo.Campo.CampoId == "QRMEDIDA")
                                    ctrl.fileForQR.qrSize = campo.ValorObjeto.toString().replace('.', ',');

                                // Para aprovechar este ciclo, por performance, capturo los datos que necesitaré enviar al backend para la posición del segundo QR en el documento PDF final, en caso de que venga un valor decimal, reemplazo el punto por una coma, porque el servidor está configurado en Latinoamérica, por ende se utiliza la coma en lugar del punto
                                return campo;
                            })

                            orderCamposList();

                            if (ctrl.generaProcesoRelacionados) {

                                var modalText;
                                if (ctrl.language == "español")
                                    modalText = "Se está ejecutando un proceso, por favor espere";
                                else if (ctrl.language == "ingles")
                                    modalText = "A process is running, please wait";
                                else if (ctrl.language == "portugues")
                                    modalText = "Um processo está sendo executado, aguarde";
                                else if (ctrl.language == "italiano")
                                    modalText = "Se está ejecutando un proceso, por favor espere";

                                Swal.fire({
                                    title: '',
                                    text: modalText,
                                    allowEscapeKey: false,
                                    allowOutsideClick: false,
                                    onOpen: function () {
                                        swal.showLoading();
                                    }
                                })

                                if (ctrl.camposTableEnr.length > 0) {
                                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                                        campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                                        delete campoTableEnr.index
                                        return campoTableEnr;
                                    });
                                    
                                    dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                dataService.SaveSolicitudCampoValorGeneraProcesos(ctrl.camposListOrdered)
                                                .then(function (response) {
                                                    if (response.data.Success) {
                                                        var solicitudId = ctrl.model.Id;

                                                        if (ctrl.fileForQRTouched) {
                                                            ctrl.camposList.map(function (campo) {
                                                                if (campo.CampoId == ctrl.fileForQR.campoId) {
                                                                    dataService.updateFileSolicitudCampoValor(
                                                                        ctrl.fileForQR.file,
                                                                        ctrl.fileForQR.campoId,
                                                                        solicitudId,
                                                                        ctrl.fileForQR.ip,
                                                                        ctrl.fileForQR.dispositivo,
                                                                        ctrl.fileForQR.qrPage,
                                                                        ctrl.fileForQR.qrPosX,
                                                                        ctrl.fileForQR.qrPosY,
                                                                        ctrl.fileForQR.qrSize
                                                                    )
                                                                        .then(function (response) {
                                                                            if (response.data.Success) {
                                                                                var fileName = response.data.Value;

                                                                                dataService.getSolicitudCampoValorCompleto(solicitudId)
                                                                                    .then(function (response) {
                                                                                        if (response.data.Success) {
                                                                                            ctrl.camposList = response.data.Value.map(function (campoActualizado) {
                                                                                                // Dandole al campo el valor del nombre del archivo generado por el backend
                                                                                                if (campoActualizado.CampoId == ctrl.fileForQR.campoId) {
                                                                                                    campoActualizado.Valor = fileName;
                                                                                                    campoActualizado.ValorObjeto = fileName;
                                                                                                }

                                                                                                // Dandole a los campos actualizados la entidad Solicitud, que es necesaria para el guardado de SolicitudCampoValor. Esta propiedad es identica en todos los campos de una solicitud, por eso se usa la misma para todos
                                                                                                campoActualizado.Solicitud = campo.Solicitud;

                                                                                                return campoActualizado;
                                                                                            })

                                                                                            updateCampoValorFile(solicitudId, fileName);

                                                                                            orderCamposList();

                                                                                            dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                                                                                                .then(function (response) {
                                                                                                    if (response.data.Success) {
                                                                                                        swal.close();

                                                                                                        executeSPAndReaload();

                                                                                                    } else {
                                                                                                        swal.close();
                                                                                                        toastr.error(response.data.ErrorSummary);
                                                                                                    }
                                                                                                })
                                                                                        } else {
                                                                                            ctrl.active = 1;
                                                                                            toastr.error(response.data.ErrorSummary);
                                                                                            ctrl.fileForQRTouched = true;
                                                                                            swal.close();
                                                                                            ctrl.isBusy = false;
                                                                                        }
                                                                                    }, function (error) {
                                                                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                                        ctrl.isBusy = false;
                                                                                        campo.isLoading = false;
                                                                                        swal.close();
                                                                                    });
                                                                            } else {
                                                                                ctrl.active = 1;
                                                                                toastr.error(response.data.ErrorSummary);
                                                                                ctrl.fileForQRTouched = true;
                                                                                swal.close();
                                                                                ctrl.isBusy = false;
                                                                            }
                                                                            campo.isLoading = false;
                                                                        }, function (error) {
                                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                            ctrl.isBusy = false;
                                                                            campo.isLoading = false;
                                                                            swal.close();
                                                                        });
                                                                }
                                                            })
                                                        } else {
                                                            swal.close();

                                                            executeSPAndReaload();
                                                        }
                                                    } else {
                                                        toastr.error(response.data.ErrorSummary);
                                                        ctrl.isBusy = false;
                                                        swal.close();
                                                    }
                                                });
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                swal.close();
                                                ctrl.isBusy = false;
                                                ctrl.isBusyBlocked = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isBusy = false;
                                            ctrl.isBusyBlocked = false;
                                            swal.close();
                                        });
                                } else {
                                    dataService.SaveSolicitudCampoValorGeneraProcesos(ctrl.camposListOrdered)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            var solicitudId = ctrl.model.Id;

                                            if (ctrl.fileForQRTouched) {
                                                ctrl.camposList.map(function (campo) {
                                                    if (campo.CampoId == ctrl.fileForQR.campoId) {
                                                        dataService.updateFileSolicitudCampoValor(
                                                            ctrl.fileForQR.file,
                                                            ctrl.fileForQR.campoId,
                                                            solicitudId,
                                                            ctrl.fileForQR.ip,
                                                            ctrl.fileForQR.dispositivo,
                                                            ctrl.fileForQR.qrPage,
                                                            ctrl.fileForQR.qrPosX,
                                                            ctrl.fileForQR.qrPosY,
                                                            ctrl.fileForQR.qrSize
                                                        )
                                                            .then(function (response) {
                                                                if (response.data.Success) {
                                                                    var fileName = response.data.Value;

                                                                    dataService.getSolicitudCampoValorCompleto(solicitudId)
                                                                        .then(function (response) {
                                                                            if (response.data.Success) {
                                                                                ctrl.camposList = response.data.Value.map(function (campoActualizado) {
                                                                                    // Dandole al campo el valor del nombre del archivo generado por el backend
                                                                                    if (campoActualizado.CampoId == ctrl.fileForQR.campoId) {
                                                                                        campoActualizado.Valor = fileName;
                                                                                        campoActualizado.ValorObjeto = fileName;
                                                                                    }

                                                                                    // Dandole a los campos actualizados la entidad Solicitud, que es necesaria para el guardado de SolicitudCampoValor. Esta propiedad es identica en todos los campos de una solicitud, por eso se usa la misma para todos
                                                                                    campoActualizado.Solicitud = campo.Solicitud;

                                                                                    return campoActualizado;
                                                                                })

                                                                                updateCampoValorFile(solicitudId, fileName);

                                                                                orderCamposList();

                                                                                dataService.saveSolicitudCampoValor(ctrl.camposListOrdered)
                                                                                    .then(function (response) {
                                                                                        if (response.data.Success) {
                                                                                            swal.close();

                                                                                            executeSPAndReaload();

                                                                                        } else {
                                                                                            swal.close();
                                                                                            toastr.error(response.data.ErrorSummary);
                                                                                        }
                                                                                    })
                                                                            } else {
                                                                                ctrl.active = 1;
                                                                                toastr.error(response.data.ErrorSummary);
                                                                                ctrl.fileForQRTouched = true;
                                                                                swal.close();
                                                                                ctrl.isBusy = false;
                                                                            }
                                                                        }, function (error) {
                                                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                            ctrl.isBusy = false;
                                                                            campo.isLoading = false;
                                                                            swal.close();
                                                                        });
                                                                } else {
                                                                    ctrl.active = 1;
                                                                    toastr.error(response.data.ErrorSummary);
                                                                    ctrl.fileForQRTouched = true;
                                                                    swal.close();
                                                                    ctrl.isBusy = false;
                                                                }
                                                                campo.isLoading = false;
                                                            }, function (error) {
                                                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                                ctrl.isBusy = false;
                                                                campo.isLoading = false;
                                                                swal.close();
                                                            });
                                                    }
                                                })
                                            } else {
                                                swal.close();

                                                executeSPAndReaload();
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            ctrl.isBusy = false;
                                            swal.close();
                                        }
                                    });
                                }

                            } else {
                                swal.close();

                                if (ctrl.camposTableEnr.length > 0) {
                                    // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                                    ctrl.camposTableEnr = ctrl.camposTableEnr.map(function(campoTableEnr) {
                                        campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                                        delete campoTableEnr.index
                                        return campoTableEnr;
                                    });
                                    
                                    dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                executeSPAndReaload();
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                swal.close();
                                                ctrl.isBusy = false;
                                                ctrl.isBusyBlocked = false;
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isBusy = false;
                                            ctrl.isBusyBlocked = false;
                                            swal.close();
                                        });
                                }
                            }
                        } else {
                            toastr.error(response.data.ErrorSummary);
                            swal.close();
                            ctrl.isBusy = false;
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                        swal.close();
                    });
            }

            function executeSPAndReaload() {
                // Esta función es autodescriptiva y fue creada por legibilidad del código

                dataService.executeProcedureRefresh(ctrl.procesoPadre.procedimientoRefresh, ctrl.model.Id, 0)
                    .then(function (response) {
                        if (response.data.Success) {

                            toastr.info(ctrl.successfulRegistration);
                            swal.close();
                            ctrl.isBusy = false;
                            ctrl.isBusyBlocked = false;

                            if (ctrl.isNew) {
                                $state.go("pages.solicitud-edit", {
                                    id: ctrl.model.Id,
                                    grupo: $stateParams.grupo,
                                    proceso: $stateParams.proceso,
                                    solicitudPadreId: 0
                                });
                            } else {
                                $state.reload();
                            }

                            sharedService.setActiveTabSolicitud(true);
                            // Si se recargar la vista luego de usar el botón que ejecuta el sp, por definición siempre debe quedar en la vista "Datos del Proceso", por lo que se almacena temporalmente en el LocalStorage

                        } else {
                            toastr.error(response.data.ErrorSummary);
                            swal.close();
                            ctrl.isBusy = false;
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        ctrl.isBusy = false;
                        swal.close();
                    });
            }

            ctrl.saveCamposAndExecSP = function () {
                // Este metodo se encarga de ejecutar el save de todos los SolicitudCampoValor y por ende, ejecuta el SP del proceso

                if (ctrl.model.Id == 0) {
                    // Creando la solicitud, guardando los SolicitudCampoValor y ejecutando el SP
                    ctrl.isBusy = true;

                    if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                        ctrl.preSaveCamposSolicitud();
                    }

                    dataService.checkSolicitudCampoValor(ctrl.camposList)
                        .then(function (response) {
                            if (response.data.Success) {
                                if (response.data.Value == true) {
                                    dataService.saveSolicitud(ctrl.model)
                                        .then(function (response) {
                                            if (response.data.Success) {
                                                // Guardando la propiedad Proceso de la Solicitud para ser usada al guardar los SolicitudCampoValor
                                                ctrl.procesoPadre = ctrl.model.Proceso;
                                                ctrl.model = response.data.Value;
                                                if (ctrl.camposList != null && ctrl.camposList.length > 0) {
                                                    saveCamposSolicitudAndExecuteSP();
                                                } else {
                                                    ctrl.isBusy = false;
                                                    $state.go("pages.solicitud-edit", {
                                                        id: ctrl.model.Id,
                                                        grupo: $stateParams.grupo,
                                                        proceso: $stateParams.proceso,
                                                        solicitudPadreId: 0
                                                    });
                                                }
                                            } else {
                                                toastr.error(response.data.ErrorSummary);
                                                ctrl.isBusy = false;
                                                swal.close();
                                            }
                                        }, function (error) {
                                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                            ctrl.isBusy = false;
                                            swal.close();
                                        });
                                } else {
                                    ctrl.active = 1;
                                    ctrl.isBusy = false;
                                    swal.close();
                                }
                            } else {
                                ctrl.active = 1;
                                toastr.error(response.data.ErrorSummary);
                                ctrl.isBusy = false;
                                swal.close();
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                            swal.close();
                        });
                    ctrl.active = 1;
                } else {
                    // Sólo guadando los SolicitudCampoValor y ejecutando el SP
                    saveCamposSolicitudAndExecuteSP();
                }
            }

            function initAutoSaveCounter() {
                if (ctrl.model.Proceso.temporizadorGuardar == 0) return;
                
                var titleConfirm;
                if (ctrl.language == "español")
                    titleConfirm = "Desea autoguardar?";
                else if (ctrl.language == "ingles")
                    titleConfirm = "Autosafe?";
                else if (ctrl.language == "portugues")
                    titleConfirm = "Salvar automaticamente?";
                else if (ctrl.language == "italiano")
                    titleConfirm = "Desea autoguardar?";

                ctrl.autoSaveInterval = $interval(function () {
                    if (ctrl.active == 1 && $('.swal2-container').length == 0) {
                        // Solamente se mostrara la modal de autoguardado cuando se este en datos del proceo (active == 1) y si no hay otra instancia de swal abierta
                        var confirmation = Swal.fire({
                            title: titleConfirm,
                            showCancelButton: true,
                            confirmButtonColor: "#f99d3b",
                            cancelButtonText: ctrl.cancelText,
                            confirmButtonText: ctrl.acceptText,
                        });
    
                        confirmation.then(function(result) {
                            if (result.value) {
                                if (ctrl.isNew) {
                                    // guardar la solicitud y los campos y recargar
                                    dataService.saveSolicitud(ctrl.model)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            ctrl.model = response.data.Value;
                                            ctrl.preSaveCamposSolicitud();
                                            dataService.saveSolicitudCampoValorNoValidaOblig(ctrl.camposList)
                                            .then(function (responseCampos) {
                                                if (responseCampos.data.Success) {
                                                    sharedService.setActiveTabSolicitud(true);
                                                    // Si se recargar la vista luego del autoguardado siempre debe quedar en la vista "Datos del Proceso"
                                                    $state.go("pages.solicitud-edit", {
                                                        id: ctrl.model.Id,
                                                        grupo: $stateParams.grupo,
                                                        proceso: $stateParams.proceso,
                                                        solicitudPadreId: 0
                                                    });
                                                } else {
                                                    toastr.error(responseCampos.data.ErrorSummary);
                                                }
                                                ctrl.isBusy = false;
                                            }, function (error) {
                                                toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                                ctrl.isBusy = false;
                                            });
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            ctrl.isBusy = false;
                                        }
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        ctrl.isBusy = false;
                                    });
                                } else {
                                    // solo guardar los campos y volverlos a renderizar
                                    ctrl.preSaveCamposSolicitud();
                                    dataService.saveSolicitudCampoValorNoValidaOblig(ctrl.camposList)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            toastr.info(ctrl.successfulRegistration);
                                            ctrl.camposList = response.data.Value;
        
                                            for (var i = 0; i < ctrl.camposList.length; i++) {
                                                loadProcesoCampoData(ctrl.camposList, i, ctrl.camposList[i].Campo.CampoTipo);
                                            }
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                        }
                                        ctrl.isBusy = false;
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        ctrl.isBusy = false;
                                    });
                                }
                            }
                        });
                    }
                }, ctrl.model.Proceso.temporizadorGuardar * 1000); // el tiempo llega en segundos por lo que hay que pasarlo a ms
            }

            $scope.$on('$destroy', function() {
                if (angular.isDefined(ctrl.autoSaveInterval)) {
                    $interval.cancel(ctrl.autoSaveInterval);
                    ctrl.autoSaveInterval = null;
                }
            });
        }
    });
})(window.angular);
(function (angular) {
    'use strict';
    angular.module('Kahuna.pages.solicitud').component('solicitudList', {
        templateUrl: 'app/pages/solicitud/list.template.html',
        controller: function ($scope, $state, $uibModal, dataService, sharedService, toastr, appConfig) {
            var ctrl = this;
            ctrl.language = sharedService.getLanguage();
            ctrl.anularVista = true;
            ctrl.filtrosProceso = {};
            ctrl.filtrosSolicitud = {};
            ctrl.procesosList = [];
            ctrl.solicitudesList = [];
            ctrl.procesoSeleccionado = {};
            ctrl.solicitudSeleccionada = {};
            ctrl.camposList = [];
            ctrl.solicitudTableState = {};
            ctrl.isSysAdmin = false;
            ctrl.primeraVez = true;
            ctrl.filtrosKey = "";
            ctrl.puedeCrearSolicitud = true;
            ctrl.showCheckProcesosCerrados = true;
            ctrl.showCheckMisSolicitudes = false;
            ctrl.verTodos = false;
            ctrl.itemsByPage = 10;
            ctrl.currentPage = 1;
            ctrl.lProcesoIsDocumentalAutorizacionesV2 = false;
            ctrl.documentalGetCerrados = true;
            ctrl.values = [];
            var authData = {};

            this.$onInit = function () {
                var solicitudListTitle;

                if (ctrl.language == "español") {
                    solicitudListTitle = 'Selección de Proceso';
                    ctrl.acceptText = "Aceptar";
                    ctrl.cancelText = "Cancelar";
                    ctrl.successfulRegistration = "Registro exitoso.";

                } else if (ctrl.language == "ingles") {
                    solicitudListTitle = 'Process Load Management';
                    ctrl.acceptText = "Accept";
                    ctrl.cancelText = "Cancel";
                    ctrl.successfulRegistration = "Registration successful.";

                } else if (ctrl.language == "portugues") {
                    solicitudListTitle = 'Gerenciamento de carga de processo';
                    ctrl.acceptText = "Aceitar";
                    ctrl.cancelText = "Cancelar";
                    ctrl.successfulRegistration = "Registro bem-sucedido.";

                } else if (ctrl.language == "italiano") {
                    solicitudListTitle = 'Selección de Proceso';
                    ctrl.acceptText = "Aceptar";
                    ctrl.cancelText = "Cancelar";
                    ctrl.successfulRegistration = "Registro exitoso.";
                }

                $state.current.title = solicitudListTitle;

                loadView();
                authData = sharedService.getLoggedUser();
                ctrl.filtrosKey = "BUSQUEDA_SOLICITUDES_" + authData.Id;
            };

            function puedeCrearSolicitud(usuarios, authData) {/*este se agrego*/
                var response = true;
                var userLoadedInProcess = false;

                angular.forEach(usuarios, function (usuario, key) {
                    if (usuario.UsuarioId == authData.Id)
                        userLoadedInProcess = true;

                    if (usuario.UsuarioId == authData.Id && usuario.RolProcesoId == 7)
                        response = false;
                });

                if (ctrl.procesoSeleccionado.isDocumental) {
                    // Si el proceso es documental. Se valida si el usuario logueado está agregado a los usuarios del proceso y tiene RolProcesoId != 7, devolverá true
                    return response && userLoadedInProcess;
                } else {
                    // Si no es proceso documental, se mantiene la validación que tenía anteriormente
                    return response;
                }
            }

            function loadView() {
                // console.log("LOAD VIEW LIST COMPONENET");
                ctrl.itemsByPage = 10;
                if ($state != null && $state.params != null &&
                    $state.params.grupoId != null && $state.params.grupoId > 0 &&
                    $state.params.procesoId != null && $state.params.procesoId > 0) {
                    ctrl.anularVista = false;
                    ctrl.isSysAdmin = sharedService.isSysAdminLoggedUser();
                    var authData = sharedService.getLoggedUser();
                    dataService.getProcesoSolicitudGrid($state.params.procesoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                ctrl.procesoSeleccionado = response.data.Value;
                                // console.log(ctrl.procesoSeleccionado);
                                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id <= 0) {
                                    ctrl.anularVista = true;
                                    return;
                                }
                                if (ctrl.procesoSeleccionado.verProcesosCerrados) {
                                    ctrl.showCheckProcesosCerrados = false;
                                    ctrl.verTodos = true;
                                }
                                if (!ctrl.procesoSeleccionado.isDocumental) {
                                    // Si el proceso es documental NO mostrará el check Mis Solicitudes, si es no documental, sí se mostrará
                                    ctrl.showCheckMisSolicitudes = true;
                                }
                                ctrl.puedeCrearSolicitud = puedeCrearSolicitud(ctrl.procesoSeleccionado.Usuarios, authData);
                                ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.procesoSeleccionado.autorizacionesDocumental;


                                // console.log("LLEGO LA informacion al cargar la data del proceso  seleccionado...");
                                llenarArrayFiltro();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        });
                }
            }

            ctrl.buscarSolicitud = function buscarSolicitud(tableState, EstadoSolicitudes) {
                // console.log("********buscarSolicitu!!!*************");
                //llenarArrayFiltro();
                // console.log(ctrl.filtrosSolicitud);
                tableState == null || tableState == undefined ? ctrl.solicitudTableState : tableState;
                // console.log(tableState);
                ctrl.solicitudTableState = tableState;
                if ($state != null && $state.params != null &&
                    $state.params.grupoId != null && $state.params.grupoId > 0 &&
                    $state.params.procesoId != null && $state.params.procesoId > 0) {
                    if (ctrl.primeraVez) {
                        ctrl.primeraVez = false;
                        ctrl.solicitudTableState = setTableFilters(tableState);
                    }
                    ctrl.isSolicitudSearching = true;
                    // console.log("TABLE STATE PAGINATION..   * ** * ") ;
                    // console.log(tableState.pagination);
                    var pagination = tableState.pagination;
                    var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
                    var number = pagination.number || 10; // Number of entries showed per page.                   

                    // console.log(tableState);
                    ctrl.itemsByPage = number;
                    // console.log(ctrl.filtrosSolicitud);                                                           
                    // console.log("ctrl.filtrosSolicitud");

                    ctrl.filtrosSolicitud.ProcesoId = $state.params.procesoId;
                    ctrl.filtrosSolicitud.PageSize = number;
                    ctrl.filtrosSolicitud.SkipNumber = start;
                    ctrl.filtrosSolicitud.VerTodos = ctrl.verTodos;
                    ctrl.filtrosSolicitud.documentalGetCerrados = ctrl.documentalGetCerrados;
                    // ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = ctrl.lProcesoIsDocumentalAutorizacionesV2;
                    ctrl.filtrosSolicitud.currentPage = ctrl.currentPage;
                    ctrl.filtrosSolicitud.VerProcesosPendientesOtrosUsuarios = ctrl.verProcesosPendientesOtrosUsuarios;
                    // Aqui se define ctrl.VerMisSolicitudes, si es undefined, significa que el usuario no había entrado al listado no tiene ningún filtro guardado en LocalStorage
                    ctrl.filtrosSolicitud.misSolicitudes = ctrl.VerMisSolicitudes;


                    // dataService.getProcesoById($state.params.procesoId)
                    dataService.getProcesoInSolicitud($state.params.procesoId)
                        .then(function (response) {
                            if (response.data.Success) {
                                var proceso = response.data.Value;

                                if ($('#checkVerTodos').hasClass('ng-pristine') && proceso.verProcesosCerrados) {
                                    ctrl.verTodos = proceso.verProcesosCerrados;
                                    ctrl.filtrosSolicitud.VerTodos = ctrl.verTodos;
                                }

                                if (proceso.VerMisSolicitudes && ctrl.filtrosSolicitud.misSolicitudes == null) {
                                    // Si en los filtros se guardó algún valor de misSolicitudes, ctrl.VerMisSolicitudes tendrá un valor para cuando se llame buscarSolicitud, sino, se le asignará el valor por defecto del proceso
                                    // Ver Linea 393
                                    ctrl.VerMisSolicitudes = proceso.VerMisSolicitudes;
                                    ctrl.filtrosSolicitud.misSolicitudes = ctrl.VerMisSolicitudes;
                                }

                                ctrl.lProcesoIsDocumentalAutorizacionesV2 = proceso.autorizacionesDocumental;
                                ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = ctrl.lProcesoIsDocumentalAutorizacionesV2;

                                // Forzando estas propiedades cuando se presione el botón que llama al método "verDocPendientes"
                                if (EstadoSolicitudes == 'Cerrados') {

                                    ctrl.filtrosSolicitud.VerTodos = true;
                                    ctrl.filtrosSolicitud.documentalGetCerrados = true;
                                    ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = true;

                                } else if (EstadoSolicitudes == 'Pendientes') {

                                    ctrl.filtrosSolicitud.VerTodos = true;
                                    ctrl.filtrosSolicitud.documentalGetCerrados = false;
                                    ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = true;
                                }

                                ctrl.filtrosSolicitud.OrderAscending = !proceso.orderDescending;

                                if (tableState.sort != null) {
                                    ctrl.filtrosSolicitud.OrderFieldName = sharedService.replaceAll(tableState.sort.predicate, "C_", "");

                                    if (tableState.sort.predicate)
                                        ctrl.filtrosSolicitud.OrderAscending = !tableState.sort.reverse;
                                    // Siempre se va a mostrar de forma ascendente el listado
                                    // ctrl.filtrosSolicitud.OrderAscending = true; <---- Removiendo que siempre el orden sea ascendente
                                }


                                // dataService.searchSolicitud(ctrl.filtrosSolicitud)
                                dataService.searchSolicitudSimple(ctrl.filtrosSolicitud)
                                    .then(function (response) {
                                        if (response.data.Success) {
                                            // ctrl.solicitudesList = response.data.Value.Resultados;

                                            // Armando el "ValorMostrarBusqueda" de cada solicitud para mostrar los valores en el listado. Anteriormente esta propiedad venia del backend, pero se cambió por el tiempo de respuesta de esta petición, ahora lo arma el front
                                            ctrl.solicitudesList = response.data.Value.Resultados.map(function (solicitud) {
                                                solicitud.ValorMostrarBusqueda = [];
                                                var contador = 1;

                                                proceso.CamposListado.map(function (campo, index) {
                                                    if (campo.CampoId != null) {
                                                        if (contador == 1) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro1);
                                                            contador++;
                                                        } else if (contador == 2) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro2);
                                                            contador++;
                                                        } else if (contador == 3) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro3);
                                                            contador++;
                                                        } else if (contador == 4) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro4);
                                                            contador++;
                                                        } else if (contador == 5) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro5);
                                                            contador++;
                                                        } else if (contador == 6) {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValorFiltro6);
                                                        }
                                                    } else {
                                                        var codigo = proceso.CamposListado[index].SolicitudColumna.Codigo;

                                                        if (codigo == "Id") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.Id);
                                                        } else if (codigo == "Activo") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.Activo);
                                                        } else if (codigo == "Descripcion") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.Descripcion);
                                                        } else if (codigo == "DescripcionResumida") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.DescripcionResumida);
                                                        } else if (codigo == "Estado") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.SolicitudEtapaNombre);
                                                        } else if (codigo == "LastUpdate") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.LastUpdate);
                                                        } else if (codigo == "FechaCierre") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.FechaCierre);
                                                        } else if (codigo == "CreationDate") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.CreationDate);
                                                        } else if (codigo == "Proceso") {
                                                            solicitud.ValorMostrarBusqueda.push(proceso.Nombre);
                                                        } else if (codigo == "NumeroCompleto") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.NumeroCompleto);
                                                        } else if (codigo == "UsuarioAprobador") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValoresSolicitudColumna.UsuarioAprobacionNombre);
                                                        } else if (codigo == "UsuarioCreacion") {
                                                            solicitud.ValorMostrarBusqueda.push(solicitud.ValoresSolicitudColumna.UsuarioCreacionNombre);
                                                        }
                                                    }
                                                })

                                                return solicitud;
                                            });

                                            // console.log(ctrl.solicitudesList);
                                            //ctrl.totalResultados = response.data.Value.TotalResultados;
                                            tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                        }
                                        ctrl.isSolicitudSearching = false;
                                        ctrl.solicitudTableState = tableState;
                                        // console.log(tableState);
                                    }, function (error) {
                                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                        ctrl.isSolicitudSearching = false;
                                    });
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isSolicitudSearching = false;
                        })

                    saveTableFilters();
                }
            };

            function llenarArrayFiltro() {
                angular.forEach(ctrl.procesoSeleccionado.CamposListado, function (campoProceso, keyListado) {
                    if (campoProceso.Campo != null) {
                        ctrl.values[keyListado] = "";
                        angular.forEach(ctrl.filtrosSolicitud.CamposList, function (campoCache, key) {
                            if (campoCache.CampoId == campoProceso.CampoId) {
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.CamposList[key].Valor;
                            }
                        });
                    }
                    if (campoProceso.SolicitudColumna != null) {
                        var codigo = campoProceso.SolicitudColumna.Codigo;
                        switch (codigo) {
                            case "Id":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.Id;
                                break;
                            case "NumeroCompleto":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.NumeroCompleto;
                                break;
                            case "Descripcion":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.Descripcion;
                                break;
                            case "DescripcionResumida":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.DescripcionResumida;
                                break;
                            case "FechaCierre":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.FechaCierre;
                                break;
                            case "Estado":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.Estado;
                                break;
                            case "UsuarioAprobador":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.UsuarioAprobador;
                                break;
                            case "Proceso":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.ProcesoNombre;
                                break;
                            case "Activo":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.Activo;
                                break;
                            case "UsuarioCreacion":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.UsuarioCreacion;
                                break;
                            case "CreationDate":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.CreationDate;
                                break;
                            case "LastUpdate":
                                ctrl.values[keyListado] = ctrl.filtrosSolicitud.LastUpdate;
                                break;
                        }
                    }
                });
            }

            function setTableFilters(tableState) {
                // console.log("leyendo desde  cache.setTableFilters..!");
                var authData = sharedService.getLoggedUser();
                ctrl.filtrosKey = "BUSQUEDA_SOLICITUDES_" + authData.Id;
                var filtros = sharedService.getLocalData(ctrl.filtrosKey);

                if (filtros != null && filtros.length > 0) {
                    for (var i = 0; i < filtros.length; i++) {
                        if (filtros[i].ProcesoId == $state.params.procesoId)
                            ctrl.filtrosSolicitud = filtros[i].Filtros;
                    }
                }

                if (ctrl.filtrosSolicitud == null)
                    ctrl.filtrosSolicitud = {};

                if (ctrl.filtrosSolicitud.SkipNumber == null)
                    ctrl.filtrosSolicitud.SkipNumber = 0;

                if (ctrl.filtrosSolicitud.documentalGetCerrados == null) {
                    ctrl.filtrosSolicitud.documentalGetCerrados = ctrl.documentalGetCerrados != null ? ctrl.documentalGetCerrados : true;
                } else {
                    ctrl.documentalGetCerrados = ctrl.filtrosSolicitud.documentalGetCerrados;
                }

                if (ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 == null) {
                    ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2 = ctrl.lProcesoIsDocumentalAutorizacionesV2;
                } else {
                    ctrl.lProcesoIsDocumentalAutorizacionesV2 = ctrl.filtrosSolicitud.lProcesoIsDocumentalAutorizacionesV2;
                }

                if (ctrl.filtrosSolicitud.currentPage == null) {
                    ctrl.filtrosSolicitud.currentPage = ctrl.currentPage;
                } else {
                    ctrl.currentPage = ctrl.filtrosSolicitud.currentPage;
                }

                if (ctrl.filtrosSolicitud.PageSize == null) {
                    ctrl.filtrosSolicitud.PageSize = 10;
                }

                if (ctrl.filtrosSolicitud.misSolicitudes != null) {
                    ctrl.VerMisSolicitudes = ctrl.filtrosSolicitud.misSolicitudes;
                }

                if (tableState.pagination == null)
                    tableState.pagination = {};

                tableState.pagination.start = ctrl.filtrosSolicitud.SkipNumber;
                tableState.pagination.number = ctrl.filtrosSolicitud.PageSize;
                ctrl.itemsByPage = ctrl.filtrosSolicitud.PageSize;

                ctrl.verTodos = ctrl.filtrosSolicitud.VerTodos;
                ctrl.verProcesosPendientesOtrosUsuarios = ctrl.filtrosSolicitud.VerProcesosPendientesOtrosUsuarios;

                if (tableState.search == null)
                    tableState.search = {};

                tableState.search.predicateObject = {};

                tableState.search.predicateObject.Id = ctrl.filtrosSolicitud.Id;
                tableState.search.predicateObject.NumeroCompleto = ctrl.filtrosSolicitud.NumeroCompleto;
                tableState.search.predicateObject.Descripcion = ctrl.filtrosSolicitud.Descripcion;
                tableState.search.predicateObject.DescripcionResumida = ctrl.filtrosSolicitud.DescripcionResumida;
                tableState.search.predicateObject.FechaCierre = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.FechaCierre);
                tableState.search.predicateObject.Estado = ctrl.filtrosSolicitud.Estado;
                tableState.search.predicateObject.UsuarioAprobador = ctrl.filtrosSolicitud.UsuarioAprobador;
                tableState.search.predicateObject.Proceso = ctrl.filtrosSolicitud.ProcesoNombre;
                tableState.search.predicateObject.Activo = ctrl.filtrosSolicitud.Activo;
                tableState.search.predicateObject.UsuarioCreacion = ctrl.filtrosSolicitud.UsuarioCreacion;
                tableState.search.predicateObject.CreationDate = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.CreationDate);
                tableState.search.predicateObject.LastUpdate = sharedService.formatDateForGetUrl(ctrl.filtrosSolicitud.LastUpdate);

                if (ctrl.filtrosSolicitud.CamposList != null && ctrl.filtrosSolicitud.CamposList.length > 0) {
                    for (var i = 0; i < ctrl.filtrosSolicitud.CamposList.length; i++) {
                        var property = "C_" + ctrl.filtrosSolicitud.CamposList[i].CampoId;
                        tableState.search.predicateObject[property] = ctrl.filtrosSolicitud.CamposList[i].Valor;
                    }
                }

                tableState.sort = {};
                tableState.sort.predicate = ctrl.filtrosSolicitud.OrderFieldName;
                tableState.sort.reverse = !ctrl.filtrosSolicitud.OrderAscending;

                //llenarArrayFiltro();
                return tableState;
            }

            function saveTableFilters() {
                // console.log("****saveTableFilters!");
                var index = -1;
                var filtros = sharedService.getLocalData(ctrl.filtrosKey);

                if (filtros != null && filtros.length > 0) {
                    for (var i = 0; i < filtros.length; i++) {
                        if (filtros[i].ProcesoId == $state.params.procesoId) {
                            index = i;
                            break;
                        }
                    }
                } else
                    filtros = [];

                if (index > -1)
                    filtros[i] = {
                        ProcesoId: $state.params.procesoId,
                        Filtros: ctrl.filtrosSolicitud
                    };
                else
                    filtros.push({
                        ProcesoId: $state.params.procesoId,
                        Filtros: ctrl.filtrosSolicitud
                    });

                // console.log(ctrl.filtrosKey);
                // console.log(filtros);
                sharedService.setLocalData(ctrl.filtrosKey, filtros);
            }

            ctrl.add = function () {
                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = 'Seleccione un proceso para poder continuar con la operación';
                    else if (ctrl.language == "ingles")
                        errorText = 'Select a process to continue';
                    else if (ctrl.language == "portugues")
                        errorText = 'Selecione um processo para continuar com a operação';
                    else if (ctrl.language == "italiano")
                        errorText = 'Seleccione un proceso para poder continuar con la operación';

                    toastr.error(errorText);
                    return;
                }

                if (ctrl.procesoSeleccionado.esMaestro) {
                    // Feature agregado el 02/05/2025
                    var confirmation = $uibModal.open({
                        animation: true,
                        component: "validaProcesoMaestro",
                        resolve: {
                            procesoId: function () {
                                return ctrl.procesoSeleccionado.Id
                            },
                        }
                    });

                    confirmation.result.then(function (returnValue) {
                        ctrl.isBusy = false;
                        $state.go("pages.solicitud-edit", {
                            id: returnValue.Id,
                            grupo: returnValue.Proceso.GrupoId,
                            proceso: returnValue.ProcesoId,
                            solicitudPadreId: returnValue.SolicitudPadreId
                        });
                    }, function () {
                        ctrl.isBusy = false;
                    });
                } else {
                    $state.go("pages.solicitud-edit", {
                        id: 0,
                        grupo: $state.params.grupoId,
                        proceso: ctrl.procesoSeleccionado.Id,
                        solicitudPadreId: 0
                    });
                }
            }

            ctrl.edit = function (id) {
                ctrl.model = {};
                ctrl.model.Id = id;
                ctrl.model.ProcesoId = ctrl.procesoSeleccionado.Id;
                // console.log(ctrl.model);

                var withoutPermissionsProcess, nextOperation, withoutPermissionsRequest;

                if (ctrl.language == "español") {
                    withoutPermissionsProcess = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                    nextOperation = 'Seleccione un proceso para poder continuar con la operación';
                    withoutPermissionsRequest = 'No tiene permisos para visualizar o realizar acciones sobre esta solicitud.';

                } else if (ctrl.language == "ingles") {
                    withoutPermissionsProcess = 'You do not have permissions to view or perform actions on this process.';
                    nextOperation = 'Select a process to continue';
                    withoutPermissionsRequest = 'You do not have permissions to view or perform actions on this request.';

                } else if (ctrl.language == "portugues") {
                    withoutPermissionsProcess = 'Você não tem permissão para visualizar ou realizar ações nesse processo.';
                    nextOperation = 'Selecione um processo para continuar com a operação';
                    withoutPermissionsRequest = 'Você não tem permissão para visualizar ou agir sobre este aplicativo.';

                } else if (ctrl.language == "italiano") {
                    withoutPermissionsProcess = 'No tiene permisos para visualizar o realizar acciones sobre este proceso.';
                    nextOperation = 'Seleccione un proceso para poder continuar con la operación';
                    withoutPermissionsRequest = 'No tiene permisos para visualizar o realizar acciones sobre esta solicitud.';
                }

                if (sharedService.isSysAdminLoggedUser() ||
                    (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {

                } else {
                    ctrl.anularVista = true;
                    ctrl.motivoBloqueo = withoutPermissionsProcess;
                }

                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    toastr.error(nextOperation);
                    return;
                }

                dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.rolProcesoList = response.data.Value;
                            if (sharedService.isSysAdminLoggedUser() ||
                                (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                // console.log("IS OK CAN CONTINUE");
                                $state.go("pages.solicitud-edit", {
                                    id: id,
                                    grupo: $state.params.grupoId,
                                    proceso: ctrl.procesoSeleccionado.Id,
                                    solicitudPadreId: 0
                                });
                            } else {
                                toastr.error(withoutPermissionsRequest);
                                return;
                            }
                        } else {
                            toastr.error(withoutPermissionsRequest);
                            return;
                        }
                        return false;
                    }, function (error) {
                        toastr.error(withoutPermissionsRequest);
                        return;
                    });

            }

            ctrl.deleteAll = function (id) {
                var confirmationTitle, withoutPermissionProcess, confirmationText;

                if (ctrl.language == "español") {
                    withoutPermissionProcess = 'Seleccione un proceso para poder continuar con la operación';
                    confirmationTitle = 'Atención';
                    confirmationText = "Confirma el borrado de todos los elementos pertenecientes al proceso?";

                } else if (ctrl.language == "ingles") {
                    withoutPermissionProcess = 'Select a process to continue';
                    confirmationTitle = 'Attention';
                    confirmationText = "Do you confirm the deletion of all elements in the process?";

                } else if (ctrl.language == "portugues") {
                    withoutPermissionProcess = 'Selecione um processo para continuar com a operação';
                    confirmationTitle = 'Atenção';
                    confirmationText = "Confirma a exclusão de todos os elementos pertencentes ao processo?";

                } else if (ctrl.language == "italiano") {
                    withoutPermissionProcess = 'Seleccione un proceso para poder continuar con la operación';
                    confirmationTitle = 'Atención';
                    confirmationText = "Confirma el borrado de todos los elementos pertenecientes al proceso?";

                }

                if (ctrl.procesoSeleccionado == null || ctrl.procesoSeleccionado.Id == null || ctrl.procesoSeleccionado.Id <= 0) {
                    toastr.error(withoutPermissionsProcess);
                    return;
                }

                ctrl.isBusy = true;
                var confirmation = $uibModal.open({
                    animation: true,
                    component: "confirmation",
                    resolve: {
                        title: function () {
                            return confirmationTitle
                        },
                        message: function () {
                            return confirmationText + ctrl.procesoSeleccionado.Nombre + "?"
                        },
                    }
                });

                confirmation.result.then(function (selectedItem) {
                    dataService.deleteSolicitudesByProceso(ctrl.procesoSeleccionado.Id)
                        .then(function (response) {
                            if (response.data.Success) {
                                toastr.info(ctrl.successfulRegistration);
                                $state.reload();
                            } else {
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            ctrl.isBusy = false;
                        });
                }, function () {
                    ctrl.isBusy = false;
                });
            }

            ctrl.openNewTab = function (fila) {
                var withoutPermissionsRequest;

                if (ctrl.language == "español")
                    withoutPermissionsRequest = 'No tiene permisos para visualizar o realizar acciones sobre esta solicitud.';
                else if (ctrl.language == "ingles")
                    withoutPermissionsRequest = 'You do not have permissions to view or perform actions on this request.';
                else if (ctrl.language == "portugues")
                    withoutPermissionsRequest = 'Você não tem permissão para visualizar ou agir sobre este aplicativo.';
                else if (ctrl.language == "italiano")
                    withoutPermissionsRequest = 'No tiene permisos para visualizar o realizar acciones sobre esta solicitud.';

                ctrl.model = {};
                ctrl.model.Id = fila.Id;
                ctrl.model.ProcesoId = ctrl.procesoSeleccionado.Id;
                var usuarioLogueadoId = authData.Id;
                // console.log(ctrl.model);
                // console.log(fila);

                dataService.getRolProcesoByProcesoUsuario(ctrl.model.Id, ctrl.model.ProcesoId, authData.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.rolProcesoList = response.data.Value;
                            if (sharedService.isSysAdminLoggedUser() ||
                                (ctrl.rolProcesoList != null && ctrl.rolProcesoList.length > 0)) {
                                // console.log("IS OK CAN CONTINUE");
                                var url = fila.UrlLink;
                                if (url != null && url.length > 0) {
                                    sharedService.openVisorDocumental(usuarioLogueadoId, url);
                                    // window.open(url);
                                }
                            } else {
                                toastr.error(withoutPermissionsRequest);
                                return;
                            }
                        } else {
                            toastr.error(withoutPermissionsRequest);
                            return;
                        }
                        return false;
                    }, function (error) {
                        toastr.error(withoutPermissionsRequest);
                        return;
                    });
            }

            ctrl.cancel = function () {
                ctrl.filtrosSolicitud.documentalGetCerrados = true;
                saveTableFilters();
                $state.go("pages.solicitud-procesos", {
                    grupoId: $state.params.grupoId
                });
            }

            ctrl.goHome = function () {
                $state.go("pages.home");
            }

            ctrl.openUrl = function (UrlLink) {
                if (UrlLink == null || UrlLink.length == 0) {
                    var errorText;

                    if (ctrl.language == "español")
                        errorText = 'URL no disponible';
                    else if (ctrl.language == "ingles")
                        errorText = 'URL unavailable';
                    else if (ctrl.language == "portugues")
                        errorText = 'URL não disponível';
                    else if (ctrl.language == "italiano")
                        errorText = 'URL no disponible';

                    toastr.error(errorText);
                    return;
                }

                var usuarioLogueadoId = authData.Id;
                sharedService.openVisorDocumental(usuarioLogueadoId, UrlLink);

                // var permisos = '';
                // var usuarioDefault = 0;
                // var usuarioLogueadoId = authData.Id;
                // var urlBase64;
                // var fileName;
                // console.log(UrlLink);
                // sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, '');

                // if (UrlLink.includes('Kahuna.Api/uploads')) {
                //     urlBase64 = btoa(appConfig.uploadUrl);
                //     fileName = UrlLink.replace(appConfig.uploadUrl, '');
                //     sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);

                // } else if (UrlLink.includes('Kahuna.Api/Images')) {
                //     var imagesUrl = appConfig.uploadUrl.replace('uploads', 'Images');
                //     urlBase64 = btoa(imagesUrl);
                //     fileName = UrlLink.replace(imagesUrl, '');
                //     sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);

                // } else if (UrlLink.includes('rs.kahuna.biz') || UrlLink.includes('wkhn-madrid')) {
                //     dataService.obtenerParametrosByIdent("URL_REPORTSERVER")
                //         .then(function (response) {
                //             if (response.data.Success) {
                //                 urlBase64 = btoa(response.data.Value.UrlDocumentos);
                //                 fileName = UrlLink.replace(response.data.Value.UrlDocumentos, '');

                //                 sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);
                //             } else {
                //                 toastr.error(response.data.ErrorSummary);
                //             }
                //         }, function (error) {
                //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                //             ctrl.isBusy = false;
                //         });
                // } else if (UrlLink.includes('pbis.kahuna.biz')) {
                //     dataService.obtenerParametrosByIdent("URL_REPORTPOWERBI")
                //         .then(function (response) {
                //             if (response.data.Success) {
                //                 urlBase64 = btoa(response.data.Value.UrlDocumentos);
                //                 fileName = UrlLink.replace(response.data.Value.UrlDocumentos, '');

                //                 sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);
                //             } else {
                //                 toastr.error(response.data.ErrorSummary);
                //             }
                //         }, function (error) {
                //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                //             ctrl.isBusy = false;
                //         });
                // } else {
                //     // console.log('entro al else del listado');
                //     urlBase64 = btoa(UrlLink);
                //     sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, '', ctrl.procesoSeleccionado);
                // }
                // dataService.getAccesosURL(usuarioLogueadoId, urlBase64)
                //     .then(function (response) {
                //         if (response.data.Success) {

                //             permisos = ctrl.validarPermisosLink(response.data.Value);
                //             // console.log(response.data);
                //             // console.log(permisos);

                //             if (response.data.Value.ver) {
                //                 sharedService.setUrlIframe(response.data.Value.urlProcesoLink + permisos);
                //                 ctrl.validarTipoDeLink(response.data.Value.urlProcesoLink + permisos);

                //             } else {
                //                 toastr.info('Usuario no autorizado para visualizar la URL');
                //             }
                //         } else {
                //             dataService.getAccesosURL(usuarioDefault, urlBase64)
                //             .then(function (response) {
                //                 if (response.data.Success) {

                //                     permisos = ctrl.validarPermisosLink(response.data.Value);
                //                     // console.log(response.data);
                //                     // console.log(permisos);

                //                     if (response.data.Value.ver) {
                //                         sharedService.setUrlIframe(response.data.Value.urlProcesoLink + permisos);
                //                         ctrl.validarTipoDeLink(response.data.Value.urlProcesoLink + permisos);

                //                     } else {
                //                         toastr.info('Usuario no autorizado para visualizar la URL');
                //                     }
                //                 } else {
                //                     toastr.info('La url no se encuentra habilitada');
                //                     // console.log(response.data);
                //                     return;
                //                 }
                //             })
                //         }
                //     });
            }

            // ctrl.validarPermisosLink = function (itemAValidar) {
            //     if (itemAValidar.ver) {
            //         if (itemAValidar.urlProcesoLink.includes('kahuna.biz')) {
            //             // Si se accede a un servidor de Reporting Services
            //             if (itemAValidar.urlProcesoLink.includes('?')) {
            //                 // si la url ya tiene parámetros
            //                 return (itemAValidar.imprimir)
            //                     ? '&rs:embed=true&rc:toolbar=true'
            //                     : '&rs:embed=true&rc:toolbar=false'
            //             } else {
            //                 // Si no tiene, se le añaden
            //                 return (itemAValidar.imprimir)
            //                     ? '?rs:embed=true&rc:toolbar=true'
            //                     : '?rs:embed=true&rc:toolbar=false'
            //             }
            //         }
            //     } 

            //     return '';
            // }

            // ctrl.validarTipoDeLink = function (link) {
            //     if(link.includes('vimeo')) {
            //         window.open(link, '', "width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no")
            //     } else {
            //         window.open('/accesoUrl.html', '', 'width=900,height=500,top=100,left=300,status=no,toolbar=no,menubar=no,location=no');
            //     }
            // }

            ctrl.verDocPendientes = function (EstadoSolicitudes) {
                ctrl.documentalGetCerrados = !ctrl.documentalGetCerrados;
                // console.log(ctrl.solicitudTableState);
                ctrl.currentPage = 1;
                if (ctrl.solicitudTableState != null && ctrl.solicitudTableState.pagination != null) {
                    ctrl.solicitudTableState.pagination.start = 0;
                } else {
                    ctrl.solicitudTableState.pagination = {};
                    ctrl.solicitudTableState.pagination.start = 0;
                }
                ctrl.buscarSolicitud(ctrl.solicitudTableState, EstadoSolicitudes);
                //saveTableFilters();
            }

            ctrl.cleanFilters = function () {
                ctrl.values = [];
                ctrl.filtrosSolicitud = {};
                llenarArrayFiltro();
                /*angular.forEach(ctrl.values, function (value, key) {                    
                    ctrl.values[key] = "";
                });*/
                ctrl.triggerFind();
            }

            ctrl.triggerFind = function () {
                // console.log("***************triggerFind*********************");                
                ctrl.filtrosSolicitud.CamposList = [];

                angular.forEach(ctrl.values, function (value, key) {
                    if (ctrl.procesoSeleccionado.CamposListado[key].Campo != null) {
                        ctrl.filtrosSolicitud.CamposList.push({
                            CampoId: ctrl.procesoSeleccionado.CamposListado[key].Campo.Id,
                            Valor: value
                        });
                    }
                });

                angular.forEach(ctrl.values, function (value, key) {
                    /*if (ctrl.procesoSeleccionado.CamposListado[key].Campo != null) {
                        ctrl.filtrosSolicitud.CamposList.push({
                            CampoId: ctrl.procesoSeleccionado.CamposListado[key].Campo.Id,
                            Valor: value
                        });
                    }*/

                    if (ctrl.procesoSeleccionado.CamposListado[key].SolicitudColumna != null) {

                        var codigo = ctrl.procesoSeleccionado.CamposListado[key].SolicitudColumna.Codigo;

                        switch (codigo) {
                            case "Id":
                                ctrl.filtrosSolicitud.Id = value;
                                break;

                            case "NumeroCompleto":
                                ctrl.filtrosSolicitud.NumeroCompleto = value;
                                break;

                            case "Descripcion":
                                ctrl.filtrosSolicitud.Descripcion = value;
                                break;

                            case "DescripcionResumida":
                                ctrl.filtrosSolicitud.DescripcionResumida = value;
                                break;

                            case "FechaCierre":
                                ctrl.filtrosSolicitud.FechaCierre = value;
                                // ctrl.filtrosSolicitud.FechaCierre = sharedService.convertDate(value);
                                break;

                            case "Estado":
                                ctrl.filtrosSolicitud.Estado = value;
                                break;

                            case "UsuarioAprobador":
                                ctrl.filtrosSolicitud.UsuarioAprobador = value;
                                break;

                            case "Proceso":
                                ctrl.filtrosSolicitud.ProcesoNombre = value;
                                break;

                            case "Activo":
                                ctrl.filtrosSolicitud.Activo = value;
                                break;

                            case "UsuarioCreacion":
                                ctrl.filtrosSolicitud.UsuarioCreacion = value;
                                break;

                            case "CreationDate":
                                ctrl.filtrosSolicitud.CreationDate = value;
                                // ctrl.filtrosSolicitud.CreationDate = sharedService.convertDate(value);
                                break;

                            case "LastUpdate":
                                ctrl.filtrosSolicitud.LastUpdate = value;
                                // ctrl.filtrosSolicitud.LastUpdate = sharedService.convertDate(value);
                                break;

                            default:
                                if (ctrl.filtrosSolicitud.CamposList == null)
                                    ctrl.filtrosSolicitud.CamposList = [];

                                ctrl.filtrosSolicitud.CamposList.push({
                                    CampoId: sharedService.replaceAll(property, "C_", ""),
                                    Valor: value
                                });
                                break;
                        }
                    }
                });
                saveTableFilters();
                ctrl.solicitudTableState.pagination.start = 0;
                ctrl.buscarSolicitud(ctrl.solicitudTableState);
            }

            // Las siguientes 3 funciones se encargan de replicar el comportamiento del botón "Ver Documento" que se muestra al editar una solicitud documental
            ctrl.openAttachment = function (fileName, isVerDocumento) {
                var usuarioLogueadoId = authData.Id;
                var fullUrl = appConfig.uploadUrl + fileName;
                sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl, false);

                // var usuarioLogueadoId = authData.Id;
                // // var urlBase64 = btoa(appConfig.uploadUrl + fileName);
                // var urlBase64 = btoa(appConfig.uploadUrl);
                // console.log(appConfig.uploadUrl + fileName);

                // if (isVerDocumento == 'verDocumento') {
                //     sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);
                //     return;
                // }

                // window.open(appConfig.uploadUrl + fileName);
            }

            // Este metodo fue cambiado el 23/10/2025 para comportarse igual al boton 'ver documento' dentro de una solicitud
            ctrl.verDocumento = function (solicitud, messageDestino) {

                var configureFieldOfProcess, configureLinkProcess;

                if (ctrl.language == "español") {
                    configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
                    configureLinkProcess = 'Debe configurar link en el Proceso.';
                }
                else if (ctrl.language == "ingles") {
                    configureFieldOfProcess = 'You must configure a field for publishable document in the Process.';
                    configureLinkProcess = 'You must configure a link in the Process.';
                }
                else if (ctrl.language == "portugues") {
                    configureFieldOfProcess = 'Deve configurar o campo para documento publicável no Processo';
                    configureLinkProcess = 'Deve configurar o link no Processo';
                }
                else if (ctrl.language == "italiano") {
                    configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
                    configureLinkProcess = 'Debe configurar link en el Proceso.';
                }

                ctrl.solicitudSeleccionada = solicitud;
                ctrl.solicitudSeleccionada.Proceso = ctrl.procesoSeleccionado;

                dataService.getSolicitudCampoValorCompleto(solicitud.Id)
                    .then(function (response) {
                        if (response.data.Success) {
                            ctrl.camposList = response.data.Value;

                            var tipoDocumentoId = ctrl.solicitudSeleccionada.Proceso.tipoDocumentoId;
                            var documentoPublicableId = ctrl.solicitudSeleccionada.Proceso.documentoPublicableId;
                            var linkDocumental = ctrl.solicitudSeleccionada.Proceso.LinkDocumental;

                            var campoForDocumentoPublicable, campoForTipoDocumento;

                            angular.forEach(ctrl.camposList, function (value, key) {
                                if (value.CampoId == tipoDocumentoId && value.Valor != "") {
                                    campoForTipoDocumento = value;
                                }
                                if (value.CampoId == documentoPublicableId && value.Valor != "") {
                                    campoForDocumentoPublicable = value;
                                }
                            });

                            var tipoDocumentoOpcion;
                            if (campoForTipoDocumento != null && campoForTipoDocumento.ValorObjeto != null && campoForTipoDocumento.ValorObjeto != undefined) {
                                var codigo = campoForTipoDocumento.ValorObjeto[0].Codigo;
                                if (codigo != null && codigo != undefined && codigo != "") {
                                    if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP1") {
                                        tipoDocumentoOpcion = 1;
                                    }
                                    if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP2") {
                                        tipoDocumentoOpcion = 2;
                                    }
                                    if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP3") {
                                        tipoDocumentoOpcion = 3;
                                    }
                                }
                            }

                            if (tipoDocumentoOpcion == 1) {
                                if (campoForDocumentoPublicable != null && campoForDocumentoPublicable.Valor != null && campoForDocumentoPublicable.Valor != undefined && campoForDocumentoPublicable.Valor != "") {
                                    dataService.generateImpresionDocumentalOtros(solicitud.Id, authData.Id)
                                    .then(function (response) {
                                        if (response.data.Success && response.data.Value) {
                                            ctrl.openAttachment(campoForDocumentoPublicable.Valor); //, 'verDocumento');
                                        } else {
                                            toastr.error(response.data.ErrorSummary);
                                            return;
                                        }
                                    }, function (error) {
                                        toastr.error(error.data || getGenericErrorMessage(error));
                                        return;
                                    });
                                } else {
                                    Swal.fire({
                                        title: configureFieldOfProcess,
                                        type: 'warning',
                                        showCancelButton: false,
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: ctrl.acceptText,
                                        cancelButtonText: ctrl.cancelText,
                                        heightAuto: false
                                    })
                                        .then(function (result) { });
                                }
                            } else if (tipoDocumentoOpcion == 2) {
                                if (linkDocumental != null && linkDocumental != undefined && linkDocumental != "") {
                                    linkDocumental = linkDocumental.replace("VarProcesoId", ctrl.solicitudSeleccionada.ProcesoId);
                                    linkDocumental = linkDocumental.replace("VarUsuarioId", authData.Id);
                                    linkDocumental = linkDocumental.replace("varDestinoID", messageDestino);
                                    linkDocumental = linkDocumental.replace("VarSolicitudId", ctrl.solicitudSeleccionada.Id);
                                    ctrl.generateImagesPdf(linkDocumental, tipoDocumentoOpcion);
                                } else {
                                    Swal.fire({
                                        title: configureLinkProcess,
                                        type: 'warning',
                                        showCancelButton: false,
                                        confirmButtonColor: '#3085d6',
                                        confirmButtonText: ctrl.acceptText,
                                        cancelButtonText: ctrl.cancelText,
                                        heightAuto: false
                                    })
                                        .then(function (result) { });
                                }
                            } else if (tipoDocumentoOpcion == 3) {
                                ctrl.generateImagesPdf('', tipoDocumentoOpcion);
                            }

                        } else {
                            toastr.error(response.data.ErrorSummary);
                        }
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    })
            }

            // Esta version del metodo funciono hasta el 23/10/2025
            // ctrl.verDocumento = function (solicitud, messageDestino) {
            //     // Este metodo se encarga de evaluar si el documento cargado es un PDF para mostrar el reporte correspondiente de Reporting Services, caso contrario abre el documento (ESTO SE VALIDA CON EL VISOR DOCUMENTAL)

            //     var configureFieldOfProcess, configureLinkProcess;

            //     if (ctrl.language == "español") {
            //         configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
            //         configureLinkProcess = 'Debe configurar link en el Proceso.';
            //     }
            //     else if (ctrl.language == "ingles") {
            //         configureFieldOfProcess = 'You must configure a field for publishable document in the Process.';
            //         configureLinkProcess = 'You must configure a link in the Process.';
            //     }
            //     else if (ctrl.language == "portugues") {
            //         configureFieldOfProcess = 'Deve configurar o campo para documento publicável no Processo';
            //         configureLinkProcess = 'Deve configurar o link no Processo';
            //     }
            //     else if (ctrl.language == "italiano") {
            //         configureFieldOfProcess = 'Debe configurar campo para documento publicable en el Proceso.';
            //         configureLinkProcess = 'Debe configurar link en el Proceso.';
            //     }

            //     ctrl.solicitudSeleccionada = solicitud;
            //     ctrl.solicitudSeleccionada.Proceso = ctrl.procesoSeleccionado;

            //     dataService.getSolicitudCampoValorCompleto(solicitud.Id)
            //         .then(function (response) {
            //             if (response.data.Success) {
            //                 ctrl.camposList = response.data.Value;

            //                 var tipoDocumentoId = ctrl.solicitudSeleccionada.Proceso.tipoDocumentoId;
            //                 var documentoPublicableId = ctrl.solicitudSeleccionada.Proceso.documentoPublicableId;
            //                 var linkDocumental = ctrl.solicitudSeleccionada.Proceso.LinkDocumental;

            //                 var campoForDocumentoPublicable, campoForTipoDocumento;

            //                 angular.forEach(ctrl.camposList, function (value, key) {
            //                     if (value.CampoId == tipoDocumentoId && value.Valor != "") {
            //                         campoForTipoDocumento = value;
            //                     }
            //                     if (value.CampoId == documentoPublicableId && value.Valor != "") {
            //                         campoForDocumentoPublicable = value;
            //                     }
            //                 });

            //                 var tipoDocumentoOpcion;
            //                 if (campoForTipoDocumento != null && campoForTipoDocumento.ValorObjeto != null && campoForTipoDocumento.ValorObjeto != undefined) {
            //                     var codigo = campoForTipoDocumento.ValorObjeto[0].Codigo;
            //                     if (codigo != null && codigo != undefined && codigo != "") {
            //                         if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP3") {
            //                             tipoDocumentoOpcion = 3;
            //                         }
            //                     }
            //                 }

            //                 if (tipoDocumentoOpcion == 3) {
            //                     ctrl.generateImagesPdf('', tipoDocumentoOpcion);
            //                 } else {
            //                     if (campoForDocumentoPublicable.Valor.toLowerCase().slice(-4) == ".pdf") {

            //                         if (linkDocumental != null && linkDocumental != undefined && linkDocumental != "") {

            //                             linkDocumental = linkDocumental.replace("VarProcesoId", ctrl.solicitudSeleccionada.ProcesoId);
            //                             linkDocumental = linkDocumental.replace("VarUsuarioId", authData.Id);
            //                             linkDocumental = linkDocumental.replace("varDestinoID", messageDestino);
            //                             linkDocumental = linkDocumental.replace("VarSolicitudId", ctrl.solicitudSeleccionada.Id);

            //                         } else {
            //                             Swal.fire({
            //                                 title: configureLinkProcess,
            //                                 type: 'warning',
            //                                 showCancelButton: false,
            //                                 confirmButtonColor: '#3085d6',
            //                                 confirmButtonText: ctrl.acceptText,
            //                                 cancelButtonText: ctrl.cancelText,
            //                                 heightAuto: false
            //                             })
            //                                 .then(function (result) { });
            //                         }

            //                         dataService.obtenerParametrosByIdent("RDLESPECIAL")
            //                             .then(function (response) {
            //                                 if (response.data.Success) {

            //                                     if (response.data.Value.UrlDocumentos != null && response.data.Value.UrlDocumentos.length > 0) {
            //                                         linkDocumental = linkDocumental.replace("Khn_Documental_V2", response.data.Value.UrlDocumentos);
            //                                     }

            //                                     ctrl.generateImagesPdf(linkDocumental, tipoDocumentoOpcion);
            //                                 } else {
            //                                     ctrl.generateImagesPdf(linkDocumental, tipoDocumentoOpcion);
            //                                 }
            //                             }, function (error) {
            //                                 toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            //                                 ctrl.isBusy = false;
            //                             });
            //                     } else {

            //                         if (campoForDocumentoPublicable != null && campoForDocumentoPublicable.Valor != null && campoForDocumentoPublicable.Valor != undefined && campoForDocumentoPublicable.Valor != "") {
            //                             ctrl.openAttachment(campoForDocumentoPublicable.Valor, 'verDocumento');
            //                         } else {
            //                             Swal.fire({
            //                                 title: configureFieldOfProcess,
            //                                 type: 'warning',
            //                                 showCancelButton: false,
            //                                 confirmButtonColor: '#3085d6',
            //                                 confirmButtonText: ctrl.acceptText,
            //                                 cancelButtonText: ctrl.cancelText,
            //                                 heightAuto: false
            //                             })
            //                                 .then(function (result) { });
            //                         }
            //                     }
            //                 }

            //             } else {
            //                 toastr.error(response.data.ErrorSummary);
            //             }
            //         }, function (error) {
            //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            //         })
            // }
            // ctrl.verDocumento = function (solicitud, messageDestino) {
            //     ctrl.solicitudSeleccionada = solicitud;
            //     ctrl.solicitudSeleccionada.Proceso = ctrl.procesoSeleccionado;
            //     //tipoDocumentoId
            //     //documentoPublicableId
            //     dataService.getSolicitudCampoValorCompleto(solicitud.Id)
            //         .then(function (response) {
            //             if (response.data.Success) {
            //                 ctrl.camposList = response.data.Value;

            //                 console.log(ctrl.solicitudSeleccionada);

            //                 var tipoDocumentoId = ctrl.solicitudSeleccionada.Proceso.tipoDocumentoId;
            //                 var documentoPublicableId = ctrl.solicitudSeleccionada.Proceso.documentoPublicableId;
            //                 var linkDocumental = ctrl.solicitudSeleccionada.Proceso.LinkDocumental;

            //                 var campoForTipoDocumento, campoForDocumentoPublicable;

            //                 angular.forEach(ctrl.camposList, function (value, key) {
            //                     if (value.CampoId == tipoDocumentoId && value.Valor != "") {
            //                         campoForTipoDocumento = value;
            //                     }
            //                     if (value.CampoId == documentoPublicableId && value.Valor != "") {
            //                         campoForDocumentoPublicable = value;
            //                     }
            //                 });

            //                 var tipoDocumentoOpcion;
            //                 if (campoForTipoDocumento != null && campoForTipoDocumento.ValorObjeto != null && campoForTipoDocumento.ValorObjeto != undefined) {
            //                     var codigo = campoForTipoDocumento.ValorObjeto[0].Codigo;
            //                     if (codigo != null && codigo != undefined && codigo != "") {
            //                         if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP1") {
            //                             tipoDocumentoOpcion = 1;
            //                         }
            //                         if (codigo.toUpperCase() == "SKT-TIPOPUBLICACION-OP2") {
            //                             tipoDocumentoOpcion = 2;
            //                         }
            //                     }
            //                 }
            //                 if (tipoDocumentoOpcion == 1) {
            //                     if (campoForDocumentoPublicable != null && campoForDocumentoPublicable.Valor != null && campoForDocumentoPublicable.Valor != undefined && campoForDocumentoPublicable.Valor != "") {
            //                         ctrl.openAttachment(campoForDocumentoPublicable.Valor, 'verDocumento');
            //                     } else {
            //                         Swal.fire({
            //                             title: 'Debe configurar campo para documento publicable en el Proceso.',
            //                             type: 'warning',
            //                             showCancelButton: false,
            //                             confirmButtonColor: '#3085d6',
            //                             confirmButtonText: 'Aceptar',
            //                             cancelButtonText: 'Cancel',
            //                             heightAuto: false
            //                         })
            //                             .then(function (result) { });
            //                     }
            //                 } else if (tipoDocumentoOpcion == 2) {
            //                     if (linkDocumental != null && linkDocumental != undefined && linkDocumental != "") {
            //                         linkDocumental = linkDocumental.replace("VarProcesoId", ctrl.solicitudSeleccionada.ProcesoId);
            //                         linkDocumental = linkDocumental.replace("VarUsuarioId", authData.Id);
            //                         linkDocumental = linkDocumental.replace("varDestinoID", messageDestino);
            //                         linkDocumental = linkDocumental.replace("VarSolicitudId", ctrl.solicitudSeleccionada.Id);
            //                         console.log(linkDocumental);
            //                         ctrl.generateImagesPdf(linkDocumental, ctrl.solicitudSeleccionada.Id);
            //                     } else {
            //                         Swal.fire({
            //                             title: 'Debe configurar link en el Proceso.',
            //                             type: 'warning',
            //                             showCancelButton: false,
            //                             confirmButtonColor: '#3085d6',
            //                             confirmButtonText: 'Aceptar',
            //                             cancelButtonText: 'Cancel',
            //                             heightAuto: false
            //                         })
            //                             .then(function (result) { });
            //                     }
            //                 }
            //             } else {
            //                 toastr.error(response.data.ErrorSummary);
            //             }
            //         }, function (error) {
            //             toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            //         })
            // }

            ctrl.generateImagesPdf = function (linkDocumental, tipoDocumentoOpcion) {
                var modalText;

                if (ctrl.language == "español")
                    modalText = 'Estamos trabajando para ti, Por favor espera.';
                else if (ctrl.language == "ingles")
                    modalText = 'We are working for you. Please wait.';
                else if (ctrl.language == "portugues")
                    modalText = 'Estamos trabalhando para você, aguarde.';
                else if (ctrl.language == "italiano")
                    modalText = 'Estamos trabajando para ti, Por favor espera.';

                Swal.fire({
                    title: modalText,
                    showCancelButton: false,
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: ctrl.acceptText,
                    cancelButtonText: ctrl.cancelText,
                    showCloseButton: false,
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    focusConfirm: false,
                    heightAuto: false,
                    onOpen: function () {
                        swal.showLoading();
                    }
                });

                if (tipoDocumentoOpcion == 3) {
                    dataService.generarImpresionDocumentalPdf(ctrl.solicitudSeleccionada.Id, ctrl.solicitudSeleccionada.ProcesoId)
                    .then(function (response) {
                        if (response.data.Success) {
                            swal.close();
                            var usuarioLogueadoId = authData.Id;
                            var decodedUrl = atob(response.data.Value);

                            sharedService.openVisorDocumental(usuarioLogueadoId, decodedUrl, true);
                        } else {
                            swal.close();
                            toastr.error(response.data.ErrorSummary);
                        }
                        ctrl.isBusy = false;
                    }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                        swal.close();
                        ctrl.isBusy = false;
                    });
                } else {
                    // Esta llamado funciono hasta el 23/10/2025
                    // dataService.generateImagesPdfFromList(ctrl.solicitudSeleccionada.Id)
                    dataService.generateImagesPdf(ctrl.solicitudSeleccionada.Id)
                        .then(function (response) {
                            if (response.data.Success) {

                                // console.log(linkDocumental);
                                swal.close();
                                var usuarioLogueadoId = authData.Id;
                                sharedService.openVisorDocumental(usuarioLogueadoId, linkDocumental);

                                // if (linkDocumental.includes('rs.kahuna.biz')) {
                                //     dataService.obtenerParametrosByIdent("URL_REPORTSERVER")
                                //     .then(function (response) {
                                //         if (response.data.Success) {
                                //             swal.close();
                                //             var usuarioLogueadoId = authData.Id;
                                //             var urlBase64 = btoa(response.data.Value.UrlDocumentos);
                                //             var fileName = linkDocumental.replace(response.data.Value.UrlDocumentos, '');

                                //             sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);
                                //             // window.open(linkDocumental, "_blank");
                                //         } else {
                                //             toastr.error(response.data.ErrorSummary);
                                //         }
                                //     }, function (error) {
                                //         toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                //         ctrl.isBusy = false;
                                //     });
                                // } else if (linkDocumental.includes('pbis.kahuna.biz')) {
                                //     dataService.obtenerParametrosByIdent("URL_REPORTPOWERBI")
                                //     .then(function (response) {
                                //         if (response.data.Success) {
                                //             swal.close();
                                //             var usuarioLogueadoId = authData.Id;
                                //             var urlBase64 = btoa(response.data.Value.UrlDocumentos);
                                //             var fileName = linkDocumental.replace(response.data.Value.UrlDocumentos, '');

                                //             sharedService.openVisorDocumental(usuarioLogueadoId, urlBase64, fileName, ctrl.procesoSeleccionado);
                                //         } else {
                                //             toastr.error(response.data.ErrorSummary);
                                //         }
                                //     }, function (error) {
                                //         toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                                //         ctrl.isBusy = false;
                                //     });
                                // }

                            } else {
                                swal.close();
                                toastr.error(response.data.ErrorSummary);
                            }
                            ctrl.isBusy = false;
                        }, function (error) {
                            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                            swal.close();
                            ctrl.isBusy = false;
                        });
                }
            }
        }
    });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.solicitud').component('solicitudProcesos', {
    templateUrl: 'app/pages/solicitud/procesolist.template.html',
    controller: function ($state, $window, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.anularVista = true;
      ctrl.procesosList = [];
      ctrl.grupoSeleccionado = {};
      this.$onInit = function () {
        if ($state != null && $state.params != null && $state.params.grupoId != null && $state.params.grupoId > 0) {
          ctrl.anularVista = false;
          ctrl.isProcesoSearching = true;

          var solicitudProcesosTitle;

          if (ctrl.language == "español")
            solicitudProcesosTitle = 'Selección de Proceso';
          else if (ctrl.language == "ingles")
            solicitudProcesosTitle = 'Process Selection';
          else if (ctrl.language == "portugues")
            solicitudProcesosTitle = 'Seleção de Processo';
          else if (ctrl.language == "italiano")
            solicitudProcesosTitle = 'Selección de Proceso';

          $state.current.title = solicitudProcesosTitle;

          dataService.getGrupoById($state.params.grupoId)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.grupoSeleccionado = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });

          dataService.getProcesoByGrupo($state.params.grupoId)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.procesosList = response.data.Value;
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isProcesoSearching = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isProcesoSearching = false;
            });
        }
        else {
          ctrl.goHome();
          return;
        }
      };

      ctrl.setProcesoSeleccionado = function (procesoSeleccionado) {
        //Si tiene seteado un link, navego a ese link
        if (procesoSeleccionado.UrlLink != null && procesoSeleccionado.UrlLink.length > 0)
          $window.open(procesoSeleccionado.UrlLink, '_blank');

        $state.go('pages.solicitud', { grupoId: $state.params.grupoId, procesoId: procesoSeleccionado.Id });
      };

      ctrl.goHome = function () {
        $state.go("pages.home");
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.solicitud').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.solicitud', {
          url: '/solicitud/:grupoId/:procesoId',
          title: '',
          template : '<solicitud-list></solicitud-list>',
          authenticate: true,
        })
        .state('pages.solicitud-edit', {
          url: '/solicitud/edit/:id/:grupo/:proceso/:solicitudPadreId',
          title: '',
          template : '<solicitud-edit></solicitud-edit>',
          params: {id:null},
          authenticate: true,
        })
        .state('pages.solicitud-template', {
          url: '/solicitud/template/edit/:solicitud/:solicitudEstado/:procesoTemplate/:template/:proceso/:solicitudProcesoTemplate',
          title: '',
          template : '<solicitud-template></solicitud-template>',
          params: {id:null},
          authenticate: true,
        })
        .state('pages.solicitud-procesos', {
          url: '/solicitudes/procesos/:grupoId',
          title: '',
          template : '<solicitud-procesos></solicitud-procesos>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  "use strict";
  angular.module("Kahuna.pages.solicitud").component("solicitudTemplate", {
    templateUrl: "app/pages/solicitud/template.template.html",
    controller: function (
      $scope,
      $state,
      dataService,
      sharedService,
      appConfig,
      toastr,
      toastrConfig,
      $stateParams,
      $uibModal,
      $timeout,
      $interval
    ) {
      // console.log("Template.componmente.js");
      var ctrl = this;
      $scope.readonly = false;
      ctrl.language = sharedService.getLanguage();
      ctrl.imgFile = appConfig.uploadUrl;
      ctrl.model = {};
      ctrl.LinkTemplate = {
        UrlDocumentos: "",
        TipoCampo: "",
      };
      ctrl.solicitudProcesoTemplateId = 0;
      ctrl.isBusy = false;
      ctrl.isNew = false;
      ctrl.showDelete = false;
      ctrl.anularVista = true;
      ctrl.viewLoading = true;
      ctrl.motivoBloqueo = "";
      ctrl.soloLectura = 1;
      ctrl.puedeBorrarTemplate = false;
      ctrl.tituloCampoValor = "";
      ctrl.title = "Carga de Gestión";
      ctrl.mensajeNotificacion = "";
      ctrl.mailsAdicionales = "";
      ctrl.solicitudHasProceduresField = false;
      ctrl.generaProcesoRelacionados = false;
      ctrl.allowToAutoriceA = false;
      ctrl.allowToAutoriceB = false;
      ctrl.styleFontTitle = {};
      ctrl.solicitud = {};
      ctrl.template = {};
      ctrl.SolicitudProcesoTemplate = {};

      ctrl.camposList = [];
      // ctrl.camposListTemplate = [];
      ctrl.jerarquia = [];
      ctrl.usuarios = [];
      ctrl.camposTableEnr = [];

      ctrl.valoresCampoSolicitudList = [];
      ctrl.procesoUsuariosList = [];
      ctrl.procesoUsuariosDS = [];
      ctrl.procesoUsuariosNotificarList = [];
      ctrl.procesoUsuariosNotificarTabList = [];
      ctrl.procesoUsuariosNotificarDS = [];
      ctrl.showBtnLink = false;

      ctrl.listadoDeProcesos = [];
      ctrl.listadoDeProcesos_doc = [];
      ctrl.listaUsuariosDerivarResponsabilidad = [];

      ctrl.templates = [];
      ctrl.rolTemplateList = [];
      var authData = {};

      ctrl.mensajeNotificacionTab = "";
      ctrl.mailsAdicionalesTab = "";

      ctrl.tipoEnvioMailConfig = {};

      ctrl.autoSaveInterval = null;

      this.$onInit = function () {
        // console.log($stateParams.solicitudProcesoTemplate);
        // console.log($stateParams);

        var solicitudListTitle;

        if (ctrl.language == "español") {
          solicitudListTitle = 'Carga de Proceso';
          ctrl.acceptText = "Aceptar";
          ctrl.cancelText = "Cancelar";
          ctrl.successfulRegistration = "Registro exitoso.";

        } else if (ctrl.language == "ingles") {
          solicitudListTitle = 'Process Load';
          ctrl.acceptText = "Accept";
          ctrl.cancelText = "Cancel";
          ctrl.successfulRegistration = "Registration successful.";

        } else if (ctrl.language == "portugues") {
          solicitudListTitle = 'Carga do processo';
          ctrl.acceptText = "Aceitar";
          ctrl.cancelText = "Cancelar";
          ctrl.successfulRegistration = "Registro bem-sucedido.";

        } else if (ctrl.language == "italiano") {
          solicitudListTitle = 'Carga de Proceso';
          ctrl.acceptText = "Aceptar";
          ctrl.cancelText = "Cancelar";
          ctrl.successfulRegistration = "Registro exitoso.";
        }

        $state.current.title = solicitudListTitle;

        authData = sharedService.getLoggedUser();
        // console.log(authData);
        var applicationProperties = sharedService.getLocalData("ApplicationProperties");

        if (
          applicationProperties != null &&
          applicationProperties != undefined &&
          applicationProperties.hasOwnProperty("HEADCOLOR")
        ) {
          ctrl.styleFontTitle = {
            color: applicationProperties.HEADCOLOR,
          };
        }

        if (authData != null && authData.Id > 0) {
          loadView(authData);
        } else {
          $state.go("auth");
          return;
        }

        // if ($location.url().match(/solicitud\/template\/edit\//g)) {
        //   ctrl.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
        // }
      };

      ctrl.openLink = function (url) {
        // console.log("OPEN LINK" + url);
        // window.open(url, "_blank");
        var usuarioLogueadoId = authData.Id;
        sharedService.openVisorDocumental(usuarioLogueadoId, url);
      };

      ctrl.openLinkTemplate = function () {
        // console.log("OPEN LINK TEMPLATE...");
        // console.log(ctrl.LinkTemplate);
        // console.log($stateParams.solicitud);
        // console.log($stateParams.template);
        // console.log($stateParams.procesoTemplate);
        ctrl.solicitudProcesoTemplateId = $stateParams.solicitudProcesoTemplate;
        // console.log(ctrl.solicitudProcesoTemplateId);

        if (
          ctrl.LinkTemplate != undefined &&
          ctrl.LinkTemplate != null &&
          ctrl.LinkTemplate.UrlDocumentos != ""
        ) {
          // console.log(ctrl.LinkTemplate);
          var usuarioLogueadoId = authData.Id;
          var urlLink = ctrl.LinkTemplate.UrlDocumentos.replace("&solicitud", ctrl.solicitud.Id);
          urlLink = urlLink.replace("&SolicitudId", ctrl.solicitud.Id);
          urlLink = urlLink.replace("&IdProcesoTemplate", ctrl.solicitudProcesoTemplateId);
          if ($stateParams.procesoTemplate != 0) {
            sharedService.openVisorDocumental(usuarioLogueadoId, urlLink);
            // window.open(urlLink, "_blank");
          }
        }
      };

      ctrl.userInGroup = function (grupoId, userId, callbackFunction) {
        try {
          // console.log("ingreso a userInGrup********");
          dataService.userInGroup(grupoId, userId).then(
            function (response) {
              if (response.data.Success) {
                // console.log("value ", response.data.Value);
                callbackFunction(response.data.Value);
              } else {
                callbackFunction(false);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
        } catch (ex) {
          // console.log("error.");
        }
      };

      ctrl.listaUsuariosDerivar = function () {
        // console.log(ctrl.solicitud);
        try {
          dataService
            .getUsuarioListByProcesoEstado(
              ctrl.solicitud.ProcesoId,
              ctrl.solicitud.Id,
              ctrl.solicitud.EstadoId
            )
            .then(
              function (response) {
                if (response.data.Success) {
                  ctrl.listaUsuariosDerivarResponsabilidad =
                    response.data.Value;
                  // console.log("LISTAO ");
                  // console.log(ctrl.listaUsuariosDerivarResponsabilidad);
                  ctrl.verificarUsuarioListado(authData.Id);
                }
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
              }
            );
        } catch (ex) {
          // console.log("error.");
          ctrl.listaUsuariosDerivarResponsabilidad = [];
        }
      };

      ctrl.verificarUsuarioListado = function (stringFind) {
        // console.log(stringFind);
        //stringFind = 3;
        if (stringFind != "") {
          var userExist = sharedService.uniqById(
            ctrl.listaUsuariosDerivarResponsabilidad,
            "Id",
            stringFind
          );
          /*if ( userExist != null && userExist != undefined && userExist.length > 0) {
            // console.log(userExist);
            ctrl.allowToAutoriceA = true;
          } else {
            ctrl.allowToAutoriceA = false;
          }
          // console.log(ctrl.allowToAutoriceA);*/
        }
      };

      // ctrl.init = function (item) {
      //   // console.log('ITEM.VALOROBJETO',item.ValorObjeto);
      //   // console.log('ITEM.SOURCEOBJETO',item.SourceObjeto);
      //   // console.log("ENTRÓ AL INIT");

      //   if (item.ValorObjeto === null) {
      //     // console.log("LLEGÓ NULL");
      //     item.ValorObjeto = [];
      //   }
      //   for (let i = 0 ;i < item.SourceObjeto.length; i++) {
      //     for (let j = 0; j < item.ValorObjeto.length; j++) {
      //       if (item.SourceObjeto[i].Id == item.ValorObjeto[j].Id) {
      //         item.SourceObjeto.splice(i, 1);
      //       }
      //     }
      //   }
      //   // item.SourceObjeto = item.SourceObjeto.filter(function(obj){
      //   //   return  item.ValorObjeto.indexOf(obj) == -1;
      //   // });
      //   // console.log(item.SourceObjeto)
      // };
      ctrl.onChangeInputCampostList = function (textoBusqueda, item, jerarquiaPadreId) {

        if (!item.SourceObjetoTemp) {
          item.SourceObjetoTemp = item.SourceObjeto;
        }

        if (!item.jerarquiaPadreId && jerarquiaPadreId) {
          item.jerarquiaPadreId = jerarquiaPadreId;
        }

        if (!item.ValorObjeto || item.ValorObjeto.length < 1) {
          item.ValorObjeto = [];
        }

        if (textoBusqueda.length >= 1) {
          dataService.searchJerarquiaByPadre(textoBusqueda, item.jerarquiaPadreId)
            .then(function (response) {
              if (response.data.Success) {
                // Si filtra los elementos seleccionados de la respuesta del backend
                item.SourceObjeto = response.data.Value.filter(function (element) {
                  var alreadySelected = item.ValorObjeto.findIndex(function (el) {
                    return element.Id == el.Id;
                  })

                  return alreadySelected == -1;
                });
              } else {
                toastr.error(response.data.ErrorSummary)
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            })
          /**
           * Antes del cambio del 17/09/2024 ↓
           */
          // var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
          // if (result != null && result != undefined && result.length > 0) {
          //   item.SourceObjeto = result;
          // } else {
          //   item.SourceObjeto = [];
          // }
        } else if (textoBusqueda.length == 0) {
          item.SourceObjeto = item.SourceObjetoTemp;
        }
      }

      ctrl.onChangeInputCampostListTableEnr = function (textoBusqueda, item, jerarquiaPadreId) {
        if (!item.SourceObjetoTemp) {
          item.SourceObjetoTemp = item.SourceObjeto;
        }

        if (!item.jerarquiaPadreId && jerarquiaPadreId) {
          item.jerarquiaPadreId = jerarquiaPadreId;
        }

        if (!item.ValorObjeto || item.ValorObjeto.length < 1) {
          item.ValorObjeto = [];
        }

        if (textoBusqueda.length >= 1) {
          dataService.searchJerarquiaByPadre(textoBusqueda, item.jerarquiaPadreId)
            .then(function (response) {
              if (response.data.Success) {
                // Si filtra los elementos seleccionados de la respuesta del backend
                item.SourceObjeto = response.data.Value.filter(function (element) {
                  var alreadySelected = item.ValorObjeto.findIndex(function (el) {
                    return element.Id == el.Id;
                  })

                  return alreadySelected == -1;
                });
              } else {
                toastr.error(response.data.ErrorSummary)
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            })
          /**
           * Antes del cambio del 17/09/2024 ↓
           */
          // var result = sharedService.contains(item.SourceObjetoTemp, "Nombre", textoBusqueda);
          // if (result != null && result != undefined && result.length > 0) {
          //   item.SourceObjeto = result;
          // } else {
          //   item.SourceObjeto = [];// item.SourceObjetoTemp;
          // }
        } else if (textoBusqueda.length == 0) {
          item.SourceObjeto = item.SourceObjetoTemp;
        }
      }

      ctrl.actionAddOnClick = function (j, item) {
        if (!item.SourceObjetoTemp) {
          item.SourceObjetoTemp = item.SourceObjeto;
        }

        if (!item.ValorObjeto) {
          item.ValorObjeto = [];
        }

        // Filtrando el elemento clickado de la lista de la vista
        item.SourceObjeto = item.SourceObjeto.filter(function (element) {
          return element.Id != j.Id;
        });

        // Filtrando el elemento clickado de la lista de por defecto
        item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (element) {
          return element.Id != j.Id;
        });

        var alreadySelected = item.ValorObjeto.findIndex(function (element) {
          return element.Id == j.Id;
        })

        // Si ya existe el elemento seleccionado, no lo agregará
        alreadySelected == -1 ? item.ValorObjeto.push(j) : '';
      };

      ctrl.actionAddOnClickTableEnr = function (j, item) {
        // Este metodo hace lo mismo que el actionAddOnClick, pero se separó por si la lógica del TableEnr es necesario cambiarla
        if (!item.SourceObjetoTemp) {
          item.SourceObjetoTemp = item.SourceObjeto;
        }

        if (!item.ValorObjeto) {
          item.ValorObjeto = [];
        }

        // Filtrando el elemento clickado de la lista de la vista
        item.SourceObjeto = item.SourceObjeto.filter(function (element) {
          return element.Id != j.Id;
        });

        // Filtrando el elemento clickado de la lista de por defecto
        item.SourceObjetoTemp = item.SourceObjetoTemp.filter(function (element) {
          return element.Id != j.Id;
        });

        var alreadySelected = item.ValorObjeto.findIndex(function (element) {
          return element.Id == j.Id;
        })

        // Si ya existe el elemento seleccionado, no lo agregará
        alreadySelected == -1 ? item.ValorObjeto.push(j) : '';
      };

      ctrl.actionRemoveOnClick = function (j, item) {
        item.ValorObjeto = item.ValorObjeto.filter(function (item) {
          return item.Id != j.Id;
        });
        item.SourceObjeto.push(j);
        item.SourceObjetoTemp.push(j);
        // item.SourceObjetoTemp = item.SourceObjeto;
        // item.TextoBusqueda = "";
      };

      ctrl.actionRemoveOnClickTableEnr = function (j, item) {
        // Este metodo hace lo mismo que el actionRemoveOnClick, pero se separó por si la lógica del TableEnr es necesario cambiarla
        item.ValorObjeto = item.ValorObjeto.filter(function (item) {
          return item.Id != j.Id;
        });
        item.SourceObjeto.push(j);
        item.SourceObjetoTemp.push(j);
        // item.SourceObjetoTemp = item.SourceObjeto;
        // item.TextoBusqueda = "";
      };

      function loadView(authData) {
        ctrl.isProcesoUsuarioSearching = true;
        ctrl.getParametrosByIdent($stateParams.template);
        dataService.getProcesoUsuarioListByProceso($stateParams.proceso).then(
          function (response) {
            if (response.data.Success) {
              var usuarios = response.data.Value;
              ctrl.procesoUsuariosList = [];
              //Carga de usuarios del proceso
              if (usuarios != null && usuarios.length > 0) {
                var index;

                for (var i = 0; i < usuarios.length; i++) {
                  index = -1;

                  for (var x = 0; x < ctrl.procesoUsuariosList.length; x++) {
                    if (
                      ctrl.procesoUsuariosList[x].Usuario.Id ==
                      usuarios[i].Usuario.Id
                    ) {
                      index = x;
                      break;
                    }
                  }

                  if (index < 0) {
                    ctrl.procesoUsuariosList.push({
                      Usuario: usuarios[i].Usuario,
                      RolProcesoList: [],
                    });
                    index = ctrl.procesoUsuariosList.length - 1;
                  }

                  //Existe el usuario
                  ctrl.procesoUsuariosList[index].RolProcesoList.push(
                    usuarios[i].RolProceso
                  );
                }
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isProcesoUsuarioSearching = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isProcesoUsuarioSearching = false;
          }
        );

        dataService
          .getRolTemplateByProcesoTemplateUsuario(
            $stateParams.solicitud,
            $stateParams.procesoTemplate,
            authData.Id
          )
          .then(
            function (response) {
              if (response.data.Success) {
                ctrl.rolTemplateList = response.data.Value;

                //Si tiene roles en el template/gestion, puede continuar con la carga
                if (
                  ctrl.rolTemplateList != null &&
                  ctrl.rolTemplateList.length > 0
                ) {
                  ctrl.anularVista = false;
                } else {
                  //Si no tiene roles asignados en el template/gestion, solo el sysadmin puede hacer algo
                  ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
                }

                // console.log(ctrl.anularVista);
                if (ctrl.anularVista) {
                  // console.log("Entro aca.. 2");
                  ctrl.viewLoading = false;

                  if (ctrl.language == "español") {
                    ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre esta gestión.';
                  } else if (ctrl.language == "ingles") {
                    ctrl.motivoBloqueo = 'You do not have permissions to view or perform actions on this management.';
                  } else if (ctrl.language == "portugues") {
                    ctrl.motivoBloqueo = 'Não tem permissões para visualizar ou realizar ações sobre esta gestão.';
                  } else if (ctrl.language == "italiano") {
                    ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre esta gestión.';
                  }

                  return;
                }

                ctrl.isCamposLoading = true;
                ctrl.soloLectura = 1;

                dataService
                  .getSolicitudCampoValorProcesoTemplate(
                    $stateParams.solicitud,
                    $stateParams.procesoTemplate
                  )
                  .then(
                    function (response) {
                      if (response.data.Success) {
                        // console.log("******getSolicitudCampoValorProcesoTemplate***");
                        ctrl.valoresCampoSolicitudList = response.data.Value;
                        // console.log(ctrl.valoresCampoSolicitudList);
                        if (ctrl.valoresCampoSolicitudList != null) {
                          for (var i = 0; i < ctrl.valoresCampoSolicitudList.length; i++) {
                            loadCampoDataSolicitudList(ctrl.valoresCampoSolicitudList[i], i);
                          }
                        }
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    },
                    function (error) {
                      toastr.error(
                        error.data || sharedService.getGenericErrorMessage(error)
                      );
                    }
                  );

                //Verificar los permisos
                if ($stateParams.solicitudProcesoTemplate > 0) {
                  // console.log("solicitudProcesoTemplate***");
                  //Si es una edicion, verificar que tenga permisos de edicion
                  ctrl.solicitudProcesoTemplateId = $stateParams.solicitudProcesoTemplate;

                  dataService.getSolicitudProcesoTemplateById($stateParams.solicitudProcesoTemplate)
                    .then(function (response) {
                      if (response.data.Success) {
                        var solicitudProcesoTemplate = response.data.Value;
                        // console.log(solicitudProcesoTemplate);
                        ctrl.template = solicitudProcesoTemplate.ProcesoTemplate.Template;
                        ctrl.puedeBorrarTemplate = puedeBorrarTemplate(
                          solicitudProcesoTemplate.Solicitud,
                          ctrl.rolTemplateList
                        );
                        ctrl.verTemplate = puedeverTemplate(
                          solicitudProcesoTemplate.Solicitud,
                          solicitudProcesoTemplate.SolicitudEstado,
                          ctrl.rolTemplateList,
                          solicitudProcesoTemplate.UsuarioCreacionId,
                          authData.Id
                        );
                        ctrl.solicitud = solicitudProcesoTemplate.Solicitud;
                        ctrl.soloLectura = !puedeEditarTemplate(
                          solicitudProcesoTemplate.Solicitud,
                          solicitudProcesoTemplate.SolicitudEstado,
                          ctrl.rolTemplateList,
                          solicitudProcesoTemplate.UsuarioCreacionId,
                          authData.Id,
                          solicitudProcesoTemplate
                        );
                        $scope.readonly = ctrl.soloLectura;
                        if (ctrl.solicitudProcesoTemplateId != 0) {
                          ctrl.listaUsuariosDerivar();
                          ctrl.userInGroup(
                            ctrl.template.gUsuariosAutorizaA,
                            authData.Id,
                            function (resultado) {
                              // console.log("ingreso a la funcion A");
                              // console.log("resultado ", resultado);
                              ctrl.allowToAutoriceA = resultado;
                              // console.log(ctrl.allowToAutoriceA);
                            }
                          );
                          ctrl.userInGroup(
                            ctrl.template.gUsuariosAutorizaB,
                            authData.Id,
                            function (resultado) {
                              // console.log("ingreso a la funcion B");
                              // console.log("resultado ", resultado);
                              ctrl.allowToAutoriceB = resultado;
                              // console.log(ctrl.allowToAutoriceB);
                            }
                          );
                        }
                        getCamposData(authData);
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    },
                      function (error) {
                        toastr.error(
                          error.data || sharedService.getGenericErrorMessage(error)
                        );
                      }
                    );
                } else {
                  //Si es una carga nueva, verificar que tenga permisos de creacion

                  ctrl.isNew = true;

                  dataService.getSolicitudById($stateParams.solicitud)
                    .then(function (response) {
                      if (response.data.Success) {
                        ctrl.solicitud = response.data.Value;
                        //Si tiene roles y el template/gestion es nuevo, verifico si puede crearlo
                        if (
                          puedeCrearTemplate(
                            ctrl.solicitud,
                            ctrl.rolTemplateList
                          )
                        ) {
                          ctrl.soloLectura = 0;
                          getCamposData(authData);
                        } else {
                          // console.log("entro a este.. ");
                          ctrl.soloLectura = 1;
                          ctrl.anularVista = true;
                          ctrl.viewLoading = false;

                          if (ctrl.language == "español") {
                            ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre esta gestión.';
                          } else if (ctrl.language == "ingles") {
                            ctrl.motivoBloqueo = 'You do not have permissions to view or perform actions on this management.';
                          } else if (ctrl.language == "portugues") {
                            ctrl.motivoBloqueo = 'Não tem permissões para visualizar ou realizar ações sobre esta gestão.';
                          } else if (ctrl.language == "italiano") {
                            ctrl.motivoBloqueo = 'No tiene permisos para visualizar o realizar acciones sobre esta gestión.';
                          }

                          return;
                        }
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    },
                      function (error) {
                        toastr.error(
                          error.data || sharedService.getGenericErrorMessage(error)
                        );
                      }
                    );
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
      }


      function getCamposData(authData) {
        if (ctrl.soloLectura == 0) {
          dataService.getCampoValorCompleto(
            $stateParams.solicitudProcesoTemplate,
            $stateParams.solicitud,
            $stateParams.solicitudEstado,
            $stateParams.procesoTemplate,
            $stateParams.template
          )
            .then(
              function (response) {
                if (response.data.Success) {
                  // console.log("getCampoValorCompleto***");
                  ctrl.camposList = response.data.Value;
                  // ctrl.camposListTemplate = response.data.Value;

                  if (ctrl.language == "español")
                    ctrl.title = "Carga de Gestión: ";
                  else if (ctrl.language == "ingles")
                    ctrl.title = "Management Load: ";
                  else if (ctrl.language == "portugues")
                    ctrl.title = "Carga da Gestão: ";
                  else if (ctrl.language == "italiano")
                    ctrl.title = "Carga de Gestión: ";

                  ctrl.title = ctrl.title + ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.Nombre;

                  ctrl.tituloCampoValor = ctrl.camposList[0].SolicitudProcesoTemplate.Resumen;
                  // console.log("LLEGARON LOS DATOS DEL CAMPO!!!!");
                  // console.log(ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template);
                  ctrl.template = ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template;
                  ctrl.SolicitudProcesoTemplate = ctrl.camposList[0].SolicitudProcesoTemplate;

                  // Recuperando la config del template cuando es ENVIO_EMAIL (TipoTemplateId: 2)
                  if (ctrl.SolicitudProcesoTemplate.ProcesoTemplate.Template.TipoTemplateId == 2) {
                    dataService.getTipoTemplateEnvioMailConfiguracion($stateParams.template)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoEnvioMailConfig = response.data.Value;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      });
                  }

                  initAutoSaveCounter();

                  for (var i = 0; i < ctrl.camposList.length; i++) {
                    loadCampoData(ctrl.camposList[i], i);
                  } //for
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              }
            );
        } else {
          //Datos de solo lectura
          dataService
            .getCampoValorTextosCompleto(
              $stateParams.solicitudProcesoTemplate,
              $stateParams.solicitud,
              $stateParams.solicitudEstado,
              $stateParams.procesoTemplate,
              $stateParams.template
            )
            .then(
              function (response) {
                if (response.data.Success) {
                  ctrl.camposList = response.data.Value;
                  // console.log("*******getCampoValorTextosCompleto");
                  // console.log(ctrl.camposList);

                  if (ctrl.language == "español")
                    ctrl.title = "Carga de Gestión: ";
                  else if (ctrl.language == "ingles")
                    ctrl.title = "Management Load: ";
                  else if (ctrl.language == "portugues")
                    ctrl.title = "Carga da Gestão: ";
                  else if (ctrl.language == "italiano")
                    ctrl.title = "Carga de Gestión: ";

                  ctrl.title = ctrl.title + ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.Nombre;
                  ctrl.tituloCampoValor = ctrl.camposList[0].SolicitudProcesoTemplate.Resumen;

                  for (var i = 0; i < ctrl.camposList.length; i++) {
                    loadCampoDataReadOnly(i, ctrl.camposList[i].Campo.CampoTipo);
                    if (ctrl.camposList[i].Campo.Nombre.endsWith('*') && ctrl.camposList[i].Valor.length <= 0) {
                      // console.log(ctrl.camposList[i]);
                      // console.log("ESTE CAMPO ES OBLIGATORIO Y LLEGO!!!!");
                      for (var j = 0; j < ctrl.rolTemplateList.length; j++) {
                        //Si es creador, puede editar solo cuando existan campos Obligatorios sin llenar.
                        if (ctrl.rolTemplateList[j].Codigo == "CREADOR") {
                          ctrl.soloLectura = false;
                          break;
                        }
                      }
                    }
                  } //for
                } else {
                  toastr.error(response.data.ErrorSummary);
                }
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              },
              function (error) {
                toastr.error(
                  error.data || sharedService.getGenericErrorMessage(error)
                );
                ctrl.isCamposLoading = false;
                ctrl.viewLoading = false;
              }
            );
        }
      }

      ctrl.AutorizarActionTemplate = function (tipoAutorizacion) {
        var authData = sharedService.getLoggedUser();
        // console.log("FUNCION DE AUTORIAZAR");
        // console.log(ctrl.AutorizarMsg);
        // console.log(ctrl.model);
        if (ctrl.AutorizarMsg == undefined || ctrl.AutorizarMsg == "") {
          // console.log("MNENSAJE ES NULL");
          var titleComment;
          if (ctrl.language == "español")
            titleComment = "Debe ingresar comentario.";
          else if (ctrl.language == "ingles")
            titleComment = "You must enter a comment.";
          else if (ctrl.language == "portugues")
            titleComment = "Deve inserir comentário";
          else if (ctrl.language == "italiano")
            titleComment = "Debe ingresar comentario.";

          Swal.fire({
            title: titleComment,
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: ctrl.acceptText,
            heightAuto: false,
          }).then(function (result) { });
          return;
        }

        var obj = {
          UsuarioId: authData.Id,
          SolicitudId: ctrl.solicitud.Id,
          EtapaId: ctrl.model.EstadoId,
          Comentario: ctrl.AutorizarMsg,
          EtapaNombre: ctrl.model.SolicitudEtapaNombre,
          TipoAutorizacion: tipoAutorizacion,
          templateId: $stateParams.solicitudProcesoTemplate
        };
        sharedService.showLoading();
        dataService.guardarAutorizacionTemplate(obj).then(
          function (response) {
            if (response.data.Success) {
              var titleAuthorization;

              if (ctrl.language == "español")
                titleAuthorization = "Autorización Guardada Correctamente.";
              else if (ctrl.language == "ingles")
                titleAuthorization = "Authorization Saved Successfully.";
              else if (ctrl.language == "portugues")
                titleAuthorization = "Autorização Salva com Sucesso.";
              else if (ctrl.language == "italiano")
                titleAuthorization = "Autorización Guardada Correctamente.";

              Swal.fire({
                title: titleAuthorization,
                type: "success",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: ctrl.acceptText,
                heightAuto: false,
              }).then(function (result) {
                //.then((result) => {
                sharedService.closeLoading();
                $state.reload();
                //listarAutorizadasEtapa();
              });
              // console.log("RESPONSE WEBSERVICE OK");
            } else {
              // console.log("USUARIO YA AUTORIZCO O ES FALSEE");
              sharedService.closeLoading();
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            sharedService.closeLoading();
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      };

      function loadCampoDataSolicitudList(item, i) {
        if (item == null || item.Campo == null || item.Campo.CampoTipo == null)
          return;

        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        switch (item.Campo.CampoTipo.Codigo) {
          case "PROCEDURE":
            ctrl.solicitudHasProceduresField = true;
            break;
          case "INT":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "DECIMAL":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "DATE":
            ctrl.valoresCampoSolicitudList[
              i
            ].ValorObjeto = sharedService.formatDate(
              ctrl.valoresCampoSolicitudList[i].ValorObjeto
            );
            break;

          case "JERARQ":
            if (
              ctrl.valoresCampoSolicitudList[i].ValorObjeto != null &&
              ctrl.valoresCampoSolicitudList[i].ValorObjeto.length > 0
            ) {
              for (
                var k = 0;
                k < ctrl.valoresCampoSolicitudList[i].ValorObjeto.length;
                k++
              ) {
                if (ctrl.valoresCampoSolicitudList[i].ValorObjeto[k] != null)
                  ctrl.valoresCampoSolicitudList[i].ValorObjeto[k].ValorInput =
                    ctrl.valoresCampoSolicitudList[i].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.valoresCampoSolicitudList[i].ValorObjeto == null)
                ctrl.valoresCampoSolicitudList[i].ValorObjeto = [];

              ctrl.valoresCampoSolicitudList[i].ValorObjeto.push({
                JerarquiaPadreId:
                  ctrl.valoresCampoSolicitudList[i].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: placeholderText,
              });
              loadJerarquiaPlaceholder(
                ctrl.valoresCampoSolicitudList[i].Campo.JerarquiaId,
                i,
                ctrl.valoresCampoSolicitudList[i].ValorObjeto.length - 1
              );
            }
            break;
          case "TABLE":
          case "TABLEENR":
            // Si encuentra un campo tipo TABLEENR
            ctrl.camposTableEnr.push({ // guarda que lo encontró
              index: i, // guarda el index en el ctrl.camposList
              Id: null,
              Campo: null,
              TablaFilas: null,
              SolicitudId: null,
              SolicitudProcesoTemplateId: null
            });
            loadTablaCampoSolicitud(i);
            break;
          case "COND":
            loadTablaCampoSolicitud(i);
            break;
        }
      }

      function loadCampoData(item, i) {
        if (item == null || item.Campo == null || item.Campo.CampoTipo == null)
          return;

        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        switch (item.Campo.CampoTipo.Codigo) {
          case "PROCEDURE":
            ctrl.solicitudHasProceduresField = true;
            if (ctrl.template.generaProcesosRelacionados) {
              ctrl.generaProcesoRelacionados = true; // setea el valor en true en caso de que el template tenga en true la propiedad "generaProcesosRelacionados"
            }
            break;
          case "INT":
            ctrl.camposList[i].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "DECIMAL":
            ctrl.camposList[i].ValorObjeto = sharedService.addThousandSeparator(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "DATE":
            ctrl.camposList[i].ValorObjeto = sharedService.formatDate(
              ctrl.camposList[i].ValorObjeto
            );
            break;

          case "JERARQ":
            if (
              ctrl.camposList[i].ValorObjeto != null &&
              ctrl.camposList[i].ValorObjeto.length > 0
            ) {
              for (var k = 0; k < ctrl.camposList[i].ValorObjeto.length; k++) {
                if (ctrl.camposList[i].ValorObjeto[k] != null)
                  ctrl.camposList[i].ValorObjeto[k].ValorInput =
                    ctrl.camposList[i].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.camposList[i].ValorObjeto == null)
                ctrl.camposList[i].ValorObjeto = [];

              ctrl.camposList[i].ValorObjeto.push({
                JerarquiaPadreId: ctrl.camposList[i].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: placeholderText,
              });
              loadJerarquiaPlaceholder(
                ctrl.camposList[i].Campo.JerarquiaId,
                i,
                ctrl.camposList[i].ValorObjeto.length - 1
              );
            }
            break;
          case "TEMPLATE":
            // console.log("LLEGO DATOS DE TIPOI TEMPLATE!!!!");
            // console.log("TEMPLATE ES:!");
            // console.log(ctrl.template);
            if (ctrl.template.isSoloEnvio) {
              // console.log(" LLEGO EN TRUE!!");
              // console.log(ctrl.SolicitudProcesoTemplate.ProcesoTemplateId);
              item.ValorObjeto = { Id: ctrl.SolicitudProcesoTemplate.ProcesoTemplateId }
            }
            break;
          case "TABLE":
          case "TABLEENR":
            // Si encuentra un campo tipo TABLEENR
            ctrl.camposTableEnr.push({ // guarda que lo encontró
              index: i, // guarda el index en el ctrl.camposList
              Id: null,
              Campo: null,
              TablaFilas: null,
              SolicitudId: null,
              SolicitudProcesoTemplateId: null
            });
            loadTablaCampo(i);
            break;
          case "COND":
            loadTablaCampo(i);
            break;
        }
      }

      function loadTablaCampoSolicitud(index) {
        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        if (
          ctrl.valoresCampoSolicitudList[index].Valor != null &&
          ctrl.valoresCampoSolicitudList[index].Valor.length > 0
        ) {
          ctrl.valoresCampoSolicitudList[index].TablaFilas = [];
          var valorFilas = ctrl.valoresCampoSolicitudList[index].Valor.split(
            "^"
          );

          if (valorFilas != null && valorFilas.length > 0) {
            for (var k = 0; k < valorFilas.length; k++) {
              ctrl.valoresCampoSolicitudList[index].TablaFilas.push({
                Valor: [],
              });
              var valorColumnas = valorFilas[k].split("~");

              if (valorColumnas != null && valorColumnas.length > 0) {
                for (var h = 0; h < valorColumnas.length; h++) {
                  switch (
                  ctrl.valoresCampoSolicitudList[index].Campo.Columnas[h]
                    .ColumnaCampo.CampoTipo.Codigo
                  ) {
                    case "INT":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "DECIMAL":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "BOOL":
                      if (valorColumnas[h] == "true" || valorColumnas[h] == "1")
                        valorColumnas[h] = true;
                      else valorColumnas[h] = false;
                      break;
                    case "DATE":
                      valorColumnas[h] = sharedService.formatDate(
                        valorColumnas[h]
                      );
                      break;
                    case 'DATETIMEREGIONAL':
                      // Manejo de un DATETIMEREGIONAL agregado el 04/09/2024

                      // valorColumnas[h] = sharedService.formatDate(valorColumnas[h]);
                      if (!valorColumnas[h])
                        valorColumnas[h] = ctrl.camposList[index].Campo.Columnas[h].ValorObjeto;

                      break;
                    case 'JERARQ':
                      // console.log("ENTRO A JERARQUIAS EN TABLEENR LOADTABLACAMPOSOLICITUD");
                      // Manejo de una jerarquia agregada el 04/09/2024
                      if (valorColumnas[h] && valorColumnas[h] != null && valorColumnas[h].length > 0) {
                        valorColumnas[h] = JSON.parse(valorColumnas[h]);
                        for (var l = 0; l < valorColumnas[h].length; l++) {
                          if (valorColumnas[h][l] != null)
                            valorColumnas[h][l].ValorInput = valorColumnas[h][l].Nombre;
                        }
                      } else {
                        if (!valorColumnas[h])
                          valorColumnas[h] = [];

                        valorColumnas[h].push({
                          JerarquiaPadreId: ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId,
                          LoadingJerarquia: false,
                          NoResults: false,
                          Placeholder: placeholderText
                        });
                        loadJerarquiaPlaceholderTableEnr(ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId, index, k, h, valorColumnas[h].length - 1);
                      }
                      break;
                    case 'MULTI_LIST':
                      // Manejo de un MULTI_LIST agregado el 05/09/2024
                      if (valorColumnas[h]) {
                        valorColumnas[h] = JSON.parse(valorColumnas[h]);
                      } else {
                        valorColumnas[h] = {
                          SourceObjeto: ctrl.camposList[index].Campo.Columnas[h].SourceObjeto,
                          ValorObjeto: [],
                        }
                      }
                      // console.log(valorColumnas[h]);
                      break;
                    default:
                      break;
                  }
                  ctrl.valoresCampoSolicitudList[index].TablaFilas[
                    k
                  ].Valor.push(valorColumnas[h]);
                }
              }
            }
          }
        }
      }

      function loadCampoDataReadOnly(index, campoTipo) {
        if (campoTipo == null || campoTipo.Codigo == null) return;

        if (index < 0) return;

        if (ctrl.camposList[index] == null) return;

        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        switch (campoTipo.Codigo) {
          case "INT":
            ctrl.camposList[index].Valor = sharedService.addThousandSeparator(
              ctrl.camposList[index].Valor
            );
            break;

          case "DECIMAL":
            ctrl.camposList[index].Valor = sharedService.addThousandSeparator(
              ctrl.camposList[index].Valor
            );
            break;

          case "TABLE":
          case "TABLEENR":
            loadTablaCampo(index);
            break;

          case "JERARQ":
            if (
              ctrl.camposList[index].ValorObjeto != null &&
              ctrl.camposList[index].ValorObjeto.length > 0
            ) {
              for (
                var k = 0;
                k < ctrl.camposList[index].ValorObjeto.length;
                k++
              ) {
                if (ctrl.camposList[index].ValorObjeto[k] != null)
                  ctrl.camposList[index].ValorObjeto[k].ValorInput =
                    ctrl.camposList[index].ValorObjeto[k].Nombre;
              }
            } else {
              if (ctrl.camposList[index].ValorObjeto == null)
                ctrl.camposList[index].ValorObjeto = [];

              ctrl.camposList[index].ValorObjeto.push({
                JerarquiaPadreId: ctrl.camposList[index].Campo.JerarquiaId,
                LoadingJerarquia: false,
                NoResults: false,
                Placeholder: placeholderText,
              });
              loadJerarquiaPlaceholder(
                ctrl.camposList[index].Campo.JerarquiaId,
                index,
                ctrl.camposList[index].ValorObjeto.length - 1
              );
            }
            break;

          case "COND":
            loadTablaCampo(index);
            break;
        } //switch
      }

      ctrl.concatRolesString = function (values) {
        return values
          .map(function (elem) {
            if (elem != null) return elem.Nombre;
            return "";
          })
          .join(", ");
      };

      function puedeverTemplate(
        solicitud,
        estadoCargaTemplate,
        rolesList,
        usuarioCreacionId,
        loggedUserId
      ) {
        if (sharedService.isSysAdminLoggedUser()) return true;
        var puedeVerTem = true;
        for (var i = 0; i < rolesList.length; i++) {
          if (rolesList[i].Codigo == "NONE") {
            puedeVerTem = false;
            break;
          }
        }
        return puedeVerTem;
      }

      function puedeEditarTemplate(
        solicitud,
        estadoCargaTemplate,
        rolesList,
        usuarioCreacionId,
        loggedUserId,
        solicitudProcesoTemplate
      ) {
        // console.log("ingreso a puedeEditarTemplate");
        // console.log("ASA!!!!");
        // console.log(solicitud);
        // console.log($stateParams.procesoTemplate);
        // console.log(
        //   solicitudProcesoTemplate.ProcesoTemplate.Template
        //     .PermiteEditarTemplate
        // );
        //PermiteEditarTemplate

        //No puede hacer nada si la solicitud se aprobo o cerro
        if (
          solicitud != null &&
          (solicitud.Estado.Codigo == "APRO" ||
            solicitud.Estado.Codigo == "CERR")
        )
          return false;

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeEditar = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (
            rolesList[i].Codigo == "ADMIN" ||
            rolesList[i].Codigo == "SUPERV"
          ) {
            puedeEditar = true;
            break;
          }

          //Si es creador, puede editar solo cuando no se haya avanzado la solicitud
          if (
            rolesList[i].Codigo == "CREADOR" &&
            usuarioCreacionId == loggedUserId
          ) {
            if (estadoCargaTemplate == null) {
              puedeEditar = true;
              break;
            } else {
              if (estadoCargaTemplate.Id == solicitud.Estado.Id) {
                puedeEditar = true;
                break;
              }
            }
          }
        }

        if (
          puedeEditar &&
          solicitudProcesoTemplate.ProcesoTemplate.Template
            .PermiteEditarTemplate
        ) {
          puedeEditar = true;
        } else {
          puedeEditar = false;
        }
        return puedeEditar;
      }

      function puedeCrearTemplate(solicitud, rolesList) {
        // console.log(solicitud);
        if (solicitud != null) {
          ctrl.lProcesoIsDocumental = solicitud.Proceso.isDocumental;
        }

        // Logica removida el 05/05/2024 a fin de cargar un template cuando cualquier solicitud esté cerrada
        // ***********************************************
        //No puede hacer nada si la solicitud se aprobo o cerro
        // if (
        //   solicitud != null &&
        //   (solicitud.Estado.Codigo == "APRO" ||
        //     solicitud.Estado.Codigo == "CERR") &&
        //   !ctrl.lProcesoIsDocumental
        // ) {
        //   // console.log("entro..");
        //   return false;
        // }

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeCrear = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (
            rolesList[i].Codigo == "CREADOR" ||
            rolesList[i].Codigo == "ADMIN" ||
            rolesList[i].Codigo == "SUPERV"
          ) {
            puedeCrear = true;
            break;
          }
        }

        return puedeCrear;
      }

      function puedeBorrarTemplate(solicitud, rolesList) {
        //No puede hacer nada si la solicitud se aprobo o cerro
        if (
          solicitud != null &&
          (solicitud.Estado.Codigo == "APRO" ||
            solicitud.Estado.Codigo == "CERR")
        )
          return false;

        if (sharedService.isSysAdminLoggedUser()) return true;

        var puedeBorrar = false;

        for (var i = 0; i < rolesList.length; i++) {
          if (rolesList[i].Codigo == "ADMIN") {
            puedeBorrar = true;
            break;
          }
        }

        return puedeBorrar;
      }

      function loadTablaCampo(index) {
        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        if (
          ctrl.camposList[index].Valor != null &&
          ctrl.camposList[index].Valor.length > 0
        ) {
          ctrl.camposList[index].TablaFilas = [];
          var valorFilas = ctrl.camposList[index].Valor.split("^");

          if (valorFilas != null && valorFilas.length > 0) {
            for (var k = 0; k < valorFilas.length; k++) {
              ctrl.camposList[index].TablaFilas.push({
                Valor: [],
              });
              var valorColumnas = valorFilas[k].split("~");

              if (valorColumnas != null && valorColumnas.length > 0) {
                for (var h = 0; h < valorColumnas.length; h++) {
                  switch (
                  ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo
                    .CampoTipo.Codigo
                  ) {
                    case "INT":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;

                    case "DECIMAL":
                      valorColumnas[h] = sharedService.addThousandSeparator(
                        valorColumnas[h]
                      );
                      break;
                    case "BOOL":
                      if (valorColumnas[h] == "true" || valorColumnas[h] == "1")
                        valorColumnas[h] = true;
                      else valorColumnas[h] = false;
                      break;

                    case "DATE":
                      valorColumnas[h] = sharedService.formatDate(
                        valorColumnas[h]
                      );
                      break;
                    case 'DATETIMEREGIONAL':
                      // Manejo de un DATETIMEREGIONAL agregado el 04/09/2024

                      // valorColumnas[h] = sharedService.formatDate(valorColumnas[h]);
                      if (!valorColumnas[h])
                        valorColumnas[h] = ctrl.camposList[index].Campo.Columnas[h].ValorObjeto;

                      break;
                    case 'JERARQ':
                      // Manejo de una jerarquia agregada el 04/09/2024
                      // console.log("ENTRO A JERARQUIA TABLEENR LOADTABLACAMPO");
                      if (valorColumnas[h] && valorColumnas[h] != null && valorColumnas[h].length > 0) {
                        valorColumnas[h] = JSON.parse(valorColumnas[h]);
                        for (var l = 0; l < valorColumnas[h].length; l++) {
                          if (valorColumnas[h][l] != null)
                            valorColumnas[h][l].ValorInput = valorColumnas[h][l].Nombre;
                        }
                      } else {
                        if (!valorColumnas[h])
                          valorColumnas[h] = [];

                        valorColumnas[h].push({
                          JerarquiaPadreId: ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId,
                          LoadingJerarquia: false,
                          NoResults: false,
                          Placeholder: placeholderText
                        });
                        loadJerarquiaPlaceholderTableEnr(ctrl.camposList[index].Campo.Columnas[h].ColumnaCampo.JerarquiaId, index, k, h, valorColumnas[h].length - 1);
                      }
                      break;
                    case 'MULTI_LIST':
                      // Manejo de un MULTI_LIST agregado el 05/09/2024
                      if (valorColumnas[h]) {
                        valorColumnas[h] = JSON.parse(valorColumnas[h]);
                      } else {
                        valorColumnas[h] = {
                          SourceObjeto: ctrl.camposList[index].Campo.Columnas[h].SourceObjeto,
                          ValorObjeto: [],
                        }
                      }
                      // console.log(valorColumnas[h]);
                      break;
                    case 'LIST':
                      valorColumnas[h] = { "Id": valorColumnas[h] }
                      break;
                    case 'USER':
                      // console.log(valorColumnas[h]);
                      if (valorColumnas[h] != null && valorColumnas[h].length > 0) {
                        valorColumnas[h] = JSON.parse(valorColumnas[h]);
                      }
                      break;
                    default:
                      break;
                  }
                  ctrl.camposList[index].TablaFilas[k].Valor.push(
                    valorColumnas[h]
                  );
                }
              }
            }
          }
        }
      }

      function loadJerarquiaPlaceholder(
        jerarquiaPadreId,
        campoIndex,
        jerarquiaIndex
      ) {
        dataService.getJerarquiaMuestra(jerarquiaPadreId, 2).then(
          function (response) {
            if (response.data.Success) {
              var ph = "";

              var placeholderText;

              if (ctrl.language == "español")
                placeholderText = "Ejemplo: ";
              else if (ctrl.language == "ingles")
                placeholderText = "Example: ";
              else if (ctrl.language == "portugues")
                placeholderText = "Exemplo: ";
              else if (ctrl.language == "italiano")
                placeholderText = "Ejemplo: ";

              if (response.data.Value != null) {
                if (response.data.Value.length > 0)
                  ph = placeholderText + response.data.Value[0].Nombre;

                if (response.data.Value.length > 1)
                  ph = ph + ", " + response.data.Value[1].Nombre;
              }

              ctrl.camposList[campoIndex].ValorObjeto[
                jerarquiaIndex
              ].Placeholder = ph;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      }

      ctrl.searchJerarquia = function (nombreJerarquia, padreId) {
        if (!(/[A-Za-z\s\-_0-9]/g.test(nombreJerarquia))) {
          var errorText;

          if (ctrl.language == "español")
            errorText = 'El carácter no es válido, revíselo e intente nuevamente';
          else if (ctrl.language == "ingles")
            errorText = 'Invalid character, please check and try again.';
          else if (ctrl.language == "portugues")
            errorText = 'O caractere não é válido, revise e tente novamente';
          else if (ctrl.language == "italiano")
            errorText = 'El carácter no es válido, revíselo e intente nuevamente';

          toastr.error(errorText);
          return;
        }
        return dataService
          .searchJerarquiaByPadre(nombreJerarquia, padreId)
          .then(
            function (response) {
              if (response.data.Success) {
                return response.data.Value;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
      };

      ctrl.altaNuevaJerarquia = function (campoIndex, jerarquiaIndex) {
        ctrl.isBusy = true;
        var jerarquiaPadre = {};
        var confirmationTitle;

        if (ctrl.language == "español")
          confirmationTitle = "Alta de Nueva Jerarquía";
        else if (ctrl.language == "ingles")
          confirmationTitle = "New Hierarchy Registration";
        else if (ctrl.language == "portugues")
          confirmationTitle = "Cadastro de Nova Hierarquia";
        else if (ctrl.language == "italiano")
          confirmationTitle = "Alta de Nueva Jerarquía";

        if (jerarquiaIndex > 0)
          jerarquiaPadre =
            ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex - 1];
        else
          jerarquiaPadre = {
            Id:
              ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex]
                .JerarquiaPadreId,
            Nombre: "",
          };

        var confirmation = $uibModal.open({
          animation: true,
          component: "altaJerarquia",
          resolve: {
            title: function () {
              return confirmationTitle;
            },
            JerarquiaPadre: function () {
              return jerarquiaPadre;
            },
          },
        });

        confirmation.result.then(
          function (returnValue) {
            ctrl.isBusy = false;
            ctrl.onSelectJerarquia(campoIndex, jerarquiaIndex, returnValue);
          },
          function () {
            ctrl.isBusy = false;
          }
        );
      };

      ctrl.onSelectJerarquia = function (
        campoIndex,
        jerarquiaIndex,
        jerarquiaSeleccionada
      ) {
        if (jerarquiaSeleccionada == null) return;

        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        if (campoIndex >= 0) {
          if (
            jerarquiaSeleccionada.Detalles != null &&
            jerarquiaSeleccionada.Detalles.length > 0
          )
            jerarquiaSeleccionada.Detalles.sort(function (a, b) {
              return parseInt(a.Orden) > parseInt(b.Orden)
                ? 1
                : parseInt(b.Orden) > parseInt(a.Orden)
                  ? -1
                  : 0;
            });

          ctrl.camposList[campoIndex].ValorObjeto[
            jerarquiaIndex
          ] = jerarquiaSeleccionada;
          ctrl.camposList[campoIndex].ValorObjeto[jerarquiaIndex].ValorInput =
            jerarquiaSeleccionada.Nombre;

          //Borrado de todas las jerarquias posteriores a la actual
          ctrl.camposList[campoIndex].ValorObjeto.splice(
            jerarquiaIndex + 1,
            ctrl.camposList[campoIndex].ValorObjeto.length - jerarquiaIndex - 1
          );
          ctrl.camposList[campoIndex].Valor = jerarquiaSeleccionada.Id; //Fixin jerarquia Templates.
        }

        dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id).then(
          function (response) {
            if (response.data.Success) {
              if (response.data.Value == true) {
                ctrl.camposList[campoIndex].ValorObjeto.push({
                  ValorInput: null,
                  JerarquiaPadreId: jerarquiaSeleccionada.Id,
                  LoadingJerarquia: false,
                  NoResults: false,
                  Placeholder: placeholderText,
                });

                loadJerarquiaPlaceholder(
                  jerarquiaSeleccionada.Id,
                  campoIndex,
                  ctrl.camposList[campoIndex].ValorObjeto.length - 1
                );
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      };

      ctrl.searchCampoUsuario = function (nombreUsuario) {
        // console.log("nombreUsuario : " + nombreUsuario);
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        return dataService.searchUsuario(filtroUsuario).then(
          function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          }
        );
      };

      ctrl.onSelectUsuarioMultiList = function (
        campoIndex,
        usuarioSeleccionado
      ) {
        if (usuarioSeleccionado == null) return;

        if (campoIndex >= 0) {
          if (ctrl.camposList[campoIndex].ValorObjeto == null)
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (
            var k = 0;
            k < ctrl.camposList[campoIndex].ValorObjeto.length;
            k++
          ) {
            if (
              ctrl.camposList[campoIndex].ValorObjeto[k].Id ==
              usuarioSeleccionado.Id
            ) {
              ctrl.usuarioCargado = null;
              return;
            }
          }

          ctrl.camposList[campoIndex].ValorObjeto.push(usuarioSeleccionado);
          // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
          //                                                                                 return elem.Id;
          //                                                                               }).join("|");
          ctrl.usuarioCargado = null;
        }
      };

      ctrl.deleteCampoUsuario = function (campoIndex, usuarioId) {
        if (ctrl.camposList[campoIndex].ValorObjeto == null) return;

        for (
          var k = 0;
          k < ctrl.camposList[campoIndex].ValorObjeto.length;
          k++
        ) {
          if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
            ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
            return;
          }
        }

        // ctrl.camposList[campoIndex].Valor = ctrl.camposList[campoIndex].ValorObjeto.map(function(elem){
        //                                                                                   return elem.Id;
        //                                                                                 }).join("|");
      };

      ctrl.onChangeInputTable = function (
        indexCampo,
        indexFila,
        indexColumna,
        valor
      ) {
        // console.log("Campo : " + indexCampo);
        // console.log("Fila : " + indexFila);
        // console.log("Columna : " + indexColumna);
        // console.log(ctrl.camposList[indexCampo]);
        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[
          indexColumna
        ] = valor;
      };

      ctrl.openAttachment = function (fileName) {
        var usuarioLogueadoId = authData.Id;
        var fullUrl = appConfig.uploadUrl + fileName;
        sharedService.openVisorDocumental(usuarioLogueadoId, fullUrl);
        // window.open(appConfig.uploadUrl + fileName);
      };

      ctrl.getParametrosByIdent = function (Ident) {
        if (Ident != "") {
          dataService.obtenerParametrosByIdent(Ident).then(function (response) {
            if (response.data.Success && response.data.Value != null) {
              ctrl.LinkTemplate = response.data.Value;
              ctrl.showBtnLink = true;
            }
          });
        }
      };

      ctrl.uploadAttachment = function (file, item) {
        if (file == null) return;

        ctrl.isBusy = true;
        item.isLoading = true;

        dataService.updateFileCampoValor(file).then(
          function (response) {
            $timeout(function () {
              //console.log(response);
              if (response.data.Success) {
                //console.log('uploadFileAttachment: ' + response.data.Value);
                item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
              } else {
                item.ValorObjeto = null;
              }
            });
            ctrl.isBusy = false;
            item.isLoading = false;
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            item.isLoading = false;
          }
        );
      };

      ctrl.uploadAttachmentTableEnr = function (file, campoIndex, filaIndex, columnaIndex) {
        if (file == null)
          return;

        ctrl.isBusy = true;

        dataService.updateFileSolicitudCampoValor(file)
          .then(function (response) {
            $timeout(function () {
              if (response.data.Success) {
                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = response.data.Value;
              } else {
                toastr.error(response.data.ErrorSummary);
                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = '';
              }
            });
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.uploadAttachmentPicture = function (file, item) {
        ctrl.isBusy = true;
        item.isLoading = true;
        $timeout(function () {
          // Swal.fire({
          //   title: '',
          //   showCancelButton: false,
          //   confirmButtonColor: '#3085d6',
          //   confirmButtonText: 'Aceptar',
          //   cancelButtonText: 'Cancel',
          //   showCloseButton: false,
          //   allowOutsideClick: false,
          //   allowEscapeKey: false,
          //   focusConfirm: false,
          //   heightAuto: false,
          //   onOpen: function () {
          //     swal.showLoading();
          //   }
          // });

          if (item.ValorObjetoImgTmp == null || item.ValorObjetoImgTmp == undefined) {
            ctrl.isBusy = false;
            item.isLoading = false;
            return;
          }

          // file = item.ValorObjetoImgTmp.compressed.dataURL; // Antes del 05/03/2025 se enviaba la imagen comprimida, lo que daba conflicto con los pngs, por ende se cambio a la imagen completa
          file = item.ValorObjetoImgTmp.dataURL;

          // console.log(file);
          file = file.replace("data:image/png;base64,", "").replace("data:image/jpg;base64,", "").replace("data:image/jpeg;base64,", "");

          //dataService.updateFileSolicitudCampoValor(file)
          dataService.updateFileCampoValor(file)
            .then(function (response) {
              $timeout(function () {
                if (response.data.Success) {
                  item.ValorObjeto = response.data.Value; //{ fileName: file.name, serverFileName: response.data.Value };
                } else {
                  item.ValorObjeto = null;
                }
                // console.log(response.data);
                swal.close();
              });
              ctrl.isBusy = false;
              item.isLoading = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
              item.isLoading = false;
            });
        }, 3000);
      }

      ctrl.removeAttachment = function (item) {
        item.ValorObjeto = null;
        item.ValorObjetoImgTmp = null;
      };

      ctrl.removeAttachmentTableEnr = function (campoIndex, filaIndex, columnaIndex) {
        // console.log(campoIndex, filaIndex, columnaIndex);
        ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex] = '';
      }

      ctrl.addUsuarioNotificar = function (item) {
        if (ctrl.procesoUsuariosNotificarList == null)
          ctrl.procesoUsuariosNotificarList = [];

        for (var i = 0; i < ctrl.procesoUsuariosNotificarList.length; i++) {
          if (ctrl.procesoUsuariosNotificarList[i].Id == item.Id)
            return;
        }

        ctrl.procesoUsuariosNotificarList.push(item);
      };

      ctrl.removeUsuarioNotificar = function (index) {
        if (ctrl.procesoUsuariosNotificarList == null)
          ctrl.procesoUsuariosNotificarList = [];

        if (ctrl.procesoUsuariosNotificarList.length > 0)
          ctrl.procesoUsuariosNotificarList.splice(index, 1);
      };

      ctrl.addUsuarioTabNotificar = function (item) {
        if (ctrl.procesoUsuariosNotificarTabList == null)
          ctrl.procesoUsuariosNotificarTabList = [];

        for (var i = 0; i < ctrl.procesoUsuariosNotificarTabList.length; i++) {
          if (ctrl.procesoUsuariosNotificarTabList[i].Usuario.Id == item.Usuario.Id)
            return;
        }

        ctrl.procesoUsuariosNotificarTabList.push(item);
        ctrl.procesoUsuariosNotificarDS = ctrl.procesoUsuariosNotificarTabList;
      };

      ctrl.removeUsuarioTabNotificar = function (index) {
        if (ctrl.procesoUsuariosNotificarTabList == null)
          ctrl.procesoUsuariosNotificarTabList = [];

        if (ctrl.procesoUsuariosNotificarTabList.length > 0)
          ctrl.procesoUsuariosNotificarTabList.splice(index, 1);

        ctrl.procesoUsuariosNotificarDS = ctrl.procesoUsuariosNotificarTabList;
      };

      ctrl.onNumericInputGotFocus = function (nStr) {
        return sharedService.replaceAll(nStr, ",", "");
      };

      ctrl.onNumericInputLostFocus = function (nStr) {
        return sharedService.addThousandSeparator(nStr);
      };

      ctrl.save = function (form) {
        // var useMailAdicional = false;

        var notificationMessageText, notificationUserText, notificationAdditionalUsersText, modalText;

        if (ctrl.language == "español") {
          notificationMessageText = "Debe ingresar un mensaje para enviar las notificaciones a los usuarios seleccionados";
          notificationUserText = "Debe seleccionar usuarios para enviar el mensaje a notificar";
          notificationAdditionalUsersText = "Debe seleccionar usuarios para enviar el mensaje a notificar o ingresar mails externos";
          modalText = "Se está ejecutando un proceso, por favor espere";

        } else if (ctrl.language == "ingles") {
          notificationMessageText = "You must enter a message to send notifications to selected users";
          notificationUserText = "You must select users to send the notification message";
          notificationAdditionalUsersText = "You must select users to send the notification message or enter external emails";
          modalText = "A process is running, please wait";

        } else if (ctrl.language == "portugues") {
          notificationMessageText = "Deve inserir uma mensagem para enviar as notificações aos usuários selecionados";
          notificationUserText = "Deve selecionar usuários para enviar a mensagem de notificação";
          notificationAdditionalUsersText = "Deve selecionar usuários para enviar a mensagem de notificação ou inserir e-mails externos";
          modalText = "Um processo está sendo executado, aguarde";

        } else if (ctrl.language == "italiano") {
          notificationMessageText = "Debe ingresar un mensaje para enviar las notificaciones a los usuarios seleccionados";
          notificationUserText = "Debe seleccionar usuarios para enviar el mensaje a notificar";
          notificationAdditionalUsersText = "Debe seleccionar usuarios para enviar el mensaje a notificar o ingresar mails externos";
          modalText = "Se está ejecutando un proceso, por favor espere";
        }

        // NOTA SOBRE LO COMENTADO EN ESTE MÈTODO:
        // Anterior al dia 08/03/2025, cuando el template tenia un tipo template id 2 (campo.SolicitudProcesoTemplate.ProcesoTemplate.Template.TipoTemplateId: 2), el front creaba un body donde obtenia los usuarios del campo USER y el mensaje del campo id seleccionado como mensaje (ver validaciones), con eso se llamaba al dataService.notificacionesCampoValor pasandole ese body
        // Actualmente ya esto no es necesario porque ese proceso se hace en backend y se envìa el correo de una vez, por eso se comentò este comportamiento

        // ctrl.camposList.map(function (campo) {
        //   if (campo.SolicitudProcesoTemplate.ProcesoTemplate.Template.TipoTemplateId == 2) {
        //     if (campo.Campo.CampoTipo.Codigo == 'USER') {
        //       if (campo.ValorObjeto != null && campo.ValorObjeto.length > 0) {
        //         campo.ValorObjeto.map(function (user) {
        //           ctrl.addUsuarioNotificar(user);
        //         })
        //       }
        //       // } else {
        //       //   // Si no encuentra que se seleccionó un usuario desde el campo "USER", cambia la variable que le indica que cambie el valor de los mailsAdicionales
        //       //   useMailAdicional = true;
        //       // }
        //     }

        //     // if (useMailAdicional) {
        //     //   // Si es true, busca el campo con nombre "CON COPIA A" y le da ese valor a los mailsAdicionales
        //     //   if (campo.Campo.Nombre.toUpperCase().includes('CON COPIA A')) {
        //     //     ctrl.mailsAdicionales = campo.ValorObjeto;
        //     //   }
        //     // }

        //     if (campo.Campo.CampoId == ctrl.tipoEnvioMailConfig.CampoMensaje.CampoId) {
        //       var messageTextDefault;

        //       if (ctrl.language == "español")
        //         messageTextDefault = "Se ha añadido una nueva gestión";

        //       else if (ctrl.language == "ingles")
        //         messageTextDefault = "A new management has been added";

        //       else if (ctrl.language == "portugues")
        //         messageTextDefault = "Uma nova gestão foi adicionada.";

        //       else if (ctrl.language == "italiano")
        //         messageTextDefault = "Se ha añadido una nueva gestión";

        //       ctrl.mensajeNotificacion = campo.ValorObjeto || messageTextDefault;
        //     }

        //     // var messageTextValidation, messageTextDefault;

        //     // if (ctrl.language == "español") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAJE');
        //     //   messageTextDefault = "Se ha añadido una nueva gestión";

        //     // } else if (ctrl.language == "ingles") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITLE') || campo.Campo.Nombre.toUpperCase().includes('MESSAGE');
        //     //   messageTextDefault = "A new management has been added";

        //     // } else if (ctrl.language == "portugues") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TÍTULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAGEM');
        //     //   messageTextDefault = "Uma nova gestão foi adicionada.";

        //     // } else if (ctrl.language == "italiano") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAJE');
        //     //   messageTextDefault = "Se ha añadido una nueva gestión";
        //     // }

        //     // if (messageTextValidation) {
        //     //   ctrl.mensajeNotificacion = campo.ValorObjeto || messageTextDefault;
        //     // }

        //   }
        // })

        // TODAS ESTAS VALIDACIONES son para revisar que los campos que tengan relación con el envío de notificaciones, tengan valor y no estén vacíos
        // if (
        //   ((ctrl.procesoUsuariosNotificarList != null &&
        //     ctrl.procesoUsuariosNotificarList.length > 0) ||
        //     (ctrl.mailsAdicionales != null &&
        //       ctrl.mailsAdicionales.length > 0)) &&
        //   (ctrl.mensajeNotificacion == null ||
        //     ctrl.mensajeNotificacion.length == 0)
        // ) {
        //   toastr.error(notificationMessageText);
        //   return;
        // }

        // if (
        //   ctrl.mensajeNotificacion != null &&
        //   ctrl.mensajeNotificacion.length > 0 &&
        //   (ctrl.procesoUsuariosNotificarList == null ||
        //     ctrl.procesoUsuariosNotificarList.length <= 0) &&
        //   (ctrl.mailsAdicionales == null || ctrl.mailsAdicionales.length <= 0)
        // ) {
        //   toastr.error(notificationUserText);
        //   return;
        // }

        if (
          ((ctrl.procesoUsuariosNotificarTabList != null && ctrl.procesoUsuariosNotificarTabList.length > 0) ||
            (ctrl.mailsAdicionalesTab != null && ctrl.mailsAdicionalesTab.length > 0)) &&
          (ctrl.mensajeNotificacionTab == null || ctrl.mensajeNotificacionTab.length == 0)
        ) {
          toastr.error(notificationMessageText);
          return;
        }

        if (
          ctrl.mensajeNotificacionTab != null && ctrl.mensajeNotificacionTab.length > 0 &&
          (ctrl.procesoUsuariosNotificarTabList == null || ctrl.procesoUsuariosNotificarTabList.length <= 0) &&
          (ctrl.mailsAdicionalesTab == null || ctrl.mailsAdicionalesTab.length <= 0)
        ) {
          toastr.error(notificationAdditionalUsersText);
          return;
        }

        ctrl.isBusy = true;
        // sharedService.setIsBusyIframe(true);

        if (ctrl.camposList != null) {
          ctrl.preSaveCampos();
        }
        // console.log("saveCampoValor *****");
        // console.log(ctrl.camposList);

        if (ctrl.camposTableEnr.length > 0) {
          // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
          ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
            campoTableEnr.TablaFilas = ctrl.camposList[campoTableEnr.index].TablaFilas;
            campoTableEnr.Campo = ctrl.camposList[campoTableEnr.index].Campo;
            campoTableEnr.SolicitudId = ctrl.camposList[campoTableEnr.index].SolicitudProcesoTemplate.SolicitudId;
            return campoTableEnr;
          });
        }


        Swal.fire({
          title: '',
          text: modalText,
          allowEscapeKey: false,
          allowOutsideClick: false,
          onOpen: function () {
            swal.showLoading();
          }
        })

        dataService.saveCampoValor(ctrl.camposList).then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;

              if (ctrl.camposTableEnr.length > 0) {
                // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                  campoTableEnr.SolicitudProcesoTemplateId = ctrl.camposList[campoTableEnr.index].SolicitudProcesoTemplateId;
                  return campoTableEnr;
                });
              }

              // console.log(ctrl.camposList);
              // console.log(ctrl.camposListTemplate);
              // Filtrando únicamente los campos que tiene la gestión (template) para ser enviados en el correo
              // var camposListTemp = ctrl.camposList.filter(function (campoL) {
              //   return ctrl.camposListTemplate.filter(function (campoLT) {
              //     return campoL.CampoId == campoLT.CampoId && campoL.SolicitudProcesoTemplate.Id == campoLT.SolicitudProcesoTemplate.Id;
              //   })[0];
              // });

              // console.log(camposListTemp);

              //Enviar notificaciones desde el campo envío email (TipoTemplateId 2)
              // if (
              //   (ctrl.procesoUsuariosNotificarList != null &&
              //     ctrl.procesoUsuariosNotificarList.length > 0) ||
              //   (ctrl.mailsAdicionales != null &&
              //     ctrl.mailsAdicionales.length > 0)
              // ) {
              //   var notificacion = {
              //     Usuarios: [],
              //     Asunto: "Kahuna | " + ctrl.title,
              //     Mensaje: ctrl.mensajeNotificacion,
              //     // Valores: ctrl.camposListTemplate,
              //     Valores: ctrl.camposList, // Se deben enviar los valores más actualizados (16/01/2025)
              //     MailsAdicionales: ctrl.mailsAdicionales,
              //   };

              //   for (var i = 0; i < ctrl.procesoUsuariosNotificarList.length; i++)
              //     notificacion.Usuarios.push(ctrl.procesoUsuariosNotificarList[i]);
              //   // notificacion.Usuarios.push(ctrl.procesoUsuariosNotificarList[i].Usuario);

              //   dataService.notificacionesCampoValor(notificacion).then(
              //     function (response) {
              //       if (response.data.Success) {
              //         // $state.reload();
              //         /*$state.go("pages.solicitud-edit", {
              //           id: $stateParams.solicitud,
              //           // grupo: $state.params.grupoId, 
              //           proceso: $stateParams.proceso,
              //           solicitudPadreId: 0
              //         });*/
              //       } else {
              //         toastr.error(response.data.ErrorSummary);
              //       }
              //     },
              //     function (error) {
              //       toastr.error(
              //         error.data || sharedService.getGenericErrorMessage(error)
              //       );
              //     }
              //   );
              // }

              //Enviar notificaciones desde la tab "Notificar Usuarios"
              if (
                (ctrl.procesoUsuariosNotificarTabList != null &&
                  ctrl.procesoUsuariosNotificarTabList.length > 0) ||
                (ctrl.mailsAdicionalesTab != null &&
                  ctrl.mailsAdicionalesTab.length > 0)
              ) {
                var notificacionTab = {
                  Usuarios: [],
                  Asunto: "Kahuna | " + ctrl.title,
                  Mensaje: ctrl.mensajeNotificacionTab,
                  // Valores: ctrl.camposListTemplate,
                  Valores: ctrl.camposList, // Se deben enviar los valores más actualizados (16/01/2025)
                  MailsAdicionales: ctrl.mailsAdicionalesTab,
                };

                for (var i = 0; i < ctrl.procesoUsuariosNotificarTabList.length; i++)
                  notificacionTab.Usuarios.push(ctrl.procesoUsuariosNotificarTabList[i].Usuario);

                // console.log(notificacionTab);

                dataService.notificacionesCampoValor(notificacionTab).then(
                  function (response) {
                    if (response.data.Success) {
                    } else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  },
                  function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  }
                );
              }

              // console.log("saveSolicitudCampoValor");
              if (ctrl.generaProcesoRelacionados) {
                // console.log("genera procesos RElacionados es TRUE!!!!");
                // console.log(camposListTemp);
                // console.log(ctrl.camposList[0].SolicitudProcesoTemplateId);

                // angular.forEach(camposListTemp, function (value, key) {
                //   camposListTemp[key].SolicitudProcesoTemplateId =
                //     ctrl.camposList[0].SolicitudProcesoTemplateId;
                // });

                // console.log(camposListTemp);

                if (ctrl.camposTableEnr.length > 0) {
                  // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                  ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                    campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                    delete campoTableEnr.index
                    return campoTableEnr;
                  });

                  dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                    .then(function (response) {
                      if (response.data.Success) {
                        dataService.SaveSolicitudCampoValorGeneraProcesosTemplates(ctrl.camposList)
                          .then(function (data) {
                            toastr.info(ctrl.successfulRegistration);

                            $state.go("pages.solicitud-edit", {
                              id: $stateParams.solicitud,
                              // grupo: $state.params.grupoId,
                              proceso: $stateParams.proceso,
                              solicitudPadreId: 0,
                            });
                          });
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
                } else {
                  dataService.SaveSolicitudCampoValorGeneraProcesosTemplates(ctrl.camposList)
                  .then(function (data) {
                    // if (ctrl.iframeSolicitudActivo) {
                    //   sharedService.setIsBusyIframe(false);
                    //   swal.close();
                    //   Swal.fire({
                    //     title: '',
                    //     text: "Proceso finalizado, puede cerrar la ventana",
                    //     allowEscapeKey: false,
                    //     allowOutsideClick: false,
                    //     showConfirmButton: false,
                    //     icon: "success"
                    //   })
                    //   ctrl.isBusy = false;
                    //   return;
                    // }

                    toastr.info(ctrl.successfulRegistration);

                    $state.go("pages.solicitud-edit", {
                      id: $stateParams.solicitud,
                      // grupo: $state.params.grupoId,
                      proceso: $stateParams.proceso,
                      solicitudPadreId: 0,
                    });
                  });
                }
              } else {
                // console.log("genera procesos Relacionados es FALSE!!!!");
                // if (ctrl.iframeSolicitudActivo) {
                //   sharedService.setIsBusyIframe(false);
                //   swal.close();
                //   Swal.fire({
                //     title: '',
                //     text: "Proceso finalizado, puede cerrar la ventana",
                //     allowEscapeKey: false,
                //     allowOutsideClick: false,
                //     showConfirmButton: false,
                //     icon: "success"
                //   })
                //   ctrl.isBusy = false;
                //   return;
                // }

                if (ctrl.camposTableEnr.length > 0) {
                  // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                  ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                    campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                    delete campoTableEnr.index
                    return campoTableEnr;
                  });

                  dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info(ctrl.successfulRegistration);

                        $state.go("pages.solicitud-edit", {
                          id: $stateParams.solicitud,
                          // grupo: $state.params.grupoId,
                          proceso: $stateParams.proceso,
                          solicitudPadreId: 0,
                        });
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
                } else {
                  toastr.info(ctrl.successfulRegistration);

                  $state.go("pages.solicitud-edit", {
                    id: $stateParams.solicitud,
                    // grupo: $state.params.grupoId,
                    proceso: $stateParams.proceso,
                    solicitudPadreId: 0,
                  });
                }
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
            // sharedService.setIsBusyIframe(false);
            swal.close();
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            // sharedService.setIsBusyIframe(false);
            swal.close();
          }
        );
      };

      ctrl.delete = function () {
        ctrl.isBusy = true;

        var modalTitle, modalMessage, confirmationText;

        if (ctrl.language == "español") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado de la gestión actual?";
          confirmationText = "Se está ejecutando un proceso, por favor espere";
        }
        else if (ctrl.language == "ingles") {
          modalTitle = "Attetion";
          modalMessage = "Do you confirm the deletion of the current management?";
          confirmationText = "A process is running, please wait";
        }
        else if (ctrl.language == "portugues") {
          modalTitle = "Atenção";
          modalMessage = "Confirma a exclusão da gestão atual?";
          confirmationText = "Um processo está sendo executado, aguarde";
        }
        else if (ctrl.language == "italiano") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado de la gestión actual?";
          confirmationText = "Se está ejecutando un proceso, por favor espere";
        }

        // sharedService.setIsBusyIframe(true);
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return modalTitle;
            },
            message: function () {
              return modalMessage;
            },
          },
        });

        confirmation.result.then(
          function (selectedItem) {
            Swal.fire({
              title: '',
              text: confirmationText,
              allowEscapeKey: false,
              allowOutsideClick: false,
              onOpen: function () {
                swal.showLoading();
              }
            });
            dataService
              .deleteCampoValor($stateParams.solicitudProcesoTemplate)
              .then(
                function (response) {
                  if (response.data.Success) {
                    toastr.info(ctrl.successfulRegistration);
                    swal.close();
                    // if (ctrl.iframeSolicitudActivo) {
                    //   swal.close();
                    //   sharedService.setIsBusyIframe(false);
                    //   Swal.fire({
                    //     title: '',
                    //     text: "Proceso finalizado, puede cerrar la ventana",
                    //     allowEscapeKey: false,
                    //     allowOutsideClick: false,
                    //     showConfirmButton: false,
                    //     icon: "success"
                    //   })
                    //   ctrl.isBusy = false;
                    //   return;
                    // }

                    ctrl.cancel();
                  } else {
                    toastr.error(response.data.ErrorSummary);
                  }
                  ctrl.isBusy = false;
                  // sharedService.setIsBusyIframe(false);
                },
                function (error) {
                  toastr.error(
                    error.data || sharedService.getGenericErrorMessage(error)
                  );
                  ctrl.isBusy = false;
                  // sharedService.setIsBusyIframe(false);
                }
              );
          },
          function () {
            ctrl.isBusy = false;
            // sharedService.setIsBusyIframe(false);
          }
        );
      };
      ctrl.evaluatenumber = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 109
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      //Previene que se ingresen separadores de miles, la coma o el punto
      ctrl.evaluatenumberDigit = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        // console.log(charCode);
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 109
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      ctrl.evaluatenumberDecimal = function (event) {
        var charCode = event.which ? event.which : event.keyCode;
        if (
          charCode == 8 ||
          charCode == 35 ||
          charCode == 36 ||
          charCode == 37 ||
          charCode == 39 ||
          charCode == 45 ||
          charCode == 46 ||
          charCode == 96 ||
          charCode == 190 ||
          charCode == 109 ||
          charCode == 110
        ) {
          return true;
        } else if (charCode >= 97 && charCode <= 105) {
          return true;
        } else if (charCode < 48 || charCode > 57) {
          event.preventDefault();
          return false;
        } else {
          return true;
        }
      };

      ctrl.onChangeInputTableCond = function (
        indexCampo,
        indexFila,
        indexColumna,
        valor
      ) {
        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[
          indexColumna
        ] = valor;
      };

      ctrl.onChangeInputcond = function (item) {
        // console.log((item.Valor[1] = ""));
      };

      ctrl.cancel = function () {
        if ($stateParams.solicitud == 0) {
          $state.transitionTo("pages.solicitud");
        } else {
          $state.go("pages.solicitud-edit", {
            id: $stateParams.solicitud,
            //grupo: $state.params.grupoId,
            proceso: $stateParams.proceso,
            solicitudPadreId: 0,
          });
        }
      };

      ctrl.initListadoProcesos = function () {
        // console.log("INICIALÑIOZANDO EL LISTADO DE LOS POROCESOSS::!!!");
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0,
        };
        // dataService.searchProceso(ctrl.filtros) // Este endpoint se usó hasta el 17/02/2025, se comporta igual al endpoint agregado abajo
        dataService.searchProceso_nodoc(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.listadoDeProcesos = response.data.Value.Resultados;
              // console.log(ctrl.listadoDeProcesos);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
            function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
            }
          );
      };
      ctrl.initListadoProcesos_doc = function () {
        // console.log("INICIALÑIOZANDO EL LISTADO DE LOS POROCESOSS::!!!");
        ctrl.isSearching = true;
        ctrl.filtros = {
          PageSize: 1000,
          SkipNumber: 0,
        };
        dataService.searchProceso_doc(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.listadoDeProcesos_doc = response.data.Value.Resultados;
              // console.log(ctrl.listadoDeProcesos_doc);
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          },
            function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isSearching = false;
            }
          );
      };
      ctrl.onChangeSelectProcesoSeleccionado = function (procesoSeleccionado) {
        // console.log(procesoSeleccionado);
      };
      ctrl.onChangeSelectProcesoSeleccionado_doc = function (
        procesoSeleccionado_doc
      ) {
        // console.log(procesoSeleccionado_doc);
      };
      ctrl.searchCampoSolicitud = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        if (
          ctrl.procesoSeleccionado != null &&
          ctrl.procesoSeleccionado.Id != ""
        ) {
          var filtrosSolicitud = {
            ProcesoId: ctrl.procesoSeleccionado.Id,
            Descripcion: nombreUsuario,
            PageSize: 100,
            SkipNumber: 0,
            VerTodos: true,
            documentalGetCerrados: true,
            // VerProcesosPendientesOtrosUsuarios: false, // esta propiedad se enviaba en el body del endpoint hasta el 12/02/2025, fue removida para que la petición, de este tipo de campo, sea exactamente igual a la petición en la solicitud
            lProcesoIsDocumentalAutorizacionesV2: ctrl.procesoSeleccionado.autorizacionesDocumental,
            VerProcesosPendientesOtrosUsuarios: false,
            misSolicitudes: true
            // las propiedades VerProcesosPendientesOtrosUsuarios y misSolicitudes fueron seteadas el dia 12/09/2025 solo cuando no es solicitud documental
          };

          // return dataService.searchSolicitud(filtrosSolicitud).then(
          return dataService.searchSolicitudSimple(filtrosSolicitud).then(
            function (response) {
              if (response.data.Success) {
                // console.log(response);
                ctrl.ListarSolicitudesProceso = response.data.Value.Resultados;
                return response.data.Value.Resultados;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
        } else {
          // console.log("seleccione el proceso.");
        }
      };
      ctrl.searchCampoSolicitud_doc = function (nombreUsuario) {
        var filtroUsuario = {
          Login: nombreUsuario,
          PageSize: 20,
          SkipNumber: 0,
        };

        if (
          ctrl.procesoSeleccionado_doc != null &&
          ctrl.procesoSeleccionado_doc.Id != ""
        ) {
          var filtrosSolicitud = {
            ProcesoId: ctrl.procesoSeleccionado_doc.Id,
            Descripcion: nombreUsuario,
            PageSize: 100,
            SkipNumber: 0,
            VerTodos: true,
            documentalGetCerrados: true,
            // VerProcesosPendientesOtrosUsuarios: false, // esta propiedad se enviaba en el body del endpoint hasta el 12/02/2025, fue removida para que la petición, de este tipo de campo, sea exactamente igual a la petición en la solicitud
            lProcesoIsDocumentalAutorizacionesV2: ctrl.procesoSeleccionado_doc.autorizacionesDocumental
          };

          // return dataService.searchSolicitud_doc(filtrosSolicitud).then(
          return dataService.searchSolicitudSimple(filtrosSolicitud).then(
            function (response) {
              if (response.data.Success) {
                // console.log(response);
                ctrl.ListarSolicitudesProceso_doc =
                  response.data.Value.Resultados;
                return response.data.Value.Resultados;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            },
            function (error) {
              toastr.error(
                error.data || sharedService.getGenericErrorMessage(error)
              );
            }
          );
        } else {
          // console.log("seleccione el proceso.");
        }
      };

      ctrl.onSelectSolicitudMultiList = function (campoIndex, itemSeleccionado) {

        if (itemSeleccionado == null)
          return;

        if (campoIndex >= 0) {
          if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
            if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
              ctrl.solicitudCargada = null;
              return;
            }
          }

          // dataService.getProcesoById(itemSeleccionado.ProcesoId)
          dataService.getProcesoInSolicitud(itemSeleccionado.ProcesoId)
            .then(function (response) {
              if (response.data.Success) {
                var proceso = response.data.Value;

                var obj = {
                  Id: itemSeleccionado.Id,
                  Numero: itemSeleccionado.Numero,
                  NumeroCompleto: itemSeleccionado.NumeroCompleto,
                  ProcesoId: itemSeleccionado.ProcesoId,
                  Descripcion: itemSeleccionado.Descripcion,
                  DescripcionResumida: itemSeleccionado.DescripcionResumida,
                  Proceso: {
                    Id: itemSeleccionado.ProcesoId,
                    Nombre: proceso.Nombre,
                    GrupoId: proceso.GrupoId
                  },
                  CreationDate: itemSeleccionado.CreationDate
                };

                ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                ctrl.solicitudCargada = null;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            })

        }
      }
      ctrl.onSelectSolicitudMultiList_doc = function (campoIndex, itemSeleccionado) {

        if (itemSeleccionado == null)
          return;

        if (campoIndex >= 0) {
          if (ctrl.camposList[campoIndex].ValorObjeto == null || ctrl.camposList[campoIndex].ValorObjeto == "")
            ctrl.camposList[campoIndex].ValorObjeto = [];

          for (var k = 0; k < ctrl.camposList[campoIndex].ValorObjeto.length; k++) {
            if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == itemSeleccionado.Id) {
              ctrl.solicitudCargada_doc = null;
              return;
            }
          }

          // dataService.getProcesoById(itemSeleccionado.ProcesoId)
          dataService.getProcesoInSolicitud(itemSeleccionado.ProcesoId)
            .then(function (response) {
              if (response.data.Success) {
                var proceso = response.data.Value;

                var obj = {
                  Id: itemSeleccionado.Id,
                  Numero: itemSeleccionado.Numero,
                  NumeroCompleto: itemSeleccionado.NumeroCompleto,
                  ProcesoId: itemSeleccionado.ProcesoId,
                  Descripcion: itemSeleccionado.Descripcion,
                  DescripcionResumida: itemSeleccionado.DescripcionResumida,
                  Proceso: {
                    Id: itemSeleccionado.ProcesoId,
                    Nombre: proceso.Nombre,
                    GrupoId: proceso.GrupoId
                  },
                  NumeradorDocumental: itemSeleccionado.NumeradorDocumental,
                  CreationDate: itemSeleccionado.CreationDate
                };

                ctrl.camposList[campoIndex].ValorObjeto.push(obj);
                ctrl.solicitudCargada_doc = null;
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            })

        }
      }

      ctrl.deleteCampoSolicitud = function (campoIndex, usuarioId) {
        if (ctrl.camposList[campoIndex].ValorObjeto == null) return;

        for (
          var k = 0;
          k < ctrl.camposList[campoIndex].ValorObjeto.length;
          k++
        ) {
          if (ctrl.camposList[campoIndex].ValorObjeto[k].Id == usuarioId) {
            ctrl.camposList[campoIndex].ValorObjeto.splice(k, 1);
            return;
          }
        }
      };

      // TABLEENR FUNCIONES

      function loadJerarquiaPlaceholderTableEnr(jerarquiaPadreId, campoIndex, filaIndex, columnaIndex, jerarquiaIndex) {
        // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Ejemplo: ";
        else if (ctrl.language == "ingles")
          placeholderText = "Example: ";
        else if (ctrl.language == "portugues")
          placeholderText = "Exemplo: ";
        else if (ctrl.language == "italiano")
          placeholderText = "Ejemplo: ";

        dataService.getJerarquiaMuestra(jerarquiaPadreId, 2)
          .then(function (response) {
            if (response.data.Success) {
              var ph = '';

              if (response.data.Value != null) {
                if (response.data.Value.length > 0)
                  ph = placeholderText + response.data.Value[0].Nombre;

                if (response.data.Value.length > 1)
                  ph = ph + ', ' + response.data.Value[1].Nombre;
              }

              ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].Placeholder = ph;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.onSelectJerarquiaTableEnr = function (campoIndex, filaIndex, columnaIndex, jerarquiaIndex, jerarquiaSeleccionada) {
        // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
        var placeholderText;

        if (ctrl.language == "español")
          placeholderText = "Cargando...";
        else if (ctrl.language == "ingles")
          placeholderText = "Loading...";
        else if (ctrl.language == "portugues")
          placeholderText = "Carregando...";
        else if (ctrl.language == "italiano")
          placeholderText = "Cargando...";

        if (jerarquiaSeleccionada == null)
          return;

        if (campoIndex >= 0) {
          if (jerarquiaSeleccionada.Detalles != null && jerarquiaSeleccionada.Detalles.length > 0) {
            jerarquiaSeleccionada.Detalles.sort(function (a, b) {
              return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
            });
          }

          // console.log("Campo : " + campoIndex);
          // console.log("Fila : " + filaIndex);
          // console.log("Columna : " + columnaIndex);
          // console.log("Jerarquia : " + jerarquiaIndex);
          // console.log(ctrl.camposList[campoIndex]);

          ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex] = jerarquiaSeleccionada;
          ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].ValorInput = jerarquiaSeleccionada.Nombre;

          //Borrado de todas las jerarquias posteriores a la actual
          ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].splice(jerarquiaIndex + 1,
            (ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].length - jerarquiaIndex - 1));

        }

        dataService.validarJerarquiaTienePadre(jerarquiaSeleccionada.Id)
          .then(function (response) {
            if (response.data.Success) {
              if (response.data.Value == true) {
                ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex].push({
                  ValorInput: null,
                  JerarquiaPadreId: jerarquiaSeleccionada.Id,
                  LoadingJerarquia: false,
                  NoResults: false,
                  Placeholder: placeholderText
                });
                // Al jerarquiaIndex se le suma uno porque actualmente tiene el valor del primer input, en caso de tener padre, el placeholder sería para el siguiente input
                loadJerarquiaPlaceholderTableEnr(jerarquiaSeleccionada.Id, campoIndex, filaIndex, columnaIndex, jerarquiaIndex + 1);
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }

      ctrl.altaNuevaJerarquiaTableEnr = function (campoIndex, filaIndex, columnaIndex, jerarquiaIndex) {
        // Método creado el 04/09/2024 para el manejo de las Jerarquias dentro del campo tipo TABLEENR
        ctrl.isBusy = true;
        var jerarquiaPadre = {};
        var confirmationTitle;

        if (ctrl.language == "español")
          confirmationTitle = "Alta de Nueva Jerarquía";
        else if (ctrl.language == "ingles")
          confirmationTitle = "New Hierarchy Registration";
        else if (ctrl.language == "portugues")
          confirmationTitle = "Cadastro de Nova Hierarquia";
        else if (ctrl.language == "italiano")
          confirmationTitle = "Alta de Nueva Jerarquía";


        if (jerarquiaIndex > 0)
          jerarquiaPadre = ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex - 1];
        else
          jerarquiaPadre = {
            Id: ctrl.camposList[campoIndex].TablaFilas[filaIndex].Valor[columnaIndex][jerarquiaIndex].JerarquiaPadreId,
            Nombre: ""
          };

        var confirmation = $uibModal.open({
          animation: true,
          component: "altaJerarquia",
          resolve: {
            title: function () {
              return confirmationTitle
            },
            JerarquiaPadre: function () {
              return jerarquiaPadre
            },
          }
        });

        confirmation.result.then(function (returnValue) {
          ctrl.isBusy = false;
          ctrl.onSelectJerarquiaTableEnr(campoIndex, filaIndex, columnaIndex, jerarquiaIndex, returnValue);
        }, function () {
          ctrl.isBusy = false;
        });
      }

      // ctrl.onSelectUsuarioMultiListTableEnrTEST = function (indexCampo, indexFila, indexColumna, colValor, defaultSelected) {
      //   // console.log("indexCampo : " + indexCampo);
      //   // console.log("FilA : " + indexFila);
      //   // console.log("Columna : " + indexColumna);
      //   // console.log("colValor!!! : " + colValor);
      //   // console.log("defaultSelected!!! : " + defaultSelected);
      // };


      ctrl.onSelectUsuarioMultiListTableEnr = function (indexCampo, indexFila, indexColumna, colValor, defaultSelected) {
        // console.log(indexCampo);
        // console.log("FilA : " + indexFila);
        // console.log("Columna : " + indexColumna);
        // console.log("VALOR!!! : " + colValor);
        // console.log(colValor);
        // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna]);
        if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == null || ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].length == 0) {
          ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = [];
        }
        if (defaultSelected == 99) {
          colValor = {
            text: {
              Id: ctrl.camposList[indexCampo].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.Id,
              Login: ctrl.camposList[indexCampo].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.Login,
              Nombre: ctrl.camposList[indexCampo].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.Nombre,
              Apellido: ctrl.camposList[indexCampo].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.Apellido
            }
          }
        }

        if (!ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].some(function (user) { return user.Id === colValor.text.Id; })) {
          ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].push({
            Id: colValor.text.Id,
            Login: colValor.text.Login,
            Nombre: colValor.text.Nombre,
            Apellido: colValor.text.Apellido
          });
        }
        //colValor.text= '';
        // console.log("OJOJOJOJOJOJOJ");
        // console.log(ctrl.camposList);
      };

      ctrl.deleteCampoUsuarioTableEnr = function (indexCampo, indexFila, indexColumna, colValor, defaultSelected) {
        // console.log(indexCampo);
        // console.log("FilA : " + indexFila);
        // console.log("Columna : " + indexColumna);
        // console.log("VALOR!!! : " + colValor);
        // console.log(ctrl.camposList[indexCampo]);
        if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == null || ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] == undefined)
          return;
        for (var k = 0; k < ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].length; k++) {
          // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna][k].Id);
          if (ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna][k].Id == colValor) {
            ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna].splice(k, 1);
            return;
          }
        }
      };

      ctrl.onChangeSelectTableEnrList = function (indexCampo, indexFila, indexColumna, valor) {
        // console.log("index CAMPO: " + indexCampo);
        // console.log("index FILA: " + indexFila);
        // console.log("index COLUMNA: " + indexColumna);
        // console.log(valor);

        ctrl.camposList[indexCampo].TablaFilas[indexFila].Valor[indexColumna] = valor.Id;
        // console.log(ctrl.camposList[indexCampo].TablaFilas[indexFila]);
      };

      ctrl.searchListadoDeProcesos = function (nombreProceso, tipoBusqueda) {
        if (tipoBusqueda && tipoBusqueda != "DOCUMENTAL") {
          return ctrl.listadoDeProcesos.filter(function (proceso) {
            if (nombreProceso == "_")
              return proceso;
            else if (proceso.Nombre.toUpperCase().includes(nombreProceso.toUpperCase()))
              return proceso;
          })
        } else {
          return ctrl.listadoDeProcesos_doc.filter(function (proceso) {
            if (nombreProceso == "_")
              return proceso;
            else if (proceso.Nombre.toUpperCase().includes(nombreProceso.toUpperCase()))
              return proceso;
          })
        }
      }

      function executeSPAndReaload() {
        // Esta función es autodescriptiva y fue creada por legibilidad del código

        
        dataService.executeProcedureRefresh(
          ctrl.template.procedimientoRefresh,
          ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.Id,
          ctrl.camposList[0].SolicitudProcesoTemplateId
        )
          .then(function (response) {
            if (response.data.Success) {
            } else {
              toastr.error(response.data.ErrorSummary);
              swal.close();
              ctrl.isBusy = false;
            }

            toastr.info(ctrl.successfulRegistration);

            if (ctrl.isNew) {
              $state.go("pages.solicitud-template", {
                solicitud: ctrl.camposList[0].SolicitudProcesoTemplate.SolicitudId,
                solicitudEstado: ctrl.camposList[0].SolicitudProcesoTemplate.SolicitudEstadoId,
                procesoTemplate: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplateId,
                template: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.TemplateId,
                proceso: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
                solicitudProcesoTemplate: ctrl.camposList[0].SolicitudProcesoTemplateId,
              });
            } else {
              $state.reload();
            }
            
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            swal.close();
          });
        
      }

      function saveCamposValorAndExecuteSP() {

        var notificationMessageText, notificationUserText, notificationAdditionalUsersText, modalText;

        if (ctrl.language == "español") {
          notificationMessageText = "Debe ingresar un mensaje para enviar las notificaciones a los usuarios seleccionados";
          notificationUserText = "Debe seleccionar usuarios para enviar el mensaje a notificar";
          notificationAdditionalUsersText = "Debe seleccionar usuarios para enviar el mensaje a notificar o ingresar mails externos";
          modalText = "Se está ejecutando un proceso, por favor espere";

        } else if (ctrl.language == "ingles") {
          notificationMessageText = "You must enter a message to send notifications to selected users";
          notificationUserText = "You must select users to send the notification message";
          notificationAdditionalUsersText = "You must select users to send the notification message or enter external emails";
          modalText = "A process is running, please wait";

        } else if (ctrl.language == "portugues") {
          notificationMessageText = "Deve inserir uma mensagem para enviar as notificações aos usuários selecionados";
          notificationUserText = "Deve selecionar usuários para enviar a mensagem de notificação";
          notificationAdditionalUsersText = "Deve selecionar usuários para enviar a mensagem de notificação ou inserir e-mails externos";
          modalText = "Um processo está sendo executado, aguarde";

        } else if (ctrl.language == "italiano") {
          notificationMessageText = "Debe ingresar un mensaje para enviar las notificaciones a los usuarios seleccionados";
          notificationUserText = "Debe seleccionar usuarios para enviar el mensaje a notificar";
          notificationAdditionalUsersText = "Debe seleccionar usuarios para enviar el mensaje a notificar o ingresar mails externos";
          modalText = "Se está ejecutando un proceso, por favor espere";
        }

        // NOTA SOBRE LO COMENTADO EN ESTE MÈTODO:
        // Anterior al dia 08/03/2025, cuando el template tenia un tipo template id 2 (campo.SolicitudProcesoTemplate.ProcesoTemplate.Template.TipoTemplateId: 2), el front creaba un body donde obtenia los usuarios del campo USER y el mensaje del campo id seleccionado como mensaje (ver validaciones), con eso se llamaba al dataService.notificacionesCampoValor pasandole ese body
        // Actualmente ya esto no es necesario porque ese proceso se hace en backend y se envìa el correo de una vez, por eso se comentò este comportamiento

        // ctrl.camposList.map(function (campo) {
        //   if (campo.SolicitudProcesoTemplate.ProcesoTemplate.Template.TipoTemplateId == 2) {
        //     if (campo.Campo.CampoTipo.Codigo == 'USER') {
        //       if (campo.ValorObjeto != null && campo.ValorObjeto.length > 0) {
        //         campo.ValorObjeto.map(function (user) {
        //           ctrl.addUsuarioNotificar(user);
        //         })
        //       }
        //     }

        //     if (campo.Campo.CampoId == ctrl.tipoEnvioMailConfig.CampoMensaje.CampoId) {
        //       var messageTextDefault;

        //       if (ctrl.language == "español")
        //         messageTextDefault = "Se ha añadido una nueva gestión";

        //       else if (ctrl.language == "ingles")
        //         messageTextDefault = "A new management has been added";

        //       else if (ctrl.language == "portugues")
        //         messageTextDefault = "Uma nova gestão foi adicionada.";

        //       else if (ctrl.language == "italiano")
        //         messageTextDefault = "Se ha añadido una nueva gestión";

        //       ctrl.mensajeNotificacion = campo.ValorObjeto || messageTextDefault;
        //     }

        //     // var messageTextValidation, messageTextDefault;

        //     // if (ctrl.language == "español") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAJE');
        //     //   messageTextDefault = "Se ha añadido una nueva gestión";

        //     // } else if (ctrl.language == "ingles") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITLE') || campo.Campo.Nombre.toUpperCase().includes('MESSAGE');
        //     //   messageTextDefault = "A new management has been added";

        //     // } else if (ctrl.language == "portugues") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TÍTULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAGEM');
        //     //   messageTextDefault = "Uma nova gestão foi adicionada";

        //     // } else if (ctrl.language == "italiano") {
        //     //   messageTextValidation = campo.Campo.Nombre.toUpperCase().includes('TITULO') || campo.Campo.Nombre.toUpperCase().includes('MENSAJE');
        //     //   messageTextDefault = "Se ha añadido una nueva gestión";
        //     // }

        //     // if (messageTextValidation) {
        //     //   ctrl.mensajeNotificacion = campo.ValorObjeto || messageTextDefault;
        //     // }

        //   }
        // })

        // TODAS ESTAS VALIDACIONES son para revisar que los campos que tengan relación con el envío de notificaciones, tengan valor y no estén vacíos
        // if (
        //   ((ctrl.procesoUsuariosNotificarList != null &&
        //     ctrl.procesoUsuariosNotificarList.length > 0) ||
        //     (ctrl.mailsAdicionales != null &&
        //       ctrl.mailsAdicionales.length > 0)) &&
        //   (ctrl.mensajeNotificacion == null ||
        //     ctrl.mensajeNotificacion.length == 0)
        // ) {
        //   toastr.error(notificationMessageText);
        //   return;
        // }

        // if (
        //   ctrl.mensajeNotificacion != null &&
        //   ctrl.mensajeNotificacion.length > 0 &&
        //   (ctrl.procesoUsuariosNotificarList == null ||
        //     ctrl.procesoUsuariosNotificarList.length <= 0) &&
        //   (ctrl.mailsAdicionales == null || ctrl.mailsAdicionales.length <= 0)
        // ) {
        //   toastr.error(notificationUserText);
        //   return;
        // }

        if (
          ((ctrl.procesoUsuariosNotificarTabList != null && ctrl.procesoUsuariosNotificarTabList.length > 0) ||
            (ctrl.mailsAdicionalesTab != null && ctrl.mailsAdicionalesTab.length > 0)) &&
          (ctrl.mensajeNotificacionTab == null || ctrl.mensajeNotificacionTab.length == 0)
        ) {
          toastr.error(notificationMessageText);
          return;
        }

        if (
          ctrl.mensajeNotificacionTab != null && ctrl.mensajeNotificacionTab.length > 0 &&
          (ctrl.procesoUsuariosNotificarTabList == null || ctrl.procesoUsuariosNotificarTabList.length <= 0) &&
          (ctrl.mailsAdicionalesTab == null || ctrl.mailsAdicionalesTab.length <= 0)
        ) {
          toastr.error(notificationAdditionalUsersText);
          return;
        }

        ctrl.isBusy = true;

        if (ctrl.camposList != null) {
          ctrl.preSaveCampos();
        }

        if (ctrl.camposTableEnr.length > 0) {
          // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
          ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
            campoTableEnr.TablaFilas = ctrl.camposList[campoTableEnr.index].TablaFilas;
            campoTableEnr.Campo = ctrl.camposList[campoTableEnr.index].Campo;
            campoTableEnr.SolicitudId = ctrl.camposList[campoTableEnr.index].SolicitudProcesoTemplate.SolicitudId;
            return campoTableEnr;
          });
        }

        Swal.fire({
          title: '',
          text: modalText,
          allowEscapeKey: false,
          allowOutsideClick: false,
          onOpen: function () {
            swal.showLoading();
          }
        });

        dataService.saveCampoValor(ctrl.camposList).then(
          function (response) {
            if (response.data.Success) {
              ctrl.camposList = response.data.Value;

              if (ctrl.camposTableEnr.length > 0) {
                // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                  campoTableEnr.SolicitudProcesoTemplateId = ctrl.camposList[campoTableEnr.index].SolicitudProcesoTemplateId;
                  return campoTableEnr;
                });
              }

              //Enviar notificaciones desde el campo envío email (TipoTemplateId 2)
              // if (
              //   (ctrl.procesoUsuariosNotificarList != null &&
              //     ctrl.procesoUsuariosNotificarList.length > 0) ||
              //   (ctrl.mailsAdicionales != null &&
              //     ctrl.mailsAdicionales.length > 0)
              // ) {
              //   var notificacion = {
              //     Usuarios: [],
              //     Asunto: "Kahuna | " + ctrl.title,
              //     Mensaje: ctrl.mensajeNotificacion,
              //     // Valores: ctrl.camposListTemplate,
              //     Valores: ctrl.camposList, // Se deben enviar los valores más actualizados (16/01/2025)
              //     MailsAdicionales: ctrl.mailsAdicionales,
              //   };

              //   for (var i = 0; i < ctrl.procesoUsuariosNotificarList.length; i++)
              //     notificacion.Usuarios.push(ctrl.procesoUsuariosNotificarList[i]);

              //   dataService.notificacionesCampoValor(notificacion).then(
              //     function (response) {
              //       if (response.data.Success) {
              //       } else {
              //         toastr.error(response.data.ErrorSummary);
              //       }
              //     },
              //     function (error) {
              //       toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              //     }
              //   );
              // }

              //Enviar notificaciones desde la tab "Notificar Usuarios"
              if (
                (ctrl.procesoUsuariosNotificarTabList != null &&
                  ctrl.procesoUsuariosNotificarTabList.length > 0) ||
                (ctrl.mailsAdicionalesTab != null &&
                  ctrl.mailsAdicionalesTab.length > 0)
              ) {
                var notificacionTab = {
                  Usuarios: [],
                  Asunto: "Kahuna | " + ctrl.title,
                  Mensaje: ctrl.mensajeNotificacionTab,
                  // Valores: ctrl.camposListTemplate,
                  Valores: ctrl.camposList, // Se deben enviar los valores más actualizados (16/01/2025)
                  MailsAdicionales: ctrl.mailsAdicionalesTab,
                };

                for (var i = 0; i < ctrl.procesoUsuariosNotificarTabList.length; i++)
                  notificacionTab.Usuarios.push(ctrl.procesoUsuariosNotificarTabList[i].Usuario);

                dataService.notificacionesCampoValor(notificacionTab).then(
                  function (response) {
                    if (response.data.Success) {
                    } else {
                      toastr.error(response.data.ErrorSummary);
                    }
                  },
                  function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                  }
                );
              }

              if (ctrl.generaProcesoRelacionados) {
                if (ctrl.camposTableEnr.length > 0) {
                  // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                  ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                    campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                    delete campoTableEnr.index
                    return campoTableEnr;
                  });
        
                  dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                    .then(function (response) {
                      if (response.data.Success) {
                        dataService
                        .SaveSolicitudCampoValorGeneraProcesosTemplates(ctrl.camposList)
                        .then(function (data) {
                          swal.close();

                          executeSPAndReaload();

                          // $state.go("pages.solicitud-edit", {
                          //   id: $stateParams.solicitud,
                          //   // grupo: $state.params.grupoId,
                          //   proceso: $stateParams.proceso,
                          //   solicitudPadreId: 0,
                          // });
                        });
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
                } else {
                  dataService
                    .SaveSolicitudCampoValorGeneraProcesosTemplates(ctrl.camposList)
                    .then(function (data) {
                      swal.close();

                      executeSPAndReaload();

                      // $state.go("pages.solicitud-edit", {
                      //   id: $stateParams.solicitud,
                      //   // grupo: $state.params.grupoId,
                      //   proceso: $stateParams.proceso,
                      //   solicitudPadreId: 0,
                      // });
                    });
                }
              } else {
                swal.close();

                if (ctrl.camposTableEnr.length > 0) {
                  // Si se cargó un campo tipo TABLEENR, se guardan los siguientes valores
                  ctrl.camposTableEnr = ctrl.camposTableEnr.map(function (campoTableEnr) {
                    campoTableEnr.Id = ctrl.camposList[campoTableEnr.index].Id;
                    delete campoTableEnr.index
                    return campoTableEnr;
                  });
        
                  dataService.saveCampoValorGrillaFilas(ctrl.camposTableEnr)
                    .then(function (response) {
                      if (response.data.Success) {
                        executeSPAndReaload();
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    });
                } else {
                  executeSPAndReaload();

                  // $state.go("pages.solicitud-edit", {
                  //   id: $stateParams.solicitud,
                  //   // grupo: $state.params.grupoId,
                  //   proceso: $stateParams.proceso,
                  //   solicitudPadreId: 0,
                  // });
                }
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
            swal.close();
          },
          function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
            swal.close();
          }
        );
      };

      ctrl.saveCamposAndExecSP = function () {
        // Este metodo se encarga de ejecutar todo el save, adicional ejecuta el SP del template 

        // if ($stateParams.solicitudProcesoTemplate > 0) {
        //   // Si la gestión (template) es nuevo


        // } else {
        //   // Si la gestión (template) se está editando

        // }

        saveCamposValorAndExecuteSP();

      }

      ctrl.preSaveCampos = function() {
        for (var i = 0; i < ctrl.camposList.length; i++) {
          ctrl.camposList[i].SolicitudProcesoTemplate.Resumen =
            ctrl.tituloCampoValor;

          if (ctrl.camposList[i].Campo.CampoTipo.Codigo == "TABLE") {
            if (ctrl.camposList[i].TablaFilas != null) {
              var filaValor = "";

              for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                if (j > 0) filaValor += "^";

                if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                  var colValor = "";

                  for (
                    var k = 0;
                    k < ctrl.camposList[i].TablaFilas[j].Valor.length;
                    k++
                  ) {
                    if (k > 0) colValor += "~";

                    colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                  }

                  filaValor += colValor;
                }
              }
            }
            ctrl.camposList[i].Valor = filaValor;
            ctrl.camposList[i].ValorObjeto = filaValor;
          }
          if (ctrl.camposList[i].Campo.CampoTipo.Codigo == "TABLEENR") {
            if (ctrl.camposList[i].TablaFilas != null) {
              var filaValor = "";
              for (var j = 0; j < ctrl.camposList[i].TablaFilas.length; j++) {
                if (j > 0)
                  filaValor += "^";

                if (ctrl.camposList[i].TablaFilas[j].Valor != null) {
                  // console.log("FIR NUL!!!!");
                  // console.log(ctrl.camposList[i].TablaFilas[j]);


                  var colValor = "";
                  for (var k = 0; k < ctrl.camposList[i].TablaFilas[j].Valor.length; k++) {
                    if (k > 0)
                      colValor += "~";
                    if (Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                      // console.log("ES UN ARRAY!!!!");
                      // console.log(JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]));
                      colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                    } else if (Object.prototype.toString.call(ctrl.camposList[i].TablaFilas[j].Valor[k]) === '[object Date]') {
                      // console.log(" ES LA FECHYA!!!");
                      colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                    } else if (typeof ctrl.camposList[i].TablaFilas[j].Valor[k] === 'object' && ctrl.camposList[i].TablaFilas[j].Valor[k] !== null && !Array.isArray(ctrl.camposList[i].TablaFilas[j].Valor[k])) {
                      // console.log("ES UN OBJECT");
                      // console.log(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                      if (ctrl.camposList[i].TablaFilas[j].Valor[k].Id) {
                        // Si dentro del valor, encuentras una prop Id, es un campo tipo LIST y sólo hace falta el Id, ya que se muestra en un <select>
                        colValor += ctrl.camposList[i].TablaFilas[j].Valor[k].Id;
                        // Guardando sólo el Id como número siempre en el valor de TablaFilas
                        ctrl.camposList[i].TablaFilas[j].Valor[k] = Number(ctrl.camposList[i].TablaFilas[j].Valor[k].Id);
                      } else {
                        // Si no, es un campo tipo MULTI_LIST, por lo que se eliminan las propiedades usadas por el front para que se limpie el registro y se pasa a texto
                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].TextoBusqueda;
                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].jerarquiaPadreId;
                        delete ctrl.camposList[i].TablaFilas[j].Valor[k].SourceObjetoTemp;

                        colValor += JSON.stringify(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                      }
                    } else {
                      // console.log(ctrl.camposList[i].TablaFilas[j].Valor[k]);
                      colValor += ctrl.camposList[i].TablaFilas[j].Valor[k];
                    }
                  }
                  filaValor += colValor;
                }
              }
            }
            ctrl.camposList[i].Valor = filaValor;
            ctrl.camposList[i].ValorObjeto = filaValor;
          }

          if (ctrl.camposList[i].Campo.CampoTipo.Codigo == "COND") {
            if (ctrl.camposList[i].TablaFilas != null) {
              var filaValor = "";
              //// console.log(ctrl.camposList[i].TablaFilas[0].Valor);
              try {
                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[0];
                filaValor += "~";

                filaValor += ctrl.camposList[i].TablaFilas[0].Valor[1];
              } catch (exception) {
                filaValor += "";
              }
            }
            ctrl.camposList[i].Valor = filaValor;
            ctrl.camposList[i].ValorObjeto = filaValor;
          }
        }
      }

      function initAutoSaveCounter() {
        if (ctrl.template.temporizadorGuardar == 0) return;
        
        var titleConfirm;
        if (ctrl.language == "español")
          titleConfirm = "Desea autoguardar?";
        else if (ctrl.language == "ingles")
          titleConfirm = "Autosafe?";
        else if (ctrl.language == "portugues")
          titleConfirm = "Salvar automaticamente?";
        else if (ctrl.language == "italiano")
          titleConfirm = "Desea autoguardar?";

        ctrl.autoSaveInterval = $interval(function() {
          if (ctrl.active == 0 && $('.swal2-container').length == 0) {
            // Solamente se mostrara la modal de autoguardado cuando se este en datos del proceo (active == 1) y si no hay otra instancia de swal abierta
            var confirmation = Swal.fire({
              title: titleConfirm,
              showCancelButton: true,
              confirmButtonColor: "#f99d3b",
              cancelButtonText: ctrl.cancelText,
              confirmButtonText: ctrl.acceptText,
            });

            confirmation.then(function(result) {
              if (result.value) {
                if (ctrl.isNew) {
                  // guardar la gestion y los campos y recargar
                  ctrl.preSaveCampos();

                  dataService.saveCampoValorNoValidaOblig(ctrl.camposList)
                  .then(function (response) {
                    if (response.data.Success) {
                      ctrl.camposList = response.data.Value;
                      $state.go("pages.solicitud-template", {
                        solicitud: ctrl.camposList[0].SolicitudProcesoTemplate.SolicitudId,
                        solicitudEstado: ctrl.camposList[0].SolicitudProcesoTemplate.SolicitudEstadoId,
                        procesoTemplate: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplateId,
                        template: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.TemplateId,
                        proceso: ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.ProcesoId,
                        solicitudProcesoTemplate: ctrl.camposList[0].SolicitudProcesoTemplateId,
                      });
                    } else {
                      toastr.error(response.data.ErrorSummary);
                    }
                    ctrl.isBusy = false;
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    ctrl.isBusy = false;
                  });
                } else {
                // solo guardar los campos y volverlos a renderizar
                  ctrl.preSaveCampos();

                  dataService.saveCampoValorNoValidaOblig(ctrl.camposList)
                  .then(function (response) {
                    if (response.data.Success) {
                      toastr.info(ctrl.successfulRegistration);
                      ctrl.camposList = response.data.Value;
                      for (var i = 0; i < ctrl.camposList.length; i++) {
                        loadCampoData(ctrl.camposList[i], i);
                      }
                    } else {
                      toastr.error(response.data.ErrorSummary);
                    }
                    ctrl.isBusy = false;
                  }, function (error) {
                    toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                    ctrl.isBusy = false;
                  });
                }
              }
            });
          }
        }, ctrl.template.temporizadorGuardar * 1000); // el tiempo llega en segundos por lo que hay que pasarlo a ms
      }

      $scope.$on('$destroy', function() {
        if (angular.isDefined(ctrl.autoSaveInterval)) {
          $interval.cancel(ctrl.autoSaveInterval);
          ctrl.autoSaveInterval = null;
        }
    });
    },
  });
})(window.angular);

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('Kahuna.pages.template').component('tablesPageCtrl', {
    templateUrl: 'app/pages/tables/editableRowTable.html',
    controller: function ($scope, $state, $filter, dataService, toastr, toastrConfig, $stateParams, $uibModal, editableOptions, editableThemes) {
  /** @ngInject */
  
  $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30'
      },
      {
        id: 6,
        firstName: 'Ann',
        lastName: 'Smith',
        username: '@ann',
        email: 'ann@gmail.com',
        age: '21'
      },
      {
        id: 7,
        firstName: 'Barbara',
        lastName: 'Black',
        username: '@barbara',
        email: 'barbara@yandex.ru',
        age: '43'
      },
      {
        id: 8,
        firstName: 'Sevan',
        lastName: 'Bagrat',
        username: '@sevan',
        email: 'sevan@outlook.com',
        age: '13'
      },
      {
        id: 9,
        firstName: 'Ruben',
        lastName: 'Vardan',
        username: '@ruben',
        email: 'ruben@gmail.com',
        age: '22'
      },
      {
        id: 10,
        firstName: 'Karen',
        lastName: 'Sevan',
        username: '@karen',
        email: 'karen@yandex.ru',
        age: '33'
      },
      {
        id: 11,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mark',
        email: 'mark@gmail.com',
        age: '38'
      },
      {
        id: 12,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@jacob',
        email: 'jacob@yandex.ru',
        age: '48'
      },
      {
        id: 13,
        firstName: 'Haik',
        lastName: 'Hakob',
        username: '@haik',
        email: 'haik@outlook.com',
        age: '48'
      },
      {
        id: 14,
        firstName: 'Garegin',
        lastName: 'Jirair',
        username: '@garegin',
        email: 'garegin@gmail.com',
        age: '40'
      },
      {
        id: 15,
        firstName: 'Krikor',
        lastName: 'Bedros',
        username: '@krikor',
        email: 'krikor@yandex.ru',
        age: '32'
      },
      {
        "id": 16,
        "firstName": "Francisca",
        "lastName": "Brady",
        "username": "@Gibson",
        "email": "franciscagibson@comtours.com",
        "age": 11
      },
      {
        "id": 17,
        "firstName": "Tillman",
        "lastName": "Figueroa",
        "username": "@Snow",
        "email": "tillmansnow@comtours.com",
        "age": 34
      },
      {
        "id": 18,
        "firstName": "Jimenez",
        "lastName": "Morris",
        "username": "@Bryant",
        "email": "jimenezbryant@comtours.com",
        "age": 45
      },
      {
        "id": 19,
        "firstName": "Sandoval",
        "lastName": "Jacobson",
        "username": "@Mcbride",
        "email": "sandovalmcbride@comtours.com",
        "age": 32
      },
      {
        "id": 20,
        "firstName": "Griffin",
        "lastName": "Torres",
        "username": "@Charles",
        "email": "griffincharles@comtours.com",
        "age": 19
      },
      {
        "id": 21,
        "firstName": "Cora",
        "lastName": "Parker",
        "username": "@Caldwell",
        "email": "coracaldwell@comtours.com",
        "age": 27
      },
      {
        "id": 22,
        "firstName": "Cindy",
        "lastName": "Bond",
        "username": "@Velez",
        "email": "cindyvelez@comtours.com",
        "age": 24
      },
      {
        "id": 23,
        "firstName": "Frieda",
        "lastName": "Tyson",
        "username": "@Craig",
        "email": "friedacraig@comtours.com",
        "age": 45
      },
      {
        "id": 24,
        "firstName": "Cote",
        "lastName": "Holcomb",
        "username": "@Rowe",
        "email": "coterowe@comtours.com",
        "age": 20
      },
      {
        "id": 25,
        "firstName": "Trujillo",
        "lastName": "Mejia",
        "username": "@Valenzuela",
        "email": "trujillovalenzuela@comtours.com",
        "age": 16
      },
      {
        "id": 26,
        "firstName": "Pruitt",
        "lastName": "Shepard",
        "username": "@Sloan",
        "email": "pruittsloan@comtours.com",
        "age": 44
      },
      {
        "id": 27,
        "firstName": "Sutton",
        "lastName": "Ortega",
        "username": "@Black",
        "email": "suttonblack@comtours.com",
        "age": 42
      },
      {
        "id": 28,
        "firstName": "Marion",
        "lastName": "Heath",
        "username": "@Espinoza",
        "email": "marionespinoza@comtours.com",
        "age": 47
      },
      {
        "id": 29,
        "firstName": "Newman",
        "lastName": "Hicks",
        "username": "@Keith",
        "email": "newmankeith@comtours.com",
        "age": 15
      },
      {
        "id": 30,
        "firstName": "Boyle",
        "lastName": "Larson",
        "username": "@Summers",
        "email": "boylesummers@comtours.com",
        "age": 32
      },
      {
        "id": 31,
        "firstName": "Haynes",
        "lastName": "Vinson",
        "username": "@Mckenzie",
        "email": "haynesmckenzie@comtours.com",
        "age": 15
      },
      {
        "id": 32,
        "firstName": "Miller",
        "lastName": "Acosta",
        "username": "@Young",
        "email": "milleryoung@comtours.com",
        "age": 55
      },
      {
        "id": 33,
        "firstName": "Johnston",
        "lastName": "Brown",
        "username": "@Knight",
        "email": "johnstonknight@comtours.com",
        "age": 29
      },
      {
        "id": 34,
        "firstName": "Lena",
        "lastName": "Pitts",
        "username": "@Forbes",
        "email": "lenaforbes@comtours.com",
        "age": 25
      },
      {
        "id": 35,
        "firstName": "Terrie",
        "lastName": "Kennedy",
        "username": "@Branch",
        "email": "terriebranch@comtours.com",
        "age": 37
      },
      {
        "id": 36,
        "firstName": "Louise",
        "lastName": "Aguirre",
        "username": "@Kirby",
        "email": "louisekirby@comtours.com",
        "age": 44
      },
      {
        "id": 37,
        "firstName": "David",
        "lastName": "Patton",
        "username": "@Sanders",
        "email": "davidsanders@comtours.com",
        "age": 26
      },
      {
        "id": 38,
        "firstName": "Holden",
        "lastName": "Barlow",
        "username": "@Mckinney",
        "email": "holdenmckinney@comtours.com",
        "age": 11
      },
      {
        "id": 39,
        "firstName": "Baker",
        "lastName": "Rivera",
        "username": "@Montoya",
        "email": "bakermontoya@comtours.com",
        "age": 47
      },
      {
        "id": 40,
        "firstName": "Belinda",
        "lastName": "Lloyd",
        "username": "@Calderon",
        "email": "belindacalderon@comtours.com",
        "age": 21
      },
      {
        "id": 41,
        "firstName": "Pearson",
        "lastName": "Patrick",
        "username": "@Clements",
        "email": "pearsonclements@comtours.com",
        "age": 42
      },
      {
        "id": 42,
        "firstName": "Alyce",
        "lastName": "Mckee",
        "username": "@Daugherty",
        "email": "alycedaugherty@comtours.com",
        "age": 55
      },
      {
        "id": 43,
        "firstName": "Valencia",
        "lastName": "Spence",
        "username": "@Olsen",
        "email": "valenciaolsen@comtours.com",
        "age": 20
      },
      {
        "id": 44,
        "firstName": "Leach",
        "lastName": "Holcomb",
        "username": "@Humphrey",
        "email": "leachhumphrey@comtours.com",
        "age": 28
      },
      {
        "id": 45,
        "firstName": "Moss",
        "lastName": "Baxter",
        "username": "@Fitzpatrick",
        "email": "mossfitzpatrick@comtours.com",
        "age": 51
      },
      {
        "id": 46,
        "firstName": "Jeanne",
        "lastName": "Cooke",
        "username": "@Ward",
        "email": "jeanneward@comtours.com",
        "age": 59
      },
      {
        "id": 47,
        "firstName": "Wilma",
        "lastName": "Briggs",
        "username": "@Kidd",
        "email": "wilmakidd@comtours.com",
        "age": 53
      },
      {
        "id": 48,
        "firstName": "Beatrice",
        "lastName": "Perry",
        "username": "@Gilbert",
        "email": "beatricegilbert@comtours.com",
        "age": 39
      },
      {
        "id": 49,
        "firstName": "Whitaker",
        "lastName": "Hyde",
        "username": "@Mcdonald",
        "email": "whitakermcdonald@comtours.com",
        "age": 35
      },
      {
        "id": 50,
        "firstName": "Rebekah",
        "lastName": "Duran",
        "username": "@Gross",
        "email": "rebekahgross@comtours.com",
        "age": 40
      },
      {
        "id": 51,
        "firstName": "Earline",
        "lastName": "Mayer",
        "username": "@Woodward",
        "email": "earlinewoodward@comtours.com",
        "age": 52
      },
      {
        "id": 52,
        "firstName": "Moran",
        "lastName": "Baxter",
        "username": "@Johns",
        "email": "moranjohns@comtours.com",
        "age": 20
      },
      {
        "id": 53,
        "firstName": "Nanette",
        "lastName": "Hubbard",
        "username": "@Cooke",
        "email": "nanettecooke@comtours.com",
        "age": 55
      },
      {
        "id": 54,
        "firstName": "Dalton",
        "lastName": "Walker",
        "username": "@Hendricks",
        "email": "daltonhendricks@comtours.com",
        "age": 25
      },
      {
        "id": 55,
        "firstName": "Bennett",
        "lastName": "Blake",
        "username": "@Pena",
        "email": "bennettpena@comtours.com",
        "age": 13
      },
      {
        "id": 56,
        "firstName": "Kellie",
        "lastName": "Horton",
        "username": "@Weiss",
        "email": "kellieweiss@comtours.com",
        "age": 48
      },
      {
        "id": 57,
        "firstName": "Hobbs",
        "lastName": "Talley",
        "username": "@Sanford",
        "email": "hobbssanford@comtours.com",
        "age": 28
      },
      {
        "id": 58,
        "firstName": "Mcguire",
        "lastName": "Donaldson",
        "username": "@Roman",
        "email": "mcguireroman@comtours.com",
        "age": 38
      },
      {
        "id": 59,
        "firstName": "Rodriquez",
        "lastName": "Saunders",
        "username": "@Harper",
        "email": "rodriquezharper@comtours.com",
        "age": 20
      },
      {
        "id": 60,
        "firstName": "Lou",
        "lastName": "Conner",
        "username": "@Sanchez",
        "email": "lousanchez@comtours.com",
        "age": 16
      }
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }
});
})(window.angular);

(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.template').component('templateEdit', {
    templateUrl: 'app/pages/template/edit.template.html',
    controller: function ($scope, $state, $filter, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      ctrl.model = {};
      ctrl.model.procedimientoRefresh = null;
      ctrl.model.tieneProcedimientoRefresh = false;
      // Seteando por defecto estas 2 propiedades en el modelo
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.showCampoTituloSelect = false;
      ctrl.title = '';

      ctrl.campoCargado = {};

      ctrl.templateCamposList = [];
      ctrl.tipoEnvioMailConfig = {};
      ctrl.tipoHabilitacionUsuarioConfig = {};
      ctrl.tipoRecursivoConfig = {};
      ctrl.campoTituloSeleccionado = null;

      ctrl.templateCamposDS = [];

      ctrl.camposList = [];
      ctrl.tipoTemplateList = [];
      ctrl.camposUsuarioList = [];
      ctrl.camposTemplateList = [];
      ctrl.camposBasicosList = [];
      ctrl.camposPeriodoList = [];
      ctrl.camposFechaList = [];

      this.$onInit = function () {
        loadView();
        ctrl.loadGrupos();
      };

      ctrl.loadGrupos = function () {
        ctrl.filtros = {
          // PageSize: 1000,
          PageSize: 5000,
          SkipNumber: 0
        };

        dataService.searchGruposUsuarios(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              // console.log("TRESPONSE USUARIOS");

              var defaultUser = {
                Id: 0,
                Nombre: ""
              }
              ctrl.GruposUsuariosList = [];
              ctrl.GruposUsuariosList.push(defaultUser);
              ctrl.GruposUsuariosList = ctrl.GruposUsuariosList.concat(response.data.Value.Resultados);
              // console.log(ctrl.GruposUsuariosList);

            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });

      }


      function loadView() {
        dataService.getTipoTemplateList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.tipoTemplateList = response.data.Value;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        // dataService.getCampoList()
        //   .then(function (response) {
        //     if (response.data.Success) {
        //       ctrl.camposList = response.data.Value;
        //     } else {
        //       toastr.error(response.data.ErrorSummary);
        //     }
        //   }, function (error) {
        //     toastr.error(error.data || sharedService.getGenericErrorMessage(error));
        //   });

        if ($stateParams.id != "0") {
          dataService.getTemplateById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;

                ctrl.title = 'Editar Gestión: ' + ctrl.model.Nombre;

                ctrl.templateCamposList = ctrl.model.Campos;
                ctrl.actualizarTituloConfigText();

                switch (ctrl.model.TipoTemplate.Codigo) {
                  case 'CREA_NOTI_DOC':
                    dataService.getTipoTemplateEnvioMailConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoEnvioMailConfig = response.data.Value;
                          ctrl.model.CuerpoMensaje = ctrl.tipoEnvioMailConfig.CuerpoMensaje;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      });
                    break;
                  case 'ENVIO_MAIL':
                    dataService.getTipoTemplateEnvioMailConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoEnvioMailConfig = response.data.Value;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      });

                    break;

                  case 'HAB_USUARIO':

                    dataService.getTipoTemplateHabilitacionUsuarioConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoHabilitacionUsuarioConfig = response.data.Value;
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      });

                    break;

                  case 'RECURSIVO':

                    dataService.getTipoTemplateRecursivoConfiguracion($stateParams.id)
                      .then(function (response) {
                        if (response.data.Success) {
                          ctrl.tipoRecursivoConfig = response.data.Value;

                          if (ctrl.templateCamposList != null &&
                            ctrl.tipoRecursivoConfig.CamposPorRepetirObject != null && ctrl.tipoRecursivoConfig.CamposPorRepetirObject.length > 0) {
                            for (var i = 0; i < ctrl.templateCamposList.length; i++) {
                              ctrl.templateCamposList[i].Campo.Seleccionado = false;

                              for (var j = 0; j < ctrl.tipoRecursivoConfig.CamposPorRepetirObject.length; j++) {
                                if (ctrl.tipoRecursivoConfig.CamposPorRepetirObject[j] == ctrl.templateCamposList[i].CampoId) {
                                  ctrl.templateCamposList[i].Campo.Seleccionado = true;
                                  break;
                                }
                              }
                            }
                          }
                        } else {
                          toastr.error(response.data.ErrorSummary);
                        }
                      }, function (error) {
                        toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      });

                    break;
                }
              } else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        } else {
          ctrl.title = 'Crear Gestión: -';
        }
      }

      ctrl.loadTipoTemplateTab = function () {
        ctrl.camposUsuarioList = [];
        ctrl.camposTemplateList = [];
        ctrl.camposBasicosList = [];
        ctrl.camposPeriodoList = [];
        ctrl.camposFechaList = [];

        if (ctrl.templateCamposList == null || ctrl.templateCamposList.length <= 0)
          return;

        for (var i = 0; i < ctrl.templateCamposList.length; i++) {
          var tipo = ctrl.templateCamposList[i].Campo.CampoTipo.Codigo;

          if (tipo == 'PERIODO')
            ctrl.camposPeriodoList.push(ctrl.templateCamposList[i].Campo);

          if (tipo == 'DATE')
            ctrl.camposFechaList.push(ctrl.templateCamposList[i].Campo);

          switch (tipo) {
            case 'USER':
              ctrl.camposUsuarioList.push(ctrl.templateCamposList[i].Campo);
              break;

            case 'TEMPLATE':
              ctrl.camposTemplateList.push(ctrl.templateCamposList[i].Campo);
              break;

            default:
              ctrl.camposBasicosList.push(ctrl.templateCamposList[i].Campo);
              break;
          }
        }
      }

      ctrl.actualizarTitulo = function () {
        if (ctrl.model != null) {
          if ($stateParams.id != "0")
            ctrl.title = 'Editar Gestión: ' + ctrl.model.Nombre;
          else
            ctrl.title = 'Crear Gestión: ' + ctrl.model.Nombre;
        }
      }

      ctrl.editCampo = function () {
        if (ctrl.campoCargado.Orden <= 0 ||
          ctrl.campoCargado.Orden == null ||
          ctrl.campoCargado.Orden == '' ||
          ctrl.campoCargado.Campo == null ||
          ctrl.campoCargado.Campo.Id == 0) {
          toastr.error('Por favor complete todos los campos obligatorios del campo para agregarlo');
          return;
        }

        if (ctrl.campoCargado.Obligatorio == null)
          ctrl.campoCargado.Obligatorio = false;

        ctrl.campoCargado.TemplateId = ctrl.model.Id;
        ctrl.campoCargado.CampoId = ctrl.campoCargado.Campo.Id;

        if (ctrl.templateCamposList == null)
          ctrl.templateCamposList = [];

        var index = -1;
        for (var i = 0; i < ctrl.templateCamposList.length; i++) {
          if (ctrl.templateCamposList[i].Campo.Id != ctrl.campoCargado.Campo.Id &&
            ctrl.templateCamposList[i].Orden == ctrl.campoCargado.Orden) {
            toastr.error('Por favor ingrese un número de orden distinto ya que el ingresado ya existe');
            return;
          }

          if (ctrl.templateCamposList[i].Campo.Id == ctrl.campoCargado.Campo.Id)
            index = i;
        }

        if (index >= 0)
          ctrl.templateCamposList[index] = ctrl.campoCargado;
        else
          ctrl.templateCamposList.push(ctrl.campoCargado);

        ctrl.templateCamposList.sort(function (a, b) {
          return (parseInt(a.Orden) > parseInt(b.Orden) ? 1 : (parseInt(b.Orden) > parseInt(a.Orden)) ? -1 : 0);
        });
        ctrl.templateCamposDS = ctrl.templateCamposList;
        ctrl.campoCargado = {};
      }

      ctrl.cargarCampo = function (campoSeleccionado) {
        if (campoSeleccionado == null) {
          toastr.error('Por favor seleccione un campo para poder visualizarlo');
          return;
        }

        ctrl.campoCargado = {};

        ctrl.campoCargado.Id = campoSeleccionado.Id;
        ctrl.campoCargado.TemplateId = campoSeleccionado.TemplateId;
        ctrl.campoCargado.Campo = campoSeleccionado.Campo;
        ctrl.campoCargado.Orden = campoSeleccionado.Orden;
        ctrl.campoCargado.Obligatorio = campoSeleccionado.Obligatorio;
      }

      ctrl.eliminarCampo = function (index) {
        if (index < 0) {
          toastr.error('Campo seleccionado inválido');
          return;
        }

        if (ctrl.templateCamposList != null && ctrl.templateCamposList.length > 0)
          ctrl.templateCamposList.splice(index, 1);
      }

      ctrl.clearCampo = function () {
        ctrl.campoCargado = {};
      }

      ctrl.buscarCampoTitulo = function (show) {
        ctrl.showCampoTituloSelect = show;
      }

      ctrl.onSelectCampoTitulo = function (campoSeleccionado) {
        if (campoSeleccionado != null && campoSeleccionado.Campo != null) {
          if (ctrl.model.ConfiguracionTitulo == null)
            ctrl.model.ConfiguracionTitulo = "";

          var position = $("#configuracionTitulo")[0].selectionStart;
          ctrl.model.ConfiguracionTitulo = [ctrl.model.ConfiguracionTitulo.slice(0, position), "{{" + campoSeleccionado.Campo.Id + "}}", ctrl.model.ConfiguracionTitulo.slice(position)].join('');
          ctrl.actualizarTituloConfigText();

          ctrl.showCampoTituloSelect = false;
          ctrl.campoTituloSeleccionado = null;
        }
      }

      ctrl.actualizarTituloConfigText = function () {
        ctrl.configuracionTituloText = "...";

        if (ctrl.model.ConfiguracionTitulo != null && ctrl.model.ConfiguracionTitulo.length > 0) {
          dataService.getTemplateTituloConfigText(ctrl.model)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.configuracionTituloText = response.data.Value;
              } else {
                toastr.error(response.data.ErrorSummary);
                ctrl.configuracionTituloText = "";
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.configuracionTituloText = "";
            });
        } else
          ctrl.configuracionTituloText = "";
      }

      ctrl.save = function (form) {
        if (ctrl.model.Codigo == null ||
          ctrl.model.Codigo == '' ||
          ctrl.model.Nombre == null ||
          ctrl.model.Nombre == '' ||
          ctrl.model.TipoTemplate == null ||
          ctrl.model.TipoTemplate.Id <= 0) {
          toastr.error('Por favor complete todos los datos obligatorios marcados con asterisco');
          return;
        }

        if (ctrl.templateCamposList == null ||
          ctrl.templateCamposList.length <= 0) {
          toastr.error('Seleccione al menos un campo para formar parte de la gestión');
          return;
        }

        if (ctrl.model.ConfiguracionTitulo == null ||
          ctrl.model.ConfiguracionTitulo.length <= 0) {
          toastr.error('Por favor inserte la Configuración de Título');
          return;
        }
    
        if (ctrl.model.tieneProcedimientoRefresh == true && (ctrl.model.procedimientoRefresh == null ||
          ctrl.model.procedimientoRefresh.length <= 0)) {
          toastr.error('Debe completar el nombre del Procedimiento Refresh');
          return;
        }

        switch (ctrl.model.TipoTemplate.Codigo) {
          case 'ESTANDAR':
            ctrl.tipoEnvioMailConfig = {};
            ctrl.tipoHabilitacionUsuarioConfig = {};
            break;
          case 'CREA_NOTI_DOC':
            if (ctrl.tipoEnvioMailConfig.CampoDestinatario == null ||
              ctrl.model.CuerpoMensaje == null) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de gestión Creación y Notificación Documental');
              return;
            }
            //ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;
            break;
          case 'ENVIO_MAIL':
            if (ctrl.tipoEnvioMailConfig == null ||
              ctrl.tipoEnvioMailConfig.CampoMensaje == null ||
              ctrl.tipoEnvioMailConfig.CampoMensaje.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de gestión Envío de Mail');
              return;
            }
            ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;
            break;
          case 'HAB_USUARIO':
            if (ctrl.tipoHabilitacionUsuarioConfig == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id <= 0 ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id <= 0 ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar == null ||
              ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de gestión Habilitación de Usuario');
              return;
            }

            ctrl.tipoHabilitacionUsuarioConfig.CampoMensajeId = ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id;
            ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id;
            ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id;
            break;
          case 'RECURSIVO':
            if (ctrl.tipoRecursivoConfig == null ||
              ctrl.tipoRecursivoConfig.CampoCondicion == null ||
              ctrl.tipoRecursivoConfig.CampoCondicion.Id <= 0 ||
              ctrl.tipoRecursivoConfig.CampoFechaInicia == null ||
              ctrl.tipoRecursivoConfig.CampoFechaInicia.Id <= 0 ||
              ctrl.tipoRecursivoConfig.CampoPeriodicidad == null ||
              ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id <= 0) {
              toastr.error('Por favor complete todos los datos obligatorios para el tipo de gestión Recursivo');
              return;
            }
            ctrl.tipoRecursivoConfig.CampoFechaIniciaId = ctrl.tipoRecursivoConfig.CampoFechaInicia.Id;
            ctrl.tipoRecursivoConfig.CampoPeriodicidadId = ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id;
            break;
          default:
            toastr.error('Tipo de gestión desconocido (' + ctrl.model.TipoTemplate.Codigo + ')');
            return;
            break;
        }

        ctrl.isBusy = true;

        // ctrl.model.Activo = 1;
        ctrl.model.TipoTemplateId = ctrl.model.TipoTemplate.Id;
        ctrl.model.Campos = ctrl.templateCamposList;

        dataService.saveTemplate(ctrl.model)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.model.Id = response.data.Value.Id;

              switch (ctrl.model.TipoTemplate.Codigo) {
                case 'CREA_NOTI_DOC':
                  ctrl.tipoEnvioMailConfig.TemplateId = ctrl.model.Id;
                  if (ctrl.tipoEnvioMailConfig.CampoDestinatario != null)
                    ctrl.tipoEnvioMailConfig.CampoDestinatarioId = ctrl.tipoEnvioMailConfig.CampoDestinatario.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoCopia != null)
                    ctrl.tipoEnvioMailConfig.CampoCopiaId = ctrl.tipoEnvioMailConfig.CampoCopia.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoAsunto != null)
                    ctrl.tipoEnvioMailConfig.CampoAsuntoId = ctrl.tipoEnvioMailConfig.CampoAsunto.Id;

                  if (ctrl.model.CuerpoMensaje != null)
                    ctrl.tipoEnvioMailConfig.CuerpoMensaje = ctrl.model.CuerpoMensaje;

                  dataService.saveTipoTemplateEnvioMailConfiguracion(ctrl.tipoEnvioMailConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Registro exitoso.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      ctrl.isBusy = false;
                    });

                  break;
                case 'ENVIO_MAIL':
                  ctrl.tipoEnvioMailConfig.TemplateId = ctrl.model.Id;
                  if (ctrl.tipoEnvioMailConfig.CampoDestinatario != null)
                    ctrl.tipoEnvioMailConfig.CampoDestinatarioId = ctrl.tipoEnvioMailConfig.CampoDestinatario.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoCopia != null)
                    ctrl.tipoEnvioMailConfig.CampoCopiaId = ctrl.tipoEnvioMailConfig.CampoCopia.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoAsunto != null)
                    ctrl.tipoEnvioMailConfig.CampoAsuntoId = ctrl.tipoEnvioMailConfig.CampoAsunto.Id;

                  if (ctrl.tipoEnvioMailConfig.CampoMensaje != null)
                    ctrl.tipoEnvioMailConfig.CampoMensajeId = ctrl.tipoEnvioMailConfig.CampoMensaje.Id;

                  dataService.saveTipoTemplateEnvioMailConfiguracion(ctrl.tipoEnvioMailConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Registro exitoso.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      ctrl.isBusy = false;
                    });

                  break;

                case 'HAB_USUARIO':

                  ctrl.tipoHabilitacionUsuarioConfig.TemplateId = ctrl.model.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitarId = ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoCopia != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoCopiaId = ctrl.tipoHabilitacionUsuarioConfig.CampoCopia.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoAsuntoId = ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto.Id;

                  if (ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje != null)
                    ctrl.tipoHabilitacionUsuarioConfig.CampoMensajeId = ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje.Id;

                  dataService.saveTipoTemplateHabilitacionUsuarioConfiguracion(ctrl.tipoHabilitacionUsuarioConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Registro exitoso.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      ctrl.isBusy = false;
                    });

                  break;

                case 'RECURSIVO':

                  ctrl.tipoRecursivoConfig.TemplateId = ctrl.model.Id;

                  if (ctrl.tipoRecursivoConfig.CampoCondicion != null)
                    ctrl.tipoRecursivoConfig.CampoCondicionId = ctrl.tipoRecursivoConfig.CampoCondicion.Id;

                  if (ctrl.tipoRecursivoConfig.CampoFechaInicia != null)
                    ctrl.tipoRecursivoConfig.CampoFechaIniciaId = ctrl.tipoRecursivoConfig.CampoFechaInicia.Id;

                  if (ctrl.tipoRecursivoConfig.CampoPeriodicidad != null)
                    ctrl.tipoRecursivoConfig.CampoPeriodicidadId = ctrl.tipoRecursivoConfig.CampoPeriodicidad.Id;

                  ctrl.tipoRecursivoConfig.CamposPorRepetirObject = [];

                  if (ctrl.templateCamposList != null) {
                    for (var i = 0; i < ctrl.templateCamposList.length; i++) {
                      if (ctrl.templateCamposList[i].Campo.Seleccionado)
                        ctrl.tipoRecursivoConfig.CamposPorRepetirObject.push(ctrl.templateCamposList[i].CampoId);
                    }
                  }

                  dataService.saveTipoTemplateRecursivoConfiguracion(ctrl.tipoRecursivoConfig)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Registro exitoso.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      ctrl.isBusy = false;
                    });

                  break;

                default:
                  dataService.deleteTipoTemplateConfiguracion(ctrl.model.Id)
                    .then(function (response) {
                      if (response.data.Success) {
                        toastr.info("Registro exitoso.");
                        $state.transitionTo("pages.template");
                      } else {
                        toastr.error(response.data.ErrorSummary);
                      }
                      ctrl.isBusy = false;
                    }, function (error) {
                      toastr.error(error.data || sharedService.getGenericErrorMessage(error));
                      ctrl.isBusy = false;
                    });
                  break;
              }
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.template");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;
        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () {
              return "Atención"
            },
            message: function () {
              return "Confirma el borrado de Gestión?"
            },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteTemplate(ctrl.model.Id)
            .then(function (response) {
              if (response.data.Success) {
                toastr.info("Registro exitoso.");
                $state.transitionTo("pages.template");
              } else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
            });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.searchCampo = function (campoNombre) {
        var filtroCampo = {
          Nombre: campoNombre,
          PageSize: 500, // 20,
          SkipNumber: 0
        };

        return dataService.searchCampo(filtroCampo)
          .then(function (response) {
            if (response.data.Success) {
              return response.data.Value.Resultados;
            } else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.template').component('templateList', {
    templateUrl: 'app/pages/template/list.template.html',
    controller: function ($scope,$state,dataService,sharedService,toastr) {
      var ctrl = this;
      ctrl.anularVista = true;
      
      this.$onInit = function () 
      {
        ctrl.anularVista = !sharedService.isSysAdminLoggedUser();
      };

      ctrl.buscar = function buscar(tableState) 
      {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0;     // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10;  // Number of entries showed per page.

        ctrl.filtros = { PageSize: number, SkipNumber: start };

        if (tableState.search.predicateObject != null)
        {
          ctrl.filtros.Codigo = tableState.search.predicateObject.Codigo;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.TipoTemplate = tableState.search.predicateObject.TipoTemplate;

          if (tableState.search.predicateObject.Activo != null)
          {
            if (tableState.search.predicateObject.Activo == "1" || tableState.search.predicateObject.Activo.toLowerCase() == "true")
              ctrl.filtros.Activo = true;

            if (tableState.search.predicateObject.Activo == "0" || tableState.search.predicateObject.Activo.toLowerCase() == "false")
              ctrl.filtros.Activo = false;
          }
        }

        if (tableState.sort != null)
        {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchTemplate(ctrl.filtros)
          .then(function (response) 
          {
            if (response.data.Success)
            {               
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados/number); //result.numberOfPages;//set the number of pages so the pagination can update
            } 
            else 
            {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
        });
      };
      
      ctrl.add = function ()
      {
        $state.go("pages.template-edit",{id:0});
      }

      ctrl.edit = function (id)
      {
        $state.go("pages.template-edit",{id:id});
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.template').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.template', {
          url: '/template',
          title: 'Gestion',
          template : '<template-list></template-list>',
          authenticate: true,
        })
        .state('pages.template-edit', {
          url: '/template/edit/:id',
          title: 'Gestion',
          template : '<template-edit></template-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.usuario').component('usuarioEdit', {
    templateUrl: 'app/pages/usuario/edit.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr, toastrConfig, $stateParams, $uibModal) {
      var ctrl = this;
      var authData = {};
      ctrl.language = sharedService.getLanguage();
      ctrl.model = {};
      ctrl.modelToSave = {};
      ctrl.isBusy = false;
      ctrl.showDelete = false;
      ctrl.title = 'Datos del Usuario';
      ctrl.rolesList = {};
      ctrl.rolesSeleccionados = null;
      ctrl.mailIngresado = null;
      ctrl.model.CanCreateProcess = true;
      ctrl.lUsuarioLogeado = {};
      ctrl.lsuarioLogueadoIsSysAdmin = false;

      this.$onInit = function () {
        ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSuperAdminLoggedUser();
        // console.log(ctrl.lsuarioLogueadoIsSysAdmin);
        authData = sharedService.getLoggedUser();
        if (authData != null && authData.Id > 0) {
          ctrl.lUsuarioLogeado = authData;
          // console.log(ctrl.lUsuarioLogeado);
        } else {
          $state.go('auth');
        }

        var userListTitle, editingTitle, creatingTitle;

        if (ctrl.language == "español") {
          userListTitle = 'Usuario';
          ctrl.successfulRegistration = "Registro exitoso.";
          editingTitle = "Editar Usuario";
          creatingTitle = "Crear Usuario";

        } else if (ctrl.language == "ingles") {
          userListTitle = 'User';
          ctrl.successfulRegistration = "Registration successful.";
          editingTitle = "Edit User";
          creatingTitle = "Create User";

        } else if (ctrl.language == "portugues") {
          userListTitle = 'Usuário';
          ctrl.successfulRegistration = "Registro bem-sucedido.";
          editingTitle = "Editar Usuário";
          creatingTitle = "Criar Usuário";

        } else if (ctrl.language == "italiano") {
          userListTitle = 'Usuario';
          ctrl.successfulRegistration = "Registro exitoso.";
          editingTitle = "Editar Usuario";
          creatingTitle = "Crear Usuario";
        }

        $state.current.title = userListTitle;

        dataService.getRolesList()
          .then(function (response) {
            if (response.data.Success) {
              ctrl.rolesList = response.data.Value;
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
          });

        if ($stateParams.id != "0") {
          ctrl.title = editingTitle;

          dataService.getUsuarioById($stateParams.id)
            .then(function (response) {
              if (response.data.Success) {
                ctrl.showDelete = true;
                ctrl.model = response.data.Value;

                ctrl.model.ConfirmaClave = ctrl.model.Clave;
                ctrl.rolesSeleccionados = [];

                if (ctrl.model.Roles != null && ctrl.model.Roles.length > 0) {
                  for (var i = 0; i < ctrl.model.Roles.length; i++)
                    ctrl.rolesSeleccionados.push(ctrl.model.Roles[i].Rol);
                }
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            });
        }
        else {
          ctrl.title = creatingTitle;
        }
      };


      ctrl.save = function (form) {
        var completeMandatoryText, passwordsText, checkPasswordText, selectRolText;

        if (ctrl.language == "español") {
          completeMandatoryText = "Por favor complete todos los campos obligatorios";
          passwordsText = "Por favor verifique que la contraseña ingresada y su confirmación sean iguales";
          checkPasswordText = "Por favor verifique que la contraseña debe contener una letra, un numero y un caracter especial. Longitud [3-6]";
          selectRolText = "Debe seleccionar al menos un rol";
        } else if (ctrl.language == "ingles") {
          completeMandatoryText = "Complete all required fields";
          passwordsText = "Please ensure the entered password and its confirmation match";
          checkPasswordText = "Please ensure the password contains a letter, a number, and a special character. Length [3-6]";
          selectRolText = "You must select at least one role";
        } else if (ctrl.language == "portugues") {
          completeMandatoryText = "Preencha todos os campos obrigatórios";
          passwordsText = "Verifique se a senha digitada e a sua confirmação são as mesmas";
          checkPasswordText = "Verifique se a senha deve conter uma letra, um número e um caractere especial. Comprimento [3-6]";
          selectRolText = "Deve selecionar pelo menos um perfil";
        } else if (ctrl.language == "italiano") {
          completeMandatoryText = "Por favor complete todos los campos obligatorios";
          passwordsText = "Por favor verifique que la contraseña ingresada y su confirmación sean iguales";
          checkPasswordText = "Por favor verifique que la contraseña debe contener una letra, un numero y un caracter especial. Longitud [3-6]";
          selectRolText = "Debe seleccionar al menos un rol";
        }

        if (ctrl.model.Login == null ||
          ctrl.model.Login == '' ||
          ctrl.model.Clave == null ||
          ctrl.model.Clave == '') {
          toastr.error(completeMandatoryText);
          return;
        }

        if (ctrl.model.Clave != ctrl.model.ConfirmaClave) {
          toastr.error(passwordsText);
          return;
        }

        if (!dataService.checkpassword(ctrl.model.Clave)) {
          toastr.error(checkPasswordText);
          return;
        }

        if (ctrl.rolesSeleccionados == null || ctrl.rolesSeleccionados.length <= 0) {
          toastr.error(selectRolText);
          return;
        }

        ctrl.model.Roles = [];
        ctrl.model.Activo = 1;

        for (var i = 0; i < ctrl.rolesSeleccionados.length; i++) {
          ctrl.model.Roles.push({
            RolId: ctrl.rolesSeleccionados[i].Id,
            Rol: ctrl.rolesSeleccionados[i],
            UsuarioId: ctrl.model.Id
          });
        }

        ctrl.isBusy = true;

        // Modelo que se va a modificar antes de enviarlo al backend para no perjudicar la vista
        // ctrl.modelToSave = ctrl.model;
        ctrl.modelToSave = Object.assign({}, ctrl.model);

        // Si alguno de los siguientes inputs, NO fue tocado, se les da un valor de null para que el backend no los guarde nuevamente, sino que sólo guarde lo que se cambió, esto porque antes de este cambio, se guardaba todo y la contraseña se encriptaba cada vez que se guardaba el usuario así no se hubiera cambiado la contraseña 
        if (!form.login.$dirty) {
          ctrl.modelToSave.Login = null;
        } else {
          ctrl.modelToSave.Login = ctrl.model.Login;
        }

        if (!form.clave.$dirty) {
          ctrl.modelToSave.Clave = null;
        } else {
          ctrl.modelToSave.Clave = ctrl.model.Clave;
        }

        if (!form.roles.$dirty) {
          ctrl.modelToSave.Roles = null;
        } else {
          ctrl.modelToSave.Roles = ctrl.model.Roles;
        }

        if (!form.name.$dirty) {
          ctrl.modelToSave.Nombre = null;
        } else {
          ctrl.modelToSave.Nombre = ctrl.model.Nombre;
        }

        if (!form.apellido.$dirty) {
          ctrl.modelToSave.Apellido = null;
        } else {
          ctrl.modelToSave.Apellido = ctrl.model.Apellido;
        }

        ctrl.modelToSave.ConfirmaClave = null;
        ctrl.modelToSave.NombreMostrar = null;
        ctrl.modelToSave.token = null;
        ctrl.modelToSave.CreationDate = null;
        ctrl.modelToSave.LastUpdate = null;

        dataService.saveUsuario(ctrl.modelToSave)
          .then(function (response) {
            if (response.data.Success) {
              toastr.info(ctrl.successfulRegistration);
              $state.transitionTo("pages.usuario");
            }
            else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isBusy = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isBusy = false;
          });
      }

      ctrl.cancel = function () {
        $state.transitionTo("pages.usuario");
      }

      ctrl.delete = function () {
        ctrl.isBusy = true;

        var modalTitle, modalMessage;

        if (ctrl.language == "español") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado del usuario?";
        } else if (ctrl.language == "ingles") {
          modalTitle = "Attention";
          modalMessage = "Do you confirm the deletion of the user?";
        } else if (ctrl.language == "portugues") {
          modalTitle = "Atenção";
          modalMessage = "Confirma a exclusão do usuário?";
        } else if (ctrl.language == "italiano") {
          modalTitle = "Atención";
          modalMessage = "Confirma el borrado del usuario?";
        }

        var confirmation = $uibModal.open({
          animation: true,
          component: "confirmation",
          resolve: {
            title: function () { return modalTitle },
            message: function () { return modalMessage },
          }
        });

        confirmation.result.then(function (selectedItem) {
          dataService.deleteUsuario(ctrl.model.Id)
            .then(function (response) {
              if (response.data.Success) {
                toastr.info(ctrl.successfulRegistration);
                $state.transitionTo("pages.usuario");
              }
              else {
                toastr.error(response.data.ErrorSummary);
              }
              ctrl.isBusy = false;
            }, function (error) {
              toastr.error(error.data || sharedService.getGenericErrorMessage(error));
              ctrl.isBusy = false;
            });
        }, function () {
          ctrl.isBusy = false;
        });
      }

      ctrl.addMail = function () {
        var enterEmailText, checlEmailText, emailAlreadyExistText;

        if (ctrl.language == "español") {
          enterEmailText = "Por favor ingrese un correo electrónico";
          checlEmailText = "El formato del correo electrónico es inválido";
          emailAlreadyExistText = "El correo electrónico ya fue ingresado";
        } else if (ctrl.language == "ingles") {
          enterEmailText = "Enter an email address";
          checlEmailText = "Invalid email format";
          emailAlreadyExistText = "The email address has already been registered";
        } else if (ctrl.language == "portugues") {
          enterEmailText = "Por favor, insira um e-mail";
          checlEmailText = "O formato do e-mail é inválido";
          emailAlreadyExistText = "O e-mail já foi inserido";
        } else if (ctrl.language == "italiano") {
          enterEmailText = "Por favor ingrese un correo electrónico";
          checlEmailText = "El formato del correo electrónico es inválido";
          emailAlreadyExistText = "El correo electrónico ya fue ingresado";
        }

        if (ctrl.mailIngresado == null || ctrl.mailIngresado.length <= 0) {
          toastr.error(enterEmailText);
          return;
        }

        if (!sharedService.checkEmailFormat(ctrl.mailIngresado)) {
          toastr.error(checlEmailText);
          return;
        }

        if (ctrl.model.Mails == null)
          ctrl.model.Mails = [];

        for (var i = 0; i < ctrl.model.Mails.length; i++) {
          if (ctrl.model.Mails[i].Mail == ctrl.mailIngresado) {
            toastr.error(emailAlreadyExistText);
            return;
          }
        }

        ctrl.model.Mails.push({ UsuarioId: ctrl.model.Id, Mail: ctrl.mailIngresado });
        ctrl.mailIngresado = '';
      }

      ctrl.eliminarMail = function (index) {
        if (ctrl.model.Mails != null && ctrl.model.Mails.length > 0) {
          ctrl.model.Mails.splice(index, 1);
        }
      }
    }
  });
})(window.angular);
(function (angular) {
  'use strict';
  angular.module('Kahuna.pages.usuario').component('usuarioList', {
    templateUrl: 'app/pages/usuario/list.template.html',
    controller: function ($scope, $state, dataService, sharedService, toastr) {
      var ctrl = this;
      ctrl.language = sharedService.getLanguage();
      ctrl.filtros = {};
      ctrl.lsuarioLogueadoIsSysAdmin = false;

      this.$onInit = function () {
        var authData = sharedService.getLoggedUser();
        if (authData != null && authData.Id > 0) {
          ctrl.lsuarioLogueadoIsSysAdmin = sharedService.isSysAdminLoggedUser();

          var userListTitle;

          if (ctrl.language == "español")
            userListTitle = 'Usuario';
          else if (ctrl.language == "ingles")
            userListTitle = 'User';
          else if (ctrl.language == "portugues")
            userListTitle = 'Usuário';
          else if (ctrl.language == "italiano")
            userListTitle = 'Usuario';

          $state.current.title = userListTitle;

        } else {
          $state.go('auth');
        }
      };

      ctrl.buscar = function buscar(tableState) {
        ctrl.isSearching = true;

        var pagination = tableState.pagination;

        var start = pagination.start || 0; // This is NOT the page number, but the index of item in the list that you want to use to display the table.
        var number = pagination.number || 10; // Number of entries showed per page.

        ctrl.filtros = {
          PageSize: number,
          SkipNumber: start
        };

        if (tableState.search.predicateObject != null) {
          ctrl.filtros.Login = tableState.search.predicateObject.Login;
          ctrl.filtros.Nombre = tableState.search.predicateObject.Nombre;
          ctrl.filtros.Apellido = tableState.search.predicateObject.Apellido;
          ctrl.filtros.Mail = tableState.search.predicateObject.Mail;
        }

        if (tableState.sort != null) {
          ctrl.filtros.OrderFieldName = tableState.sort.predicate;
          ctrl.filtros.OrderAscending = !tableState.sort.reverse;
        }

        dataService.searchUsuario(ctrl.filtros)
          .then(function (response) {
            if (response.data.Success) {
              ctrl.resultList = response.data.Value.Resultados;
              //ctrl.totalResultados = response.data.Value.TotalResultados;

              tableState.pagination.numberOfPages = Math.ceil(response.data.Value.TotalResultados / number); //result.numberOfPages;//set the number of pages so the pagination can update
            } else {
              toastr.error(response.data.ErrorSummary);
            }
            ctrl.isSearching = false;
          }, function (error) {
            toastr.error(error.data || sharedService.getGenericErrorMessage(error));
            ctrl.isSearching = false;
          });
      };

      ctrl.add = function () {
        $state.go("pages.usuario-edit", {
          id: 0
        });
      }

      ctrl.edit = function (id) {
        $state.go("pages.usuario-edit", {
          id: id
        });
      }
    }
  });
})(window.angular);
(function () {
    'use strict';
    angular.module('Kahuna.pages.usuario').config(routeConfig);
    function routeConfig($stateProvider) {
      $stateProvider
        .state('pages.usuario', {
          url: '/usuario',
          title: '',
          template : '<usuario-list></usuario-list>',
          authenticate: true,
        })
        .state('pages.usuario-edit', {
          url: '/usuario/edit/:id',
          title: '',
          template : '<usuario-edit></usuario-edit>',
          params: {id:null},
          authenticate: true,
        });
    }
  })();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 7500,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-center',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('listadoHistorialAutorizacion', listadoHistorialAutorizacion);

  /** @ngInject */
  function listadoHistorialAutorizacion($timeout, $rootScope) {
    // console.log("entro al modal Directiva listadoHistorialAutorizacion");
    return {
      templateUrl: 'app/theme/directives/templateshtml/listHistorialAutorizacion.html'
    };
  }
})();
(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('listadoUsuariosAutorizacion', listadoUsuariosAutorizacion);

  /** @ngInject */
  function listadoUsuariosAutorizacion($timeout, $rootScope) {
    // console.log("entro al modal Directiva listadoUsuariosAutorizacion");
    return {
      templateUrl: 'app/theme/directives/templateshtml/listUsuariosAutorizacion.html'
    };
  }
})();

(function () {
  'use strict';
  angular.module('BlurAdmin.theme')
      .directive('modalDirective', modalDirective);

  /** @ngInject */
  function modalDirective($timeout, $rootScope) {
    // console.log("entro al modal Diurectiva");
    return {
      templateUrl: 'app/theme/directives/templateshtml/modal.html'
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
// Esta directiva agrega un texto traducido según corresponda al botón de primera o ultima pagina, al paginado de una smart-table
angular.module('Kahuna')
  .directive('stLanguage', ['stConfig', function (stConfig) {
    return {
      require: '^stTable',
      link: function (element, attrs, ctrl) {
        // console.log(ctrl.stLanguage);
        // console.log(stConfig);
        if (ctrl.stLanguage == "first") {
          if (stConfig.language == "español")
            attrs[0].append("Primero")
          else if (stConfig.language == "ingles")
            attrs[0].append("First")
          else if (stConfig.language == "portugues")
            attrs[0].append("Primeiro")
          else if (stConfig.language == "italiano")
            attrs[0].append("Italiano")

        } else if (ctrl.stLanguage == "last") {
          if (stConfig.language == "español")
            attrs[0].append("Último")
          else if (stConfig.language == "ingles")
            attrs[0].append("Last")
          else if (stConfig.language == "portugues")
            attrs[0].append("Durar")
          else if (stConfig.language == "italiano")
            attrs[0].append("Italiano")
        }
      }
    };
  }]);
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
angular.module('Kahuna')
    .directive('trumbowygEditor', function (sharedService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attrs, ngModel) {
                var language = sharedService.getLanguage();
                var titlesByLanguage;
                var editorLang;

                if (language == "español") {
                    editorLang = 'es';
                    titlesByLanguage = {
                        formatting: {
                            title: 'Formato del texto',
                        },
                        superscript: {
                            title: 'Superíndice'
                        },
                        subscript: {
                            title: 'Subíndice'
                        },
                        strong: {
                            title: 'Negrilla'
                        },
                        em: {
                            title: 'Italica'
                        },
                        del: {
                            title: 'Tachado'
                        },
                        fontfamily: {
                            title: 'Fuente'
                        },
                        fontsize: {
                            title: 'Tamaño de la fuente'
                        },
                        lineheight: {
                            title: 'Altura de linea'
                        },
                        base64: {
                            title: 'Imagen'
                        },
                        foreColor: {
                            title: 'Color de texto'
                        },
                        backColor: {
                            title: 'Color de fondo'
                        },
                        justifyLeft: {
                            title: 'Alinear izquierda'
                        },
                        justifyRight: {
                            title: 'Alinear derecha'
                        },
                        justifyCenter: {
                            title: 'Alinear centro'
                        },
                        justifyFull: {
                            title: 'Justificar'
                        },
                        unorderedList: {
                            title: 'Lista desordenada'
                        },
                        orderedList: {
                            title: 'Lista ordenada'
                        },
                        removeformat: {
                            title: 'Borrar formato'
                        },
                    }
                } else if (language == "ingles") {
                    titlesByLanguage = {
                        formatting: {
                            title: 'Text formatting',
                        },
                        superscript: {
                            title: 'Superscript'
                        },
                        subscript: {
                            title: 'Subscript'
                        },
                        strong: {
                            title: 'Bold'
                        },
                        em: {
                            title: 'Italic'
                        },
                        del: {
                            title: 'Strikethrough'
                        },
                        fontfamily: {
                            title: 'Font'
                        },
                        fontsize: {
                            title: 'Font size'
                        },
                        lineheight: {
                            title: 'Line Height'
                        },
                        base64: {
                            title: 'Image'
                        },
                        foreColor: {
                            title: 'Text color'
                        },
                        backColor: {
                            title: 'Background color'
                        },
                        justifyLeft: {
                            title: 'Align left'
                        },
                        justifyRight: {
                            title: 'Align right'
                        },
                        justifyCenter: {
                            title: 'Center align'
                        },
                        justifyFull: {
                            title: 'Justify'
                        },
                        unorderedList: {
                            title: 'Unordered list'
                        },
                        orderedList: {
                            title: 'Ordered list'
                        },
                        removeformat: {
                            title: 'Clear formatting'
                        },
                    }
                } else if (language == "portugues") {
                    editorLang = 'pt_br';
                    titlesByLanguage = {
                        formatting: {
                            title: 'Formato do texto',
                        },
                        superscript: {
                            title: 'Sobrescrito'
                        },
                        subscript: {
                            title: 'Subscrito'
                        },
                        strong: {
                            title: 'Negrito'
                        },
                        em: {
                            title: 'Itálico'
                        },
                        del: {
                            title: 'Tachado'
                        },
                        fontfamily: {
                            title: 'Fonte'
                        },
                        fontsize: {
                            title: 'Tamanho da fonte'
                        },
                        lineheight: {
                            title: 'Altura da linha'
                        },
                        base64: {
                            title: 'Imagem'
                        },
                        foreColor: {
                            title: 'Cor do texto'
                        },
                        backColor: {
                            title: 'Cor de fundo'
                        },
                        justifyLeft: {
                            title: 'Alinhar à esquerda'
                        },
                        justifyRight: {
                            title: 'Alinhar à direita'
                        },
                        justifyCenter: {
                            title: 'Alinhar ao centro'
                        },
                        justifyFull: {
                            title: 'Justificar'
                        },
                        unorderedList: {
                            title: 'Lista não ordenada'
                        },
                        orderedList: {
                            title: 'Lista ordenada'
                        },
                        removeformat: {
                            title: 'Remover formato'
                        },
                    }
                } else if (language == "italiano") {
                    titlesByLanguage = {
                        formatting: {
                            title: 'Formato del texto',
                        },
                        superscript: {
                            title: 'Superíndice'
                        },
                        subscript: {
                            title: 'Subíndice'
                        },
                        strong: {
                            title: 'Negrilla'
                        },
                        em: {
                            title: 'Italica'
                        },
                        del: {
                            title: 'Tachado'
                        },
                        fontfamily: {
                            title: 'Fuente'
                        },
                        fontsize: {
                            title: 'Tamaño de la fuente'
                        },
                        lineheight: {
                            title: 'Tamaño de la fuente'
                        },
                        base64: {
                            title: 'Imagen'
                        },
                        foreColor: {
                            title: 'Color de texto'
                        },
                        backColor: {
                            title: 'Color de fondo'
                        },
                        justifyLeft: {
                            title: 'Alinear izquierda'
                        },
                        justifyRight: {
                            title: 'Alinear derecha'
                        },
                        justifyCenter: {
                            title: 'Alinear centro'
                        },
                        justifyFull: {
                            title: 'Justificar'
                        },
                        unorderedList: {
                            title: 'Lista desordenada'
                        },
                        orderedList: {
                            title: 'Lista ordenada'
                        },
                        removeformat: {
                            title: 'Borrar formato'
                        },
                    }
                }

                var editor = $(element).trumbowyg({
                    lang: editorLang,
                    svgPath: '/assets/img/iconsTrumbowyg.svg',
                    btnsDef: titlesByLanguage,
                    // Opciones del editor
                    btns: [
                        ['formatting'],
                        ['strong', 'em', 'del'],
                        ['superscript', 'subscript'],
                        ['fontfamily'],
                        ['fontsize', 'lineheight'],
                        ['link'],
                        ['base64'],
                        ['foreColor', 'backColor'],
                        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                        ['unorderedList', 'orderedList'],
                        ['indent', 'outdent'],
                        ['removeformat'],
                    ],
                    plugins: {
                        fontfamily: {
                            fontList: [
                                { name: 'Arial', family: 'Arial, Helvetica, sans-serif' },
                                { name: 'Arial Black', family: '"Arial Black", Gadget, sans-serif' },
                                { name: 'Comic Sans MS', family: '"Comic Sans MS", cursive, sans-serif' },
                                { name: 'Courier New', family: '"Courier New", Courier, monospace' },
                                { name: 'Georgia', family: 'Georgia, serif' },
                                { name: 'Helvetica Neue', family: '"Helvetica Neue", Helvetica, Arial, sans-serif' },
                                { name: 'Impact', family: 'Impact, Charcoal, sans-serif' },
                                { name: 'Lucida Console', family: '"Lucida Console", Monaco, monospace' },
                                { name: 'Lucida Sans Unicode', family: '"Lucida Sans Unicode", "Lucida Grande", sans-serif' },
                                { name: 'Palatino Linotype', family: '"Palatino Linotype", "Book Antiqua", Palatino, serif' },
                                { name: 'Tahoma', family: 'Tahoma, Geneva, sans-serif' },
                                { name: 'Times New Roman', family: '"Times New Roman", Times, serif' },
                                { name: 'Trebuchet MS', family: '"Trebuchet MS", Helvetica, sans-serif' },
                                { name: 'Verdana', family: 'Verdana, Geneva, sans-serif' },
                                { name: 'Sans Serif', family: 'sans-serif' },
                                { name: 'Serif', family: 'serif' },
                                { name: 'Monospace', family: 'monospace' }
                            ]
                        },
                        fontsize: {
                            sizeList: [
                                '12px',
                                '14px',
                                '16px',
                                '24px',
                            ]
                        },
                    }
                }).on('tbwchange', function () {
                    ngModel.$setViewValue(editor.trumbowyg('html'));
                });

                ngModel.$render = function () {
                    editor.trumbowyg('html', ngModel.$viewValue || '');
                };
            }
        };
    });
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          //elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h5 class="panel-title">' + attrs.baPanelTitle + '</h5></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

// /**
//  * @author v.lugovksy
//  * created on 16.12.2015
//  */
// (function () {
//   'use strict';

//   angular.module('BlurAdmin.theme.components')
//       .directive('baSidebar2', baSidebar);

//   /** @ngInject */
//   function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
//     var jqWindow = $(window);
//     return {
//       restrict: 'E',
//       templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
//       controller: 'BaSidebarCtrl',
//       link: function(scope, el) {

//         scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
//         jqWindow.on('click', _onWindowClick);
//         jqWindow.on('resize', _onWindowResize);

//         scope.$on('$destroy', function() {
//           jqWindow.off('click', _onWindowClick);
//           jqWindow.off('resize', _onWindowResize);
//         });

//         function _onWindowClick($evt) {
//           if (!baUtil.isDescendant(el[0], $evt.target) &&
//               !$evt.originalEvent.$sidebarEventProcessed &&
//               !baSidebarService.isMenuCollapsed() &&
//               baSidebarService.canSidebarBeHidden()) {
//             $evt.originalEvent.$sidebarEventProcessed = true;
//             $timeout(function () {
//               baSidebarService.setMenuCollapsed(true);
//             }, 10);
//           }
//         }

//         // watch window resize to change menu collapsed state if needed
//         function _onWindowResize() {
//           var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
//           var newMenuHeight = _calculateMenuHeight();
//           if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
//             scope.$apply(function () {
//               scope.menuHeight = newMenuHeight;
//               baSidebarService.setMenuCollapsed(newMenuCollapsed)
//             });
//           }
//         }

//         function _calculateMenuHeight() {
//           return el[0].childNodes[0].clientHeight - 84;
//         }
//       }
//     };
//   }

// })();
// (function() {
//   'use strict';

//   angular.module('BlurAdmin.theme.components')
//       .provider('baSidebarService', baSidebarServiceProvider);

//   /** @ngInject */
//   function baSidebarServiceProvider() {
//     var staticMenuItems = [];

//     this.addStaticItem = function() {
//       staticMenuItems.push.apply(staticMenuItems, arguments);
//     };

//     /** @ngInject */
//     this.$get = function($state, layoutSizes) {
//       return new _factory();

//       function _factory() {
//         var isMenuCollapsed = shouldMenuBeCollapsed();

//         this.getMenuItems = function() {
//           var states = defineMenuItemStates();
//           var menuItems = states.filter(function(item) {
//             return item.level == 0;
//           });

//           menuItems.forEach(function(item) {
//             var children = states.filter(function(child) {
//               return child.level == 1 && child.name.indexOf(item.name) === 0;
//             });
//             item.subMenu = children.length ? children : null;
//           });

//           return menuItems.concat(staticMenuItems);
//         };

//         this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
//         this.canSidebarBeHidden = canSidebarBeHidden;

//         this.setMenuCollapsed = function(isCollapsed) {
//           isMenuCollapsed = isCollapsed;
//         };

//         this.isMenuCollapsed = function() {
//           return isMenuCollapsed;
//         };

//         this.toggleMenuCollapsed = function() {
//           isMenuCollapsed = !isMenuCollapsed;
//         };

//         this.getAllStateRefsRecursive = function(item) {
//           var result = [];
//           _iterateSubItems(item);
//           return result;

//           function _iterateSubItems(currentItem) {
//             currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
//               subItem.stateRef && result.push(subItem.stateRef);
//               _iterateSubItems(subItem);
//             });
//           }
//         };

//         function defineMenuItemStates() {
//           return $state.get()
//               .filter(function(s) {
//                 return s.sidebarMeta;
//               })
//               .map(function(s) {
//                 var meta = s.sidebarMeta;
//                 return {
//                   name: s.name,
//                   title: s.title,
//                   level: (s.name.match(/\./g) || []).length,
//                   order: meta.order,
//                   icon: meta.icon,
//                   stateRef: s.name,
//                 };
//               })
//               .sort(function(a, b) {
//                 return (a.level - b.level) * 100 + a.order - b.order;
//               });
//         }

//         function shouldMenuBeCollapsed() {
//           return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
//         }

//         function canSidebarBeHidden() {
//           return window.innerWidth <= layoutSizes.resWidthHideSidebar;
//         }
//       }

//     };

//   }
// })();

// /**
//  * @author v.lugovksy
//  * created on 16.12.2015
//  */
// (function () {
//   'use strict';

//   angular.module('BlurAdmin.theme.components')
//     .controller('BaSidebarCtrl', BaSidebarCtrl);

//   /** @ngInject */
//   function BaSidebarCtrl($scope, baSidebarService) {

//     $scope.menuItems = baSidebarService.getMenuItems();
//     $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

//     $scope.hoverItem = function ($event) {
//       $scope.showHoverElem = true;
//       $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
//       var menuTopValue = 66;
//       $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
//     };

//     $scope.$on('$stateChangeSuccess', function () {
//       if (baSidebarService.canSidebarBeHidden()) {
//         baSidebarService.setMenuCollapsed(true);
//       }
//     });
//   }
// })();
// /**
//  * @author v.lugovsky
//  * created on 03.05.2016
//  */
// (function () {
//   'use strict';

//   angular.module('BlurAdmin.theme.components')
//       .directive('baSidebarToggleMenu', baSidebarToggleMenu)
//       .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
//       .directive('baSidebarTogglingItem', baSidebarTogglingItem)
//       .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
//       .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
//       .directive('baUiSrefToggler', baUiSrefToggler);

//   /** @ngInject */
//   function baSidebarToggleMenu(baSidebarService) {
//     return {
//       restrict: 'A',
//       link: function(scope, elem) {
//         elem.on('click', function($evt) {
//           $evt.originalEvent.$sidebarEventProcessed = true;
//           scope.$apply(function() {
//             baSidebarService.toggleMenuCollapsed();
//           });
//         });
//       }
//     };
//   }

//   /** @ngInject */
//   function baSidebarCollapseMenu(baSidebarService) {
//     return {
//       restrict: 'A',
//       link: function(scope, elem) {
//         elem.on('click', function($evt) {
//           $evt.originalEvent.$sidebarEventProcessed = true;
//           if (!baSidebarService.isMenuCollapsed()) {
//             scope.$apply(function() {
//               baSidebarService.setMenuCollapsed(true);
//             });
//           }
//         });
//       }
//     };
//   }

//   /** @ngInject */
//   function baSidebarTogglingItem() {
//     return {
//       restrict: 'A',
//       controller: 'BaSidebarTogglingItemCtrl'
//     };
//   }

//   /** @ngInject */
//   function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
//     var vm = this;
//     var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
//     if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
//       vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
//       vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

//       var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

//       vm.$expand = function() {
//         vm.$$expandSubmenu();
//         $element.addClass('ba-sidebar-item-expanded');
//       };

//       vm.$collapse = function() {
//         vm.$$collapseSubmenu();
//         $element.removeClass('ba-sidebar-item-expanded');
//       };

//       vm.$toggle = function() {
//         $element.hasClass('ba-sidebar-item-expanded') ?
//             vm.$collapse() :
//             vm.$expand();
//       };

//       if (_isState($state.current)) {
//         $element.addClass('ba-sidebar-item-expanded');
//       }

//       $scope.$on('$stateChangeStart', function (event, toState) {
//         if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
//           vm.$collapse();
//           $element.removeClass('ba-sidebar-item-expanded');
//         }
//       });

//       $scope.$on('$stateChangeSuccess', function (event, toState) {
//         if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
//           vm.$expand();
//           $element.addClass('ba-sidebar-item-expanded');
//         }
//       });
//     }

//     function _isState(state) {
//       return state && subItemsStateRefs.some(function(subItemState) {
//             return state.name.indexOf(subItemState) == 0;
//           });
//     }
//   }

//   /** @ngInject */
//   function baUiSrefTogglingSubmenu($state) {
//     return {
//       restrict: 'A',
//       require: '^baSidebarTogglingItem',
//       link: function(scope, el, attrs, baSidebarTogglingItem) {
//         baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
//         baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
//       }
//     };
//   }

//   /** @ngInject */
//   function baUiSrefToggler(baSidebarService) {
//     return {
//       restrict: 'A',
//       require: '^baSidebarTogglingItem',
//       link: function(scope, el, attrs, baSidebarTogglingItem) {
//         el.on('click', function() {
//           if (baSidebarService.isMenuCollapsed()) {
//             // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
//             // This should not affect mobiles, because on mobiles sidebar should be hidden at all
//             scope.$apply(function() {
//               baSidebarService.setMenuCollapsed(false);
//             });
//             baSidebarTogglingItem.$expand();
//           } else {
//             baSidebarTogglingItem.$toggle();
//           }
//         });
//       }
//     };
//   }

// })();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl',
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state, sharedService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function ($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;

          // if ($location.url().match(/solicitud\/template\/edit\//g)) {
          //   $scope.iframeSolicitudActivo = sharedService.getIframeSolicitudActivo();
          // }

          contentTopHome();
        });

        function contentTopHome() {
          // Función para cambiar el tamaño del contentTop dependiendo si se está en la vista home o si se cambia de vista
          var url = $location.url();

          if (url == '/home') {
            $('.content-top').addClass('is-home');
          } else {
            $('.content-top').removeClass('is-home');
          }
        }
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .provider('pageTopService', pageTopService);

  /** @ngInject */
  function pageTopService() {
    var staticMenuItems = [];

    this.addStaticItem = function () {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function ($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function () {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function (item) {
            return item.level == 0;
          });

          menuItems.forEach(function (item) {
            var children = states.filter(function (child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function (isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function () {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function () {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function (item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function (subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
            .filter(function (s) {
              return s.sidebarMeta;
            })
            .map(function (s) {
              var meta = s.sidebarMeta;
              return {
                name: s.name,
                title: s.title,
                level: (s.name.match(/\./g) || []).length,
                order: meta.order,
                icon: meta.icon,
                stateRef: s.name,
              };
            })
            .sort(function (a, b) {
              return (a.level - b.level) * 100 + a.order - b.order;
            });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTopToggleMenu', pageTopToggleMenu)
      .directive('pageTopCollapseMenu', pageTopCollapseMenu)
      .directive('pageTopTogglingItem', pageTopTogglingItem)
      .controller('PageTopTogglingItemCtrl', PageTopTogglingItemCtrl)
      .directive('ptUiSrefTogglingSubmenu', ptUiSrefTogglingSubmenu)
      .directive('ptUiSrefToggler', ptUiSrefToggler);

  /** @ngInject */
  function pageTopToggleMenu(pageTopService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            pageTopService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function pageTopCollapseMenu(pageTopService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!pageTopService.isMenuCollapsed()) {
            scope.$apply(function() {
              pageTopService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function pageTopTogglingItem() {
    return {
      restrict: 'A',
      controller: 'PageTopTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function PageTopTogglingItemCtrl($scope, $element, $attrs, $state, pageTopService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.pageTopTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by ptUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by ptUiSrefTogglingSubmenu') };

      var subItemsStateRefs = pageTopService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('page-top-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('page-top-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('page-top-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      // if (_isState($state.current)) {
      //   $element.addClass('page-top-item-expanded');
      // }

      // $scope.$on('$stateChangeStart', function (event, toState) {
      //   if (!_isState(toState) && $element.hasClass('page-top-item-expanded')) {
      //     vm.$collapse();
      //     $element.removeClass('page-top-item-expanded');
      //   }
      // });

      // $scope.$on('$stateChangeSuccess', function (event, toState) {
      //   if (_isState(toState) && !$element.hasClass('page-top-item-expanded')) {
      //     vm.$expand();
      //     $element.addClass('page-top-item-expanded');
      //   }
      // });
    }

    // function _isState(state) {
    //   return state && subItemsStateRefs.some(function(subItemState) {
    //         return state.name.indexOf(subItemState) == 0;
    //       });
    // }
  }

  /** @ngInject */
  function ptUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^pageTopTogglingItem',
      link: function(scope, el, attrs, pageTopTogglingItem) {
        pageTopTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        pageTopTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function ptUiSrefToggler(pageTopService) {
    return {
      restrict: 'A',
      require: '^pageTopTogglingItem',
      link: function(scope, el, attrs, pageTopTogglingItem) {
        el.on('click', function() {
          if (pageTopService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              pageTopService.setMenuCollapsed(false);
            });
            pageTopTogglingItem.$expand();
          } else {
            pageTopTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '=',
        switcherLanguage: '='
      }
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
angular.module('Kahuna').run(['$templateCache', function($templateCache) {$templateCache.put('app/auth/auth.html','<section class="auth-main"><div class="auth-block"><div class="auth-logo"><img ng-src="{{$ctrl.logoIcon}}"></div><form class="form-horizontal"><div class="auth-input"><img ng-src="{{$ctrl.userIcon}}"> <input class="" ng-model="$ctrl.model.Usuario" id="inputUser3" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Usuario\' : (($ctrl.language == \'ingles\') ? \'User\' : (($ctrl.language == \'portugues\') ? \'Usu\xE1rio\' : \'italiano\')) }}"></div><div class="auth-input"><img ng-src="{{$ctrl.passwordIcon}}"> <input class="" type="password" ng-model="$ctrl.model.Password" id="inputPassword3" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Contrase\xF1a\' : (($ctrl.language == \'ingles\') ? \'Password\' : (($ctrl.language == \'portugues\') ? \'Senha\' : \'italiano\')) }}"> <img class="pointer" ng-src="{{$ctrl.showPasswordIcon}}" ng-click="$ctrl.togglePassword($event)"></div><div class="auth-btn"><button ng-click="$ctrl.login();" ng-class="{\'disabled\': $ctrl.isBusy}">{{$ctrl.buttonLoginText}}</button></div></form><div class="auth-info"><p class="auth-licence">El Acceso y Uso de la Herramienta implican la aceptaci\xF3n del <a href="https://kahunasoft.com/clufkhn.pdf" rel="noopener" target="_blank">CLUF</a> de Licencias</p><p class="text-right auth-version">{{$ctrl.appVersion}}</p></div></div></section>');
$templateCache.put('app/components/altaJerarquia.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><label class="col-md-3 center-label" ng-if="$ctrl.model.JerarquiaPadre.Nombre.length > 0"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Jerarqu\xEDa Padre:</span> <span ng-if="$ctrl.language == \'ingles\'">Parent Hierarchy:</span> <span ng-if="$ctrl.language == \'portugues\'">Hierarquia Pai:</span> <span ng-if="$ctrl.language == \'italiano\'">Jerarqu\xEDa Padre:</span></label> <label class="col-md-9" style="text-align: left" ng-if="$ctrl.model.JerarquiaPadre.Nombre.length > 0">{{$ctrl.model.JerarquiaPadre.Nombre}}</label> <label class="col-md-3 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre*:</span> <span ng-if="$ctrl.language == \'ingles\'">Name*:</span> <span ng-if="$ctrl.language == \'portugues\'">Nome*:</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre*:</span></label><div class="col-md-9"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Nombre" ng-keydown="$ctrl.checkKey($event)"></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button></div></div>');
$templateCache.put('app/components/baSidebar.template.html','<div class="sidebar"><div ng-show="$ctrl.isGroupSearching"><h5><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></h5></div><div class="row" ng-show="!$ctrl.isGroupSearching"><div class="col-12" ng-repeat="item in $ctrl.grupos"><div class="home-group-button" ng-click="$ctrl.setGrupoSeleccionado(item.Id)"><img ng-src="{{item.UrlImagen}}" ng-show="item.UrlImagen != null && item.UrlImagen.length > 0"><br><label ng-style="{ \'color\': item.ColorTexto }">{{item.Nombre}}</label><br><span ng-style="{ \'color\': item.ColorTexto }">{{item.Resumen}}</span></div><br></div></div></div>');
$templateCache.put('app/components/cambioClave.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><div class="col-md-12" ng-if="$ctrl.resolve.showUsername" style="display:flex;justify-content:center"><h3><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario:</span> <span ng-if="$ctrl.language == \'ingles\'">User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario:</span> <b>{{$ctrl.resolve.username}}</b></h3></div><div class="col-md-12 margin-bottom"><label class="col-md-4 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Clave Actual:</span> <span ng-if="$ctrl.language == \'ingles\'">Current Password:</span> <span ng-if="$ctrl.language == \'portugues\'">Senha Atual:</span> <span ng-if="$ctrl.language == \'italiano\'">Clave Actual:</span></label><div class="col-md-8 password-input"><input type="password" id="currentPassword" class="form-control" ng-model="$ctrl.model.ClaveActual" ng-keydown="$ctrl.checkKey($event)"> <img class="pointer" ng-src="{{$ctrl.showPasswordIcon}}" ng-click="$ctrl.togglePassword(\'currentPassword\', $event)"></div></div><div class="col-md-12 margin-bottom"><label class="col-md-4 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nueva Clave:</span> <span ng-if="$ctrl.language == \'ingles\'">New Password:</span> <span ng-if="$ctrl.language == \'portugues\'">Nova Senha:</span> <span ng-if="$ctrl.language == \'italiano\'">Nueva Clave:</span></label><div class="col-md-8 password-input"><input type="password" id="newPassword" class="form-control" ng-model="$ctrl.model.ClaveNueva" ng-keydown="$ctrl.checkKey($event)"> <img class="pointer" ng-src="{{$ctrl.showPasswordIcon}}" ng-click="$ctrl.togglePassword(\'newPassword\', $event)"></div></div><div class="col-md-12 margin-bottom"><label class="col-md-4 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Confirmar Clave:</span> <span ng-if="$ctrl.language == \'ingles\'">Confirm Password:</span> <span ng-if="$ctrl.language == \'portugues\'">Confirmar Senha:</span> <span ng-if="$ctrl.language == \'italiano\'">Confirmar Clave:</span></label><div class="col-md-8 password-input"><input type="password" id="confirmPassword" class="form-control" ng-model="$ctrl.model.ClaveNuevaConfirmacion" ng-keydown="$ctrl.checkKey($event)"> <img class="pointer" ng-src="{{$ctrl.showPasswordIcon}}" ng-click="$ctrl.togglePassword(\'confirmPassword\', $event)"></div></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success margin-top" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button type="button" class="btn btn-danger margin-top" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button></div></div>');
$templateCache.put('app/components/cierreSesion.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.title}}</span></div><div class="modal-body text-center add-top-space"><div class="col-md-12 text-username"><h3><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario:</span> <span ng-if="$ctrl.language == \'ingles\'">User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario:</span> <b>{{$ctrl.resolve.username}}</b></h3></div><div class="col-md-12"><h4><span ng-if="$ctrl.language == \'espa\xF1ol\'">\xBFDesea cerrar la sesi\xF3n anterior y loguearse de nuevo?</span> <span ng-if="$ctrl.language == \'ingles\'">Do you want to log out from the previous session and log in again?</span> <span ng-if="$ctrl.language == \'portugues\'">Deseja encerrar a sess\xE3o anterior e fazer login novamente?</span> <span ng-if="$ctrl.language == \'italiano\'">\xBFDesea cerrar la sesi\xF3n anterior y loguearse de nuevo?</span></h4></div></div><div class="modal-footer add-top-space modal-footer-center"><button type="button" class="btn btn-success" ng-click="$ctrl.logout()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">SI</span> <span ng-if="$ctrl.language == \'ingles\'">YES</span> <span ng-if="$ctrl.language == \'portugues\'">SIM</span> <span ng-if="$ctrl.language == \'italiano\'">SI</span></button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">NO</span> <span ng-if="$ctrl.language == \'ingles\'">NO</span> <span ng-if="$ctrl.language == \'portugues\'">N\xC3O</span> <span ng-if="$ctrl.language == \'italiano\'">NO</span></button></div></div>');
$templateCache.put('app/components/confirmation.template.html','<div class="modal-content"><div class="modal-header bg-warning"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center">{{$ctrl.resolve.message}}</div><div class="modal-footer"><button type="button" class="btn btn-warning" ng-click="$ctrl.confirm()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">SI</span> <span ng-if="$ctrl.language == \'ingles\'">YES</span> <span ng-if="$ctrl.language == \'portugues\'">SIM</span> <span ng-if="$ctrl.language == \'italiano\'">SI</span></button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">NO</span> <span ng-if="$ctrl.language == \'ingles\'">NO</span> <span ng-if="$ctrl.language == \'portugues\'">N\xC3O</span> <span ng-if="$ctrl.language == \'italiano\'">NO</span></button></div></div>');
$templateCache.put('app/components/footerUser.template.html','<footer class="footer-user"><div class="footer-container"><div class="user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-button"><label>{{$ctrl.userMessage}}</label> <img ng-src="{{::( \'generic-user-profile\' | profilePicture )}}"></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a ng-click="$ctrl.medirVelocidadInternet()"><i class="fa fa-rocket"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Medir Velocidad</span> <span ng-if="$ctrl.language == \'ingles\'">Measure Speed</span> <span ng-if="$ctrl.language == \'portugues\'">Medir Velocidade</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></a></li><li><a ng-click="$ctrl.cambioClave()" class="change-password"><i class="fa fa-lock"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Cambiar Clave</span> <span ng-if="$ctrl.language == \'ingles\'">Change Password</span> <span ng-if="$ctrl.language == \'portugues\'">Alterar Senha</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></a></li><li><a ng-click="$ctrl.logout()" class="signout"><i class="fa fa-power-off"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Cerrar Sesi\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Log Out</span> <span ng-if="$ctrl.language == \'portugues\'">Encerrar Sess\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></a></li></ul></div><p class="alert-message" ng-show="$ctrl.alert.length > 0">{{ $ctrl.alert }}</p><div class="footer-headlines"><p>{{$ctrl.applicationProperties.HEADLINEA1}}</p><p>{{$ctrl.applicationProperties.HEADLINEA2}}</p><p><i class="fa fa-info"></i> {{$ctrl.appVersion}}</p></div></div></footer>');
$templateCache.put('app/components/modalVisor.template.html','<div class="modal-visor-content"><iframe frameborder="0" id="accessUrl" ng-if="!$ctrl.resolve.isPdf" ng-src="{{ $ctrl.urlVisor }}"></iframe><div id="displayPdf" ng-if="$ctrl.resolve.isPdf"></div></div><div class="navigation" ng-if="$ctrl.resolve.isPdf"><div class="page-info"><button class="btn" ng-click="$ctrl.prevPage()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'P\xE1gina Anterior\' : (($ctrl.language == \'ingles\') ? \'Previous Page\' : (($ctrl.language == \'portugues\') ? \'P\xE1gina Anterior\' : \'italiano\')) }}"><i class="fa fa-arrow-left" aria-hidden="true"></i></button> <span><span>{{$ctrl.currentPage}}</span> / <span>{{$ctrl.totalPages}}</span></span> <button class="btn" ng-click="$ctrl.nextPage()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'P\xE1gina siguiente\' : (($ctrl.language == \'ingles\') ? \'Next page\' : (($ctrl.language == \'portugues\') ? \'Pr\xF3xima p\xE1gina\' : \'italiano\')) }}"><i class="fa fa-arrow-right" aria-hidden="true"></i></button></div><button class="btn" ng-click="$ctrl.zoomInPage()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Acercar\' : (($ctrl.language == \'ingles\') ? \'Zoom In\' : (($ctrl.language == \'portugues\') ? \'Ampliar\' : \'italiano\')) }}"><i class="fa fa-plus" aria-hidden="true"></i></button> <button class="btn" ng-click="$ctrl.zoomOutPage()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Alejar\' : (($ctrl.language == \'ingles\') ? \'Zoom out\' : (($ctrl.language == \'portugues\') ? \'Remover\' : \'italiano\')) }}"><i class="fa fa-minus" aria-hidden="true"></i></button> <button class="download btn" ng-click="$ctrl.downloadPdf()" ng-if="$ctrl.resolve.canPrint"><i class="fa fa-download" aria-hidden="true"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Descargar PDF</span> <span ng-if="$ctrl.language == \'ingles\'">Download PDF</span> <span ng-if="$ctrl.language == \'portugues\'">Baixar PDF</span> <span ng-if="$ctrl.language == \'italiano\'">Descargar PDF</span></button></div><button type="button" class="btn btn-danger margin-top modal-close" ng-click="$ctrl.close()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cerrar</span> <span ng-if="$ctrl.language == \'ingles\'">Close</span> <span ng-if="$ctrl.language == \'portugues\'">Fechar</span> <span ng-if="$ctrl.language == \'italiano\'">Cerrar</span></button>');
$templateCache.put('app/components/pageTop.template.html','<div class="page-top" scroll-position="scrolled"><img class="logo app" ng-src="{{$ctrl.appLogoIcon}}"> <img class="logo client" ng-src="{{$ctrl.clientLogoIcon}}"><div class="icons-container"><a ng-href="{{$ctrl.emailIconHref}}" class="icon" target="_blank" rel="noopener noreferrer"><img ng-src="{{$ctrl.emailIcon}}" alt="email icon"></a> <a ng-href="{{$ctrl.infoIconHref}}" class="icon" target="_blank" rel="noopener noreferrer"><img ng-src="{{$ctrl.infoIcon}}" alt="info icon icon"></a> <a ng-href="{{$ctrl.aiIconHref}}" class="icon" target="_blank" rel="noopener noreferrer"><img ng-src="{{$ctrl.aiIcon}}" alt="artificial intelligence icon"></a></div><a href="" class="collapse-menu-link ion-navicon" ng-click="$ctrl.toggleMenuMobile()"></a><div class="menu-panel"><ul><li ng-repeat="item in ::menuItems" ng-click="$ctrl.hideMenu($index)" class="menu-option" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" page-top-toggling-item="item"><a ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-if="::item.subMenu" pt-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" pt-ui-sref-toggling-submenu="" class="submenu"><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" page-top-toggling-item="subitem"><a ng-if="::subitem.subMenu" pt-ui-sref-toggler=""><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a href="" ng-if="::subSubitem.disabled">{{ ::subSubitem.title }}</a> <a ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a href="" ng-if="::(!subitem.subMenu && subitem.disabled)">{{ ::subitem.title }}</a> <a target="{{::(subitem.blank ? \'_blank\' : \'_self\')}}" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul></div></div>');
$templateCache.put('app/components/seleccionProceso.template.html','<div class="modal-content"><div class="modal-header bg-info"><i class="ion-android-warning modal-icon"></i><span>{{$ctrl.resolve.title}}</span></div><div class="modal-body text-center add-top-space"><div class="col-md-12"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso:</span> <span ng-if="$ctrl.language == \'ingles\'">Process:</span> <span ng-if="$ctrl.language == \'portugues\'">Processo:</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso:</span></label> <label class="col-md-10 center-label" ng-show="$ctrl.procesoLoading" style="font-weight:normal"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></label><div class="col-md-10" ng-show="!$ctrl.procesoLoading"><select name="" class="form-control" ng-model="$ctrl.model.ProcesoSeleccionado" ng-options="item as item.Nombre for item in $ctrl.procesosList track by item.Id"></select></div></div></div><div class="modal-footer add-top-space"><button type="button" class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Aceptar</span> <span ng-if="$ctrl.language == \'ingles\'">Accept</span> <span ng-if="$ctrl.language == \'portugues\'">Aceitar</span> <span ng-if="$ctrl.language == \'italiano\'">Aceptar</span></button> <button type="button" class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button></div></div>');
$templateCache.put('app/components/validaProcesoMaestro.template.html','<div class="modal-content"><div class="modal-header bg-info col-md-12"><label class="center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Inserte el c\xF3digo de maestro</span> <span ng-if="$ctrl.language == \'ingles\'">Enter the master code</span> <span ng-if="$ctrl.language == \'portugues\'">Digite o c\xF3digo mestre</span> <span ng-if="$ctrl.language == \'italiano\'">Inserte el c\xF3digo de maestro</span></label> <i class="ion-android-search modal-icon" style="margin-left: 10px"></i></div><div class="modal-body text-center"><div class="col-md-12 margin-y-20"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.value" ng-keydown="$ctrl.checkKey($event)"></div></div><div class="modal-footer"><div class="col-md-12"><button type="button" class="btn btn-success modal-footer-btn" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Consultar</span> <span ng-if="$ctrl.language == \'ingles\'">Consult</span> <span ng-if="$ctrl.language == \'portugues\'">Consultar</span> <span ng-if="$ctrl.language == \'italiano\'">Consultar</span></button> <button type="button" class="btn btn-danger modal-footer-btn" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button></div></div></div>');
$templateCache.put('app/pages/shell.html','<page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="" autoscroll="true" autoscroll-body-top=""></div></div></div><footer-user></footer-user>');
$templateCache.put('app/pages/accesosurl/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="accesosurl"><form name="$ctrl.form" novalidate=""><div ba-panel="" ba-panel-title="Datos del URL" class="add-top-space"><div class="form-group"><label class="col-md-2 center-label">URL*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.urlProcesoLink" name="url" placeholder="http://..." required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el URL.</span></div></div><label class="col-md-2 center-label">Proceso:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.idProceso" placeholder="Ingrese el proceso a configurar..." uib-typeahead="proceso as proceso.Nombre for proceso in $ctrl.searchProceso($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingProceso" typeahead-no-results="noResultsProceso"> <i ng-show="loadingProceso" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProceso"><i class="glyphicon glyphicon-remove"></i> Proceso no encontrado</div></div><div class="col-md-12" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.MostrarUserAndPassword" name="" ng-disabled="$ctrl.isBusy"> El URL requiere Usuario y Contrase\xF1a?</div></div></div><div ba-panel="" ba-panel-title="Datos de Usuario" ba-panel-class="with-scroll"><div class="form-group"><label class="col-md-2 center-label">Usuario*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.usuarioCargado.Usuario" placeholder="Ingrese un usuario a buscar..." uib-typeahead="i as i.Login for i in $ctrl.searchUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuario($model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div><label class="col-md-2 center-label" style="margin: 8px 0 5px">Se puede Ver:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.usuarioCargado.verUrl"></ba-switcher></div><label class="col-md-2 center-label" style="margin: 8px 0 5px">Se puede Imprimir/Descargar:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.usuarioCargado.imprimirUrl"></ba-switcher></div><div class="col-md-12"><label class="col-md-12 center-label"></label> <label class="col-md-12 center-label"></label></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearUsuario()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.saveUsuarioModel()" ng-disabled="$ctrl.isBusy">Guardar</button></div></div></div><div ba-panel="" ba-panel-title="Usuarios Cargados" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center">Puede ver</th><th class="text-center">Puede imprimir</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.cargarUsuario(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center" class="col-xs-1 col-sm-1"><i class="fa fa-check" style="color:green" ng-show="item.verUrl"></i> <i class="fa fa-times" style="color:red" ng-hide="item.verUrl"></i></td><td align="center" class="col-xs-1 col-sm-1"><i class="fa fa-check" style="color:green" ng-show="item.imprimirUrl"></i> <i class="fa fa-times" style="color:red" ng-hide="item.imprimirUrl"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarUsuario(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarUsuario($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div ba-panel="" ba-panel-title="Usuario y Contrase\xF1a del URL" ba-panel-class="with-scroll" ng-show="$ctrl.MostrarUserAndPassword" class="add-top-space"><div class="form-group"><div class="col-md-12"><label class="col-md-2 center-label">Usuario*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.usrReport" name="usrReport" placeholder="Ingrese el nombre de Usuario"></div><label class="col-md-2 center-label">Contrase\xF1a*:</label><div class="col-md-4"><input type="text" class="form-control" ng-model="$ctrl.model.pswdReport" name="pswdReport" placeholder="Ingrese la Contrase\xF1a"></div></div></div></div></form></div><div class="col-md-12" style="padding-top: 25px;margin-top: 5px; margin-bottom: 80px;"><button class="btn btn-success" ng-click="$ctrl.save()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isEditing">Guardar</button> <button class="btn btn-success" ng-click="$ctrl.update()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.isEditing">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete && $ctrl.isEditing">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div>');
$templateCache.put('app/pages/accesosurl/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-7 col-sm-7" st-sort="Url">URL</th><th class="text-center col-xs-3 col-sm-3" st-sort="Proceso">Proceso</th><th class="text-center col-xs-1 col-sm-1" st-sort="Usuario">Cant. Usuarios</th><th class="text-center col-xs-1 col-sm-1">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Url" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por URL" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Proceso" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Proceso" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList track by $index" ng-click="$ctrl.edit(item.id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-7 col-sm-7">{{item.urlProcesoLink}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.idProceso.Nombre}}</td><td align="center" class="col-xs-1 col-sm-1">{{item.idUsuario.length || \'Todos\'}}</td><td align="center" class="col-xs-1 col-sm-1"><a href="" class="text-links" ng-click="$ctrl.edit(item.id)">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/autoautorizar/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">AutClave*:</label><div class="col-md-4" style="margin-bottom: 25px"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.AutClave" name="codigo" placeholder="" required="" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'AutClave\')}}" tooltip-class="customClass"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el AutClave.</span></div></div><label class="col-md-2 center-label">Descripci\xF3n*:</label><div class="col-md-4" style="margin-bottom: 25px"><input type="text" spellcheck="true" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'DescripAccion\')}}" tooltip-class="customClass" class="form-control" ng-model="$ctrl.model.DescripAccion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la Descripci\xF3n.</span></div></div><label class="col-md-2 center-label">Proceso*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'procesoId\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoId" ng-change="$ctrl.loadTemplatesProcesos($ctrl.model.procesoId)"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id}} - {{proceso.Nombre}}</option></select></div><label class="col-md-2 center-label">Id Proceso Gesti\xF3n*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'ProcesoTemplate\')}}" tooltip-class="customClass" name="" ng-model="$ctrl.model.ProcesoTemplate" class="form-control" ng-change="$ctrl.setIdSSolicitudEstado()" ng-options="item as item.Template.Nombre for item in $ctrl.resultListTemplatesProcesos track by item.TemplateId"></select></div><label class="col-md-2 center-label">IdSolicitudEstado:</label><div class="col-md-4" style="margin-bottom: 25px"><input type="text" spellcheck="true" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'IdSolicitudEstado\')}}" tooltip-class="customClass" class="form-control" ng-model="$ctrl.model.IdSolicitudEstado" name="name" readonly="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdSolicitudEstado.</span></div></div><label class="col-md-2 center-label">IdCampoOk:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'campoId\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.campoId"><option ng-repeat="campo in $ctrl.camposList" value="{{campo.Id}}">{{ campo.Id}} - {{campo.Nombre}}</option></select></div><label class="col-md-2 center-label">TipoProcedure*:</label><div class="col-md-4" style="margin-bottom: 25px"><input type="text" spellcheck="true" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'TipoProcedure\')}}" tooltip-class="customClass" class="form-control" ng-model="$ctrl.model.TipoProcedure" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de TipoProcedure.</span></div></div><label class="col-md-2 center-label">CodigoProcedure*:</label><div class="col-md-4" style="margin-bottom: 25px"><select tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'CodigoProcedure\')}}" tooltip-class="customClass" name="" class="col-md-6 form-control" ng-model="$ctrl.model.CodigoProcedure"><option ng-repeat="autoSolicitud in $ctrl.listaAutoSolicitud" value="{{autoSolicitud.AutoId}}">{{ autoSolicitud.AutoId}} - {{autoSolicitud.DetalleAcciones}}</option></select></div></div></form></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/autoautorizar/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-2 col-sm-2" st-sort="CodigoProcedure">Codigo Procedure</th><th class="text-center col-xs-3 col-sm-3" st-sort="AutClave">AutClave</th><th class="text-center col-xs-3 col-sm-3" st-sort="DescripAccion">Descripcion</th><th class="text-center col-xs-3 col-sm-3" st-sort="Proceso.Nombre">Proceso</th><th class="text-center col-xs-1 col-sm-1">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CodigoProcedure" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por CodigoProcedure" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="AutClave" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por AutClave" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="DescripAccion" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Descripcion" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Proceso.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Proceso" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-2 col-sm-2">{{item.CodigoProcedure}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.AutClave}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.DescripAccion}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.Proceso.Nombre}}</td><td align="center" class="col-xs-1 col-sm-1"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/autosolicitud/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="autosolicitud"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Auto Id*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" tooltip-placement="bottom" uib-tooltip="{{$ctrl.returnDescription(\'AutoId\')}}" tooltip-class="customClass" class="form-control" ng-model="$ctrl.model.AutoId" name="codigo" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el AutoId.</span></div></div><label class="col-md-2 center-label">DetalleAcciones*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'DetalleAcciones\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.DetalleAcciones" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el DetalleAcciones.</span></div></div><label class="col-md-2 center-label">OrigenSP*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenSP\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenSP" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenSP</span></div></div><label class="col-md-2 center-label">IdProcesoDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdProcesoDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdProcesoDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdProcesoDestino</span></div></div><label class="col-md-2 center-label">OrigenDiasdeCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenDiasdeCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenDiasdeCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenDiasdeCierre</span></div></div><label class="col-md-2 center-label">OrigenJerarquiaDiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenJerarquiaDiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenJerarquiaDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenJerarquiaDiasCierre</span></div></div><label class="col-md-2 center-label">IdCampoJerarquiaDiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoJerarquiaDiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoJerarquiaDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoJerarquiaDiasCierre</span></div></div><label class="col-md-2 center-label">DiasCierre*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'DiasCierre\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.DiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de DiasCierre</span></div></div><label class="col-md-2 center-label">AquienMando*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'AquienMando\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.AQuienMando" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de DiasCierre</span></div></div><label class="col-md-2 center-label">UsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.UsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">OrigenUsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenUsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenUsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenUsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">IdCampoUsuarioCreadorDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoUsuarioCreadorDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoUsuarioCreadorDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoUsuarioCreadorDestino</span></div></div><label class="col-md-2 center-label">OrigenCabezaDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCabezaDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenCabezaDescripcion" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCabezaDescripcion</span></div></div><label class="col-md-2 center-label">IdCampoCabezaDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoCabezaDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoCabezaDescripcion" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoCabezaDescripcion</span></div></div><label class="col-md-2 center-label">MensajeDescripcion*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'MensajeDescripcion\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.MensajeDescripcion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar MensajeDescripcion</span></div></div><label class="col-md-2 center-label">OrigenFinalDescripcion1*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenFinalDescripcion1\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenFinalDescripcion1" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenFinalDescripcion1</span></div></div><label class="col-md-2 center-label">IdCampoFinalDescripcion1*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoFinalDescripcion1\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoFinalDescripcion1" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoFinalDescripcion1</span></div></div><label class="col-md-2 center-label">OrigenFinalDescripcion2*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenFinalDescripcion2\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenFinalDescripcion2" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenFinalDescripcion2</span></div></div><label class="col-md-2 center-label">IdCampoFinalDescripcion2*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoFinalDescripcion2\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoFinalDescripcion2" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoFinalDescripcion2</span></div></div><label class="col-md-2 center-label">IdEstadoFinal*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdEstadoFinal\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdEstadoFinal" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdEstadoFinal</span></div></div><label class="col-md-2 center-label">UsuarioAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.UsuarioAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioAprobador</span></div></div><label class="col-md-2 center-label">OrigenCampoIdAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoIdAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.OrigenCampoIdAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoIdAprobador</span></div></div><label class="col-md-2 center-label">IdCampoIdAprobador*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoIdAprobador\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.IdCampoIdAprobador" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoIdAprobador</span></div></div><label class="col-md-2 center-label">SubjectCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'SubjectCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.SubjectCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar subject del correo.</span></div></div><label class="col-md-2 center-label">CuerpoCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'CuerpoCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.CuerpoCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar Cuerpo Correo</span></div></div><label class="col-md-2 center-label">UrlAddCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UrlAddCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.UrlAddCorreo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la UrlAddCorreo</span></div></div><label class="col-md-2 center-label">EnviaCorreo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'EnviaCorreo\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.EnviaCorreo" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de EnviaCorreo</span></div></div><label class="col-md-2 center-label">UsuarioModificacionId*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioModificacionId\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.UsuarioModificacionId" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioModificacionId.</span></div></div><label class="col-md-2 center-label">UsuarioCreacionid*:</label><div class="col-md-4" style="margin-bottom: 55px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreacionid\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.model.UsuarioCreacionid" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreacionid.</span></div></div></div></form></div></uib-tab><uib-tab index="1" heading="AutoSolicitud Detalle" ng-disabled="true"><div ba-panel="" ba-panel-title="AutoSolicitud Detalle" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.formDetalle" novalidate=""><label class="col-md-2 center-label">OrigenCampo*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampo\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampo" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampo</span></div></div><label class="col-md-2 center-label">IdCampoDestino*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoDestino\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.IdCampoDestino" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoDestino</span></div></div><label class="col-md-2 center-label">IdCampoOrigen*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigen\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigen" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigen</span></div></div><label class="col-md-2 center-label">OrigenCampoA*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoA\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoA" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoA</span></div></div><label class="col-md-2 center-label">IdCampoOrigenA*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenA\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenA" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenA</span></div></div><label class="col-md-2 center-label">OrigenCampoB*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoB\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoB" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoB</span></div></div><label class="col-md-2 center-label">IdCampoOrigenB*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenB\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenB" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenB</span></div></div><label class="col-md-2 center-label">OrigenCampoC*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'OrigenCampoC\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.OrigenCampoC" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrigenCampoC</span></div></div><label class="col-md-2 center-label">IdCampoOrigenC*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'IdCampoOrigenC\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.IdCampoOrigenC" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de IdCampoOrigenC</span></div></div><label class="col-md-2 center-label">ValCampoOrigen*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'ValCampoOrigen\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.ValCampoOrigen" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de ValCampoOrigen</span></div></div><label class="col-md-2 center-label">UsuarioCreacionid*:</label><div class="col-md-4" style="margin-bottom: 5px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioCreacionid\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.UsuarioCreacionid" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioCreacionid</span></div></div><label class="col-md-2 center-label">UsuarioModificacionId*:</label><div class="col-md-4" style="margin-bottom: 35px"><input type="text" spellcheck="true" uib-tooltip="{{$ctrl.returnDescription(\'UsuarioModificacionId\')}}" tooltip-class="customClass" tooltip-placement="bottom" class="form-control" ng-model="$ctrl.campoCargado.UsuarioModificacionId" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de UsuarioModificacionId</span></div></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></form></div><div class="table-responsive" ba-panel="" ba-panel-title="AutoSolicitud Detalle List" ba-panel-class="with-scroll"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center">Origen Campo</th><th class="text-center" st-sort-default="true">Ide Campo Destino</th><th class="text-center">Id Campo Origen</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.OrigenCampo}}</td><td align="center">{{item.IdCampoDestino}}</td><td align="center">{{item.IdCampoOrigen}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="item.Id==undefined || item.Id ==0">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/autosolicitud/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-2 col-sm-2" st-sort="AutoId">AutoId</th><th class="text-center col-xs-4 col-sm-4" st-sort="DetalleAcciones">DetalleAcciones</th><th class="text-center col-xs-3 col-sm-3" st-sort="SubjectCorreo">SubjectCorreo</th><th class="text-center col-xs-2 col-sm-2" st-sort="OrigenDiasdeCierre">Origen Dias de Cierre</th><th class="text-center col-xs-1 col-sm-1">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="AutoId" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por AutoId" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="DetalleAcciones" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por DetalleAcciones" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SubjectCorreo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por SubjectCorreo" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-2 col-sm-2">{{item.AutoId}}</td><td align="center" class="col-xs-4 col-sm-4">{{item.DetalleAcciones}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.SubjectCorreo}}</td><td align="center" class="col-xs-2 col-sm-2">{{item.OrigenDiasdeCierre}}</td><td align="center" class="col-xs-1 col-sm-1"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/auxparametros/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos Del Parametro" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="$ctrl.form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Ident*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Ident" name="codigo" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Ident.</span></div></div><label class="col-md-2 center-label">Descripci\xF3n*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Descripcion" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la Descripci\xF3n.</span></div></div><label class="col-md-2 center-label">TipoCampo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.TipoCampo" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el TipoCampo.</span></div></div><label class="col-md-2 center-label">OrdenImp:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.OrdenImp" name="name" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de OrdenImp.</span></div></div><label class="col-md-2 center-label">Campo *:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.model.campo" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchCampos($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingCampo" typeahead-no-results="noResults" class="form-control" typeahead-on-select="$ctrl.onSelectCampo($model)"> <i ng-show="loadingCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResults"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><label class="col-md-2 center-label">UrlDocumentos*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.UrlDocumentos" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar la UrlDocumentos.</span></div></div><label class="col-md-2 center-label">ObjetivoParametro*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.ObjetivoParametro" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el ObjetivoParametro.</span></div></div><label class="col-md-2 center-label">Parametro 1*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Parametro1" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Parametro 1.</span></div></div><label class="col-md-2 center-label">Parametro 2*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Parametro2" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Parametro 2.</span></div></div><label class="col-md-2 center-label">Parametro 3*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Parametro3" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Parametro 3.</span></div></div><label class="col-md-2 center-label">Parametro 4*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Parametro4" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Parametro 4.</span></div></div><label class="col-md-2 center-label">Parametro 5*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Parametro5" name="name" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Parametro 5.</span></div></div></div></form></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy">Eliminar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/auxparametros/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center" st-sort="Ident">Ident</th><th class="text-center" st-sort="Descripcion">Descripcion</th><th class="text-center" st-sort="ObjetivoParametro">ObjetivoParametro</th><th class="text-center" st-sort="OrdenImp">OrdenImp</th><th class="text-center" st-sort="TipoCampo">Tipo Campo</th><th class="text-center" st-sort="CreationDate">Fecha Creaci\xF3n</th><th class="text-center" st-sort="LastUpdate">\xDAltima Actualizaci\xF3n</th><th class="text-center" st-sort="UrlDocumentos">Url Documentos</th><th class="text-center" st-sort="Parametro1">Parametro 1</th><th class="text-center" st-sort="Parametro2">Parametro 2</th><th class="text-center" st-sort="Parametro3">Parametro 3</th><th class="text-center" st-sort="Parametro4">Parametro 4</th><th class="text-center" st-sort="Parametro5">Parametro 5</th><th class="text-center">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Ident" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Ident" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Descripcion" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Descripcion" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="ObjetivoParametro" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por ObjetivoParametro" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="OrdenImp" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por OrdenImp" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="TipoCampo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por TipoCampo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CreationDate" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por CreationDate" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="LastUpdate" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por LastUpdate" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="UrlDocumentos" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por UrlDocumentos" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Parametro1" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Parametro1" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Parametro2" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Parametro2" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Parametro3" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Parametro3" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Parametro4" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Parametro4" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Parametro5" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por Parametro5" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" style="white-space: wrap">{{item.Ident}}</td><td align="center" style="white-space: wrap">{{item.Descripcion}}</td><td align="center" style="white-space: wrap">{{item.ObjetivoParametro}}</td><td align="center" style="white-space: wrap">{{item.OrdenImp}}</td><td align="center" style="white-space: wrap">{{item.TipoCampo}}</td><td align="center" style="white-space: wrap">{{item.CreationDate}}</td><td align="center" style="white-space: wrap">{{item.LastUpdate}}</td><td align="center" style="white-space: wrap">{{item.UrlDocumentos}}</td><td align="center" style="white-space: wrap">{{item.Parametro1}}</td><td align="center" style="white-space: wrap">{{item.Parametro2}}</td><td align="center" style="white-space: wrap">{{item.Parametro3}}</td><td align="center" style="white-space: wrap">{{item.Parametro4}}</td><td align="center" style="white-space: wrap">{{item.Parametro5}}</td><td align="center" style="white-space: wrap"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/campo/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="campos"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Identificador*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.CampoId" required=""><div ng-messages="form.CampoId.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el Identificador del campo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Tipo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.CampoTipo" placeholder="Ingrese el tipo de campo a configurar..." uib-typeahead="item as item.Nombre for item in $ctrl.searchCampoTipo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingCampoTipo" typeahead-no-results="noResultsCampoTipo"> <i ng-show="loadingCampoTipo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsCampoTipo"><i class="glyphicon glyphicon-remove"></i> Tipo de Campo no encontrado</div></div><label class="col-md-2 center-label">Nombre Ingl\xE9s:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.NombreENG"></div><label class="col-md-2 center-label">Nombre Portugu\xE9s:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.NombrePOR"></div><label class="col-md-2 center-label">Nombre IDM1:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.NombreIDM1"></div><label class="col-md-2 center-label">Aux 1:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Aux01"></div><label class="col-md-2 center-label">Aux 2:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Aux02"></div><label class="col-md-2 center-label">Aux 3:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Aux03"></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'LINK\' || $ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'">Valor por defecto:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'LINK\' || $ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.defaultValue"></div><label class="col-md-2 center-label" ng-if="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'TEXTAREA\' || $ctrl.model.CampoTipo.Codigo == \'JERARQ\'">Es de lectura?:</label><div class="col-md-4" ng-if="$ctrl.model.CampoTipo.Codigo == \'TEXT\' || $ctrl.model.CampoTipo.Codigo == \'TEXTAREA\' || $ctrl.model.CampoTipo.Codigo == \'JERARQ\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.isReadOnly"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'">Se ejecuta siempre?:</label><div class="col-md-4" ng-if="$ctrl.model.CampoTipo.Codigo == \'PROCEDURE\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.runProcedure"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\' || $ctrl.model.CampoTipo.Codigo == \'LIST\' || $ctrl.model.CampoTipo.Codigo == \'MULTI_LIST\'">Jerarqu\xEDa*:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\' || $ctrl.model.CampoTipo.Codigo == \'LIST\' || $ctrl.model.CampoTipo.Codigo == \'MULTI_LIST\'"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Jerarquia" placeholder="Ingrese la Jerarqu\xEDa a configurar..." uib-typeahead="item as item.Nombre for item in $ctrl.searchJerarquia($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingJerarquia" typeahead-no-results="noResultsJerarquia"> <i ng-show="loadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsJerarquia"><i class="glyphicon glyphicon-remove"></i> Jerarqu\xEDa no encontrada</div></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\' || $ctrl.model.CampoTipo.Codigo == \'TABLEENR\'">Total Filas*:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\' || $ctrl.model.CampoTipo.Codigo == \'TABLEENR\'"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.TotalRegistrosTabla" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'">Permite Editar Columna:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteEditarColumna"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLEENR\'">Permite Editar Columna:</label><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLEENR\'"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteEditarColumna"></ba-switcher></div><div class="col-md-4" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\'" style="margin-top: 10px"><input type="checkbox" ng-model="$ctrl.model.PermiteAltaJerarquia" name=""> Permitir el alta de nuevos elementos</div><div class="col-md-12" ng-show="$ctrl.model.CampoTipo.Codigo == \'JERARQ\'" style="margin-top: 10px"><input type="checkbox" ng-model="$ctrl.model.tipoNumerador" name=""> Es tipo numerador?</div></div><div ba-panel="" ba-panel-title="Columnas de la Tabla" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLE\'"><label class="col-md-2 center-label" style="margin-top:10px">Campo*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.campoCargado.ColumnaCampoInput" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchColumnaCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingColumnaCampo" typeahead-no-results="noResultsColumnaCampo" class="form-control" typeahead-on-select="$ctrl.onSelectColumnaCampo($model)"> <i ng-show="loadingColumnaCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsColumnaCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><button class="btn btn-secondary" ng-click="$ctrl.editColumnaCampo(form)" ng-disabled="$ctrl.isBusy">Agregar</button><div class="table-responsive"><table class="table" st-table="$ctrl.camposTablaList" style="margin-top:20px"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.camposTablaList"><td align="center">{{item.ColumnaCampo.Nombre}}</td><td align="center">{{item.ColumnaCampo.CampoTipo.Nombre}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarColumnaCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></div><div ba-panel="" ba-panel-title="Propiedades de la Tabla Personalizada" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLEENR\'"><div ba-panel="" ba-panel-title="Encabezado" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLEENR\'" style="margin-top: 10px"><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Alto Encabezado (px):</label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.encabezadoHeight" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Color Encabezado:</label><div class="col-md-8"><div class="col-sm-1 cssForPreviewColor" ng-style="style={\'background-color\': $ctrl.model.encabezadoColor}"></div><input colorpicker="rgba" type="text" class="form-control" ng-model="$ctrl.model.encabezadoColor" maxlength="50" style="float: right;width: 90%;"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Tama\xF1o Fuente Encabezado (px):</label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.encabezadoFontSize" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Color Fuente:</label><div class="col-md-8"><div class="col-sm-1 cssForPreviewColor" ng-style="myStyleCFUENTE2={\'background-color\': $ctrl.model.encabezadoFontColor }"></div><input colorpicker="rgba" type="text" class="form-control" ng-model="$ctrl.model.encabezadoFontColor" maxlength="50" style="float: right;width: 90%;"></div></div></div><div ba-panel="" ba-panel-title="Cuerpo Tabla" style="margin-top: 10px"><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Alto Filas (px):</label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.bodyHeight" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Tama\xF1o Fuente (px):</label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.bodyFontSize" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Color Fila:</label><div class="col-md-8"><div class="col-sm-1 cssForPreviewColor" ng-style="myStyleCFUENTE={\'background-color\': $ctrl.model.bodyColor }"></div><input colorpicker="rgba" type="text" class="form-control" ng-model="$ctrl.model.bodyColor" maxlength="20" style="float: right;width: 90%;"></div></div><div class="col-md-6" style="margin-top: 10px"><label class="col-md-4 center-label">Color Fuente:</label><div class="col-md-8"><div class="col-sm-1 cssForPreviewColor" ng-style="myStyleCFUENTE={\'background-color\': $ctrl.model.bodyFontColor }"></div><input colorpicker="rgba" type="text" class="form-control" ng-model="$ctrl.model.bodyFontColor" maxlength="20" style="float: right;width: 90%;"></div></div></div></div><div ba-panel="" ba-panel-title="Columnas de la Tabla Personalizada" ng-show="$ctrl.model.CampoTipo.Codigo == \'TABLEENR\'"><label class="col-md-2 center-label" style="margin-top:10px">Campo*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.campoCargado.ColumnaCampoInput" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchColumnaCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingColumnaCampo" typeahead-no-results="noResultsColumnaCampo" class="form-control" typeahead-on-select="$ctrl.onSelectColumnaCampo($model)"> <i ng-show="loadingColumnaCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsColumnaCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><button class="btn btn-secondary" ng-click="$ctrl.editColumnaCampo(form)" ng-disabled="$ctrl.isBusy">Agregar</button><div class="table-responsive"><table class="table" st-table="$ctrl.camposTablaList" style="margin-top:20px"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center">Ancho Columna (%)</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.camposTablaList"><td align="center">{{item.ColumnaCampo.Nombre}}</td><td align="center">{{item.ColumnaCampo.CampoTipo.Nombre}}</td><td align="center"><input type="text" spellcheck="true" class="form-control" ng-model="item.encabezadoWidth" maxlength="20"></td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarColumnaCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></div><div ba-panel="" ba-panel-title="Condiciones" ng-show="$ctrl.model.CampoTipo.Codigo==\'COND\'"><label class="col-md-2 center-label" style="margin-top:10px">Condicion*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.campoCargado.condicion" placeholder="Ingrese la condicion" class="form-control"></div><label class="col-md-2 center-label" style="margin-top:10px">Campo*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.campoCargado.ColumnaCampoInput" placeholder="Ingrese un campo a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchColumnaCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingColumnaCampo" typeahead-no-results="noResultsColumnaCampo" class="form-control" typeahead-on-select="$ctrl.onSelectColumnaCampo($model)"> <i ng-show="loadingColumnaCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsColumnaCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><div class="col-md-12" style="margin-top:10px"><button class="btn btn-secondary pull-right" ng-click="$ctrl.editColumnaCampoCondicional(form)" ng-disabled="$ctrl.isBusy">Agregar</button></div><div class="table-responsive"><table class="table" st-table="$ctrl.camposTablaListCondicional" style="margin-top:20px"><thead><tr class="sortable"><th class="text-center">Condicion</th><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.camposTablaListCondicional"><td align="center">{{item.condicion}}</td><td align="center">{{item.ColumnaCampo.Nombre}}</td><td align="center">{{item.ColumnaCampo.CampoTipo.Nombre}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarColumnaCampoCondicional($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody></table></div></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></form></div>');
$templateCache.put('app/pages/campo/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-secondary" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable row"><th class="text-center col-xs-2 col-sm-2">C\xF3digo</th><th class="text-center col-xs-4 col-sm-4" st-sort="Nombre">Nombre</th><th class="text-center col-xs-2 col-sm-2" st-sort="CampoTipo.Nombre">Tipo</th><th class="text-center col-xs-2 col-sm-2" st-sort="Jerarquia.Nombre">Jerarqu\xEDa</th><th class="text-center col-xs-2 col-sm-2">Datos</th></tr><tr class="row"><th></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CampoTipo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Jerarquia.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por jerarqu\xEDa" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-2 col-sm-2">{{item.CampoId}}</td><td align="center" class="col-xs-4 col-sm-4">{{item.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2">{{item.CampoTipo.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2">{{item.Jerarquia.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="6" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/grupo/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" class="add-top-space"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-10"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Resumen:</label><div class="col-md-10"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Resumen" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Fondo:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorFondo" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Texto:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorTexto" name="" placeholder=""></div><label class="col-md-2 center-label">URL Imagen:</label><div class="col-md-10" style="margin-top:17px"><a href="" ng-click="$ctrl.openAttachment($ctrl.model.UrlImagen)" class="text-links">{{$ctrl.model.UrlImagen}}</a><div class="btn btn-success editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachment($file)">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment()" ng-disabled="$ctrl.isBusy">Quitar</div><p ng-show="ctrl.model.isImageLoading">Cargando archivo...</p></div><label class="col-md-2 center-label" style="margin-top:25px">Mostrar en Home*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.MostrarEnHome"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.MostrarEnHome">Orden en Home:</label><div class="col-md-4" ng-show="$ctrl.model.MostrarEnHome"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.HomeOrden" name="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="3"></div></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></form></div>');
$templateCache.put('app/pages/grupo/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-secondary" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable row"><th class="text-center col-xs-5 col-sm-5" st-sort="Nombre">Nombre</th><th class="text-center col-xs-5 col-sm-5" st-sort="Resumen">Resumen</th><th class="text-center col-xs-2 col-sm-2">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Resumen" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por resumen" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-5 col-sm-5">{{item.Nombre}}</td><td align="center" class="col-xs-5 col-sm-5">{{item.Resumen}}</td><td align="center" class="col-xs-2 col-sm-2"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="2" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="2" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/grupos-usuarios/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" class="add-top-space" id="grupo-usuarios"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos del Grupo\' : (($ctrl.language == \'ingles\') ? \'Group Data\' : (($ctrl.language == \'portugues\') ? \'Dados do grupo\' : \'italiano\')) }}" ba-panel-class="with-scroll"><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre*:</span> <span ng-if="$ctrl.language == \'ingles\'">Name*:</span> <span ng-if="$ctrl.language == \'portugues\'">Nome*:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano*:</span></label><div class="col-md-10"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe completar el nombre</span> <span ng-if="$ctrl.language == \'ingles\'">You must complete the name</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve preencher o nome</span> <span ng-if="$ctrl.language == \'italiano\'">Debe completar el nombre</span></span></div></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos de Usuario\' : (($ctrl.language == \'ingles\') ? \'User Data\' : (($ctrl.language == \'portugues\') ? \'Dados do usu\xE1rio\' : \'italiano\')) }}" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario*:</span> <span ng-if="$ctrl.language == \'ingles\'">User*:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio*:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano*:</span></label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.usuarioCargado.UsuarioInput" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to search...\' : (($ctrl.language == \'portugues\') ? \'Digite um usu\xE1rio para pesquisar...\' : \'Ingrese un usuario a buscar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuario($model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></div></div></div><div class="col-md-12"><label class="col-md-12 center-label"></label> <label class="col-md-12 center-label"></label></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearUsuario()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Limpiar</span> <span ng-if="$ctrl.language == \'ingles\'">Clear</span> <span ng-if="$ctrl.language == \'portugues\'">Limpar</span> <span ng-if="$ctrl.language == \'italiano\'">Limpiar</span></button> <button class="btn btn-success pull-right" ng-click="$ctrl.editUsuario(form)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Usuarios del Grupo\' : (($ctrl.language == \'ingles\') ? \'Group Users\' : (($ctrl.language == \'portugues\') ? \'Usu\xE1rios do grupo\' : \'Usuarios del Grupo\')) }}" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acciones</span> <span ng-if="$ctrl.language == \'ingles\'">Actions</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xF5es</span> <span ng-if="$ctrl.language == \'italiano\'">Acciones</span></th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por usuario\' : (($ctrl.language == \'ingles\') ? \'Search by user\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'Buscar por usuario\')) }}" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.cargarUsuario(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarUsuario(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarUsuario(item.Usuario.Id)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></button></td></tr></tbody><tbody ng-show="$ctrl.isUsuarioSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Apagar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div></form></div>');
$templateCache.put('app/pages/grupos-usuarios/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-click="$ctrl.add()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Agregar</span> <span ng-if="$ctrl.language == \'ingles\'">Add</span> <span ng-if="$ctrl.language == \'portugues\'">Adicionar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-10 col-sm-10" st-sort="Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center col-xs-2 col-sm-2"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Datos</span></th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por nombre\' : (($ctrl.language == \'ingles\') ? \'Search by name\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por nome\' : \'Buscar por nombre\')) }}" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-10 col-sm-10">{{item.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="3" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando..</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="3" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/home/home.html','<ba-sidebar></ba-sidebar><section class="home container-fluid"><iframe ng-if="$ctrl.powerbiReport" ng-src="{{$ctrl.powerbiReport}}" frameborder="0"></iframe></section>');
$templateCache.put('app/pages/jerarquia/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" id="datos-principales" class="add-top-space"><form name="form" novalidate=""><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Principales\' : (($ctrl.language == \'ingles\') ? \'Main Data\' : (($ctrl.language == \'portugues\') ? \'Dados Principais\' : \'italiano\')) }}" class="add-top-space"><label class="col-md-1 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">C\xF3digo*:</span> <span ng-if="$ctrl.language == \'ingles\'">Code*:</span> <span ng-if="$ctrl.language == \'portugues\'">C\xF3digo*:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano*:</span></label><div class="col-md-5"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Codigo" ng-disabled="$ctrl.isOnlyRead" name="" placeholder=""></div><label class="col-md-1 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre*:</span> <span ng-if="$ctrl.language == \'ingles\'">Name*:</span> <span ng-if="$ctrl.language == \'portugues\'">Nome*:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano*:</span></label><div class="col-md-5"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" ng-disabled="$ctrl.isOnlyRead" name="" placeholder=""></div><label class="col-md-1 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Padre</span> <span ng-if="$ctrl.language == \'ingles\'">Parent</span> <span ng-if="$ctrl.language == \'portugues\'">Pai</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></label><div class="col-md-5"><input type="text" spellcheck="true" ng-model="$ctrl.model.JerarquiaPadreInput" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese una jerarqu\xEDa a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter a hierarchy to search...\' : (($ctrl.language == \'portugues\') ? \'Insira uma hierarquia para pesquisar...\' : \'italiano\')) }}" ng-disabled="$ctrl.isOnlyRead" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquiaPadre($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingJerarquiaPadre" typeahead-no-results="noResultsJerarquia" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($model)"> <i ng-show="loadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsJerarquia"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Jerarqu\xEDa no encontrada</span> <span ng-if="$ctrl.language == \'ingles\'">Hierarchy not found</span> <span ng-if="$ctrl.language == \'portugues\'">Hierarquia n\xE3o encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></div></div><label class="col-md-1 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Activo:</span> <span ng-if="$ctrl.language == \'ingles\'">Active:</span> <span ng-if="$ctrl.language == \'portugues\'">Ativo:</span> <span ng-if="$ctrl.language == \'italiano\'">Activo:</span></label><div class="col-md-5" style="margin-top:1px" ng-class="{\'switcher-disabled\': $ctrl.isOnlyRead}"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.Activo" switcher-language="$ctrl.language"></ba-switcher></div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.MostrarDetalle" name="" ng-disabled="$ctrl.isBusy"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Tiene detalle?</span> <span ng-if="$ctrl.language == \'ingles\'">Has details?</span> <span ng-if="$ctrl.language == \'portugues\'">Tem detalhe?</span> <span ng-if="$ctrl.language == \'italiano\'">Tiene detalle?</span></div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TienePermisos" name="" ng-disabled="$ctrl.isBusy"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Es de permisos?</span> <span ng-if="$ctrl.language == \'ingles\'">Is it for permissions?</span> <span ng-if="$ctrl.language == \'portugues\'">\xC9 uma autoriza\xE7\xE3o?</span> <span ng-if="$ctrl.language == \'italiano\'">Es de permisos?</span></div><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TieneTemplateDependiente" name="" ng-disabled="$ctrl.isBusy"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Tiene Gesti\xF3n Dependiente?</span> <span ng-if="$ctrl.language == \'ingles\'">Has Dependent Management?</span> <span ng-if="$ctrl.language == \'portugues\'">Tem Gest\xE3o Dependente?</span> <span ng-if="$ctrl.language == \'italiano\'">Tiene Gesti\xF3n Dependiente?</span></div><div class="col-md-12" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.TieneJerarquiaPermisosCampos" name="" ng-disabled="$ctrl.isBusy"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Tiene Seguridad Campos?</span> <span ng-if="$ctrl.language == \'ingles\'">Has Field Security?</span> <span ng-if="$ctrl.language == \'portugues\'">Tem Seguran\xE7a de Campos?</span> <span ng-if="$ctrl.language == \'italiano\'">Tiene Seguridad Campos?</span></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Gesti\xF3n Dependiente\' : (($ctrl.language == \'ingles\') ? \'Dependent Management\' : (($ctrl.language == \'portugues\') ? \'Gest\xF5es Dependente\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.TieneTemplateDependiente" class="add-top-space"><div class="col-md-12"><label class="col-md-4 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso*:</span> <span ng-if="$ctrl.language == \'ingles\'">Process*:</span> <span ng-if="$ctrl.language == \'portugues\'">Processo*:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano*:</span></label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" value="$ctrl.procesoFounded1.Nombre" ng-model="$ctrl.procesoFounded1" ng-disabled="$ctrl.isOnlyRead" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'Ingrese el proceso a configurar...\')) }}" uib-typeahead="item as item.Nombre for item in $ctrl.searchProceso($viewValue)" typeahead-wait-ms="300" typeahead-loading="loadingProceso1" typeahead-no-results="noResultsProceso1" typeahead-on-select="$ctrl.loadJerarquiaProcesos($ctrl.procesoFounded1.Id)"> <i ng-show="loadingProceso1" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProceso1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div></div><div class="col-md-12" style="margin-top:10px" ng-show="!$ctrl.isOnlyRead"><ul class="list-group col-md-6 add-top-space"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Para Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">To Select</span> <span ng-if="$ctrl.language == \'portugues\'">Para Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Para Seleccionar</span></li><li multiple="" name="{{item.Campo.Id}}" ng-repeat="j in $ctrl.resultListJerarquiaProcesos track by j.Template.Id" ng-click="$ctrl.actionAddOnClick(j);" class="list-group-item list-group-item-action"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Template.Nombre}}</a></li></ul><ul class="list-group col-md-6 add-top-space"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionado</span> <span ng-if="$ctrl.language == \'ingles\'">Selected</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionado</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionado</span></li><li multiple="" name="{{item.Campo.Id}}" ng-repeat="j in $ctrl.arrayTemplateSeleccionados track by j.Template.Id" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClick(j);"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Template.Nombre}}</a></li></ul></div><div class="col-md-12" style="margin-top: 20px" ng-show="$ctrl.isOnlyRead"><ul class="list-group add-top-space"><div style="min-height: 100px; overflow-y: auto;" class="col-md-12"><li multiple="" name="{{item.Campo.Id}}" ng-repeat="j in $ctrl.arrayTemplateSeleccionados track by j.Template.Id" class="list-group-item list-group-item-action col-md-12">{{j.Template.Nombre}}</li></div></ul></div></div></form></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Detalles de Jerarqu\xEDa\' : (($ctrl.language == \'ingles\') ? \'Hierarchy Details\' : (($ctrl.language == \'portugues\') ? \'Detalhes da Hierarquia\' : \'italiano\')) }}" id="detalles-jerarquia" ba-panel-class="with-scroll" ng-show="$ctrl.model.MostrarDetalle"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos del Detalle a Mostrar\' : (($ctrl.language == \'ingles\') ? \'Details Data to Display\' : (($ctrl.language == \'portugues\') ? \'Dados do Detalhe a Exibir\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Titulo*:</span> <span ng-if="$ctrl.language == \'ingles\'">Title*:</span> <span ng-if="$ctrl.language == \'portugues\'">T\xEDtulo*:</span> <span ng-if="$ctrl.language == \'italiano\'">Titulo*:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.detalleCargado.Titulo" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor*:</span> <span ng-if="$ctrl.language == \'ingles\'">Value*:</span> <span ng-if="$ctrl.language == \'portugues\'">Valor*:</span> <span ng-if="$ctrl.language == \'italiano\'">Valor*:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.detalleCargado.Valor" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Orden*:</span> <span ng-if="$ctrl.language == \'ingles\'">Order*:</span> <span ng-if="$ctrl.language == \'portugues\'">Ordem*:</span> <span ng-if="$ctrl.language == \'italiano\'">Orden*:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.detalleCargado.Orden" ng-disabled="$ctrl.isOnlyRead" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearDetalle()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Limpiar</span> <span ng-if="$ctrl.language == \'ingles\'">Clear</span> <span ng-if="$ctrl.language == \'portugues\'">Limpar</span> <span ng-if="$ctrl.language == \'italiano\'">Limpiar</span></button> <button class="btn btn-success pull-right" ng-click="$ctrl.editDetalle(form)" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Detalles de Jerarqu\xEDa\' : (($ctrl.language == \'ingles\') ? \'Hierarchy Details\' : (($ctrl.language == \'portugues\') ? \'Detalhes da Hierarquia\' : \'italiano\')) }}" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.jerarquiaDetalleDS" st-safe-src="$ctrl.model.Detalles"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Titulo</span> <span ng-if="$ctrl.language == \'ingles\'">Title</span> <span ng-if="$ctrl.language == \'portugues\'">T\xEDtulo</span> <span ng-if="$ctrl.language == \'italiano\'">Titulo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor</span> <span ng-if="$ctrl.language == \'ingles\'">Value</span> <span ng-if="$ctrl.language == \'portugues\'">Valor</span> <span ng-if="$ctrl.language == \'italiano\'">Valor</span></th><th class="text-center" st-sort-default="true"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Orden</span> <span ng-if="$ctrl.language == \'ingles\'">Order</span> <span ng-if="$ctrl.language == \'portugues\'">Ordem</span> <span ng-if="$ctrl.language == \'italiano\'">Orden</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acciones</span> <span ng-if="$ctrl.language == \'ingles\'">Actions</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xF5es</span> <span ng-if="$ctrl.language == \'italiano\'">Acciones</span></th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Titulo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por t\xEDtulo\' : (($ctrl.language == \'ingles\') ? \'Search by title\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por t\xEDtulo\' : \'Buscar por t\xEDtulo\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Valor" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por valor\' : (($ctrl.language == \'ingles\') ? \'Search by value\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por valor\' : \'Buscar por valor\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por orden\' : (($ctrl.language == \'ingles\') ? \'Search by order\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por ordem\' : \'Buscar por orden\')) }}" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isDetalleSearching"><tr ng-repeat="item in $ctrl.jerarquiaDetalleDS" ng-click="$ctrl.cargarDetalle(item)" style="cursor: pointer"><td align="center">{{item.Titulo}}</td><td align="center">{{item.Valor}}</td><td align="center">{{item.Orden}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarDetalle(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarDetalle($index)" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></button></td></tr></tbody><tbody ng-show="$ctrl.isDetalleSearching"><tr><td colspan="4" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Permisos de Jerarqu\xEDa\' : (($ctrl.language == \'ingles\') ? \'Hierarchy Permissions\' : (($ctrl.language == \'portugues\') ? \'Permiss\xF5es de Hierarquia\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.TienePermisos" id="permisos-jerarquia"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Etapa 2\' : (($ctrl.language == \'ingles\') ? \'Stage 2 Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Etapa 2\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Subject Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Subject:</span> <span ng-if="$ctrl.language == \'portugues\'">Assunto Correio:</span> <span ng-if="$ctrl.language == \'italiano\'">Subject Correo:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa2" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email:</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico:</span> <span ng-if="$ctrl.language == \'italiano\'">Correo:</span></label><div class="col-md-4"><textarea type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa2" ng-disabled="$ctrl.isOnlyRead" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 1 *:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 1 *:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa2" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo1Etapa2.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults1" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 2:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 2:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa2" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo2Etapa2.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults2" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 3:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 3:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa2" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo3Etapa2.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults3" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults3"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Etapa 3\' : (($ctrl.language == \'ingles\') ? \'Stage 3 Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Etapa 3\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Subject Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Subject:</span> <span ng-if="$ctrl.language == \'portugues\'">Assunto Correio:</span> <span ng-if="$ctrl.language == \'italiano\'">Subject Correo:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa3" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo</span> <span ng-if="$ctrl.language == \'ingles\'">Email</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico</span> <span ng-if="$ctrl.language == \'italiano\'">Correo</span></label><div class="col-md-4"><textarea type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa3" ng-disabled="$ctrl.isOnlyRead" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 1 *:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 1 *:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa3" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo1Etapa3.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults1" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 2:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 2:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa3" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo2Etapa3.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults2" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 3:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 3:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa3" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo3Etapa3.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults3" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults3"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Etapa 4\' : (($ctrl.language == \'ingles\') ? \'Stage 4 Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Etapa 4\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Subject Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Subject:</span> <span ng-if="$ctrl.language == \'portugues\'">Assunto Correio:</span> <span ng-if="$ctrl.language == \'italiano\'">Subject Correo:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa4" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo</span> <span ng-if="$ctrl.language == \'ingles\'">Email</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico</span> <span ng-if="$ctrl.language == \'italiano\'">Correo</span></label><div class="col-md-4"><textarea type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa4" ng-disabled="$ctrl.isOnlyRead" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 1 *:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 1 *:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa4" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo1Etapa4.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults1" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 2:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 2:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa4" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo2Etapa4.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults2" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 3:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 3:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa4" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo3Etapa4.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults3" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults3"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Etapa 5\' : (($ctrl.language == \'ingles\') ? \'Stage 5 Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Etapa 5\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Subject Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Subject:</span> <span ng-if="$ctrl.language == \'portugues\'">Assunto Correio:</span> <span ng-if="$ctrl.language == \'italiano\'">Subject Correo:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoEtapa5" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo</span> <span ng-if="$ctrl.language == \'ingles\'">Email</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico</span> <span ng-if="$ctrl.language == \'italiano\'">Correo</span></label><div class="col-md-4"><textarea type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoEtapa5" ng-disabled="$ctrl.isOnlyRead" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 1 *:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 1 *:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1Etapa5" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo1Etapa5.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults1" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 2:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 2:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2Etapa5" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo2Etapa5.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults2" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 3:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 3:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3Etapa5" ng-disabled="$ctrl.isOnlyRead" value="$ctrl.model.Permisos.grupo3Etapa5.Nombre" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults3" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults3"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos Lectores\' : (($ctrl.language == \'ingles\') ? \'Reader Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Leitor\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Subject Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Subject:</span> <span ng-if="$ctrl.language == \'portugues\'">Assunto Correio:</span> <span ng-if="$ctrl.language == \'italiano\'">Subject Correo:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.subjectCorreoLectores" ng-disabled="$ctrl.isOnlyRead"></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo:</span> <span ng-if="$ctrl.language == \'ingles\'">Email:</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico:</span> <span ng-if="$ctrl.language == \'italiano\'">Correo:</span></label><div class="col-md-4"><textarea type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.model.Permisos.cuerpoCorreoLectores" ng-disabled="$ctrl.isOnlyRead" cols="40" rows="5"></textarea></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 1 *:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 1 *:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 1 *:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo1EtapaLectores" ng-disabled="$ctrl.isOnlyRead" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults1" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults1"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 2:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 2:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 2:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo2EtapaLectores" ng-disabled="$ctrl.isOnlyRead" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults2" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'ingles\'">Group 3:</span> <span ng-if="$ctrl.language == \'portugues\'">Grupo 3:</span> <span ng-if="$ctrl.language == \'italiano\'">Grupo 3:</span></label><div class="col-md-4"><input type="text" spellcheck="true" name="grupo" class="form-control" ng-model="$ctrl.model.Permisos.grupo3EtapaLectores" ng-disabled="$ctrl.isOnlyRead" autocomplete="off" uib-typeahead="group as group.Nombre for group in $ctrl.searchGroup($viewValue)" typeahead-wait-ms="500" typeahead-no-results="noResults3" typeahead-on-select="$ctrl.clearInput($model)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un grupo usuario a buscar...\' : (($ctrl.language == \'ingles\') ? \'Enter an users group to search...\' : (($ctrl.language == \'portugues\') ? \'Insira um grupo de usu\xE1rios para pesquisar...\' : \'italiano\')) }}"><div ng-show="noResults3"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo.</span> <span ng-if="$ctrl.language == \'ingles\'">You must select a group</span> <span ng-if="$ctrl.language == \'portugues\'">Voc\xEA deve selecionar um grupo</span> <span ng-if="$ctrl.language == \'italiano\'">Debe seleccionar un grupo.</span></span></div></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Seguridad de Campos\' : (($ctrl.language == \'ingles\') ? \'Fields Security\' : (($ctrl.language == \'portugues\') ? \'Seguran\xE7a de Campo\' : \'italiano\')) }}" id="seguridad-campos" ba-panel-class="with-scroll" ng-show="$ctrl.model.TieneJerarquiaPermisosCampos"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Proceso\' : (($ctrl.language == \'ingles\') ? \'Process\' : (($ctrl.language == \'portugues\') ? \'Processo\' : \'italiano\')) }}"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso*:</span> <span ng-if="$ctrl.language == \'ingles\'">Process*:</span> <span ng-if="$ctrl.language == \'portugues\'">Processo*:</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso*:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" value="$ctrl.procesoFounded2.Id + \' - \' + $ctrl.procesoFounded2.Nombre" ng-model="$ctrl.procesoFounded2" ng-disabled="$ctrl.isOnlyRead" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'italiano\')) }}" uib-typeahead="item as (item.Id + \' - \' + item.Nombre) for item in $ctrl.searchProceso($viewValue)" typeahead-wait-ms="300" typeahead-loading="loadingProceso2" typeahead-no-results="noResultsProceso2" typeahead-on-select="$ctrl.loadCamposProceso($ctrl.procesoFounded2.Id)"> <i ng-show="loadingProceso2" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProceso2"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Campos de Proceso\' : (($ctrl.language == \'ingles\') ? \'Process Fields\' : (($ctrl.language == \'portugues\') ? \'Campos de Processo\' : \'Campos de Proceso\')) }}" ng-if="$ctrl.resultListCamposProceso.length>0"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos del Campo\' : (($ctrl.language == \'ingles\') ? \'Field Data\' : (($ctrl.language == \'portugues\') ? \'Dados de campo\' : \'Datos del Campo\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Campo*:</span> <span ng-if="$ctrl.language == \'ingles\'">Field*:</span> <span ng-if="$ctrl.language == \'portugues\'">Campo*:</span> <span ng-if="$ctrl.language == \'italiano\'">Campo*:</span></label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.Campo" ng-disabled="$ctrl.isOnlyRead" class="form-control" ng-options="item as item.Nombre for item in $ctrl.resultListCamposProceso track by item.Id"></select></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Limpiar</span> <span ng-if="$ctrl.language == \'ingles\'">Clear</span> <span ng-if="$ctrl.language == \'portugues\'">Limpar</span> <span ng-if="$ctrl.language == \'italiano\'">Limpiar</span></button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Campos Cargados\' : (($ctrl.language == \'ingles\') ? \'Loaded Fields\' : (($ctrl.language == \'portugues\') ? \'Campos Carregados\' : \'Campos Cargados\')) }}" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acciones</span> <span ng-if="$ctrl.language == \'ingles\'">Actions</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xF5es</span> <span ng-if="$ctrl.language == \'italiano\'">Acciones</span></th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por campo\' : (($ctrl.language == \'ingles\') ? \'Search by field\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por campo\' : \'Buscar por campo\')) }}" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></div><div class="col-md-12" style="padding-top: 25px;margin-top: 5px; margin-bottom: 15px; padding-bottom: 60px;"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy" ng-if="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete" ng-if="!$ctrl.isOnlyRead"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Apagar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div>');
$templateCache.put('app/pages/jerarquia/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-click="$ctrl.add()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Agregar</span> <span ng-if="$ctrl.language == \'ingles\'">Add</span> <span ng-if="$ctrl.language == \'portugues\'">Adicionar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-3 col-sm-3" st-sort="Codigo"><span ng-if="$ctrl.language == \'espa\xF1ol\'">C\xF3digo</span> <span ng-if="$ctrl.language == \'ingles\'">Code</span> <span ng-if="$ctrl.language == \'portugues\'">C\xF3digo</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></th><th class="text-center col-xs-5 col-sm-5" st-sort="Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></th><th class="text-center col-xs-3 col-sm-3" st-sort="JerarquiaPadre.Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Jerarqu\xEDa Padre</span> <span ng-if="$ctrl.language == \'ingles\'">Parent Hierarchy</span> <span ng-if="$ctrl.language == \'portugues\'">Hierarquia Pai</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></th><th class="text-center col-xs-1 col-sm-1"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por c\xF3digo\' : (($ctrl.language == \'ingles\') ? \'Search by code\' : (($ctrl.language == \'portugues\') ? \'Pesquisa por c\xF3digo\' : \'italiano\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por nombre\' : (($ctrl.language == \'ingles\') ? \'Search by name\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por nome\' : \'italiano\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="JerarquiaPadre.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por jerarqu\xEDa padre\' : (($ctrl.language == \'ingles\') ? \'Search by parent hierarchy\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por hierarquia pai\' : \'italiano\')) }}" aria-describedby="basic-addon1"></div></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-3 col-sm-3">{{item.Codigo}}</td><td align="center" class="col-xs-5 col-sm-5">{{item.Nombre}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.JerarquiaPadre.Nombre}}</td><td align="center" class="col-xs-1 col-sm-1"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="4" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/reporte/templatespendienteslist.template.html','<div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ng-show="$ctrl.anularVista"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading">Cargando datos...</label></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><div class="add-top-space col-md-12 col-xs-12"><label class="col-md-12 col-xs-12 center-label">Reporte Generado en una nueva pesta\xF1a</label></div></div>');
$templateCache.put('app/pages/proceso/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="procesos"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos del Proceso" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><label class="col-md-2 center-label">C\xF3digo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Codigo" name="codigo" placeholder="" required="" ng-disabled="!$ctrl.enableDatosProcesoTab"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el c\xF3digo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" name="name" placeholder="" required="" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.actualizarTitulo()"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label">Grupo*:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.Grupo" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.Nombre for item in $ctrl.gruposList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Cantidad D\xEDas Cierre*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.CantidadDiasCierre" name="name" placeholder="" required="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8" ng-disabled="!$ctrl.enableDatosProcesoTab"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe ingresar la cantidad de d\xEDas al cierre.</span></div></div><label class="col-md-2 center-label" title="tiempo en segundos">Temporizador Autoguardado (s):</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.temporizadorGuardar" name="name" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><div class="col-md-12"><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Validaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Validaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereValidacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereValidacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereValidacion"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Verificaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Verificaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereVerificacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereVerificacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereVerificacion" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Requiere Aprobaci\xF3n*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Requiere Aprobaci\xF3n*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.RequiereAutorizacion">S\xED</label> <label ng-if="!$ctrl.model.RequiereAutorizacion">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.RequiereAutorizacion" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Ver Boton Agregar*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Boton Agregar*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.verBtnAgregar">S\xED</label> <label ng-if="!$ctrl.model.verBtnAgregar">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.verBtnAgregar"></ba-switcher></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Tiene Procedimiento Refresh?:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Tiene Procedimiento Refresh:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.tieneProcedimientoRefresh">S\xED</label> <label ng-if="!$ctrl.model.tieneProcedimientoRefresh">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.tieneProcedimientoRefresh"></ba-switcher></div></div><label class="col-md-2 center-label" ng-show="$ctrl.model.tieneProcedimientoRefresh">Nombre Procedimiento Refresh*:</label><div class="col-md-4" style="margin-bottom:25px" ng-show="$ctrl.model.tieneProcedimientoRefresh"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.procedimientoRefresh" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre del procedimiento.</span></div></div><label class="col-md-2 center-label">Nombre de Link del Proceso:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.NombreLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">URL de Link del Proceso:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.UrlLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">Nombre de Link de Solicitud:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.NombreSolicitudLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">URL de Link de Solicitud:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.UrlSolicitudLink" name="" placeholder="" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label">Color de Fondo:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorFondo" name="" placeholder=""></div><label class="col-md-2 center-label">Color de Texto:</label><div class="col-md-4"><input type="color" class="form-control" ng-model="$ctrl.model.ColorTexto" name="" placeholder=""></div><label class="col-md-2 center-label">Imagen:</label><div class="col-md-10" style="margin-top:12px"><a href="" ng-click="$ctrl.openAttachment($ctrl.model.UrlImagen)" class="text-links">{{$ctrl.model.UrlImagen}}</a><div class="btn btn-success editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachment($file)">Seleccionar</div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment()" ng-disabled="$ctrl.isBusy">Quitar</div><p ng-show="ctrl.model.isImageLoading">Cargando archivo...</p></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Mostrar en Home*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Mostrar en Home*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.MostrarEnHome">S\xED</label> <label ng-if="!$ctrl.model.MostrarEnHome">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.MostrarEnHome"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Requiere Justificacion:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.justificacionEsRequerida"></ba-switcher></div><div class="col-md-12 center-label" style="padding-left: 0px;"><label class="col-md-2 center-label" style="margin-top:25px" ng-show="$ctrl.model.MostrarEnHome">Jerarquia Gesti\xF3n:</label><div class="col-md-10" ng-show="$ctrl.model.MostrarEnHome" style="margin-top:10px"><select name="" class="form-control" ng-model="$ctrl.model.jerarquiatemplate"><option ng-repeat="item in $ctrl.procesoCamposListJerarquiaGestion" value="{{item.Campo.Id}}">{{ item.Campo.Id }} {{ item.Campo.Id != \'\' ? \' - \' : \'\' }} {{item.Campo.Nombre}}</option></select></div></div><label class="col-md-2 center-label" style="margin-top:25px">Permite Copia:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteCopia"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Permite Enviar a Obsoleto:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.permiteEnviarObsoleto"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Orden Descendente:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.orderDescending"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Versionado SP:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.versionadoSP"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Ver Procesos Cerrados:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.verProcesosCerrados"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Ver Mis Solicitudes:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.VerMisSolicitudes"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Es de Autorizaciones?:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.autorizaciones"></ba-switcher></div><label class="col-md-2 center-label" style="margin-top:25px">Proceso de Evidencia?:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.mcaOcultaAvanzarEtapa"></ba-switcher></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo Autorizaci\xF3n:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.campoIdAutorizacion"><option value="0" selected=""></option><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo de Tipo de Publicaci\xF3n:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.tipoDocumentoId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Campo Documento Publicable:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.documentoPublicableId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><div class="col-md-6" ng-show="$ctrl.model.autorizaciones"><label class="col-md-6 center-label" style="margin-top:25px">Codigo Numerador Documental:</label><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.numeradorDocumentalId"><option ng-repeat="item in $ctrl.procesoCamposList" value="{{item.Campo.Id}}">{{ item.Campo.Id }} - {{item.Campo.Nombre}}</option></select></div><label class="col-md-2 center-label" style="margin-top:25px" ng-show="$ctrl.model.autorizaciones">Autorizaci\xF3n Documental (V.2)?:</label><div class="col-md-4" ng-show="$ctrl.model.autorizaciones"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.autorizacionesDocumental"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.autorizaciones">Link:</label><div class="col-md-4" ng-show="$ctrl.model.autorizaciones"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.LinkDocumental" name="name" placeholder=""></div><div class="col-md-12 center-label"><label class="center-label" style="margin-top:25px" ng-show="$ctrl.model.MostrarEnHome">Orden en Home:</label><div ng-show="$ctrl.model.MostrarEnHome" style="margin-top:10px"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.HomeOrden" name="" placeholder="" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" maxlength="3" ng-disabled="!$ctrl.enableDatosProcesoTab"></div></div><label class="col-md-12 center-label">Configuraci\xF3n de T\xEDtulo*: <a href="" class="text-links" style="margin-left:5px" ng-click="$ctrl.showTituloConfigText = !$ctrl.showTituloConfigText"><i class="fa fa-eye"></i></a></label><div class="col-md-12" ng-show="!$ctrl.showTituloConfigText"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.ConfiguracionTitulo" placeholder="" id="configuracionTitulo" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.actualizarTituloConfigText()" ng-model-options="{ debounce: 1500 }"></div><label class="col-md-12 center-label" ng-show="$ctrl.showTituloConfigText" style="margin-top: 0px">{{$ctrl.configuracionTituloText}}</label><div class="col-md-12" style="margin-top:5px" ng-show="$ctrl.enableDatosProcesoTab"><a href="" class="text-links" ng-click="$ctrl.buscarCampoProcesoTitulo(!$ctrl.showCampoProcesoTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo del proceso</a></div><div class="col-md-12" style="margin-top:5px" ng-show="$ctrl.enableDatosProcesoTab"><a href="" class="text-links" ng-click="$ctrl.buscarCampoTemplateTitulo(!$ctrl.showTemplateTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo de Gesti\xF3n</a></div><div class="col-md-4" ng-show="$ctrl.showCampoProcesoTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Campo.Nombre for item in $ctrl.procesoCamposList track by item.Campo.Id" ng-change="$ctrl.onSelectCampoProcesoTitulo($ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo de proceso...</option></select></div><div class="col-md-4" ng-show="$ctrl.showTemplateTituloSelect"><select name="" class="form-control" ng-model="$ctrl.templateTituloSeleccionado" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.onSelectTemplateTitulo($ctrl.templateTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione una gesti\xF3n del proceso...</option></select></div><div class="col-md-4" ng-show="$ctrl.showCampoTemplateTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Nombre for item in $ctrl.templateCamposList track by item.Id" ng-change="$ctrl.onSelectCampoTemplateTitulo($ctrl.templateTituloSeleccionado, $ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo de la gesti\xF3n...</option></select></div><div class="col-md-12"><label class="col-md-4 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Desea generar automaticamente todos los procesos relacionados?*:</label><div class="col-md-2" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.model.generaProcesosRelacionados">S\xED</label> <label ng-if="!$ctrl.model.generaProcesosRelacionados">No</label></div><div class="col-md-2" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.generaProcesosRelacionados" ng-disabled="!$ctrl.enableDatosProcesoTab"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-4 center-label" style="margin-top:25px">Documental:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.isDocumental"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-4 center-label" style="margin-top:25px">Es Maestro:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.esMaestro"></ba-switcher></div></div><div class="col-md-12" ng-if="$ctrl.model.isDocumental"><label class="col-md-4 center-label">Proceso Id Versiones*:</label><div class="col-md-8"><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoIdVersiones"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id}} - {{proceso.Nombre}}</option></select></div></div><div class="col-md-12" ng-if="$ctrl.model.isDocumental"><label class="col-md-4 center-label">Proceso Id Obsoletos*:</label><div class="col-md-8"><select name="" class="col-md-6 form-control" ng-model="$ctrl.model.procesoIdObsoletos"><option ng-repeat="proceso in $ctrl.resultListProcesos" value="{{proceso.Id}}">{{ proceso.Id }}- {{proceso.Nombre}}</option></select></div></div></div></form></div></uib-tab><uib-tab index="1" heading="Campos de Proceso" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Campo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.campoCargado.Campo" placeholder="Ingrese el campo a configurar..." uib-typeahead="campo as campo.Nombre for campo in $ctrl.searchCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingCampo" typeahead-no-results="noResultsCampo"> <i ng-show="loadingCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><label class="col-md-2 center-label">Tipo Campo Solicitud*:</label><div class="col-md-4"><select name="" ng-model="$ctrl.campoCargado.TipoCampoSolicitud" class="form-control" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.Nombre for item in $ctrl.tipoCampoSolicitudList track by item.Id"></select></div><label class="col-md-2 center-label">Orden*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.campoCargado.Orden" ng-disabled="!$ctrl.enableDatosProcesoTab" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label">Ancho del Campo (%):</label><div class="col-md-4"><input type="number" class="form-control" ng-model="$ctrl.campoCargado.PorcentajeOcupacion" onkeypress="return event.charCode >= 48 && event.charCode <= 57" ng-change="$ctrl.validatePercentage($ctrl.campoCargado.PorcentajeOcupacion)"></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:25px">Obligatorio*:</label> <label class="col-md-2 center-label" ng-if="!$ctrl.enableDatosProcesoTab">Obligatorio*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.campoCargado.Obligatorio">S\xED</label> <label ng-if="!$ctrl.campoCargado.Obligatorio">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.campoCargado.Obligatorio"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></div><div ba-panel="" ba-panel-title="Campos Cargados" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoCamposDS" st-safe-src="$ctrl.procesoCamposList"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center" st-sort-default="true">Orden</th><th class="text-center">Tipo Campo Solicitud</th><th class="text-center">Obligatorio</th><th class="text-center">Porcentaje Ocupaci\xF3n</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.CampoTipo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo de campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por orden" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.procesoCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td><td align="center">{{item.Orden}}</td><td align="center">{{item.TipoCampoSolicitud.Nombre}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center">{{item.PorcentajeOcupacion}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></uib-tab><uib-tab index="2" heading="Seguridad de Procesos" select="$ctrl.loadSeguridadProcesosTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.MostrarOpcionProcesosPendientes" name="" ng-disabled="$ctrl.isBusy"> Mostrar filtro de \'Ver procesos pendientes de cualquier usuario\'</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.MostrarSolicitudesAUsuariosInvolucrados" name="" ng-disabled="$ctrl.isBusy"> Mostrar todas las solicitudes a los usuarios involucrados en el proceso</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.PermiteAvanzarProceso" name="" ng-disabled="$ctrl.isBusy"> Permitir Avanzar cuando sus procesos hijos NO est\xE1n en una etapa posterior a la etapa actual del proceso padre</div><div class="col-md-12"><input type="checkbox" ng-model="$ctrl.model.PermiteDerivarRes" name="" ng-disabled="$ctrl.isBusy"> Permitir derivar responsabilidad a otro usuario con el mismo rol</div></div><div ba-panel="" ba-panel-title="Datos de Usuario" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-2 center-label">Usuario*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.usuarioCargado.UsuarioInput" placeholder="Ingrese un usuario a buscar..." uib-typeahead="i as i.Login for i in $ctrl.searchUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuario($model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> Usuario no encontrado</div></div><label class="col-md-2 center-label">Roles*:</label><div class="col-md-4" style="height:125px"><select multiple="" name="" ng-model="$ctrl.usuarioCargado.RolProcesoList" class="form-control" style="height:125px" ng-options="item as item.Nombre for item in $ctrl.rolProcesoFilteredList track by item.Id"></select></div></div><div class="col-md-12"><label class="col-md-12 center-label"></label> <label class="col-md-12 center-label"></label></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearUsuario()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editUsuario(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Usuarios Cargados" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login">Usuario</th><th class="text-center">Roles Asociados</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span><input ng-model="$ctrl.searchProcesoUsuarioLogin" ng-change="$ctrl.searchProcesoUsuarios($ctrl.searchProcesoUsuarioLogin)" ng-model-options="{ debounce: 300 }" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por usuario" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.cargarUsuario(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarUsuario(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarUsuario(item.Usuario.Id)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isUsuarioSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot ng-show="$ctrl.showFooterTable"><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></uib-tab><uib-tab index="3" heading="Gestiones Asociadas" select="$ctrl.loadTemplatesTab()" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos de la Gesti\xF3n" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Gesti\xF3n*:</label><div class="col-md-4"><input type="text" spellcheck="true" ng-model="$ctrl.templateCargado.TemplateInput" placeholder="Ingrese una gesti\xF3n a buscar..." uib-typeahead="i as i.Nombre for i in $ctrl.searchTemplate($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingTemplate" typeahead-no-results="noResultsTemplate" class="form-control" typeahead-on-select="$ctrl.onSelectTemplate($model)" ng-disabled="!$ctrl.enableDatosProcesoTab"> <i ng-show="loadingTemplate" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsTemplate"><i class="glyphicon glyphicon-remove"></i> Gesti\xF3n no encontrada</div></div><label class="col-md-2 center-label">Etapa:</label><div class="col-md-4"><select name="" ng-model="$ctrl.templateCargado.SolicitudEstado" class="form-control" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-options="item as item.NombreEtapa for item in $ctrl.estadosFilteredList track by item.Id"></select></div><label class="col-md-2 center-label">Ocurrencia*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.templateCargado.Ocurrencia" name="" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8" ng-disabled="!$ctrl.enableDatosProcesoTab"></div><label class="col-md-2 center-label" ng-if="$ctrl.enableDatosProcesoTab">Obligatorio*:</label> <label class="col-md-2 center-label" style="margin-top:16px;margin-bottom:15px" ng-if="!$ctrl.enableDatosProcesoTab">Obligatorio*:</label><div class="col-md-4" style="margin-top:2px;margin-bottom:10px" ng-if="!$ctrl.enableDatosProcesoTab"><label ng-if="$ctrl.templateCargado.Obligatorio">S\xED</label> <label ng-if="!$ctrl.templateCargado.Obligatorio">No</label></div><div class="col-md-4" ng-if="$ctrl.enableDatosProcesoTab" style="margin-top:-3px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.templateCargado.Obligatorio"></ba-switcher></div><label class="col-md-2 center-label" style="margin:10px 0" ng-if="$ctrl.enableDatosProcesoTab">Acceso Directo*:</label> <label class="col-md-2 center-label" style="margin-top:5px" ng-if="!$ctrl.enableDatosProcesoTab">Acceso Directo*:</label><div class="col-md-4" ng-if="!$ctrl.enableDatosProcesoTab" style="margin-top:-10px"><label ng-if="$ctrl.templateCargado.EsAccesoDirecto">S\xED</label> <label ng-if="!$ctrl.templateCargado.EsAccesoDirecto">No</label></div><div class="col-md-4" style="margin-top:-3px" ng-if="$ctrl.enableDatosProcesoTab"><ba-switcher switcher-style="primary" switcher-value="$ctrl.templateCargado.EsAccesoDirecto"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearTemplate()" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editTemplate(form)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Guardar</button></div></div><div ba-panel="" ba-panel-title="Gestiones Cargadas" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoTemplatesDS" st-safe-src="$ctrl.procesoTemplatesList"><thead><tr class="sortable"><th class="text-center" st-sort="Template.Codigo">C\xF3digo</th><th class="text-center" st-sort="Template.Nombre">Nombre</th><th class="text-center" st-sort="SolicitudEstado.Nombre">Etapa</th><th class="text-center" st-sort="Ocurrencia">Ocurrencia</th><th class="text-center" st-sort="Obligatorio">Obligatorio</th><th class="text-center" st-sort="EsAccesoDirecto">Acceso Directo</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Codigo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SolicitudEstado.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por estado" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Ocurrencia" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por ocurrencia" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Obligatorio" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por obligatorio" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="EsAccesoDirecto" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por acceso directo" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isTemplateSearching"><tr ng-repeat="item in $ctrl.procesoTemplatesDS" ng-click="$ctrl.cargarTemplate(item)" style="cursor: pointer"><td align="center">{{item.Template.Codigo}}</td><td align="center">{{item.Template.Nombre}}</td><td align="center">{{item.SolicitudEstado.NombreEtapa}}</td><td align="center">{{item.Ocurrencia}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.EsAccesoDirecto"></i> <i class="fa fa-times" style="color:red" ng-hide="item.EsAccesoDirecto"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarTemplate(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarTemplate($index)" ng-disabled="$ctrl.isBusy || !$ctrl.enableDatosProcesoTab">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isTemplateSearching"><tr><td colspan="7" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="7" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></uib-tab><uib-tab index="4" heading="Seguridad de Gestiones" select="$ctrl.loadSeguridadTemplatesTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><div class="col-md-8"><label class="col-md-3 center-label">Gesti\xF3n*:</label><div class="col-md-9"><select name="" class="form-control" ng-model="$ctrl.usuarioTemplateCargado.ProcesoTemplate" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.loadTemplateUsuarioSeleccionado()"></select></div></div><div class="col-md-8" ng-repeat="item in $ctrl.usuarioTemplateCargado.Usuarios" ng-show="$ctrl.usuarioTemplateCargado.ProcesoTemplate != null"><label class="col-md-3 center-label">{{item.Nombre}} {{item.Apellido}}<br>{{item.Login}}</label><div class="col-md-9"><select multiple="" name="" ng-model="item.RolTemplateList" style="height:90px" class="form-control" ng-options="rol as rol.Nombre for rol in $ctrl.rolTemplateList track by rol.Id" ng-change="$ctrl.onRolTemplateSeleccionado($ctrl.usuarioTemplateCargado.ProcesoTemplate, item)"></select></div></div></div></uib-tab><uib-tab index="5" heading="Campos del Proceso en Gestiones" select="$ctrl.loadCamposTemplatesTab()" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><div class="col-md-8"><label class="col-md-3 center-label">Gesti\xF3n*:</label><div class="col-md-9"><select name="" class="form-control" ng-model="$ctrl.campoTemplateCargado.ProcesoTemplate" ng-options="item as item.Template.Nombre for item in $ctrl.procesoTemplatesList track by item.Template.Id" ng-change="$ctrl.loadTemplateCampoSeleccionado()"></select></div></div><div class="col-md-8" ng-show="$ctrl.campoTemplateCargado.ProcesoTemplate != null"><label class="col-md-12 center-label">Campos:</label><div class="col-md-12 col-md-offset-3" ng-repeat="item in $ctrl.procesoCamposList"><input type="checkbox" ng-model="item.Seleccionado" name="" ng-click="$ctrl.onTemplateCampoSeleccionado(item)" ng-disabled="!$ctrl.enableDatosProcesoTab"> <span>{{item.Campo.Nombre}}</span> <input type="number" ng-model="item.orden" name="" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.onTemplateCampoSeleccionadoOrden(item)" ng-keydown="$ctrl.evaluatenumberDigit($event)" style="float: right;margin-right: 50px;"></div></div></div></uib-tab><uib-tab index="6" heading="Procesos Hijo" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-class="with-scroll"><input type="checkbox" ng-model="$ctrl.model.AceptaHijos" ng-click="$ctrl.loadProcesosHijoTab($ctrl.model.AceptaHijos)" name="" ng-disabled="!$ctrl.enableDatosProcesoTab"> Acepta Procesos Hijo</div><div ba-panel="" ba-panel-title="Procesos Seleccionables Como Hijo" ba-panel-class="with-scroll" ng-show="$ctrl.model.AceptaHijos" class="add-top-space"><div class="col-md-8"><label class="col-md-2 center-label">Grupo*:</label><div class="col-md-10"><select name="" class="form-control" ng-model="$ctrl.procesoHijoCargado" ng-options="item as item.Grupo.Nombre for item in $ctrl.allProcesosList track by item.Grupo.Id" ng-change="$ctrl.loadProcesosByGrupo()"></select></div></div><div class="col-md-8"><label class="col-md-2 center-label">Procesos*:</label><div class="col-md-10"><select multiple="" name="" ng-model="$ctrl.procesoHijoCargado.ProcesosHijoSeleccionados" class="form-control" ng-options="item as item.Nombre for item in $ctrl.procesoHijoCargado.ProcesosHijosList track by item.Id" ng-change="$ctrl.onProcesoHijoSeleccionado($ctrl.procesoHijoCargado.ProcesosHijoSeleccionados, item)" ng-disabled="!$ctrl.enableDatosProcesoTab"></select></div></div></div><div ba-panel="" ba-panel-title="Procesos Hijos" ba-panel-class="with-scroll" ng-show="$ctrl.model.AceptaHijos" class="add-top-space"><div class="table-responsive"><table class="table"><thead><tr><th class="text-center">Nombre Proceso Hijo</th><th class="text-center">Permite Avanzar Etapa</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.procesoHijosSeleccionables"><td align="center">{{item.ProcesoHijo.Nombre}}</td><td align="center"><input type="checkbox" ng-model="item.permiteAvanzar" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td></tr></tbody></table></div></div></uib-tab><uib-tab index="7" heading="Etapas" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Configuraci\xF3n Ejecucion de Procedimientos" ba-panel-class="with-scroll"><div class="col-md-8"><label class="col-md-3 center-label">Procedimiento Avanzar Etapa:</label><div class="col-md-9"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.procedimientoSiguienteEtapa" placeholder="Ingrese procedimiento a ejecutar para avanzar etapa"></div></div><div class="col-md-8"><label class="col-md-3 center-label">Procedimiento Regresar Etapa:</label><div class="col-md-9"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.procedimientoRegresarEtapa" placeholder="Ingrese procedimiento a ejecutar para regresar etapa"></div></div></div><div ba-panel="" ba-panel-title="Personalizaci\xF3n de Nombres de Etapas" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.model.EtapasNombres"><thead><tr><th class="text-center">Nombre Etapa Original</th><th class="text-center">Nombre Etapa Proceso</th><th class="text-center">Ver Procesos Hijo</th><th class="text-center">Permite Forzar Cierre</th><th class="text-center">Requiere Autorizaci\xF3n Completa</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.model.EtapasNombres"><td align="center">{{item.SolicitudEstado.NombreEtapa}}</td><td align="center"><input type="text" spellcheck="true" class="form-control" ng-model="item.NombreEtapa" placeholder="Ingrese un nuevo nombre para la etapa..." ng-disabled="!$ctrl.enableDatosProcesoTab"></td><td align="center"><input type="checkbox" ng-model="item.procesoHijo" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td><td align="center"><input type="checkbox" ng-model="item.forzarCierre" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td><td align="center"><input type="checkbox" ng-model="item.reqAutorizacionMultiple" ng-disabled="!$ctrl.enableDatosProcesoTab" name="" style="height: 18px;width: 18px;vertical-align: middle;"></td></tr></tbody></table></div></div></uib-tab><uib-tab index="8" heading="Columnas de Listado" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Columnas a Mostrar en Listado" ba-panel-class="with-scroll"><label class="col-md-12 center-label">Campos Nativos del Proceso:</label><div class="table-responsive"><table class="table" st-table="$ctrl.columnasProcesoList"><thead><tr><th class="text-center">Seleccionado</th><th class="text-center">Columna del Proceso</th><th class="text-center">Orden</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.columnasProcesoList"><td align="center"><input type="checkbox" ng-model="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"></td><td align="center">{{item.Nombre}}</td><td align="center"><input type="text" spellcheck="true" ng-model="item.OrdenLista" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" style="text-align:right;" ng-show="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"><p ng-show="!item.SeleccionLista" style="font-size: inherit">{{item.OrdenLista}}</p></td></tr></tbody></table></div><br><label class="col-md-12 center-label">Campos del Proceso:</label> <button class="btn btn-warning" ng-click="$ctrl.updateFilters()" ng-disabled="$ctrl.isBusy">Update All Filters</button><div class="table-responsive"><table class="table" st-table="$ctrl.procesoCamposList"><thead><tr><th class="text-center">Seleccionado</th><th class="text-center">Columna del Proceso</th><th class="text-center">Orden</th></tr></thead><tbody><tr ng-repeat="item in $ctrl.procesoCamposList"><td align="center"><input type="checkbox" ng-model="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab" ng-change="$ctrl.isCampoListChequed(item)"></td><td align="center">{{item.Campo.Nombre}}</td><td align="center"><input type="text" spellcheck="true" ng-model="item.OrdenLista" onkeypress="return (event.charCode >= 48 && event.charCode <= 57)" style="text-align:right;" ng-show="item.SeleccionLista" ng-disabled="!$ctrl.enableDatosProcesoTab"><p ng-show="!item.SeleccionLista" style="font-size: inherit">{{item.OrdenLista}}</p></td></tr></tbody></table></div></div></uib-tab><uib-tab index="9" heading="Links Personalizados" ng-disabled="true" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><div ba-panel="" ba-panel-title="Datos del Link" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Nombre del Link*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoLinkCargado.NombreLink" name="" placeholder=""></div><label class="col-md-2 center-label">URL del Link*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoLinkCargado.UrlLink" name="" placeholder=""></div><label class="col-md-2 center-label">Link Nivel Solicitud*:</label><div><div class="col-md-2"><label ng-if="$ctrl.procesoLinkCargado.solicitudLevel">S\xED</label> <label ng-if="!$ctrl.procesoLinkCargado.solicitudLevel">No</label></div><div class="col-md-2"><ba-switcher switcher-style="primary" switcher-value="$ctrl.procesoLinkCargado.solicitudLevel"></ba-switcher></div></div><label class="col-md-2 center-label">Ejecuta Procedure?*:</label><div class="col-md-2"><ba-switcher switcher-style="primary" switcher-value="$ctrl.procesoLinkCargado.ejecutaProcedure"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearProcesoLink()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editProcesoLink()" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Links Cargados" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoLinksList"><thead><tr class="sortable"><th class="text-center" st-sort="NombreLink">Nombre Link</th><th class="text-center" st-sort="UrlLink">URL Link</th><th class="text-center" st-sort="solicitudLevel">Link Nivel Solicitud</th><th class="text-center">Acciones</th></tr></thead><tbody ng-show="!$ctrl.isProcesoLinkSearching"><tr ng-repeat="item in $ctrl.procesoLinksList" ng-click="$ctrl.cargarProcesoLink(item)" style="cursor: pointer"><td align="center">{{item.NombreLink}}</td><td align="center">{{item.UrlLink}}</td><td align="center">{{item.solicitudLevel}}</td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarProcesoLink(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarProcesoLink($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isProcesoLinkSearching"><tr><td colspan="2" class="text-center">Cargando...</td></tr></tbody></table></div></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button></div></div>');
$templateCache.put('app/pages/proceso/list.template.html','<div class="add-row-editable-table"><button class="btn btn-secondary" ng-show="$ctrl.mostrarAgregar" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-2 col-sm-2" st-sort="Codigo">C\xF3digo</th><th class="text-center col-xs-2 col-sm-2" st-sort="Nombre">Nombre</th><th class="text-center col-xs-2 col-sm-2" st-sort="Grupo.Nombre">Grupo</th><th class="text-center col-xs-1 col-sm-1" st-sort="RequiereValidacion">Requiere Validaci\xF3n</th><th class="text-center col-xs-1 col-sm-1" st-sort="RequiereVerificacion">Requiere Verificaci\xF3n</th><th class="text-center col-xs-1 col-sm-1" st-sort="RequiereAutorizacion">Requiere Autorizaci\xF3n</th><th class="text-center col-xs-2 col-sm-2" st-sort="CantidadDiasCierre">Cant. D\xEDas Cierre</th><th class="text-center col-xs-1 col-sm-1">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Grupo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por grupo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereValidacion" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por validaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereVerificacion" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por verificaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="RequiereAutorizacion" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por aprobaci\xF3n" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="CantidadDiasCierre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por cant. d\xEDas cierre" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-2 col-sm-2">{{item.Codigo}}</td><td align="center" class="col-xs-2 col-sm-2">{{item.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2">{{item.Grupo.Nombre}}</td><td align="center" class="col-xs-1 col-sm-1"><i class="fa fa-check" style="color:green" ng-show="item.RequiereValidacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereValidacion"></i></td><td align="center" class="col-xs-1 col-sm-1"><i class="fa fa-check" style="color:green" ng-show="item.RequiereVerificacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereVerificacion"></i></td><td align="center" class="col-xs-1 col-sm-1"><i class="fa fa-check" style="color:green" ng-show="item.RequiereAutorizacion"></i> <i class="fa fa-times" style="color:red" ng-hide="item.RequiereAutorizacion"></i></td><td align="center" class="col-xs-2 col-sm-2">{{item.CantidadDiasCierre}}</td><td align="center" class="col-xs-1 col-sm-1"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="8" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="8" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/solicitud/edit.template.html','<script>\r\n    $(document).ready(function () {\r\n        //Div que envuelve el tab\r\n        $(\'#divTab .panel-body\').first().css(\'padding\', \'0px\');\r\n\r\n\r\n        //Letra en negrita\r\n        $(\'#cabecera .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#camposProceso .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#procesosHijo .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#templates .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapas .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaActual .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaAnterior .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#etapaSiguiente .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#historial .panel-title\').css(\'font-weight\', \'bold\');\r\n        $(\'#copiaControlada .panel-title\').css(\'font-weight\', \'bold\');\r\n\r\n        //Color en cabecera\r\n        $(\'#titulo .panel\').css(\'background-color\', \'#dddddd\');\r\n\r\n        $(\'#cabecera .panel-heading\').css(\'background-color\', \'#1995ad\'); //#B3C100 //f58307\r\n        // $(\'#cabecera .panel-heading\').css(\'background-color\', \'#f99d3b\');\r\n        // $(\'#cabecera .panel-body\').css(\'background-color\', \'#f9f2ea\'); //ffdcb7\r\n\r\n        $(\'#camposProceso .panel-heading\').css(\'background-color\', \'#1995ad\');//#B3C100\r\n        // $(\'#camposProceso .panel-heading\').css(\'background-color\', \'#f99d3b\');\r\n        // $(\'#camposProceso .panel-body\').css(\'background-color\', \'#f9f2ea\');\r\n\r\n        $(\'#procesosHijo .panel-heading\').css(\'background-color\', \'#1995ad\'); //#B3C100 //f99d3b\r\n        // $(\'#procesosHijo .panel-body\').css(\'background-color\',\'#bcbcbc\'); //f9f2ea\r\n\r\n        $(\'#templates .panel-heading\').css(\'background-color\', \'#1995ad\'); //45ee61\r\n\r\n        $(\'#etapas .panel-heading\').css(\'background-color\', \'#1995ad\'); //60cbf2\r\n        $(\'#etapaActual .panel-heading\').css(\'background-color\', \'#1995ad\'); //#90b900\r\n        $(\'#etapaAnterior .panel-heading\').css(\'background-color\', \'#1995ad\'); //#90b900\r\n        $(\'#etapaSiguiente .panel-heading\').css(\'background-color\', \'#1995ad\'); //#90b900\r\n\r\n        $(\'#historial .panel-heading\').css(\'background-color\', \'#1995ad\'); //bcbcbc\r\n        $(\'#copiaControlada .panel-heading\').css(\'background-color\', \'#1995ad\'); //bcbcbc\r\n\r\n        // $(\'#camposProceso > div > div.panel-body\').css(\'background-color\', \'rgba(204, 216, 239, 0.4)\');\r\n\r\n    });\r\n</script><div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista" class="add-top-space"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando datos...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading data...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando dados...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></label></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="titulo" style="padding:0px" ng-mousemove="ctrl.testFn()"><div class="col-xs-12 col-sm-4" style="margin-top: 10px"><h4 class="title" style="display:inline">{{$ctrl.model.Proceso.Nombre}}</h4></div><div class="col-xs-12 col-sm-8" style="margin-top: 5px"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-admin-options pull-right" ng-click="$ctrl.crearVersion()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.IdSolicitudEtapa==6 && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin || $ctrl.lsuarioLogueadoIsSupervisorProceso || $ctrl.lDocIsUserAbleToCreateDocumentV2)" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-albums ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Crear Version</span> <span ng-if="$ctrl.language == \'ingles\'">Create Version</span> <span ng-if="$ctrl.language == \'portugues\'">Criar Vers\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-admin-options pull-right" ng-click="$ctrl.enviarObsoleto()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.model.Proceso.permiteEnviarObsoleto && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.IdSolicitudEtapa==6 && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin || $ctrl.userTieneMarcaObsoleto)" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-social-buffer ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Enviar a Obsoleto</span> <span ng-if="$ctrl.language == \'ingles\'">Send to Obsolete</span> <span ng-if="$ctrl.language == \'portugues\'">Enviar para Obsoleto</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-admin-options pull-right" ng-click="$ctrl.crearCopia()" ng-disabled="$ctrl.isBusy" ng-show="($ctrl.model.Proceso.permiteCopia && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin ))" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-copy-outline ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Crear Copia</span> <span ng-if="$ctrl.language == \'ingles\'">Create Copy</span> <span ng-if="$ctrl.language == \'portugues\'">Criar C\xF3pia</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-atras pull-right" ng-click="$ctrl.goListado()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.anularVista" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-ios-list-outline ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Ir al listado</span> <span ng-if="$ctrl.language == \'ingles\'">Go to list</span> <span ng-if="$ctrl.language == \'portugues\'">Ir para a Lista</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-atras pull-right" ng-click="$ctrl.goBack()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.anularVista" style="margin-bottom: 2px;margin-left:5px;padding-top: 2px;padding-bottom: 2px;"><span class="ion-arrow-left-c ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Ir Atr\xE1s</span> <span ng-if="$ctrl.language == \'ingles\'">Go back</span> <span ng-if="$ctrl.language == \'portugues\'">Voltar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button></div></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.model.Proceso.Links != null && $ctrl.model.Proceso.Links.length > 0"><div class="col-xs-12 col-md-7"><h4 class="title" style="display:inline" ng-if="$ctrl.language == \'espa\xF1ol\'">Links</h4><h4 class="title" style="display:inline" ng-if="$ctrl.language == \'ingles\'">Links</h4><h4 class="title" style="display:inline" ng-if="$ctrl.language == \'portugues\'">Links</h4><h4 class="title" style="display:inline" ng-if="$ctrl.language == \'italiano\'">Italiano</h4></div><div class="col-xs-12 col-md-10" style="float:right"><div ng-repeat="item in $ctrl.model.Proceso.Links track by $index"><button class="btn btn-descargarPdf" ng-if="!item.ejecutaProcedure && item.solicitudLevel" ng-click="$ctrl.openUrlLink(item.UrlLink)" style="margin-right: 5px; float:right">{{item.NombreLink}}</button> <button class="btn btn-descargarPdf" ng-if="item.ejecutaProcedure && item.solicitudLevel" ng-click="$ctrl.executeProcedure(item)" style="margin-right: 5px; float:right">{{item.NombreLink}}</button></div></div></div><div ba-panel="" id="divTab"><div class="container stepcontainer" id="steeper"><div class="table-responsive"><table class="table tableStep"><tbody><tr><td align="center" class="removePaddingCell" ng-repeat="step in $ctrl.objSteps" style="padding-top: 5px; padding-bottom: 5px;"><div class="stepBlock"><div ng-class="step.ngclass" style="margin-bottom: 0px;margin-right: 0px;"><div style="height: 100%;margin: auto;margin-top: 10px;display: block;font-size: 20px;text-decoration: none;text-shadow: 0px -1px 1px #bdb5b4, 1px 1px 1px white;" class="ng-binding">{{step.Imgtext}}</div></div><div class="cssForMdDividerLabel"></div></div></td></tr><tr><td align="center" ng-repeat="step in $ctrl.objSteps" style="text-align: left;"><div class="stepBlock"><label class="stepsTextLabel">{{step.label}}</label><div class="cssForMdDividerLabel"></div></div></td></tr></tbody></table></div></div><uib-tabset active="$ctrl.active" ng-show="!$ctrl.anularVista" ng-class="{\'blocked\': $ctrl.isBusyBlocked}"><uib-tab index="0" ng-disabled="true"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Gestiones</span> <span ng-if="$ctrl.language == \'ingles\'">Managements</span> <span ng-if="$ctrl.language == \'portugues\'">Gest\xF5es</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Encabezado\' : (($ctrl.language == \'ingles\') ? \'Header\' : (($ctrl.language == \'portugues\') ? \'Cabe\xE7alho\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="cabecera"><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'ingles\'">Number:</b> <b ng-if="$ctrl.language == \'portugues\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.NumeroCompleto}}</label><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha de Alta:</b> <b ng-if="$ctrl.language == \'ingles\'">Registration Date:</b> <b ng-if="$ctrl.language == \'portugues\'">Data de Cadastro:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.CreationDate|date:\'dd-MM-yyyy\'}}</label> <label class="col-xs-12 col-md-6 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</b> <b ng-if="$ctrl.language == \'ingles\'">Requesting User:</b> <b ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.UsuarioCreacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa atual:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.SolicitudEtapaNombre}}</label> <label class="col-xs-12 col-md-4 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage User:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa atual do usu\xE1rio:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.UsuarioAprobador.NombreMostrar}}</label><label ng-if="!$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Descripci\xF3n Resumida:</b> <b ng-if="$ctrl.language == \'ingles\'">Summary Description:</b> <b ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.DescripcionResumida}}</label> <label ng-if="$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Descripci\xF3n Resumida:</b> <b ng-if="$ctrl.language == \'ingles\'">Summary Description:</b> <b ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> <input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.DescripcionResumida" name=""></label></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Proceso Padre\' : (($ctrl.language == \'ingles\') ? \'Parent Process\' : (($ctrl.language == \'portugues\') ? \'Processo de Origem\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.SolicitudPadreId > 0"><div class="table-responsive"><table class="table" st-table="$ctrl.solicitudesPadreList" ng-show="$ctrl.model.SolicitudPadreId > 0"><thead><tr><th class="text-center" ng-repeat="col in $ctrl.model.SolicitudPadre.Proceso.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></th></tr></thead><tbody ng-show="!$ctrl.isSolicitudSearching"><tr ng-repeat="fila in $ctrl.solicitudesPadreList" ng-click="$ctrl.verSolicitudPadre(fila)" style="cursor: pointer"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left"><div ng-switch="" on="$ctrl.model.SolicitudPadre.Proceso.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="left">{{colValor}}</div><div ng-switch-when="DECIMAL" align="left">{{colValor}}</div><div ng-switch-when="JERARQ" align="left">{{colValor}}</div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a href="{{colValor}}" class="text-links" target="_blank">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="$ctrl.model.SolicitudPadre.Proceso.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><div class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.verSolicitudPadre(fila)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></div><a href="{{fila.UrlLink}}" target="_blank" class="text-links" ng-show="!$ctrl.isBusy">{{fila.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.isSolicitudPadreSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Gestiones\' : (($ctrl.language == \'ingles\') ? \'Managements\' : (($ctrl.language == \'portugues\') ? \'Gest\xF5es\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="templates"><form editable-form="" name="formTemplates" novalidate=""><div class="col-md-4" ng-show="$ctrl.templatePendientesIsSearching"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div class="col-sm-12 col-md-12 form-group add-top-space" style="min-height: 25px;"><label class="col-xs-12 col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Gestiones por Cargar:</span> <span ng-if="$ctrl.language == \'ingles\'">Managements to Load:</span> <span ng-if="$ctrl.language == \'portugues\'">Gest\xF5es a Carregar:</span> <span ng-if="$ctrl.language == \'italiano\'">italiano:</span></label><div class="col-xs-12 col-md-4" ng-show="!$ctrl.templatePendientesIsSearching"><select ng-model="$ctrl.procesoTemplateSeleccionado" class="form-control" ng-options="item as item.Template.Nombre for item in $ctrl.templatesPendientesList track by item.Id"></select></div><div class="col-xs-12 col-md-4"><button class="col-xs-12 col-md-3 btn btn-primary" ng-disabled="$ctrl.isBusy" ng-click="$ctrl.cargarTemplate()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargar</span> <span ng-if="$ctrl.language == \'ingles\'">Load</span> <span ng-if="$ctrl.language == \'portugues\'">Carregar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div></div><div class="col-xs-12 col-md-12 col-sm-12" style="position: inherit;"><button class="col-sm-12 col-md-3 col-xs-12 btn btn-primary" ng-click="$ctrl.cargarAccesoDirectoTemplate(item)" ng-disabled="(($ctrl.isBusy || $ctrl.model.Estado.Codigo == \'APRO\' || $ctrl.model.Estado.Codigo == \'CERR\') && !$ctrl.lProcesoIsDocumental)" ng-repeat="item in $ctrl.templatesPendientesAccesoDirectoList track by $index" style="margin-bottom: 12px; margin-right: 10px; padding-bottom:4px;">{{item.Template.Nombre}}</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscarTemplatesCargados" st-table="$ctrl.templatesCargadosList" style="margin-top:10px"><thead><tr class="sortable center-label row"><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">T\xEDtulo</b> <b ng-if="$ctrl.language == \'ingles\'">Title</b> <b ng-if="$ctrl.language == \'portugues\'">T\xEDtulo</b> <b ng-if="$ctrl.language == \'italiano\'">T\xEDtulo</b></th><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Gesti\xF3n</b> <b ng-if="$ctrl.language == \'ingles\'">Management Name</b> <b ng-if="$ctrl.language == \'portugues\'">Nome da Gest\xE3o</b> <b ng-if="$ctrl.language == \'italiano\'">Nombre Gesti\xF3n</b></th><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Etapa</b> <b ng-if="$ctrl.language == \'ingles\'">Stage Name</b> <b ng-if="$ctrl.language == \'portugues\'">Nome do Etapa</b> <b ng-if="$ctrl.language == \'italiano\'">Nombre Etapa</b></th><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha \xDAlt. Modif.</b> <b ng-if="$ctrl.language == \'ingles\'">Last Modification Date</b> <b ng-if="$ctrl.language == \'portugues\'">Data da \xDAlt. Modifica\xE7\xE3o</b> <b ng-if="$ctrl.language == \'italiano\'">Fecha \xDAlt. Modif.</b></th><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario \xDAlt. Modif.</b> <b ng-if="$ctrl.language == \'ingles\'">Last Modified User</b> <b ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio da \xDAlt. Modifica\xE7\xE3o</b> <b ng-if="$ctrl.language == \'italiano\'">Usuario \xDAlt. Modif.</b></th><th class="text-center"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</b> <b ng-if="$ctrl.language == \'ingles\'">Data</b> <b ng-if="$ctrl.language == \'portugues\'">Dados</b> <b ng-if="$ctrl.language == \'italiano\'">Datos</b></th></tr><tr class="center-label row"><th class="col-sm-4 col-md-4"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Resumen" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por t\xEDtulo\' : (($ctrl.language == \'ingles\') ? \'Search by title\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por t\xEDtulo\' : \'Buscar por t\xEDtulo\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Template.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por gesti\xF3n\' : (($ctrl.language == \'ingles\') ? \'Search by management\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por gest\xE3o\' : \'Buscar por gesti\xF3n\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="SolicitudEtapaNombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por etapa\' : (($ctrl.language == \'ingles\') ? \'Search by stage\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por Etapa\' : \'Buscar por etapa\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-sm-1 col-md-1"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="LastUpdate" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por \xFAlt. modif.\' : (($ctrl.language == \'ingles\') ? \'Search by last modification\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por \xFAlt. Modifica\xE7\xE3o\' : \'Buscar por \xFAlt. modif.\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-sm-2 col-md-2"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="UsuarioModificacion.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por usuario\' : (($ctrl.language == \'ingles\') ? \'Search by user\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'Buscar por usuario\')) }}" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.templateCargadosIsSearching"><tr ng-repeat="item in $ctrl.templatesCargadosList" ng-click="$ctrl.openTemplate(item)" style="cursor: pointer" class="row"><td align="left" style="text-align:left" ng-if="item.Resumen.length &gt; 50" class="col-sm-4 col-md-4">{{item.Resumen | limitTo : 50 : 0}} ...</td><td align="left" style="text-align:left" ng-if="item.Resumen == null || item.Resumen.length &lt;= 50" class="col-sm-4 col-md-4">{{item.Resumen}}</td><td align="left" ng-if="item.ProcesoTemplate.Template.Nombre.length &gt; 30">{{item.ProcesoTemplate.Template.Nombre | limitTo : 30 : 0}} ...</td><td align="left" ng-if="item.ProcesoTemplate.Template.Nombre.length &lt;= 30">{{item.ProcesoTemplate.Template.Nombre}}</td><td align="left">{{item.SolicitudEtapaNombre}}</td><td align="left" class="col-sm-1 col-md-1">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="left" ng-if="(item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre).length &gt; 20">{{item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre | limitTo : 20 : 0}} ...</td><td align="left" ng-if="(item.UsuarioModificacion.Apellido + \' \' + item.UsuarioModificacion.Nombre).length &lt;= 20">{{item.UsuarioModificacion.Apellido}} {{item.UsuarioModificacion.Nombre}}</td><td align="center" class="col-sm-2 col-md-2"><a href="" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></a> <a href="{{item.ProcesoTemplate.Template.UrlLink}}" class="text-links" target="_blank">{{item.ProcesoTemplate.Template.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.templateCargadosIsSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody></table></div></form><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-verDocumento pull-right" ng-click="$ctrl.verDocumento(\'descarga de documento Kahuna - APP\')" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.lProcesoIsDocumental && $ctrl.lProcesoIsDocumentalAutorizacionesV2" style="margin-bottom: 2px;margin-left: 1px;padding-top: 2px;padding-bottom: 2px;margin-top: 20px;margin-right: 30px;"><span class="ion-ios-albums ion-2x" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver Documento</span> <span ng-if="$ctrl.language == \'ingles\'">View Document</span> <span ng-if="$ctrl.language == \'portugues\'">Exibir documento</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Crear Copia controlada\' : (($ctrl.language == \'ingles\') ? \'Create Controlled Copy\' : (($ctrl.language == \'portugues\') ? \'Criar C\xF3pia Controlada\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space" id="copiaControlada" ng-show="$ctrl.lProcesoIsDocumental && $ctrl.IdSolicitudEtapa==6 && $ctrl.lProcesoIsDocumentalAutorizacionesV2"><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Destinada a *:</span> <span ng-if="$ctrl.language == \'ingles\'">Destined for *:</span> <span ng-if="$ctrl.language == \'portugues\'">Destinado a *:</span> <span ng-if="$ctrl.language == \'italiano\'">Destinada a *:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.copiaDestinadaA" name="" required=""></div><div class="col-md-12"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.imprimirCopiaControlada($ctrl.copiaDestinadaA)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Crear Copia controlada</span> <span ng-if="$ctrl.language == \'ingles\'">Create controlled copy</span> <span ng-if="$ctrl.language == \'portugues\'">Criar C\xF3pia Controlada</span> <span ng-if="$ctrl.language == \'italiano\'">Crear Copia controlada</span></button></div></div><uib-tabset active="$ctrl.active2"><uib-tab index="66" ng-show="($ctrl.model.EstadoId==1 && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista) || (!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista)"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Etapas</span> <span ng-if="$ctrl.language == \'ingles\'">Stages</span> <span ng-if="$ctrl.language == \'portugues\'">Etapas</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></uib-tab-heading><div ng-if="!$ctrl.procesomcaOcultaAvanzarEtapa"><div ba-panel="" ba-panel-title="" ba-panel-class="with-scroll" style="padding: 0;" ng-show="($ctrl.model.EstadoId==1 && $ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista) || (!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.mostrarAprobacion && !$ctrl.anularVista)" id="etapas"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Etapa Actual:\' : (($ctrl.language == \'ingles\') ? \'Current Stage:\' : (($ctrl.language == \'portugues\') ? \'Etapa atual:\' : \'italiano:\')) }} {{$ctrl.model.SolicitudEtapaNombre}}" ba-panel-class="with-scroll" ng-show="$ctrl.mostrarControlesAprobacion($ctrl.model.Estado.Codigo)" id="etapaActual" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">\xBFEtapa concluida?</span> <span ng-if="$ctrl.language == \'ingles\'">Is stage complete?</span> <span ng-if="$ctrl.language == \'portugues\'">Etapa Concluida?</span> <span ng-if="$ctrl.language == \'italiano\'">\xBFEtapa concluida?</span></label><div class="col-md-2" style="margin-top:-10px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.aceptadoEtapa" switcher-language="$ctrl.language"></ba-switcher></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha de Cierre de Etapa:</span> <span ng-if="$ctrl.language == \'ingles\'">Stage Closing Date:</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Encerramento da Etapa:</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha de Cierre de Etapa:</span></label><div class="col-md-6"><label class="col-md-6 center-label" style="font-weight:normal">{{$ctrl.fechaEtapa|date:\'dd-MM-yyyy\'}}</label></div><label class="col-md-12 center-label" ng-show="$ctrl.model.Proceso.justificacionEsRequerida"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Justificaci\xF3n*:</span> <span ng-if="$ctrl.language == \'ingles\'">Justification*:</span> <span ng-if="$ctrl.language == \'portugues\'">Justificativa*:</span> <span ng-if="$ctrl.language == \'italiano\'">Justificaci\xF3n*:</span></label> <label class="col-md-12 center-label" ng-show="!$ctrl.model.Proceso.justificacionEsRequerida"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Justificaci\xF3n:</span> <span ng-if="$ctrl.language == \'ingles\'">Justification:</span> <span ng-if="$ctrl.language == \'portugues\'">Justificativa:</span> <span ng-if="$ctrl.language == \'italiano\'">Justificaci\xF3n:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.justificacionEtapa" name=""></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Etapa Anterior:\' : (($ctrl.language == \'ingles\') ? \'Previous Stage:\' : (($ctrl.language == \'portugues\') ? \'Etapa anterior:\' : \'italiano:\')) }} {{$ctrl.anteriorEstadoSolicitud.NombreEtapa}}" ba-panel-class="with-scroll" ng-show="!$ctrl.aceptadoEtapa && $ctrl.anteriorEstadoSolicitud != null" class="add-top-space" id="etapaAnterior"><div class="col-md-12" ng-show="$ctrl.isDatosAnteriorEstadoLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div class="col-md-12" ng-show="!$ctrl.isDatosAnteriorEstadoLoading"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Derivar A:</span> <span ng-if="$ctrl.language == \'ingles\'">Assign To:</span> <span ng-if="$ctrl.language == \'portugues\'">Encaminhar Para:</span> <span ng-if="$ctrl.language == \'italiano\'">Derivar A:</span></label><div class="col-md-3"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.findUsuarioAnterior" name="" ng-change="$ctrl.onChangeInputUsuarioAnterior($ctrl.model.findUsuarioAnterior)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por Usuario\' : (($ctrl.language == \'ingles\') ? \'Search by User\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'italiano\')) }}"></div><div class="col-md-5"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaAnterior" ng-options="item as item.NombreMostrar for item in $ctrl.anteriorEstadoUsuariosList track by item.Id"></select></div><div class="col-md-2"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.retrocederEtapa()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeRetrocederEstado($ctrl.model)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Regresar Etapa</span> <span ng-if="$ctrl.language == \'ingles\'">Revert Stage</span> <span ng-if="$ctrl.language == \'portugues\'">Retornar Etapa</span> <span ng-if="$ctrl.language == \'italiano\'">Regresar Etapa</span></button></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Etapa Siguiente:\' : (($ctrl.language == \'ingles\') ? \'Next Stage:\' : (($ctrl.language == \'portugues\') ? \'Pr\xF3xima Etapa:\' : \'italiano:\')) }} {{$ctrl.siguienteEstadoSolicitud.NombreEtapa}}" ba-panel-class="with-scroll" ng-show="$ctrl.aceptadoEtapa && $ctrl.siguienteEstadoSolicitud != null" class="add-top-space" id="etapaSiguiente"><div class="col-md-12" ng-show="$ctrl.isDatosSiguienteEstadoLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando..</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div ng-show="!$ctrl.isDatosSiguienteEstadoLoading"><label class="col-md-2 center-label" ng-show="$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Derivar A:</span> <span ng-if="$ctrl.language == \'ingles\'">Assign To:</span> <span ng-if="$ctrl.language == \'portugues\'">Encaminhar Para:</span> <span ng-if="$ctrl.language == \'italiano\'">Derivar A:</span></label><div class="col-md-3" ng-show="$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.findUsuarioSiguiente" name="" ng-change="$ctrl.onChangeInputUsuarioSiguiente($ctrl.model.findUsuarioSiguiente)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por Usuario\' : (($ctrl.language == \'ingles\') ? \'Search by User\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'italiano\')) }}"></div><div class="col-md-5" ng-show="$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)" style="min-height: 55px;"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaSiguiente" ng-options="item as item.NombreMostrar for item in $ctrl.siguienteEstadoUsuariosList track by item.Id"></select></div><div class="col-md-2" ng-show="$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.avanzarEtapa()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeAvanzarEstado($ctrl.model)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Avanzar Etapa</span> <span ng-if="$ctrl.language == \'ingles\'">Advance Stage</span> <span ng-if="$ctrl.language == \'portugues\'">Avan\xE7ar Etapa</span> <span ng-if="$ctrl.language == \'italiano\'">Avanzar Etapa</span></button></div><div class="col-md-2" ng-show="!$ctrl.mostrarComboSiguienteEstado($ctrl.siguienteEstadoSolicitud.Codigo)"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.avanzarEtapa()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeAvanzarEstado($ctrl.model)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cerrar Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Close Process</span> <span ng-if="$ctrl.language == \'portugues\'">Fechar Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Cerrar Proceso</span></button></div></div></div></div></div></uib-tab><uib-tab index="88" ng-disabled="true" ng-show="($ctrl.model.Id!=0 && $ctrl.model.Proceso.PermiteDerivarRes==1) && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.model.UsuarioAprobadorId == $ctrl.lUsuarioLogeado.Id) && ($ctrl.model.EstadoId!=6) && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Derivar Responsabilidad</span> <span ng-if="$ctrl.language == \'ingles\'">Assign Responsibility</span> <span ng-if="$ctrl.language == \'portugues\'">Transferir Responsabilidade</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Derivar Responsabilidad\' : (($ctrl.language == \'ingles\') ? \'Assign Responsibility\' : (($ctrl.language == \'portugues\') ? \'Transferir Responsabilidade\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="(!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.model.Id!=0 && $ctrl.model.Proceso.PermiteDerivarRes==1) && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.model.UsuarioAprobadorId == $ctrl.lUsuarioLogeado.Id)"><div class="col-md-12" ng-show="$ctrl.isDatosSiguienteEstadoLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div ng-show="!$ctrl.isDatosSiguienteEstadoLoading"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Derivar A:</span> <span ng-if="$ctrl.language == \'ingles\'">Assign To:</span> <span ng-if="$ctrl.language == \'portugues\'">Encaminhar Para:</span> <span ng-if="$ctrl.language == \'italiano\'">Derivar A:</span></label><div class="col-md-3"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.listaUsuariosDerivarResponsabilidad" name="" ng-change="$ctrl.onChangeInputUsuarioSiguienteDerivar($ctrl.model.listaUsuariosDerivarResponsabilidad)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por Usuario\' : (($ctrl.language == \'ingles\') ? \'Search by User\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'italiano\')) }}"></div><div class="col-md-5"><select name="" class="form-control" ng-model="$ctrl.usuarioEtapaSiguienteDerivar" ng-options="item as item.NombreMostrar for item in $ctrl.listaUsuariosDerivarResponsabilidad track by item.Id"></select></div><div class="col-md-2"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.derivarEtapa()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Derivar</span> <span ng-if="$ctrl.language == \'ingles\'">Assign</span> <span ng-if="$ctrl.language == \'portugues\'">Encaminhar</span> <span ng-if="$ctrl.language == \'italiano\'">Derivar</span></button></div></div></div></uib-tab><uib-tab index="99" ng-disabled="true" ng-show="$ctrl.showForzarCierre && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Forzar Cierre</span> <span ng-if="$ctrl.language == \'ingles\'">Force Close</span> <span ng-if="$ctrl.language == \'portugues\'">For\xE7ar Fechamento</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Forzar cierre de proceso\' : (($ctrl.language == \'ingles\') ? \'Force process closure\' : (($ctrl.language == \'portugues\') ? \'For\xE7ar fechamento de processo\' : \'italiano\')) }}" ba-panel-class="with-scroll" id="etapaActual" class="add-top-space" ng-show="$ctrl.showForzarCierre && !$ctrl.lProcesoIsDocumentalAutorizacionesV2"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha de Cierre</span> <span ng-if="$ctrl.language == \'ingles\'">Closure Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Fechamento</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha de Cierre</span></label><div class="col-md-6"><label class="col-md-6 center-label" style="font-weight:normal">{{$ctrl.fechaEtapaForzarCierre|date:\'dd-MM-yyyy\'}}</label></div><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Justificaci\xF3n*:</span> <span ng-if="$ctrl.language == \'ingles\'">Justification*:</span> <span ng-if="$ctrl.language == \'portugues\'">Justificativa*:</span> <span ng-if="$ctrl.language == \'italiano\'">Justificaci\xF3n*:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.justificacionEtapaForzarCierre" name="" required=""></div><div class="col-md-12"><button class="btn btn-admin-options pull-right" ng-click="$ctrl.forzarCierre()" ng-disabled="$ctrl.justificacionEtapaForzarCierre.length === 0 || $ctrl.justificacionEtapaForzarCierre==undefined"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Forzar Cierre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Force Process Closure</span> <span ng-if="$ctrl.language == \'portugues\'">For\xE7ar Fechamento de Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Forzar Cierre Proceso</span></button></div></div></uib-tab><uib-tab index="77" ng-disabled="true" ng-show="($ctrl.model.Id!=0 && $ctrl.model.Proceso.autorizaciones==1 && $ctrl.usuarioPuedeAutorizar && !$ctrl.usuarioYaAutorizo) && ($ctrl.model.EstadoId>=2 && $ctrl.model.EstadoId!=6)"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizar el Documento</span> <span ng-if="$ctrl.language == \'ingles\'">Authorize the Document</span> <span ng-if="$ctrl.language == \'portugues\'">Autorizar o Documento</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizar el Documento</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Autorizar o Rechazar\' : (($ctrl.language == \'ingles\') ? \'Authorize or Reject\' : (($ctrl.language == \'portugues\') ? \'Autorizar ou Rejeitar\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="$ctrl.usuarioPuedeAutorizar"><div class="col-md-12"><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios*:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments*:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios*:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios*:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-danger pull-right col-md-2" ng-click="$ctrl.RechazarAction()" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;" ng-show="$ctrl.lProcesoIsDocumentalAutorizacionesV2"><span class="glyphicon glyphicon-remove" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Rechazar</span> <span ng-if="$ctrl.language == \'ingles\'">Reject</span> <span ng-if="$ctrl.language == \'portugues\'">Rejeitar</span> <span ng-if="$ctrl.language == \'italiano\'">Rechazar</span></button> <button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarAction()" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizar</span> <span ng-if="$ctrl.language == \'ingles\'">Authorize</span> <span ng-if="$ctrl.language == \'portugues\'">Autorizar</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizar</span></button></div></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Autorizar el Documento\' : (($ctrl.language == \'ingles\') ? \'Authorize the Document\' : (($ctrl.language == \'portugues\') ? \'Autorizar o Documento\' : \'Autorizar el Documento\')) }}" ba-panel-class="with-scroll" class="add-top-space" id="etapaSiguiente" ng-show="!$ctrl.lProcesoIsDocumentalAutorizacionesV2"><div ba-panel="" ba-panel-class="with-scroll" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Grupo 1\' : (($ctrl.language == \'ingles\') ? \'Group 1\' : (($ctrl.language == \'portugues\') ? \'Grupo 1\' : \'Grupo 1\')) }} - {{$ctrl.grupoUsuariosObj.grupo1Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo1Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span> {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios:</span> {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Autorizaci\xF3n:</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization Date:</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Autoriza\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Autorizacion:</span> {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo1Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">No se encontraron Autorizaciones</span> <span ng-if="$ctrl.language == \'ingles\'">No Authorizations found</span> <span ng-if="$ctrl.language == \'portugues\'">Nenhuma Autoriza\xE7\xE3o Encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">No se encontraron Autorizaciones</span></label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Grupo 2\' : (($ctrl.language == \'ingles\') ? \'Group 2\' : (($ctrl.language == \'portugues\') ? \'Grupo 2\' : \'Grupo 2\')) }} - {{$ctrl.grupoUsuariosObj.grupo2Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo2Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span> {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios:</span> {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Autorizaci\xF3n:</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization Date:</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Autoriza\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Autorizacion:</span> {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo2Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">No se encontraron Autorizaciones</span> <span ng-if="$ctrl.language == \'ingles\'">Data de Autoriza\xE7\xE3o</span> <span ng-if="$ctrl.language == \'portugues\'">Nenhuma Autoriza\xE7\xE3o Encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">No se encontraron Autorizaciones</span></label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Grupo 3\' : (($ctrl.language == \'ingles\') ? \'Group 3\' : (($ctrl.language == \'portugues\') ? \'Grupo 3\' : \'Grupo 3\')) }} - {{ $ctrl.grupoUsuariosObj.grupo3Obj.Nombre}}" ng-show="$ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion.length>0"><div ng-repeat="Usuario in $ctrl.grupoUsuariosObj.grupo3Obj.gruposUsuariosRelacion" style="margin-bottom: 5px;"><div ng-show="Usuario.hasAutorized" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="45" width="45" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span> {{ Usuario.Usuario.Id }} - {{ Usuario.Usuario.Nombre }}</label> <img src="/images/check2.png" height="45" width="45" style="float: right;margin: 5px;"></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios:</span> {{ Usuario.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Autorizaci\xF3n:</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization Date:</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Autoriza\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Autorizacion:</span> {{ Usuario.FechaAutorizacion}}</label></div></div></div><div style="margin-bottom: 5px;" ng-show="!$ctrl.grupoUsuariosObj.grupo3Obj.GrupoIsAutorizated==true"><div class="mdc-card cardAutorizaciones"><div class="demo-card__title"><label style="padding: 5px;margin-left: 10px;margin: auto;text-align: center;width: 80%;margin-top: 15px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">No se encontraron Autorizaciones</span> <span ng-if="$ctrl.language == \'ingles\'">No Authorizations found</span> <span ng-if="$ctrl.language == \'portugues\'">Nenhuma Autoriza\xE7\xE3o Encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">No se encontraron Autorizaciones</span></label> <img src="/images/cancel1.png" height="45" width="45"></div></div></div></div></div></uib-tab></uib-tabset><div listado-usuarios-autorizacion=""></div><div listado-historial-autorizacion=""></div></uib-tab><uib-tab index="1" ng-disabled="true" ng-click="$ctrl.runModal()" ng-hide="($ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.hideDatosDelProceso)"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos del Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Datos del Proceso</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos\' : (($ctrl.language == \'ingles\') ? \'Data\' : (($ctrl.language == \'portugues\') ? \'Dados\' : \'Datos\')) }}" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="camposProceso"><div class="header-icons"><i class="autosave-icon fa fa-clock-o" ng-show="$ctrl.model.Proceso.temporizadorGuardar > 0" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Esta solicitud tiene autoguardado\' : (($ctrl.language == \'ingles\') ? \'This request has autosave\' : (($ctrl.language == \'portugues\') ? \'Esta solicita\xE7\xE3o tem salvamento autom\xE1tico\' : \'Guardar y ejecutar procedimiento\')) }}"></i> <i class="executeSP-icon glyphicon glyphicon-refresh" ng-show="$ctrl.procesoPadre.tieneProcedimientoRefresh" ng-click="$ctrl.saveCamposAndExecSP()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Guardar y ejecutar procedimiento\' : (($ctrl.language == \'ingles\') ? \'Save and execute procedure\' : (($ctrl.language == \'portugues\') ? \'Salvar e executar procedimento\' : \'Guardar y ejecutar procedimiento\')) }}"></i></div><div class="col-md-12" ng-show="$ctrl.isCamposLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList track by $index" style="margin-bottom: 2px;"><div class="add-top-space col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\' && item.Campo.CampoTipo.Codigo != \'LINK\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}:</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXT\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-disabled="{{item.Campo.isReadOnly == true}}" required="" title=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" switcher-language="$ctrl.language" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-secondary pull-right" style="margin-top: 15px;" ng-click="$ctrl.openAttachment(item.ValorObjeto)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" cols="40" rows="5" ng-disabled="{{item.Campo.isReadOnly == true}}" title="">\r\n                            </textarea></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Id==0"><input type="number" ng-init="item.ValorObjeto = 1" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" ng-change="$ctrl.validateNotOnlyZero(item)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Id!=0"><input type="number" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" ng-change="$ctrl.validateNotOnlyZero(item)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly="" style="color: #676565;"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly="" style="color: #666666;"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><div trumbowyg-editor="" ng-model="item.ValorObjeto" id="{{item.Campo.Id}}" name="{{item.Campo.Id}}" style="resize: vertical;"></div></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'INT\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" maxlength="22" style="text-align:right;" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)" title=""></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DECIMAL\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" ng-keydown="$ctrl.evaluatenumberDecimal($event)" maxlength="20" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)" title=""></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" min="1900-01-01" max="2100-12-31" style="min-height: 35px;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'BOOL\'"><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" switcher-language="$ctrl.language"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LIST\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id" ng-change="$ctrl.activarCampoValorDefault(item)"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'"><div class="col-md-6" style="margin-bottom: 10px; margin-left: 2px;"><input type="text" spellcheck="true" class="form-control" ng-model="item.TextoBusqueda" ng-change="$ctrl.onChangeInputCampostList(item.TextoBusqueda, item, item.SourceObjeto[0].JerarquiaPadreId)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar\' : (($ctrl.language == \'ingles\') ? \'Search\' : (($ctrl.language == \'portugues\') ? \'Pesquisar\' : \'Buscar\')) }}"></div><ul class="list-group col-md-6"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Para Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">To Select</span> <span ng-if="$ctrl.language == \'portugues\'">Para Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Para Seleccionar</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.SourceObjeto track by $index" ng-click="$ctrl.actionAddOnClick(j, item);" class="list-group-item list-group-item-action" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{j.Nombre}}</a></li></div></ul><ul class="list-group col-md-6"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionado</span> <span ng-if="$ctrl.language == \'ingles\'">Selected</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionado</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionado</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by $index" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClick(j, item);" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{j.Nombre}}</a></li></div></ul></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==true"><div ng-repeat="j in item.ValorObjeto"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-readonly="(!$ctrl.model.Id==0) || (item.Solicitud.Proceso.isDocumental && item.Solicitud.Proceso.autorizacionesDocumental && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id)" ng-disabled="{{item.Campo.isReadOnly == true}}" style="color: #666666;"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==false"><div ng-repeat="j in item.ValorObjeto"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-disabled="{{item.Campo.isReadOnly == true}}"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NOTIF\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required="" title=""> <label class="center-label" style="margin-top:5px"><h6 ng-if="$ctrl.language == \'espa\xF1ol\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6><h6 ng-if="$ctrl.language == \'ingles\'"><u>NOTE</u>: To enter multiple email addresses, separate each with a semicolon (;).</h6><h6 ng-if="$ctrl.language == \'portugues\'"><u>NOTA</u>: para inserir m\xFAltiplos endere\xE7os de e-mail, separe cada um com ponto e v\xEDrgula (;)</h6><h6 ng-if="$ctrl.language == \'italiano\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'USER\'"><div class="col-md-3"><input type="text" spellcheck="true" class="form-control" style="width: 195px;" ng-model="$ctrl.usuarioCargado" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a agregar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to add...\' : (($ctrl.language == \'portugues\') ? \'Insira um usu\xE1rio para adicionar...\' : \'Ingrese un usuario a agregar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" typeahead-on-select="$ctrl.onSelectUsuarioMultiList($index, $model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario no encontrado</span></div></div><div class="col-md-9" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" class="text-links" ng-click="$ctrl.onSelectUsuarioMultiList($index, $ctrl.model.UsuarioCreacion)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</span> <span ng-if="$ctrl.language == \'ingles\'">Requesting User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario Solicitante:</span> {{$ctrl.model.UsuarioCreacion.Nombre}} {{$ctrl.model.UsuarioCreacion.Apellido}}</a></div><div class="table-responsive"><table class="table" style="margin-bottom: 20px;" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="u in item.ValorObjeto"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoUsuario($parent.$index, u.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" ng-init="$ctrl.initListadoProcesos()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione el proceso:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the process:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione o processo:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione el proceso:</span></label><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoSeleccionado" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'Ingrese el proceso a configurar...\')) }}" ng-change="$ctrl.onChangeSelectProcesoSeleccionado($ctrl.procesoSeleccionado)" uib-typeahead="item as item.Nombre for item in $ctrl.searchListadoDeProcesos($viewValue, \'SIMPLE\')" typeahead-wait-ms="500" typeahead-loading="loadingProcesos" typeahead-no-results="noResultsProcesos"> <i ng-show="loadingProcesos" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProcesos"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione la solicitud:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the request:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione a solicita\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione la solicitud:</span></label> <input type="text" spellcheck="true" ng-model="$ctrl.solicitudCargada" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese una Solicitud\' : (($ctrl.language == \'ingles\') ? \'Enter a Request\' : (($ctrl.language == \'portugues\') ? \'Insira uma Solicita\xE7\xE3o\' : \'Ingrese una Solicitud\')) }}" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Solicitud no encontrada</span> <span ng-if="$ctrl.language == \'ingles\'">Request not found</span> <span ng-if="$ctrl.language == \'portugues\'">Solicita\xE7\xE3o n\xE3o encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">Solicitud no encontrada</span></div></div><div class="table-responsive"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" ng-init="$ctrl.initListadoProcesos_doc()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione el proceso:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the process:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione o processo:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione el proceso:</span></label><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoSeleccionado_doc" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'Ingrese el proceso a configurar...\')) }}" ng-change="$ctrl.onChangeSelectProcesoSeleccionado_doc($ctrl.procesoSeleccionado_doc)" uib-typeahead="item as item.Nombre for item in $ctrl.searchListadoDeProcesos($viewValue, \'DOCUMENTAL\')" typeahead-wait-ms="500" typeahead-loading="loadingProcesos_doc" typeahead-no-results="noResultsProcesos_doc"> <i ng-show="loadingProcesos_doc" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProcesos_doc"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione la solicitud:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the request:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione a solicita\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione la solicitud:</span></label> <input type="text" spellcheck="true" ng-model="$ctrl.solicitudCargada_doc" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese una Solicitud\' : (($ctrl.language == \'ingles\') ? \'Enter a Request\' : (($ctrl.language == \'portugues\') ? \'Insira uma Solicita\xE7\xE3o\' : \'Ingrese una Solicitud\')) }}" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud_doc($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList_doc($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Solicitud no encontrada</span> <span ng-if="$ctrl.language == \'ingles\'">Request not found</span> <span ng-if="$ctrl.language == \'portugues\'">Solicita\xE7\xE3o n\xE3o encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">Solicitud no encontrada</span></div></div><div class="table-responsive"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><span class="valorObjetoUrl" data-index="{{$index}}"><a href="" ng-click="$ctrl.openAttachment(item.ValorObjeto)" class="text-links">{{item.ValorObjeto}}</a></span><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando archivo...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading file...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando arquivo...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando archivo...</span></p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img ng-src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\' && item.ValorObjeto!=null" style="object-fit: contain"> <input class="btn btn-success editable-table-button btn-xs" id="inputImage{{item.Campo.Id}}" type="file" accept="image/*" image="item.ValorObjetoImgTmp" resize-max-height="500" resize-max-width="500" resize-quality="0.7" resize-type="image/jpg" ng-image-compress="" style="visibility:hidden; display: none;" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachmentPicture(item.ValorObjetoImgTmp, item)"> <label for="inputImage{{item.Campo.Id}}" class="btn btn-success editable-table-button btn-xs" style="margin: auto;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></label><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.TablaFilas[0].Valor[0]" ng-options="j.condicion as j.condicion for j in item.Campo.Columnas" ng-change="$ctrl.onChangeInputcond(item.TablaFilas[0])"></select></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="TEXT" ng-init="item.TablaFilas[0].Valor[1]==\'\'?item.TablaFilas[0].Valor[1]=col.ColumnaCampo.defaultValue:item.TablaFilas[0].Valor[1]" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" title=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" cols="40" rows="5" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" title="">\r\n                                    </textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" maxlength="22" style="text-align:right;" title=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputGotFocus(item.TablaFilas[0].Valor[1])" ng-blur="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputLostFocus(item.TablaFilas[0].Valor[1])" title=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" style="min-height: 35px;"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><span class="valorObjetoUrl" data-index="{{$index}}"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a></span><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEMPLATE\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="t as t.Template.Nombre for t in item.SourceObjeto track by t.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PERIODO\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLEENR\'"><div class="table-responsive"><table class="table campo-tabla cssForTablTableEnr"><thead ng-style="myStyle={ \'height\': item.Campo.encabezadoHeight, \'background-color\': item.Campo.encabezadoColor, \'font-size\': {{item.Campo.encabezadoFontSize}}, \'color\': item.Campo.encabezadoFontColor}"><tr class="sortable center-label cssForTrTableEnr"><th class="text-center" ng-repeat="col in item.Campo.Columnas" style="border-right: 2px solid white" ng-style="myStyleTextHeader={ \'width\': col.encabezadoWidth + \'%\'}"><div style="white-space: normal">{{col.ColumnaCampo.Nombre}}</div></th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas" ng-style="myStyle2={ \'height\': item.Campo.bodyHeight, \'background-color\': item.Campo.bodyColor }"><td align="center" ng-repeat="colValor in fila.Valor track by $index" ng-style="myStyleTd={\'background-color\': item.Campo.bodyColor, \'color\': item.Campo.bodyFontColor}" style="vertical-align: inherit;" class="cssForTdTableEnr"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor }" style="border-bottom: 1px solid #cbcbcb" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" style="border: 1px solid #cbcbcb" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}" title="">\r\n                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" style="color: #757171;" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" readonly="" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputEnr( $parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12 tableenr-overflow tableenr-attach" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'"><a href="" class="text-links col-md-12" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" ngf-select="$ctrl.uploadAttachmentTableEnr( $file, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" ng-click="$ctrl.removeAttachmentTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index )" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LINK\'"><button class="btn btn-secondary" style="margin-top: 15px;" ng-click="$ctrl.openAttachment(colValor)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LIST\'"><label>{{item.Campo.Columnas[$index].ColumnaCampo.Nombre}}</label><select ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-change="$ctrl.onChangeSelectTableEnrList( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select><select ng-if="$index==0 && !item.Campo.permiteEditarColumna" name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-disabled="true" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.Columnas[$index].ColumnaCampo.tipoNumerador==true"><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><div ng-repeat="j in colValor"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquiaTableEnr( $parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $index, $model )" ng-readonly="(!$ctrl.model.Id==0) || (item.Solicitud.Proceso.isDocumental && item.Solicitud.Proceso.autorizacionesDocumental && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Columnas[$index].ColumnaCampo.Id)" style="color: #666666;"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.Columnas[$index].ColumnaCampo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquiaTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="tableenr-jerarquia-onlyread" ng-if="$index==0 && !item.Campo.permiteEditarColumna"><div ng-repeat="j in colValor"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.Columnas[$index].ColumnaCampo.tipoNumerador==false"><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><div ng-repeat="j in colValor"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquiaTableEnr( $parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $index, $model )"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.Columnas[$index].ColumnaCampo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquiaTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="tableenr-jerarquia-onlyread" ng-if="$index==0 && !item.Campo.permiteEditarColumna"><div ng-repeat="j in colValor"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'MULTI_LIST\'"><div class="col-md-12" style="margin: 10px 0" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><input type="text" spellcheck="true" class="form-control" ng-model="colValor.TextoBusqueda" ng-change="$ctrl.onChangeInputCampostListTableEnr(colValor.TextoBusqueda, colValor, colValor.SourceObjeto[0].JerarquiaPadreId)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar\' : (($ctrl.language == \'ingles\') ? \'Search\' : (($ctrl.language == \'portugues\') ? \'Pesquisar\' : \'Buscar\')) }}"></div><ul class="list-group col-md-12 p-0" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Para Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">To Select</span> <span ng-if="$ctrl.language == \'portugues\'">Para Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Para Seleccionar</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="listItem in colValor.SourceObjeto track by $index" ng-click="$ctrl.actionAddOnClickTableEnr(listItem, colValor);" class="list-group-item list-group-item-action" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{listItem.Nombre}}</a></li></div></ul><ul class="list-group col-md-12 p-0" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionado</span> <span ng-if="$ctrl.language == \'ingles\'">Selected</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionado</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionado</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="listItem in colValor.ValorObjeto track by $index" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClickTableEnr(listItem, colValor);" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{listItem.Nombre}}</a></li></div></ul><ul class="list-group col-md-12 p-0" ng-if="$index==0 && !item.Campo.permiteEditarColumna"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="j in colValor.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'USER\'"><div class="col-md-12" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><input type="text" spellcheck="true" class="form-control" style="width: 195px;" ng-model="colValor.text" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a agregar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to add...\' : (($ctrl.language == \'portugues\') ? \'Insira um usu\xE1rio para adicionar...\' : \'Ingrese un usuario a agregar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" typeahead-on-select="$ctrl.onSelectUsuarioMultiListTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 0 )"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario no encontrado</span></div></div><div class="col-md-12" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" ng-click="$ctrl.onSelectUsuarioMultiListTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 99 )" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</span> <span ng-if="$ctrl.language == \'ingles\'">Requesting User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario Solicitante:</span> <span>{{$ctrl.model.UsuarioCreacion.Nombre}} {{$ctrl.model.UsuarioCreacion.Apellido}}</span></a></div><table class="table" style="margin-bottom: 20px;"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="u in $ctrl.camposList[$parent.$parent.$parent.$index].TablaFilas[$parent.$parent.$index].Valor[$parent.$index]"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center" ng-if="$parent.$index!=0 || $parent.$index==0 && item.Campo.permiteEditarColumna"><a href="" class="text-links" ng-click="$ctrl.deleteCampoUsuarioTableEnr( $parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, u.Id, 0)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></td></tr></tbody></table></div></div><div style="clear: both;"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><div class="table-responsive"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" id="no_permite_editar_columna"><div class="col-md-12" style="margin-bottom:10px"><label class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}">{{colValor}}</label></div></div><div id="permite_editar_columna" ng-if="$index==0 && item.Campo.permiteEditarColumna"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" title="">\r\n                                                        </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" class="text-links" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div></div><div id="permite_editar_columna" ng-if="$index!=0"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" title="">\r\n                                                        </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Seleccionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Eliminar</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><a href="" class="text-links" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LIST\'"><label>{{item.Campo.Columnas[$index].ColumnaCampo.Nombre}}</label><select name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-change="$ctrl.onChangeSelectTableEnrList($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'USER\'"><div class="col-md-3"><input type="text" spellcheck="true" class="form-control" style="width: 195px;" ng-model="colValor.text" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a agregar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to add...\' : (($ctrl.language == \'portugues\') ? \'Insira um usu\xE1rio para adicionar...\' : \'Ingrese un usuario a agregar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" typeahead-on-select="$ctrl.onSelectUsuarioMultiListTableEnr ($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 0)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario no encontrado</span></div></div><div class="col-md-9" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" ng-click="$ctrl.onSelectUsuarioMultiListTableEnr($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 99)" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</span> <span ng-if="$ctrl.language == \'ingles\'">Requesting User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario Solicitante:</span> {{$ctrl.model.UsuarioCreacion.Nombre}} {{$ctrl.model.UsuarioCreacion.Apellido}}</a></div><table class="table" style="margin-bottom: 20px;"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="u in $ctrl.camposList[$parent.$parent.$parent.$parent.$index].TablaFilas[$parent.$parent.$parent.$index].Valor[$parent.$parent.$index]"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoUsuarioTableEnr($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, u.Id, 0)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div></td></tr></tbody></table></div></div><div style="clear: both;"></div><br></div></div><div ng-show="!$ctrl.isCamposLoading" ng-if="!$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList" style="margin-bottom: 2px;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\' && item.Campo.CampoTipo.Codigo != \'LINK\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'" style="display: inline;"><textarea class="col-md-9 center-label" style="font-weight:normal; margin-left: 0px; padding-left: 0px; border: none; resize: none; width: 100%; background-color: transparent;" rows="7" disabled="true" title="">{{item.Valor}}</textarea></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-secondary pull-right" style="margin-top: 15px;" ng-click="$ctrl.openAttachment(item.ValorObjeto)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'" style="display: inline;"><div ng-bind-html="item.Valor"></div></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\' && item.Valor != \'\'"><a class="col-md-9 text-links" href="" style="font-weight:normal; padding-top: 8px;" ng-click="$ctrl.openAttachment(item.Valor)">{{item.Valor}}</a></div><div ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img ng-src="{{$ctrl.imgFile}}{{item.Valor}}" height="350" width="350" ng-if="item.Valor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'TABLEENR\'"><table class="table campo-tabla cssForTablTableEnr"><thead ng-style="myStyle={ \'height\': item.Campo.encabezadoHeight, \'background-color\': item.Campo.encabezadoColor, \'font-size\': {{item.Campo.encabezadoFontSize}}, \'color\': item.Campo.encabezadoFontColor}"><tr class="sortable center-label cssForTrTableEnr"><th class="text-center" ng-repeat="col in item.Campo.Columnas" style="border-right: 2px solid white" ng-style="myStyleTextHeader={ \'width\': col.encabezadoWidth + \'%\'}"><div style="white-space: normal">{{col.ColumnaCampo.Nombre}}</div></th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas track by $index" ng-style="myStyle2={ \'height\': item.Campo.bodyHeight, \'background-color\': item.Campo.bodyColor }"><td align="center" ng-repeat="colValor in fila.Valor track by $index" ng-style="myStyleTd={\'background-color\': item.Campo.bodyColor, \'color\': item.Campo.bodyFontColor}" class="cssForTdTableEnr"><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" id="no_permite_editar_columna"><div class="col-md-12" style="margin-bottom: 10px"><label class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}">{{colValor}}</label></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom: 10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="border-bottom: 1px solid red" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor }" ng-readonly="true" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom: 10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="3" ng-readonly="true" style="border: 1px solid #cbcbcb" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}" title="">\r\n                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom: 10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align: right" maxlength="22" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" ng-readonly="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom: 10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align: right" ng-readonly="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}" title=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom: 10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-readonly="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom: 10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" style="color: #757171" ng-readonly="true" readonly="" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom: 10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputEnr($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-readonly="true" disabled="" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12 tableenr-overflow tableenr-attach" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom: 10px"><a href="" class="text-links col-md-12" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom: 10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LIST\'"><label>{{item.Campo.Columnas[$index].ColumnaCampo.Nombre}}</label><select name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-disabled="true" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'JERARQ\'" style="display: inline;"><div class="tableenr-jerarquia-onlyread"><div ng-repeat="j in colValor"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'MULTI_LIST\'" style="display: inline;"><ul class="list-group col-md-12 p-0"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="j in colValor.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'USER\'"><table class="table" style="margin-bottom: 20px;"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th></tr></thead><tbody><tr ng-repeat="u in $ctrl.camposList[$parent.$parent.$parent.$index].TablaFilas[$parent.$parent.$index].Valor[$parent.$index]"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td></tr></tbody></table></div></td></tr></tbody></table></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><div class="table-responsive"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div class="col-md-12" style="margin-bottom:10px" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'TEXTAREA\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DATE\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'ATTACH\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'INT\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DECIMAL\'">{{colValor}}</div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\' || item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" align="right">{{colValor}}</div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a class="col-md-12 text-links" href="" style="font-weight:normal" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'"><pre class="col-md-12" style="background: transparent; border: transparent; font-family:inherit">{{colValor}}</pre></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'"><label class="col-md-12 center-label" style="font-weight:normal">{{colValor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><label class="col-md-12 center-label" style="font-weight:normal">{{colValor | date:\'dd/MM/yyyy\'}}</label></div></td></tr></tbody></table></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'" style="display: inline;"><div style="font-family:inherit; color:black; -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */ -moz-box-sizing: border-box; /* Firefox, other Gecko */ box-sizing: border-box; /* Opera/IE 8+ */ padding:1%; border:none; padding-left: 0px; padding-top: 0px;"><div ng-repeat="j in item.ValorObjeto"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><input type="text" spellcheck="true" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[0]" readonly="" title=""></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly="" title=""></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item, $index)" ng-disabled="$ctrl.isBusy"></div></div><div ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img ng-src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'" style="display: inline;"><ul class="list-group col-md-6"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div ng-if="item.Campo.CampoTipo.Codigo!==\'TABLE\' && item.Campo.CampoTipo.Codigo!==\'TABLEENR\' && item.Campo.CampoTipo.Codigo!==\'TEXTAREA\' && item.Campo.CampoTipo.Codigo!==\'DATE\' && item.Campo.CampoTipo.Codigo!==\'ATTACH\' && item.Campo.CampoTipo.Codigo!==\'COND\' && item.Campo.CampoTipo.Codigo!==\'TEXTENR\' && item.Campo.CampoTipo.Codigo!==\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL_DOCASO\' && item.Campo.CampoTipo.Codigo!==\'LINK\' && item.Campo.CampoTipo.Codigo!==\'PROCEDURE\' && item.Campo.CampoTipo.Codigo!==\'MULTI_LIST\' && item.Campo.CampoTipo.Codigo!==\'TITLE\' && item.Campo.CampoTipo.Codigo!==\'IMG\' && item.Campo.CampoTipo.Codigo!==\'DATETIMEREGIONAL\' && item.Campo.CampoTipo.Codigo!==\'JERARQ\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div style="clear: both;"></div></div></div><div class="add-top-space col-md-8" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.procesoGeneraProcesosRelacionados"><label class="center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Desea generar automaticamente todos los procesos relacionados?:</span> <span ng-if="$ctrl.language == \'ingles\'">Do you want to automatically generate all related processes?:</span> <span ng-if="$ctrl.language == \'portugues\'">Deseja gerar automaticamente todos os processos relacionados?:</span> <span ng-if="$ctrl.language == \'italiano\'">Desea generar automaticamente todos los procesos relacionados?:</span></label></div><div class="col-md-8" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.procesoGeneraProcesosRelacionados"><ba-switcher switcher-style="primary" switcher-value="$ctrl.generaProcesoRelacionados" switcher-language="$ctrl.language"></ba-switcher></div><div class="col-md-12" ng-show="!$ctrl.isCamposLoading"><button class="btn btn-success pull-right" ng-click="$ctrl.saveCamposSolicitud()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeEditarCampos && $ctrl.mostrarCamposBoton && $ctrl.model.Id > 0"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar Campos</span> <span ng-if="$ctrl.language == \'ingles\'">Save Fields</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar Campos</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar Campos</span></button></div></div><div modal-directive=""></div></uib-tab><uib-tab index="2" ng-disabled="true" ng-show="$ctrl.model.Id > 0"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Historial</span> <span ng-if="$ctrl.language == \'ingles\'">History</span> <span ng-if="$ctrl.language == \'portugues\'">Hist\xF3rico</span> <span ng-if="$ctrl.language == \'italiano\'">Historial</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Historial\' : (($ctrl.language == \'ingles\') ? \'History\' : (($ctrl.language == \'portugues\') ? \'Hist\xF3rico\' : \'Historial\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="historial"><div class="table-responsive"><table class="table" st-table="$ctrl.historialSolicitud" st-safe-src="$ctrl.dataSource"><thead><tr class="sortable center-label"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha</span> <span ng-if="$ctrl.language == \'ingles\'">Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Etapa</span> <span ng-if="$ctrl.language == \'ingles\'">Stage</span> <span ng-if="$ctrl.language == \'portugues\'">Etapa</span> <span ng-if="$ctrl.language == \'italiano\'">Etapa</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Gestionado</span> <span ng-if="$ctrl.language == \'ingles\'">Managed</span> <span ng-if="$ctrl.language == \'portugues\'">Gerenciado</span> <span ng-if="$ctrl.language == \'italiano\'">Gestionado</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios</span> <span ng-if="$ctrl.language == \'ingles\'">Comments</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span></th></tr></thead><tbody ng-show="!$ctrl.historialIsSearching"><tr ng-repeat="item in $ctrl.historialSolicitud"><td align="center">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="center">{{item.SolicitudEtapaNombre}}</td><td align="center">{{item.AprobadoText}}</td><td align="center">{{item.Comentarios}}</td><td align="center">{{item.UsuarioCreacion.Login}}</td></tr></tbody><tbody ng-show="$ctrl.historialIsSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody></table></div></div></uib-tab><uib-tab index="3" ng-disabled="true" ng-show="$ctrl.model.Id > 0" ng-click="$ctrl.getHistorialTrazabilidadSolicitud()"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Trazabilidad</span> <span ng-if="$ctrl.language == \'ingles\'">Traceability</span> <span ng-if="$ctrl.language == \'portugues\'">Rastreabilidade</span> <span ng-if="$ctrl.language == \'italiano\'">Trazabilidad</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Trazabilidad\' : (($ctrl.language == \'ingles\') ? \'Traceability\' : (($ctrl.language == \'portugues\') ? \'Rastreabilidade\' : \'Trazabilidad\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista" id="historial"><div class="table-responsive"><table class="table" st-table="$ctrl.TrazabilidadSolicitud" st-safe-src="$ctrl.dataSource"><thead><tr class="sortable center-label"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha</span> <span ng-if="$ctrl.language == \'ingles\'">Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios</span> <span ng-if="$ctrl.language == \'ingles\'">Comments</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Gesti\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Management Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome da Gest\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Gesti\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Titulo Gesti\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Management Title</span> <span ng-if="$ctrl.language == \'portugues\'">T\xEDtulo da Gest\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Titulo Gesti\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Texto Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data Text</span> <span ng-if="$ctrl.language == \'portugues\'">Texto de Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Texto Datos</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Destinatarios correos</span> <span ng-if="$ctrl.language == \'ingles\'">Email Recipients</span> <span ng-if="$ctrl.language == \'portugues\'">Destinat\xE1rios de e-mails</span> <span ng-if="$ctrl.language == \'italiano\'">Destinatarios correos</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha creacion</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha creacion</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha update</span> <span ng-if="$ctrl.language == \'ingles\'">Update Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de atualiza\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha update</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n Realizada</span> <span ng-if="$ctrl.language == \'ingles\'">Action performed</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xF5es tomadas</span> <span ng-if="$ctrl.language == \'italiano\'">Accion Realizada</span></th></tr></thead><tbody ng-show="!$ctrl.historialIsSearchingTrazabilidad"><tr ng-repeat="item in $ctrl.TrazabilidadSolicitud"><td align="center">{{item.LastUpdate | date:\'dd/MM/yyyy\'}}</td><td align="center">{{item.NombreProceso}}</td><td align="center">{{item.DescripcionResumidaProceso}}</td><td align="center">{{item.NombreApellidoUsuario}}</td><td align="center">{{item.NombreTemplate}}</td><td align="center">{{item.TituloTemplate}}</td><td align="center">{{item.TextoDatos}}</td><td align="center">{{item.DestinatariosCorreo}}</td><td align="center">{{item.CreationDate}}</td><td align="center">{{item.LastUpdate}}</td><td align="center">{{item.AccionRealizada}}</td></tr></tbody><tbody ng-show="$ctrl.historialIsSearchingTrazabilidad"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody></table></div></div></uib-tab><uib-tab index="4" ng-disabled="true" ng-show="$ctrl.model.Id > 0" class="procesos-asociados"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Procesos Asociados</span> <span ng-if="$ctrl.language == \'ingles\'">Associated Processes</span> <span ng-if="$ctrl.language == \'portugues\'">Processos Associados</span> <span ng-if="$ctrl.language == \'italiano\'">Procesos Asociados</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Encabezado\' : (($ctrl.language == \'ingles\') ? \'Header\' : (($ctrl.language == \'portugues\') ? \'Cabe\xE7alho\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space" id="cabecera"><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'ingles\'">Number:</b> <b ng-if="$ctrl.language == \'portugues\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.NumeroCompleto}}</label><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha de Alta:</b> <b ng-if="$ctrl.language == \'ingles\'">Creation Date:</b> <b ng-if="$ctrl.language == \'portugues\'">Data de Cadastro:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.CreationDate|date:\'dd-MM-yyyy\'}}</label> <label class="col-xs-12 col-md-6 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</b> <b ng-if="$ctrl.language == \'ingles\'">Requesting User:</b> <b ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.UsuarioCreacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa Atual:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.SolicitudEtapaNombre}}</label> <label class="col-xs-12 col-md-4 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage User:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa atual do usu\xE1rio:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.model.UsuarioAprobador.NombreMostrar}}</label><label ng-if="!$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Descripci\xF3n Resumida:</b> <b ng-if="$ctrl.language == \'ingles\'">Summary Description:</b> <b ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.model.DescripcionResumida}}</label> <label ng-if="$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Descripci\xF3n Resumida:</b> <b ng-if="$ctrl.language == \'ingles\'">Summary Description:</b> <b ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> <input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.DescripcionResumida" title=""></label></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Procesos Asociados\' : (($ctrl.language == \'ingles\') ? \'Associated Processes\' : (($ctrl.language == \'portugues\') ? \'Processos Associados\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && $ctrl.model.Proceso.AceptaHijos && !$ctrl.anularVista" class="add-top-space" id="procesosHijo"><div class="col-xs-12 col-md-12"><input type="checkbox" ng-model="$ctrl.verTodosProcesosAsociados" ng-click="$ctrl.buscarSolicitudesHijo()" ng-disabled="$ctrl.isBusy" style="margin-top:10px;margin-bottom:10px" name=""> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver procesos cerrados</span> <span ng-if="$ctrl.language == \'ingles\'">View closed processes</span> <span ng-if="$ctrl.language == \'portugues\'">Consulte processos fechados</span> <span ng-if="$ctrl.language == \'italiano\'">Ver procesos cerrados</span> <button class="col-xs-12 col-md-3 btn btn-primary pull-right" ng-show="$ctrl.showProcesosHijosEtapaActual" ng-click="$ctrl.agregarSolicitudHijo()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Agregar Proceso Asociado</span> <span ng-if="$ctrl.language == \'ingles\'">Add Associated Process</span> <span ng-if="$ctrl.language == \'portugues\'">Adicionar Processo Associado</span> <span ng-if="$ctrl.language == \'italiano\'">Agregar Proceso Asociado</span></button></div><span ng-show="$ctrl.solicitudesHijoIsSearching"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></span><div ng-repeat="(nombreProceso, solicitudesHijo) in $ctrl.solicitudesHijoList" ng-show="!$ctrl.solicitudesHijoIsSearching"><label class="col-md-12" style="margin-top:20px;margin-bottom:10px" ng-show="$ctrl.totalProcesosHijo()"><b>{{nombreProceso}}:</b></label><div class="table-responsive"><table class="table" st-table="solicitudesHijo"><thead><tr class="sortable"><th class="text-center" ng-repeat="col in solicitudesHijo[0].Proceso.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody ng-show="!$ctrl.solicitudesHijoIsSearching"><tr ng-repeat="fila in solicitudesHijo" ng-click="$ctrl.verSolicitudHijo(fila)" style="cursor: pointer" ng-class="{ \'solicitud-vencida\': fila.EstaVencida }"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left"><div ng-switch="" on="solicitudesHijo[0].Proceso.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="right">{{colValor}}</div><div ng-switch-when="DECIMAL" align="right">{{colValor}}</div><div ng-switch-when="JERARQ" align="right"><div ng-repeat="c in colValor">{{c.Nombre}}</div></div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} != \'\' && {{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} != \'\' && {{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a class="text-links" href="{{colValor}}" target="_blank">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="solicitudesHijo[0].Proceso.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><a href="" ng-click="$ctrl.edit(fila.Id)" ng-show="!$ctrl.isBusy" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></a> <a href="{{fila.UrlLink}}" class="text-links" target="_blank" ng-show="!$ctrl.isBusy">{{fila.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.solicitudesHijoIsSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando..</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody></table></div></div></div></uib-tab><div class="icon-tiene-procesos" ng-show="$ctrl.model.Id > 0 && $ctrl.solicitudesHijoList && !$ctrl.verTodosProcesosAsociados"><i class="fa fa-star icon-star" ng-style="{\'opacity\': $ctrl.showIconProcesosAsociados ? 1 : 0}"></i></div></uib-tabset></div><div class="col-md-12 margin-solicitud-edit"><button class="btn btn-success pull-right" ng-click="$ctrl.createSolicitud()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeEditarSolicitud && $ctrl.model.Id == 0"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Crear Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Create Process</span> <span ng-if="$ctrl.language == \'portugues\'">Criar Processo</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button> <button class="btn btn-atras" ng-click="$ctrl.goBack()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ir Atr\xE1s</span> <span ng-if="$ctrl.language == \'ingles\'">Go back</span> <span ng-if="$ctrl.language == \'portugues\'">Voltar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button> <button class="btn btn-atras" ng-click="$ctrl.goListado()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ir al Listado</span> <span ng-if="$ctrl.language == \'ingles\'">Go to list</span> <span ng-if="$ctrl.language == \'portugues\'">Ir para a Lista</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button><button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="!$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.showDelete && !$ctrl.anularVista && $ctrl.puedeEditarSolicitud && ($ctrl.lsuarioLogueadoIsAdminProceso || $ctrl.lsuarioLogueadoIsSysAdmin)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Delete Process</span> <span ng-if="$ctrl.language == \'portugues\'">Apagar Processo</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div>');
$templateCache.put('app/pages/solicitud/list.template.html','<div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Proceso:\' : (($ctrl.language == \'ingles\') ? \'Process:\' : (($ctrl.language == \'portugues\') ? \'Processo:\' : \'italiano:\')) }} {{$ctrl.procesoSeleccionado.Codigo}} - {{$ctrl.procesoSeleccionado.Nombre}}" ba-panel-class="with-scroll"><div ba-panel="" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista"><h5 ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo y un proceso ingresando por la <a href="" ng-click="$ctrl.goHome()">home</a>.</h5><h5 ng-if="$ctrl.language == \'ingles\'">You must select a group and a process from the <a href="" ng-click="$ctrl.goHome()">home page</a>.</h5><h5 ng-if="$ctrl.language == \'portugues\'">Deve selecionar um grupo de processo entrando pela <a href="" ng-click="$ctrl.goHome()">p\xE1gina inicial</a>.</h5><h5 ng-if="$ctrl.language == \'italiano\'">italiano <a href="" ng-click="$ctrl.goHome()">home</a>.</h5></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><button class="btn btn-secondary col-md-2 col-xs-12" ng-click="$ctrl.cancel()" style="margin-top: 5px" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Volver</span> <span ng-if="$ctrl.language == \'ingles\'">Back</span> <span ng-if="$ctrl.language == \'portugues\'">Voltar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <img src="/images/doc_cerrados.png" class="imgZoom" height="40" width="40" style="cursor: pointer; float: left; margin-left: 15px;display: block;" ng-if="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && !$ctrl.documentalGetCerrados" ng-click="$ctrl.verDocPendientes(\'Cerrados\')" alt="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Cerrados\' : (($ctrl.language == \'ingles\') ? \'Closed\' : (($ctrl.language == \'portugues\') ? \'Fechados\' : \'italiano\')) }}" data-toggle="tooltip" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Cerrados!\' : (($ctrl.language == \'ingles\') ? \'Closed!\' : (($ctrl.language == \'portugues\') ? \'Fechados!\' : \'italiano\')) }}"> <img src="/images/doc_pendientes.png" class="imgZoom" height="40" width="40" style="cursor: pointer; float: left; margin-left: 15px;display: block;" ng-if="$ctrl.lProcesoIsDocumentalAutorizacionesV2 && $ctrl.documentalGetCerrados" ng-click="$ctrl.verDocPendientes(\'Pendientes\')" alt="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Pendientes\' : (($ctrl.language == \'ingles\') ? \'Pending\' : (($ctrl.language == \'portugues\') ? \'Pendentes\' : \'italiano\')) }}" data-toggle="tooltip" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Pendientes!\' : (($ctrl.language == \'ingles\') ? \'Pending!\' : (($ctrl.language == \'portugues\') ? \'Pendentes!\' : \'italiano\')) }}"><button class="btn btn-secondary pull-right col-md-2 col-xs-12" style="margin-top: 5px; margin-left: 5px" ng-click="$ctrl.add()" ng-if="$ctrl.procesoSeleccionado.verBtnAgregar && $ctrl.puedeCrearSolicitud" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Agregar</span> <span ng-if="$ctrl.language == \'ingles\'">Add</span> <span ng-if="$ctrl.language == \'portugues\'">Adicionar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <button class="btn btn-danger pull-right col-md-2 col-xs-12" ng-click="$ctrl.deleteAll()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.isSysAdmin" style="margin-top: 5px"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar Todas</span> <span ng-if="$ctrl.language == \'ingles\'">Delete All</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir tudo</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button><div class="col-md-12 col-xs-12" style="margin-top:10px" ng-show="$ctrl.showCheckProcesosCerrados"><input type="checkbox" ng-model="$ctrl.verTodos" ng-click="$ctrl.buscarSolicitud($ctrl.solicitudTableState)" ng-disabled="$ctrl.isBusy" id="checkVerTodos"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver procesos cerrados</span> <span ng-if="$ctrl.language == \'ingles\'">View closed processes</span> <span ng-if="$ctrl.language == \'portugues\'">Consulte processos fechados</span> <span ng-if="$ctrl.language == \'italiano\'">Show closed process</span></div><div class="col-md-12 col-xs-12" ng-show="$ctrl.showCheckMisSolicitudes"><input type="checkbox" ng-model="$ctrl.VerMisSolicitudes" ng-click="$ctrl.buscarSolicitud($ctrl.solicitudTableState)" ng-disabled="$ctrl.isBusy" id="checkVerMisSolicitudes"> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Mis solicitudes</span> <span ng-if="$ctrl.language == \'ingles\'">My Records</span> <span ng-if="$ctrl.language == \'portugues\'">Meus Registros</span> <span ng-if="$ctrl.language == \'italiano\'">Mis solicitudes</span></div><div class="col-md-12 col-xs-12"><input type="checkbox" ng-model="$ctrl.verProcesosPendientesOtrosUsuarios" ng-click="$ctrl.buscarSolicitud($ctrl.solicitudTableState)" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" name=""> <span ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" ng-if="$ctrl.language == \'espa\xF1ol\'">Ver procesos pendientes de cualquier usuario</span> <span ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" ng-if="$ctrl.language == \'ingles\'">View pending processes for any user</span> <span ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" ng-if="$ctrl.language == \'portugues\'">Visualizar processos pendentes de qualquer usu\xE1rio</span> <span ng-show="$ctrl.procesoSeleccionado.MostrarOpcionProcesosPendientes" ng-if="$ctrl.language == \'italiano\'">View pending processes for any user</span></div></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.procesoSeleccionado.Links != null && $ctrl.procesoSeleccionado.Links.length > 0"><button class="btn btn-primary" ng-click="$ctrl.openUrl(item.UrlLink)" ng-repeat="item in $ctrl.procesoSeleccionado.Links track by $index" style="margin-right: 10px" ng-if="!item.solicitudLevel">{{item.NombreLink}}</button></div><div ba-panel="" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista"><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscarSolicitud" st-table="$ctrl.solicitudesList"><thead><tr><div style="width: auto;margin-right: 1px;float: right;padding: 6px;" class="ng-scope"><button class="btn btn-primary col-md-3 col-xs-12" ng-click="$ctrl.triggerFind()" style="margin-top: 5px;min-width: 150px;margin-left: 15px;" ng-disabled="$ctrl.isBusy"><i class="fa fa-search" style="font-size: 16px;margin-right: 5px;"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Buscar</span> <span ng-if="$ctrl.language == \'ingles\'">Search</span> <span ng-if="$ctrl.language == \'portugues\'">Pesquisar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button> <button class="btn btn-primary col-md-3 col-xs-12" ng-click="$ctrl.cleanFilters()" style="margin-top: 5px;min-width: 150px;margin-left: 15px;" ng-disabled="$ctrl.isBusy"><i class="fa fa-pencil-square-o" style="font-size: 16px;margin-right: 5px;" aria-hidden="true"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Limpiar</span> <span ng-if="$ctrl.language == \'ingles\'">Clear</span> <span ng-if="$ctrl.language == \'portugues\'">Limpar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button></div></tr><tr class="sortable"><th class="text-center" st-sort="{{col.SolicitudColumna.Codigo}}{{col.Campo.Id}}" ng-repeat="col in $ctrl.procesoSeleccionado.CamposListado"><span ng-show="col.SolicitudColumna != null">{{col.SolicitudColumna.Nombre}}</span> <span ng-show="col.Campo != null">{{col.Campo.Nombre}}</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></th><th class="text-center" ng-show="$ctrl.procesoSeleccionado.isDocumental"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Documento</span> <span ng-if="$ctrl.language == \'ingles\'">Document</span> <span ng-if="$ctrl.language == \'portugues\'">Documento</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></th></tr><tr><th ng-repeat="col in $ctrl.procesoSeleccionado.CamposListado"><div class="input-group search-field" ng-if="$ctrl.language == \'espa\xF1ol\'"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Buscar por {{col.SolicitudColumna.Nombre}}" aria-describedby="basic-addon1" ng-show="col.SolicitudColumna != null"> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Buscar por {{col.Campo.Nombre}}" aria-describedby="basic-addon1" ng-show="col.Campo != null"></div><div class="input-group search-field" ng-if="$ctrl.language == \'ingles\'"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Search by {{col.SolicitudColumna.Nombre}}" aria-describedby="basic-addon1" ng-show="col.SolicitudColumna != null"> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Search by {{col.Campo.Nombre}}" aria-describedby="basic-addon1" ng-show="col.Campo != null"></div><div class="input-group search-field" ng-if="$ctrl.language == \'portugues\'"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Pesquisar por {{col.SolicitudColumna.Nombre}}" aria-describedby="basic-addon1" ng-show="col.SolicitudColumna != null"> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="Pesquisar por {{col.Campo.Nombre}}" aria-describedby="basic-addon1" ng-show="col.Campo != null"></div><div class="input-group search-field" ng-if="$ctrl.language == \'italiano\'"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="ITALIANO {{col.SolicitudColumna.Nombre}}" aria-describedby="basic-addon1" ng-show="col.SolicitudColumna != null"> <input type="search" spellcheck="true" ng-model="$ctrl.values[$index]" class="input-sm form-control with-primary-addon" placeholder="ITALIANO {{col.Campo.Nombre}}" aria-describedby="basic-addon1" ng-show="col.Campo != null"></div></th><th></th><th ng-show="$ctrl.procesoSeleccionado.isDocumental"></th></tr></thead><tbody ng-show="!$ctrl.isSolicitudSearching"><tr ng-repeat="fila in $ctrl.solicitudesList" ng-class="{ \'solicitud-vencida\': fila.EstaVencida }" style="cursor: pointer"><td align="left" ng-repeat="colValor in fila.ValorMostrarBusqueda track by $index" style="text-align: left" ng-click="$ctrl.edit(fila.Id)"><div ng-switch="" on="$ctrl.procesoSeleccionado.CamposListado[$index].Campo.CampoTipo.Codigo"><div ng-switch-when="DATE">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="INT" align="right">{{colValor}}</div><div ng-switch-when="DECIMAL" align="right">{{colValor}}</div><div ng-switch-when="JERARQ" align="right">{{colValor}}</div><div ng-switch-when="BOOL"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-when="ATTACH"><a href="{{colValor}}" target="_blank" class="text-links">{{colValor}}</a></div><div ng-switch-default=""><div ng-switch="" on="$ctrl.procesoSeleccionado.CamposListado[$index].SolicitudColumna.Codigo"><div ng-switch-when="Id">{{colValor}}</div><div ng-switch-when="Activo"><i class="fa fa-check" style="color:green" ng-show="{{colValor}} == true"></i> <i class="fa fa-times" style="color:red" ng-hide="{{colValor}} == true"></i></div><div ng-switch-when="Descripcion">{{colValor}}</div><div ng-switch-when="DescripcionResumida">{{colValor}}</div><div ng-switch-when="Estado">{{colValor}}</div><div ng-switch-when="LastUpdate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="FechaCierre">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="CreationDate">{{colValor | date:\'dd/MM/yyyy\'}}</div><div ng-switch-when="Proceso">{{colValor}}</div><div ng-switch-when="NumeroCompleto">{{colValor}}</div><div ng-switch-when="UsuarioAprobador">{{colValor}}</div><div ng-switch-when="UsuarioCreacion">{{colValor}}</div><div ng-switch-default="">{{colValor}}</div></div></div></div></td><td align="center"><a ng-click="$ctrl.openNewTab(fila)" target="_blank" class="text-links">{{fila.NombreLink}}</a></td><td align="center" ng-show="$ctrl.procesoSeleccionado.isDocumental" ng-click="$ctrl.verDocumento(fila, \'descarga de documento Kahuna - APP\')" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></td></tr></tbody><tbody ng-show="$ctrl.isSolicitudSearching"><tr><td colspan="1" class="text-center" ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</td><td colspan="1" class="text-center" ng-if="$ctrl.language == \'ingles\'">Loading...</td><td colspan="1" class="text-center" ng-if="$ctrl.language == \'portugues\'">Carregando...</td><td colspan="1" class="text-center" ng-if="$ctrl.language == \'italiano\'">Italiano...</td></tr></tbody><tfoot><tr><td colspan="10"><div st-template="app/pages/solicitud/pagination.html" st-pagination="" st-items-by-page="$ctrl.itemsByPage" style="display: inline-block;text-align: center;margin: auto;width: 100%;"></div><div class="btn-group pull-right ng-scope"><button type="button" ng-class="{\'active\':$ctrl.itemsByPage==10}" ng-click="$ctrl.itemsByPage=10" class="btn btn-default">10</button> <button type="button" ng-class="{\'active\':$ctrl.itemsByPage==25}" ng-click="$ctrl.itemsByPage=25" class="btn btn-default">25</button> <button type="button" ng-class="{\'active\':$ctrl.itemsByPage==50}" ng-click="$ctrl.itemsByPage=50" class="btn btn-default">50</button></div></td></tr></tfoot></table></div></div></div>');
$templateCache.put('app/pages/solicitud/pagination.html','<div class="pagination" ng-if="pages.length >= 2"><ul class="pagination"><li ng-if="currentPage > 1"><a ng-click="selectPage(1)" st-language="first"></a></li><li ng-repeat="page in pages" ng-class="{active: page==currentPage}"><a ng-click="selectPage(page)">{{page}}</a></li><li ng-if="currentPage<numPages"><a ng-click="selectPage(numPages)" st-language="last"></a></li></ul></div>');
$templateCache.put('app/pages/solicitud/procesolist.template.html','<section class="procesolist container-fluid"><h4 class="procesolist-title">{{$ctrl.grupoSeleccionado.Nombre}}</h4><div ng-show="$ctrl.anularVista"><h5 ng-if="$ctrl.language == \'espa\xF1ol\'">Debe seleccionar un grupo de proceso ingresando por la <a href="" class="text-links" ng-click="$ctrl.goHome()">home</a>.</h5><h5 ng-if="$ctrl.language == \'ingles\'">You must select a process group from the <a href="" class="text-links" ng-click="$ctrl.goHome()">home page</a>.</h5><h5 ng-if="$ctrl.language == \'portugues\'">Deve selecionar um grupo de processo entrando pela <a href="" class="text-links" ng-click="$ctrl.goHome()">p\xE1gina inicial</a>.</h5><h5 ng-if="$ctrl.language == \'italiano\'">italiano <a href="" class="text-links" ng-click="$ctrl.goHome()">home</a>.</h5></div><div ng-show="!$ctrl.anularVista"><div ng-show="$ctrl.isProcesoSearching"><h5 ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</h5><h5 ng-if="$ctrl.language == \'ingles\'">Loading...</h5><h5 ng-if="$ctrl.language == \'portugues\'">Carregando...</h5><h5 ng-if="$ctrl.language == \'italiano\'">italiano...</h5></div><div class="row" ng-show="!$ctrl.isProcesoSearching"><div class="col-md-3 col-sm-4 col-12 procesolist-wrapper" ng-repeat="item in $ctrl.procesosList"><div class="procesolist-group-button" ng-click="$ctrl.setProcesoSeleccionado(item)"><img ng-src="{{item.UrlImagen}}" ng-show="item.UrlImagen != null || item.UrlImagen.lenght > 0"><br><label ng-style="{ \'color\': item.ColorTexto }">{{item.Nombre}}</label><br><span ng-style="{ \'color\': item.ColorTexto }">{{item.Codigo}}</span></div><br></div></div></div></section>');
$templateCache.put('app/pages/solicitud/template.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="solicitud-templates"><div class="col-md-12"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Cabecera\' : (($ctrl.language == \'ingles\') ? \'Header\' : (($ctrl.language == \'portugues\') ? \'Cabe\xE7alho\' : \'Cabecera\')) }}" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista" class="add-top-space"><label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'ingles\'">Number:</b> <b ng-if="$ctrl.language == \'portugues\'">N\xFAmero:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.solicitud.NumeroCompleto}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha de Alta:</b> <b ng-if="$ctrl.language == \'ingles\'">Registration Date:</b> <b ng-if="$ctrl.language == \'portugues\'">Data de Cadastro:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.solicitud.CreationDate|date:\'dd-MM-yyyy\'}}</label> <label class="col-xs-12 col-md-6 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</b> <b ng-if="$ctrl.language == \'ingles\'">Requesting User:</b> <b ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.solicitud.UsuarioCreacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-3 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa Atual:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.solicitud.SolicitudEtapaNombre}}</label> <label class="col-xs-12 col-md-4 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Etapa Actual:</b> <b ng-if="$ctrl.language == \'ingles\'">Current Stage User:</b> <b ng-if="$ctrl.language == \'portugues\'">Etapa atual do usu\xE1rio:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.solicitud.UsuarioAprobador.NombreMostrar}}</label> <label ng-if="!$ctrl.puedeEditarDescripcion($ctrl.model)" class="col-xs-12 col-md-12 center-label cabeceraLbl"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Descripci\xF3n Resumida:</b> <b ng-if="$ctrl.language == \'ingles\'">Summary Description:</b> <b ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.solicitud.DescripcionResumida}}</label></div><form editable-form="" name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos de la Carga\' : (($ctrl.language == \'ingles\') ? \'Load Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Carregamento\' : \'Datos de la Carga\')) }}" ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.viewLoading"><label class="col-xs-12 col-md-4 center-label" ng-show="!$ctrl.anularVista" style="font-weight:normal"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Modificaci\xF3n:</b> <b ng-if="$ctrl.language == \'ingles\'">Modification Date:</b> <b ng-if="$ctrl.language == \'portugues\'">Data de Modifica\xE7\xE3o:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b> {{$ctrl.camposList[0].LastUpdate|date:\'dd/MM/yyyy HH:mm:ss\'}}</label> <label class="col-xs-12 col-md-4 center-label" ng-show="!$ctrl.anularVista" style="font-weight:normal"><b ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario:</b> <b ng-if="$ctrl.language == \'ingles\'">User:</b> <b ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio:</b> <b ng-if="$ctrl.language == \'italiano\'">italiano:</b> {{$ctrl.camposList[0].UsuarioModificacion.NombreMostrar}}</label> <label class="col-xs-12 col-md-12 center-label"><b ng-if="$ctrl.language == \'espa\xF1ol\'">T\xEDtulo:</b> <b ng-if="$ctrl.language == \'ingles\'">Title:</b> <b ng-if="$ctrl.language == \'portugues\'">T\xEDtulo:</b> <b ng-if="$ctrl.language == \'italiano\'">Italiano:</b></label> <label class="col-xs-12 col-md-12 center-label" style="font-weight:normal" ng-show="!$ctrl.anularVista" ng-if="$ctrl.soloLectura==1 && $ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.ConfiguracionTitulo.length > 0">{{$ctrl.tituloCampoValor}}</label><div class="col-xs-12 col-md-12" ng-show="!$ctrl.anularVista" ng-if="$ctrl.soloLectura==0 && !($ctrl.camposList[0].SolicitudProcesoTemplate.ProcesoTemplate.Template.ConfiguracionTitulo.length > 0)"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.tituloCampoValor"></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos del Proceso...\' : (($ctrl.language == \'ingles\') ? \'Process Data...\' : (($ctrl.language == \'portugues\') ? \'Dados do Processo...\' : \'Datos del Proceso...\')) }}" ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.viewLoading"><div class="header-icons"><i class="autosave-icon fa fa-clock-o" ng-show="$ctrl.template.temporizadorGuardar > 0" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Esta gesti\xF3n tiene autoguardado\' : (($ctrl.language == \'ingles\') ? \'This management has autosave\' : (($ctrl.language == \'portugues\') ? \'Esta gest\xE3o tem salvamento autom\xE1tico\' : \'Guardar y ejecutar procedimiento\')) }}"></i> <i class="executeSP-icon glyphicon glyphicon-refresh" ng-show="$ctrl.template.tieneProcedimientoRefresh" ng-click="$ctrl.saveCamposAndExecSP()" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Guardar y ejecutar procedimiento\' : (($ctrl.language == \'ingles\') ? \'Save and execute procedure\' : (($ctrl.language == \'portugues\') ? \'Salvar e executar procedimento\' : \'Guardar y ejecutar procedimiento\')) }}"></i></div><div ng-repeat="item in $ctrl.valoresCampoSolicitudList"><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo!=\'JERARQ\' && item.Campo.CampoTipo.Codigo!=\'COND\' && item.Campo.CampoTipo.Codigo!=\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!=\'VERSION\' && item.Campo.CampoTipo.Codigo!=\'TEXTENR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.Valor" switcher-language="$ctrl.language" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><label class="col-xs-12 col-md-12 center-label">{{item.Valor}}</label></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-secondary pull-right" style="margin-top: 15px;" ng-click="$ctrl.openLink(item.Valor)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><div trumbowyg-editor="" ng-model="item.ValorObjeto" id="{{item.Campo.Id}}" style="resize: vertical;" name="{{item.Campo.Id}}" enable-bootstrap-title="true"></div></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div><label class="col-xs-12 col-md-12 center-label">{{item.TablaFilas[0].Valor[1]}}</label><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label"><b>{{col.ColumnaCampo.Nombre}}:</b></label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' || col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' || col.ColumnaCampo.CampoTipo.Codigo==\'INT\' || col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><label class="center-label">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{item.TablaFilas[0].Valor[1]|date:\'dd-MM-yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px; color: #757171;" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{item.TablaFilas[0].Valor[1]|date:\'dd-MM-yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img ng-src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div></div><div class="col-md-6" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'"><label class="col-xs-6 col-md-6 center-label" ng-if="item.Campo.CampoTipo.Codigo != \'LINK\'" ng-style="$ctrl.styleFontTitle"><b>{{item.Campo.Nombre}}:</b></label><div class="col-md-6"><div ng-repeat="j in item.ValorObjeto"><label class="col-xs-12 col-md-12 center-label tituloTextColor">{{j.Nombre}}</label><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label><b>{{det.Titulo}}:</b> {{det.Valor}}</label></div></div></div></div></div></div><uib-tabset active="$ctrl.active"><uib-tab index="0" ng-disabled="true"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Campos a Cargar</span> <span ng-if="$ctrl.language == \'ingles\'">Fields to Load</span> <span ng-if="$ctrl.language == \'portugues\'">Campos para Carregar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></uib-tab-heading><div ba-panel="" ba-panel-class="with-scroll" ng-show="$ctrl.anularVista" class="add-top-space"><label class="center-label" ng-show="!$ctrl.viewLoading">{{$ctrl.motivoBloqueo}}</label> <label class="center-label" ng-show="$ctrl.viewLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando datos...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading data...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></label></div><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space" ng-show="!$ctrl.anularVista"><div class="col-md-12" ng-show="$ctrl.isCamposLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div class="col-md-12" ng-if="$ctrl.verTemplate==false"><span ng-if="$ctrl.language == \'espa\xF1ol\'">No permitido.</span> <span ng-if="$ctrl.language == \'ingles\'">Not allowed.</span> <span ng-if="$ctrl.language == \'portugues\'">N\xE3o permitido.</span> <span ng-if="$ctrl.language == \'italiano\'">No permitido.</span></div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.soloLectura==0 && $ctrl.verTemplate!=false"><div ng-repeat="item in $ctrl.camposList" style="clear: both;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}:</b></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" switcher-language="$ctrl.language" ng-if="item.Campo.runProcedure==\'0\'"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-disabled="{{item.Campo.isReadOnly == true}}" ng-model="item.ValorObjeto" spellcheck="true"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-disabled="{{item.Campo.isReadOnly == true}}" ng-model="item.ValorObjeto" cols="40" rows="5">\r\n                                        </textarea></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'INT\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-keydown="$ctrl.evaluatenumber($event)" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)" spellcheck="true"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DECIMAL\'"><input type="text" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-keydown="$ctrl.evaluatenumberDecimal($event)" maxlength="22" style="text-align:right;" ng-focus="item.ValorObjeto = $ctrl.onNumericInputGotFocus(item.ValorObjeto)" ng-blur="item.ValorObjeto = $ctrl.onNumericInputLostFocus(item.ValorObjeto)" spellcheck="true"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="1900-01-01" max="2100-12-31" style="min-height: 35px;"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" min="2001-01-01T00:00:00" style="color: #757171;" max="2013-12-31T00:00:00" readonly=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'BOOL\'"><ba-switcher switcher-style="primary" switcher-value="item.ValorObjeto" switcher-language="$ctrl.language"></ba-switcher></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LIST\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'"><div class="col-md-6" style="margin-bottom: 10px; margin-left: 2px;"><input type="text" class="form-control" ng-model="item.TextoBusqueda" ng-change="$ctrl.onChangeInputCampostList(item.TextoBusqueda, item, item.SourceObjeto[0].JerarquiaPadreId)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar\' : (($ctrl.language == \'ingles\') ? \'Search\' : (($ctrl.language == \'portugues\') ? \'Pesquisar\' : \'Buscar\')) }}" spellcheck="true"></div><ul class="list-group col-md-6"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Para Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">To Select</span> <span ng-if="$ctrl.language == \'portugues\'">Para Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Para Seleccionar</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.SourceObjeto track by j.Id" ng-click="$ctrl.actionAddOnClick(j, item);" style="padding: 2px 2px;" class="list-group-item list-group-item-action"><a class="list-group-item list-group-item-action list-group-item-dark" ng-click="$ctrl.actionAddOnClick(j, item);">{{j.Nombre}}</a></li></div></ul><ul class="list-group col-md-6"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionado</span> <span ng-if="$ctrl.language == \'ingles\'">Selected</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionado</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionado</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action" style="padding: 2px 2px;" ng-click="$ctrl.actionRemoveOnClick(j, item);"><a class="list-group-item list-group-item-action list-group-item-dark">{{j.Nombre}}</a></li></div></ul></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'"><div ng-repeat="j in item.ValorObjeto"><input type="text" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-disabled="{{item.Campo.isReadOnly == true}}" spellcheck="true"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="text-links pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NOTIF\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" required=""> <label class="center-label" style="margin-top:5px"><h6 ng-if="$ctrl.language == \'espa\xF1ol\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6><h6 ng-if="$ctrl.language == \'ingles\'"><u>NOTE</u>: to enter multiple email addresses, separate each with a semicolon (;).</h6><h6 ng-if="$ctrl.language == \'portugues\'"><u>NOTA</u>: para inserir m\xFAltiplos endere\xE7os de e-mail, separe cada um com ponto e v\xEDrgula (;)</h6><h6 ng-if="$ctrl.language == \'italiano\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'USER\'"><div class="col-md-3"><input type="text" spellcheck="true" style="width: 195px;" ng-model="$ctrl.usuarioCargado" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a agregar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to add...\' : (($ctrl.language == \'portugues\') ? \'Insira um usu\xE1rio para adicionar...\' : \'Ingrese un usuario a agregar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" class="form-control" typeahead-on-select="$ctrl.onSelectUsuarioMultiList($index, $model)"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario no encontrado</span></div></div><div class="col-md-9" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" class="text-links" ng-click="$ctrl.onSelectUsuarioMultiList($index, $ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</span> <span ng-if="$ctrl.language == \'ingles\'">Requesting User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario Solicitante:</span> {{$ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.NombreMostrar}}</a></div><div class="table-responsive"><table class="table" style="margin-bottom: 20px;" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="u in item.ValorObjeto"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoUsuario($parent.$index, u.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" ng-init="$ctrl.initListadoProcesos()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione el proceso:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the process:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione o processo:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione el proceso:</span></label><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoSeleccionado" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'Ingrese el proceso a configurar...\')) }}" ng-change="$ctrl.onChangeSelectProcesoSeleccionado($ctrl.procesoSeleccionado)" uib-typeahead="item as item.Nombre for item in $ctrl.searchListadoDeProcesos($viewValue, \'SIMPLE\')" typeahead-wait-ms="500" typeahead-loading="loadingProcesos" typeahead-no-results="noResultsProcesos"> <i ng-show="loadingProcesos" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProcesos"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione la solicitud:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the request:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione a solicita\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione la solicitud:</span></label> <input type="text" spellcheck="true" ng-model="$ctrl.solicitudCargada" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese una Solicitud\' : (($ctrl.language == \'ingles\') ? \'Enter a Request\' : (($ctrl.language == \'portugues\') ? \'Insira uma Solicita\xE7\xE3o\' : \'Ingrese una Solicitud\')) }}" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Solicitud no encontrada</span> <span ng-if="$ctrl.language == \'ingles\'">Request not found</span> <span ng-if="$ctrl.language == \'portugues\'">Solicita\xE7\xE3o n\xE3o encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">Solicitud no encontrada</span></div></div><div class="table-responsive"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" ng-init="$ctrl.initListadoProcesos_doc()"><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione el proceso:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the process:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione o processo:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione el proceso:</span></label><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.procesoSeleccionado_doc" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese el proceso a configurar...\' : (($ctrl.language == \'ingles\') ? \'Enter the process to configure...\' : (($ctrl.language == \'portugues\') ? \'Insira o processo para configurar...\' : \'Ingrese el proceso a configurar...\')) }}" ng-change="$ctrl.onChangeSelectProcesoSeleccionado_doc($ctrl.procesoSeleccionado_doc)" uib-typeahead="item as item.Nombre for item in $ctrl.searchListadoDeProcesos($viewValue, \'DOCUMENTAL\')" typeahead-wait-ms="500" typeahead-loading="loadingProcesos_doc" typeahead-no-results="noResultsProcesos_doc"> <i ng-show="loadingProcesos_doc" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsProcesos_doc"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Proceso no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Process not found</span> <span ng-if="$ctrl.language == \'portugues\'">Processo n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Proceso no encontrado</span></div></div><div class="col-xs-12 col-md-6" style="margin-bottom:20px"><label><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccione la solicitud:</span> <span ng-if="$ctrl.language == \'ingles\'">Select the request:</span> <span ng-if="$ctrl.language == \'portugues\'">Selecione a solicita\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccione la solicitud:</span></label> <input type="text" spellcheck="true" ng-model="$ctrl.solicitudCargada_doc" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese una Solicitud\' : (($ctrl.language == \'ingles\') ? \'Enter a Request\' : (($ctrl.language == \'portugues\') ? \'Insira uma Solicita\xE7\xE3o\' : \'Ingrese una Solicitud\')) }}" uib-typeahead="descripcion as solicitud.Descripcion for solicitud in $ctrl.searchCampoSolicitud_doc($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingSolicitud" typeahead-no-results="noResultsSolicitud" class="form-control" typeahead-editable="false" typeahead-on-select="$ctrl.onSelectSolicitudMultiList_doc($index, $item)"> <i ng-show="loadingSolicitud" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsSolicitud"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Solicitud no encontrada</span> <span ng-if="$ctrl.language == \'ingles\'">Request not found</span> <span ng-if="$ctrl.language == \'portugues\'">Solicita\xE7\xE3o n\xE3o encontrada</span> <span ng-if="$ctrl.language == \'italiano\'">Solicitud no encontrada</span></div></div><div class="table-responsive"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"><a href="" class="text-links" ng-click="$ctrl.deleteCampoSolicitud($parent.$index, obj.Id)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.ValorObjeto)">{{item.ValorObjeto}}</a><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando archivo...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading file...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando arquivo...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando archivo...</span></p></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'"><img ng-src="{{$ctrl.imgFile}}{{item.ValorObjeto}}" height="350" width="350" ng-if="item.ValorObjeto!=\'\' && item.ValorObjeto!=null" style="object-fit: contain"> <input class="btn btn-success editable-table-button btn-xs" id="inputImage{{item.Campo.Id}}" type="file" accept="image/*" image="item.ValorObjetoImgTmp" resize-max-height="500" resize-max-width="500" resize-quality="0.7" resize-type="image/jpg" ng-image-compress="" style="visibility:hidden; display: none;" ng-disabled="$ctrl.isBusy" ngf-select="$ctrl.uploadAttachmentPicture(item.ValorObjetoImgTmp, item)"> <label for="inputImage{{item.Campo.Id}}" class="btn btn-success editable-table-button btn-xs" style="margin: auto; color: #fff;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></label><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Estado.Codigo==\'ALTA\'"><input type="number" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto"></div><div class="col-md-3" ng-if="item.Campo.CampoTipo.Codigo==\'VERSION\' && $ctrl.model.Estado.Codigo!=\'ALTA\'"><inputtype="number" class="col-md-3" min="0" pattern="[0-9]*" ng-keydown="$ctrl.evaluatenumberDigit($event)" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly=""></inputtype="number"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" readonly=""></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-secondary pull-right" style="margin-top: 15px;" ng-click="$ctrl.openLink(item.ValorObjeto);"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><div trumbowyg-editor="" ng-model="item.ValorObjeto" id="{{item.Campo.Id}}" style="resize: vertical;" name="{{item.Campo.Id}}" enable-bootstrap-title="true"></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.TablaFilas[0].Valor[0]" ng-options="j.condicion as j.condicion for j in item.Campo.Columnas" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></select></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" class="form-control" spellcheck="true" name="TEXT" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                </textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" maxlength="22" style="text-align:right;"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="text" class="form-control" spellcheck="true" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputGotFocus(item.TablaFilas[0].Valor[1])" ng-blur="item.TablaFilas[0].Valor[1] = $ctrl.onNumericInputLostFocus(item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTableCond($parent.$parent.$parent.$index, 0, 1,item.TablaFilas[0].Valor[1])"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\' && item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEMPLATE\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-disabled="{{$ctrl.template.isSoloEnvio}}" ng-options="t as t.Template.Nombre for t in item.SourceObjeto track by t.Id"></select></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PERIODO\'"><select name="{{item.Campo.Id}}" class="form-control" ng-model="item.ValorObjeto" ng-options="j as j.Nombre for j in item.SourceObjeto track by j.Id"></select></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'TABLEENR\'"><table class="table campo-tabla cssForTablTableEnr"><thead ng-style="myStyle={ \'height\': item.Campo.encabezadoHeight, \'background-color\': item.Campo.encabezadoColor, \'font-size\': {{item.Campo.encabezadoFontSize}}, \'color\': item.Campo.encabezadoFontColor}"><tr class="sortable center-label cssForTrTableEnr"><th class="text-center" ng-repeat="col in item.Campo.Columnas" style="border-right: 2px solid white" ng-style="myStyleTextHeader={ \'width\': col.encabezadoWidth + \'%\'}"><div style="white-space: normal">{{col.ColumnaCampo.Nombre}}</div></th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas" ng-style="myStyle2={ \'height\': item.Campo.bodyHeight, \'background-color\': item.Campo.bodyColor }"><td align="center" ng-repeat="colValor in fila.Valor track by $index" ng-style="myStyleTd={\'background-color\': item.Campo.bodyColor, \'color\': item.Campo.bodyFontColor}" style="vertical-align: inherit;" class="cssForTdTableEnr"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor }" style="border-bottom: 1px solid #cbcbcb"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" style="border: 1px solid #cbcbcb" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}">\r\n                                                                </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-style="myStyleFonts={\'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index, $parent.$parent.$index, $parent.$index, colValor)" ng-disabled="$index==0 && !item.Campo.permiteEditarColumna" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12 tableenr-overflow tableenr-attach" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'"><a href="" class="text-links col-md-12" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" ngf-select="$ctrl.uploadAttachmentTableEnr( $file, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" ng-click="$ctrl.removeAttachmentTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, $index )" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LINK\'"><button class="btn btn-secondary" style="margin-top: 15px;" ng-click="$ctrl.openLink(colValor)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LIST\'"><label>{{item.Campo.Columnas[$index].ColumnaCampo.Nombre}}</label><select ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-change="$ctrl.onChangeSelectTableEnrList( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select><select ng-if="$index==0 && !item.Campo.permiteEditarColumna" name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-disabled="true" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'JERARQ\'"><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><div ng-repeat="j in colValor"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquiaTableEnr( $parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $index, $model )"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.Columnas[$index].ColumnaCampo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquiaTableEnr( $parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" class="tableenr-jerarquia-onlyread"><div ng-repeat="j in colValor"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'MULTI_LIST\'"><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" class="col-md-12" style="margin: 10px 0"><input type="text" spellcheck="true" class="form-control" ng-model="colValor.TextoBusqueda" ng-change="$ctrl.onChangeInputCampostListTableEnr(colValor.TextoBusqueda, colValor, colValor.SourceObjeto[0].JerarquiaPadreId)" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar\' : (($ctrl.language == \'ingles\') ? \'Search\' : (($ctrl.language == \'portugues\') ? \'Pesquisar\' : \'Buscar\')) }}"></div><ul ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" class="list-group col-md-12 p-0"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Para Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">To Select</span> <span ng-if="$ctrl.language == \'portugues\'">Para Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Para Seleccionar</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="listItem in colValor.SourceObjeto track by $index" ng-click="$ctrl.actionAddOnClickTableEnr(listItem, colValor);" class="list-group-item list-group-item-action" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{listItem.Nombre}}</a></li></div></ul><ul ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" class="list-group col-md-12 p-0"><li class="list-group-item active"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionado</span> <span ng-if="$ctrl.language == \'ingles\'">Selected</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionado</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionado</span></li><div style="min-height: 100px; max-height: 190px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="listItem in colValor.ValorObjeto track by $index" class="list-group-item list-group-item-action" ng-click="$ctrl.actionRemoveOnClickTableEnr(listItem, colValor);" style="padding: 2px 2px;"><a class="list-group-item list-group-item-action list-group-item-dark text-links">{{listItem.Nombre}}</a></li></div></ul><ul class="list-group col-md-12 p-0" ng-if="$index==0 && !item.Campo.permiteEditarColumna"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="j in colValor.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'USER\'"><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" class="col-md-12"><input type="text" spellcheck="true" class="form-control" style="width: 195px;" ng-model="colValor.text" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Ingrese un usuario a agregar...\' : (($ctrl.language == \'ingles\') ? \'Enter a user to add...\' : (($ctrl.language == \'portugues\') ? \'Insira um usu\xE1rio para adicionar...\' : \'Ingrese un usuario a agregar...\')) }}" uib-typeahead="i as i.Login for i in $ctrl.searchCampoUsuario($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingUsuario" typeahead-no-results="noResultsUsuario" typeahead-on-select="$ctrl.onSelectUsuarioMultiListTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 0 )"> <i ng-show="loadingUsuario" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsUsuario"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">User not found</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario no encontrado</span></div></div><div ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna" class="col-md-12" style="margin-top:5px;margin-bottom:20px"><i class="glyphicon glyphicon-info-sign"></i> <a href="" class="text-links" ng-click="$ctrl.onSelectUsuarioMultiListTableEnr( $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor, 99 )"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario Solicitante:</span> <span ng-if="$ctrl.language == \'ingles\'">Requesting User:</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio Solicitante:</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario Solicitante:</span> {{$ctrl.camposList[0].SolicitudProcesoTemplate.Solicitud.UsuarioCreacion.NombreMostrar}}</a></div><table class="table" style="margin-bottom: 20px;"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center" ng-if="$index!=0 || $index==0 && item.Campo.permiteEditarColumna"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="u in $ctrl.camposList[$parent.$parent.$parent.$index].TablaFilas[$parent.$parent.$index].Valor[$parent.$index]"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td><td align="center" ng-if="$parent.$index!=0 || $parent.$index==0 && item.Campo.permiteEditarColumna"><a href="" class="text-links" ng-click="$ctrl.deleteCampoUsuarioTableEnr( $parent.$parent.$parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, u.Id, 0)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></a></td></tr></tbody></table></div></td></tr></tbody></table></div><div style="clear: both;"></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table campo-tabla"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div ng-if="$index==0 && !item.Campo.permiteEditarColumna" id="no_permite_editar_columna"><div class="col-md-12" style="margin-bottom:10px"><label class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}">{{colValor}}</label></div></div><div id="permite_editar_columna" ng-if="$index==0 && item.Campo.permiteEditarColumna"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                                </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" class="text-links" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div></div><div id="permite_editar_columna" ng-if="$index!=0"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)">\r\n                                                                    </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" style="text-align:right;" maxlength="22" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumber($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" style="text-align:right;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)" ng-keydown="$ctrl.evaluatenumberDecimal($event)" ng-focus="colValor = $ctrl.onNumericInputGotFocus(colValor)" ng-blur="colValor = $ctrl.onNumericInputLostFocus(colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$parent.$index, $parent.$parent.$parent.$index, $parent.$parent.$index, colValor)"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a href="" class="text-links" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ngf-accept="\'image/*\'" accept="image/*" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Seleccionar</span> <span ng-if="$ctrl.language == \'ingles\'">Select</span> <span ng-if="$ctrl.language == \'portugues\'">Selecionar</span> <span ng-if="$ctrl.language == \'italiano\'">Seleccionar</span></div><div class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.removeAttachment(item)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></div><p ng-show="item.isLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando Imagen...</span> <span ng-if="$ctrl.language == \'ingles\'">Uploading Image...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando Imagem...</span> <span ng-if="$ctrl.language == \'italiano\'">Cargando Imagen...</span></p></div></div></td></tr></tbody></table></div><br><div style="clear: both;"></div></div></div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.soloLectura==1 && $ctrl.verTemplate==true"><div ng-repeat="item in $ctrl.camposList" style="margin-bottom: 2px;"><div class="col-md-3 center-label cssForCamposLabel" ng-if="item.Campo.CampoTipo.Codigo != \'TITLE\'"><label class="col-md-12 center-label"><b>{{item.Campo.Nombre}}</b></label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TITLE\'" style="text-align: center;"><h3 class="campo-title">{{item.Campo.Nombre}}</h3></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTAREA\'" style="display: inline;"><textarea class="col-md-9 center-label" style="font-weight:normal; margin-left: 0px; padding-left: 0px; border: none; resize: none; width: 100%; background-color: transparent;" rows="7" disabled="disabled">{{item.Valor}}</textarea></div><div ng-if="item.Campo.CampoTipo.Codigo==\'DATE\'" style="display: inline;"><label class="col-md-3 center-label">{{item.Valor | date:\'dd/MM/yyyy\'}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'ATTACH\' && item.Valor != \'\'" style="display: inline;"><a class="col-md-9 text-links" href="" ng-click="$ctrl.openAttachment(item.Valor)">{{item.Valor}}</a></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'IMG\'" style="display: inline;"><img ng-src="{{$ctrl.imgFile}}{{item.Valor}}" height="350" width="350" ng-if="item.Valor!=\'\'"></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'NUMERADOR\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'LINK\'" style="display: inline;"><button class="col-xs-12 col-sm-3 col-md-3 col-lg-2 btn btn-secondary pull-right" style="margin-top: 15px;" ng-click="$ctrl.openLink(item.ValorObjeto);"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'" style="display: inline;"><div ng-bind-html="item.Valor"></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'PROCEDURE\'"><i class="glyphicon glyphicon-cog" style="font-size: 18px;float: left;padding: 9px;"></i></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'" style="display: inline;"><input type="text" spellcheck="true" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[0]" readonly=""></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><input type="text" spellcheck="true" style="color:black" class="form-control" name="{{item.Campo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><textarea class="center-label" style="font-weight:normal; margin-left: 0px; padding-left: 0px; border: none; resize: none; width: 100%; background-color: transparent;" rows="7" disabled="disabled">{{item.TablaFilas[0].Valor[1]}}</textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img ng-src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\'" style="display: inline;"><div style="font-family:inherit; color:black; -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */ -moz-box-sizing: border-box; /* Firefox, other Gecko */ box-sizing: border-box; /* Opera/IE 8+ */ padding:1%; border:none; padding-left: 0px; padding-top: 0px;"><div ng-repeat="j in item.ValorObjeto"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-9 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL\'" style="display: inline;"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'SOLPROCESOSREL_DOCASO\'" style="display: inline;"><table class="table" st-table="item.ValorObjeto"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'ingles\'">Complete Number</span> <span ng-if="$ctrl.language == \'portugues\'">N\xFAmero Completo</span> <span ng-if="$ctrl.language == \'italiano\'">Numero Completo</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre Proceso</span> <span ng-if="$ctrl.language == \'ingles\'">Process Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome do Processo</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre Proceso</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Creaci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Creation Date</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Cria\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Creaci\xF3n</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Descripcion Resumida</span> <span ng-if="$ctrl.language == \'ingles\'">Summary Description</span> <span ng-if="$ctrl.language == \'portugues\'">Descri\xE7\xE3o Resumida</span> <span ng-if="$ctrl.language == \'italiano\'">Descripcion Resumida</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">LINK</span> <span ng-if="$ctrl.language == \'ingles\'">LINK</span> <span ng-if="$ctrl.language == \'portugues\'">LINK</span> <span ng-if="$ctrl.language == \'italiano\'">LINK</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="obj in item.ValorObjeto track by $index"><td align="center">{{obj.NumeroCompleto}}</td><td align="center">{{obj.Proceso.Nombre}}</td><td align="center">{{obj.CreationDate}}</td><td align="center">{{obj.DescripcionResumida}}</td><td align="center"><a class="text-links" href="#/solicitud/edit/{{obj.Id}}/{{obj.Proceso.GrupoId}}/{{obj.Proceso.Id}}/0" target="_blank"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Abrir link</span> <span ng-if="$ctrl.language == \'ingles\'">Open link</span> <span ng-if="$ctrl.language == \'portugues\'">Abrir link</span> <span ng-if="$ctrl.language == \'italiano\'">Abrir link</span></a></td><td align="center"></td></tr></tbody></table></div><div class="col-md-9" ng-if="item.Campo.CampoTipo.Codigo==\'MULTI_LIST\'" style="display: inline;"><ul class="list-group col-md-12" style="margin-bottom: 2px;"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Id}}" ng-model="item.ValorObjeto" ng-repeat="j in item.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'TABLEENR\'"><table class="table campo-tabla cssForTablTableEnr"><thead ng-style="myStyle={ \'height\': item.Campo.encabezadoHeight, \'background-color\': item.Campo.encabezadoColor, \'font-size\': {{item.Campo.encabezadoFontSize}}, \'color\': item.Campo.encabezadoFontColor}"><tr class="sortable center-label cssForTrTableEnr"><th class="text-center" ng-repeat="col in item.Campo.Columnas" style="border-right: 2px solid white" ng-style="myStyleTextHeader={ \'width\': col.encabezadoWidth + \'%\'}"><div style="white-space: normal">{{col.ColumnaCampo.Nombre}}</div></th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas" ng-style="myStyle2={ \'height\': item.Campo.bodyHeight, \'background-color\': item.Campo.bodyColor }"><td align="center" ng-repeat="colValor in fila.Valor track by $index" ng-style="myStyleTd={\'background-color\': item.Campo.bodyColor, \'color\': item.Campo.bodyFontColor}" style="vertical-align: inherit;" class="cssForTdTableEnr"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-disabled="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor }" style="border-bottom: 1px solid #cbcbcb"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px"><textarea spellcheck="true" class="form-control" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" cols="40" rows="5" ng-disabled="true" style="border: 1px solid #cbcbcb" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}">\r\n                                                            </textarea></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-disabled="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control tableenr-input-number" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" maxlength="22" ng-disabled="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-disabled="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-style="myStyleFonts={\'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor" ng-disabled="true" ng-style="myStyleFonts={ \'font-size\': {{item.Campo.bodyFontSize}}, \'color\': item.Campo.bodyFontColor}"></div><div class="col-md-12 tableenr-overflow tableenr-attach" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'"><a href="" class="text-links col-md-12" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LINK\'"><button class="btn btn-secondary" style="margin-top: 15px;" ng-click="$ctrl.openLink(colValor)"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{item.Campo.Nombre}}</button></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'LIST\'"><label>{{item.Campo.Columnas[$index].ColumnaCampo.Nombre}}</label><select name="{{item.Campo.Id}}" class="form-control" ng-model="colValor" ng-disabled="true" ng-options="j as j.Nombre for j in item.Campo.Columnas[$index].SourceObjeto track by j.Id"></select></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'JERARQ\'"><div class="tableenr-jerarquia-onlyread"><div ng-repeat="j in colValor"><label class="center-label" style="font-weight:normal; margin: 2px;">{{j.ValorInput}}</label><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles" style="display: inline;"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'MULTI_LIST\'"><ul class="list-group col-md-12 p-0" ng-if="$index==0 && !item.Campo.permiteEditarColumna"><div style="min-height: 100px; overflow-y: auto;"><li multiple="" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="colValor.ValorObjeto" ng-repeat="j in colValor.ValorObjeto track by j.Id" class="list-group-item list-group-item-action">{{j.Nombre}}</li></div></ul></div><div class="col-md-12 tableenr-overflow" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'USER\'"><table class="table" style="margin-bottom: 20px;"><thead><tr class="sortable"><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th></tr></thead><tbody><tr ng-repeat="u in $ctrl.camposList[$parent.$parent.$parent.$index].TablaFilas[$parent.$parent.$index].Valor[$parent.$index]"><td align="center">{{u.Login}}</td><td align="center">{{u.Nombre}}</td><td align="center">{{u.Apellido}}</td></tr></tbody></table></div></td></tr></tbody></table></div><div class="col-md-12 table-responsive" ng-if="item.Campo.CampoTipo.Codigo==\'TABLE\'"><table class="table"><thead><tr class="sortable center-label"><th class="text-center" ng-repeat="col in item.Campo.Columnas">{{col.ColumnaCampo.Nombre}}</th></tr></thead><tbody><tr ng-repeat="fila in item.TablaFilas"><td align="center" ng-repeat="colValor in fila.Valor track by $index"><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'TEXTAREA\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DATE\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'ATTACH\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'INT\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo!=\'DECIMAL\'">{{colValor}}</div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'INT\' || item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" align="right">{{colValor}}</div><div class="col-md-12" ng-if="colValor!=\'null\' && item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px"><a class="col-md-12 text-links" href="" style="font-weight:normal" ng-click="$ctrl.openAttachment(colValor)">{{colValor}}</a></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px"><img ng-src="{{$ctrl.imgFile}}{{colValor}}" height="350" width="350" ng-if="colValor!=\'\'"></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'TEXTENR\'"><div trumbowyg-editor="" ng-model="colValor" id="{{item.Campo.Id}}" style="resize: vertical;" name="{{item.Campo.Id}}" enable-bootstrap-title="true"></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[0]}}</label></div><div ng-if="item.Campo.CampoTipo.Codigo==\'COND\'"><div ng-repeat="col in item.Campo.Columnas track by $index"><div class="add-top-space col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo != \'TITLE\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label">{{col.ColumnaCampo.Nombre}}:</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXT\'" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion" style="margin-bottom:10px"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><textarea class="center-label" style="font-weight:normal; margin-left: 0px; padding-left: 0px; border: none; resize: none; width: 100%; background-color: transparent;" rows="7" disabled="disabled">{{item.TablaFilas[0].Valor[1]}}</textarea></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'INT\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DECIMAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1]}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><label class="col-md-12 center-label" style="font-weight:normal">{{item.TablaFilas[0].Valor[1] | date:\'dd/MM/yyyy\'}}</label></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'BOOL\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><input type="checkbox" name="{{item.Campo.Columnas[$index].ColumnaCampo.Id}}" ng-model="item.TablaFilas[0].Valor[1]" readonly=""></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'ATTACH\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><a href="" class="text-links" ng-click="$ctrl.openAttachment(item.TablaFilas[0].Valor[1])">{{item.TablaFilas[0].Valor[1]}}</a><div class="btn btn-success editable-table-button btn-xs" ngf-select="$ctrl.uploadAttachment($file, item)" ng-disabled="$ctrl.isBusy"></div></div><div class="col-md-12" ng-if="col.ColumnaCampo.CampoTipo.Codigo==\'IMG\'" style="margin-bottom:10px" ng-show="item.TablaFilas[0].Valor[0] != null && item.TablaFilas[0].Valor[0]==col.condicion"><img ng-src="{{$ctrl.imgFile}}{{item.TablaFilas[0].Valor[1]}}" height="350" width="350" ng-if="item.TablaFilas[0].Valor[1]!=\'\'"></div></div></div><div ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'TEXTAREA\'"><pre class="col-md-12" style="background: transparent; border: transparent; font-family:inherit">{{colValor}}</pre></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATE\'" style="margin-bottom:10px"><input type="date" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="1900-01-01" max="2100-12-31" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index,$parent.$parent.$index,$parent.$index,colValor)" readonly=""></div><div class="col-md-12" ng-if="item.Campo.Columnas[$index].ColumnaCampo.CampoTipo.Codigo==\'DATETIMEREGIONAL\'" style="margin-bottom:10px"><input type="text" spellcheck="true" class="form-control" name="{{item.Campo.Id}}" ng-model="colValor" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" readonly="" style="color: #757171;" ng-change="$ctrl.onChangeInputTable($parent.$parent.$parent.$index,$parent.$parent.$index,$parent.$index,colValor)"></div></td></tr></tbody></table></div><div ng-if="item.Campo.CampoTipo.Codigo!==\'TABLE\' &&item.Campo.CampoTipo.Codigo!==\'TABLEENR\' && item.Campo.CampoTipo.Codigo!==\'TEXTAREA\' && item.Campo.CampoTipo.Codigo!==\'DATE\' && item.Campo.CampoTipo.Codigo!==\'ATTACH\' && item.Campo.CampoTipo.Codigo!==\'COND\' && item.Campo.CampoTipo.Codigo!==\'JERARQ\' && item.Campo.CampoTipo.Codigo!==\'TEXTENR\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL\' && item.Campo.CampoTipo.Codigo!==\'SOLPROCESOSREL_DOCASO\' && item.Campo.CampoTipo.Codigo!==\'NUMERADOR\' && item.Campo.CampoTipo.Codigo!==\'PROCEDURE\' && item.Campo.CampoTipo.Codigo!==\'LINK\' && item.Campo.CampoTipo.Codigo!==\'TITLE\' && item.Campo.CampoTipo.Codigo!==\'IMG\' && item.Campo.CampoTipo.Codigo!==\'MULTI_LIST\'" style="display: inline;"><label class="col-md-9 center-label" style="font-weight:normal">{{item.Valor}}</label></div><div style="clear: both;"></div></div></div><div class="add-top-space col-md-12" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.template.generaProcesosRelacionados"><label class="center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Desea generar automaticamente todos los procesos relacionados?:</span> <span ng-if="$ctrl.language == \'ingles\'">Do you want to automatically generate all related processes?:</span> <span ng-if="$ctrl.language == \'portugues\'">Deseja gerar automaticamente todos os processos relacionados?:</span> <span ng-if="$ctrl.language == \'italiano\'">Desea generar automaticamente todos los procesos relacionados?:</span></label></div><div class="col-md-12" ng-if="$ctrl.solicitudHasProceduresField && !$ctrl.template.generaProcesosRelacionados"><ba-switcher switcher-style="primary" switcher-value="$ctrl.generaProcesoRelacionados" switcher-language="$ctrl.language"></ba-switcher></div></div></uib-tab><uib-tab index="1" ng-disabled="true" ng-if="$ctrl.solicitudProcesoTemplateId!=0 && $ctrl.allowToAutoriceA" ng-show="!$ctrl.anularVista"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizaci\xF3n A</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization A</span> <span ng-if="$ctrl.language == \'portugues\'">Autoriza\xE7\xE3o A</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizaci\xF3n A</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Mensaje de la Autorizaci\xF3n\' : (($ctrl.language == \'ingles\') ? \'Authorization Message\' : (($ctrl.language == \'portugues\') ? \'Mensagem da Autoriza\xE7\xE3o\' : \'Mensaje de la Autorizaci\xF3n\')) }}" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios*:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments*:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios*:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios*:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarActionTemplate(1)" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizar</span> <span ng-if="$ctrl.language == \'ingles\'">Authorize</span> <span ng-if="$ctrl.language == \'portugues\'">Autorizar</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizar</span></button></div></div></div></uib-tab><uib-tab index="2" heading="Autorizaci\xF3n B" ng-disabled="true" ng-if="$ctrl.solicitudProcesoTemplateId!=0 && $ctrl.allowToAutoriceB" ng-show="!$ctrl.anularVista"><uib-tab-heading><span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizaci\xF3n B</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization B</span> <span ng-if="$ctrl.language == \'portugues\'">Autoriza\xE7\xE3o B</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizaci\xF3n B</span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Mensaje de la Autorizaci\xF3n\' : (($ctrl.language == \'ingles\') ? \'Authorization Message\' : (($ctrl.language == \'portugues\') ? \'Mensagem da Autoriza\xE7\xE3o\' : \'Mensaje de la Autorizaci\xF3n\')) }}" ba-panel-class="with-scroll"><div class="col-md-12"><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios*:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments*:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios*:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios*:</span></label><div class="col-md-12"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.AutorizarMsg" name="" required=""></div><div class="col-md-12"><button class="btn btn-success pull-right col-md-2" ng-click="$ctrl.AutorizarActionTemplate(0)" ng-disabled="$ctrl.isBusy" style="margin-left: 2px;font-size: 15px; margin-top: 8px;"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Autorizar</span> <span ng-if="$ctrl.language == \'ingles\'">Authorize</span> <span ng-if="$ctrl.language == \'portugues\'">Autorizar</span> <span ng-if="$ctrl.language == \'italiano\'">Autorizar</span></button></div></div></div></uib-tab><uib-tab index="3" id="notificaciones-tab" title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Notificar Usuarios\' : (($ctrl.language == \'ingles\') ? \'Notify Users\' : (($ctrl.language == \'portugues\') ? \'Notificar Usu\xE1rios\' : \'Notificar Usuarios\')) }}" ng-disabled="true" ng-if="$ctrl.soloLectura==0" ng-show="!$ctrl.anularVista"><uib-tab-heading><span class="ion-android-notifications ion-2x" aria-hidden="true"></span></uib-tab-heading><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Mensaje de la Notificaci\xF3n\' : (($ctrl.language == \'ingles\') ? \'Notification Message\' : (($ctrl.language == \'portugues\') ? \'Mensagem da Notifica\xE7\xE3o\' : \'Mensaje de la Notificaci\xF3n\')) }}" ba-panel-class="with-scroll"><textarea spellcheck="true" class="form-control" ng-model="$ctrl.mensajeNotificacionTab" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Escriba el mensaje que ser\xE1 entregado con la notificaci\xF3n...\' : (($ctrl.language == \'ingles\') ? \'Write the message that will be delivered with the notification...\' : (($ctrl.language == \'portugues\') ? \'Escreva a mensagem que ser\xE1 enviada com a notifica\xE7\xE3o...\' : \'Escriba el mensaje que ser\xE1 entregado con la notificaci\xF3n...\')) }}" cols="40" rows="5">\r\n                            </textarea></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Usuarios del Proceso Disponibles para ser Notificados\' : (($ctrl.language == \'ingles\') ? \'Available Process Users for Notification\' : (($ctrl.language == \'portugues\') ? \'Usu\xE1rios do Processo Dispon\xEDveis para ser Notificados\' : \'Usuarios del Proceso Disponibles para ser Notificados\')) }}" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoUsuariosDS" st-safe-src="$ctrl.procesoUsuariosList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span></th><th class="text-center" st-sort="Usuario.Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center" st-sort="Usuario.Apellido"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Rol</span> <span ng-if="$ctrl.language == \'ingles\'">Role</span> <span ng-if="$ctrl.language == \'portugues\'">Fun\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Rol</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por usuario\' : (($ctrl.language == \'ingles\') ? \'Search by user\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'Buscar por usuario\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por nombre\' : (($ctrl.language == \'ingles\') ? \'Search by name\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por nome\' : \'Buscar por nombre\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Apellido" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por apellido\' : (($ctrl.language == \'ingles\') ? \'Search by lastname\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por sobrenome\' : \'Buscar por apellido\')) }}" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isProcesoUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosDS" ng-click="$ctrl.addUsuarioTabNotificar(item)" style="cursor: pointer"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{item.Usuario.Nombre}}</td><td align="center">{{item.Usuario.Apellido}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><a href="" class="text-links" ng-click="$ctrl.addUsuarioTabNotificar(item)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Notificar</span> <span ng-if="$ctrl.language == \'ingles\'">Notify</span> <span ng-if="$ctrl.language == \'portugues\'">Notificar</span> <span ng-if="$ctrl.language == \'italiano\'">Notificar</span></a></td></tr></tbody><tbody ng-show="$ctrl.isProcesoUsuarioSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Usuarios a Notificar\' : (($ctrl.language == \'ingles\') ? \'Users to Notify\' : (($ctrl.language == \'portugues\') ? \'Usu\xE1rios a Notificar\' : \'Usuarios a Notificar\')) }}" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.procesoUsuariosNotifcarDS" st-safe-src="$ctrl.procesoUsuariosNotificarTabList"><thead><tr class="sortable"><th class="text-center" st-sort="Usuario.Login"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Usuario</span> <span ng-if="$ctrl.language == \'ingles\'">User</span> <span ng-if="$ctrl.language == \'portugues\'">Usu\xE1rio</span> <span ng-if="$ctrl.language == \'italiano\'">Usuario</span></th><th class="text-center" st-sort="Usuario.Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center" st-sort="Usuario.Apellido"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Rol</span> <span ng-if="$ctrl.language == \'ingles\'">Role</span> <span ng-if="$ctrl.language == \'portugues\'">Fun\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Rol</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Login" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por usuario\' : (($ctrl.language == \'ingles\') ? \'Search by user\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por usu\xE1rio\' : \'Buscar por usuario\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por nombre\' : (($ctrl.language == \'ingles\') ? \'Search by name\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por nome\' : \'Buscar por nombre\')) }}" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Usuario.Apellido" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por apellido\' : (($ctrl.language == \'ingles\') ? \'Search by lastname\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por sobrenome\' : \'Buscar por apellido\')) }}" aria-describedby="basic-addon1"></div></th><th></th><th></th></tr></thead><tbody ng-show="!$ctrl.isProcesoUsuarioSearching"><tr ng-repeat="item in $ctrl.procesoUsuariosNotificarDS"><td align="center">{{item.Usuario.Login}}</td><td align="center">{{item.Usuario.Nombre}}</td><td align="center">{{item.Usuario.Apellido}}</td><td align="center">{{$ctrl.concatRolesString(item.RolProcesoList)}}</td><td align="center"><a href="" class="text-links" ng-click="$ctrl.removeUsuarioTabNotificar($index)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Eliminar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir</span> <span ng-if="$ctrl.language == \'italiano\'">Eliminar</span></a></td></tr></tbody><tbody ng-show="$ctrl.isProcesoUsuarioSearching"><tr><td colspan="5" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="5" class="text-center"><div st-pagination="" st-items-by-page="50" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Destinatarios Externos\' : (($ctrl.language == \'ingles\') ? \'External Recipients\' : (($ctrl.language == \'portugues\') ? \'Destinat\xE1rios Externos\' : \'Destinatarios Externos\')) }}" ba-panel-class="with-scroll"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.mailsAdicionalesTab"> <label class="center-label" style="margin-top:5px"><h6 ng-if="$ctrl.language == \'espa\xF1ol\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6><h6 ng-if="$ctrl.language == \'ingles\'"><u>NOTE</u>: To enter multiple email addresses, separate each with a semicolon (;).</h6><h6 ng-if="$ctrl.language == \'portugues\'"><u>NOTA</u>: para inserir m\xFAltiplos endere\xE7os de e-mail, separe cada um com ponto e v\xEDrgula (;).</h6><h6 ng-if="$ctrl.language == \'italiano\'"><u>NOTA</u>: para ingresar m\xFAltiples direcciones de mail, separe cada una con punto y coma (;).</h6></label></div></uib-tab></uib-tabset></div></form></div><div class="col-md-12"><button class="btn btn-success" ng-show="$ctrl.soloLectura==0 && !$ctrl.anularVista" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cerrar</span> <span ng-if="$ctrl.language == \'ingles\'">Close</span> <span ng-if="$ctrl.language == \'portugues\'">Fechar</span> <span ng-if="$ctrl.language == \'italiano\'">Cerrar</span></button><button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.puedeBorrarTemplate && !$ctrl.anularVista"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar Gesti\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Delete Management</span> <span ng-if="$ctrl.language == \'portugues\'">Excluir Gest\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Borrar Gesti\xF3n</span></button> <button class="btn btn-success" ng-show="$ctrl.showBtnLink" ng-disabled="$ctrl.isBusy" ng-click="$ctrl.openLinkTemplate()"><span class="glyphicon glyphicon-link" aria-hidden="true"></span> {{$ctrl.LinkTemplate.TipoCampo}}</button></div></div>');
$templateCache.put('app/pages/template/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="templates"><form editable-form="" name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><uib-tabset active="$ctrl.active"><uib-tab index="0" heading="Datos de la Gesti\xF3n" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">C\xF3digo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Codigo" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el c\xF3digo.</span></div></div><label class="col-md-2 center-label">Nombre*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" name="" placeholder="" required="" ng-change="$ctrl.actualizarTitulo()"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre.</span></div></div><label class="col-md-2 center-label" title="tiempo en segundos">Temporizador Autoguardado (s):</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.temporizadorGuardar" name="name" placeholder="" onkeypress="return event.charCode >= 48 && event.charCode <= 57"></div><label class="col-md-2 center-label">Activo*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.Activo"></ba-switcher></div><label class="col-md-2 center-label">Permite Editar*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.PermiteEditarTemplate"></ba-switcher></div><label class="col-md-2 center-label">Tiene Procedimiento Refresh?:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.tieneProcedimientoRefresh"></ba-switcher></div><label class="col-md-2 center-label" ng-show="$ctrl.model.tieneProcedimientoRefresh">Nombre Procedimiento Refresh*:</label><div class="col-md-4" style="margin-bottom:25px" ng-show="$ctrl.model.tieneProcedimientoRefresh"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.procedimientoRefresh" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el nombre del procedimiento.</span></div></div><label class="col-md-2 center-label">Desea generar autom\xE1ticamente todos los procesos relacionados?:</label><div class="col-md-4" style="margin-bottom:25px"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.generaProcesosRelacionados"></ba-switcher></div><label class="col-md-12 center-label">Configuraci\xF3n de T\xEDtulo*: <a href="" class="text-links" style="margin-left:5px" ng-click="$ctrl.showTituloConfigText = !$ctrl.showTituloConfigText"><i class="fa fa-eye"></i></a></label><div class="col-md-12" ng-show="!$ctrl.showTituloConfigText"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.ConfiguracionTitulo" placeholder="" id="configuracionTitulo" ng-change="$ctrl.actualizarTituloConfigText()" ng-model-options="{ debounce: 1500 }"></div><label class="col-md-12 center-label" ng-show="$ctrl.showTituloConfigText" style="margin-top: 0px">{{$ctrl.configuracionTituloText}}</label><div class="col-md-12" style="margin-top:5px"><a href="" class="text-links" ng-click="$ctrl.buscarCampoTitulo(!$ctrl.showCampoTituloSelect)"><i class="ion-ios-search-strong"></i> Incluir campo de la gesti\xF3n</a></div><div class="col-md-12"><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.tieneAutorizacionA" name="" ng-disabled="$ctrl.isBusy"> Tiene Autorizaci\xF3n A</div><div ng-show="$ctrl.model.tieneAutorizacionA"><label class="col-md-2 center-label">Autorizaci\xF3n A:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosAutorizaA" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div><div class="col-md-12"><div class="col-md-6" style="margin-top:10px"><input type="checkbox" ng-model="$ctrl.model.tieneAutorizacionB" name="" ng-disabled="$ctrl.isBusy"> Tiene Autorizaci\xF3n B</div><div ng-show="$ctrl.model.tieneAutorizacionB"><label class="col-md-2 center-label">Autorizaci\xF3n B:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosAutorizaB" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div><div class="col-md-4" ng-show="$ctrl.showCampoTituloSelect"><select name="" class="form-control" ng-model="$ctrl.campoTituloSeleccionado" ng-options="item as item.Campo.Nombre for item in $ctrl.templateCamposList track by item.Campo.Id" ng-change="$ctrl.onSelectCampoTitulo($ctrl.campoTituloSeleccionado)"><option value="" disabled="" selected="">Seleccione un campo...</option></select></div></div><div ba-panel="" ba-panel-title="Grupo de Usuarios" ba-panel-class="with-scroll"><div class="col-md-12" style="margin-top:10px"><label class="col-md-2 center-label">Creaci\xF3n:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosCreacion" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div><label class="col-md-2 center-label">Lectura:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosLectores" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div><div class="col-md-12" style="margin-top:10px"><label class="col-md-2 center-label">Notificaci\xF3n:</label><div class="col-md-4"><select name="grupo" class="form-control" ng-model="$ctrl.model.gUsuariosNotificacion" ng-options="item.Id as item.Nombre for item in $ctrl.GruposUsuariosList"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un grupo.</span></div></div></div></div></uib-tab><uib-tab index="1" heading="Campos de Gesti\xF3n" ng-disabled="true"><div ba-panel="" ba-panel-title="Datos del Campo" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label">Campo*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.campoCargado.Campo" placeholder="Ingrese el campo a configurar..." uib-typeahead="campo as campo.Nombre for campo in $ctrl.searchCampo($viewValue)" typeahead-wait-ms="500" typeahead-loading="loadingCampo" typeahead-no-results="noResultsCampo"> <i ng-show="loadingCampo" class="glyphicon glyphicon-refresh"></i><div ng-show="noResultsCampo"><i class="glyphicon glyphicon-remove"></i> Campo no encontrado</div></div><label class="col-md-2 center-label">Orden*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" name="" ng-model="$ctrl.campoCargado.Orden" onkeypress="return event.charCode >= 48 && event.charCode <= 57" maxlength="8"></div><label class="col-md-2 center-label">Obligatorio*:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.campoCargado.Obligatorio"></ba-switcher></div><div class="col-md-12"><button class="btn btn-warning" ng-click="$ctrl.clearCampo()" ng-disabled="$ctrl.isBusy">Limpiar</button> <button class="btn btn-success pull-right" ng-click="$ctrl.editCampo(form)" ng-disabled="$ctrl.isBusy">Guardar</button></div></div><div ba-panel="" ba-panel-title="Campos Cargados" ba-panel-class="with-scroll"><div class="table-responsive"><table class="table" st-table="$ctrl.templateCamposDS" st-safe-src="$ctrl.templateCamposList"><thead><tr class="sortable"><th class="text-center">Nombre</th><th class="text-center">Tipo</th><th class="text-center" st-sort-default="true">Orden</th><th class="text-center">Obligatorio</th><th class="text-center">Acciones</th></tr><tr><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Campo.CampoTipo.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo de campo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Orden" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por orden" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.templateCamposDS" ng-click="$ctrl.cargarCampo(item)" style="cursor: pointer"><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td><td align="center">{{item.Orden}}</td><td align="center"><i class="fa fa-check" style="color:green" ng-show="item.Obligatorio"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Obligatorio"></i></td><td align="center"><button class="btn btn-success editable-table-button btn-xs" ng-click="$ctrl.cargarCampo(item)" ng-disabled="$ctrl.isBusy">Ver</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="$ctrl.eliminarCampo($index)" ng-disabled="$ctrl.isBusy">Eliminar</button></td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></uib-tab><uib-tab index="2" heading="Tipo de Gesti\xF3n" select="$ctrl.loadTipoTemplateTab()" ng-disabled="true"><div ba-panel="" ba-panel-class="with-scroll" class="add-top-space"><div class="col-md-12"><label class="col-md-2 center-label">Tipo*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.model.TipoTemplate" ng-options="item as item.Nombre for item in $ctrl.tipoTemplateList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un tipo.</span></div></div><label class="col-md-2 center-label">Es Gesti\xF3n de solo envio:</label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.isSoloEnvio"></ba-switcher></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'ENVIO_MAIL\'"><label class="col-md-2 center-label">Destinatario:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoDestinatario" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoMensaje" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo mensaje.</span></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'CREA_NOTI_DOC\'"><label class="col-md-2 center-label">Destinatario:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoDestinatario" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoEnvioMailConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.CuerpoMensaje" name="" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe completar el cuerpo del mensaje.</span></div></div><div class="col-md-12"><label class="col-md-2 center-label">Se envia a todos los usuarios del proceso?*:</label><div class="col-md-4"><label ng-if="$ctrl.model.enviotodos">S\xED</label> <label ng-if="!$ctrl.model.enviotodos">No</label></div><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.enviotodos"></ba-switcher></div></div><div class="col-md-12"><label class="col-md-2 center-label">Se envia a todos los usuarios del sistema?*:</label><div class="col-md-4"><label ng-if="$ctrl.model.enviosistema">S\xED</label> <label ng-if="!$ctrl.model.enviosistema">No</label></div><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.enviosistema"></ba-switcher></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'HAB_USUARIO\'"><label class="col-md-2 center-label">Usuario a Habilitar*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoUsuarioHabilitar" ng-options="item as item.Nombre for item in $ctrl.camposUsuarioList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo usuario a habilitar.</span></div></div><label class="col-md-2 center-label">Gesti\xF3n a Habilitar*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoTemplatesHabilitar" ng-options="item as item.Nombre for item in $ctrl.camposTemplateList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo gesti\xF3n a habilitar.</span></div></div><label class="col-md-12 center-label" style="margin-top: 30px">Datos propios de la notificaci\xF3n que se enviar\xE1 cuando se habilite la gesti\xF3n:</label> <label class="col-md-2 center-label">Copia:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoCopia" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Asunto:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoAsunto" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Mensaje*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoHabilitacionUsuarioConfig.CampoMensaje" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required">Debe seleccionar un campo mensaje.</span></div></div></div><div class="col-md-12" ng-if="$ctrl.model.TipoTemplate.Codigo == \'RECURSIVO\'"><label class="col-md-2 center-label">Condici\xF3n*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoCondicion" ng-options="item as item.Nombre for item in $ctrl.camposBasicosList track by item.Id"></select></div><label class="col-md-2 center-label">Valor de Condici\xF3n*:</label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.ValorCondicion" name="" placeholder=""></div><label class="col-md-2 center-label">Fecha Inicial*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoFechaInicia" ng-options="item as item.Nombre for item in $ctrl.camposFechaList track by item.Id"></select></div><label class="col-md-2 center-label">Periodicidad*:</label><div class="col-md-4"><select name="" class="form-control" ng-model="$ctrl.tipoRecursivoConfig.CampoPeriodicidad" ng-options="item as item.Nombre for item in $ctrl.camposPeriodoList track by item.Id"></select></div><label class="col-md-12 center-label">Campos a Repetir:</label><div class="table-responsive"><table class="table" st-table="$ctrl.templateCamposList"><thead><tr class="sortable"><th class="text-center">Seleccionado</th><th class="text-center">Campo</th><th class="text-center">Tipo</th></tr></thead><tbody ng-show="!$ctrl.isCampoSearching"><tr ng-repeat="item in $ctrl.templateCamposList"><td align="center"><input type="checkbox" ng-model="item.Campo.Seleccionado" name="" ng-disabled="$ctrl.isBusy"></td><td align="center">{{item.Campo.Nombre}}</td><td align="center">{{item.Campo.CampoTipo.Nombre}}</td></tr></tbody><tbody ng-show="$ctrl.isCampoSearching"><tr><td colspan="4" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div></div></div></uib-tab></uib-tabset><div class="col-md-12"><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy">Guardar</button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy">Cancelar</button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete">Borrar</button></div></div></form></div>');
$templateCache.put('app/pages/template/list.template.html','<div class="col-md-12" ng-if="$ctrl.anularVista"><h5>No tiene permisos para visualizar esta vista.</h5></div><div class="add-row-editable-table" ng-if="!$ctrl.anularVista"><button class="btn btn-secondary" ng-click="$ctrl.add()">Agregar</button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList" ng-if="!$ctrl.anularVista"><thead><tr class="sortable row"><th class="text-center col-xs-2 col-sm-2" st-sort="Codigo">C\xF3digo</th><th class="text-center col-xs-4 col-sm-4" st-sort="Nombre">Nombre</th><th class="text-center col-xs-2 col-sm-2" st-sort="Activo">Activo</th><th class="text-center col-xs-2 col-sm-2" st-sort="TipoTemplate.Nombre">Tipo</th><th class="text-center col-xs-2 col-sm-2">Datos</th></tr><tr class="row"><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Codigo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por c\xF3digo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por nombre" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Activo" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por activo" aria-describedby="basic-addon1"></div></th><th><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="TipoTemplate.Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="Buscar por tipo" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-2 col-sm-2">{{item.Codigo}}</td><td align="center" class="col-xs-4 col-sm-4">{{item.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2"><i class="fa fa-check" style="color:green" ng-show="item.Activo"></i> <i class="fa fa-times" style="color:red" ng-hide="item.Activo"></i></td><td align="center" class="col-xs-2 col-sm-2">{{item.TipoTemplate.Nombre}}</td><td align="center" class="col-xs-2 col-sm-2"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links">Ver</a> <a href="{{item.UrlLink}}" target="_blank">{{item.NombreLink}}</a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="5" class="text-center">Cargando...</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/usuario/edit.template.html','<div ba-panel="" ba-panel-title="{{$ctrl.title}}" ba-panel-class="with-scroll" id="usuarios"><form name="form" novalidate=""><div class="form-group" ng-class="{ \'has-error\': form.name.$invalid && (form.name.$dirty || $ctrl.showError) }"><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos de Conexi\xF3n\' : (($ctrl.language == \'ingles\') ? \'Connection Data\' : (($ctrl.language == \'portugues\') ? \'Dados de Conex\xE3o\' : \'italiano\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre de Usuario*:</span> <span ng-if="$ctrl.language == \'ingles\'">User name*:</span> <span ng-if="$ctrl.language == \'portugues\'">Nome de usu\xE1rio*:</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre de Usuario*:</span></label><div class="col-md-10"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Login" name="login" placeholder="" required="" ng-disabled="!$ctrl.lsuarioLogueadoIsSysAdmin"><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe completar el nombre de usuario.</span> <span ng-if="$ctrl.language == \'ingles\'">You must fill in the username.</span> <span ng-if="$ctrl.language == \'portugues\'">Deve preencher o nome de usu\xE1rio.</span> <span ng-if="$ctrl.language == \'italiano\'">Debe completar el nombre de usuario.</span></span></div><br></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Contrase\xF1a*:</span> <span ng-if="$ctrl.language == \'ingles\'">Password*:</span> <span ng-if="$ctrl.language == \'portugues\'">Senha*:</span> <span ng-if="$ctrl.language == \'italiano\'">Contrase\xF1a*:</span></label><div class="col-md-4"><input type="password" class="form-control" ng-model="$ctrl.model.Clave" name="clave" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe completar la contrase\xF1a.</span> <span ng-if="$ctrl.language == \'ingles\'">You must fill in the password</span> <span ng-if="$ctrl.language == \'portugues\'">Deve preencher a senha</span> <span ng-if="$ctrl.language == \'italiano\'">Debe completar la contrase\xF1a.</span></span></div><br></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Confirmar Contrase\xF1a*:</span> <span ng-if="$ctrl.language == \'ingles\'">Confirm Password*:</span> <span ng-if="$ctrl.language == \'portugues\'">Confirmar Senha*:</span> <span ng-if="$ctrl.language == \'italiano\'">Confirmar Contrase\xF1a*:</span></label><div class="col-md-4"><input type="password" class="form-control" ng-model="$ctrl.model.ConfirmaClave" name="clave" placeholder="" required=""><div ng-messages="form.name.$error" role="alert"><span class="help-block error-block basic-block" ng-message="required"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Debe completar la confirmaci\xF3n de la contrase\xF1a</span> <span ng-if="$ctrl.language == \'ingles\'">You must complete password confirmation.</span> <span ng-if="$ctrl.language == \'portugues\'">Deve concluir a confirma\xE7\xE3o da senha</span> <span ng-if="$ctrl.language == \'italiano\'">Debe completar la confirmaci\xF3n de la contrase\xF1a</span></span></div><br></div><label class="col-md-12 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Roles*:</span> <span ng-if="$ctrl.language == \'ingles\'">Roles*:</span> <span ng-if="$ctrl.language == \'portugues\'">Fun\xE7\xF5es*:</span> <span ng-if="$ctrl.language == \'italiano\'">Roles*:</span></label><div class="col-md-12"><select multiple="" name="roles" class="form-control" ng-model="$ctrl.rolesSeleccionados" ng-options="item as item.Nombre for item in $ctrl.rolesList track by item.Id" ng-disabled="!$ctrl.lsuarioLogueadoIsSysAdmin"></select></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos del Usuario\' : (($ctrl.language == \'ingles\') ? \'User Data\' : (($ctrl.language == \'portugues\') ? \'Dados do Usu\xE1rio\' : \'Datos del Usuario\')) }}" ba-panel-class="with-scroll" class="add-top-space"><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre:</span> <span ng-if="$ctrl.language == \'ingles\'">Name:</span> <span ng-if="$ctrl.language == \'portugues\'">Nome:</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Nombre" name="name" placeholder=""><br></div><label class="col-md-2 center-label"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido:</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname:</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome:</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido:</span></label><div class="col-md-4"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.model.Apellido" name="apellido" placeholder=""><br></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos de Contacto\' : (($ctrl.language == \'ingles\') ? \'Contact Data\' : (($ctrl.language == \'portugues\') ? \'Dados de Contato\' : \'Datos de Contacto\')) }}" ba-panel-class="with-scroll"><label class="col-md-2 center-label" style="margin-top:10px"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo Electr\xF3nico*:</span> <span ng-if="$ctrl.language == \'ingles\'">Email Address*:</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico*:</span> <span ng-if="$ctrl.language == \'italiano\'">Correo Electr\xF3nico*:</span></label><div class="col-md-8"><input type="text" spellcheck="true" class="form-control" ng-model="$ctrl.mailIngresado"></div><button class="btn btn-primary" ng-click="$ctrl.addMail()" style="margin-bottom:20px"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button><div class="table-responsive"><table class="table" st-table="$ctrl.model.Mails"><thead><tr><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Correo Electr\xF3nico</span> <span ng-if="$ctrl.language == \'ingles\'">Email Address</span> <span ng-if="$ctrl.language == \'portugues\'">Correio eletr\xF4nico</span> <span ng-if="$ctrl.language == \'italiano\'">Correo Electr\xF3nico</span></th><th class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Acci\xF3n</span> <span ng-if="$ctrl.language == \'ingles\'">Action</span> <span ng-if="$ctrl.language == \'portugues\'">A\xE7\xE3o</span> <span ng-if="$ctrl.language == \'italiano\'">Acci\xF3n</span></th></tr></thead><tbody><tr ng-repeat="item in $ctrl.model.Mails"><td align="center">{{item.Mail}}</td><td align="center"><button class="btn btn-danger editable-table-button btn-xs" ng-disabled="$ctrl.isBusy" ng-click="$ctrl.eliminarMail($index)"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Quitar</span> <span ng-if="$ctrl.language == \'ingles\'">Remove</span> <span ng-if="$ctrl.language == \'portugues\'">Remover</span> <span ng-if="$ctrl.language == \'italiano\'">Quitar</span></button></td></tr></tbody></table></div></div><div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Permisos a nivel de usuario\' : (($ctrl.language == \'ingles\') ? \'User level permissions\' : (($ctrl.language == \'portugues\') ? \'Permiss\xF5es em n\xEDvel de usu\xE1rio\' : \'Permisos a nivel de usuario\')) }}" ba-panel-class="with-scroll" class="add-top-space"><div layout="row" layout-sm="row" layout-align="start end" layout-xs="row"><label class="col-md-2 center-label" style="margin-top:25px"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Puede crear Procesos</span> <span ng-if="$ctrl.language == \'ingles\'">Can create Processes</span> <span ng-if="$ctrl.language == \'portugues\'">Pode criar Processos</span> <span ng-if="$ctrl.language == \'italiano\'">Puede crear Procesos</span></label><div class="col-md-4"><ba-switcher switcher-style="primary" switcher-value="$ctrl.model.CanCreateProcess" switcher-language="$ctrl.language"></ba-switcher></div></div></div><div class="col-md-12"><br><button class="btn btn-success" ng-click="$ctrl.save(form)" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Guardar</span> <span ng-if="$ctrl.language == \'ingles\'">Save</span> <span ng-if="$ctrl.language == \'portugues\'">Salvar</span> <span ng-if="$ctrl.language == \'italiano\'">Guardar</span></button> <button class="btn btn-danger" ng-click="$ctrl.cancel()" ng-disabled="$ctrl.isBusy"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cancelar</span> <span ng-if="$ctrl.language == \'ingles\'">Cancel</span> <span ng-if="$ctrl.language == \'portugues\'">Cancelar</span> <span ng-if="$ctrl.language == \'italiano\'">Cancelar</span></button> <button class="btn btn-danger pull-right" ng-click="$ctrl.delete()" ng-disabled="$ctrl.isBusy" ng-show="$ctrl.showDelete"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Borrar</span> <span ng-if="$ctrl.language == \'ingles\'">Delete</span> <span ng-if="$ctrl.language == \'portugues\'">Apagar</span> <span ng-if="$ctrl.language == \'italiano\'">italiano</span></button></div></div></form></div>');
$templateCache.put('app/pages/usuario/list.template.html','<div class="add-row-editable-table" ng-if="$ctrl.lsuarioLogueadoIsSysAdmin"><button class="btn btn-secondary" ng-click="$ctrl.add()"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Agregar</span> <span ng-if="$ctrl.language == \'ingles\'">Add</span> <span ng-if="$ctrl.language == \'portugues\'">Adicionar</span> <span ng-if="$ctrl.language == \'italiano\'">Italiano</span></button></div><div class="table-responsive"><table class="table" st-pipe="$ctrl.buscar" st-table="$ctrl.resultList"><thead><tr class="sortable row"><th class="text-center col-xs-3 col-sm-3" st-sort="Login"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Login</span> <span ng-if="$ctrl.language == \'ingles\'">Login</span> <span ng-if="$ctrl.language == \'portugues\'">Login</span> <span ng-if="$ctrl.language == \'italiano\'">Login</span></th><th class="text-center col-xs-3 col-sm-3" st-sort="Nombre"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Nombre</span> <span ng-if="$ctrl.language == \'ingles\'">Name</span> <span ng-if="$ctrl.language == \'portugues\'">Nome</span> <span ng-if="$ctrl.language == \'italiano\'">Nombre</span></th><th class="text-center col-xs-3 col-sm-3" st-sort="Apellido"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Apellido</span> <span ng-if="$ctrl.language == \'ingles\'">Lastname</span> <span ng-if="$ctrl.language == \'portugues\'">Sobrenome</span> <span ng-if="$ctrl.language == \'italiano\'">Apellido</span></th><th class="text-center col-xs-3 col-sm-3"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Datos</span> <span ng-if="$ctrl.language == \'ingles\'">Data</span> <span ng-if="$ctrl.language == \'portugues\'">Dados</span> <span ng-if="$ctrl.language == \'italiano\'">Datos</span></th></tr><tr class="row"><th class="col-xs-3 col-sm-3"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Login" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por login\' : (($ctrl.language == \'ingles\') ? \'Search by login\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por login\' : \'Buscar por login\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-xs-3 col-sm-3"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Nombre" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por nombre\' : (($ctrl.language == \'ingles\') ? \'Search by name\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por nome\' : \'Buscar por nombre\')) }}" aria-describedby="basic-addon1"></div></th><th class="col-xs-3 col-sm-3"><div class="input-group search-field"><span class="input-group-addon input-group-addon-default addon-left" id="basic-addon1"><i class="fa fa-search"></i></span> <input st-search="Apellido" spellcheck="true" type="search" class="input-sm form-control with-primary-addon" placeholder="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Buscar por apellido\' : (($ctrl.language == \'ingles\') ? \'Search by lastname\' : (($ctrl.language == \'portugues\') ? \'Pesquisar por sobrenome\' : \'Buscar por login\')) }}" aria-describedby="basic-addon1"></div></th><th></th></tr></thead><tbody ng-show="!$ctrl.isSearching"><tr ng-repeat="item in $ctrl.resultList" ng-click="$ctrl.edit(item.Id)" style="cursor: pointer" class="row"><td align="center" class="col-xs-3 col-sm-3">{{item.Login}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.Nombre}}</td><td align="center" class="col-xs-3 col-sm-3">{{item.Apellido}}</td><td align="center" class="col-xs-3 col-sm-3"><a href="" ng-click="$ctrl.edit(item.Id)" class="text-links"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Ver</span> <span ng-if="$ctrl.language == \'ingles\'">View</span> <span ng-if="$ctrl.language == \'portugues\'">Olhar</span> <span ng-if="$ctrl.language == \'italiano\'">Ver</span></a></td></tr></tbody><tbody ng-show="$ctrl.isSearching"><tr><td colspan="4" class="text-center"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando..</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></td></tr></tbody><tfoot><tr><td colspan="4" class="text-center"><div st-pagination="" st-items-by-page="200" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/basic/tables.html','<div class="widgets"><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Hover Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/hoverRows.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Bordered Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/borderedTable.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Condensed Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/condensedTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Striped Rows" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/stripedRows.html"></div></div></div></div><div class="row"><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Contextual Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/contextualTable.html"></div></div></div><div class="col-lg-6 col-md-12"><div ba-panel="" ba-panel-title="Responsive Table" ba-panel-class="with-scroll table-panel"><div include-with-scope="app/pages/tables/widgets/responsiveTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/smart/tables.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Rows" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableRowTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Editable Cells" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/editableTable.html"></div></div></div></div><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Smart Table With Filtering, Sorting And Pagination" ba-panel-class="with-scroll"><div include-with-scope="app/pages/tables/widgets/smartTable.html"></div></div></div></div></div>');
$templateCache.put('app/pages/tables/widgets/basicTable.html','<div class="horizontal-scroll"><table class="table"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Downloads</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">DAU</th><th class="table-arr"></th><th class="align-right">MAU</th><th class="table-arr"></th><th class="align-right">LTV</th><th class="table-arr"></th><th class="align-right">Users %</th><th class="table-arr"></th></tr></thead><tbody><tr><td><img src="img/chrome.svg" width="20" height="20"></td><td class="nowrap">Google Chrome</td><td class="align-right">10,392</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">3,822</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,214</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">899</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">7,098</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">178</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">45%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/firefox.svg" width="20" height="20"></td><td class="nowrap">Mozilla Firefox</td><td class="align-right">7,873</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">6,003</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,031</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">897</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">8,997</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">28%</td><td class="table-arr"><i class="icon-up"></i></td></tr><tr><td><img src="img/ie.svg" width="20" height="20"></td><td class="nowrap">Internet Explorer</td><td class="align-right">5,890</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,492</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">2,102</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">27</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">4,039</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">99</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">17%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/safari.svg" width="20" height="20"></td><td class="nowrap">Safari</td><td class="align-right">4,001</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">2,039</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">1,001</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">104</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">3,983</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">209</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">14%</td><td class="table-arr"><i class="icon-down"></i></td></tr><tr><td><img src="img/opera.svg" width="20" height="20"></td><td class="nowrap">Opera</td><td class="align-right">1,833</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">983</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">83</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">19</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">1,099</td><td class="table-arr"><i class="icon-down"></i></td><td class="align-right">103</td><td class="table-arr"><i class="icon-up"></i></td><td class="align-right">5%</td><td class="table-arr"><i class="icon-up"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/borderedTable.html','<div class="horizontal-scroll"><table class="table table-bordered"><thead><tr><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="align-right">Purchases</th><th class="align-right">%</th></tr></thead><tbody><tr ng-repeat="item in metricsTableData"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="align-right">{{item.purchases}}</td><td class="align-right">{{item.percent}}</td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/condensedTable.html','<div class="horizontal-scroll"><table class="table table-condensed"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat="item in peopleTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><button class="status-button btn btn-xs btn-{{item.status}}">{{item.status}}</button></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/contextualTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class="primary"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr class="success"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr class="warning"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr class="danger"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr class="info"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/editableRowTable.html','<div class="add-row-editable-table"><button class="btn btn-primary" ng-click="addUser()">Add row</button></div><div class="table-responsive"><table class="table table-bordered table-hover table-condensed"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat="user in users" class="editable-row"><td>{{$index}}</td><td><span editable-text="user.name" e-name="name" e-form="rowform" e-required="">{{ user.name || \'empty\' }}</span></td><td class="select-td"><span editable-select="user.status" e-name="status" e-form="rowform" e-selectpicker="" e-ng-options="s.value as s.text for s in statuses">{{ showStatus(user) }}</span></td><td class="select-td"><span editable-select="user.group" e-name="group" onshow="loadGroups()" e-form="rowform" e-selectpicker="" e-ng-options="g.id as g.text for g in groups">{{ showGroup(user) }}</span></td><td><form editable-form="" name="rowform" ng-show="rowform.$visible" class="form-buttons form-inline" shown="inserted == user"><button type="submit" ng-disabled="rowform.$waiting" class="btn btn-primary editable-table-button btn-xs">Save</button> <button type="button" ng-disabled="rowform.$waiting" ng-click="rowform.$cancel()" class="btn btn-default editable-table-button btn-xs">Cancel</button></form><div class="buttons" ng-show="!rowform.$visible"><button class="btn btn-primary editable-table-button btn-xs" ng-click="rowform.$show()">Edit</button> <button class="btn btn-danger editable-table-button btn-xs" ng-click="removeUser($index)">Delete</button></div></td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/editableTable.html','<div class="horizontal-scroll"><table class="table table-hover" st-table="editableTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr></thead><tbody><tr ng-repeat="item in editableTableData" class="editable-tr-wrap"><td class="table-id">{{item.id}}</td><td><span editable-text="item.firstName" blur="cancel">{{item.firstName}}</span></td><td><span editable-text="item.lastName" blur="cancel">{{item.lastName}}</span></td><td><span editable-text="item.username" blur="cancel">{{item.username}}</span></td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td><span editable-text="item.age" blur="cancel">{{item.age}}</span></td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="12" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/hoverRows.html','<div class="horizontal-scroll"><table class="table table-hover"><thead><tr class="black-muted-bg"><th class="browser-icons"></th><th>Browser</th><th class="align-right">Visits</th><th class="table-arr"></th><th class="align-right">Purchases</th><th class="table-arr"></th><th class="align-right">%</th><th class="table-arr"></th></tr></thead><tbody><tr ng-repeat="item in metricsTableData" class="no-top-border"><td><img ng-src="{{::( item.image | appImage )}}" width="20" height="20"></td><td ng-class="nowrap">{{item.browser}}</td><td class="align-right">{{item.visits}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }"></i></td><td class="align-right">{{item.purchases}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }"></i></td><td class="align-right">{{item.percent}}</td><td class="table-arr"><i ng-class="{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }"></i></td></tr></tbody></table></div>');
$templateCache.put('app/pages/tables/widgets/responsiveTable.html','<div class="table-responsive"><table class="table"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class="email-link" ng-href="mailto:mdo@gmail.com" href="mailto:mdo@gmail.com">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class="email-link" ng-href="mailto:fat@yandex.ru" href="mailto:fat@yandex.ru">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class="email-link" ng-href="mailto:twitter@outlook.com" href="mailto:twitter@outlook.com">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class="email-link" ng-href="mailto:snow@gmail.com" href="mailto:snow@gmail.com">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class="email-link" ng-href="mailto:jack@yandex.ru" href="mailto:jack@yandex.ru">jack@yandex.ru</a></td><td>30</td></tr></table></div>');
$templateCache.put('app/pages/tables/widgets/smartTable.html','<div class="horizontal-scroll"><div class="form-group select-page-size-wrap"><label>Rows on page<select class="form-control selectpicker show-tick" title="Rows on page" selectpicker="" ng-model="smartTablePageSize" ng-options="i for i in [5,10,15,20,25]"></select></label></div><table class="table" st-table="smartTableData"><thead><tr class="sortable"><th class="table-id" st-sort="id" st-sort-default="true">#</th><th st-sort="firstName">First Name</th><th st-sort="lastName">Last Name</th><th st-sort="username">Username</th><th st-sort="email">Email</th><th st-sort="age">Age</th></tr><tr><th></th><th><input st-search="firstName" spellcheck="true" placeholder="Search First Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="lastName" spellcheck="true" placeholder="Search Last Name" class="input-sm form-control search-input" type="search"></th><th><input st-search="username" spellcheck="true" placeholder="Search Username" class="input-sm form-control search-input" type="search"></th><th><input st-search="email" spellcheck="true" placeholder="Search Email" class="input-sm form-control search-input" type="search"></th><th><input st-search="age" spellcheck="true" placeholder="Search Age" class="input-sm form-control search-input" type="search"></th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan="6" class="text-center"><div st-pagination="" st-items-by-page="smartTablePageSize" st-displayed-pages="5"></div></td></tr></tfoot></table></div>');
$templateCache.put('app/pages/tables/widgets/stripedRows.html','<div class="vertical-scroll"><table class="table table-striped"><thead><tr><th class="table-id">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat="item in smartTableData"><td class="table-id">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class="email-link" ng-href="mailto:{{item.email}}">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top"><h1 class="al-title">{{ activePageTitle }}</h1></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/directives/templateshtml/listHistorialAutorizacion.html','<div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Historial de Autorizaciones\' : (($ctrl.language == \'ingles\') ? \'Authorization History\' : (($ctrl.language == \'portugues\') ? \'Hist\xF3rico de Autoriza\xE7\xF5es\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista && $ctrl.listadoHistorialAutorizaciones.length>0" id="lusuarios"><div ng-repeat="obj in $ctrl.listadoHistorialAutorizaciones"><div style="margin-bottom: 5px;background-color: #62666921; border-radius: 20px;padding-bottom: 10px;"><div class="panel-heading header-historial-autorizacion clearfix panel-headingV2"><h5 class="panel-title ng-binding" style="font-size: 14px;color: white;font-weight: 700;">{{obj.EtapaNombre}}</h5></div><div style="margin-bottom: 5px; min-height: 55px;" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="40" width="40" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label style="padding: 16px;">{{ obj.Usuario.Nombre }} - {{ obj.Usuario.Login }}</label> <img src="/images/check2.png" height="40" width="40" style="float: right;margin: 5px;" ng-show="obj.autoriza==true"> <img src="/images/cancel1.png" height="40" width="40" style="float: right;margin: 5px;" ng-show="obj.autoriza!=true"></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Comentarios:</span> <span ng-if="$ctrl.language == \'ingles\'">Comments:</span> <span ng-if="$ctrl.language == \'portugues\'">Coment\xE1rios:</span> <span ng-if="$ctrl.language == \'italiano\'">Comentarios:</span> {{ obj.Comentario }}</label></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Fecha Autorizacion:</span> <span ng-if="$ctrl.language == \'ingles\'">Authorization Date:</span> <span ng-if="$ctrl.language == \'portugues\'">Data de Autoriza\xE7\xE3o:</span> <span ng-if="$ctrl.language == \'italiano\'">Fecha Autorizacion:</span> {{ obj.CreationDate}}</label></div><div class="demo-card__subhead"><label style="margin: 0px; font-size: 13px;margin-left: 10px;padding: 3px;"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Etapa:</span> <span ng-if="$ctrl.language == \'ingles\'">Stage:</span> <span ng-if="$ctrl.language == \'portugues\'">Etapa:</span> <span ng-if="$ctrl.language == \'italiano\'">Etapa:</span> {{ obj.EtapaNombre}}</label></div></div></div></div></div>');
$templateCache.put('app/theme/directives/templateshtml/listUsuariosAutorizacion.html','<div ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Usuarios que pueden Autorizar\' : (($ctrl.language == \'ingles\') ? \'Users who can Authorize\' : (($ctrl.language == \'portugues\') ? \'Usu\xE1rios que podem Autorizar\' : \'italiano\')) }}" ba-panel-class="with-scroll header-usuario-autorizacion" ng-show="$ctrl.model.Id > 0 && !$ctrl.anularVista && $ctrl.listadoUsuariosAutorizanSolicitudEtapa.length>0" id="lusuarios"><div ng-repeat="obj in $ctrl.listadoUsuariosAutorizanSolicitudEtapa"><div style="margin-bottom: 5px;background-color: white;border-radius: 20px;padding-bottom: 10px;"><div class="panel-heading clearfix panel-headingV2"><h5 class="panel-title ng-binding" style="font-size: 14px;color: white;font-weight: 700;">{{obj.Nombre}}</h5></div><div ng-repeat="usuario in obj.gruposUsuariosRelacion" style="margin-bottom: 5px; min-height: 55px;" class="mdc-card cardAutorizaciones"><img src="/images/user1.png" height="40" width="40" style="float: left;margin: 5px;display: block;"><div class="demo-card__title"><label style="padding: 16px; font-size: 13px;">{{ usuario.Usuario.Nombre }} - {{ usuario.Usuario.Login }}</label> <img src="/images/canAutorice.png" height="40" width="40" style="float: right;margin: 5px;"></div></div></div></div></div>');
$templateCache.put('app/theme/directives/templateshtml/modal.html','<div id="divContainerData" ba-panel="" ba-panel-title="{{ ($ctrl.language == \'espa\xF1ol\') ? \'Datos\' : (($ctrl.language == \'ingles\') ? \'Data\' : (($ctrl.language == \'portugues\') ? \'Dados\' : \'italiano\')) }}" ba-panel-class="with-scroll" ng-show="!$ctrl.anularVista && $ctrl.showModalDataContainer" class="add-top-space"><div class="col-md-12" ng-show="$ctrl.isCamposLoading"><span ng-if="$ctrl.language == \'espa\xF1ol\'">Cargando...</span> <span ng-if="$ctrl.language == \'ingles\'">Loading...</span> <span ng-if="$ctrl.language == \'portugues\'">Carregando...</span> <span ng-if="$ctrl.language == \'italiano\'">italiano...</span></div><div ng-show="!$ctrl.isCamposLoading" ng-if="$ctrl.puedeEditarCampos"><div ng-repeat="item in $ctrl.camposList"><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==true && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id"><label class="center-label">{{item.Campo.Nombre}}:</label><div ng-repeat="j in item.ValorObjeto"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)" ng-readonly="!$ctrl.model.Id==0" style="color: #666666;"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div><div class="col-md-12" ng-if="item.Campo.CampoTipo.Codigo==\'JERARQ\' && item.Campo.tipoNumerador==false && item.Solicitud.Proceso.campoIdAutorizacion == item.Campo.Id"><label class="center-label">{{item.Campo.Nombre}}:</label><div ng-repeat="j in item.ValorObjeto"><input type="text" spellcheck="true" ng-model="j.ValorInput" placeholder="{{j.Placeholder}}" autocomplete="off" uib-typeahead="i as i.Nombre for i in $ctrl.searchJerarquia(j.ValorInput, j.JerarquiaPadreId)" typeahead-wait-ms="500" typeahead-loading="j.LoadingJerarquia" typeahead-no-results="j.NoResults" class="form-control" typeahead-on-select="$ctrl.onSelectJerarquia($parent.$index, $index, $model)"> <i ng-show="j.LoadingJerarquia" class="glyphicon glyphicon-refresh"></i><div ng-show="j.NoResults"><i class="glyphicon glyphicon-remove"></i> <span ng-if="$ctrl.language == \'espa\xF1ol\'">Valor no encontrado</span> <span ng-if="$ctrl.language == \'ingles\'">Value not found</span> <span ng-if="$ctrl.language == \'portugues\'">Valor n\xE3o encontrado</span> <span ng-if="$ctrl.language == \'italiano\'">Valor no encontrado</span></div><a href="" class="pull-right" ng-if="item.Campo.PermiteAltaJerarquia" ng-click="$ctrl.altaNuevaJerarquia($parent.$parent.$index, $parent.$index)"><i class="ion-plus-circled"></i></a><div class="col-md-12" ng-show="j.MostrarDetalle" ng-repeat="det in j.Detalles"><label>{{det.Titulo}}: {{det.Valor}}</label></div></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on"><span ng-if="switcherLanguage == \'espa\xF1ol\'">SI</span> <span ng-if="switcherLanguage == \'ingles\'">YES</span> <span ng-if="switcherLanguage == \'portugues\'">SIM</span> <span ng-if="switcherLanguage == \'italiano\'">SI</span> <span ng-if="!switcherLanguage">SI</span></span> <span class="handle"></span> <span class="handle handle-off"><span ng-if="switcherLanguage == \'espa\xF1ol\'">NO</span> <span ng-if="switcherLanguage == \'ingles\'">NO</span> <span ng-if="switcherLanguage == \'portugues\'">N\xC3O</span> <span ng-if="switcherLanguage == \'italiano\'">NO</span> <span ng-if="!switcherLanguage">NO</span></span></div></div></label>');}]);